const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "背景-月讀",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "場景資產過量，無法發佈，請刪除部分資產後重試。",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "尚未取得會員功能權限",
  T_12_I_GIFT_SENDER_BELL: "聖誕鈴鐺",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "複製人殺手佩戴的頭盔，存在感極強的冷峻雙色。[FFB300](穿戴頭盔仍可顯示外觀)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "聖誕銀鬍(面飾)",
  T_12_L_COS_PINKMAN: "粉粉特務",
  T_12_L_COS_POLAR: "白熊好夥伴",
  T_12_L_COS_RENDER: "彩虹特務",
  T_12_L_COS_TIGER: "阿虎特務",
  T_12_L_MALE_BOTTOM_COS_ELF: "聖誕精靈(下裝)",
  T_12_L_MALE_COS_SANTA: "超進化聖誕老人",
  T_12_L_MALE_HAIR_COS_ELF: "聖誕精靈(頭飾)",
  T_12_L_MALE_SHOE_COS_ELF: "聖誕精靈(鞋子)",
  T_12_L_MALE_TOP_COS_ELF: "聖誕精靈(上裝)",
  T_12_O_CAT_NAME: "喵喵",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-特大號禮物發送器",
  T_12_O_MACHETE_GOLD_NAME: "大砍刀-法老裁決",
  T_12_O_PET_TITLE: "寵物",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "彈跳動力鞋",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "裝備了空氣動力裝置的鞋子，可讓你在空中二段跳躍",
  T_12_Q_ITEM_FLYSHOE: "噴氣飛行鞋",
  T_12_Q_ITEM_FLYSHOE_DESC: "可進行空中作戰的輔助裝備，但需要隨時留意能量的消耗",
  T_12_Q_ITEM_STOCK1: "槍托 Lv.1",
  T_12_Q_ITEM_STOCK2: "槍托 Lv.2",
  T_12_Q_ITEM_STOCK3: "槍托 Lv.3",
  T_12_Q_ITEM_TREATMENTGUN: "治療手槍",
  T_12_Q_ITEM_VEST4: "防彈衣 Lv.4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "安東尼奧",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "悟空",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot舞",
  T_12_R_EMOTE_WAVE_NAME: "電流浪潮",
  T_12_R_SKILL_NAME_GANGLEADER: "教父氣魄",
  T_12_R_SKILL_NAME_MONKEYGOD: "幻化術",
  T_13_I_COLLECTION_V_AMPHIBIAN: "水陸兩用車",
  T_13_I_COLLECTION_V_JEEP: "吉普車",
  T_13_I_COLLECTION_V_MONSTER: "怪獸卡車",
  T_13_I_COLLECTION_V_MOTOBIKE: "重型機車",
  T_13_I_COLLECTION_V_ROADSTER: "超跑",
  T_13_I_COLLECTION_V_SUV: "皮卡車",
  T_13_I_COLLECTION_V_TUTU: "嘟嘟車",
  T_13_L_MALE_ACCESSORY_COS_BJD: "冰晶男偶(面飾)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "熱戀少年(下裝)",
  T_13_L_MALE_HAIR_COS_BJD: "冰晶男偶(頭飾)",
  T_13_L_MALE_TOP_COS_VALENTINE: "熱戀少年(上裝)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "武器",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "寵物外觀：探險喵喵",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR-邱比特",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "莫科",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "伏地挺身",
  T_13_R_EMOTE_EGYPT_NAME: "法老舞步",
  T_13_R_PVE_WEAPON_SLOT: "武器欄位",
  T_13_R_PVE_WEAPONSKIN_RANGE: "射程",
  T_13_R_PVE_WEAPONSKIN_SPEED: "射速",
  T_13_R_SKILL_DESC_HACKERGIRL: "標記被擊中的敵人，顯示標記 [FFB300]{0} 秒[-]。信息會同步給隊友。",
  T_13_R_SKILL_NAME_HACKERGIRL: "駭客之眼",
  T_13_Z_KICKOFF_BAN: "屏蔽",
  T_13_Z_ROOM_MORNING: "白天",
  T_13_Z_ROOM_NIGHT: "黑夜",
  T_14_G_ITEM_KATANA: "武士刀",
  T_14_I_HEADPIC_SONGKRAN_NAME: "頭像-潑潑！",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "可愛立方體(面飾)",
  T_14_L_COS_EASTER: "1937號觀察員",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "消防衛兵(鞋子)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "邦尼老大(面飾)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47-水球大戰",
  T_14_O_DOG_NAME: "智械帕皮",
  T_14_O_PETSKIN_IRON_DOG_NAME: "寵物外觀：鋼鐵帕皮",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "寵物外觀：閃電帕皮",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "寵物外觀：磁力帕皮",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "寵物外觀：暗夜喵喵",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR-血月",
  T_14_O_SCAR_SHARK_NAME: "SCAR-殘酷鯊客",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "夜神隼",
  T_14_R_SKILL_DESC_SAMURAI: "每損失 [FFB300]{0}%[-] HP，護甲穿透增加 [FFB300]{1}%[-]。",
  T_14_R_SKILL_NAME_SAMURAI: "武士道",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "飢餓打擊(面飾)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "猛毒之觸(面飾)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "飢餓打擊(下裝)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "猛毒之觸(下裝)",
  T_15_L_MALE_SHOE_COS_FAIM: "飢餓打擊(鞋子)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "猛毒之觸(鞋子)",
  T_15_L_MALE_TOP_COS_FAIM: "飢餓打擊(上裝)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "猛毒之觸(上裝)",
  T_15_L_TOP_COS_MOTHERSDAY: "媽媽我愛你(上裝)",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94-死亡天啟",
  T_15_O_BASEBALLBAT_VIKING_NAME: "球棒-維京之棍",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014-死亡天啟",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1-死亡天啟",
  T_15_O_PANTHER_NAME: "奔奔小豹",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "寵物外觀：隊長豹豹",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "寵物外觀：黃金豹豹",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "寵物外觀：主宰豹豹",
  T_15_O_SKS_DEATH_NAME: "SKS-浴血奮戰",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP-死亡天啟",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "加特林機槍",
  T_15_R_CHARACTER_AGENT_NAME: "柔拉",
  T_15_R_EMOTE_LETSGROOVE_NAME: "搖擺",
  T_15_R_SKILL_DESC_AGENT: "開鏡瞄準時，射擊精準度提升 [FFB300]{0}%[-]。",
  T_15_R_SKILL_NAME_AGENT: "精準射手",
  T_15_W_BACKPACK_MECHGIRL_NAME: "背包-紫色飛行",
  T_16_B_ITEM_GRAPPLINGHOOK: "鉤鎖",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "鉤鎖槍",
  T_16_L_MALE_COS_LEGO: "瘋狂積木人",
  T_16_L_MALE_SHOE_COS_SUMMER: "沙灘型男(鞋子)",
  T_16_P_MANUAL_MONSTER: "怪獸卡車",
  T_16_P_MANUAL_MUSHROOM1: "磨菇 Lv.1",
  T_16_P_MANUAL_MUSHROOM2: "磨菇 Lv.2",
  T_16_P_MANUAL_MUSHROOM3: "磨菇 Lv.3",
  T_16_P_MANUAL_MUSHROOM4: "磨菇 Lv.4",
  T_16_P_MANUAL_ROADSTER_DESC: "帥氣的超跑，血量較低，但速度飛快，最高乘載2人",
  T_16_P_MANUAL_STROP: "滑索",
  T_16_P_MANUAL_SUV: "皮卡車",
  T_16_P_MANUAL_SUV_DESC: "Free Fire 代表性載具，中等裝甲值，中等速度，最高乘載 2 人",
  T_16_P_MANUAL_TUTU_DESC: "裝甲值較低，加速和爬坡能力較弱，最高乘載3人",
  T_16_P_MANUAL_WEAPON_AR: "步槍",
  T_16_P_MANUAL_WEAPON_BOMB: "投擲物",
  T_16_P_MANUAL_WEAPON_PISTOL: "手槍",
  T_16_P_MANUAL_WEAPON_SG: "霰彈槍",
  T_16_P_MANUAL_WEAPON_SMG: "衝鋒槍",
  T_16_P_MANUAL_WEAPON_SR: "狙擊槍",
  T_16_Q_MINISENTRY: "迷你哨塔",
  T_16_Q_MINISENTRY_DESC: "高科技材料製成的人工智能砲塔，會主動搜尋範圍內的敵人",
  T_16_R_EMOTE_DESERT_NAME: "憤怒之捶",
  T_16_R_EMOTE_EPHUNTER_NAME: "戰舞",
  T_16_R_EMOTE_EPHUNTER2_NAME: "擊掌",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "後空翻",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "滑步",
  T_16_W_AK_FIRE_NAME: "AK47-火焰驚喜",
  T_16_W_SCAR_LLENN_NAME: "SCAR-粉紅殺手",
  T_16_W_SCAR_WATER_NAME: "SCAR-水流之音",
  T_16_Y_CHARACTER_HITMAN_NAME: "拉斐爾",
  T_16_Y_PANDA_NAME: "偵探熊貓",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "寵物外觀：野戰熊貓",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "寵物外觀：骷髏熊貓",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "寵物外觀：鋼鐵熊貓",
  T_17_B_CS_MODE_NAME: "團隊突襲",
  T_17_C_SKILL_NAME_PLAYBOY: "鬼魅行動",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "貴族小丑(面飾)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "暗夜貴婦(面飾)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "暗夜貴婦(下裝)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "仙影靈狐(頭飾)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "暗夜貴婦(鞋子)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "暗夜貴婦(上裝)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "帝王之怒(面飾)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "無我狂徒(下裝)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "帝王之怒(下裝)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "深紫暗影(頭飾)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "優雅紳士(鞋子)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "帝王之怒(鞋子)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "帝王之怒(上裝)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "陰陽白金(上裝)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "寵物外觀：公主喵喵",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "寵物外觀：金色柴柴",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "寵物外觀：深藍柴柴",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "寵物外觀：幸運柴柴",
  T_17_O_SHIBA_NAME: "柴柴",
  T_17_Q_FOLDWINGS: "滑翔翼",
  T_17_Q_FOLDWINGS_DESC: "可以讓您從高架地形下滑。",
  T_17_Q_SUPERHEAT: "等離子槍",
  T_17_R_EMOTE_PARTYDANCE_NAME: "派對舞",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS-帝王統治",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR-幻影刺客",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR-風度翩翩",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "喬瑟夫",
  T_17_Z_CS_NAME: "名字",
  T_17_Z_ROOM_JUMP_SWITCH: "跳躍高度",
  T_17_Z_ROOM_SPEED_SWITCH: "移動速度",
  T_18_B_THROWINGKNIFE_NAME: "飛刀",
  T_18_C_DUMMY_NAME: "誘餌手榴彈",
  T_18_C_SKILL_DESC_DJMALE: "創建一個 [FFB300]{1} 公尺[-]的光環，機動性提高 [FFB300]{3}%[-]，並在 [FFB300]{0} 秒[-]內每秒恢復 [FFB300]{2} HP[-]。效果無法疊加。冷卻時間：[FFB300]{4} 秒[-]。",
  T_18_C_SKILL_NAME_DJMALE: "激勵旋律",
  T_18_C_SKILL_NAME_JUNKENGINEER: "殘骸回收",
  T_18_L_COS_INDIANEWYEAR: "深海巨獸",
  T_18_L_HAIR_COS_HALLOWEEN2019: "氣噗噗小妖(頭飾)",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "熾熱男偶(面飾)",
  T_18_O_FOX_NAME: "白銀小狐",
  T_18_O_PETSKIN_BLACKFOX_NAME: "寵物外觀：戰爭小狐",
  T_18_O_PETSKIN_BLUEFOX_NAME: "寵物外觀：湛藍小狐",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "寵物外觀：熔岩柴柴",
  T_18_O_PETSKIN_PINKFOX_NAME: "寵物外觀：緋紅小狐",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "寵物外觀：靈魂豹豹",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1-焚毀誓言",
  T_18_W_UMP_GEISHA_N: "UMP-戰鬥藝術",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "莎妮",
  T_19_B_HB_NAME: "磁浮滑板",
  T_19_C_ICE_GUN_NAME: "冰牆發射器",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "爆炸類武器傷害提升 [FFB300]{0}%[-]，範圍擴大 [FFB300]{1}%[-]。",
  T_19_C_SKILL_DESC_TOMBOY: "使用載具時，每 [FFB300]{0} 秒[-]為車內所有人恢復[FFB300]{1} HP[-]，最多可恢復至[FFB300] {2} HP[-]。",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "爆破藝術",
  T_19_C_SKILL_NAME_TOMBOY: "救命專車",
  T_19_I_EVENT_INFI_ITEM: "無限",
  T_19_L_A_ICEFESTIVAL19_B: "臨別一笑(頭飾)",
  T_19_L_F_S_ICEFESTIVAL: "耶誕女僕(鞋子)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "復古歌手(下裝)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "復古歌手(頭飾)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "復古歌手(上裝)",
  T_19_O_PETSKIN_NAME: "寵物外觀：預設",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "寵物外觀：嘻哈熊貓",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "寵物外觀：冬日熊貓",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "寵物外觀：守護滾滾",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "寵物外觀：春節滾滾",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "寵物外觀：冰雪滾滾",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "寵物外觀：嘻哈柴柴",
  T_19_O_ROBOT_NAME: "滾滾",
  T_19_O_TDM_NAME: "團隊死鬥",
  T_19_R_EMOTE_MIGUEL_NAME: "地板動作",
  T_19_S_SECOND_WEAPON_TITLE: "副武器",
  T_19_S_VEST_TITLE: "防彈衣",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "雙彈匣",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA-叛逆標記",
  T_19_W_M60_ICEFESTIVAL_N: "M60-聖誕來臨",
  T_19_W_MP40_PARK_N: "MP40-嘉年華大會",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR-騰龍翱翔",
  T_19_X_PVE_SAMURAINAME: "武士守衛",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "艾瓦諾",
  T_19_Y_CHARACTER_TOMBOY_N: "娜塔拉",
  T_20_C_INHALER_NAME: "治療呼吸器",
  T_20_C_SKILL_DESC_PARKOURGUY: "每當使用槍枝命中敵人時獲得少量 HP，當擊倒敵人時恢復 [FFB300]{0}%[-] HP。",
  T_20_C_SKILL_NAME_GRAFFITIST: "塗鴉庇護",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "疾風衝刺",
  T_20_C_SKILL_NAME_PARKOURGUY: "特技突襲",
  T_20_L_A_APRILFOOL2020: "嚕嚕嚕(頭飾)",
  T_20_L_F_A_METALHEAD_RED: "熱浪鬥士(面飾)",
  T_20_L_F_B_THAIGIRL: "泰式風情(下裝)",
  T_20_L_F_H_KILLERCUPID: "愛戀女孩(頭飾)",
  T_20_L_F_H_THAIGIRL: "泰式風情(頭飾)",
  T_20_L_F_S_THAIGIRL: "泰式風情(鞋子)",
  T_20_L_F_T_METALHEAD_RED: "熱浪鬥士(上裝)",
  T_20_L_F_T_THAIGIRL: "泰式風情(上裝)",
  T_20_L_JEANDINO: "丹寧特務",
  T_20_L_M_A_METALHEAD_RED: "熱浪戰士(面飾)",
  T_20_L_M_T_METALHEAD_RED: "熱浪戰士(上裝)",
  T_20_L_M_T_STOCKING: "花俏王子(上裝)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "寵物外觀：戀戀小狐",
  T_20_P_CHANNEL_G: "戰隊",
  T_20_P_WORLD_SSPEAKER: "喇叭",
  T_20_S_CSROOM_COIN: "初始金幣",
  T_20_U_SHIELD_GUN_NAME: "護盾槍",
  T_20_W_AN94_METALHEAD_N: "AN94-生生不息",
  T_20_W_P90_EVILBONE_N: "P90-制裁者",
  T_20_Y_CHARACTER_GRAFFITIST_N: "史黛菲",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "凱莉．疾風",
  T_20_Y_CHARACTER_PARKOURGUY_N: "祖達",
  T_21_B_SMOKEGRENADE_DESC: "使用後可以產生遮蔽視線的煙霧，適合擾敵人進攻的利器",
  T_21_B_SMOKEGRENADE_NAME: "煙霧彈",
  T_21_C_AUTOPICKUP_AVERAGE: "預設",
  T_21_C_SKILL_DESC_KPOPSINGER: "救助隊友時，給予該隊友 [FFB300]{0} HP [-]的護盾並提高 [FFB300]{1}%[-] 機動性，效果於成功救起 [FFB300]{2} 秒[-]內逐漸衰減。降低倒地隊友的 HP 損失率 [FFB300]{3}%[-]。效果無法疊加。",
  T_21_C_SKILL_DESC_SOCCERSTAR: "每次擊殺敵人可增加 HP 上限 [FFB300]{0}[-]，最高可增加 [FFB300]{1}[-]。",
  T_21_C_SKILL_NAME_KPOPSINGER: "療癒歌曲",
  T_21_C_SKILL_NAME_SOCCERSTAR: "帽子戲法",
  T_21_L_ANGELICAL: "天人特務",
  T_21_L_S_VNSLIPPER: "浴室拖鞋(鞋子)",
  T_21_O_OTTER_NAME: "獺吞吞",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "寵物外觀：冒險吞吞",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "寵物外觀：櫻櫻吞吞",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "寵物外觀：暗夜吞吞",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "寵物外觀：死神滾滾",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "寵物外觀：龐克豹豹",
  T_21_R_EMOTE_SORROW_NAME: "天啊！",
  T_21_U_WEAPON_THOMPSON_NAME: "湯普森衝鋒槍",
  T_21_W_BACKPACK_SPINE_N: "背包-生化改造",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "球棒-搖滾靈魂",
  T_21_W_M79_RABBITKILLER_N: "M79-紅眼兔殺手",
  T_21_W_PAN_VOLCANO_N: "平底鍋-熔岩之怒",
  T_21_W_XM8_RAINBOW_N: "XM8-潑灑歡樂",
  T_21_Y_CHARACTER_KPOPSINGER_N: "智妍",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "盧凱達",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "顯示 [FFB300]{0} 公尺[-]內的敵人(蹲下或趴下的敵人除外)，持續 [FFB300]{1} 秒[-]，技能效果可與隊友共享。冷卻時間：[FFB300]{2} 秒[-]。",
  T_22_C_SKILL_NAME_DETECTIVE: "行蹤探查",
  T_22_C_SKILL_NAME_STREAMERGUY: "焦點人物",
  T_22_L_F_H_COLLEGE: "血衛學妹(頭飾)",
  T_22_L_F_S_SUMMER20: "夏日情人(鞋子)",
  T_22_L_M_A_GREENCOAT: "豔綠歐巴(面飾)",
  T_22_L_M_A_PINKFUR: "緋櫻跑趴王(面飾)",
  T_22_L_M_A_PLAGUE2: "猛毒幻影(面飾)",
  T_22_L_M_B_FAIM2: "飢荒之火(下裝)",
  T_22_L_M_B_GREENCOAT: "豔綠歐巴(下裝)",
  T_22_L_M_B_PINKFUR: "緋櫻跑趴王(下裝)",
  T_22_L_M_B_PLAGUE2: "猛毒幻影(下裝)",
  T_22_L_M_B_REDPANTS: "嘻哈指南針(下裝)",
  T_22_L_M_B_TIGERSTRIPE: "虎皮夜店咖(下裝)",
  T_22_L_M_H_COLLEGE: "血衛學長(頭飾)",
  T_22_L_M_H_FAIM2: "飢荒之火(頭飾)",
  T_22_L_M_H_GREENCOAT: "豔綠歐巴(頭飾)",
  T_22_L_M_H_PINKFUR: "緋櫻跑趴王(頭飾)",
  T_22_L_M_H_PLAGUE2: "猛毒幻影(頭飾)",
  T_22_L_M_H_REDPANTS: "嘻哈指南針(頭飾)",
  T_22_L_M_H_TIGERSTRIPE: "虎皮夜店咖(頭飾)",
  T_22_L_M_S_FAIM2: "飢荒之火(鞋子)",
  T_22_L_M_S_PLAGUE2: "猛毒幻影(鞋子)",
  T_22_L_M_T_FAIM2: "飢荒之火(上裝)",
  T_22_L_M_T_GREENCOAT: "豔綠歐巴(上裝)",
  T_22_L_M_T_PINKFUR: "緋櫻跑趴王(上裝)",
  T_22_L_M_T_PLAGUE2: "猛毒幻影(上裝)",
  T_22_L_M_T_REDPANTS: "嘻哈指南針(上裝)",
  T_22_L_M_T_TIGERSTRIPE: "虎皮夜店咖(上裝)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98k-反叛學園",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "平底鍋-瓜瓜樂",
  T_22_LC_SCAR_HERMIT_N: "SCAR-秘傳奔雷",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "治療手槍-生命光線",
  T_22_O_HAWK_NAME: "獵隼",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "寵物外觀：末日小狐",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "寵物外觀：獄火獵隼",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "寵物外觀：森林獵隼",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "寵物外觀：陽光柴柴",
  T_22_Q_BOMB_PLIERS: "拆彈鉗",
  T_22_R_EMOTE_SHIMMY_NAME: "抖肩",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "護甲穿透",
  T_22_U_WPNSKN_SPEED_RUN: "持槍機動性",
  T_22_Y_CHARACTER_DETECTIVE_N: "克露",
  T_22_Y_CHARACTER_STREAMERGUY_N: "沃爾夫勒",
  T_23_B_CARDIAC_NAME: "強心針",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "拔刀格擋",
  T_23_C_SKILL_NAME_SWATGUY: "戰術補彈",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "夜神隼．火印",
  T_23_D_CHARACTER_SWATGUY_N: "宰伊",
  T_23_L_F_B_GANGSTERRAP_GOLD: "快金女王蜂(下裝)",
  T_23_L_F_B_MIKOGIRL: "火狐巫女(下裝)",
  T_23_L_F_B_NAVYGIRL: "海洋歷險(下裝)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "快金女王蜂(頭飾)",
  T_23_L_F_H_MIKOGIRL: "火狐巫女(頭飾)",
  T_23_L_F_H_NAVYGIRL: "海洋歷險(頭飾)",
  T_23_L_F_S_MIKOGIRL: "火狐巫女(鞋子)",
  T_23_L_F_S_ORDERCHALLENGER: "逞熊鬥粉(鞋子)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "快金女王蜂(上裝)",
  T_23_L_F_T_MIKOGIRL: "火狐巫女(上裝)",
  T_23_L_F_T_NAVYGIRL: "海洋歷險(上裝)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "快金狂徒(面飾)",
  T_23_L_M_B_FOXGUY: "火狐使者(下裝)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "快金狂徒(下裝)",
  T_23_L_M_H_FOXGUY: "火狐使者(頭飾)",
  T_23_LC_SKS_GEMINI_N: "SKS-極度混亂",
  T_23_O_PENGUIN_NAME: "瓦哥",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "寵物外觀：派對瓦哥",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "寵物外觀：科技瓦哥",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "寵物外觀：黃金瓦哥",
  T_23_T_ANNI3_LOBBY_NODENAME20: "團隊突襲",
  T_23_T_ANNI3_LOBBY_NODENAME5: "角色",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "WARNING",
  T_24_C_FLAMETHROWER_NAME: "火焰噴射器",
  T_24_C_SKILL_DESC_PROFESSOR: "EP 上限增加 [FFB300]{0}[-]。柔術大師狀態：[FFB300]{2} 公尺[-]內我方 EP 轉化速度提升 [FFB300]{1}%[-]；心理學家狀態：每 [FFB300]{4} 秒[-]補充 [FFB300]{5} EP[-]，上限 [FFB300]{6} EP[-]；切換冷卻時間：[FFB300]{3} 秒[-]。",
  T_24_C_SKILL_NAME_PARTYGIRL: "派對舞王",
  T_24_C_SKILL_NAME_PROFESSOR: "全面菁英",
  T_24_D_CHARACTER_PARTYGIRL_N: "達莎",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX(下裝)",
  T_24_L_H_PUMPKIN2020_A: "扭曲瓜瓜帽(頭飾)",
  T_24_L_T_TSHIRT_COMEDIAN: "喜劇英雄 T-Shirt",
  T_24_LC_MP5_RICHBOXER_N: "MP5-擂台冠軍",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR-派對焦點",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD-戰國傳奇",
  T_24_U_M21A5: "瘋鳥步槍",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "總分",
  T_24_V_TRAINING_BOX_ATTACH: "配件",
  T_24_V_TRAINING_BOX_WEAPON: "武器",
  T_24_W_ARMORY: "武器",
  T_24_W_ARMOTY_MELEE: "近戰武器",
  T_24_W_ARMOTY_PISTOL: "手槍",
  T_24_W_ARMOTY_RIFLE: "步槍",
  T_24_W_ARMOTY_SHOTGUN: "霰彈槍",
  T_24_W_ARMOTY_SNIPER: "狙擊槍",
  T_24_W_ARMOTY_SPECIAL: "其他",
  T_24_W_ARMOTY_SUBMACHINE: "衝鋒槍",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "寵物外觀：勝利熊貓",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "寵物外觀：骷髏浣仔",
  T_24_W_PETSKIN_RACCOON_MECH_N: "寵物外觀：派對浣仔",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "寵物外觀：不死浣仔",
  T_24_W_RACCOON_N: "搖滾浣仔",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "時空屏障",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "方案 1",
  T_25_E_HUD_02: "方案 2",
  T_25_L_F_B_DEMONKILLER: "燃燒青春-女(下裝)",
  T_25_L_F_H_DEMONKILLER: "狂怒少女(頭飾)",
  T_25_L_F_S_DEMONKILLER: "狂怒少女(鞋子)",
  T_25_L_F_T_DEMONKILLER: "狂怒少女(上裝)",
  T_25_L_HA_FP_EVIL: "惡魔(臉彩)",
  T_25_L_M_H_ANIMEHAIR: "微風(頭飾)",
  T_25_L_S_MAXSNEAKERS: "MAX(鞋子)",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "球棒-時空打擊",
  T_25_LC_GLOO_WINTERFEST2020_N: "凝膠護盾-聖誕酷冬冬",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887-冬季雪臨",
  T_25_LC_MACHETE_BOUNTY_N: "大砍刀-時空斬擊",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90-音爆穿越(綠)",
  T_25_LC_P90_MUSICFALL_RED_N: "P90-音爆穿越(紅)",
  T_25_LC_PAN_BOUNTY_N: "平底鍋-時空進擊",
  T_25_R_LEGEND_REMIND: "提醒",
  T_25_U_MAG7: "MAG7",
  T_25_U_SICKLE: "鐮刀",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "筋肉魈",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "寵物外觀：冰河魈",
  T_25_W_PETSKIN_BABOON_HELL_N: "寵物外觀：怒火魈",
  T_25_W_PETSKIN_BABOON_PURE_N: "寵物外觀：巨金魈",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "寵物外觀：雪嶺豹豹",
  T_25_Z_R_SIMULATOR_OFF: "禁止",
  T_26_C_SKILL_DESC_SUPERSTAR: "向前放出 [FFB300]{0} 公尺[-]的音波。音波爆炸並在 [FFB300]{2} 秒[-]內對 [FFB300]{1} 公尺[-]內的凝膠護盾造成傷害，冷卻時間：[FFB300]{3} 秒[-]。",
  T_26_C_SKILL_NAME_SUPERSTAR: "節奏狂潮",
  T_26_D_CHARACTER_DELIVERY_N: "士郎",
  T_26_D_CHARACTER_SUPERSTAR_N: "斯凱伊爾",
  T_26_ET_CELLPHONE_NAME: "迷你無人機",
  T_26_L_A_FLAMING_PREM: "燃炎先鋒隊(面飾)",
  T_26_L_A_SANTAMODE: "雪人小子(面飾)",
  T_26_L_B_SANTAMODE: "雪人小子(下裝)",
  T_26_L_F_B_WATERFEST21_A: "夏日微風(下裝)",
  T_26_L_F_H_WATERFEST21_A: "夏日微風(頭飾)",
  T_26_L_F_S_WATERFEST21_A: "夏日微風(鞋子)",
  T_26_L_F_T_WATERFEST21_A: "夏日微風(上裝)",
  T_26_L_M_A_EGGDAY2021: "龐克邦尼(面飾)",
  T_26_L_M_B_EGGDAY2021: "龐克邦尼(下裝)",
  T_26_L_M_B_PAIRING: "絕世搭檔(下裝)",
  T_26_L_M_B_WATERFEST21_A: "夏日熱浪(下裝)",
  T_26_L_M_H_EGGDAY2021: "龐克邦尼(頭飾)",
  T_26_L_M_H_PAIRING: "絕世搭檔(頭飾)",
  T_26_L_M_H_WATERFEST21_A: "夏日熱浪(頭飾)",
  T_26_L_M_S_EGGDAY2021: "龐克邦尼(鞋子)",
  T_26_L_M_S_PAIRING: "絕世搭檔(鞋子)",
  T_26_L_M_S_WATERFEST21_A: "夏日熱浪(鞋子)",
  T_26_L_M_T_EGGDAY2021: "龐克邦尼(上裝)",
  T_26_L_M_T_PAIRING: "絕世搭檔(上裝)",
  T_26_L_M_T_WATERFEST21_A: "夏日熱浪(上裝)",
  T_26_L_S_SANTAMODE: "雪人小子(鞋子)",
  T_26_L_T_SANTAMODE: "雪人小子(上裝)",
  T_26_LC_AWM_KOICARP_N: "AWM-好運錦鯉",
  T_26_LC_KATANA_VALENTINE2021_N: "武士刀-粉色季節",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "超跑-眼鏡蛇",
  T_26_P_SKILL_NAME_DELIVERY: "絕命快遞",
  T_26_V_TRAINING_BHH: "趣味大槌",
  T_26_V_TRAINING_DICE: "巨大骰子",
  T_26_W_DRAGON_N: "瑞奇",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "寵物外觀：冰晶瑞奇",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "寵物外觀：閃雷瑞奇",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "寵物外觀：星河瑞奇",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "寵物外觀：戀愛瓦哥",
  T_26_XL_SETTING_TEAMMATE_INFO: "隊友資訊",
  T_26_YP_HISTORY_WIN: "勝利",
  T_26_YP_SOCIAL_GENDER_FEMALE: "女性",
  T_26_YP_SOCIAL_GENDER_MALE: "男性",
  T_26_YP_SOCIAL_NAME: "暱稱",
  T_27_C_SKILL_DESC__RACERGIRL: "載具速度提高 [FFB300]{0}%[-]。在載具上時，角色將變得難以瞄準，自身受到傷害降低 [FFB300]{1}%[-]。",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "創造一個可抵擋 [FFB300]{0}[-] 傷害的虛擬屏障，子彈無法穿透屏障；所有效果持續 [FFB300]{1} 秒[-]；冷卻時間：[FFB300]{2} 秒[-]。",
  T_27_C_SKILL_DESC_FALCONER: "傷害隨距離增加，最高可增加 [FFB300]{0}%[-]。對被標記的敵人造成的傷害增加 [FFB300]{1}%[-]。",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "覺醒：每損失 [FFB300]{0}%[-] 最大 HP，正面受到的傷害減少 [FFB300]{1}%[-]。",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "覺醒：衝刺 [FFB300]{0} 秒[-]後觸發。觸發後，對目標進行的前 [FFB300]{2} 次[-]射擊，造成 [FFB300]{1}%[-] 傷害。持續時間 [FFB300]{3} 秒[-]。",
  T_27_C_SKILL_NAME_FALCONER: "狂野獵隼",
  T_27_C_SKILL_NAME_XTREME: "極限執行者",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "安德魯．狂熱",
  T_27_D_CHARACTER_FALCONER_N: "馬洛",
  T_27_D_CHARACTER_XTREME_N: "夏涅",
  T_27_F_EAP_PKG3_D: "帥氣登場",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "阿虎紙箱(面飾)",
  T_27_L_B_CARDBOARD_REG: "熊兄紙箱(下裝)",
  T_27_L_M_S_KAZAKHSTAN: "雪國護衛隊(鞋子)",
  T_27_L_S_CARDBOARD_REG: "熊兄紙箱(鞋子)",
  T_27_L_T_CARDBOARD_REG: "熊兄紙箱(上裝)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector-電競時代",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "怪獸卡車-電競時代",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "機車-K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "超跑-翡翠閃光",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "皮卡車-魔焱幻龍",
  T_27_P_SKILL_NAME_HITMAN_RE: "無聲殺手",
  T_27_R_EMOTE_GREETING_NAME: "打招呼",
  T_27_R_VEHICLE_ACCELERATION: "加速",
  T_27_R_VEHICLE_HP: "耐久度",
  T_27_R_VEHICLE_SPEED: "最高速度",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "覺醒：護甲傷害減免提高 [FFB300]{0}%[-]。每有一名隊友在 [FFB300]{2} 公尺[-]內，額外獲得 [FFB300]{1}%[-] 傷害減免。",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "群狼",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "莫尼",
  T_27_W_ARMOTY_DMR: "射手步槍",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "寵物外觀：水晶莫尼",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "寵物外觀：電競莫尼",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "寵物外觀：嘻哈莫尼",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "寵物外觀：電競帕皮",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "寵物外觀：電競熊貓",
  T_27_XC_REPLAY_DIE: "死亡",
  T_27_XC_REPLAY_KILL: "擊殺",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "修復",
  T_28_C_G_ICE_NAME: "冰凍手榴彈",
  T_28_C_SKILL_DESC_STREETBEAT: "在移動中射擊時，機動性增加 [FFB300]{0}%[-]，精準度增加 [FFB300]{1}%[-]。",
  T_28_C_SKILL_NAME_STREETBEAT: "跳躍彈丸",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "烏茲手槍",
  T_28_L_B_BRJERSEY_A: "23號球員(下裝)",
  T_28_L_B_BRJERSEY_B: "10號球員(下裝)",
  T_28_L_B_BRJERSEY_C: "24號球員(下裝)",
  T_28_L_B_BRJERSEY_D: "30號球員(下裝)",
  T_28_L_B_BRJERSEY_E: "1號球員(下裝)",
  T_28_L_B_BRJERSEY_F: "20號球員(下裝)",
  T_28_L_F_B_FOURSYMBOLS_C: "朱雀炎風(下裝)",
  T_28_L_F_H_FOURSYMBOLS_C: "朱雀炎風(頭飾)",
  T_28_L_F_HA_FOURSYMBOLS_C: "朱雀炎風(臉彩)",
  T_28_L_F_S_FOURSYMBOLS_C: "朱雀炎風(鞋子)",
  T_28_L_F_T_FOURSYMBOLS_C: "朱雀炎風(上裝)",
  T_28_L_HA_THUNDER: "雷之眼",
  T_28_L_M_A_SPORTSUIT: "溜板小王子(面飾)",
  T_28_L_M_B_FOURSYMBOLS_D: "幽影撼地者(下裝)",
  T_28_L_M_B_SPORTSUIT: "溜板小王子(下裝)",
  T_28_L_M_H_FOURSYMBOLS_D: "幽影撼地者(頭飾)",
  T_28_L_M_H_SPORTSUIT: "溜板小王子(頭飾)",
  T_28_L_M_S_FOURSYMBOLS_D: "幽影撼地者(鞋子)",
  T_28_L_M_S_SPORTSUIT: "溜板小王子(鞋子)",
  T_28_L_M_T_FALLWINTER: "肆意揮灑(上裝)",
  T_28_L_M_T_FOURSYMBOLS_D: "幽影撼地者(上裝)",
  T_28_L_M_T_SPORTSUIT: "溜板小王子(上裝)",
  T_28_L_T_BRJERSEY_A: "23號球員(上裝)",
  T_28_L_T_BRJERSEY_B: "10號球員(上裝)",
  T_28_L_T_BRJERSEY_C: "24號球員(上裝)",
  T_28_L_T_BRJERSEY_D: "30號球員(上裝)",
  T_28_L_T_BRJERSEY_E: "1號球員(上裝)",
  T_28_L_T_BRJERSEY_F: "20號球員(上裝)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94-紅寶石花嫁",
  T_28_LC_GLOO_FALLWINTER_N: "凝膠護盾-創意潑灑",
  T_28_LC_GLOO_FOURSYMBOLS_N: "凝膠護盾-風暴使者",
  T_28_LC_KORD_SHINOBI_N: "Kord-殺戮花火",
  T_28_LC_M21A5_FANTASYEYE_N: "瘋鳥步槍-死靈法師",
  T_28_LC_MAG7_WHITESHARK_N: "MAG7-致命紋路",
  T_28_LC_PAN_FOURSYMBOLS_N: "平底鍋-撼地之跺",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "吉普車-風暴使者",
  T_28_T_WS_ITEM1: "方形木箱",
  T_28_T_WS_ITEM10: "小屋",
  T_28_T_WS_ITEM11: "哨塔",
  T_28_T_WS_ITEM12: "警衛室",
  T_28_T_WS_ITEM13: "一層民房",
  T_28_T_WS_ITEM14: "二層民房",
  T_28_T_WS_ITEM15: "三層民房",
  T_28_T_WS_ITEM16: "沙雕",
  T_28_T_WS_ITEM17: "噴泉",
  T_28_T_WS_ITEM18: "櫻花樹",
  T_28_T_WS_ITEM19: "香蕉樹",
  T_28_T_WS_ITEM2: "長箱",
  T_28_T_WS_ITEM20: "洗手間",
  T_28_T_WS_ITEM21: "圍欄",
  T_28_T_WS_ITEM3: "樹叢",
  T_28_T_WS_ITEM4: "草堆",
  T_28_T_WS_ITEM5: "汽車",
  T_28_T_WS_ITEM6: "巴士",
  T_28_T_WS_ITEM7: "放置箱A",
  T_28_T_WS_ITEM8: "放置箱B",
  T_28_T_WS_ITEM9: "放置箱C",
  T_28_T_WS_TYPE1: "小型物件",
  T_28_T_WS_TYPE4: "裝飾物",
  T_28_W_DUCK_N: "豆豆博士",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "寵物外觀：神話瑞奇",
  T_28_W_PETSKIN_DUCK_ARMY_N: "寵物外觀：士官豆豆",
  T_28_W_PETSKIN_DUCK_BLACK_N: "寵物外觀：黑幫豆豆",
  T_28_W_PETSKIN_DUCK_SHINY_N: "寵物外觀：搖滾豆豆",
  T_28_YF_AR15: "翠鳥步槍",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "覺醒：被擊中的敵人移動時會延長標記的時間，最多延長 [FFB300]{0} 秒[-]。",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "迷幻之眼",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "強韌生命",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "心跳節拍",
  T_29_D_CHARACTER_AMOCO_N: "莫科．密文",
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "條紋足球服(下裝)",
  T_29_L_M_A_FALCONER_C: "金光閃閃(面飾)",
  T_29_L_M_A_JUNGLE_GREEN: "卡穆戰龜(面飾)",
  T_29_L_M_B_FALCONER_C: "金光閃閃(下裝)",
  T_29_L_M_B_JUNGLE_GREEN: "卡穆戰龜(下裝)",
  T_29_L_M_H_FALCONER_C: "金光閃閃(頭飾)",
  T_29_L_M_H_JUNGLE_GREEN: "卡穆戰龜(頭飾)",
  T_29_L_M_S_FALCONER_C: "金光閃閃(鞋子)",
  T_29_L_M_S_JUNGLE_GREEN: "卡穆戰龜(鞋子)",
  T_29_L_M_T_FALCONER_C: "金光閃閃(上裝)",
  T_29_L_M_T_JUNGLE_GREEN: "卡穆戰龜(上裝)",
  T_29_L_T_TRJERSEY: "條紋足球服(上裝)",
  T_29_M_WS_ITEM22: "破碎容器",
  T_29_M_WS_ITEM23: "破碎圍欄",
  T_29_M_WS_ITEM24: "出生點A",
  T_29_M_WS_ITEM25: "出生點B",
  T_29_M_WS_TYPE5: "互動物件",
  T_29_W_PETSKIN_BROWN_TIGER_N: "寵物外觀：地球蒂格",
  T_29_W_PETSKIN_FIRE_TIGER_N: "寵物外觀：火焰蒂格",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "寵物外觀：科技獵隼",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "寵物外觀：派對熊貓",
  T_29_W_PETSKIN_WHITE_TIGER_N: "寵物外觀：冰霜蒂格",
  T_29_W_TIGER_NINJA_N: "蒂格老師",
  T_29_YF_MACHETE_MUSICFEST_N: "大砍刀-音波震盪",
  T_29_YF_MAGEZINE_CHAIN_N: "步槍彈匣",
  T_29_YF_MUZZLE_CRASH_N: "衝鋒槍槍口",
  T_29_YF_MUZZLE_WIDE_N: "霰彈槍槍口",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12-超時空傳送",
  T_29_YF_UZI_GOLDENWING_N: "烏茲手槍-天空行者",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "怪獸卡車-狂怒惡獸",
  T_30_AD_RP_ROUNDEND: "回合結束",
  T_30_AD_TRAINING_SNOWBALL: "雪球",
  T_30_AD_TRAINING_SNOWBALL_DES: "來一場雪球大戰吧",
  T_30_C_SKILL_DESC_BOOYAHGUY: "被攻擊 [FFB300]{0}[-] 秒後，每秒恢復 [FFB300]{1}[-] HP，持續[FFB300] {2}[-] 秒。",
  T_30_C_SKILL_NAME_BOOYAHGUY: "零秒出手",
  T_30_C_SKILL_NAME_MUERTOGUY: "記憶之霧",
  T_30_D_CHARACTER_BOOYAHGUY_N: "里昂",
  T_30_D_CHARACTER_MUERTOGUY_N: "奧托",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "宰伊晶片",
  T_30_L_A_BRMASCOT_ADULT: "老鳥雞(頭飾)",
  T_30_L_A_BRMASCOT_KIDS: "小菜雞(頭飾)",
  T_30_L_A_SUGARSKULL21_BANDANA: "死咬面巾(面飾)",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF 足球服-黑(下裝)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF 足球服-綠(下裝)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF 足球服-灰(下裝)",
  T_30_L_B_BRUNIFORM: "黃毛雛雞(下裝)",
  T_30_L_F_A_SUGARSKULL21: "亡靈饗宴(面飾)",
  T_30_L_F_B_SUGARSKULL21: "亡靈饗宴(下裝)",
  T_30_L_F_B_THASIAN: "凌雲叛軍(下裝)",
  T_30_L_F_H_CATEARS: "可愛小耳朵(頭飾)",
  T_30_L_F_H_SUGARSKULL21: "亡靈饗宴(頭飾)",
  T_30_L_F_H_THASIAN: "凌雲叛軍(頭飾)",
  T_30_L_F_S_SUGARSKULL21: "亡靈饗宴(鞋子)",
  T_30_L_F_S_THASIAN: "凌雲叛軍(鞋子)",
  T_30_L_F_T_SUGARSKULL21: "亡靈饗宴(上裝)",
  T_30_L_F_T_THASIAN: "凌雲叛軍(上裝)",
  T_30_L_H_CHILDRENSDAY_BLUE: "海豚頭(頭飾)",
  T_30_L_H_CHILDRENSDAY_RED: "大象頭(頭飾)",
  T_30_L_H_CLOWNHAT: "馬戲團帽-黃(頭飾)",
  T_30_L_H_ZASCARF: "描金面巾(面飾)",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "黑夜降臨(面飾)",
  T_30_L_M_A_SUGARSKULL21: "金縷亡靈(面飾)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "黑夜降臨(下裝)",
  T_30_L_M_B_PKCRICKET: "板球少年(下裝)",
  T_30_L_M_B_SUGARSKULL21: "金縷亡靈(下裝)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "亡靈之風(下裝)",
  T_30_L_M_B_THASIAN: "翔龍叛軍(下裝)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "黑夜降臨(頭飾)",
  T_30_L_M_H_SUGARSKULL21: "金縷亡靈(頭飾)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "亡靈之風(頭飾)",
  T_30_L_M_H_THASIAN: "翔龍叛軍(頭飾)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "怒雷幽骸(臉彩)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "黑夜降臨(鞋子)",
  T_30_L_M_S_PKCRICKET: "板球少年(鞋子)",
  T_30_L_M_S_SUGARSKULL21: "金縷亡靈(鞋子)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "亡靈之風(鞋子)",
  T_30_L_M_S_THASIAN: "翔龍叛軍(鞋子)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "黑夜降臨(上裝)",
  T_30_L_M_T_PKCRICKET: "板球少年(上裝)",
  T_30_L_M_T_SUGARSKULL21: "金縷亡靈(上裝)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "亡靈之風(上裝)",
  T_30_L_M_T_THASIAN: "翔龍叛軍(上裝)",
  T_30_L_S_BRUNIFORM: "黃毛雛雞(鞋子)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF 足球服-黑(上裝)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF 足球服-綠(上裝)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF 足球服-灰(上裝)",
  T_30_L_T_BRUNIFORM: "黃毛雛雞(上裝)",
  T_30_M_WS_PARTY_MODE: "派對模式",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "下一位挑戰者",
  T_30_R_EMOTE_MAX_NAME: "饒舌風格",
  T_30_R_LEGEND_HALO_NAME: "熾熱光環",
  T_30_T_WS_DEFAULTDESCRIPTION: "我的戰場專屬地圖",
  T_30_T_WS_ITEM26: "輪胎",
  T_30_T_WS_ITEM27: "輪胎堆A",
  T_30_T_WS_ITEM28: "輪胎堆B",
  T_30_T_WS_ITEM29: "輪胎堆C",
  T_30_T_WS_ITEM30: "碰碰車",
  T_30_T_WS_ITEM31: "水陸兩用車",
  T_30_T_WS_ITEM32: "吉普車",
  T_30_T_WS_ITEM33: "垃圾桶",
  T_30_T_WS_ITEM34: "陰影",
  T_30_T_WS_ITEM35: "醫療帳篷",
  T_30_T_WS_ITEM36: "車庫",
  T_30_T_WS_ITEM37: "彩繪牆",
  T_30_T_WS_ITEM38: "鳥居",
  T_30_T_WS_ITEM39: "鐵台",
  T_30_T_WS_ITEM40: "貨櫃屋",
  T_30_T_WS_ITEM41: "拖車",
  T_30_T_WS_ITEM42: "牆壁A",
  T_30_T_WS_ITEM43: "牆壁B",
  T_30_T_WS_ITEM44: "牆壁C",
  T_30_T_WS_ITEM45: "牆壁D",
  T_30_T_WS_ITEM46: "牆壁E",
  T_30_T_WS_ITEM47: "牆壁F",
  T_30_U_ATTACHMENT_1: "護盾擴充器",
  T_30_U_ATTACHMENT_4: "全身裝甲",
  T_30_U_ATTACHMENT_5: "頭盔夾層",
  T_30_U_ATTACHMENT_6: "防爆夾層",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "寵物外觀：骷髏魈",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "寵物外觀：龐克瓦哥",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "寵物外觀：狙擊蹦蹦",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "寵物外觀：慶典蹦蹦",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "寵物外觀：科技蹦蹦",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "寵物外觀：圓眼滾滾",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "寵物外觀：鮮綠滾滾",
  T_30_W_RABBIT_N: "蹦蹦特務",
  T_30_XH_PCMAP_P17: "工廠",
  T_30_YF_GLOO_BOOYAHDAY21_N: "凝膠護盾-勝利怒吼",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "手榴彈-勝利怒吼",
  T_30_YF_Healinggun_Sniper_N: "治療狙擊槍",
  T_30_YF_MINI_LIGHTFEST_N: "AC80-砂金勇士",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL-緋紅傳承",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR-砂金勇士",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "湯普森衝鋒槍-金縷傳承",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "超跑-罪惡旋律",
  T_31_C_SKILL_NAME_WINTERGUY: "不毀堅冰",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "球棒-骷髏天使",
  T_31_HQ_GLOO_EAGLE_N: "凝膠護盾-灼熱沙漠",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "治療狙擊槍-骷髏天使",
  T_31_HQ_KATANA_WINTERFEST21_N: "武士刀-耶誕祝福",
  T_31_HQ_PAN_WINTERFEST21_N: "平底鍋-骷髏天使",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "寵物外觀：冰雪吞吞",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "寵物外觀：冰雪瓦哥",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "寵物外觀：森林毛毛",
  T_31_HQ_PETSKIN_YETI_RED_N: "寵物外觀：烈火毛毛",
  T_31_HQ_SICKLE_WINTERFEST21_N: "鐮刀-耶誕驚喜",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "機車-新紀元",
  T_31_HQ_YETI_N: "雪怪毛毛",
  T_31_KK_WINTER_BUJIX: "輔助箱",
  T_31_KK_WINTER_SANJITOU: "頭盔",
  T_31_L_A_BDCRICKET: "勝利猛擊(面飾)",
  T_31_L_A_WINTERFEST21: "麋鹿面巾(面飾)",
  T_31_L_B_BDCRICKET: "勝利猛擊(下裝)",
  T_31_L_B_MEJERSEY_10: "10號前鋒球員(下裝)",
  T_31_L_B_MEJERSEY_11: "11號中鋒球員(下裝)",
  T_31_L_B_MEJERSEY_13: "13號後衛球員(下裝)",
  T_31_L_B_MEJERSEY_18G: "18號前鋒球員(下裝)",
  T_31_L_B_MEJERSEY_18R: "18號後衛球員(下裝)",
  T_31_L_B_MEJERSEY_7: "7號前鋒球員(下裝)",
  T_31_L_F_B_RUMUSICIAN: "深紅魅惑(下裝)",
  T_31_L_F_B_THAGENT: "夜色潛行者(下裝)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "漸層漁夫帽(頭飾)",
  T_31_L_F_H_RUMUSICIAN: "深紅魅惑(頭飾)",
  T_31_L_F_H_THAGENT: "夜色潛行者(頭飾)",
  T_31_L_F_HA_RUMUSICIAN: "深紅魅惑(臉彩)",
  T_31_L_F_S_RUMUSICIAN: "深紅魅惑(鞋子)",
  T_31_L_F_S_THAGENT: "夜色潛行者(鞋子)",
  T_31_L_F_T_RUMUSICIAN: "深紅魅惑(上裝)",
  T_31_L_F_T_THAGENT: "夜色潛行者(上裝)",
  T_31_L_HA_RUMUSICIAN_MU: "深紅陷阱(臉彩)",
  T_31_L_HA_WINTERFEST21_BLUE: "雪花(臉彩)",
  T_31_L_HA_WINTERFEST21_PINK: "紅粉戀人(臉彩)",
  T_31_L_M_A_REGGAETON_B: "深藍閃電(面飾)",
  T_31_L_M_A_REGGAETON_P: "粉紅閃電(面飾)",
  T_31_L_M_A_RUMUSICIAN: "深紅陷阱(面飾)",
  T_31_L_M_A_THAGENT: "暗月王權(面飾)",
  T_31_L_M_B_PKCOSTUME: "沙瓦卡米茲(下裝)",
  T_31_L_M_B_REGGAETON_B: "深藍閃電(下裝)",
  T_31_L_M_B_REGGAETON_P: "粉紅閃電(下裝)",
  T_31_L_M_B_RUMUSICIAN: "深紅陷阱(下裝)",
  T_31_L_M_B_THAGENT: "暗月王權(下裝)",
  T_31_L_M_H_GREENCAP: "綠星帽(頭飾)",
  T_31_L_M_H_PKCOSTUME: "沙瓦卡米茲(頭飾)",
  T_31_L_M_H_REGGAETON_B: "深藍閃電(頭飾)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "漸層漁夫帽(頭飾)",
  T_31_L_M_H_REGGAETON_P: "粉紅閃電(頭飾)",
  T_31_L_M_H_RUMUSICIAN: "深紅陷阱(頭飾)",
  T_31_L_M_H_THAGENT: "暗月王權(頭飾)",
  T_31_L_M_S_PKCOSTUME: "沙瓦卡米茲(鞋子)",
  T_31_L_M_S_REGGAETON_B: "深藍閃電(鞋子)",
  T_31_L_M_S_REGGAETON_P: "粉紅閃電(鞋子)",
  T_31_L_M_S_RUMUSICIAN: "深紅陷阱(鞋子)",
  T_31_L_M_S_THAGENT: "暗月王權(鞋子)",
  T_31_L_M_T_PKCOSTUME: "沙瓦卡米茲(上裝)",
  T_31_L_M_T_REGGAETON_B: "深藍閃電(上裝)",
  T_31_L_M_T_REGGAETON_P: "粉紅閃電(上裝)",
  T_31_L_M_T_REGGAETON_TATOO: "原始刺青",
  T_31_L_M_T_RUMUSICIAN: "深紅陷阱(上裝)",
  T_31_L_M_T_THAGENT: "暗月王權(上裝)",
  T_31_L_S_BDCRICKET: "勝利猛擊(鞋子)",
  T_31_L_T_BDCRICKET: "勝利猛擊(上裝)",
  T_31_L_T_BRBANK: "褐紅轟炸(上裝)",
  T_31_L_T_MEJERSEY_10: "10號前鋒球員(上裝)",
  T_31_L_T_MEJERSEY_11: "11號中鋒球員(上裝)",
  T_31_L_T_MEJERSEY_13: "13號後衛球員(上裝)",
  T_31_L_T_MEJERSEY_18G: "18號前鋒球員(上裝)",
  T_31_L_T_MEJERSEY_18R: "18號後衛球員(上裝)",
  T_31_L_T_MEJERSEY_7: "7號前鋒球員(上裝)",
  T_31_L_T_PKMOBILE: "Infinix T-Shirt",
  T_31_L_T_REGGAETON_HOOD: "微笑連帽衫(上裝)",
  T_31_MF_CHARACTER_WINTERGUY_N: "奈里",
  T_31_R_EMOTE_FALCONER_NAME: "No.1",
  T_31_RW_COMBINEMACHINE_2: "雙持啟動器(進階)",
  T_31_RW_VIBRATION_EXPLOSION: "爆炸",
  T_31_RW_VIBRATION_MELEEWEAPONS: "近戰武器",
  T_31_RW_VIBRATION_OTHERWEAPONS: "其他武器",
  T_31_T_WS_1PLAYERTEAM: "單人",
  T_31_T_WS_2PLAYERTEAM: "雙人",
  T_31_T_WS_3PLAYERTEAM: "三人",
  T_31_T_WS_4PLAYERTEAM: "四人",
  T_31_T_WS_5PLAYERTEAM: "五人對局",
  T_31_T_WS_6PLAYERTEAM: "六人",
  T_31_T_WS_BUFFTIME_TITLE: "刷新時間(秒)",
  T_31_T_WS_BUFFTYPE_AMMO: "子彈",
  T_31_T_WS_BUFFTYPE_ARMOR: "護甲",
  T_31_T_WS_BUFFTYPE_HP: "生命",
  T_31_T_WS_BUFFTYPE_RANDOM: "隨機",
  T_31_T_WS_BUFFTYPE_TITLE: "加成類型",
  T_31_T_WS_DESC48: "可用來空間傳送的裝置",
  T_31_T_WS_DESC49: "發出鋼琴聲的方塊",
  T_31_T_WS_DESC51: "發出鼓聲的方塊",
  T_31_T_WS_DESC53: "發出合成器聲的方塊",
  T_31_T_WS_DESC59: "一個會周期性生成加成效果的裝置，拾取後獲得對應的加成效果",
  T_31_T_WS_DRUMTYPE_CLAPS: "拍掌",
  T_31_T_WS_DRUMTYPE_HIHATS: "腳踏鈸",
  T_31_T_WS_DRUMTYPE_KICK: "大鼓",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "開鈸",
  T_31_T_WS_DRUMTYPE_RIDES: "曡音鈸",
  T_31_T_WS_DRUMTYPE_SNARES: "小鼓",
  T_31_T_WS_EARLYSHRINK: "快速縮圈",
  T_31_T_WS_ITEM48: "傳送門",
  T_31_T_WS_ITEM49: "鋼琴鍵",
  T_31_T_WS_ITEM51: "鼓鍵",
  T_31_T_WS_ITEM53: "合成器鍵A",
  T_31_T_WS_ITEM55: "合成器鍵B",
  T_31_T_WS_ITEM57: "合成器鍵C",
  T_31_T_WS_ITEM59: "加成產生器",
  T_31_T_WS_LATESHRINK: "慢速縮圈",
  T_31_T_WS_ME_DAMAGE: "傷害量",
  T_31_T_WS_ME_DAMAGED: "受到傷害量",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "初始EP值比例",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "初始安全區半徑",
  T_31_T_WS_ME_EPQUICKRESTORE: "EP 快速轉換",
  T_31_T_WS_ME_FLOW: "模式",
  T_31_T_WS_ME_GENERALSETTING: "通用設定",
  T_31_T_WS_ME_INRANDOMSPAWN: "隨機出生點",
  T_31_T_WS_ME_KILLSCORE: "擊殺加分",
  T_31_T_WS_ME_MAXEP: "EP上限",
  T_31_T_WS_ME_MAXHP: "生命上限",
  T_31_T_WS_ME_NEARTEAM: "隊友附近",
  T_31_T_WS_ME_REBIRTH: "重生等待時間",
  T_31_T_WS_ME_REBIRTHLOCATION: "重生位置",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "開始縮圈時間",
  T_31_T_WS_ME_WINSCORE: "獲勝分數",
  T_31_T_WS_MINIZONE: "小型戰場",
  T_31_T_WS_MUSICTYPE_TITLE: "音樂類型",
  T_31_T_WS_UNLIMITEDAMMO: "無限子彈",
  T_31_WT_WS_DESC1: "可以堆疊使用的普通正方形木箱",
  T_31_WT_WS_DESC10: "破舊的木製小屋，有木樓梯可上樓",
  T_31_WT_WS_DESC11: "破舊的哨塔，有多個可供射擊的窗戶",
  T_31_WT_WS_DESC12: "金屬製的警衛室，有門及窗戶",
  T_31_WT_WS_DESC13: "有多個門窗的民房",
  T_31_WT_WS_DESC14: "兩層樓的露天民房",
  T_31_WT_WS_DESC15: "兩層樓的封閉式民房",
  T_31_WT_WS_DESC16: "裝飾物-新型的沙雕",
  T_31_WT_WS_DESC17: "裝飾物-噴泉",
  T_31_WT_WS_DESC18: "裝飾物-盛開的櫻花樹",
  T_31_WT_WS_DESC19: "裝飾物-沒有香蕉的小型香蕉樹",
  T_31_WT_WS_DESC2: "普通的長方形木箱，可堆疊使用",
  T_31_WT_WS_DESC20: "白色馬桶，可做為室內家具",
  T_31_WT_WS_DESC21: "小型圍欄，做為分隔區域使用",
  T_31_WT_WS_DESC22: "側面木板可被打碎的集裝箱",
  T_31_WT_WS_DESC23: "可被打碎的小型圍欄",
  T_31_WT_WS_DESC24: "隊伍A出生區域，僅在特定模式下生效（團隊突襲/團隊死鬥/派對模式）",
  T_31_WT_WS_DESC25: "隊伍B出生區域，僅在特定模式下生效（團隊突襲/團隊死鬥/派對模式）",
  T_31_WT_WS_DESC26: "可以將玩家向前彈射一小段距離的輪胎",
  T_31_WT_WS_DESC27: "可以將玩家向特定方向彈射一小段距離的輪胎",
  T_31_WT_WS_DESC28: "可以將玩家向特定方向彈射中段距離的輪胎",
  T_31_WT_WS_DESC29: "可以將玩家向特定方向彈射一大段距離的輪胎",
  T_31_WT_WS_DESC3: "紅黃相間的灌木，可作為點綴戰場使用",
  T_31_WT_WS_DESC30: "一輛可駕駛的碰碰車",
  T_31_WT_WS_DESC31: "一輛可駕駛的水陸兩用車",
  T_31_WT_WS_DESC32: "一輛可駕駛的吉普車",
  T_31_WT_WS_DESC33: "專滿垃圾的垃圾桶，略矮於人，可做為掩體使用",
  T_31_WT_WS_DESC34: "半開放的金屬製小型觀賽亭",
  T_31_WT_WS_DESC35: "有兩扇門的中型醫療帳篷",
  T_31_WT_WS_DESC36: "半開放式的大型車庫",
  T_31_WT_WS_DESC37: "磚塊堆砌而成的大型圍牆，可用於分隔區域",
  T_31_WT_WS_DESC38: "一個實用的地標",
  T_31_WT_WS_DESC39: "金屬質感的大型平台，可做為主要戰場",
  T_31_WT_WS_DESC4: "普通的草叢，比人高，可充當掩體使用",
  T_31_WT_WS_DESC40: "類似房車結構的小型建築，有多個門窗",
  T_31_WT_WS_DESC41: "類似房車結構的小型建築，有多個窗戶及單門",
  T_31_WT_WS_DESC42: "有門的單面磚牆",
  T_31_WT_WS_DESC43: "普通的單面磚牆",
  T_31_WT_WS_DESC44: "平整的直角磚牆",
  T_31_WT_WS_DESC45: "凹陷的直角磚牆",
  T_31_WT_WS_DESC46: "凹陷的直角磚牆",
  T_31_WT_WS_DESC47: "有窗的直角磚牆",
  T_31_WT_WS_DESC5: "廢棄的小轎車，略比人矮，可作為掩體使用",
  T_31_WT_WS_DESC6: "小巴士，略比人高，可做為掩體使用",
  T_31_WT_WS_DESC7: "前後貫通的貨櫃，可用於分隔區域、構成通路",
  T_31_WT_WS_DESC8: "單面貫通的貨櫃，可用於分隔區域",
  T_31_WT_WS_DESC9: "封閉的貨櫃，可用於分隔區域",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "載具",
  T_31_Z_OB_UAV: "無人機",
  T_32_C_SKILL_DESC_YAKUZA: "快速向前方衝刺，持續[FFB300]{0} 秒[-]。這個技能最多可以累積使用[FFB300] {2} [-]次，每次使用之間有 [FFB300]{3} 秒[-]的冷卻時間。衝刺回復時間為[FFB300] {1} 秒[-]。",
  T_32_C_SKILL_NAME_YAKUZA: "急速衝鋒",
  T_32_HQ_AUG_VNSTREET_N: "AUG-咆嘯槍手",
  T_32_HQ_BACKPACK_REDDRAGON_N: "背包-黎明惡獸",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B-血族惡意",
  T_32_HQ_GLOO_DUNHUANG_N: "凝膠護盾-急凍鉑金",
  T_32_HQ_GLOO_HURRICANE_2_N: "凝膠護盾-音浪節奏",
  T_32_HQ_GRENADE_HURRICANE_N: "手榴彈-黃銅麥克風",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10-急凍鉑金",
  T_32_HQ_PETSKIN_DUCK_RED_N: "寵物外觀：小紅豆豆",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "寵物外觀：科技麥麥龜",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "寵物外觀：玩家麥麥龜",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "寵物外觀：節慶麥麥龜",
  T_32_HQ_TORTOISE_N: "麥麥龜",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "超跑-閃螢紫塵",
  T_32_L_F_A_PHARAOH: "金裝克麗奧(面飾)",
  T_32_L_F_B_PHARAOH: "金裝克麗奧(下裝)",
  T_32_L_F_H_PHARAOH: "金裝克麗奧(頭飾)",
  T_32_L_F_HA_PHARAOH: "金裝克麗奧(臉彩)",
  T_32_L_F_S_PHARAOH: "金裝克麗奧(鞋子)",
  T_32_L_F_T_PHARAOH: "金裝克麗奧(上裝)",
  T_32_L_M_A_JUNKFOOD: "無博弈(面飾)",
  T_32_L_M_A_PHARAOH: "金絲法老(面飾)",
  T_32_L_M_B_JUNKFOOD: "無博弈(下裝)",
  T_32_L_M_B_PHARAOH: "金絲法老(下裝)",
  T_32_L_M_H_JUNKFOOD: "無博弈(頭飾)",
  T_32_L_M_H_PHARAOH: "金絲法老(頭飾)",
  T_32_L_M_S_JUNKFOOD: "無博弈(鞋子)",
  T_32_L_M_S_PHARAOH: "金絲法老(鞋子)",
  T_32_L_M_T_JUNKFOOD: "無博弈(上裝)",
  T_32_L_M_T_PHARAOH: "金絲法老(上裝)",
  T_32_L_T_WHITESWEATER: "白色高領衫(上裝)",
  T_32_LC_NEWVAULT_EMOTE: "表情",
  T_32_LO_WS_IMMORTAL: "無敵區域",
  T_32_LO_WS_ITEM60: "管道",
  T_32_LO_WS_ITEM60_DESC: "可直接通過的大型管道",
  T_32_LO_WS_ITEM61: "T型管道",
  T_32_LO_WS_ITEM61_DESC: "可以通過的T型管道",
  T_32_LO_WS_ITEM62: "十字管道",
  T_32_LO_WS_ITEM62_DESC: "可以通過的十字管道",
  T_32_LO_WS_ITEM63: "轉角管道",
  T_32_LO_WS_ITEM63_DESC: "可以通過的直角管道",
  T_32_LO_WS_ITEM64: "小餐車",
  T_32_LO_WS_ITEM64_DESC: "路邊常見的餐飲車",
  T_32_LO_WS_ITEM65: "巨型蘑菇群",
  T_32_LO_WS_ITEM65_DESC: "奇異的巨大蘑菇，就算是人的重量也可踩在上面",
  T_32_LO_WS_ITEM66: "衣架",
  T_32_LO_WS_ITEM66_DESC: "常見於居民區",
  T_32_LO_WS_ITEM67: "木板橋",
  T_32_LO_WS_ITEM67_DESC: "一塊堅硬的木板，可作為簡易的橋讓人通過",
  T_32_LO_WS_ITEM68: "屏風",
  T_32_LO_WS_ITEM68_DESC: "充滿亞洲風格的裝飾物",
  T_32_LO_WS_ITEM69: "柱子",
  T_32_LO_WS_ITEM69_DESC: "工地常見的結構性柱子",
  T_32_LO_WS_ITEM70: "仙人掌",
  T_32_LO_WS_ITEM70_DESC: "碩大的仙人掌，其尖刺不對人造成傷害",
  T_32_LO_WS_ITEM71: "枯木",
  T_32_LO_WS_ITEM71_DESC: "乾枯沒有樹葉的樹木",
  T_32_LO_WS_ITEM72: "石燈籠",
  T_32_LO_WS_ITEM72_DESC: "日式庭院風格常出現的裝飾物",
  T_32_LO_WS_ITEM73: "街燈",
  T_32_LO_WS_ITEM73_DESC: "街道旁常見的路燈",
  T_32_LO_WS_ITEM74: "太陽能板",
  T_32_LO_WS_ITEM74_DESC: "透過日光轉換成電力",
  T_32_LO_WS_ITEM75: "冷氣機A",
  T_32_LO_WS_ITEM75_DESC: "酷暑中的必備家電",
  T_32_LO_WS_ITEM76: "螺旋槳機關",
  T_32_LO_WS_ITEM77: "平底鍋機關",
  T_32_LO_WS_ITEM78: "方塊機關",
  T_32_LO_WS_ITEM79: "圓環機關",
  T_32_LO_WS_ITEM80: "巨槌機關",
  T_32_LO_WS_ITEM81: "移動板",
  T_32_LO_WS_ITEM82: "移動靶",
  T_32_LO_WS_ITEM83: "伸縮牆",
  T_32_LO_WS_ITEM84AMMO: "彈藥點",
  T_32_LO_WS_ITEM84AMMO_DESC: "放置後將出現所選擇的子彈種類",
  T_32_LO_WS_ITEM84AR: "護具點",
  T_32_LO_WS_ITEM84AR_DESC: "放置後將出現所選擇的護具種類",
  T_32_LO_WS_ITEM84ARLV1: "護甲 Lv.1",
  T_32_LO_WS_ITEM84ARLV2: "護甲 Lv.2",
  T_32_LO_WS_ITEM84ARLV3: "護甲 Lv.3",
  T_32_LO_WS_ITEM84CO: "消耗品點",
  T_32_LO_WS_ITEM84CO_DESC: "放置後將出現所選擇的消耗品",
  T_32_LO_WS_ITEM84JA: "投擲物點",
  T_32_LO_WS_ITEM84JA_DESC: "放置後將出現所選擇的投擲物種類",
  T_32_LO_WS_ITEM84TE: "瞄準鏡點",
  T_32_LO_WS_ITEM84TE_DESC: "放置後將出現所選擇的瞄準鏡",
  T_32_LO_WS_ITEM84W: "武器點",
  T_32_LO_WS_ITEM84W_DESC: "放置後將出現所選擇的武器種類",
  T_32_LO_WS_ITEM85: "死亡/無敵區域",
  T_32_LO_WS_ITEM85_DESC: "放置一個玩家觸碰後會發生不同效果的物件，可以選無敵或死亡效果，在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_32_LO_WS_ITEM85CP: "檢查點",
  T_32_LO_WS_ITEM85CP_DESC: "跑酷模式中必須擺放的物件，放置後，玩家通過檢查點後死亡將回到最近的檢查點重生，在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_32_LO_WS_ITEM85TM: "終點",
  T_32_LO_WS_ITEM85TM_DESC: "跑酷模式中必須擺放的物件，放置後，玩家通過終點將完成遊戲，在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_32_LO_WS_ITEM86: "通用出生點",
  T_32_LO_WS_ITEM86_DESC: "不分陣營，放置後隊伍將隨機於通用出生點進行復活，若隊伍數量大於通用出生點數量，出生點有可能出現2支以上的隊伍，在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_32_LO_WS_ITEM86L: "大型出生點",
  T_32_LO_WS_ITEM86L_DESC: "跑酷模式專用，放置後所有的玩家將在相同的出生點開始，在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_32_LO_WS_ITEM87: "基本方塊",
  T_32_LO_WS_ITEM87_DESC: "可以隨意調整大小的基礎方塊",
  T_32_LO_WS_ITEM88: "立方體與斜坡",
  T_32_LO_WS_ITEM88_DESC: "一個大小可調整的長方體或斜面",
  T_32_LO_WS_ITEMLINE: "移動",
  T_32_LO_WS_ITEMMOVE: "機關設定",
  T_32_LO_WS_ITEMROT: "變換",
  T_32_LO_WS_ITEMSCALE: "縮放",
  T_32_LO_WS_KILLZONE: "死亡區域",
  T_32_LO_WS_LOOT_AMMOTYPE: "子彈",
  T_32_LO_WS_LOOT_ARTYPE: "護具",
  T_32_LO_WS_LOOT_COTYPE: "消耗品",
  T_32_LO_WS_LOOT_JATYPE: "投擲物",
  T_32_LO_WS_LOOT_RANDOM: "隨機掉落",
  T_32_LO_WS_LOOT_TETYPE: "瞄準鏡",
  T_32_LO_WS_LOOT_WEAPONTYPE: "武器",
  T_32_LO_WS_SCALEX: "長度",
  T_32_LO_WS_SCALEY: "高度",
  T_32_LO_WS_SCALEZ: "寬度",
  T_32_LO_WS_TRIGGERH: "隱藏",
  T_32_LO_WS_TRIGGERHORP: "顯示/隱藏觸發器",
  T_32_LO_WS_TRIGGERP: "顯示",
  T_32_LO_WS_TRIGGERTYPE: "觸發器類型",
  T_32_M_WS_MODE_ANNIHILATE: "殲滅",
  T_32_M_WS_MODE_SCORE: "獲得分數",
  T_32_M_WS_MODE_SPEED: "跑酷",
  T_32_M_WS_MULTIPLETEAMS: "多隊戰鬥",
  T_32_M_WS_ROUNDS: "回合",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "神奇腳步",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "危險區",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "傷害",
  T_32_T_WS_ME_BLUECIRCLESETTING: "危險區設定",
  T_32_T_WS_ME_CUSTOM: "自訂模式",
  T_32_T_WS_ME_ENDTYPE1: "殲滅",
  T_32_T_WS_ME_ENDTYPE2: "積分",
  T_32_T_WS_ME_ENDTYPE3: "跑酷",
  T_32_T_WS_ME_ENDTYPEDESC1: "成為最後存活的隊伍",
  T_32_T_WS_ME_ENDTYPEDESC2: `積分制模式，率先達到目標分數的隊伍獲勝。
你可以自由設定遊戲規則與調整遊戲參數，包括設定淘汰後獲得的分數。`,
  T_32_T_WS_ME_ENDTYPEDESC3: `跑酷模式，率先讓全隊成員到達終點的隊伍獲勝。
你可以自由設定遊戲規則、路徑上的物件以及終點位置。`,
  T_32_T_WS_ME_MATCHTIME: "比賽時間",
  T_32_T_WS_ME_MECHANIC: "機制",
  T_32_T_WS_ME_NEARCHECKPOINT: "檢查點周圍",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "總人數無法超過 12 人",
  T_32_T_WS_ME_PREGAMETIME: "準備階段",
  T_32_T_WS_ME_RESPAWN: "重生",
  T_32_T_WS_ME_RESPAWNSETTING: "重生設定",
  T_32_T_WS_ME_ROUNDNUM: "回合數",
  T_32_T_WS_ME_ROUNDOPEN: "是否開啟多回合",
  T_32_T_WS_ME_ROUNDRESET: "回合重置內容",
  T_32_T_WS_ME_ROUNDSETTING: "回合設定",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "縮圈時間",
  T_32_T_WS_ME_SCORESETTING: "積分設定",
  T_32_T_WS_ME_TEAMMATENUM: "隊伍人數",
  T_32_T_WS_ME_TEAMNUM: "隊伍數量",
  T_32_T_WS_ME_TEAMSETTING: "隊伍設定",
  T_32_U_ATTACHMENT_8: "擴充包",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "等離子槍-I",
  T_32_U_GOLD_HEATGUN_II: "等離子槍-II",
  T_32_U_GOLD_HEATGUN_III: "等離子槍-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "升級晶片",
  T_32_WT_WS_BARRIER: "障礙物",
  T_32_WT_WS_BDS: "建築物",
  T_32_WT_WS_MMINVALIDERROR: "無效的地圖代碼",
  T_32_WT_WS_TRGS: "觸發器",
  T_32_YF_CHARGESHOT_N: "蓄力剋星",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "額外傷害",
  T_32_YS_WEAPON_TAG_3: "射速",
  T_32_YS_WEAPON_TAG_36: "破甲",
  T_32_YS_WEAPON_TAG_39: "可雙持",
  T_32_YS_WEAPON_TAG_42: "冰牆",
  T_33_C_SKILL_DESC_GRAFFITIST: "創建一個 [FFB300]{0} 公尺[-]的投擲物傷害無效區域。範圍內隊友每秒將恢復 [FFB300]{1}%[-] 護甲耐久度，敵人給予的子彈傷害減少 [FFB300]{2}%[-]。持續 [FFB300]{3} 秒[-]。效果無法疊加。冷卻時間：[FFB300]{4} 秒[-]。",
  T_33_C_SKILL_DESC_HITMAN: "使用狙擊槍和射手步槍射擊時，附加消音效果，擊倒敵人時，被擊倒的敵人流血速度提升 [FFB300]{0}%[-]。",
  T_33_C_SKILL_DESC_KENTA: "形成一個 [FFB300]{0} 公尺[-]的護盾，減少來自正面的 [FFB300]{1}%[-] 武器傷害，持續 [FFB300]{3} 秒[-]，射擊時減傷變為 [FFB300]{2}%[-]，冷卻時間：[FFB300]{4} 秒[-]。",
  T_33_C_SKILL_DESC_MADEMANA: "釋放 [FFB300]{0} 公尺[-]的電磁波，阻止敵人施放技能，造成 [FFB300]{3} [-]傷害，並打斷對方的讀取倒數，持續 [FFB300]{1} 秒[-]。冷卻時間：[FFB300]{2} 秒[-]。",
  T_33_C_SKILL_NAME_BODYGUARD: "槍械專家",
  T_33_C_SKILL_NAME_KENTA: "武者之怒",
  T_33_C_SKILL_NAME_MADEMANA: "戰爭顫慄",
  T_33_DY_AXOLOTL_N: "絨恩",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "寵物外觀：西瓜絨恩",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "寵物外觀：電競豆豆",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "寵物外觀：叢林獵隼",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "球棒-法國麵包",
  T_33_HQ_EMOTE_SONGKRAN_N: "一同舞蹈",
  T_33_HQ_G18_CYBERTHIEF_N: "G18-核心藍調",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "手榴彈-宇宙科技",
  T_33_HQ_M14_SPIDERLILY_N: "M14-彼岸業花",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG7-神秘組織",
  T_33_HQ_MP40_FFWS03_N: "MP40-殿堂守衛",
  T_33_HQ_SCAR_FFWS03_N: "SCAR-殿堂守衛",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "鐮刀-綠光魔法",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "飛刀-殿堂守衛",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector-核心藍調",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "吉普車-綠銹焱",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "怪獸卡車-群山獅吼",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "皮卡車-殿堂守護者",
  T_33_LO_WS_BHPARA_A: "主動",
  T_33_LO_WS_BHPARA_ATKMODE: "攻擊模式",
  T_33_LO_WS_BHPARA_GROUP: "陣營",
  T_33_LO_WS_BHPARA_NA: "不攻擊",
  T_33_LO_WS_BHPARA_P: "被動",
  T_33_LO_WS_DICE_DESC: "彈跳能力極佳的骰子，可以用在各種遊戲",
  T_33_LO_WS_DICEVXZ: "X、Z軸彈跳速度",
  T_33_LO_WS_DICEVY: "Y軸彈跳速度",
  T_33_LO_WS_DTOWER: "防禦塔",
  T_33_LO_WS_DTOWER_DESC: "一定範圍內會自動攻擊敵人的防禦建築。如果其 HP 達到零，則停止。在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_33_LO_WS_FORT: "堡壘",
  T_33_LO_WS_FORT_DESC: "一定範圍內會自動攻擊敵人的堡壘建築。如果其 HP 達到零，則停止。在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_33_LO_WS_ITEM89: "大水罐",
  T_33_LO_WS_ITEM89_DESC: "巨大的儲水建築",
  T_33_LO_WS_ITEM90: "狗屋",
  T_33_LO_WS_ITEM90_DESC: "小狗的家",
  T_33_LO_WS_ITEM91: "公車站",
  T_33_LO_WS_ITEM91_DESC: "一個普通的公車站",
  T_33_LO_WS_ITEM92: "塗鴉牆",
  T_33_LO_WS_ITEM92_DESC: "用噴漆裝飾的井",
  T_33_LO_WS_ITEM93: "草棚",
  T_33_LO_WS_ITEM93_DESC: "簡易的草木建築",
  T_33_LO_WS_ITEM94: "長椅",
  T_33_LO_WS_ITEM94_DESC: "公園常見的椅子",
  T_33_LO_WS_ITEM95: "石橋",
  T_33_LO_WS_ITEM95_DESC: "用石頭建造的橋",
  T_33_LO_WS_ITEM96: "傘桌組合",
  T_33_LO_WS_ITEM96_DESC: "在傘下防止太陽曬傷",
  T_33_LO_WS_ITEM97: "終點線",
  T_33_LO_WS_ITEM97_DESC: "標註終點的橫幅",
  T_33_LO_WS_ITEM98: "廣告牌",
  T_33_LO_WS_ITEM98_DESC: "常見的廣告牌",
  T_33_LO_WS_PARA_DM: "傷害",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "感應範圍",
  T_33_LO_WS_PARA_SP: "速度",
  T_33_LO_WS_ZBPARA_AMOUNT: "每波殭屍數量",
  T_33_LO_WS_ZBPARA_INTERVAL: "間隔時間(秒)",
  T_33_LO_WS_ZBPARA_ROUND: "生成波數",
  T_33_LO_WS_ZBSPAWNER: "殭屍產生器",
  T_33_LO_WS_ZBSPAWNER_DESC: "依照設定自動生成殭屍，並可以在一定程度上規定殭屍的行為。在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_33_MF_CHARACTER_BLACKSMITH_N: "健太",
  T_33_PD_ZOMBIE_LEVELUP: "升級",
  T_33_RW_SKILL_DESC_GANGGIRL: "獲得 [FFB300]{0}%[-] 射速，擊中敵人時逐漸轉化為機動性，最多獲得 [FFB300]{1}%[-] 機動性。脫離戰鬥後轉化將會重置。",
  T_33_RW_SKILL_NAME_GANGGIRL: "罪惡狂歡",
  T_33_WT_WS_BASICSET1: "基礎設定",
  T_33_WT_WS_QCEPRTIP: "EP 快速轉換 HP",
  T_33_WT_WS_SKILLSET_TAG: "無技能冷卻時間",
  T_33_WT_WS_SKILLSET1: "技能設定",
  T_33_WT_WS_SKILLSET10: "時空屏障 (Chrono)",
  T_33_WT_WS_SKILLSET11: "節奏狂潮 (斯凱伊爾)",
  T_33_WT_WS_SKILLSET12: "極限執行者 (夏涅)",
  T_33_WT_WS_SKILLSET13: "心跳節拍 (Dimitri)",
  T_33_WT_WS_SKILLSET2: "被動技能",
  T_33_WT_WS_SKILLSET2_TIP: "關閉/開啟被動技能",
  T_33_WT_WS_SKILLSET3: "主動技能(開啟以調整下方冷卻時間)",
  T_33_WT_WS_SKILLSET3_TIP: "關閉/開啟主動技能。若開啟主動技能可以在下方按照比例調整冷卻時間",
  T_33_WT_WS_SKILLSET4: "幻化術 (悟空)",
  T_33_WT_WS_SKILLSET5: "戰爭顫慄 (A124)",
  T_33_WT_WS_SKILLSET6: "激勵旋律 (Alok)",
  T_33_WT_WS_SKILLSET7: "塗鴉庇護 (史黛菲)",
  T_33_WT_WS_SKILLSET8: "行蹤探查 (克露)",
  T_33_WT_WS_SKILLSET9: "全面菁英 (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/秒",
  T_33_WT_WS_UNIT_METER: "公尺",
  T_33_WT_WS_UNIT_SECOND: "秒",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "雨夜殺機(下裝)",
  T_33_YS_H_ONIGIRI: "御飯糰(頭飾)",
  T_33_YS_H_RAINCOAT: "雨夜殺機(頭飾)",
  T_33_YS_HA_CRYINGFACE: "哭哭(臉彩)",
  T_33_YS_M_H_FROGKING: "青蛙王子(頭飾)",
  T_33_YS_S_RAINCOAT: "雨夜殺機(鞋子)",
  T_33_YS_T_BLACKHOLE: "宇宙奇點(上裝)",
  T_33_YS_T_RAINCOAT: "雨夜殺機(上裝)",
  T_33_YS_T_SOCCER_GREEN: "綠格球員(上裝)",
  T_33_YS_T_SOCCER_YELLOW: "黃格球員(上裝)",
  T_33_YS_T_WIFI: "WiFi T-Shirt",
  T_34_C_SKILL_DESC_STREAMERGUY: "每次擊殺或被觀戰將增加疊層。每次疊加減少受到的爆頭傷害 [FFB300]{0}%[-] (最多 [FFB300]{1}%[-]) 並增加對敵人的爆頭傷害 [FFB300]{2}%[-] (最多[FFB300]{3}%[-])。",
  T_34_C_SKILL_DESC_TRACKER: "向前方 [FFB300]100 公尺[-] 內距離最近的敵人釋放 1 架無人機，產生直徑 [FFB300]{5} 公尺[-]的爆炸，降低 [FFB300]{0}%[-] 機動性和 [FFB300]{1}%[-] 射速，持續 [FFB300]{3} 秒[-]，造成 [FFB300]{2} [-]傷害，冷卻時間：[FFB300]{4} 秒[-]。",
  T_34_C_SKILL_NAME_TRACKER: "感應衝擊",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "寵物外觀：森七七鯊鯊芬恩",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "寵物外觀：深海鯊鯊芬恩",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "寵物外觀：雷霆鯊鯊芬恩",
  T_34_DY_PETSKIN_TIGER_BIS_N: "寵物外觀：數位蒂格",
  T_34_DY_SURFSHARK_N: "鯊鯊芬恩",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "傳奇指揮家",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "炸～裂～",
  T_34_HQ_EMOTE_RIDICULE_N: "嘲諷",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "皮卡車-邪惡工程師",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "嘟嘟車-毛絨二哈",
  T_34_JL_EAGLE_RAMPAGE4_N: "沙漠之鷹-混搭爆破",
  T_34_JL_G36_MADBIONIC_N: "G36-街頭暴走",
  T_34_JL_GRENADE_BIS_N: "手榴彈-玩酷潮流",
  T_34_JL_MACHETE_RAMPAGE4_N: "大砍刀-夜刃",
  T_34_JL_THROWINGKNIFE_BANANA_N: "飛刀-尊的芭娜娜",
  T_34_JL_UMP45_BIS_N: "UMP-玩酷潮流",
  T_34_LY_WS_ABS_DESC: "獲取這個數的絕對值",
  T_34_LY_WS_ADD_DESC: "在列表末尾添加一個新元素",
  T_34_LY_WS_AUTO_A: "自動掃描敵人",
  T_34_LY_WS_BOT: "常規的",
  T_34_LY_WS_BOT_PATH: "小路",
  T_34_LY_WS_BOT_TYPE: "類型",
  T_34_LY_WS_BOT4: "斧頭",
  T_34_LY_WS_BOT5: "拋擲",
  T_34_LY_WS_BOT6: "自爆",
  T_34_LY_WS_BOT8: "巨盾殭屍",
  T_34_LY_WS_COL_DESC: "選擇一個顏色",
  T_34_LY_WS_DEL_DESC: "刪除列表中指定索引的對應元素",
  T_34_LY_WS_DF_PER: "防禦百分比",
  T_34_LY_WS_FORT_INTERVAL: "攻擊間隔時間(秒)",
  T_34_LY_WS_GET: "獲得",
  T_34_LY_WS_GET_DESC: "獲取列表中指定索引的對應元素",
  T_34_LY_WS_GLEN_ARR_DESC: "獲取當前列表的元素個數",
  T_34_LY_WS_GLEN_DESC: "維持此段文字的長度",
  T_34_LY_WS_GVX: "獲取 x 向量分量",
  T_34_LY_WS_GVX_DESC: "獲取向量的第一個分量",
  T_34_LY_WS_GVY: "獲取 y 向量分量",
  T_34_LY_WS_GVY_DESC: "獲取向量的第二個分量",
  T_34_LY_WS_GVZ: "獲取 z 向量分量",
  T_34_LY_WS_GVZ_DESC: "獲取向量的第三個分量",
  T_34_LY_WS_INDEX: "索引",
  T_34_LY_WS_JOIN: "連接",
  T_34_LY_WS_NEG_DESC: "獲取這個數的負值",
  T_34_LY_WS_PATH: "路徑設置器",
  T_34_LY_WS_PATH_DESC: "用於指定特殊生物的行進路徑。在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_34_LY_WS_POINT: "標記",
  T_34_LY_WS_POINT_DESC: "用於標出當前位置的位置。在特定模式下不生效（團隊突襲/團隊死鬥/派對模式）",
  T_34_LY_WS_RANGE_F: "遠的",
  T_34_LY_WS_RANGE_M: "中等",
  T_34_LY_WS_RANGE_N: "靠近",
  T_34_LY_WS_RNDF_DESC: "從區間生成隨機小數",
  T_34_LY_WS_RNDI_DESC: "從一個區間生成一個隨機整數",
  T_34_LY_WS_SET: "設定",
  T_34_LY_WS_SET_DESC: "設置列表中指定索引的對應元素",
  T_34_LY_WS_SQRT_DESC: "獲得這個數的平方根",
  T_34_LY_WS_STRC_DESC: "連接兩段文字",
  T_34_LY_WS_SVX: "設置 x 向量分量",
  T_34_LY_WS_SVX_DESC: "設置向量的第一個分量",
  T_34_LY_WS_SVY: "設置 y 向量分量",
  T_34_LY_WS_SVY_DESC: "設置向量的第二個分量",
  T_34_LY_WS_SVZ: "設置 z 向量分量",
  T_34_LY_WS_SVZ_DESC: "設置向量的第三個分量",
  T_34_LY_WS_VADD: "向量加法",
  T_34_LY_WS_VADD_DESC: "兩個向量相加",
  T_34_LY_WS_VAL_DESC: "根據場景輸入整數或小數",
  T_34_LY_WS_VANG_DESC: "計算兩個向量之間的角度",
  T_34_LY_WS_VCP: "向量叉乘",
  T_34_LY_WS_VCP_DESC: "計算兩個向量的叉積",
  T_34_LY_WS_VDIS_DESC: "計算兩個向量之間的距離",
  T_34_LY_WS_VDP: "點積",
  T_34_LY_WS_VDP_DESC: "計算兩個向量的數量積",
  T_34_LY_WS_VFX1: "球型",
  T_34_LY_WS_VFX2: "圓柱形",
  T_34_LY_WS_VFX3: "圓環",
  T_34_LY_WS_VFX4: "爆炸",
  T_34_LY_WS_VFX5: "像素",
  T_34_LY_WS_VFX6: "火花",
  T_34_LY_WS_VMOD_DESC: "計算向量的大小",
  T_34_LY_WS_VMUL: "向量乘法",
  T_34_LY_WS_VMUL_DESC: "將兩個向量相乘",
  T_34_LY_WS_VNOR_DESC: "規範化一個向量",
  T_34_LY_WS_VSUB: "向量減法",
  T_34_LY_WS_VSUB_DESC: "兩個向量相減",
  T_34_M_WS_ANGLE: "旋轉角度",
  T_34_M_WS_ARRAY: "列表",
  T_34_M_WS_ATT: "屬性",
  T_34_M_WS_BOOL: "布林值",
  T_34_M_WS_COLORARRAY: "顏色數組",
  T_34_M_WS_COLOUR: "顏色",
  T_34_M_WS_CONFRONBANNER: "戰鬥背景",
  T_34_M_WS_COORDINATE: "座標",
  T_34_M_WS_CUSTOMINF: "自定義介面",
  T_34_M_WS_CUSTOMMODEDESC: `可完全自訂的模式，沒有預設玩法，可以依照自己的規則創建並遊玩。
對於初學者地圖創作者來說會有些挑戰。`,
  T_34_M_WS_DAMAGETYPE: "傷害類型",
  T_34_M_WS_DAMAGETYPEDESC: "系統當前設置的傷害類型",
  T_34_M_WS_DESCTEXT: "形容文字",
  T_34_M_WS_DURACTION: "持續時間",
  T_34_M_WS_ECAMODE: "編輯模式",
  T_34_M_WS_ENDPHASEDESC: "立即結束當前階段，進入下一階段",
  T_34_M_WS_ENTITY: "實體",
  T_34_M_WS_FLOAT: "小數",
  T_34_M_WS_GAME: "遊戲",
  T_34_M_WS_GAMERESULTS: "回合結果",
  T_34_M_WS_GETCONTROL2: "從玩家介面獲取控制實體，編輯實體的屬性 (包括設計、顏色、內容等)",
  T_34_M_WS_HEIGHT: "高度",
  T_34_M_WS_HUDBUTTONWIDGET: "按鈕控件",
  T_34_M_WS_HUDEMPTYWIDGET: "空節點",
  T_34_M_WS_HUDIMAGEWIDGET: "圖像控件",
  T_34_M_WS_HUDINPUTWIDGET: "文字框控件",
  T_34_M_WS_HUDLABELWIDGET: "文字控件",
  T_34_M_WS_ICON: "圖標",
  T_34_M_WS_ICON_AIM: "準星",
  T_34_M_WS_ICON_ARROW: "弓箭",
  T_34_M_WS_ICON_BLAST: "爆破",
  T_34_M_WS_ICON_CIRCULAR: "圓圈",
  T_34_M_WS_ICON_CLOTH: "手掌",
  T_34_M_WS_ICON_COLLIMATION: "十字準線",
  T_34_M_WS_ICON_CORPSE: "殭屍",
  T_34_M_WS_ICON_CROSS: "十字",
  T_34_M_WS_ICON_DAY: "太陽",
  T_34_M_WS_ICON_DEFENSE: "護盾",
  T_34_M_WS_ICON_DIALOGUE: "對話",
  T_34_M_WS_ICON_DIAMONDS: "鑽石",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "驚嘆號",
  T_34_M_WS_ICON_FLAG: "背景",
  T_34_M_WS_ICON_FOLDER: "資料夾",
  T_34_M_WS_ICON_GLASSES: "眼睛",
  T_34_M_WS_ICON_GUN: "槍",
  T_34_M_WS_ICON_HEART: "愛心",
  T_34_M_WS_ICON_HEXAGON: "六邊形",
  T_34_M_WS_ICON_HOURGLASS: "沙漏",
  T_34_M_WS_ICON_HOUSE: "房子",
  T_34_M_WS_ICON_KEY: "鑰匙",
  T_34_M_WS_ICON_LIGHTNING: "閃電",
  T_34_M_WS_ICON_LOCK: "鎖定",
  T_34_M_WS_ICON_LOOP: "循環",
  T_34_M_WS_ICON_MAGNIFIER: "放大鏡",
  T_34_M_WS_ICON_MONEY: "錢",
  T_34_M_WS_ICON_MONTH: "月",
  T_34_M_WS_ICON_OPENFOLDER: "打開資料夾",
  T_34_M_WS_ICON_PLUS: "增加",
  T_34_M_WS_ICON_QUADRI: "四方形",
  T_34_M_WS_ICON_QUESTIONMARK: "問號",
  T_34_M_WS_ICON_RECYCLING: "回收",
  T_34_M_WS_ICON_REFRESH: "刷新",
  T_34_M_WS_ICON_REST: "休息",
  T_34_M_WS_ICON_RETURN: "返回",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "右梯形",
  T_34_M_WS_ICON_SCISSORS: "剪刀",
  T_34_M_WS_ICON_SETUP: "設定",
  T_34_M_WS_ICON_SIGN: "標記",
  T_34_M_WS_ICON_SIGNOUT: "出口",
  T_34_M_WS_ICON_SQUARE: "正方形",
  T_34_M_WS_ICON_STAR: "星星",
  T_34_M_WS_ICON_STONE: "石頭",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "游泳圈",
  T_34_M_WS_ICON_TAGGING: "紀念章",
  T_34_M_WS_ICON_THESWORD: "劍",
  T_34_M_WS_ICON_TRAPEZOID: "梯形",
  T_34_M_WS_ICON_TRASHCAN: "垃圾桶",
  T_34_M_WS_ICON_TRIANGLE: "三角形",
  T_34_M_WS_ICON_TROPHY: "戰利品",
  T_34_M_WS_ICON_UP: "讚",
  T_34_M_WS_ICON_WRONG: "錯誤",
  T_34_M_WS_ICON_YES: "正確",
  T_34_M_WS_ICONNAME: "圖標名稱",
  T_34_M_WS_INT: "整數",
  T_34_M_WS_KILLZONE: "爆炸區",
  T_34_M_WS_LEFTCOLOR: "左側顏色",
  T_34_M_WS_LEFTTEAMINDEX: "左隊索引",
  T_34_M_WS_LEFTTEAMSCORE: "左隊分數",
  T_34_M_WS_LOCSWITCH: "本地化開關",
  T_34_M_WS_MAX: "最大",
  T_34_M_WS_MIN: "最小值",
  T_34_M_WS_NUMBER: "數字",
  T_34_M_WS_OBJECT: "實體",
  T_34_M_WS_OPEN: "開啟",
  T_34_M_WS_OPENSATUS: "開啟狀態",
  T_34_M_WS_PICTURE: "圖形",
  T_34_M_WS_RANKARRAY: "位階陣列",
  T_34_M_WS_RESULTS: "結果",
  T_34_M_WS_RIGHTCOLOR: "右隊顏色",
  T_34_M_WS_RIGHTTEAMINDEX: "右隊索引",
  T_34_M_WS_RIGHTTEAMSCORE: "右隊分數",
  T_34_M_WS_ROUNDBANNER: "回合橫幅",
  T_34_M_WS_ROUNDDESC: "回合說明",
  T_34_M_WS_ROUNDHUD: "回合序",
  T_34_M_WS_ROUNDPARAMS: "整數數組",
  T_34_M_WS_SAME_NAME: "名字重複，請嘗試一個新的。",
  T_34_M_WS_SCOREARRAY: "分數數組",
  T_34_M_WS_SCORINGTYPE: "分數類型",
  T_34_M_WS_SCORINGTYPEDECS: "玩家可以獲得的分數類型。支持分數自定義。",
  T_34_M_WS_SCUFFLESCORING: "多隊伍得分",
  T_34_M_WS_SETATTRIBUTES: "屬性設置",
  T_34_M_WS_SHUT: "外",
  T_34_M_WS_SOUND: "音效",
  T_34_M_WS_SOUNDCLICK: "點擊",
  T_34_M_WS_SOUNDDD: "倒數聲",
  T_34_M_WS_SOUNDFEMALEA: "受傷(女)",
  T_34_M_WS_SOUNDM: "槍聲",
  T_34_M_WS_SOUNDMALEA: "受傷(男)",
  T_34_M_WS_SOUNDUAV: "爆炸",
  T_34_M_WS_ST_ASSISTCOUNT: "助攻數",
  T_34_M_WS_ST_CHECKPROGRESS: "檢查點進度",
  T_34_M_WS_ST_DAMAGESUM: "傷害",
  T_34_M_WS_ST_FINISHCOUNT: "已達成目標數",
  T_34_M_WS_ST_FINISHORDER: "達成目標順序",
  T_34_M_WS_ST_FINISHTIME: "目標達成時間",
  T_34_M_WS_ST_KILLCOUNT: "擊殺數",
  T_34_M_WS_ST_MAINSCORE: "目標分數",
  T_34_M_WS_ST_RANKSCORE: "排名得分",
  T_34_M_WS_ST_SURVIVALDURACTION: "生存時間",
  T_34_M_WS_ST_UNKOWN: "未知",
  T_34_M_WS_STARTBANNER: "開局橫幅",
  T_34_M_WS_STARTTIME: "開始時間",
  T_34_M_WS_STRING: "文字",
  T_34_M_WS_STUDIO: "編輯器",
  T_34_M_WS_TEAMARRAY: "團隊數組",
  T_34_M_WS_TEXTCONTENT: "內容",
  T_34_M_WS_THEMECOLOR: "主題顏色",
  T_34_M_WS_TIME: "倒數HUD",
  T_34_M_WS_TITLETEXT: "標題文字",
  T_34_M_WS_TYPE: "類型",
  T_34_M_WS_UODATETYPE: "更新類型",
  T_34_M_WS_VARNAME: "變量名",
  T_34_M_WS_VECTOR: "向量",
  T_34_M_WS_VFX: "視覺特效",
  T_34_M_WS_WIDTH: "寬度",
  T_34_MF_CHARACTER_TRACKER_N: "赫馬",
  T_34_PD_FlagBattle_HYPE_1: "火焰",
  T_34_SP_WS_BLOCK1_NAME: "切換階段",
  T_34_SP_WS_BLOCK1_NAMEDESC: "切換比賽的階段以進入所需的階段(或回合)。回合也有階段索引，是一種特殊類型的階段。",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "目標階段的索引",
  T_34_SP_WS_BLOCK10_NAME: "創建視覺效果",
  T_34_SP_WS_BLOCK10_NAMEDESC: "使用指定的視覺效果創建圖標。通過調整視覺效果實體的屬性，可以設置更多的視覺效果屬性。",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "視覺效果",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "可應用的視覺效果種類",
  T_34_SP_WS_BLOCK12_NAME: "刪除視覺效果",
  T_34_SP_WS_BLOCK12_NAMEDESC: "刪除指定的視覺效果",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "視覺效果實體",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "要刪除的視覺效果實體",
  T_34_SP_WS_BLOCK13_NAMEDESC: "命令客戶端播放視覺效果",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "玩家清單",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "會收到訊息的玩家",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "資源路徑",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "系統資源路徑在:path。自定義資源路徑已出：路徑。默認為空。",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA 通道，每個通道取一個 0 到 255 之間的值，保存在 int32 中。默認顏色為白色 (255,255,255,255)。",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "飛漲",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "縮放比例；默認為 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "以全局坐標表示的顯示位置。Vector3(0) 默認情況下。",
  T_34_SP_WS_BLOCK14_NAME: "播放音效",
  T_34_SP_WS_BLOCK14_NAMEDESC: "命令客戶端播放音效",
  T_34_SP_WS_BLOCK15_NAME: "輸出日誌",
  T_34_SP_WS_BLOCK15_NAMEDESC: "將內容輸出到日誌界面",
  T_34_SP_WS_BLOCK2_NAMEDESC: "打開對安全區外玩家造成的傷害",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "安全區中心點",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "半徑",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "安全區半徑",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "安全區開始縮小的倒計時",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "安全區域縮小的持續時間",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "在安全區之外受到的傷害量",
  T_34_SP_WS_BLOCK3_NAMEDESC: "關閉危險區時，安全區外的玩家不會受到傷害",
  T_34_SP_WS_BLOCK4_NAMEDESC: "用於將後續動作延遲指定時間",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "等待持續時間，以毫秒為單位",
  T_34_SP_WS_BLOCK5_NAMEDESC: "用於將後續動作推遲到下一幀",
  T_34_SP_WS_BLOCK6_NAME: "創建自定義HUD",
  T_34_SP_WS_BLOCK6_NAMEDESC: "創建指定的自定義HUD",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "用於創建介面實體的名稱。它對應的局部變量是正在創建的介面的實體。",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "玩家",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "特定玩家的實體。僅對所述玩家可見。",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "唯一的介面索引",
  T_34_SP_WS_BLOCK7_NAMEDESC: "創建一個默認介面，僅對指定玩家可見",
  T_34_SP_WS_BLOCK8_NAMEDESC: "刪除後，客戶端將看不到默認介面(隱藏或丟棄)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD實體",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "要刪除的HUD實體",
  T_34_SP_WS_BLOCK9_NAMEDESC: "刪除後，自定義HUD將不會在客戶端上顯示(隱藏或丟棄)",
  T_34_T_WS_BLOCK1_NAMEDESC: "比賽開始時觸發事件",
  T_34_T_WS_BLOCK10_NAMEDESC: "當玩家被淘汰時觸發事件",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "觸發事件的淘汰玩家",
  T_34_T_WS_BLOCK13_NAMEDESC: "當玩家協助另一名玩家時觸發事件",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "被淘汰的玩家",
  T_34_T_WS_BLOCK14_NAMEDESC: "當玩家受傷時觸發",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "受到傷害的玩家",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "造成的傷害類型",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "造成的傷害量",
  T_34_T_WS_BLOCK15_NAMEDESC: "當一名玩家淘汰另一名玩家時觸發事件",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "被淘汰的玩家",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "導致消除的損壞類型",
  T_34_T_WS_BLOCK16_NAMEDESC: "玩家加入比賽時觸發事件",
  T_34_T_WS_BLOCK17_NAMEDESC: "玩家復活時觸發事件",
  T_34_T_WS_BLOCK18_NAMEDESC: "團隊被移除時觸發事件",
  T_34_T_WS_BLOCK19_NAMEDESC: "添加團隊時觸發事件",
  T_34_T_WS_BLOCK2_NAMEDESC: "比賽結束時觸發事件",
  T_34_T_WS_BLOCK20_NAMEDESC: "當隊伍團滅時觸發",
  T_34_T_WS_BLOCK3_NAMEDESC: "每輪開始時觸發事件",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "輪數從0開始",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "回合索引",
  T_34_T_WS_BLOCK4_NAMEDESC: "每輪結束時觸發事件",
  T_34_T_WS_BLOCK5_NAMEDESC: "階段開始時觸發事件",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "階段號從0開始",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "階段實體",
  T_34_T_WS_BLOCK6_NAMEDESC: "階段結束時觸發事件",
  T_34_T_WS_BLOCK7_NAMEDESC: "當玩家退出比賽時觸發事件",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "觸發事件的玩家",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "觸發玩家",
  T_34_T_WS_BLOCK8_NAMEDESC: "當玩家的分數發生變化時觸發事件",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "更改分數的類型",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "改變後的分數值",
  T_34_T_WS_BLOCK9_NAMEDESC: "當團隊的分數發生變化時觸發事件",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "觸發事件的團隊",
  T_34_WT_WS_BORNENTITY_PARAM1: "出生點",
  T_34_WT_WS_BORNENTITY_PARAM2: "可用坐標",
  T_34_WT_WS_BORNENTITY_PARAM3: "設置為默認出生點",
  T_34_WT_WS_BORNENTITY_PARAM4: "動態柵欄",
  T_34_WT_WS_BORNENTITY_PARAM5: "正在使用與否",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "檢查點HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "開放狀態",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "狀態觸發器",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "擊殺觸發器與否",
  T_34_WT_WS_ENTITY_PARAM1: "遊戲實體",
  T_34_WT_WS_ENTITY_PARAM10: "隊伍數",
  T_34_WT_WS_ENTITY_PARAM11: "隊伍成員數",
  T_34_WT_WS_ENTITY_PARAM12: "每回合重置裝備",
  T_34_WT_WS_ENTITY_PARAM13: "啟用安全區外傷害",
  T_34_WT_WS_ENTITY_PARAM14: "區域大小",
  T_34_WT_WS_ENTITY_PARAM15: "區域縮小開始時間",
  T_34_WT_WS_ENTITY_PARAM16: "區域縮小持續時間",
  T_34_WT_WS_ENTITY_PARAM17: "安全區外傷害",
  T_34_WT_WS_ENTITY_PARAM18: "目標分數",
  T_34_WT_WS_ENTITY_PARAM19: "淘汰分數",
  T_34_WT_WS_ENTITY_PARAM2: "無效狀態",
  T_34_WT_WS_ENTITY_PARAM20: "重生類型",
  T_34_WT_WS_ENTITY_PARAM21: "回合得分排名標準(玩家)",
  T_34_WT_WS_ENTITY_PARAM22: "標準重要性(玩家)",
  T_34_WT_WS_ENTITY_PARAM23: "回合得分排名標準(團隊)",
  T_34_WT_WS_ENTITY_PARAM24: "標準重要性(團隊)",
  T_34_WT_WS_ENTITY_PARAM25: "得分排名標準(MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "標準重要性(MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "回合排名得分",
  T_34_WT_WS_ENTITY_PARAM28: "在結果頁面上顯示標準",
  T_34_WT_WS_ENTITY_PARAM29: "遊戲總回合數",
  T_34_WT_WS_ENTITY_PARAM3: "遊戲時間",
  T_34_WT_WS_ENTITY_PARAM4: "當前回合索引",
  T_34_WT_WS_ENTITY_PARAM5: "當前階段索引",
  T_34_WT_WS_ENTITY_PARAM6: "模式模板 ID",
  T_34_WT_WS_ENTITY_PARAM7: "啟用玩家復活",
  T_34_WT_WS_ENTITY_PARAM8: "啟用機器人重生",
  T_34_WT_WS_ENTITY_PARAM9: "重生時間",
  T_34_WT_WS_ENTITY1_NAME: "當前實體",
  T_34_WT_WS_ENTITY1_NAMEDESC: "返回當前實體",
  T_34_WT_WS_ENTITY10_NAME: "移除圖標",
  T_34_WT_WS_ENTITY10_NAMEDESC: "移除指定圖標",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "選擇您要刪除的圖標",
  T_34_WT_WS_ENTITY11_NAME: "删除文本",
  T_34_WT_WS_ENTITY11_NAMEDESC: "移除文字實體",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "選擇你希望移除的文字",
  T_34_WT_WS_ENTITY12_NAMEDESC: "為指定玩家添加物品",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "將收到物品的玩家",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "要獲得的具體物品ID",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "給予物品的數量",
  T_34_WT_WS_ENTITY12_PARAM3: "數量",
  T_34_WT_WS_ENTITY13_PARAM1: "類型",
  T_34_WT_WS_ENTITY13_PARAM2: "地點",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "生成對象的位置坐標",
  T_34_WT_WS_ENTITY13_PARAM4: "物品",
  T_34_WT_WS_ENTITY14_NAME: "移除對象",
  T_34_WT_WS_ENTITY14_NAMEDESC: "移除指定對象",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "刪除物品",
  T_34_WT_WS_ENTITY15_NAMEDESC: "獲取所有玩家實體",
  T_34_WT_WS_ENTITY16_NAMEDESC: "獲取所有隊伍實體",
  T_34_WT_WS_ENTITY17_NAMEDESC: "恢復指定玩家的HP值。如果恢復量超過最大值，則只會恢復到最大值。",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "HP變動正在設置的玩家",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "指定恢復的HP量",
  T_34_WT_WS_ENTITY18_NAME: "獲取隨機出生坐標",
  T_34_WT_WS_ENTITY18_NAMEDESC: "使指定玩家在一個隨機出生點出生，並返回該出生座標",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "將從該位置隨機生成的玩家",
  T_34_WT_WS_ENTITY18_RETURNDESC: "玩家將被分配到的位置坐標",
  T_34_WT_WS_ENTITY19_NAME: "獲得玩家分數",
  T_34_WT_WS_ENTITY19_NAMEDESC: "獲得指定玩家的某類積分分數",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "獲取該玩家的得分實體",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "獲取分數類型",
  T_34_WT_WS_ENTITY19_RETURNDESC: "要獲得的具體分數值",
  T_34_WT_WS_ENTITY2_NAME: "設置屬性",
  T_34_WT_WS_ENTITY2_NAMEDESC: "設置實體的屬性，其中屬性類型已經選擇",
  T_34_WT_WS_ENTITY2_PARAM1: "實體",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "某遊戲實體",
  T_34_WT_WS_ENTITY2_PARAM3: "屬性",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "該遊戲實體的某個屬性",
  T_34_WT_WS_ENTITY2_PARAM4: "值",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "屬於該遊戲實體的某個屬性的特定值。確保屬性類型與選定的屬性類型一致，並與相關圖元中設置的類型相匹配",
  T_34_WT_WS_ENTITY20_NAMEDESC: "設置指定玩家的一定分數",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "設置此玩家的得分實體",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "設置分數類型",
  T_34_WT_WS_ENTITY20_PARAM3: "分數",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "正在設置的具體分數值",
  T_34_WT_WS_ENTITY21_NAME: "獲得隊伍總分數",
  T_34_WT_WS_ENTITY21_NAMEDESC: "獲取指定隊伍的某類積分總分數",
  T_34_WT_WS_ENTITY21_PARAM1: "團隊",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "獲取該隊的得分實體",
  T_34_WT_WS_ENTITY22_NAME: "設定團隊當前回合分數",
  T_34_WT_WS_ENTITY22_NAMEDESC: "設定指定隊伍當前回合某類分數",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "設置此團隊的分數",
  T_34_WT_WS_ENTITY23_NAME: "獲得玩家回合分數",
  T_34_WT_WS_ENTITY23_NAMEDESC: "為指定玩家獲得某一回合的特定分數",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "獲取該玩家的回合分數",
  T_34_WT_WS_ENTITY23_PARAM2: "回合索引",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "獲得本輪得分",
  T_34_WT_WS_ENTITY24_NAME: "獲得團隊回合得分",
  T_34_WT_WS_ENTITY24_NAMEDESC: "為指定隊伍獲得某一回合的特定分數",
  T_34_WT_WS_ENTITY25_NAME: "傳送",
  T_34_WT_WS_ENTITY25_NAMEDESC: "將指定玩家傳送到指定位置",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "將被傳送的玩家",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "玩家將被傳送到的坐標",
  T_34_WT_WS_ENTITY26_NAMEDESC: "使指定玩家對指定目標造成傷害。如果沒有攻擊玩家，指定的目標將受到系統的傷害。",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "將受到損害的實體",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "造成的傷害量",
  T_34_WT_WS_ENTITY28_NAMEDESC: "復活指定玩家",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "可以復活的玩家實體",
  T_34_WT_WS_ENTITY3_NAMEDESC: "設置圖元的類型",
  T_34_WT_WS_ENTITY3_PARAM1: "作為",
  T_34_WT_WS_ENTITY4_NAME: "獲得屬性",
  T_34_WT_WS_ENTITY4_NAMEDESC: "獲取實體的特定屬性",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "獲取屬性值的具體遊戲實體",
  T_34_WT_WS_ENTITY4_RETURNDESC: "獲取到的具體屬性值",
  T_34_WT_WS_ENTITY5_NAMEDESC: "為所有玩家設置移動能力",
  T_34_WT_WS_ENTITY6_NAME: "創建圖標",
  T_34_WT_WS_ENTITY6_PARAM1: "圖標",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "介面上顯示的圖像。從各種設計中選擇。",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "選擇應應用設計的圖標",
  T_34_WT_WS_ENTITY7_NAMEDESC: "為指定玩家創建介面圖標",
  T_34_WT_WS_ENTITY7_PARAM1: "玩家",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "為選定的玩家創建介面圖標",
  T_34_WT_WS_ENTITY8_NAME: "創建文本",
  T_34_WT_WS_ENTITY8_PARAM1: "文字",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "因為此指令而創建的文字內容",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "當前被創建的文字實體",
  T_34_WT_WS_ENTITY9_NAMEDESC: "為指定玩家添加一行介面文本，如果沒有玩家被指定，將為所有玩家增添介面文本。",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "為選定的玩家添加介面文本",
  T_34_WT_WS_ICONENTITY_PARAM1: "圖標實體",
  T_34_WT_WS_ICONENTITY_PARAM2: "設計",
  T_34_WT_WS_ICONENTITY_PARAM3: "顏色",
  T_34_WT_WS_ICONENTITY_PARAM4: "等比縮放",
  T_34_WT_WS_ICONENTITY_PARAM5: "顯示位置",
  T_34_WT_WS_ICONENTITY_PARAM6: "跟隨目標",
  T_34_WT_WS_ICONENTITY_PARAM7: "穿牆可見",
  T_34_WT_WS_ICONENTITY_PARAM8: "一直在螢幕上",
  T_34_WT_WS_ONETEAM_TAG: "單隊合作",
  T_34_WT_WS_PHASEENTITY_PARAM1: "階段實體",
  T_34_WT_WS_PHASEENTITY_PARAM2: "階段索引",
  T_34_WT_WS_PHASEENTITY_PARAM3: "開始時間",
  T_34_WT_WS_PHASEENTITY_PARAM4: "結束時間",
  T_34_WT_WS_PHASEENTITY_PARAM5: "持續時間",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "玩家實體",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "復活點",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "武器傷害 %",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "角色3D模型",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "身份",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "當前 HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "HP最大值",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "玩家狀態",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "生存時間",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "無敵的",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "隊伍",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "目標檢查點 ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "出生點",
  T_34_WT_WS_PROCIRCLE_ICON: "圖標",
  T_34_WT_WS_PVEDESC1: "如果在時間結束前至少一名玩家到達終點線，則團隊獲勝。如果所有玩家同時被淘汰，則遊戲結束。",
  T_34_WT_WS_PVEDESC2: "在指定時間內生存即可獲勝。如果所有玩家同時被淘汰，則遊戲結束。",
  T_34_WT_WS_PVENAME1: "闖關生存",
  T_34_WT_WS_PVENAME2: "防守生存",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "當前檢查點 ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "跑酷模式檢查站編號",
  T_34_WT_WS_SKILLSET14: "武者之怒 (健太)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "隊伍實體",
  T_34_WT_WS_TEAMENTITY_PARAM2: "是否團滅",
  T_34_WT_WS_TEAMENTITY_PARAM3: "所有成員",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "常規觸發",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "外貌類型",
  T_34_WT_WS_TXTENTITY_PARAM1: "文字實體",
  T_34_WT_WS_TXTENTITY_PARAM2: "內容",
  T_34_WT_WS_VFXENTITY_PARAM1: "視覺效果實體",
  T_34_WZ_WS_LOGIC10_NAME: "繼續下一個",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "跳過當前循環迭代並執行下一個",
  T_34_WZ_WS_LOGIC11_NAME: "返回",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "終止當前執行並返回主程序。返回時允許發回數據。",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "返回值",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "要發送回主程式的數據",
  T_34_WZ_WS_LOGIC2_NAME: "比較",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "使用指定的運算符比較 2 個值",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "左值",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "用於比較的左側值",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "比較功能",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "選擇您希望如何比較值。支持的運算符有：>, ≥, ==, ≠, ≤, <, AND(僅限布林值), OR(僅限布林值)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "右值",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "用於比較的右值",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "比較結果",
  T_34_WZ_WS_LOGIC3_NAME: "非",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "邏輯取非",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "你希望在其上使用 NOT 運算符的值",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT 運算的結果",
  T_34_WZ_WS_LOGIC4_NAME: "檢查空",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "檢查實體是否為空",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "實體",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "檢查空虛的實體",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "實體是否為空",
  T_34_WZ_WS_LOGIC5_NAME: "if",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "根據是否滿足條件執行。子流程與後續的邏輯分支相同。",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "價值",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "條件個數和子流程（邏輯分支）個數必須相同",
  T_34_WZ_WS_LOGIC6_NAME: "逐個循環",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "從 x 到 y 以 z 為步長循環。子流程就是循環本身。",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "可用於提取局部變量的循環索引值的循環索引的名稱",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "起始值",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "循環開始的值",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "最終值",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "循環結束的值",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "步驟",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "每個循環的步長。當起始值小於終止值時，步長應大於 0。當起始值大於結束值時，步距應小於 0。",
  T_34_WZ_WS_LOGIC7_NAME: "所有元素循環",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "啟用數據容器的遍歷以提取其中的每個子元素。子流程就是循環本身。",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "元素",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "遍歷該名稱將提取局部變量的子元素的值",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "數據容器",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "要遍歷的數據容器，目前支持列表類型",
  T_34_WZ_WS_LOGIC8_NAME: "條件循環",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "實現條件是否為真持續執行的循環，直到條件為假結束循環",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "情形",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "如果條件為真則重複循環，直到條件為假，則停止",
  T_34_WZ_WS_LOGIC9_NAME: "中斷循環",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "停止當前循環進程並跳出循環",
  T_34_Y_B_DINOSAURS: "恐龍幻想 (下裝)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "靈能之翼-黑白(下裝)",
  T_34_YS_F_B_PANDACATTLE: "小牛哞哞(下裝)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "激流湧動(下裝)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "激流湧動(頭飾)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "激流湧動(臉彩)",
  T_34_YS_F_S_PANDACATTLE: "小牛哞哞(鞋子)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "激流湧動(鞋子)",
  T_34_YS_F_T_PANDACATTLE: "小牛哞哞(上裝)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "激流湧動(上裝)",
  T_34_YS_M_B_ANGEL_BW: "天人-黑白(下裝)",
  T_34_YS_M_B_PANDACATTLE: "貓熊睡衣(下裝)",
  T_34_YS_M_H_PANDACATTLE: "貓熊睡衣(頭飾)",
  T_34_YS_M_S_PANDACATTLE: "貓熊睡衣(鞋子)",
  T_34_YS_M_T_PANDACATTLE: "貓熊睡衣(上裝)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "芭忒蘿",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "擊倒敵人立即獲得 [FFB300]{0} EP[-]。",
  T_35_DY_PET_OWL_N: "度咕",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "寵物外觀：宇宙莫尼",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "寵物外觀：勝利絨恩",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "寵物外觀：勝利獵隼",
  T_35_DY_PETSKIN_OWL_FIRE_N: "寵物外觀：烈火裡度咕",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "寵物外觀：星空裡度咕",
  T_35_DY_PETSKIN_OWL_STORM_N: "寵物外觀：雪地裡度咕",
  T_35_JL_KNOCKEDDOWN: "被擊倒",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "在 [FFB300]{1} 秒[-]內，當你成功攻擊凝膠護盾會標記周圍 [FFB300]{3} 公尺[-]內的敵人，並穿透凝膠護盾對敵人造成傷害(造成的傷害較低)。最多對 [FFB300]{0} 個[-]凝膠護盾有效。冷卻時間：[FFB300]{2} 秒[-]。",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "護盾穿透",
  T_35_KY_INFECTION_MAPNAME: "荒蕪之地",
  T_35_M_WS_BUTTONCLICKDESC: "當對應按鈕被點擊時觸發此事件。觸發玩家可透過參數獲取。",
  T_35_M_WS_GETTEAMMATEPOS: "獲得附近隊友位置",
  T_35_M_WS_ROUND2: "當前波次",
  T_35_PD_Infection_HUMANSELECT: "選擇武器",
  T_35_PD_INFECTION_MODENAME: "啟示錄",
  T_35_QX_WS_ICONTYPE_ITEM: "物件",
  T_35_QX_WS_ICONTYPE_NATURE: "自然",
  T_35_QX_WS_ICONTYPE_SHAPE: "形狀",
  T_35_QX_WS_ICONTYPE_SYMBOL: "符號",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "武器聲",
  T_35_R_EMOTE_TAG_MUSIC_N: "音樂",
  T_35_RW_SKILL_DESC_Singers: "自身及周圍 [FFB300]{0} 公尺[-]內的隊友可以使用 EP 阻擋 [FFB300]{1}%[-] 傷害，其他隊友因抵擋傷害而消耗的 EP 會補充給你。",
  T_35_RW_SKILL_NAME_Singers: "和平連結",
  T_35_SP_WS_COMMENTKEY_01: "難度適中",
  T_35_SP_WS_COMMENTKEY_02: "玩法新穎",
  T_35_SP_WS_COMMENTKEY_03: "玩法有趣",
  T_35_SP_WS_COMMENTKEY_04: "可重複玩",
  T_35_SP_WS_COMMENTKEY_05: "引人入勝的故事情節",
  T_35_SP_WS_COMMENTKEY_06: "平衡良好",
  T_35_SP_WS_COMMENTKEY_07: "愉快的體驗",
  T_35_SP_WS_COMMENTKEY_08: "自由度高",
  T_35_SP_WS_COMMENTKEY_09: "設計美觀",
  T_35_SP_WS_COMMENTKEY_10: "太困難",
  T_35_SP_WS_COMMENTKEY_11: "太簡單",
  T_35_SP_WS_COMMENTKEY_12: "遊戲內容無聊",
  T_35_SP_WS_COMMENTKEY_13: "太冗長",
  T_35_SP_WS_COMMENTKEY_14: "平衡較差",
  T_35_SP_WS_COMMENTKEY_15: "糟糕的體驗",
  T_35_SP_WS_IMAGE03: "質地",
  T_35_SP_WS_IMAGE04: "楨",
  T_35_SY_CHARGESHOT_TEARS_N: "蓄力剋星-光耀火岩",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "手榴彈-恐怖紫晶",
  T_35_SY_GRENADE_PIRATES_N: "手榴彈-閃亮金光",
  T_35_SY_GRENADE_RIDERS_N: "手榴彈-陰森騎手",
  T_35_SY_M24_KUN_N: "M24-松風水月",
  T_35_SY_SCAR_PARKOUR_N: "SCAR-自由跑者",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "吉普車-單色拼圖",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "享受慶典吧！",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "機車-紫晶陵墓",
  T_35_WT_WS_PREFAB_MENUBAR_1: "結構及裝飾",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "結構物件",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "其他",
  T_35_WT_WS_PREFAB_MENUBAR_2: "建築物",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "大型房屋",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "中型房屋",
  T_35_WT_WS_PREFAB_MENUBAR_3: "功能物件",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "模式必須",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "音樂物件",
  T_35_WT_WS_PVEMODE_TAG: "生存模式",
  T_35_WZY_WS_BECRE_NAMEDESC: "該實體被創建時觸發",
  T_35_WZY_WS_BEKILL_NAMEDESC: "該實體被擊殺時觸發。可以通過[觸發實體]判別兇手，也可以通過[傷害類型]確認擊殺方式。",
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "觸發事件的實體",
  T_35_WZY_WS_CREPROP_NAMEDESC: "在指定位置創建一種物品或一組物品，創建一種類型的物品時，總量是該物品的數量。創建一組物品時，總量為物品列表對應的總量列表。創建的物品將隨地圖的單位而定。",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "將要創建的物品組成的列表。它也可以由一個物品組成。",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "對應物品列表的數量列表。它可能只包含一種道具類型的數量。",
  T_35_WZY_WS_DAMTYPE_CAR: "載具",
  T_35_WZY_WS_DAMTYPE_FALL: "墜落傷害",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "槍",
  T_35_WZY_WS_DAMTYPE_GRENADE: "手榴彈",
  T_35_WZY_WS_DAMTYPE_MELEE: "近戰武器",
  T_35_WZY_WS_DAMTYPE_ZONE: "毒圈",
  T_35_WZY_WS_DELPROP_NAMEDESC: "刪除指定玩家指定數量的物品",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "進入觸發器",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: "[觸發實體]進入觸發器時觸發",
  T_35_WZY_WS_ENTITYPLAYER_DESC: "玩家獲得實體。當與玩家連接時，實體的信息只會給所述玩家更新。當沒有玩家鏈接時，所有玩家都會收到實體信息。",
  T_35_WZY_WS_FIGHTENTITY_NAME: "戰鬥實體",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "獲得指定類型的所有物件，返回結果是一個列表",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "獲得的物件類型",
  T_35_WZY_WS_HUDWIDGET_NAME: "介面控制",
  T_35_WZY_WS_HURT_NAMEDESC: "該實體受到傷害時觸發，可以通過[觸發實體]確認傷害來源",
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "物品種類",
  T_35_WZY_WS_LEVELOBJECT_NAME: "舞台物件",
  T_35_WZY_WS_OBKILL_NAMEDESC: "該實體造成擊殺時觸發，可以通過[死亡實體]確認擊殺對象類型",
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "被擊殺的實體",
  T_35_WZY_WS_ONHURT_NAMEDESC: "當實體造成傷害時觸發",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "正在造成傷害的實體",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "目標實體",
  T_35_WZY_WS_PREFABID_NAME: "模板ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "當前EP",
  T_35_WZY_WS_PROPERTY_JUMP: "跳躍高度",
  T_35_WZY_WS_QUITTRIGGER_NAME: "退出觸發器",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: "[觸發實體]退出觸發器時觸發",
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "從列表中移除特定元素，[列表]是元素所在的列表，[元素]是要移除的元素",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "元素值",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "要移除的元素值",
  T_35_WZY_WS_ROUNDENTITY_NAME: "回合實體",
  T_35_WZY_WS_TOWER_PARAM1: "塔和堡壘",
  T_35_WZY_WS_TOWER_PARAM2: "隊伍ID",
  T_35_WZY_WS_TOWER_PARAM3: "當前HP",
  T_35_WZY_WS_TOWER_PARAM4: "HP最大值",
  T_35_WZY_WS_TOWER_PARAM5: "傷害",
  T_35_WZY_WS_TOWER_PARAM6: "攻擊間隔",
  T_35_WZY_WS_TOWER_PARAM7: "攻擊範圍",
  T_35_WZY_WS_TOWER_PARAM8: "防禦%",
  T_35_XYL_PDM_REVENGE: "復仇成功",
  T_35_XYL_WS_BISPARTERRE: "BIS塗鴉花壇",
  T_35_XYL_WS_BISPARTERRE_DESC: "BIS主題的普通花壇",
  T_35_XYL_WS_BISWALL: "BIS塗鴉牆",
  T_35_XYL_WS_BISWALL_DESC: "可以拼接的BIS主題牆壁",
  T_35_XYL_WS_BOTDROP: "是否開啟戰利品掉落",
  T_35_XYL_WS_CUSTOMTRIGGER: "自定義觸發器",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "放置一個玩家觸碰後可以觸發自定義效果的物件，效果需要玩家在腳本中編輯設置。（僅限編輯模式）",
  T_35_XYL_WS_DOUBLEDOOR: "雙扇門",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "略微錯開的兩扇門",
  T_35_XYL_WS_RESET: "是否每回合重置",
  T_35_XYL_WS_RESETN: "不是",
  T_35_XYL_WS_RESETY: "是",
  T_35_XYL_WS_ROADBLOCK: "路障A",
  T_35_XYL_WS_ROADBLOCK_DESC: "可以阻擋通行的普通路障",
  T_35_XYL_WS_STAIRS: "樓梯",
  T_35_XYL_WS_STAIRS_DESC: "可以拼接的樓梯",
  T_35_XYL_WS_STAIRSL: "樓梯平台B",
  T_35_XYL_WS_STAIRSL_DESC: "折返的樓梯平台，可以與樓梯搭配使用",
  T_35_XYL_WS_STAIRSZ: "樓梯平台A",
  T_35_XYL_WS_STAIRSZ_DESC: "折返的樓梯平台，可以與樓梯搭配使用",
  T_35_XYL_WS_TBOOTH: "電話亭",
  T_35_XYL_WS_TBOOTH_DESC: "馬路邊常見的電話亭",
  T_35_YF_PP19_N: "野牛衝鋒槍",
  T_35_YS_A_CATEAM_HW: "老鷹頭套",
  T_35_YS_A_CUBBY: "呆熊面罩",
  T_35_YS_F_A_PANTOMIME: "失意默劇(面飾)",
  T_35_YS_F_A_RIDERS: "致命騎士(面飾)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "宇宙佳人(下裝)",
  T_35_YS_F_B_GOLDCHAIN: "嘻哈黑金(下裝)",
  T_35_YS_F_B_PANTOMIME: "失意默劇(下裝)",
  T_35_YS_F_B_RIDERS: "致命騎士(下裝)",
  T_35_YS_F_H_BEAR_HW: "蠢萌呆熊",
  T_35_YS_F_H_DIGITALUNIVERSE2: "宇宙佳人(頭飾)",
  T_35_YS_F_H_GOLDCHAIN: "嘻哈黑金(頭飾)",
  T_35_YS_F_H_PANTOMIME: "失意默劇(頭飾)",
  T_35_YS_F_H_RIDERS: "致命騎士(頭飾)",
  T_35_YS_F_HA_GOLDCHAIN: "嘻哈黑金(臉彩)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "宇宙佳人(鞋子)",
  T_35_YS_F_S_GOLDCHAIN: "嘻哈黑金(鞋子)",
  T_35_YS_F_S_PANTOMIME: "失意默劇(鞋子)",
  T_35_YS_F_S_RIDERS: "致命騎士(鞋子)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "宇宙佳人(上裝)",
  T_35_YS_F_T_GOLDCHAIN: "嘻哈黑金(上裝)",
  T_35_YS_F_T_PANTOMIME: "失意默劇(上裝)",
  T_35_YS_F_T_RIDERS: "致命騎士(上裝)",
  T_35_YS_ITEM_SUPERFAK: "超級急救包",
  T_35_YS_M_A_GOLDCHAIN: "壕氣金鏈(面飾)",
  T_35_YS_M_A_RIDERS: "生化騎士(面飾)",
  T_35_YS_M_B_GOLDCHAIN: "壕氣金鏈(下裝)",
  T_35_YS_M_B_RIDERS: "生化騎士(下裝)",
  T_35_YS_M_H_BEAR_HW: "蠢萌呆熊",
  T_35_YS_M_H_GOLDCHAIN: "壕氣金鏈(頭飾)",
  T_35_YS_M_H_RIDERS: "生化騎士(頭飾)",
  T_35_YS_M_S_GOLDCHAIN: "壕氣金鏈(鞋子)",
  T_35_YS_M_S_RIDERS: "生化騎士(鞋子)",
  T_35_YS_M_T_GOLDCHAIN: "壕氣金鏈(上裝)",
  T_35_YS_M_T_RIDERS: "生化騎士(上裝)",
  T_35_YS_T_CHAMPION: "冠軍 T-shirt",
  T_35_YS_T_PAINTING: "揪揪你 T-shirt",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "艾瑞絲",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "回合開始時獲得代幣",
  T_36_JH_WS_CESAYCLOSE: "是否禁用手動關閉",
  T_36_JH_WS_CHOOSEEDITSHOP: "選擇要修改的商店",
  T_36_JH_WS_CHOOSESHOP: "選擇商店",
  T_36_JH_WS_COINCOUNT: "貨幣數量",
  T_36_JH_WS_COINHUD: "顯示硬幣數量與否",
  T_36_JH_WS_CRAFTSHOP: "編輯商店",
  T_36_JH_WS_CREATEGOLD: "金幣產生器",
  T_36_JH_WS_CSHOPENTITY: "綁定商店實體",
  T_36_JH_WS_CSHOPHUD: "商店介面",
  T_36_JH_WS_CURRENTLIMIT: "剩餘限購",
  T_36_JH_WS_ECONOMIC: "經濟",
  T_36_JH_WS_INGAMEECONOMI: "遊戲經濟",
  T_36_JH_WS_ITEMINDEXID: "商品編號",
  T_36_JH_WS_KILLMONEY: "擊殺可獲得的代幣數量",
  T_36_JH_WS_KILLMONEYTIP: "闖關生存與防守生存模式中擊殺殭屍獲得的金幣獎勵",
  T_36_JH_WS_LISTINDEX: "商品類型列表",
  T_36_JH_WS_NULL: "空",
  T_36_JH_WS_NUMBER: "數量",
  T_36_JH_WS_OPTIONNAME: "啟示錄模式專屬",
  T_36_JH_WS_REALSHOPENTITY: "商店實體",
  T_36_JH_WS_SEEORHIDE: "顯示自動販賣機",
  T_36_JH_WS_SHOPFRONT: "商店",
  T_36_JH_WS_SHOPITEMLIST: "商品類型",
  T_36_JH_WS_SHOPOPENCON: "開放狀態",
  T_36_JH_WS_SSHOPNAME: "商店名稱",
  T_36_JH_WS_TOTALLIMIT: "限購",
  T_36_JH_WS_TRIGGERWIDE: "觸發範圍",
  T_36_JH_WS_VENDMACHINE: "自動販賣機",
  T_36_JH_WS_WINMONEY: "回合勝利獲得代幣",
  T_36_JH_WS_WORTH: "價值",
  T_36_JL_FOREGRIP_MR_N: "射手步槍握把",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "霰彈槍槍托",
  T_36_JL_STOCK_SR_N: "狙擊槍槍托",
  T_36_KK_WS_MONTSTERDES: "4人座卡車，經久耐用，可穿越崎嶇地形",
  T_36_M_WS_SETTEMPVAR: "設置臨時變量",
  T_36_M_WS_TEMPVAR: "臨時變量",
  T_36_SY_AK47_MAMBAS_N: "AK47-曼巴嘶咬",
  T_36_SY_AN94_MAMBAS_N: "AN94-曼巴嘶咬",
  T_36_SY_AR15_MAMBAS_N: "翠鳥步槍-曼巴嘶咬",
  T_36_SY_AUG_MAMBAS_N: "AUG-曼巴嘶咬",
  T_36_SY_AWM_MAMBAS_N: "AWM-曼巴嘶咬",
  T_36_SY_BLT_MAMBAS_N: "M82B-曼巴嘶咬",
  T_36_SY_CHARGESHOT_MAMBAS_N: "蓄力剋星-曼巴嘶咬",
  T_36_SY_EAGLE_MAMBAS_N: "沙漠之鷹-曼巴嘶咬",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS-曼巴嘶咬",
  T_36_SY_G18_MAMBAS_N: "G18-曼巴嘶咬",
  T_36_SY_G36_MAMBAS_N: "G36-曼巴嘶咬",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "手榴彈-靛藍慶典",
  T_36_SY_GROZA_MAMBAS_N: "GROZA-曼巴嘶咬",
  T_36_SY_HAND_CANNON_MAMBAS_N: "手銃-曼巴嘶咬",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "治療狙擊槍-曼巴嘶咬",
  T_36_SY_ICE_GUN_MAMBAS_N: "冰牆發射器-曼巴嘶咬",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k-曼巴嘶咬",
  T_36_SY_KORD_MAMBAS_N: "Kord-曼巴嘶咬",
  T_36_SY_M1014_MAMBAS_N: "M1014-曼巴嘶咬",
  T_36_SY_M14_MAMBAS_N: "M14-曼巴嘶咬",
  T_36_SY_M1873_MAMBAS_N: "M1873-曼巴嘶咬",
  T_36_SY_M1887_MAMBAS_N: "M1887-曼巴嘶咬",
  T_36_SY_M1917_MAMBAS_N: "M1917-曼巴嘶咬",
  T_36_SY_M21A5_MAMBAS_N: "瘋鳥步槍-曼巴嘶咬",
  T_36_SY_M24_MAMBAS_N: "M24-曼巴嘶咬",
  T_36_SY_M249_MAMBAS_N: "M249-曼巴嘶咬",
  T_36_SY_M4A1_MAMBAS_N: "M4A1-曼巴嘶咬",
  T_36_SY_M500_MAMBAS_N: "M500-曼巴嘶咬",
  T_36_SY_M60_MAMBAS_N: "M60-曼巴嘶咬",
  T_36_SY_M79_MAMBAS_N: "M79-曼巴嘶咬",
  T_36_SY_MAC10_MAMBAS_N: "MAC10-曼巴嘶咬",
  T_36_SY_MAG7_MAMBAS_N: "MAG7-曼巴嘶咬",
  T_36_SY_MINI_MAMBAS_N: "AC80-曼巴嘶咬",
  T_36_SY_MP40_MAMBAS_N: "MP40-曼巴嘶咬",
  T_36_SY_MP5_MAMBAS_N: "MP5-曼巴嘶咬",
  T_36_SY_P90_MAMBAS_N: "P90-曼巴嘶咬",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL-曼巴嘶咬",
  T_36_SY_PP19_MAMBAS_N: "野牛衝鋒槍-曼巴嘶咬",
  T_36_SY_PP19_POLICEMAN_N: "野牛衝鋒槍-現代緝魔",
  T_36_SY_SCAR_MAMBAS_N: "SCAR-曼巴嘶咬",
  T_36_SY_SKS_MAMBAS_N: "SKS-曼巴嘶咬",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12-曼巴嘶咬",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "等離子槍-曼巴嘶咬",
  T_36_SY_SVD_MAMBAS_N: "SVD-曼巴嘶咬",
  T_36_SY_THOMPSON_MAMBAS_N: "湯普森衝鋒槍-曼巴嘶咬",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "飛刀-曼巴嘶咬",
  T_36_SY_THROWINGKNIFE_MENA_N: "飛刀-波赫",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "治療手槍-曼巴嘶咬",
  T_36_SY_UMP45_MAMBAS_N: "UMP-曼巴嘶咬",
  T_36_SY_USP45_MAMBAS_N: "USP-曼巴嘶咬",
  T_36_SY_UZI_MAMBAS_N: "烏茲手槍-曼巴嘶咬",
  T_36_SY_VECTOR_MAMBAS_N: "Vector-曼巴嘶咬",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "怪獸卡車-金光刺眼",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "機車-幽冥之旅",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "超跑-流金歲月",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "嘟嘟車-現代緝魔",
  T_36_SY_VSS_MAMBAS_N: "VSS-曼巴嘶咬",
  T_36_SY_XM8_MAMBAS_N: "XM8-曼巴嘶咬",
  T_36_WZY_AFTERACCUMULATOR: "後置累加器",
  T_36_WZY_AVAILAB: "是否啟用",
  T_36_WZY_BACKANDFORTH: "往返",
  T_36_WZY_BASEMULTIPLIER: "基本係數",
  T_36_WZY_BASIC: "基本類型",
  T_36_WZY_BEFORACCUMULATOR: "前置累加器",
  T_36_WZY_CYLIC: "迴圈",
  T_36_WZY_GUNPRO_PARAM1: "基礎傷害",
  T_36_WZY_GUNPRO_PARAM10: "子彈擴散門檻值",
  T_36_WZY_GUNPRO_PARAM11: "最大擴散門檻值",
  T_36_WZY_GUNPRO_PARAM12: "連射",
  T_36_WZY_GUNPRO_PARAM2: "彈匣子彈數",
  T_36_WZY_GUNPRO_PARAM3: "初始彈匣數量",
  T_36_WZY_GUNPRO_PARAM4: "發射間隔",
  T_36_WZY_GUNPRO_PARAM7: "最大傷害距離",
  T_36_WZY_GUNPRO_PARAM8: "最小傷害距離",
  T_36_WZY_GUNPRO_PARAM9: "最小傷害",
  T_36_WZY_MULTIPLIR: "連乘器",
  T_36_WZY_PRICE: "價格",
  T_36_WZY_SUMMULTIPLIER: "乘法累加器",
  T_36_WZY_WS_3DZOOM: "3D 縮放",
  T_36_WZY_WS_ABSRES: "絕對值結果",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "將[追加列表]中所有元素添加到[目標列表]尾部",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "增加元素的目標列表",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "追加元素的列表",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "在指定錢包內添加一定數量的特定貨幣",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "錢包",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "欲添加貨幣的錢包",
  T_36_WZY_WS_ADDSUB: "加減數值",
  T_36_WZY_WS_AIENTITY: "AI實體",
  T_36_WZY_WS_ALLSHOP_DESC: "包含商店實體的列表",
  T_36_WZY_WS_ANGLE_DESC: "角度值",
  T_36_WZY_WS_ANYTYPE: "任意類型",
  T_36_WZY_WS_ARILEFT: "運算的左值",
  T_36_WZY_WS_ARIRES: "運算結果",
  T_36_WZY_WS_ARIRIGHT: "運算的右值",
  T_36_WZY_WS_ARITHMETIC_NAME: "四則運算",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "基本四則運算，整數支援加、減、乘、除、餘；小數支持加、減、乘、除",
  T_36_WZY_WS_ARRAY_DESC: "目標列表",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "判斷一個列表中是否包含指定的元素，返回值是一個布林值",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "指定的列表",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "判斷是否在列表中的元素",
  T_36_WZY_WS_ARRCONELERES: "判斷列表中是否包含指定元素的結果，布林值",
  T_36_WZY_WS_ATTACK: "巡邏與攻擊",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "玩家被擊倒時觸發",
  T_36_WZY_WS_BIGFLOAT: "大浮點數",
  T_36_WZY_WS_BIGTOYBALL: "骰子",
  T_36_WZY_WS_BOOLLIST: "布林列表",
  T_36_WZY_WS_CEIL_NAME_DESC: "將值取為大於自身的最小整數",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "無條件進位的值",
  T_36_WZY_WS_CEILRES: "無條件進位後的結果",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "選擇的AI實體將無視距離追擊實體，[目標實體]可以是任何實體，[目標實體]沒有HP屬性時，AI實體造成0傷害",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "執行追擊動作的單位實體",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "被追逐的目標實體，可以是任何實體。",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "用於複製物件的模板。使用鼠標選擇。複製的物件屬性和腳本與所選的物件一致。",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "要複製的物件實體",
  T_36_WZY_WS_CONDITION: "條件",
  T_36_WZY_WS_CONDITIONLIST: "條件列表",
  T_36_WZY_WS_CONOFHUD: "控件所在的HUD實體",
  T_36_WZY_WS_CONTROL_DESC: "控件的唯一索引",
  T_36_WZY_WS_COS_NAMEDESC: "求角度的餘弦值",
  T_36_WZY_WS_COSRES: "角度的餘弦值",
  T_36_WZY_WS_CREABLEOB: "可創建物件",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "在指定位置創建一個物件實體（測試版）",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "物件創建的座標位置",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "創建的物件類型",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "創建的物件實體",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "貨幣",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "商品實體",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "創建的商品實體",
  T_36_WZY_WS_CREWALL_NAMEDESC: "創建一個錢包實體。[綁定玩家]是可以看到這個錢包的玩家。[擁有者] 是錢包所屬的玩家。如果錢包已經存在則無效。",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "被綁定玩家",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "可見此錢包的玩家。如果沒有配置任何設置，錢包將對所有人可見。",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "錢包主人",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "錢包實體",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "創建的錢包實體",
  T_36_WZY_WS_CURRAMT: "貨幣數量",
  T_36_WZY_WS_DATA_TYPE1: "嵌入參數",
  T_36_WZY_WS_DATA_TYPE2: "基本與邏輯運算",
  T_36_WZY_WS_DATA_TYPE3: "列表操作",
  T_36_WZY_WS_DATA_TYPE4: "向量計算",
  T_36_WZY_WS_DESTITEM_NAME: "摧毀玩家物品",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "為指定玩家銷毀指定類型的物品",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "可被摧毀的物品，包括武器、防彈衣、頭盔",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "所選物品類型的槽索引。武器為 [1,3]，護甲和頭盔默認為 1。",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "被淘汰時失去裝備",
  T_36_WZY_WS_DESTOBJ: "可被摧毀的物件",
  T_36_WZY_WS_DIRPOINT: "方向點",
  T_36_WZY_WS_DIRPOINTDESC: "構造的方向點",
  T_36_WZY_WS_ELEFINDRES: "列表中元素最先出現的位置索引",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "獲取列表中元素最先出現的位置索引。如果列表中不存在目標元素，則結果將返回“-1”。",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "列表中欲尋找的元素",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: "獲取列表中元素最後位置的索引。如果列表中不存在目標元素，則結果將返回“-1”。",
  T_36_WZY_WS_ELELINDRES: "元素最後出現的位置索引",
  T_36_WZY_WS_ELEMENTSNUM: "排序中的元素個數",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "[觸發實體]碰撞該機關時觸發",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "與該機關碰撞的實體",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "[觸發實體]駕駛該載具時觸發",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "駕駛該載具的實體",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "玩家進入機關時觸發",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "進入的機關",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "[觸發實體]離開載具碰時觸發",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "離開該載具的實體",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "[觸發實體]進入載具碰時觸發",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "進入載具的實體",
  T_36_WZY_WS_ENTITY_TYPE1: "常用",
  T_36_WZY_WS_ENTITY_TYPE2: "屬性",
  T_36_WZY_WS_ENTITY_TYPE3: "物件與物品",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "修改後的元素值",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "目標玩家",
  T_36_WZY_WS_ENTITYLIST: "實體列表",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "[觸發實體]被該輪胎擊飛時觸發",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "被輪胎擊飛的實體",
  T_36_WZY_WS_ENTTP_NAMEDESC: "當[觸發實體]通過傳送門傳送後觸發事件",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "通過該傳送門傳送的實體",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "裝備的防具類型，包括防彈衣、頭盔、背包",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "玩家成功裝備武器時觸發，[觸發玩家]是成功裝備武器的玩家，[武器實體]是玩家裝備的武器實體",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "裝備的武器實體",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "武器類型",
  T_36_WZY_WS_EULERANGLE: "歐拉角",
  T_36_WZY_WS_FACECAMERA: "永遠面對鏡頭",
  T_36_WZY_WS_FLOATLIST: "小數列表",
  T_36_WZY_WS_FLOOR_NAME_DESC: "將值取為小於自身的最大整數",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "無條件捨去的值",
  T_36_WZY_WS_FLOORRES: "無條件捨去結果",
  T_36_WZY_WS_FORMUENT: "可公式化屬性實體",
  T_36_WZY_WS_FORMUFACT: "屬性公式因子類型",
  T_36_WZY_WS_GAME_TYPE2: "玩法相關",
  T_36_WZY_WS_GAME_TYPE3: "特效相關",
  T_36_WZY_WS_GENENT_NAMEDESC: "當生成器生成單位時觸發，[單位實體列表]是生成器生成的單位清單，[波數]是生成器該次生成的波數",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "單位實體",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "生成器的單位實體組成的列表",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "生成器該次生成的波數",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "獲取比賽中的所有商店，返回值為商店實體的列表",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "使用 RGB 獲取顏色",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "獲取特定錢包中特定貨幣的數量",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "從中獲取貨幣金額的錢包",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "要獲取的貨幣種類",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "獲取目標實體的實體類型",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "要獲取其類型的實體",
  T_36_WZY_WS_GETENTTYPERES: "目標實體的實體類型",
  T_36_WZY_WS_GETFOR_NAME: "獲取方向座標",
  T_36_WZY_WS_GETFOR_NAMEDESC: "獲取指定方向點的方向向量",
  T_36_WZY_WS_GETFORRES: "方向點的方向向量",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "獲取錢包中某種幣種的幣種實體",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "貨幣實體所在的錢包",
  T_36_WZY_WS_GETPOS_NAME: "獲取位置座標",
  T_36_WZY_WS_GETPOS_NAMEDESC: "獲取指定方向點的位置座標",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "指定的方向點",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "裝備類型",
  T_36_WZY_WS_GETWALLET_NAME: "獲取錢包",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "獲取所選所有者的錢包",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "是否存在綁定錢包",
  T_36_WZY_WS_GETWALLETRES: "擁有者的錢包實體",
  T_36_WZY_WS_HUDCONTROL_DESC: "HUD的控件實體",
  T_36_WZY_WS_HUDTYPE: "HUD類型",
  T_36_WZY_WS_INCIDENT_TYPE1: "全局事件",
  T_36_WZY_WS_INCIDENT_TYPE2: "實體事件",
  T_36_WZY_WS_INDEX_DESC: "列表的索引值，從 0 開始",
  T_36_WZY_WS_INTLIST: "整數列表",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "實際判斷類型是否是實體的子類，返回值是布林值",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "屬於選擇的實體母類",
  T_36_WZY_WS_JENTSUBCLRES: "判斷實體母類別的結果",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "判斷選擇的實體是否是一個實體類型，返回值是一個布林值",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "進行判斷的實體",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "與選擇的實體類型一致",
  T_36_WZY_WS_JENTTYPERES: "實體類型的判斷結果",
  T_36_WZY_WS_JUSTPATROL: "只巡邏",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "[觸發實體]離開載具時觸發",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "退出的機關",
  T_36_WZY_WS_LEVELOBLIST: "物件列表",
  T_36_WZY_WS_LEVOBJSLIST: "當前遊戲中所有地圖物件的列表",
  T_36_WZY_WS_LEVOBTYPE: "物件類型",
  T_36_WZY_WS_LISTT: "任何列表",
  T_36_WZY_WS_LOGCONTEXT_DESC: "要影印的內容",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "連接的字串左值",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "連接的字串右值",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "要添加的元素值",
  T_36_WZY_WS_LOGOPER: "在進行邏輯運算（and 和 or）時：如果使用 and 運算符且兩個布林值都為 TRUE，結果為 TRUE；如果使用 or 運算符且其中一個布林值為 TRUE，結果為 TRUE。",
  T_36_WZY_WS_LOOTPOINT: "資源點",
  T_36_WZY_WS_MAINWEAP: "目前武器",
  T_36_WZY_WS_MAX_DESC: "生成整數的上限（開區間）",
  T_36_WZY_WS_MIN_DESC: "生成整數的下限（閉區間）",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "武器實體",
  T_36_WZY_WS_MONENT: "貨幣實體",
  T_36_WZY_WS_MONTYPE: "貨幣類型",
  T_36_WZY_WS_MOVETO_NAMEDESC: "AI實體向目標點移動，可以通過[是否返回]選擇是否到終點返回原處，也可以通過[是否攻擊]選擇是否在路徑上掃描敵方目標",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "移動的AI實體",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "目的地",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "用於設置AI到達目的地後是否返回原位。TRUE 表示返回；FALSE 表示不返回。",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "是否攻擊",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "用於設置 AI 是否會沿途攻擊附近的敵人。TRUE 表示掃描敵人；FALSE 表示不掃描敵人。",
  T_36_WZY_WS_MULVALUE: "向量純量乘法的值",
  T_36_WZY_WS_MULVEC: "進行純量乘法的向量",
  T_36_WZY_WS_NEGRES: "負值結果",
  T_36_WZY_WS_NEUTRAL: "中立",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "強制指定的生成器生成下一波，生成器包括殭屍與物品生成",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "生成器實體",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "指定的生成器實體，例如殭屍產生器和物品產生器",
  T_36_WZY_WS_OBJENT: "物件實體",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "獲得物品時觸發，[物品類型]為獲得物品的類型",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "獲得武器時觸發，[武器實體]是獲取的武器",
  T_36_WZY_WS_ONEWAY: "單程",
  T_36_WZY_WS_OPENSTATE: "開啟狀態",
  T_36_WZY_WS_OPERMETHOD_NAME: "運算方式",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "基本四則運算，整數支援加、減、乘、除、餘；小數支持加、減、乘、除",
  T_36_WZY_WS_OWNERENT_DESC: "要獲取錢包的實體",
  T_36_WZY_WS_PERCENTAGE: "百分比調整",
  T_36_WZY_WS_PLACOLLIDE_NAME: "玩家與機關碰撞時",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "[觸發玩家]與機關碰撞時觸發",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "與機關碰撞的玩家",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "玩家碰撞的物件實體",
  T_36_WZY_WS_PLADRIVEH_NAME: "當玩家駕駛載具",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "[觸發實體]駕駛載具時觸發",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "駕駛載具的玩家",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "玩家駕駛的載具實體",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "玩家離開載具時",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "[觸發玩家]離開載具時觸發",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "離開載具的玩家",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "玩家離開的載具實體",
  T_36_WZY_WS_PLAGETONVEH_NAME: "當玩家進入載具",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "[觸發實體]進入載具時觸發",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "玩家進入的載具實體",
  T_36_WZY_WS_PLAKNOFLY_NAME: "當玩家被輪胎擊飛時",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "[觸發玩家]被輪胎擊飛時觸發",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "被輪胎擊飛的玩家",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "擊飛玩家的物件實體",
  T_36_WZY_WS_PLATP_NAME: "玩家傳送後",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "使用傳送門的玩家",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "玩家使用的傳送門實體",
  T_36_WZY_WS_PLAYERLIST_DESC: "當前遊戲所有玩家的列表",
  T_36_WZY_WS_POINTPICKER: "路徑節點",
  T_36_WZY_WS_PORTALENT: "傳送門實體",
  T_36_WZY_WS_PREFAB: "模板",
  T_36_WZY_WS_PRODLIST: "商品列表",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "排序",
  T_36_WZY_WS_PROPMOD: "屬性修改方式",
  T_36_WZY_WS_RANKABLEE: "可排名實體",
  T_36_WZY_WS_REDCURR_NAMEDESC: "在指定錢包內消耗一定數量的特定貨幣",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "消耗的貨幣錢包",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "消耗的貨幣種類",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "消耗的貨幣數量",
  T_36_WZY_WS_RNDFRES: "隨機生成的小數",
  T_36_WZY_WS_RNDIRES: "整數隨機生成的結果",
  T_36_WZY_WS_ROUND_NAME_DESC: "將值四捨五入為最接近的整數",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "四捨五入的值",
  T_36_WZY_WS_ROUNDRES: "四捨五入的結果",
  T_36_WZY_WS_RUNAI_NAMEDESC: "停止/執行選擇的AI實體預設的行為樹",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "停止/執行預設行為樹的單元實體",
  T_36_WZY_WS_SCOREABLEE: "可計分實體",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "分數改變時觸發，[分數類型]為改變分數的類型，[分數]為新分數",
  T_36_WZY_WS_SETDIRPOINT_NAME: "創建方向點",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "獲取一個新創建的方向點，使用[位置]設置方向點的位置，使用[方向]設置方向點的方向向量",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "方向點座標",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "方向",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "方向點的方向",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI實體按照此處設置的路徑點順序移動，可以選擇移動方式有單程、迴圈、往返，也可以選擇是否在路徑上掃描敵對目標",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "AI移動路徑點的列表",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "移動方式",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "這些是移動類型。單程是AI在到達目的地後停止移動。迴圈是AI在到達目的地後會尋找返回的路。往返是AI根據路徑列表的倒序原路返回起點。",
  T_36_WZY_WS_SHOPECON: "商店和經濟",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "用於顯示螢幕上的飄字通知。使用[文本]設置內容，使用[顏色]設置文本顏色，使用[時長]設置顯示時長（單位為毫秒）。",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "飄字通知的內容",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "飄字通知的顏色",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "飄字通知的顯示時長，單位為毫秒",
  T_36_WZY_WS_SIN_NAMEDESC: "求角度的正弦值",
  T_36_WZY_WS_SINRES: "角度的正弦值",
  T_36_WZY_WS_SKIPKNODOWN: "擊倒時是否淘汰",
  T_36_WZY_WS_SQRTRES: "平方根結果",
  T_36_WZY_WS_STRCONRES: "字串連接結果",
  T_36_WZY_WS_STRINGLIST: "字串列表",
  T_36_WZY_WS_STRLEN: "字串長度",
  T_36_WZY_WS_STRVAL: "字串值",
  T_36_WZY_WS_TAN_NAMEDESC: "求角度的正切值",
  T_36_WZY_WS_TANRES: "角度的切線值",
  T_36_WZY_WS_TEAMLIST: "隊伍列表",
  T_36_WZY_WS_TEAMLIST_DESC: "當前比賽中所有隊伍的列表",
  T_36_WZY_WS_TIMETWEENTIPS: "倒數通知實體",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "將目標轉換為字串",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "目標數值轉換為字串",
  T_36_WZY_WS_TOSTRINGRES: "字串轉換結果",
  T_36_WZY_WS_TOWERCAMP_DESC: "陣營編號和隊伍編號一致，中立防禦塔、基地攻擊範圍內的所有玩家和AI實體",
  T_36_WZY_WS_TRACURR_NAMEDESC: "將一定數量的指定貨幣從一個錢包轉移到另一個錢包",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "將貨幣轉出的錢包",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "交易的貨幣種類",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "交易中的貨幣金額",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "將貨幣轉入的錢包",
  T_36_WZY_WS_TWEENTIPS: "飄字通知實體",
  T_36_WZY_WS_TYPEENUM: "列舉類型",
  T_36_WZY_WS_USEPROP_NAMEDESC: "玩家使用物品時觸發，[觸發玩家]是使用物品的玩家，[物品類型]是玩家使用道具的類型",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "玩家使用的物品類型",
  T_36_WZY_WS_VECADDLEFT: "向量加法左值",
  T_36_WZY_WS_VECADDRES: "向量加法計算結果",
  T_36_WZY_WS_VECADDRIGHT: "向量加法右值",
  T_36_WZY_WS_VECANGLEFT: "向量夾角計算左值",
  T_36_WZY_WS_VECANGRES: "兩向量的夾角",
  T_36_WZY_WS_VECANGRIGHT: "向量夾角計算右值",
  T_36_WZY_WS_VECCROLEFT: "向量外積左值",
  T_36_WZY_WS_VECCRORES: "向量外積計算結果",
  T_36_WZY_WS_VECCRORIGHT: "向量外積右值",
  T_36_WZY_WS_VECDISLEFT: "向量距離計算左值",
  T_36_WZY_WS_VECDISRES: "兩向量的距離",
  T_36_WZY_WS_VECDISRIGHT: "向量距離計算右值",
  T_36_WZY_WS_VECDOCLEFT: "向量內積左值",
  T_36_WZY_WS_VECDOCRES: "向量內積計算結果",
  T_36_WZY_WS_VECDOCRIGHT: "向量內積右值",
  T_36_WZY_WS_VECMULRES: "純量乘法計算結果",
  T_36_WZY_WS_VECNORRES: "標準化的向量",
  T_36_WZY_WS_VECSIZERES: "向量的模長",
  T_36_WZY_WS_VECSUBLEFT: "向量減法左值",
  T_36_WZY_WS_VECSUBRES: "向量減法計算結果",
  T_36_WZY_WS_VECSUBRIGHT: "向量減法右值",
  T_36_WZY_WS_VECTORLIST: "向量列表",
  T_36_WZY_WS_VECX: "向量X分量",
  T_36_WZY_WS_VECY: "向量Y分量",
  T_36_WZY_WS_VECZ: "向量Z分量",
  T_36_WZY_WS_VEHENT: "載具實體",
  T_36_WZY_WS_WALLCONT: "錢包內容",
  T_36_WZY_WS_ZOMBIESPERWAVE: "連續",
  T_36_XYL_WS_AIBOT: "單元",
  T_36_XYL_WS_AIGENERATOR: "單位生成器",
  T_36_XYL_WS_AIGENERATOR_DESC: "可以連續生成指定單位（例如殭屍）的生成器",
  T_36_XYL_WS_AIWAVE: "每波生成單位數量",
  T_36_XYL_WS_ARROW: "方向指示牌",
  T_36_XYL_WS_ARROW_DESC: "指示方向的標誌",
  T_36_XYL_WS_BREAKBOX: "可破壞的木箱",
  T_36_XYL_WS_BREAKBOX_DESC: "受到攻擊時會被破壞的木箱",
  T_36_XYL_WS_FENCE: "鐵圍欄",
  T_36_XYL_WS_FENCE_DESC: "可以讓子彈飛過的圍欄",
  T_36_XYL_WS_STAIRI: "樓梯平台C",
  T_36_XYL_WS_STAIRI_DESC: "所有平台皆可與樓梯合併",
  T_36_XYL_WS_ZOMBIEAI: "殭屍",
  T_36_XYL_WS_ZOMBIEAI_DESC: "一個可以自定義的殭屍，可在單位生成器中獲得和複製",
  T_36_YF_CORRODE_GRENADE_N: "凝膠腐蝕手榴彈",
  T_36_YF_SETTING_TYPE3: "方案 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF 蔚藍榮耀(下裝)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF 曙光榮耀(下裝)",
  T_36_YS_F_A_GHOSTHUNTER: "黑白靈貓(面飾)",
  T_36_YS_F_B_GHOSTHUNTER: "黑白靈貓(下裝)",
  T_36_YS_F_H_GHOSTHUNTER: "黑白靈貓(頭飾)",
  T_36_YS_F_S_GHOSTHUNTER: "黑白靈貓(鞋子)",
  T_36_YS_SETTING_GRENADE: "投擲物",
  T_36_YS_SETTING_MOVE: "移動",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF 蔚藍榮耀(上裝)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF 曙光榮耀(上裝)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "露娜",
  T_36_YZY_CHARACTER_YAKUZA_N: "達也",
  T_36_YZY_PET_WOLF_N: "芬里爾",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "寵物外觀：葡萄絨恩",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "寵物外觀：雷霆獵隼",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "寵物外觀：熔岩芬里爾",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "寵物外觀：幽冥芬里爾",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "寵物外觀：極地芬里爾",
  T_37_B_WS_HIDE: "躲貓貓模式",
  T_37_HZ_WS_CATMODEDESC1: "躲貓貓模式",
  T_37_JH_WS_CREATEGOLD_DESC: "玩家可購買物品的販賣機（於團隊突襲、團隊死鬥派對模式、啟示錄模式中無效）",
  T_37_JH_WS_NAME1: "飛刀(啟示錄)",
  T_37_JH_WS_NAME10: "M1887-X(啟示錄)",
  T_37_JH_WS_NAME11: "SPAS12(啟示錄)",
  T_37_JH_WS_NAME12: "M1014(啟示錄)",
  T_37_JH_WS_NAME13: "MP40(啟示錄)",
  T_37_JH_WS_NAME14: "MP5-III(啟示錄)",
  T_37_JH_WS_NAME15: "P90(啟示錄)",
  T_37_JH_WS_NAME16: "M60-III(啟示錄)",
  T_37_JH_WS_NAME17: "湯普森衝鋒槍(啟示錄)",
  T_37_JH_WS_NAME18: "UMP(啟示錄)",
  T_37_JH_WS_NAME19: "SVD(啟示錄)",
  T_37_JH_WS_NAME2: "GROZA(啟示錄)",
  T_37_JH_WS_NAME20: "AWM(啟示錄)",
  T_37_JH_WS_NAME21: "M82B(啟示錄)",
  T_37_JH_WS_NAME22: "M249-X(啟示錄)",
  T_37_JH_WS_NAME23: "Kar98k-III(啟示錄)",
  T_37_JH_WS_NAME3: "AK47(啟示錄)",
  T_37_JH_WS_NAME4: "M4A1-III(啟示錄)",
  T_37_JH_WS_NAME5: "SCAR(啟示錄)",
  T_37_JH_WS_NAME6: "M14-III(啟示錄)",
  T_37_JH_WS_NAME7: "PARAFAL(啟示錄)",
  T_37_JH_WS_NAME8: "XM8(啟示錄)",
  T_37_JH_WS_NAME9: "MAG7(啟示錄)",
  T_37_JH_WS_VENDMACHINE_DESC: "可在地圖各處拾取的金幣（於團隊突襲、團隊死鬥派對模式、啟示錄模式中無效）",
  T_37_JH_WS_X: "X軸",
  T_37_JH_WS_Y: "Y軸",
  T_37_JH_WS_Z: "Z軸",
  T_37_JL_FOOTBALL_TIE: "平手",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "雪人瓦哥",
  T_37_LC_BP_ENTRANCE_GIFT: "禮物！",
  T_37_M_WS_MISSING: "已丟失",
  T_37_M_WS_NAMEERROR: "包含敏感文字，請修改後再試",
  T_37_PD_HuntingGround_BOSSTITLE: "鉸剪屠夫",
  T_37_QL_JUMPPAD_DES: "使用彈跳手榴彈在地面上創造氣旋跳板，可將角色快速推向空中，且能夠在空中射擊",
  T_37_QL_JUMPPAD_NAME: "彈跳手榴彈",
  T_37_R_TAILOR_LIMIT: "限時活動獲取",
  T_37_RW_LOADOUT_BORNFIRETAG: "比賽開始時，獲得 2 個營火棒，幫助範圍內自己和隊友每秒恢復[FFBA00] 5 HP 及 20 EP[-]，持續 10 秒，效果無法疊加。",
  T_37_RW_PROPCATAPULT_DESC: "完成充氣後，氣流噴射台可以將人發射至空中，但小心不要發射到安全區外！",
  T_37_RW_PROPCATAPULT_NAME: "氣流噴射台",
  T_37_SP_WS_COLOR_02: "顏色",
  T_37_SP_WS_COLOR_03: "外觀",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "獲得或設定屬性時實體為空",
  T_37_SP_WS_LOG_PHASE_END: "關卡{0}結束",
  T_37_SP_WS_LOG_PHASE_START: "關卡{0}開始",
  T_37_SP_WS_LOG_ROUND_END: "回合{0}結束",
  T_37_SP_WS_LOG_ROUND_START: "回合{0}開始",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "對變量指定值時類型不一致，需要類型：{0}，當前類型：{1}",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "未定義或超出範圍的區域變數",
  T_37_SP_WS_MAPACCESS_08: "編輯",
  T_37_SP_WS_RACEMODE_01: "倒數計時模式",
  T_37_SP_WS_RACEMODE_02: "倒數計時時間",
  T_37_SP_WS_RACEMODE_04: "開啟時，隊伍到達終點時會啟動倒數計時，計時結束時遊戲結束",
  T_37_SY_AR15_KABUKI_N: "翠鳥步槍-風姿花傳",
  T_37_SY_BACKPACK_STRAW_N: "背包-冒險草帽",
  T_37_SY_GRENADE_FFWS2022_01_N: "手榴彈-深藍星辰",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "入場動畫-星辰黑洞",
  T_37_SY_M1216_MAMBAS_N: "Trogon-曼巴嘶咬",
  T_37_SY_PET_FLYINGCREATURE_N: "潮男阿龍",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "寵物外觀：毛帽豆豆",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "寵物外觀：冷酷阿龍",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "寵物外觀：星辰阿龍",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "寵物外觀：火爆阿龍",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "寵物外觀：足球麥麥龜",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "寵物外觀：冰雪毛毛",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "吉普車-節慶狂歡",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "皮卡車-星辰狂襲",
  T_37_WT_WS_PVE2DESC: `殭屍模式，需在時間內消滅指定數量的殭屍或堅持生存到最後。
你可以自由設定遊戲規則與調整殭屍相關設定，包括需消滅的殭屍目標數量。`,
  T_37_WT_WS_RULEDESC: "擊殺指定數量的殭屍獲得勝利",
  T_37_WT_WS_RULETITLE: "通關目標",
  T_37_WT_WS_TXT1: "擊殺殭屍",
  T_37_WT_WS_TXT1DESC: "開啟時，擊殺指定數量的殭屍獲得勝利，關閉時，存活至最後一秒獲得勝利。",
  T_37_WT_WS_TXT2: "擊殺數量",
  T_37_WZY_FRIDPLA: "友軍玩家",
  T_37_WZY_FRIDSIDE: "友軍陣營",
  T_37_WZY_FRIDTEAM: "友軍隊伍",
  T_37_WZY_HOSTPLA: "敵方玩家",
  T_37_WZY_HOSTSIDE: "敵軍陣營",
  T_37_WZY_WS_ACCFRAMES: "累積運行幀數",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "添加物品製一個商品，可添加單一物品或一組物品，數量可為單一道具的數量或此數量道具組成的一個列表",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "要添加物品到的商品實體",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "要添加的物品",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "單一物品的添加數量或對應數量的物品組成的列表",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "添加標籤至所選的實體",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "要添加標籤的實體",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "要添加的標籤文本",
  T_37_WZY_WS_AIMABLEENT: "可瞄準實體",
  T_37_WZY_WS_AIMASSISTTYPE: "輔助瞄準類型",
  T_37_WZY_WS_ALLOWDROP_NAME: "允許/禁止丟棄物品",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "玩家是否可丟棄物品",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "要設置是否可丟棄物品的玩家實體",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "玩家是否能丟棄物品，為布林值",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "允許/禁止物品拾取",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "玩家是否可拾取物品",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "要設置是否可拾取物品的玩家實體",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "玩家是否能拾取物品，為布林值",
  T_37_WZY_WS_AMBIENTCOLOR: "環境光顏色",
  T_37_WZY_WS_AMRORTOOL: "護甲修復",
  T_37_WZY_WS_ATTACK: "攻擊",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "取消玩家的偽裝，變回正常外型",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "取消偽裝的玩家實體",
  T_37_WZY_WS_BALLADDV_NAMEDES: "對足球增加瞬時速度",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "施加順時速度的足球",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "施加的順時速度向量",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "足球被足球槍擊中時觸發，[玩家實體]為擁有足球槍的玩家，[增加速度]為足球被足球槍擊中增加的瞬時速度",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "擁有足球槍的玩家",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "足球遭碰撞後的順時速度向量",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "足球與實體碰撞且速度增加時觸發，[碰撞實體]為與足球碰撞的實體[增加速度]為碰撞使足球增加的瞬時速度",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "與足球碰撞的實體",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "碰撞給足球施加的瞬時速度向量",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "實體被玩家瞄準時觸發",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "瞄準該實體的玩家",
  T_37_WZY_WS_BEHAVIORSTAT: "玩家行為狀態",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "命中該實體的武器",
  T_37_WZY_WS_BLOODBARENT: "血條實體",
  T_37_WZY_WS_BOMBEND: "炸彈引爆前",
  T_37_WZY_WS_BOMBSTART: "炸彈提示",
  T_37_WZY_WS_CHANENT: "頻道實體",
  T_37_WZY_WS_CHEER: "歡呼",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "判斷所選的實體是否包含指定的標籤",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "判斷是否包含標籤的實體",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "要判斷的標籤",
  T_37_WZY_WS_CHELABELRES: "判斷實體是否包含標籤的結果，為布林值",
  T_37_WZY_WS_CJERSEY_NAME: "更換球衣",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "要更換球衣的玩家",
  T_37_WZY_WS_CJERSEY_PARAM2: "球衣樣式",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "要更改為的球衣樣式",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "球衣部位1的顏色",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "球衣部位2的顏色",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "球衣部位3的顏色",
  T_37_WZY_WS_CJERSEYTYPE1: "設計方案 1",
  T_37_WZY_WS_CJERSEYTYPE2: "設計方案 2",
  T_37_WZY_WS_CJERSEYTYPE3: "設計方案 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "清除列表中所有元素",
  T_37_WZY_WS_CREABLEOB_DESC: "可通過圖元創建的物件類型",
  T_37_WZY_WS_CREPROD_NAMEDESC: "創建一個可自訂的商品並返回商品實體，商品內容可以通過屬性設定修改",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "創建一個自訂商品列表，並返回商品列表實體，此列表內容可以透過屬性設置修改",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "創建的商品列表實體",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "創建一個陣營實體",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "創進的陣營實體",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "創建一個自訂商店，並返回商店實體，此商店內容可以透過屬性設置修改",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "創建的商店實體",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "更換遊戲的天空盒環境樣式，可以選擇白天、黃昏、黑夜",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "要更換的天空盒樣式，包括白天、黃昏、黑夜",
  T_37_WZY_WS_DARKNESS: "全局暗度",
  T_37_WZY_WS_DELENT_NAMEDESC: "刪除指定實體，目前支持圖標實體、文字實體、HUD實體，視覺效果實體，武器實體，以及其他物件實體",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "要刪除的實體",
  T_37_WZY_WS_DROP: "失誤",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "玩家丟棄物品時觸發，[物品類型]是丟棄的物品類型ID",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "丟棄物品的類型ID",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "玩家丟棄武器時觸發，[武器實體]是丟棄的武器",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "丟棄的武器",
  T_37_WZY_WS_DUMMYLEOBJ: "普通關卡物件",
  T_37_WZY_WS_DUST: "黃昏",
  T_37_WZY_WS_EMPTYCH: "默認空頻道",
  T_37_WZY_WS_EMPTYCH1: "空頻道1",
  T_37_WZY_WS_EMPTYCH2: "空頻道2",
  T_37_WZY_WS_EMPTYCH3: "空頻道3",
  T_37_WZY_WS_EMPTYCH4: "空頻道4",
  T_37_WZY_WS_EMPTYCH5: "空頻道5",
  T_37_WZY_WS_EMPTYCH6: "空頻道6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: "獲取符合三個條件的所有實體組成的列表，「包含」、「不包含」、「包含其一」填入的內容為單一組件類型或組件類型列表，返回值是符合條件的實體組成的列表",
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "篩選出的實體必須包含該數組的全部組件",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "篩選出的實體必須不包含該數組的任意組件",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "篩選出的實體必須至少包含該數組的一個組件",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "要修改的該實體屬性類型",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "修改後的屬性值",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "指定的玩家推出所在頻道，不在任何頻道中",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "推出目前頻道的玩家",
  T_37_WZY_WS_FAKEENT: "偽裝實體",
  T_37_WZY_WS_FIND_STR_DESC: "在字串中尋找指定文本的位置",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "要尋找的文字",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "從起始位置0開始尋找字串",
  T_37_WZY_WS_FINDSTRRES: "該字串第一個出現的位置，從 0 開始。",
  T_37_WZY_WS_FOGCOLOR: "霧氣顏色",
  T_37_WZY_WS_FRICTIONCON: "普通摩擦力係數",
  T_37_WZY_WS_FRICTIONIMP: "碰撞摩擦力係數",
  T_37_WZY_WS_FROMDEATH: "復活",
  T_37_WZY_WS_FROMKNODOWN: "救助",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "獲取指定玩家目前所在的頻道",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "獲取頻道的玩家實體",
  T_37_WZY_WS_GETCHANRES: "玩家目前所在的頻道",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "根據頻道ID 1-8，獲取遊戲開始時默認創建的空頻道",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "默認空頻道的ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "獲取的頻道實體",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "獲取玩家的偽裝實體，用於更換玩家外型",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "獲取偽裝實體的物件",
  T_37_WZY_WS_GETGAMEENT_NAME: "獲取全局實體",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "獲取該局的遊戲實體",
  T_37_WZY_WS_GETHOSTPLA_NAME: "獲取可攻擊玩家",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "陣營實體",
  T_37_WZY_WS_GOAL_NAMEDESC: "足球進入球門時觸發，[球門]為該足球進入的球門，[進球者]是最後一位接觸該足球的玩家，[助攻者]是倒數第二位接觸該足球的玩家",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "該足球進入的球門",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "最後一位接觸該足球的玩家",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "倒數第二位接觸該足球的玩家",
  T_37_WZY_WS_HEARTBEAT: "心跳",
  T_37_WZY_WS_HEAVYWEAPON: "重武器",
  T_37_WZY_WS_HIHGSHOOTANGLE: "最小抽射角度",
  T_37_WZY_WS_HOSTPLA: "可攻擊玩家列表",
  T_37_WZY_WS_HOSTSIDE: "可攻擊陣營列表",
  T_37_WZY_WS_HOSTTEAM: "可攻擊隊伍列表",
  T_37_WZY_WS_ICON_CLOCK: "倒數計時",
  T_37_WZY_WS_ICON_CLOTHES: "服飾",
  T_37_WZY_WS_ICON_QUIT: "出口",
  T_37_WZY_WS_INSERT_ARR_DESC: "在列表中的指定位置插入一個新元素",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "從索引位置開始截取指定長度的字串，若截取長度超過字串長度，將截取內容直到字串結束",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "截取長度",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "截取的字串",
  T_37_WZY_WS_INTORINTL: "整數或整數列表",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "玩家加入指定陣營",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "玩家加入的陣營",
  T_37_WZY_WS_JUMP: "跳躍",
  T_37_WZY_WS_LABEL: "標籤",
  T_37_WZY_WS_LENSFLARE: "光暈強度",
  T_37_WZY_WS_LENTH: "長度",
  T_37_WZY_WS_LIGHTATTACK: "擊中",
  T_37_WZY_WS_LIGHTCOLOR: "主光源顏色",
  T_37_WZY_WS_LIGHTINTENSITY: "主光源強度",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "加載新的場景",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "要加載的場景名稱",
  T_37_WZY_WS_MOROBJECT: "偽裝物件",
  T_37_WZY_WS_MOVEAXISX: "沿X軸移動",
  T_37_WZY_WS_MOVEAXISY: "沿Y軸移動",
  T_37_WZY_WS_MOVEAXISZ: "沿Z軸移動",
  T_37_WZY_WS_MOVEDISTITLE: "移動距離",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "開啟關閉快捷訊息",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "開啟玩家的快捷訊息，關閉時，快捷訊息HUD無法使用，且玩家無法發送與接收快捷訊息",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "要開啟/關閉快捷訊息的玩家",
  T_37_WZY_WS_MUTEVOICE_NAME: "開啟關閉語音聊天",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "開關玩家的語音聊天，關閉時禁用語音HUD，同時無法發送和接受語音訊息",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "要開啟/關閉語音聊天的玩家",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "布林值，True為關閉；False為開啟",
  T_37_WZY_WS_NIGHTMODE: "夜晚模式",
  T_37_WZY_WS_ONAIM_NAMEDESC: "玩家準星瞄準可瞄準實體時觸發，[目標實體]是被瞄準的實體，沒有實體被瞄準時，返回值為空",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "被瞄準的實體",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "被該武器命中的實體",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "場景讀取成功時觸發",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "加載的場景名稱，為字串",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "場景切換成功時觸發",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "新場景的名稱，為字串",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "將玩家的服飾恢復成默認樣式",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "要恢復默認服飾的玩家",
  T_37_WZY_WS_PETSET: "寵物設定",
  T_37_WZY_WS_PETSKILL: "寵物技能",
  T_37_WZY_WS_PETSWITCH2: "寵物技能是否可使用",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "是否允許玩家移動，為布林值",
  T_37_WZY_WS_PLAYERBEHAVIOR: "玩家行為類型",
  T_37_WZY_WS_PRESS: "弱點擊",
  T_37_WZY_WS_PROGRESS: "當前進度值",
  T_37_WZY_WS_PROGRESSBAR: "進度HUD實體",
  T_37_WZY_WS_RANKDOWN: "降級",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "移除所選實體的標籤",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "要移除的標籤文本",
  T_37_WZY_WS_REPLACE_STR_DESC: "將該字串內容替換為指定內容",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "被替換的文字",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "用來替換的新文字",
  T_37_WZY_WS_REVERSE_ARR_DESC: "反轉此列表的所有元素",
  T_37_WZY_WS_REVIVEHERE: "在該復活點復活隊友的玩家",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "玩家在該復活點復活隊友時觸發",
  T_37_WZY_WS_REVIVEWAYDESC: "將玩家從擊殺或擊倒狀態復活或救助的方法",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "設置玩家的行為狀態，行為包括移動、攻擊、跳躍、衝刺，狀態包括禁止、隱藏、啟用。禁止狀態下HUD上的對應鍵位為禁止使用，禁止主動和被動的移動；隱藏狀態會隱藏HUD上的對應鍵位，禁止主動的移動，但允許被動的移動；啟用狀態會顯示HUD上的對應鍵位，允許主動和被動的移動",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "要設置行為狀態的玩家",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "玩家的行為，包括移動、攻擊、跳躍、衝刺",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "狀態包括禁止、隱藏、啟用。隱藏狀態會隱藏HUD上的對應鍵位，禁止主動的移動，但允許被動的移動；啟用狀態會顯示HUD上的對應鍵位，允許主動和被動的移動",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "足球的座標",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "該足球是否保持設置前的速度，為布林值",
  T_37_WZY_WS_SETPLAHOST_NAME: "設置玩家是否可攻擊",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "設置[設置玩家]是否可攻擊[目標玩家]，默認設置取決於目標玩家是否屬於可被攻擊的隊伍和陣營，此設置優先於隊伍/陣營設定",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "要設置為敵人的玩家",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "設置為敵人的玩家",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "是否可攻擊",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: "「是」為可攻擊；「否」為不可攻擊；默認設置取決於玩家是否屬於可被攻擊的隊伍和陣營",
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: "「是」為可攻擊；「否」為不可攻擊",
  T_37_WZY_WS_SHADOWSTRENGTH: "陰影暗度",
  T_37_WZY_WS_SHOOTANGLE: "最小射門角度",
  T_37_WZY_WS_SKYBOX: "天空盒",
  T_37_WZY_WS_SKYBOXENT: "天空盒實體",
  T_37_WZY_WS_SKYBOXTYPE: "天空盒基礎樣式",
  T_37_WZY_WS_STEPPED: "踩機關",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "切換玩家所在的語音聊天頻道",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "要切換頻道的玩家",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "要切換到的頻道",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "切換至指定場景",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "要切換到的場景名稱",
  T_37_WZY_WS_TARGETSTR_DESC: "目標字串",
  T_37_WZY_WS_TEAMASIDE: "隊伍與陣營",
  T_37_WZY_WS_TELEPORTN_AUTO: "自動",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "是否可傳送",
  T_37_WZY_WS_TELEPORTN_MANUAL: "手動",
  T_37_WZY_WS_TELEPORTN_NO: "否",
  T_37_WZY_WS_TELEPORTN_TITLE: "傳送模式",
  T_37_WZY_WS_TELEPORTN_YES: "是",
  T_37_WZY_WS_TERRAINWET: "地面濕度",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "將[玩家實體]外觀替換為所選的[場景物件]外觀",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "更改外型的玩家",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "獲取偽裝實體的玩家",
  T_37_WZY_WS_TRANSP: "透明度",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "解除安裝指定場景",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "要解除安裝的場景名稱",
  T_37_WZY_WS_VFX1: "地面標記",
  T_37_WZY_WS_VFX2: "煙霧",
  T_37_WZY_WS_VFX3: "符咒爆炸",
  T_37_WZY_WS_VFX5: "冰凍",
  T_37_WZY_WS_VFX6: "聚光燈",
  T_37_WZY_WS_VFX7: "上升氣流",
  T_37_WZY_WS_VFX8: "氣體爆炸",
  T_37_WZY_WS_VISABLE: "可見性",
  T_37_WZY_WS_WEAOPEN: "是否顯示",
  T_37_WZY_WS_WEAPONENT: "武器實體",
  T_37_WZY_WS_WEATARGETED: "是否可被輔助瞄準鎖定",
  T_37_XYL_CUSTOMJERSEY: "球衣製造機",
  T_37_XYL_CUSTOMJERSEY_DESC: "使用球衣製造機打造你的夢幻球衣",
  T_37_XYL_FOOTGUN: "足球槍",
  T_37_XYL_SOCCER: "足球",
  "T_37_XYL_SOCCER_ RADIUS": "足球半徑",
  T_37_XYL_SOCCER_DESC: "可以自訂屬性的足球",
  T_37_XYL_SOCCER_HIGHT1: "普通射擊角度",
  T_37_XYL_SOCCER_HIGHT2: "抽射角度",
  T_37_XYL_SOCCER_RESET: "進球後復位時間(秒)",
  T_37_XYL_SOCCER_RESIST1: "足球阻力（普通狀態）",
  T_37_XYL_SOCCER_RESIST2: "足球阻力（槍擊狀態）",
  T_37_XYL_SOCCERGOAL: "球門",
  T_37_XYL_SOCCERGOAL_DESC: "足球球門，將足球踢進球門得分（僅積分賽有效）",
  T_37_XYL_SOCCERITEM: "足球產生點",
  T_37_XYL_SOCCERITEM_DESC: "放置後，將產生所選的物品",
  T_37_XYL_SPAWN_PEOPLE: "出生的人數",
  T_37_XYL_WS_AIRCONDITIONER001: "冷氣機B",
  T_37_XYL_WS_AMMUCHEST: "軍火箱A",
  T_37_XYL_WS_BAFFLE001: "障礙物A",
  T_37_XYL_WS_BARREL001: "木桶",
  T_37_XYL_WS_BARREL001_DES: "隨處可見的圓木桶",
  T_37_XYL_WS_BOARD001: "廣告牌B",
  T_37_XYL_WS_BOOK001: "書堆A",
  T_37_XYL_WS_BOOK002: "桌遊A",
  T_37_XYL_WS_BOUGAINVILLEA: "九重葛",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "裝飾物-九重葛",
  T_37_XYL_WS_BOX001: "紙箱堆A",
  T_37_XYL_WS_BOX002: "小箱子",
  T_37_XYL_WS_BUSHCOVER: "灌木叢",
  T_37_XYL_WS_BUSHCOVER_DES: "可以躲藏的灌木叢",
  T_37_XYL_WS_CABINET001: "櫃子A",
  T_37_XYL_WS_CHAIR001: "椅子A",
  T_37_XYL_WS_COCONUTTREE: "椰子樹",
  T_37_XYL_WS_COCONUTTREE_DES: "裝飾物-椰子樹",
  T_37_XYL_WS_COMPUTER001: "電腦A",
  T_37_XYL_WS_DAMAGERATIO: "受傷倍率",
  T_37_XYL_WS_FIREEX: "滅火器",
  T_37_XYL_WS_GUIDEPOSE: "方向標",
  T_37_XYL_WS_HUGEHOUSE001: "三層房屋B",
  T_37_XYL_WS_HUGEHOUSE002: "二層房屋B",
  T_37_XYL_WS_JACKSTRAW: "南瓜頭稻草人",
  T_37_XYL_WS_LADDER001: "梯子A",
  T_37_XYL_WS_OILDRUM: "小油桶",
  T_37_XYL_WS_ORNAMENT001: "花瓶A",
  T_37_XYL_WS_PACKBOX: "物資箱",
  T_37_XYL_WS_PILLA001: "水泥柱",
  T_37_XYL_WS_PRESENT: "聖誕禮盒",
  T_37_XYL_WS_PRESENT_DES: "裝有禮品的聖誕節禮盒",
  T_37_XYL_WS_PUMPKIN: "南瓜燈B",
  T_37_XYL_WS_PUMPKINCUT: "南瓜燈A",
  T_37_XYL_WS_PUMPKINCUT_DES: "萬聖節常見的南瓜頭",
  T_37_XYL_WS_ROADBLOCK001: "路障B",
  T_37_XYL_WS_SHELF001: "書架A",
  T_37_XYL_WS_SOFA001: "沙發A",
  T_37_XYL_WS_SPAWNTEAM: "所有隊伍",
  T_37_XYL_WS_SUPPLYBOX: "彈藥箱",
  T_37_XYL_WS_TABLE001: "桌子A",
  T_37_XYL_WS_TABLE002: "桌子B",
  T_37_XYL_WS_TARGET001: "標靶",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "傳送門終點",
  T_37_XYL_WS_TELEPORTNEW: "傳送門A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "可傳送玩家至傳送門終點",
  T_37_XYL_WS_TIRES001: "輪胎A",
  T_37_XYL_WS_TOOLRACK: "工具架",
  T_37_XYL_WS_WALL001: "圍牆",
  T_37_XYL_WS_WOOD001: "木堆",
  T_37_XYL_WS_YELLOWDUCK001: "小黃鴨泳圈",
  T_37_XYL_WS_YELLOWDUCK001_DES: "充氣小黃鴨泳圈",
  T_37_YM_BOMBSQUAD_DEFUSER: "拆彈器",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF 純白榮耀(下裝)",
  T_37_YS_F_B_VN_STREET: "緋紅吉祥(下裝)",
  T_37_YS_F_H_VN_STREET: "緋紅吉祥(頭飾)",
  T_37_YS_F_S_VN_STREET: "緋紅吉祥(鞋子)",
  T_37_YS_F_T_VN_STREET: "緋紅吉祥(上裝)",
  T_37_YS_M_A_CRICKET_BLACK: "閃電板球員(面飾)",
  T_37_YS_M_A_THKOL: "熾燄狂徒(面飾)",
  T_37_YS_M_B_CRICKET_BLACK: "閃電板球員(下裝)",
  T_37_YS_M_B_SILVERERA: "無懼衛士(下裝)",
  T_37_YS_M_B_THKOL: "熾燄狂徒(下裝)",
  T_37_YS_M_H_SILVERERA: "無懼衛士(頭飾)",
  T_37_YS_M_H_THKOL: "熾燄狂徒(頭飾)",
  T_37_YS_M_S_CRICKET_BLACK: "閃電板球員(鞋子)",
  T_37_YS_M_S_SILVERERA: "無懼衛士(鞋子)",
  T_37_YS_M_S_THKOL: "熾燄狂徒(鞋子)",
  T_37_YS_M_T_CRICKET_BLACK: "閃電板球員(上裝)",
  T_37_YS_M_T_SILVERERA: "無懼衛士(上裝)",
  T_37_YS_M_T_THKOL: "熾燄狂徒(上裝)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF 純白榮耀(上裝)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "最小開局人數",
  T_38_BQ_SKILL_NAME_DUMMY1: "爆破假人",
  T_38_BQ_SKILL_NAME_DUMMY2: "替身假人",
  T_38_CJ_F_B_STREAMER_MUSIC: "反派甜心(下裝)",
  T_38_CJ_F_H_STREAMER_MUSIC: "反派甜心(頭飾)",
  T_38_CJ_F_S_STREAMER_MUSIC: "反派甜心(鞋子)",
  T_38_CJ_F_T_STREAMER_MUSIC: "反派甜心(上裝)",
  T_38_JH_WS_CM1: "玩法清晰",
  T_38_JH_WS_CM2: "玩法難懂",
  T_38_JH_WS_CM3: "頻繁中離",
  T_38_JL_M79_AMMO_N: "M79 榴彈",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs 晶片",
  T_38_M_WS_VECTOR2: "二維向量",
  T_38_R_TACTICS_N: "戰術方案",
  T_38_RW_NIW_NIWNAME: "凝膠製造器",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "圖元堆疊層數過多，當前為{0}，上限為{1}",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "創建物品數量 {0} 個，超過上限 {1} 個。",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "同一幀接收事件數量 {0} 個，超過上限數量 {1} 個。",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "單幀可建立的實體數量上限為 ({0})，已拒絕 {1} 次建立請求。",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "列表初始長度為{0}，超過上限{1}，自動建立最大容量列表",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "循環{0}次，超過上限{1}次，循環中斷",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "協程作用域中同時執行的協程數量 ({0})，已超出限制 ({1})。",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "添加元素至列表失敗，列表{0}為空",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "四則運算左右類型不符，左側類型{0}，右側類型{1}",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "重複定義臨時變量，變量名：{0}",
  T_38_SP_WS_REVIEW_01: "不友善",
  T_38_SP_WS_REVIEW_02: "粗俗",
  T_38_SP_WS_REVIEW_03: "侮辱",
  T_38_SP_WS_REVIEW_04: "極度不友善",
  T_38_SP_WS_REVIEW_05: "威脅",
  T_38_SP_WS_REVIEW_06: "人身攻擊",
  T_38_SP_WS_REVIEW_07: "審核中",
  T_38_SP_WS_REVIEW_08: "{0}類型名稱{1}不符合規定，{2}",
  T_38_SP_WS_REVIEW_09: "字串",
  T_38_SP_WS_REVIEW_10: "商店",
  T_38_SP_WS_REVIEW_11: "變量",
  T_38_SP_WS_REVIEW_12: "函數",
  T_38_SP_WS_REVIEW_13: "物件",
  T_38_SP_WS_REVIEW_14: "跳轉至定義處",
  T_38_SP_WS_REVIEW_15: "跳轉至物件選擇器",
  T_38_SP_WS_REVIEW_16: "無跳轉",
  T_38_SP_WS_REVIEW_17: "地圖名稱",
  T_38_SP_WS_REVIEW_18: "地圖描述",
  T_38_SP_WS_REVIEW_19: "地圖封面",
  T_38_SP_WS_REVIEW_20: "文本包含敏感字詞。",
  T_38_SP_WS_REVIEW_21: "儲存失敗，無法審核",
  T_38_SP_WS_REVIEW_22: "審核冷卻中",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "球棒-蛋營養",
  T_38_SY_CHARACTER_DESIGNER_N: "聖提諾",
  T_38_SY_PET_CACTUS_N: "刺刺",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "寵物外觀：陰森刺刺",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "寵物外觀：霓虹刺刺",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "寵物外觀：度假刺刺",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "寵物外觀：派對阿龍",
  T_38_SY_PETSKIN_RACCOON_MO_N: "寵物外觀：龐克浣仔",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR-業火阿修羅",
  T_38_SY_SICKLE_ES_N: "鐮刀-Free Fire 宇宙",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "皮卡車-海鮮餐車",
  T_38_WT_WS_MUITLEVEL: "多關卡",
  T_38_WT_WS_SKILLSET15: "戰爭顫慄 (A124)",
  T_38_WT_WS_SKILLSET16: "感應衝擊 (赫馬)",
  T_38_WT_WS_SKILLSET17: "護盾穿透 (艾瑞絲)",
  T_38_WT_WS_SKILLSET18: "急速衝鋒 (達也)",
  T_38_WZY_WS_ACTIVEA: "場景中可否使用",
  T_38_WZY_WS_ACTIVEB: "是否開啟邏輯更新",
  T_38_WZY_WS_ACTIVEVALUE: "活動狀態",
  T_38_WZY_WS_AIR: "空氣",
  T_38_WZY_WS_ALLOWMOVE: "是否可移動",
  T_38_WZY_WS_AMMOAMOUNT: "子彈數量",
  T_38_WZY_WS_AMMONAME: "子彈實體",
  T_38_WZY_WS_ARMOR_DAMRED: "傷害減免係數",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "爆炸傷害減免系數",
  T_38_WZY_WS_ARMOR_DURABILITY: "當前耐久度",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "最大耐久度",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "是否不會破損",
  T_38_WZY_WS_ARMOR_ISDESTROY: "是否無法摧毀",
  T_38_WZY_WS_ARMOR_LEVEL: "等級",
  T_38_WZY_WS_ASSCONZOM: "對殭屍擊殺助攻數",
  T_38_WZY_WS_BAGNAME: "背包實體",
  T_38_WZY_WS_BAGSPACEEX: "額外背包空間",
  T_38_WZY_WS_BRIDGING: "橋梁渲染組件",
  T_38_WZY_WS_BUBBLE: "泡泡",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "清空[玩家實體]背包中所有物品",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "清除地圖中的物品殘留，包括地面可拾取道具、投擲物殘留、快遞盒",
  T_38_WZY_WS_CLEARPRO: "清除單個屬性因子",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "在[玩家實體]的位置，生成一個[場景物件]實體的分身，並返回創建的[偽裝實體]",
  T_38_WZY_WS_COMPONENT: "組件",
  T_38_WZY_WS_COSTAMMO: "消耗子彈",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "創建相機並返回[相機實體]，相機的屬性可在屬性設置中更改",
  T_38_WZY_WS_CYCLES: "播放次數",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "判斷[實體]是否在圓柱體範圍內，[中心點]為圓柱體重心，[半徑]為圓半徑，[高]為圓柱的高，[旋轉角]為為繞中心點的三維旋轉歐拉角",
  T_38_WZY_WS_CYLINDERJUD_RES: "圓柱範圍判定的結果，為布爾值",
  T_38_WZY_WS_DAMSUMZOM: "對殭屍造成傷害",
  T_38_WZY_WS_DARKNESS: "黑暗",
  T_38_WZY_WS_DIFCOLOR: "表面顏色",
  T_38_WZY_WS_DIFTEXTURE: "表面圖片",
  T_38_WZY_WS_DRUMMUSIC: "組件類型：鼓組",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "斷線的玩家",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "重新連接的玩家",
  T_38_WZY_WS_EUIANCHOR: "HUD 錨點類型列舉",
  T_38_WZY_WS_FEATHER: "羽毛",
  T_38_WZY_WS_FLAMEAMMO: "火焰噴射器子彈",
  T_38_WZY_WS_FLOWER: "花朵",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "設置[實體]始終跟隨[跟隨實體]，[偏移座標]為跟隨位置和跟隨實體位置的相對座標",
  T_38_WZY_WS_FOLLOWENT: "跟隨實體",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "獲取[玩家實體]當前使用的相機實體",
  T_38_WZY_WS_GETCURCAMDESC: "玩家當前使用的相機",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "獲取[玩家]擁有的指定[物品類型]的物品數量",
  T_38_WZY_WS_GETITEMNUM_RES: "玩家擁有的指定物品的數量",
  T_38_WZY_WS_GETVEC_NAME: "獲取向量",
  T_38_WZY_WS_GETVEC_NAMEDESC: "根據座標的X、Y、Z分量獲取向量",
  T_38_WZY_WS_GETVECRES: "根據X、Y、Z分量獲取的向量",
  T_38_WZY_WS_GHOST: "鬼魂",
  T_38_WZY_WS_GRENADEFROZENNAME: "冰凍手榴彈實體",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "冰凍區域半徑",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "冰凍區域時長",
  T_38_WZY_WS_GRENADENAME: "手榴彈實體",
  T_38_WZY_WS_GRENADEPARAM1: "最小傷害",
  T_38_WZY_WS_GRENADEPARAM2: "最大傷害",
  T_38_WZY_WS_GRENADEPARAM4: "爆炸範圍",
  T_38_WZY_WS_GRENADEPARAM5: "投擲速度",
  T_38_WZY_WS_GRENADEPARAM6: "爆炸延遲時間",
  T_38_WZY_WS_GRENADEPARAM7: "對自身傷害係數",
  T_38_WZY_WS_GRENADEPARAM8: "對隊友傷害係數",
  T_38_WZY_WS_GRENADEPARAM9: "對載具傷害係數",
  T_38_WZY_WS_GUNFIRE: "槍火",
  T_38_WZY_WS_GUNPRO_PARAM2: "裝填速度",
  T_38_WZY_WS_GUNPRO_PARAM3: "擊中身體傷害比例",
  T_38_WZY_WS_GUNPRO_PARAM4: "擊中頭部傷害比例",
  T_38_WZY_WS_GUNPRO_PARAM5: "擊中四肢傷害比例",
  T_38_WZY_WS_GUNPRO_PARAM7: "額外傷害",
  T_38_WZY_WS_HELMET_NAME: "頭盔實體",
  T_38_WZY_WS_ICON1: "皇冠",
  T_38_WZY_WS_ICON2: "決鬥",
  T_38_WZY_WS_INITPOS: "初始位置",
  T_38_WZY_WS_ISRESET: "來回運動",
  T_38_WZY_WS_KILLCONZOM: "擊殺的殭屍數量",
  T_38_WZY_WS_KILLENT_NAMEDESC: "擊殺所選[實體]，實體類型需要為可戰鬥實體，無視無敵狀態",
  T_38_WZY_WS_LABELPARAM: "文本內容參數列表",
  T_38_WZY_WS_LEADMUSICA: "組件類型：鋼琴（高音）",
  T_38_WZY_WS_LEADMUSICB: "組件類型：鋼琴（中音）",
  T_38_WZY_WS_LEADMUSICC: "組件類型：鋼琴（低音）",
  T_38_WZY_WS_LINE: "線",
  T_38_WZY_WS_LIQUID: "液體",
  T_38_WZY_WS_LOCALKEY: "本地化字串",
  T_38_WZY_WS_LOCALPOS: "相對位置",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "設置[實體]始終朝向[朝向實體]，[偏移座標]為朝向位置和朝向實體位置的相對座標",
  T_38_WZY_WS_MAINWEAPONA: "主武器1",
  T_38_WZY_WS_MAINWEAPONB: "主武器2",
  T_38_WZY_WS_MOTIONTIME: "移動時長",
  T_38_WZY_WS_MOTIONTYPE: "移動方式",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "EP修改值",
  T_38_WZY_WS_MUSHROOMNAME: "蘑菇實體",
  T_38_WZY_WS_OBFACTION: "觀戰陣營",
  T_38_WZY_WS_OBGLOBAL: "觀戰全體",
  T_38_WZY_WS_OBSERVER: "觀戰設定",
  T_38_WZY_WS_OBTEAM: "觀戰隊伍",
  T_38_WZY_WS_OFFSETVEC: "偏移座標",
  T_38_WZY_WS_ONBUY_NAMEDESC: "玩家在該商店購買商品時觸發，[玩家實體]時購買商品的玩家，[商品實體]是購買的商品",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "被[玩家實體]裝備時觸發",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "玩家成功完成跳躍後觸發",
  T_38_WZY_WS_ONLIE_NAMEDESC: "玩家成功完成趴下後觸發",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "當武器裝填子彈時觸發",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "玩家成功完成衝刺後觸發",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "玩家成功完成蹲下後觸發",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "武器擊殺單位時觸發，[擊殺實體]為被擊殺的實體",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "武器對可戰鬥實體造成傷害時觸發，[傷害對象]為受到傷害的可戰鬥實體，[傷害值]為此次傷害的數值",
  T_38_WZY_WS_OWNER: "所有者",
  T_38_WZY_WS_PARAMLIST: "參數列表",
  T_38_WZY_WS_PARTICALMAP: "粒子圖",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: "暫停或恢復[玩家實體]的表情，[是否暫停]為布林值，「是」為暫停，「否」為恢復",
  T_38_WZY_WS_PLAENTTRI_DESC: "玩家進入觸發器時觸發",
  T_38_WZY_WS_PLAQUITTRI_DESC: "玩家離開觸發器時觸發",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "強制[玩家實體]使用指定[表情]，使用一次後返回原位",
  T_38_WZY_WS_PLAYSPEED: "播放速度百分比",
  T_38_WZY_WS_PREHUD_NAME: "預製圖標",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[玩家實體]退出當前所在的陣營",
  T_38_WZY_WS_RESETENT: "每回合重置組件",
  T_38_WZY_WS_RESUUID: "資源 UUID",
  T_38_WZY_WS_RIMCOLOR: "邊緣顏色",
  T_38_WZY_WS_RIMTEXTURE: "邊緣圖片",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "判斷[實體]是否在扇形柱體範圍內，[中心點]為中截面圓心，[半徑]為截面圓半徑，[截取半徑]為扇形截去的小扇形半徑，高為立體圖形的高，[角度]為扇形的角度，[方向角]為軸線的方向向量",
  T_38_WZY_WS_SECTORJUD_RES: "扇形範圍判定的結果，為布林值",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "設置[目標實體]的活動狀態，[活動狀態]為布林值，同時影響實體的可用性、可見性和可碰撞性",
  T_38_WZY_WS_SETROUNDSCORE: "設置玩家回合積分",
  T_38_WZY_WS_SHOOTANGMAX: "最大射擊角度",
  T_38_WZY_WS_SHOWMAPINFO: "同陣營顯示地圖資訊",
  T_38_WZY_WS_SHOWNAMEHUD: "同陣營顯示名稱HUD",
  T_38_WZY_WS_SOUND1: "加速裝置",
  T_38_WZY_WS_SOUND10: "階段開始",
  T_38_WZY_WS_SOUND11: "殭屍背景音樂",
  T_38_WZY_WS_SOUND12: "恐怖氛圍",
  T_38_WZY_WS_SOUND13: "變身音效",
  T_38_WZY_WS_SOUND14: "快速心跳音效",
  T_38_WZY_WS_SOUND15: "中速心跳音效",
  T_38_WZY_WS_SOUND16: "慢速心跳音效",
  T_38_WZY_WS_SOUND17: "暴走時間音效",
  T_38_WZY_WS_SOUND18: "點擊音效",
  T_38_WZY_WS_SOUND19: "技能恢復音效",
  T_38_WZY_WS_SOUND2: "消失提示音",
  T_38_WZY_WS_SOUND20: "加入遊戲音效",
  T_38_WZY_WS_SOUND3: "視覺效果",
  T_38_WZY_WS_SOUND4: "夜晚蟲鳴",
  T_38_WZY_WS_SOUND5: "打擊（沉重）",
  T_38_WZY_WS_SOUND6: "反應",
  T_38_WZY_WS_SOUND7: "發現驚喜",
  T_38_WZY_WS_SOUND8: "小鬼嬉鬧",
  T_38_WZY_WS_SOUNDENT: "音樂實體",
  T_38_WZY_WS_SPAWNPOS: "舊出生點",
  T_38_WZY_WS_SPHERENAME: "基礎球體",
  T_38_WZY_WS_SPHERERADIUS: "球體半徑",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "判斷[實體]是否在球型範圍內，[中心點]和[半徑]是球體球心和半徑",
  T_38_WZY_WS_SPHERICALJUD_RES: "球型範圍判定的結果，為布林值",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "判斷[實體]是否在立方體範圍內，[中心點]為立方體重心，[長]、[寬]、[高]為立方體的長、寬、高，[旋轉角]為繞中心點的三維旋轉歐拉角",
  T_38_WZY_WS_SQUAREJUD_RES: "立方體範圍判定的結果，為布林值",
  T_38_WZY_WS_STARTGENTIME: "開始生成時間",
  T_38_WZY_WS_STAYTIME: "停止時長",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "將[玩家]的相機切換為[相機實體]，[切換模式]可以選擇無動畫或漸進式切換，[切換事件]為漸進模式的切換時間",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "切換相機的模式，可以選擇無動畫或漸進模式",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: "漸進模式的切換時間，選擇「無動畫」時無效",
  T_38_WZY_WS_TEXTHUD: "HUD 文本組件",
  T_38_WZY_WS_TEXTTYPE: "字體大小",
  T_38_WZY_WS_TEXTUREID: "圖片類型",
  T_38_WZY_WS_TRANDIST: "傳遞距離",
  T_38_WZY_WS_TWEENERENABLED: "是否開啟 UITWeener 腳本",
  T_38_WZY_WS_TYPELIST: "類型列表",
  T_38_WZY_WS_TYPELISTORLIST: "類型或類型列表",
  T_38_WZY_WS_VEST_NAME: "防彈衣實體",
  T_38_WZY_WS_VFX1: "躲藏者被擊殺",
  T_38_WZY_WS_VFX10: "持續燃燒",
  T_38_WZY_WS_VFX11: "毒氣",
  T_38_WZY_WS_VFX13: "愛心",
  T_38_WZY_WS_VFX15: "門",
  T_38_WZY_WS_VFX2: "暴走",
  T_38_WZY_WS_VFX3: "分身死亡",
  T_38_WZY_WS_VFX4: "射擊反饋",
  T_38_WZY_WS_VFX5: "分身",
  T_38_WZY_WS_VFX6: "偽裝",
  T_38_WZY_WS_VFX7: "閃光彈煙火",
  T_38_WZY_WS_VFX8: "運動軌跡",
  T_38_WZY_WS_VFX9: "火焰彈",
  T_38_WZY_WS_VFXENT: "特效實例",
  T_38_WZY_WS_VFXTYPEA_NAME: "可更換圖像特效",
  T_38_WZY_WS_VFXTYPEB_NAME: "不可更換圖像特效",
  T_38_WZY_WS_VISIBILITY: "可見組件",
  T_38_WZY_WS_VOLUME: "音量",
  T_38_WZY_WS_WEAPONGEN: "武器生成器",
  T_38_WZY_WS_WHECYCLE: "循環",
  T_38_XXJ_WS_BLOCKMODE: "遮蔽模式",
  T_38_XXJ_WS_CUSTOMCAMARA: "自訂相機",
  T_38_XXJ_WS_FFCLASSIC: "FF 經典（射擊）",
  T_38_XXJ_WS_FOV: "視野範圍",
  T_38_XXJ_WS_FOVDESC: "視野範圍為相機的觀察角度",
  T_38_XXJ_WS_FPS: "第一人稱（射擊）",
  T_38_XXJ_WS_HORIZONTALANGLE: "水平角",
  T_38_XXJ_WS_INVISICAM: "半透明",
  T_38_XXJ_WS_OFFSET: "偏移量",
  T_38_XXJ_WS_ORTHOGRAPHIC: "正交",
  T_38_XXJ_WS_PERSPECTIVE: "透視",
  T_38_XXJ_WS_PROJECTIONMODE: "投影模式",
  T_38_XXJ_WS_STABLE: "固定",
  T_38_XXJ_WS_STARTCAMERA: "預設相機",
  T_38_XXJ_WS_STARTCAMERAMODE: "預設相機模式",
  T_38_XXJ_WS_THIRD: "追蹤相機鏡頭",
  T_38_XXJ_WS_TOPVIEW: "俯視角",
  T_38_XXJ_WS_TPS: "第三人稱",
  T_38_XXJ_WS_TRANSVERSE: "水平移動",
  T_38_XXJ_WS_VERTICALANGLE: "垂直角",
  T_38_XXJ_WS_ZOOM: "縮放",
  T_38_XYL_WS_AISTARTTIME: "開始時間(秒)",
  T_38_XYL_WS_ARMORDESTROY: "護甲傷害係數",
  T_38_XYL_WS_BONFIRE: "篝火",
  T_38_XYL_WS_CANDLE01: "蠟燭A",
  T_38_XYL_WS_CANNON01: "機械大砲",
  T_38_XYL_WS_CLIPAMMOSIZE: "彈匣容量",
  T_38_XYL_WS_DAMAGEDTRUCK: "損壞的卡車",
  T_38_XYL_WS_DOLL01: "詭異玩偶",
  T_38_XYL_WS_ENTERANCEHOUSE01: "小矮房A",
  T_38_XYL_WS_FENCE002: "鐵圍欄B",
  T_38_XYL_WS_FIREWORK01: "煙火A",
  T_38_XYL_WS_GENERATOR: "生成器",
  T_38_XYL_WS_GRAVITY: "重力加速度",
  T_38_XYL_WS_GRAVITYAREA: "重力改變區",
  T_38_XYL_WS_GRAVITYAREA_DESC: "可以改變重力的區域",
  T_38_XYL_WS_HOLDWEAPON: "持槍狀態",
  T_38_XYL_WS_INDOORFURNITURE: "室內家具",
  T_38_XYL_WS_LIGHTTUBE001: "日光燈A",
  T_38_XYL_WS_LOVEBALLOON01: "情人節氣球A",
  T_38_XYL_WS_LOVELAMP01: "情人節路燈",
  T_38_XYL_WS_LOVESIGN01: "情人節霓虹燈",
  T_38_XYL_WS_OILDRUM_DAMAGE: "油桶傷害倍率",
  T_38_XYL_WS_OUTDOORPROPS: "戶外物品",
  T_38_XYL_WS_PIPEANDBOX: "管道和貨櫃",
  T_38_XYL_WS_PLANT: "植物",
  T_38_XYL_WS_ROSE01: "玫瑰",
  T_38_XYL_WS_ROSEN: "玫瑰花束",
  T_38_XYL_WS_SMALLBUILDING: "小型建築",
  T_38_XYL_WS_SOFA002: "沙發B",
  T_38_XYL_WS_TOWNHOUSE01: "破舊的二層房屋",
  T_38_XYL_WS_TV001: "舊電視機",
  T_38_ZP_CC_EXCHANGESTATUS: "狀態",
  T_39_BQ_SKILL_NAME_VILLAIN: "腥紅爆發",
  T_39_CJ_A_BURN: "勝利光印(面飾)",
  T_39_HJ_WS_Arrow002: "箭頭 2",
  T_39_HJ_WS_LIKERATE2: "{0} 分鐘",
  T_39_HJ_WS_LIKERATE3: "{0} - {1}分鐘",
  T_39_HJ_WS_SOUND10: "腳步提示",
  T_39_HJ_WS_SOUND11: "任務成功 1",
  T_39_HJ_WS_SOUND13: "危險提示 1",
  T_39_HJ_WS_SOUND14: "危險提示 2",
  T_39_HJ_WS_SOUND15: "倒計時 3",
  T_39_HJ_WS_SOUND16: "提示音",
  T_39_HJ_WS_SOUND17: "烏鴉叫聲",
  T_39_HJ_WS_SOUND18: "傳送至錯誤區域的提示音",
  T_39_HJ_WS_SOUND19: "傳送至正確區域的提示音",
  T_39_HJ_WS_SOUND2: "倒計時 1",
  T_39_HJ_WS_SOUND20: "傳送",
  T_39_HJ_WS_SOUND21: "電擊",
  T_39_HJ_WS_SOUND23: "獲得物品",
  T_39_HJ_WS_SOUND24: "可愛電子音樂",
  T_39_HJ_WS_SOUND25: "休閒遊戲音樂",
  T_39_HJ_WS_SOUND4: "機械裝置回音",
  T_39_HJ_WS_SOUND5: "蚊子",
  T_39_HJ_WS_SOUND6: "叮叮叮 1",
  T_39_HJ_WS_SOUND7: "叮叮叮 2",
  T_39_HJ_WS_SOUND8: "機關開啟",
  T_39_HJ_WS_SOUND9: "充能 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "無限凝膠護盾",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "無限投擲物",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "特殊槍聲",
  T_39_HQ_UGC_CUSTOMRES: "自訂資源",
  T_39_M_ACCOUNTID: "玩家帳號",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "雙擊按鈕時執行",
  T_39_MF_SKILLTAG_4: "移動",
  T_39_PD_HuntingGroundSnow_MYNAME: "黑衣人",
  T_39_QL_SKILL_OTHO_DES: "擊倒敵人時，標記該敵人 [FFB300]{0}公尺[-] 內的隊友，並且降低他們的機動性 [FFB300]{1}%[-]，持續 [FFB300]{2} 秒[-]。被敵人擊倒時，降低該敵人與其隊友的機動性並標記他們。",
  T_39_QL_SKILL_WOLFRAHH_DES: "擊倒敵人後進入狂歡時刻，提升 [FFB300]{0}%[-] 射速和 [FFB300]{1}%[-] 機動性並快速衰減，持續 [FFB300]{2} 秒[-]。狂歡時刻下擊倒敵人會刷新持續時間並且獲得額外 [FFB300]{3}%[-] 射速和 [FFB300]{4}%[-] 機動性。",
  T_39_QL_SKILL_XAYNE_DES1: "使用後進入極限狀態，獲得 [FFB300]{0} 臨時 HP[-]，持續 [FFB300]{1} 秒[-]，在技能持續期間 HP 恢復效果提升 [FFB300]{2}%[-]，冷卻時間：[FFB300]{3} 秒[-]。",
  T_39_RW_GM_DEFEAT: "失敗",
  T_39_RW_SKILL_DESC_FORD: "受到傷害時，會在 [FFB300]{0} 秒[-]內每秒恢復 [FFB300]{1} HP[-]，冷卻時間：[FFB300]{2} 秒[-]。施放主動技能後，這個被動技能會立刻重置。",
  T_39_SP_WS_ITEMENTITY_01: "道具實體",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: "艾瓦諾．怒爆",
  T_39_SY_CHARACTER_VILLAIN_N: "奧利恩",
  T_39_SY_KATANA_FASTBREAKING23_N: "武士刀-野外之力",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "寵物外觀：教官阿龍",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "寵物外觀：武士蒂格",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "寵物外觀：腥紅芬里爾",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "怪獸卡車-越野王者",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "嘟嘟車-叢林狂歡",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "覺醒：手榴彈在爆炸前 [FFB300]{0} 秒[-]額外分裂出 [FFB300]{1} 個[-]手榴彈，分裂手榴彈造成原手榴彈 [FFB300]{2}%[-] 傷害。",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "分裂手榴彈",
  T_39_WT_WS_EMPTYMAP_TAG: "開闊空間",
  T_39_WT_WS_FEMAPMODE: "模式標題",
  T_39_WT_WS_FEMAPTAG: "地圖標籤",
  T_39_WT_WS_MAPPLAYER: "比賽人數",
  T_39_WT_WS_MEDENTERNUM: "匹配補人數量限制",
  T_39_WT_WS_MIDENTER: "中途補人",
  T_39_WT_WS_MIDENTERCOUNT: "累計匹配補人數量",
  T_39_WT_WS_MIDENTERTIME1: "匹配補人時間限制",
  T_39_WT_WS_MIDENTERTIME2: "匹配補人持續時長",
  T_39_WT_WS_MIDENTERTIMETIP: "對局前 N 秒開啟中途補人。當地圖人數未滿時，局外玩家可在前 N 秒內匹配進入比賽。超過 N 秒後則不再補人。",
  T_39_WT_WS_MIDENTERTIP: "是否開始中途補人，開啟後局外的匹配玩家可加入該地圖進行中的比賽",
  T_39_WT_WS_PLAYERCOUNT: "開局匹配人數",
  T_39_WT_WS_PLAYERCOUNTTIP: "開局時匹配該地圖的玩家人數，開局後可以通過中途補人地圖最大人數",
  T_39_WT_WS_TAG1: "個人死鬥",
  T_39_WT_WS_TAG10: "簡單",
  T_39_WT_WS_TAG11: "一般",
  T_39_WT_WS_TAG12: "困難",
  T_39_WT_WS_TAG13: "極限",
  T_39_WT_WS_TAG14: "逃脫",
  T_39_WT_WS_TAG16: "VIP 特權地圖",
  T_39_WT_WS_TAG17: "自訂資源",
  T_39_WT_WS_TAG18: "解謎",
  T_39_WT_WS_TAG19: "競速",
  T_39_WT_WS_TAG2: "亂槍對決",
  T_39_WT_WS_TAG20: "音樂",
  T_39_WT_WS_TAG21: "多人競技",
  T_39_WT_WS_TAG22: "冒險",
  T_39_WT_WS_TAG23: "殭屍試煉",
  T_39_WT_WS_TAG24: "PVP",
  T_39_WT_WS_TAG25: "派對遊戲",
  T_39_WT_WS_TAG26: "團隊死鬥",
  T_39_WT_WS_TAG27: "防禦守城",
  T_39_WT_WS_TAG28: "訓練",
  T_39_WT_WS_TAG3: "槍械大師",
  T_39_WT_WS_TAG4: "重生",
  T_39_WT_WS_TAG5: "狙擊",
  T_39_WT_WS_TAG6: "生存",
  T_39_WT_WS_TAG7: "單人",
  T_39_WT_WS_TAG8: "恐怖",
  T_39_WT_WS_TAG9: "休閒",
  T_39_WT_WS_TAGMAXTIP: "最多選擇 {0} 個標籤",
  T_39_WT_WS_TAGTYPE1: "玩法類型",
  T_39_WT_WS_TAGTYPE2: "地圖類型",
  T_39_WT_WS_TAGTYPE3: "模式類型",
  T_39_WT_WS_TAGTYPE4: "隊伍規模",
  T_39_WZY_WS_ACCSPEED: "加速度",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "為[實體]添加指定[腳本名稱]的腳本",
  T_39_WZY_WS_ASC: "升序",
  T_39_WZY_WS_ASCIGZERO: "升序忽略零值",
  T_39_WZY_WS_BALLISTMOVENT: "彈道運動實體",
  T_39_WZY_WS_BEUSED_NAMEDESC: "該物品被[玩家實體]使用時觸發事件",
  T_39_WZY_WS_BODYSCALE: "身體縮放",
  T_39_WZY_WS_BRAKETORQUE: "剎車馬力",
  T_39_WZY_WS_CAMTRANTYPE: "相機切換動畫類型",
  T_39_WZY_WS_CARVEHICLE: "四輪車",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "檢查[實體]是否存在指定[腳本名稱]的腳本，返回值為布林值",
  T_39_WZY_WS_CHECKSCRIPT_RES: "檢查實體是否存在指定腳本的結果，為布林值",
  T_39_WZY_WS_COMBINEALL: "任意組合雙持",
  T_39_WZY_WS_COMBINESELF: "和自身雙持",
  T_39_WZY_WS_CONENAME: "基礎圓錐",
  T_39_WZY_WS_COORSYS: "座標系",
  T_39_WZY_WS_CRASHMAXD: "最大撞擊傷害",
  T_39_WZY_WS_CRASHMIND: "最小撞擊傷害",
  T_39_WZY_WS_CRAWLSPEED: "趴下移速百分比",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "為[目標實體]創建彈道運動，可以設置目標實體的[初速度]、[加速度]、初速度方向累計的[最大距離]，並返回[彈道運動實體]",
  T_39_WZY_WS_CRETWEEN_NAME: "創建插值運動",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "為[實體]創建插值運動，在[時間]內，實體的[屬性]從[起始值]到[目標值]平滑運動，[方式]為運動的方式，包括單次、循環、往復，[曲線]為運動的曲線，並返回[插值運動實體]",
  T_39_WZY_WS_CURVE: "曲線",
  T_39_WZY_WS_CUSTRESULT: "自訂結算",
  T_39_WZY_WS_CYLINDERNAME: "基礎柱體",
  T_39_WZY_WS_DEFAULT: "無動畫（預設）",
  T_39_WZY_WS_DESC: "降序",
  T_39_WZY_WS_DIFFUSEALPHA: "表面透明度",
  T_39_WZY_WS_DISCONNECT: "斷線",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "每秒恢復能量",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "消耗能量",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "兩段跳最大跳躍高度",
  T_39_WZY_WS_ENABLEJOIN: "允許中途加入",
  T_39_WZY_WS_ENDPOS: "終點座標",
  T_39_WZY_WS_ENGINETORQUE: "引擎馬力",
  T_39_WZY_WS_EXPLODED: "爆炸傷害",
  T_39_WZY_WS_FEELDSPEED: "倒地移速百分比",
  T_39_WZY_WS_FLASH_CFLASHTIME: "中心閃光時間",
  T_39_WZY_WS_FLASH_CRANGE: "中心範圍",
  T_39_WZY_WS_FLASH_EFLASHTIME: "邊緣閃光時間",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "閃光彈命中效果開關",
  T_39_WZY_WS_FLASH_RANGE: "爆炸範圍",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "結束滑行下降速度",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "最大飛行高度",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "滑行速度",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "滑行下降速度",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "最小結束高度",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "最小起飛高度",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "超越高度上限後的下落速度",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "轉彎速度",
  T_39_WZY_WS_FOLMOVENT: "位置跟隨運動實體",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "獲取[玩家實體]的技能列表",
  T_39_WZY_WS_HB_BOOSTCD: "衝刺冷卻時間",
  T_39_WZY_WS_HB_BOOSTDURATION: "衝刺持續時間",
  T_39_WZY_WS_HB_BOOSTINITIAL: "上滑板後衝刺冷卻時間",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "上滑板後衝刺冷卻時間開關",
  T_39_WZY_WS_HB_BOOSTSPEED: "衝刺速度",
  T_39_WZY_WS_HB_HOVERBCD: "上滑板冷卻時間",
  T_39_WZY_WS_HB_JUMPCD: "跳躍冷卻時間",
  T_39_WZY_WS_HB_JUMPH: "滑板跳躍高度",
  T_39_WZY_WS_HEADSCALE: "頭骨縮放",
  T_39_WZY_WS_HEADSHOTDESCALE: "爆頭傷害減少",
  T_39_WZY_WS_INTITALSPEED: "初速度",
  T_39_WZY_WS_INVENTORYBASE: "基礎物品類型",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "每秒能量消耗",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "基礎水平速度",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "基礎垂直速度",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "每秒快跑能量消耗",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "快跑水平速度",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "衝刺距離",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "每秒衝刺能量消耗",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "衝刺垂直速度",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "每秒上升能量消耗",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "是否可被攻擊",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "是否能自身觸發",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "是否隊友能觸發",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "是否可載具觸發",
  T_39_WZY_WS_LANDMINE_LIFETIME: "持續時間",
  T_39_WZY_WS_LANDMINE_STARTTIME: "啟動時間",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "觸發半徑",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "觸發時間",
  T_39_WZY_WS_LEAVE: "主動退出",
  T_39_WZY_WS_LIMBSCALE: "四肢縮放",
  T_39_WZY_WS_LISTLOCSTR: "本地化字串列表",
  T_39_WZY_WS_LOADRESULT_NAME: "上傳結算資訊",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "上傳[玩家]的結算資訊，包括[排名]、[結果]、[積分標題]、[積分值]",
  T_39_WZY_WS_LOOKMOVENT: "注視跟隨運動實體",
  T_39_WZY_WS_MAXCOUNT: "最大數量",
  T_39_WZY_WS_MAXDISTANCE: "最大距離",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "炮塔俯角",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "炮塔角速度",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "炮塔仰角",
  T_39_WZY_WS_MINISENTRY_DAM: "炮塔傷害",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "減傷率",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "開火角度",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "炮塔命中率",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "炮塔攻擊間隔",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "最大炮塔數量",
  T_39_WZY_WS_MINISENTRY_RANGE: "炮塔攻擊範圍",
  T_39_WZY_WS_MOVEENT: "運動實體",
  T_39_WZY_WS_NOCOMBINE: "不可雙持",
  T_39_WZY_WS_ONCE: "單次",
  T_39_WZY_WS_ONDROP_NAMEDESC: "該物品被[玩家實體]丟棄時觸發事件",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "該物品被[玩家實體]裝備時觸發事件",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "鉤鎖槍射擊時觸發事件",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "地雷被啟用時觸發事件",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "地雷被[玩家實體]觸發時觸發事件",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "運動實體暫停運動時觸發",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "運動實體從暫停狀態恢復運動時觸發",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "運動實體開始運動時觸發",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "該物品被[玩家實體]拾取時觸發事件",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "投擲物擊中目標時觸發事件",
  T_39_WZY_WS_OPENATTACK: "是否啟用攻擊",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "暫停運動實體或實體列表的運動狀態",
  T_39_WZY_WS_PAUSESOUND_NAME: "暫停音效",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "暫停音樂實體或音樂實體列表",
  T_39_WZY_WS_PIANOTYPE: "音樂組件類型",
  T_39_WZY_WS_PINGPONG: "往復",
  T_39_WZY_WS_PLAYABLELIST: "運動實體列表",
  T_39_WZY_WS_PLAYINGSTATUE: "播放狀態",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "恢復暫停的運動實體或實體列表的運動狀態，可以選擇繼續播放或從頭開始播放",
  T_39_WZY_WS_PLAYSOUND_NAME: "播放音效",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "播放暫停狀態的音樂實體或實體列表，可以選擇繼續播放或從頭播放",
  T_39_WZY_WS_PROCIRCLE_NAME: "等待進度圈",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "從[起始座標]處沿[方向]發射一條射線，檢測射線在[距離]內命中的所有實體，返回[命中實體]和[命中座標列表]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "從[起始座標]處沿[方向]發射一條射線，檢測射線在[距離]內命中的第一個實體，返回[命中實體]和[命中座標]",
  T_39_WZY_WS_REAHEALHP: "耐久恢復值",
  T_39_WZY_WS_REAHEALTIME: "生效時間間隔",
  T_39_WZY_WS_RELATCOORSYS: "相對座標系",
  T_39_WZY_WS_REPAIRARM: "修復工具包",
  T_39_WZY_WS_REVERSE: "倒放",
  T_39_WZY_WS_RIMALPHA: "邊緣透明度",
  T_39_WZY_WS_SCORENAME: "積分標題",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "向目標實體發射訊號，上傳的參數通過預定義訊號參數定義，定義時選擇實體類型會生成對應的接受訊號事件",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "為[目標實體]創建位置跟隨運動，[跟隨實體]為目標實體的跟隨物件，[偏移座標]為目標點和跟隨實體的座標偏移量，[坐標系]可以選擇世界坐標系和基於跟隨實體朝向的相對座標系，創建運動後返回[位置跟隨運動實體]",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "為[目標實體]創建注視跟隨運動，[跟隨實體]為目標實體的朝向物件，[偏移座標]為實際點和跟隨實體的座標偏移量，[坐標系]可以選擇世界坐標系和基於跟隨實體朝向的相對座標系，創建運動後返回[注視跟隨運動實體]",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "掉落傷害百分比",
  T_39_WZY_WS_SHOE_MAXENERGY: "最大能量值",
  T_39_WZY_WS_SKILLLIST: "技能列表",
  T_39_WZY_WS_SKILLTYPE: "角色技能",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "煙霧特效持續時間",
  T_39_WZY_WS_SMOOTH: "相機切換",
  T_39_WZY_WS_SOUNDENTL: "音效實體列表",
  T_39_WZY_WS_SOUNDENTLORSENT: "音效實體或列表",
  T_39_WZY_WS_SPRINTSPEED: "衝刺速度百分比",
  T_39_WZY_WS_SQUATSPEED: "蹲下移速百分比",
  T_39_WZY_WS_STARTCOO: "起始座標",
  T_39_WZY_WS_STATE: "播放狀態",
  T_39_WZY_WS_TARGETVAL: "目標值",
  T_39_WZY_WS_THROWSPEED: "鉤鎖飛行速度",
  T_39_WZY_WS_TOWER_PARAM10: "旋轉角度",
  T_39_WZY_WS_TOWER_PARAM11: "防禦塔狀態",
  T_39_WZY_WS_TOWER_PARAM12: "實體 ID",
  T_39_WZY_WS_TOWER_PARAM9: "攻擊目標",
  T_39_WZY_WS_TOWSPEED: "牽引玩家速度",
  T_39_WZY_WS_TWEENCURVE_NAME: "自訂曲線",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "自訂曲線，可用於插值運動",
  T_39_WZY_WS_TWEENENT: "插值運動實體",
  T_39_WZY_WS_TWEENPLAYST_NAME: "播放方式",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "插值運動的播放方式",
  T_39_WZY_WS_TWEENSTYLE: "方式",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "為[實體]移除指定[腳本名稱]的腳本",
  T_39_WZY_WS_UPSET_NAMEDESC: "對列表中元素隨機排序",
  T_39_WZY_WS_VISIBLEONBACK: "背在身上是否顯示",
  T_39_WZY_WS_WEAPCOMBINET: "武器雙持類型",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "擊中倒地者額外傷害",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "單次子彈發射數量",
  T_39_WZY_WS_WEAREPLAY: "是否重新播放",
  T_39_WZY_WS_WORLDCOORSYS: "世界座標系",
  T_39_XXJ_WS_ADDFRIEND: "添加好友",
  T_39_XXJ_WS_ALLOWZ: "是否允許玩家X軸運動",
  T_39_XXJ_WS_BLOCKMODEDESC: "相機與跟隨目標之間有阻礙物時，相機的運動模式",
  T_39_XXJ_WS_CAMERADISTANCE: "相機距離目標的距離",
  T_39_XXJ_WS_CAMERATYPEDESC: "提供多種預設相機類型，以及自訂相機類型",
  T_39_XXJ_WS_CAMERAUSER: "正在使用該相機的玩家",
  T_39_XXJ_WS_CURENTCAMERA: "玩家正在使用的相機",
  T_39_XXJ_WS_DETAILS: "對局詳情",
  T_39_XXJ_WS_FFECONOMY: "局外經濟",
  T_39_XXJ_WS_FOCUSTARGET: "相機觀察的目標",
  T_39_XXJ_WS_FOLLOWTARGET: "相機跟隨的目標",
  T_39_XXJ_WS_GAMERESULT: "比賽結果",
  T_39_XXJ_WS_GAMETITLE1: "比賽標題1",
  T_39_XXJ_WS_GAMETITLE2: "比賽標題2",
  T_39_XXJ_WS_GIFT: "贈送",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "相機在水平方向上的旋轉角",
  T_39_XXJ_WS_INVISICAM: "透視",
  T_39_XXJ_WS_INVISICAMDESC: "相機與跟隨目標之間有阻礙物時，阻礙物會變為半透明",
  T_39_XXJ_WS_LEFTSCORE: "左邊玩家列表",
  T_39_XXJ_WS_LIKE: "按讚",
  T_39_XXJ_WS_LOBBY: "回到大廳",
  T_39_XXJ_WS_MAINSCORENAME: "總積分名",
  T_39_XXJ_WS_MAINSCORENUM: "總積分數",
  T_39_XXJ_WS_MAPEVALUATE: "地圖評價",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "多隊結算頁面",
  T_39_XXJ_WS_MVP1: "MVP標記1",
  T_39_XXJ_WS_MVP2: "MVP標記2",
  T_39_XXJ_WS_OFFSET2: "觀察點的偏移量",
  T_39_XXJ_WS_OFFSET2DESC: "一般指相機焦點相對於玩家原點位置的偏移量，不同相機類型具體含義不同",
  T_39_XXJ_WS_OFFSETDESC: "一般指相機位置相對於玩家原點位置的偏移量，不同相機類型具體含義不同",
  T_39_XXJ_WS_ORTHOGONAL: "正交",
  T_39_XXJ_WS_ORTHOGONALDESC: "相機觀察目標時，遠近物體大小一樣",
  T_39_XXJ_WS_PERSPECTIVE: "透視",
  T_39_XXJ_WS_PERSPECTIVEDESC: "相機觀察目標時，近處物體較大，遠處物體較小",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "相機的投影成像方式",
  T_39_XXJ_WS_RANK1: "隊伍排名",
  T_39_XXJ_WS_RANK2: "玩家排名",
  T_39_XXJ_WS_REPORT: "檢舉",
  T_39_XXJ_WS_REVIEW: "回放",
  T_39_XXJ_WS_RIGHTSCORE: "右邊隊伍得分",
  T_39_XXJ_WS_SCORENUM1: "積分1",
  T_39_XXJ_WS_SCORENUM2: "積分2",
  T_39_XXJ_WS_SCORENUM3: "積分3",
  T_39_XXJ_WS_SCORENUM4: "積分4",
  T_39_XXJ_WS_SCORENUM5: "積分5",
  T_39_XXJ_WS_SCORETITLELIST: "標題列表",
  T_39_XXJ_WS_SHARE: "分享",
  T_39_XXJ_WS_SPECTATORSWITCH: "觀戰開關",
  T_39_XXJ_WS_STABLE: "固定",
  T_39_XXJ_WS_STABLEDESC: "相機與跟隨目標之間有阻礙物時，相機不做任何變化",
  T_39_XXJ_WS_TEAMNAME1: "左邊隊伍名",
  T_39_XXJ_WS_TEAMNAME2: "右邊隊伍名",
  T_39_XXJ_WS_TEAMRANK: "隊伍名次",
  T_39_XXJ_WS_TRANSITIONTIME: "相機切換動畫的時間",
  T_39_XXJ_WS_TRANSITIONTYPE: "相機切換動畫的類型",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "兩隊結算頁面",
  T_39_XXJ_WS_VERTICALANGLEDESC: "相機在垂直方向上的旋轉角",
  T_39_XXJ_WS_ZOOM: "拉近",
  T_39_XXJ_WS_ZOOMDESC: "相機與跟隨目標之間有阻礙物時，相機會拉近跟隨目標",
  T_39_XYL_WS_LIGHTINTENSITY: "光照強度",
  T_39_XYL_WS_LIGHTRANGE: "光照範圍",
  T_39_XYL_WS_POINTLIGHT: "點光源",
  T_39_XYL_WS_WATERZONE: "自訂水域",
  T_40_B_DISABLE_RECONNECT: "關閉自動重連",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "榮耀羽球衣-黑(上裝)",
  T_40_CJ_T_SHUTTLECOCK_RED2: "榮耀羽球衣-紅(上裝)",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "榮耀羽球衣-紅黑(上裝)",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "榮耀羽球衣-黃(上裝)",
  T_40_CJ_T_SPORTSWEAR_FIRE: "浴火重生(上裝)",
  T_40_DYEING_CLEAR: "清楚染色狀態",
  T_40_HJ_WS_EFFECT32: "跑鞋特效",
  T_40_HJ_WS_EFFECT33: "爆炸特效",
  T_40_HJ_WS_EFFECT34: "出生點特效",
  T_40_HJ_WS_EFFECT35: "雷射特效",
  T_40_HJ_WS_EFFECT36: "武器子彈特效",
  T_40_HJ_WS_EFFECT37: "子彈命中特效",
  T_40_HJ_WS_EFFECT38: "武器開火特效",
  T_40_HJ_WS_EFFECT43: "技能特效",
  T_40_HJ_WS_EFFECT44: "技能釋放特效",
  T_40_HJ_WS_SOUND69: "打開盒子",
  T_40_HJ_WS_SOUND70: "等級提升",
  T_40_HJ_WS_SOUND71: "滿級",
  T_40_HJ_WS_SOUND72: "點擊按鈕",
  T_40_HJ_WS_SOUND73: "倒計時",
  T_40_HJ_WS_SOUND74: "哨子聲",
  T_40_HJ_WS_SOUND75: "完成",
  T_40_HJ_WS_SOUND76: "前進",
  T_40_HJ_WS_SOUND77: "勝利",
  T_40_HJ_WS_SOUND78: "檢查點",
  T_40_HJ_WS_SOUND79: "倒計時",
  T_40_HJ_WS_SOUND80: "遊戲開始",
  T_40_HJ_WS_SOUND81: "獲得大量金幣",
  T_40_HJ_WS_SOUND82: "獲得金幣",
  T_40_HJ_WS_SOUND83: "獲得少量金幣",
  T_40_HJ_WS_SOUND84: "加入戰場",
  T_40_HJ_WS_SOUND85: "打開戰隊補給箱",
  T_40_HJ_WS_SOUND86: "喇叭聲",
  T_40_HJ_WS_SOUND87: "擊殺首領",
  T_40_HJ_WS_SOUND88: "軍火箱開啟中",
  T_40_HJ_WS_SOUND89: "染色玩法中釋放元氣彈技能時的音效",
  T_40_HJ_WS_SOUND90: "子彈擊中敵人的音效",
  T_40_HJ_WS_SOUND91: "染色玩法中釋放血池技能時的音效",
  T_40_HJ_WS_SOUND92: "按鈕被禁用時，點擊該按鈕的提示音效",
  T_40_HJ_WS_SOUND93: "技能充能完成時的提示音效",
  T_40_HJ_WS_SOUND95: "釋放雷射技能時的音效",
  T_40_HJ_WS_SOUND96: "獲得道具 2",
  T_40_HJ_WS_SOUND97: "遊戲結束 2",
  T_40_HJ_WS_SOUND98: "擊殺敵人時的提示音效",
  T_40_HJ_WS_SOUNDTYPE_BMG: "背景音樂",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "遊戲局內音效",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI 控件音效",
  T_40_JH_WS_MAPTAG1: "顏色遊戲",
  T_40_JH_WS_MAPTAG10: "色彩躲貓貓",
  T_40_JH_WS_MAPTAG11: "周年慶",
  T_40_JH_WS_MAPTAG12: "角色扮演",
  T_40_JH_WS_MAPTAG13: "模擬",
  T_40_JH_WS_MAPTAG14: "非對稱戰場",
  T_40_JH_WS_MAPTAG15: "資源戰",
  T_40_JH_WS_MAPTAG16: "推車護送",
  T_40_JH_WS_MAPTAG17: "官方地圖",
  T_40_JH_WS_MAPTAG18: "迷你遊戲",
  T_40_JH_WS_MAPTAG19: "速度挑戰",
  T_40_JH_WS_MAPTAG2: "噴色遊戲",
  T_40_JH_WS_MAPTAG20: "隨機冒險",
  T_40_JH_WS_MAPTAG3: "色彩大作戰",
  T_40_JH_WS_MAPTAG4: "色彩槍戰",
  T_40_JH_WS_MAPTAG5: "彩色遊樂場",
  T_40_JH_WS_MAPTAG6: "遊樂場塗色大作戰",
  T_40_JH_WS_MAPTAG7: "色彩派對遊戲",
  T_40_JH_WS_MAPTAG8: "色彩跑酷",
  T_40_JH_WS_MAPTAG9: "蜘蛛跑酷",
  T_40_JH_WS_TAG30: "商業大亨",
  T_40_JH_WS_TAG31: "拆家大作戰",
  T_40_JH_WS_TAG32: "神秘小鎮",
  T_40_JH_WS_TAG33: "黎明殺機",
  T_40_JH_WS_TAG34: "亡命起義",
  T_40_JH_WS_TAG35: "拳頭戰",
  T_40_JH_WS_TAG36: "舊工廠屋頂",
  T_40_JH_WS_UGCTOKENNAME: "我的戰場代幣",
  T_40_L_QUICKMESSAGE_MODE2: "團隊突襲",
  T_40_M_WS_HIS: "的",
  T_40_SP_WS_DYEING: "染色",
  T_40_SP_WS_DYEING_AREA: "區域染色",
  T_40_SP_WS_DYEING_COLOR: "顏色序號",
  T_40_SP_WS_DYEING_COUNT: "染色統計",
  T_40_SP_WS_DYEING_DIR: "射線方向",
  T_40_SP_WS_DYEING_DIS: "射線長度",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "固定染色範圍",
  T_40_SP_WS_DYEING_NORMAL: "法線",
  T_40_SP_WS_DYEING_PLANE: "平面範圍染色",
  T_40_SP_WS_DYEING_POSITION: "座標",
  T_40_SP_WS_DYEING_RANDOMDECAY: "隨機染色機率衰減",
  T_40_SP_WS_DYEING_RANDOMRATIO: "隨機染色機率",
  T_40_SP_WS_DYEING_RANGE: "染色範圍",
  T_40_SP_WS_DYEING_STATE: "染色狀態",
  T_40_SP_WS_FACTIONTIPS_11: "紫色",
  T_40_SP_WS_SHOE_CURENERGY: "當前能量",
  T_40_SW_SKILL_Name_Nanoscientist: "奈米護盾",
  T_40_SY_AK47_PENGUIN_W_N: "AK47-瓦哥宇宙",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok．Booyah 天王",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "索妮雅",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS-瓦哥宇宙",
  T_40_SY_M1014_PENGUIN_W_N: "M1014-瓦哥宇宙",
  T_40_SY_M24_PENGUIN_W_N: "M24-瓦哥宇宙",
  T_40_SY_MINI_PENGUIN_W_N: "AC80-瓦哥宇宙",
  T_40_SY_PET_PUG_N: "巴哥",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: "寵物外觀：蜘蛛莫尼",
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "寵物外觀：雷霆阿龍",
  T_40_SY_PETSKIN_PUG_BLACK_N: "寵物外觀：終結者巴哥",
  T_40_SY_PETSKIN_PUG_GREEN_N: "寵物外觀：度假巴哥",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "寵物外觀：豹紋巴哥",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR-瓦哥宇宙",
  T_40_SY_THOMPSON_PENGUIN_W_N: "湯普森衝鋒槍-瓦哥宇宙",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP-瓦哥宇宙",
  T_40_SY_USP45_PENGUIN_W_N: "USP-瓦哥宇宙",
  T_40_SY_UZI_PENGUIN_W_N: "烏茲手槍-瓦哥宇宙",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "啟用文本內容",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "佔位文本內容",
  T_40_W_DJMALE_AWAKENING_D: "覺醒：光環持續期間，每隔 [FFB300]{0} 秒[-]會在使用者身後 [FFB300]{1} 公尺[-]掉落持續 [FFB300]{2} 秒[-]的音符，拾取音符的隊友獲得等同光環的效果。",
  T_40_W_DJMALE_AWAKENING_N: "派對嗨歌",
  T_40_W_NURSE_D: "將自身單體 [FFB300]{0}%[-] 的治療量（技能、急救包、治療槍等）擴散給範圍內 [FFB300]{1} 公尺[-]內的隊友",
  T_40_WH_MP_BOXING_NAME: "拳擊擂台賽",
  T_40_WH_MP_C_PACK: "贓物背包",
  T_40_WH_MP_EXCH_COIN: "現金",
  T_40_WH_MP_EXCH_TEMPCOIN: "赃款",
  T_40_WH_MP_PAYCHECK: "薪資",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "救起隊友的速度提升 [FFB300]{0}%[-]，冷卻時間：[FFB300]{3} 秒[-]，救起的隊友 [FFB300]{1} 秒[-]內恢復 [FFB300]{2} HP[-]。",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "創造半徑[FFB300] {0} 公尺[-]的區域，持續 [FFB300]{2} 秒[-]，區域內我方人員每秒恢復[FFB300] {1} HP[-]，且會自動救助倒地隊友，救助隊友效果受到其他技能加成，冷卻時間：[FFB300]{3} 秒[-]。",
  T_40_WT_WS_ICONENTITY_PARAM6: "顯示方式",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "膠囊體",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "高",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "半徑",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "球體",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "顏色",
  T_40_WZY_WS_ICONENTITY_FILLED: "漸進",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "圖片資源",
  T_40_WZY_WS_ICONENTITY_NAME: "圖標物件",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "顯示方式",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "簡單",
  T_40_WZY_WS_ICONENTITY_SLICED: "九宮格",
  T_40_WZY_WS_ICONENTITY_TILED: "平舖",
  T_40_WZY_WS_NEWMAPTAG: "新地圖圖標",
  T_40_WZY_WS_NEWVFX1: "光環",
  T_40_WZY_WS_NEWVFX10: "符咒",
  T_40_WZY_WS_NEWVFX11: "冰凍區域",
  T_40_WZY_WS_NEWVFX12: "冷氣",
  T_40_WZY_WS_NEWVFX13: "雪花",
  T_40_WZY_WS_NEWVFX14: "火焰",
  T_40_WZY_WS_NEWVFX15: "光束",
  T_40_WZY_WS_NEWVFX16: "毒氣擴散",
  T_40_WZY_WS_NEWVFX17: "毒氣",
  T_40_WZY_WS_NEWVFX18: "爆炸火光",
  T_40_WZY_WS_NEWVFX19: "光效",
  T_40_WZY_WS_NEWVFX2: "氣泡",
  T_40_WZY_WS_NEWVFX20: "星星",
  T_40_WZY_WS_NEWVFX3: "煙塵",
  T_40_WZY_WS_NEWVFX4: "石子飛濺",
  T_40_WZY_WS_NEWVFX5: "線條",
  T_40_WZY_WS_NEWVFX6: "閃爍",
  T_40_WZY_WS_NEWVFX7: "圓環",
  T_40_WZY_WS_NEWVFX8: "上升粒子",
  T_40_WZY_WS_NEWVFX9: "煙霧",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "字體大小",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "字體樣式",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "字體",
  T_40_WZY_WS_TEXTENTITY_NAME: "文本物件",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "互動按鈕 HUD 組件",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: "在場景中是否可用。唯讀，取決於 ActiveParent 以及 ActiveSelf",
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "所有父節點是否都可用，唯讀，對玩家不可見",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "父節用可用與否",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "開啟狀態為 True 時顯示，反之關閉",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: "自身是否可用。在場景中必須使用 ActiveInHierarchy 。唯讀，通過API設置",
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "設置相機遮罩對某層是否可見",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "在某處生成 token",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "給予玩家可拾取物品",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "玩家當前的朝向",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "朝向",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI 攻擊實體中",
  T_40_XXJ_WS_AITARGET_DESCKEY: "攻擊的 AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "對齊方式",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "水平對齊",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "垂直對齊",
  T_40_XXJ_WS_ALPHA_DESCKEY: "透明度",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "剩餘子彈數",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "當前餘彈量",
  T_40_XXJ_WS_ANCHORMAX: "最大錨點",
  T_40_XXJ_WS_ANCHORMIN: "最小錨點",
  T_40_XXJ_WS_APOSITION_DESCKEY: "玩家當前位置",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "位置",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "護甲 HUD 開關",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "設置資產 ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "資產 ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "攻擊目標",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "攻擊投擲物 HUD 開關",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "被 AI 攻擊的實體",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "AI 攻擊的目標",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "當前可分配的出生點位置座標",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "可用點座標",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "背景",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "背景",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "背包 HUD 開關",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "背景透明度",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "背景顏色",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "背景顏色",
  T_40_XXJ_WS_BGFILL_DESCKEY: "是否填充背景",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "背景填充",
  T_40_XXJ_WS_BGNAME_DESCKEY: "背景名稱",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "背景名稱",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "背景尺寸增量",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "背景尺寸增量",
  T_40_XXJ_WS_BLUE: "藍",
  T_40_XXJ_WS_BODY_DESCKEY: "軀幹",
  T_40_XXJ_WS_BODY_NAMEKEY: "軀幹",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "骨骼縮放",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "玩家出生點",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "出生點",
  T_40_XXJ_WS_BOTH: "男女皆可",
  T_40_XXJ_WS_BUTTONNAME: "按鈕組件名稱",
  T_40_XXJ_WS_CAMERA_DESCKEY: "相機",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "用戶端相機朝向",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "用戶端相機位置",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "刪除用戶端相機射線",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "相機射線檢測",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "剛好合適視口時停止拖動",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "剛好合適視口時停止拖動",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "膠囊體兩端半球球心之間的距離，不能小於球體的兩倍半徑",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "單元格尺寸",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "單元格高度",
  T_40_XXJ_WS_CELLVALUE: "讀取表內某一單元格的內容，返回一個物件",
  T_40_XXJ_WS_CENTER_DESCKEY: "小地圖中心對應的世界座標，預設為 0",
  T_40_XXJ_WS_CENTER_NAMEKEY: "小地圖中心",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "按鈕位置的偏移",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "位置偏移",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "重心座標，相對於本地座標系",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "重心",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "是否顯示中線",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "是否顯示中線",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "中線位置[0, 1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "中線位置",
  T_40_XXJ_WS_CHASERANGE: "追擊範圍",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "被 AI 追擊的對象",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "AI 追擊的目標",
  T_40_XXJ_WS_CHILD_DESCKEY: "子節點實體",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "父節點的子節點",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "相機射線擊中位置",
  T_40_XXJ_WS_CHOOSECARHUD: "選擇卡片 HUD 實體",
  T_40_XXJ_WS_CLAMP_DESCKEY: "如果參數位於最小數值和最大數值之間的數值範圍內，則該函數將返回參數值；如果參數大於範圍，該函數將返回最大數值；如果參數小於範圍，該函數將返回最小數值",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "僅支援具有 Transform 組件的實體，目前限制為所有物件",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "點擊區域大小",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "點擊區域",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "裁剪類型",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "裁切類型",
  T_40_XXJ_WS_CLONEENT_D: "複製所選實體及其屬性，保持原父節點。如果選擇的是關卡物件則基於建立關卡物件",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "服裝列表",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "服裝 ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "服裝 ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "服裝 ID",
  T_40_XXJ_WS_COL_DESC: "要讀取的列",
  T_40_XXJ_WS_COLNAME_DESC: "要讀取的列名",
  T_40_XXJ_WS_COLOR_DESCKEY: "顏色",
  T_40_XXJ_WS_COLOR_NAMEKEY: "顏色",
  T_40_XXJ_WS_COLOR1_DESCKEY: "疊加顏色，RGBA四通道，單通道取值範圍 0 ~ 255，存儲在一個 Int32 中，默認為白色(255, 255, 255, 255)",
  T_40_XXJ_WS_COLOR2_DESCKEY: "進度條顏色",
  T_40_XXJ_WS_COLOR3_DESCKEY: "描述 RGBA 顏色的類型，每個通道取值範圍 0 ~ 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "文本顏色",
  T_40_XXJ_WS_COLOR5_DESCKEY: "HUD 顏色",
  T_40_XXJ_WS_COLOR6_DESCKEY: "光照顏色",
  T_40_XXJ_WS_COLORA_DESCKEY: "顏色 A 值",
  T_40_XXJ_WS_COLORB_DESCKEY: "顏色 B 值",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "進度條顏色",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "染色桶",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "染色桶",
  T_40_XXJ_WS_COLORG_DESCKEY: "顏色 G 值",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "取得顏色(RGBA)值通道",
  T_40_XXJ_WS_COLORGUN: "彩虹噴漆槍",
  T_40_XXJ_WS_COLORGUN_01: "彩虹噴漆槍（紅）",
  T_40_XXJ_WS_COLORGUN_02: "彩虹噴漆槍（黃）",
  T_40_XXJ_WS_COLORGUN_03: "彩虹噴漆槍（藍）",
  T_40_XXJ_WS_COLORGUN_04: "彩虹噴漆槍（綠）",
  T_40_XXJ_WS_COLORGUN_05: "彩虹噴漆槍（紫）",
  T_40_XXJ_WS_COLORR_DESCKEY: "顏色 R 值",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "文字顏色",
  T_40_XXJ_WS_COLVALUE: "表某一列的內容",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "通用 HUD 開關的 HUD 實體",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "通用 HUD 開關的 HUD 實體",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "限制",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "限制",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "限制數量",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "限制數量",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "原始內容",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "初始方向",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "滾動起點，默認為左上角",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "為某個物件在地圖上生成像素圖，生成像素為靜態，不會跟隨物件移動",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "建立小地圖圖標",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "定義一個時間戳本地化字串",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "在指定自訂 HUD 與父控件下建立自訂 UI 控件",
  T_40_XXJ_WS_CREEP_NAMEKEY: "爬行 HUD 開關",
  T_40_XXJ_WS_CROUCH_DESCKEY: "True 時則顯示，否則關閉",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "蹲下 HUD 開關",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "相機的渲染層遮罩，可透過可見性層級篩選相機的渲染對象",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "相機遮罩",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "上裝 ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "上裝",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "臉彩 ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "鞋 ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "鞋子",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "頭飾 ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "頭飾",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "臉飾 ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "面飾",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "下裝 ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "下裝",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "臉彩",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "套裝 ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "套裝",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "XY 方向拖動分量",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY 拖動",
  T_40_XXJ_WS_DB: "讀取數據庫表值",
  T_40_XXJ_WS_DB_DESC: "讀取資料庫某個表中某個標識符對應的值",
  T_40_XXJ_WS_DBDELETE_DESC: "刪除數據庫某個表中某個標識符對應的值",
  T_40_XXJ_WS_DBKEY_DESCKEY: "用於標識資料的自訂名稱",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "標識符",
  T_40_XXJ_WS_DBTABLENAME: "數據庫表名",
  T_40_XXJ_WS_DBTABLENAME_DESC: "數據庫中表名",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "寫入的值",
  T_40_XXJ_WS_DBWRITE: "寫入數據庫表值",
  T_40_XXJ_WS_DBWRITE_DESC: "寫入數據庫某個表中某個標識符對應的值",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "防禦投擲物 HUD 開關",
  T_40_XXJ_WS_DEFULT: "預設",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "刪除資料庫某個排行榜表中某個 Key 對應的值",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "刪除數據庫排行榜表中某個名次對應的值",
  T_40_XXJ_WS_DEPTH: "HUD 層級",
  T_40_XXJ_WS_DEPTH_D: "HUD 的基礎層級",
  T_40_XXJ_WS_DICTANDLIST: "列表和字典",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "目標字典的值",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "表面透明度",
  T_40_XXJ_WS_DIR_DESCKEY: "向量",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "提供的點，可用於復活點等用途",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "點座標",
  T_40_XXJ_WS_DISABLEALL: "取消全選",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "禁用顏色",
  T_40_XXJ_WS_DISTANT_DESCKEY: "相機射線檢測的距離",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "投射距離",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "支援多種拖動效果",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "拖動效果",
  T_40_XXJ_WS_DRIVER_DESCKEY: "載具駕駛者",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "駕駛者",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "修改一個值",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "顯示特效",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "顯示特效",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "特效顏色",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "特效實體表示一個顯示的特效",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "特效物件",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "表情 HUD 開關",
  T_40_XXJ_WS_ENABLEALL: "全選",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "是否開啟邏輯更新，關閉時，該實體上的圖元會停止每幀更新",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "寫入槍械塗裝對武器的屬性時，武器的基本數值會受塗裝影響",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "寫入槍械塗裝屬性",
  T_40_XXJ_WS_ENTITY_DESCKEY: "實體是所有組件的載體，組件必須附加到實體上才能啟用",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "實體類",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "實體基礎組件，所有組件都會組合該組件",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "玩家變成的實體",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "代碼中是用來表示新增自訂 UI 控件實體的參數名稱，其對應的局部變量值是新增自訂 UI 控件的實體",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "實體變量名稱",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "代碼中是用來表示建立圖示實體的參數名稱，其對應的局部變量值是建立圖示的實體",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP 條 HUD 開關",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "旋轉歐拉角",
  T_40_XXJ_WS_FACINFECTION: "陣營（啟示錄）",
  T_40_XXJ_WS_FACINFECTION_DESC: "玩家的陣營，1 為人類，2 為哨兵",
  T_40_XXJ_WS_FEMALE: "女",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "填充方向",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "排列方向",
  T_40_XXJ_WS_FIRE_NAMEKEY: "開火 HUD 開關",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "浮點值",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "跟隨的目標實體，預設為空",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "字體大小",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "字體大小",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "字體風格",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "足球凝膠護盾",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "格式化樣式",
  T_40_XXJ_WS_FORWARD_DESCKEY: "玩家的朝向",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "要傳送的朝向",
  T_40_XXJ_WS_FREE_DESCKEY: "由玩家控制，自由移動的相機",
  T_40_XXJ_WS_FREE_NAMEKEY: "自由相機",
  T_40_XXJ_WS_GENDER: "性別",
  T_40_XXJ_WS_GENDER_DESCKEY: "性別",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "性別枚舉",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "獲取相機遮罩",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "僅支援具有 Transform 組件的實體，目前限制為所有物件",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "僅支援具有 Transform 組件的實體，目前限制為所有物件",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "僅支援具有 Transform 組件的實體，目前限制為所有物件",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "獲取玩家服裝 ID",
  T_40_XXJ_WS_GETPLAYERRANK: "獲取玩家排名",
  T_40_XXJ_WS_GETPLAYERRANK_D: "獲取玩家遊戲總排名",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "獲取玩家回合排名",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "獲取玩家指定回合排名",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "查找玩家 token 數據",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "獲取玩家槍械塗裝",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "獲取當前可用沒有完全占滿的隨機出生點內可用座標",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "獲取場景的天空盒",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "獲取伺服器區域",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "獲取伺服器時間戳",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "獲取隊友附近位置，會避開無法站立玩家的位置",
  T_40_XXJ_WS_GETTEAMRANK: "獲取隊伍排名",
  T_40_XXJ_WS_GETTEAMRANK_D: "獲取隊伍遊戲總排名",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "獲取隊伍回合排名",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "獲取隊伍指定回合排名",
  T_40_XXJ_WS_GREEN: "綠",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "盒型三條邊尺寸的一半",
  T_40_XXJ_WS_HEAD_DESCKEY: "頭部",
  T_40_XXJ_WS_HEAD_NAMEKEY: "頭部",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "螢幕心跳特效實體",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "螢幕心跳特效實體",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "高度",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "提示按鈕",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "提示按鈕",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "目標點顯示的實體",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "目標點顯示的實體",
  T_40_XXJ_WS_HITPOS_DESCKEY: "命中點",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "水平顯示類型",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "水平顯示類型",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "跟隨另一個實體的實體",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "注視其他實體的實體",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "血條 HUD 開關",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "HUD 輸入實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "空 HUD 面板組件",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "所屬 HUD 實體",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "HUD 輸入實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "網格實體組件",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "HUD 輸入實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "面板實體組件",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "HUD 輸入實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD 滾動視圖組件",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "人體模型 ID",
  T_40_XXJ_WS_ICON_DESCKEY: "圖標資源名",
  T_40_XXJ_WS_ICON_NAMEKEY: "圖標",
  T_40_XXJ_WS_ICON1_DESCKEY: "選擇圖標",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "圖標實體表示一個顯示的圖標",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "資源路徑，內置資源 in:path，自訂資源 out:path、預設為空",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "圖標名稱",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "圖標名稱",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "資源路徑，預設為空",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "是否可以掃描出觸發器",
  T_40_XXJ_WS_INDEX_DESCKEY: "子節點在父節點下的索引",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "初始值 [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "整數值",
  T_40_XXJ_WS_IS3D: "3D 音效",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "總是面向相機",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "粗體",
  T_40_XXJ_WS_ISBYORDER_D: "檢測玩家是否按順序觸發關卡物件",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "是否為 FirEditor 按鈕",
  T_40_XXJ_WS_ISHIT_DESCKEY: "相機射線是否擊中實體",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "是否對某層可見",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "斜體",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "是否被掃描標記",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "是否被掃描標記",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "是否被標記按鈕標記",
  T_40_XXJ_WS_ISTRIGGER: "是否觸發",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "底線",
  T_40_XXJ_WS_ITEMID_DESCKEY: "實體對應的物品 ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "物品 ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "物品 ID (當前版本只支援武器 ID)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "武器對應的物品 ID",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "物品 ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "都會區",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "都會區",
  T_40_XXJ_WS_JUMP_NAMEKEY: "跳躍 HUD 開關",
  T_40_XXJ_WS_KEY_DESCKEY: "鍵值",
  T_40_XXJ_WS_KEY_NAMEKEY: "鍵",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "編歷到 key 的名稱，可用於獲取局部變量中的 key 值",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "擊殺提示 HUD 開關",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "文本顏色",
  T_40_XXJ_WS_LANDMINEOBJ: "建立地雷後的實體",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "碰撞層級蒙版，未選擇的層級將不參與掃描，留空表示所有層級都參與掃描",
  T_40_XXJ_WS_LAYERSEDIT: "編輯圖層",
  T_40_XXJ_WS_LAYERSETTING: "可見性層級設置",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "相機射線檢測的碰撞層遮罩",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "碰撞層遮罩",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "佈局類型",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "佈局類型",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "計分板 HUD 組件",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "打開計分板按鈕 HUD 實體，修改實體屬性會影響 UI 上的顯示內容",
  T_40_XXJ_WS_LEADERBOARDNAME: "排行榜表名",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "數據庫中排行榜表名",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "離開擺蕩的加速度",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "離開擺盪的加速度",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "左臂",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "左臂",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "左邊顏色",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "左側顏色",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "是否顯示左側特效",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "是否顯示左側特效",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "左腳",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "左腳",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "左手",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "左手",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "左側圖標",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "左側圖標",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "左腿",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "左腿",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "左側分數文本",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "左側分數文本",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "左側文本",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "左側文本",
  T_40_XXJ_WS_LERP_DESCKEY: "t 是介於 0 到 1 之間。當 t = 0 時，返回 from。當 t = 1 時，返回 to。當 t = 0.5 時返回 from 和  to 之間的平均數",
  T_40_XXJ_WS_LEVELOBJECT: "關卡物件",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "行距",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "比較列表中的值，返回其中最大的那個",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "比較列表中的值，返回其中最小的值",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "列表或字典",
  T_40_XXJ_WS_LOCALPOSITION: "局部位置",
  T_40_XXJ_WS_LOCALROTA: "局部歐拉角",
  T_40_XXJ_WS_LOCALROTATIONQ: "局部四元數旋轉",
  T_40_XXJ_WS_LOCALSACLE: "局部縮放",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "本地化切換",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "要編歷的容器",
  T_40_XXJ_WS_MALE: "男",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "清除字典",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "獲得字典長度",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "獲取字典元素中指定鍵的值",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "移除字典指定鍵值對",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "設置子彈中指定鍵的值",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "小地圖尺寸，長寬相等",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "地圖大小",
  T_40_XXJ_WS_MAPT: "字典模板",
  T_40_XXJ_WS_MAPT_D: "字典數據模板，可透過 T1、T2 指定內容類型",
  T_40_XXJ_WS_MAPVALUE_D: "字典數據容器，數據元素是由一個 key 與一個值組成的一對",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "目標字典",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "字典值",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "遮罩類型是遮罩時使用的遮罩名稱",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "遮罩名稱",
  T_40_XXJ_WS_MASS_DESCKEY: "質量(kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "質量(kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "比較2個數的值，返回其中最大的那個",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "最大長度",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "最大值",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "當前最大控件 ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "最大控件 ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "醫療道具 HUD 開關",
  T_40_XXJ_WS_MIN_DESCKEY: "比較 2 個值，返回其中較小的值",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "小地圖組件",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "小地圖像素",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "小地圖圖標",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "小地圖 HUD 開關",
  T_40_XXJ_WS_MINNUM_DESCKEY: "最小值",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "慣性係數，值越大滾動時的慣性越大",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "慣性係數",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "移動搖桿 HUD 開關",
  T_40_XXJ_WS_MRESULT_DESCKEY: "比賽結果",
  T_40_XXJ_WS_NEWENTITY_D: "建立後的新物品實體（可能為空）",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "建立新字典",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "建立新字典",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "命中法線",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD 位置[0, 1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD 位置",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "將元素轉換為數字的列表",
  T_40_XXJ_WS_OBJECT_DESCKEY: "噴漆槍命中的物件",
  T_40_XXJ_WS_OBSOLETE: "已遭刪除，為保險起見請替換該圖元",
  T_40_XXJ_WS_OFFSET_DESCKEY: "顯示位置，有跟隨目標時是相對目標原點的偏移，沒有跟隨目標時是螢幕座標，預設為Vector3(0)",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "螢幕座標，預設為Vector3(0)",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "顯示位置，有跟隨目標時是相對目標原點的偏移，沒有跟隨目標時是螢幕座標，預設為Vector3(0)",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "顯示位置（錨點在右上角）",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "水平偏移",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "水平方向偏移量",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "垂直偏移",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "垂直方向偏移量",
  T_40_XXJ_WS_OK_DESCKEY: "轉換成功",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "實體進入攻擊範圍時觸發該事件",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "實體進入追擊範圍時觸發事件",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "實體離開攻擊範圍時觸發該事件",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "實體離開追擊範圍時觸發該事件",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "通過用戶端點擊事件觸發相機射線檢測",
  T_40_XXJ_WS_ONCOLLISION_D: "僅具有 Collider 組件的實體支援該事件",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "噴漆槍命中實體時觸發該事件",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "停止開火時",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "玩家切換場景區域時",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "開啟狀態為 True 時顯示，反之關閉",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "開啟狀態",
  T_40_XXJ_WS_ORANGE: "橘",
  T_40_XXJ_WS_ORDER_DESC: "排行榜中的名次",
  T_40_XXJ_WS_ORDER1: "起始名次",
  T_40_XXJ_WS_ORDER2: "結束名次",
  T_40_XXJ_WS_ORIGINAL: "保持原有邏輯",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "溢位方式",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "玩家配置優先時，玩家身上的槍械塗裝配置會覆蓋武器本身的塗裝屬性",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "優先玩家武器塗裝",
  T_40_XXJ_WS_OWNER_DESCKEY: "擁有該實體的玩家",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "所屬的子場景 GUID",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "所屬子場景的 GUID",
  T_40_XXJ_WS_PARENT_DESCKEY: "父節點實體",
  T_40_XXJ_WS_PARENT_NAMEKEY: "父節點",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "父節點組件實體 ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "父節點控件檔案 ID",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "載具上所有乘客",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "乘客",
  T_40_XXJ_WS_PHYSICALLAYER: "物理層",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "物理層矩陣",
  T_40_XXJ_WS_PHYSICALTIP1: "名稱已存在",
  T_40_XXJ_WS_PHYSICALTIP2: "刪除某層級名，在實體層級矩陣、層級枚舉中不可見該層級，但該層級中的實體物件不會改變",
  T_40_XXJ_WS_PHYSICS: "物理",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "拾取列表 HUD 開關",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "可播放實體",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "正面始終朝向另一實體的實體",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "一實體跟隨另一實體",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "彈道動畫是彈道運動的模擬動畫",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "接收訊息的玩家",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "玩家使用的頭像",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "玩家裝備的服裝",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "玩家服裝",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "玩家 HUD 類型",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "玩家介面類型",
  T_40_XXJ_WS_PLAYERIDINFAC: "玩家陣營中的序號",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "要記錄到日誌的玩家",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "消耗某玩家 token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "玩家技能列表",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "玩家狀態類型：存活、擊倒、死亡",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "播放速度",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "播放速度",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "例如，1.25 表示正常速度的 1.25 倍",
  T_40_XXJ_WS_POS_DESCKEY: "傳送到的座標",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "特效貼圖類型",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "按下顏色時",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "實現對一個容器的遍歷，獲取到每一對鍵值對，含有子過程，循環體就是子過程",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "字典循環訪問",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "進度[0, 1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "進度[0, 1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "技能進度按鈕",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "進度技能按鈕",
  T_40_XXJ_WS_QUATERNION: "四元數旋轉",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "快速訊息 HUD 開關",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "隊伍列表旁訊息  HUD 開關",
  T_40_XXJ_WS_RADIUS_DESCKEY: "膠囊體兩端半球的半徑",
  T_40_XXJ_WS_READCELL: "讀取表中某一單元格的內容",
  T_40_XXJ_WS_READCSV: "讀取表內容",
  T_40_XXJ_WS_READCSV_DESC: "讀取整張表的內容，返回二維數組",
  T_40_XXJ_WS_READCSVCELL: "通過行數和列名讀取表某一儲存格的內容",
  T_40_XXJ_WS_READCSVCOL_DESC: "讀取整張表某一列的內容，返回一個數組",
  T_40_XXJ_WS_READCSVROW_DESC: "讀取整張表某一行的內容，返回一個數組",
  T_40_XXJ_WS_READLEADERBOARD: "讀取數據庫中排行榜表值",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "讀取資料庫中個排行榜表中某個標識符對應的值",
  T_40_XXJ_WS_READLEADERBOARD2: "根據名次區間讀取數據庫中排行榜表值",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "讀取數據庫排行榜表中從某名次到某名次之間的值",
  T_40_XXJ_WS_RED: "紅",
  T_40_XXJ_WS_RELOAD: "換彈",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "顯示方式",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "恢復玩家預設服裝",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "恢復玩家預設槍械塗裝",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "拖動是否限制在視口內，預設限制",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "限制拖動與否",
  T_40_XXJ_WS_RESULT_DESCKEY: "讀取的結果",
  T_40_XXJ_WS_RESULT_NAMEKEY: "結果",
  T_40_XXJ_WS_RESULT1_DESCKEY: "是否在列表中找到最大數字",
  T_40_XXJ_WS_RESULT2_DESCKEY: "是否在列表中找到最小數字",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "在列表中找到最小數字",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "查找列表中最大的數字",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "玩家復活點，沒過沒有檢查點紀錄則使用出生點，否則使用檢查點",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "復活點",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "右臂",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "右臂",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "右邊顏色",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "右側顏色",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "是否顯示右側特效",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "是否顯示右側特效",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "右腳",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "右腳",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "右手",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "右手",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "右側圖標",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "右側圖標",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "右腿",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "右腿",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "右側分數文本",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "右側分數文本",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "右側文本",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "右側文本",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "鋼体類型組件",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "剛體組件",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "剛體類型枚舉",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "剛體類型枚舉",
  T_40_XXJ_WS_ROW_DECS: "要讀取的行數",
  T_40_XXJ_WS_ROWVALUE: "表某一行的內容",
  T_40_XXJ_WS_SCALE_DESCKEY: "設置物件縮放值",
  T_40_XXJ_WS_SCALE_NAMEKEY: "縮放值",
  T_40_XXJ_WS_SCALE0_DESCKEY: "世界座標系中縮放尺寸",
  T_40_XXJ_WS_SCALE1_DESCKEY: "縮放大小，預設為 1",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "縮放值",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "區域名字",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "比分條",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "比分條",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "支援多種滾動方向",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "滾動方向",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "滾動係數，值越大滾動越快",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "滾動係數",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "設置相機遮罩",
  T_40_XXJ_WS_SETGLOBAL: "設置全局實體",
  T_40_XXJ_WS_SETPARENT_D: "僅支援具有 Transform 組件的實體",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "設置玩家服裝 ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "批量修改玩家服裝",
  T_40_XXJ_WS_SETPLAYERFORWAR: "設置玩家位置",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "設置玩家 HUD 開關",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "設置玩家槍械塗裝",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "是否在目標點顯示實體",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "在目標點顯示實體",
  T_40_XXJ_WS_SHOWPLAYER: "顯示實體",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "單人比賽詳情 HUD 實體",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "單人比賽 HUD 實體，修改實體屬性會影響對應 UI 上的顯示內容",
  T_40_XXJ_WS_SIZEDELTA: "錨框與組件的尺寸增量",
  T_40_XXJ_WS_SKELETON: "骨骼",
  T_40_XXJ_WS_SKELETON_D: "用於訪問骨骼遮罩的節點",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "骨骼部分",
  T_40_XXJ_WS_SKILLBUTTONHUD: "技能按鈕 HUD 實體",
  T_40_XXJ_WS_SLOT_DESCKEY: "武器欄位",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "勾選時，拖動開始時速度會短暫變慢，不勾選時，開始拖動就是滑鼠移動的速度",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "平滑運動與否",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "柔和",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "柔和",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "音效實體",
  T_40_XXJ_WS_SPACE_DESCKEY: "間距",
  T_40_XXJ_WS_SPACE_NAMEKEY: "子單元格間距",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "AI 出生點座標",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "出生點座標",
  T_40_XXJ_WS_SPEED_DESCKEY: "速度",
  T_40_XXJ_WS_SPEED_NAMEKEY: "機動性",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "衝刺 HUD 開關",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "球型半徑",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "噴漆顏色",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "噴漆顏色",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "噴漆結果",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "噴漆結算",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "噴漆槍（步槍）",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "噴漆槍（步槍）",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "初始速度",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "翻轉貼紙",
  T_40_XXJ_WS_SPRITEID: "精靈圖集 ID",
  T_40_XXJ_WS_SPRITEID_D: "用於描述精靈圖集的 ID",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "貼紙類型",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "生成靜態像素的目標實體",
  T_40_XXJ_WS_STARTPOSITION_D: "形狀幾何中心的世界坐標",
  T_40_XXJ_WS_STAY_D: "是否保留子節點當前世界位置、旋轉和縮放，一般為true，UI 設置對該項無效",
  T_40_XXJ_WS_STRING_NAMEKEY: "字串",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "字串轉浮點值",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "字串轉整數",
  T_40_XXJ_WS_STYLE_DESCKEY: "插值運動播放的方式，可選單次、迴圈、往復",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "切換玩家區域",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "開關值",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "根據欄位切換玩家武器",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "切換物品欄位",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "物品切換",
  T_40_XXJ_WS_TABLENAME_DESC: "顯示表名，實際上是UUID",
  T_40_XXJ_WS_TABLEVALUE: "表的內容，二維數組",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "標籤列表",
  T_40_XXJ_WS_TARGET_DESCKEY: "生成地圖像素的目標實體，預設為空",
  T_40_XXJ_WS_TARGET_NAMEKEY: "建立地圖像素的實體",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "攻擊實體",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "目標實體",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "目標實體",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "自訂函數所在的實體",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "被 AI 攻擊的實體",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "要跟隨的目標實體",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "物品實體（可以為空）",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "注視的目標實體",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "要暫停的音效實體",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "暫停後繼續播放的音效實體",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "要移除的音效實體",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "隊友資訊 HUD 開關",
  T_40_XXJ_WS_TELEPORTA_D: "將玩家傳送至指定位置，並設置其朝向",
  T_40_XXJ_WS_TEXT_NAMEKEY: "提示文本",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "通知文本顏色",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "文本實體表示一個顯示的文本",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "要顯示的文本 key",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "文本鍵",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "時間戳",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "時間戳格式化顯示樣式",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "時間戳格式化顯示樣式",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "時間戳本地化字串",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "時間戳本地化字串",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "提示",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "提示",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "可拾取物品數量",
  T_40_XXJ_WS_TOKENID_DESCKEY: "可拾取物品 ID",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "玩家牽引速度",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "翻譯類型",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "插值動畫實體",
  T_40_XXJ_WS_TYPE_DESCKEY: "描述類型的類型，當使用 Typeof 時返回該類型",
  T_40_XXJ_WS_TYPE_NAMEKEY: "剛體類型",
  T_40_XXJ_WS_TYPE2_DESCKEY: "不同剛體類型功能不同",
  T_40_XXJ_WS_TYPE3_DESCKEY: "目前版本只有基礎貨幣",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "是否啟用小地圖深度圖顯示模式",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "使用深度圖",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "是否受重力影響",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "是否受重力影響",
  T_40_XXJ_WS_UUID_DESCKEY: "一名玩家的唯一標識符",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "值",
  T_40_XXJ_WS_VALUE_NAMEKEY: "值",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "值[0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "第一個值",
  T_40_XXJ_WS_VALUE2_DESCKEY: "第二個值",
  T_40_XXJ_WS_VALUE6_DESCKEY: "值[0, 1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "初始值",
  T_40_XXJ_WS_VALUEB_DESCKEY: "目標值",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "遍歷到值的名稱，可用於獲取局部變量中的值",
  T_40_XXJ_WS_VALUET_DESCKEY: "插值進度，介於 0 到 1 之間",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "變量類型",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "垂直顯示類型",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "垂直顯示類型",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "物件可見件層級",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "可見性層級",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "服裝分為組合包、頭飾、面飾、臉彩、上裝、下裝以及鞋子",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "服裝類型",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "服裝欄位",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "武器欄 HUD 開關",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "槍械塗裝 ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "槍械塗裝 ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "槍械塗裝 ID",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "玩家槍械塗裝",
  T_40_XXJ_WS_WIDGETTYPEENUM: "組件類型枚舉",
  T_40_XXJ_WS_WIDTH_DESCKEY: "寬度",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "自動換行",
  T_40_XXJ_WS_WRITELEADERBOARD: "寫入數據庫中排行榜表值",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "寫入數據庫某個排行榜表中某個 Key 對應的值",
  T_40_XYL_WS_BUMPERFACTORY: "碰碰車工廠",
  T_40_XYL_WS_BURNDAMAGE: "燃燒傷害",
  T_40_XYL_WS_BURNINTERVAL: "燃燒傷害間隔(秒)",
  T_40_XYL_WS_BURNTIME: "爆炸後燃燒時間",
  T_40_XYL_WS_COLORFULSKY: "彩色魔方天空",
  T_40_XYL_WS_CRANEMACHINE: "娃娃機",
  T_40_XYL_WS_CRASHMAXDAMAGE: "撞擊最大傷害",
  T_40_XYL_WS_CRASHMAXSPEED: "撞擊傷害速度上限",
  T_40_XYL_WS_CRASHMESS: "撞擊時質量參數",
  T_40_XYL_WS_CRASHMINDAMAGE: "最低碰撞傷害",
  T_40_XYL_WS_DISPLAYBOARD: "大型廣告牌",
  T_40_XYL_WS_EXPLODEDAMAGE: "爆炸傷害",
  T_40_XYL_WS_EXPLODEDELAY: "爆炸延遲時間",
  T_40_XYL_WS_EXPLODERANGE: "爆炸範圍",
  T_40_XYL_WS_FERRISWHEEL: "摩天輪",
  T_40_XYL_WS_FOODTRUCK002: "小餐車 B",
  T_40_XYL_WS_GEARSHIFTDELAY: "檔位切換時間(秒)",
  T_40_XYL_WS_ICAROUSEL001: "旋轉木馬組件 A",
  T_40_XYL_WS_ICAROUSEL002: "旋轉木馬組件 B",
  T_40_XYL_WS_ICAROUSEL003: "旋轉木馬台",
  T_40_XYL_WS_ICEDANCEDOOL: "藍色娃娃",
  T_40_XYL_WS_IDLEBRAKEINPUT: "不受控制的停車馬力比例",
  T_40_XYL_WS_LOLLIPOP: "巨大棒棒糖",
  T_40_XYL_WS_NEWHOOKGUN: "強力鉤鎖槍",
  T_40_XYL_WS_OPENSWING: "開啟擺盪按鈕",
  T_40_XYL_WS_OPENTRACTION: "牽引按鈕",
  T_40_XYL_WS_PODIUM: "頒獎台",
  T_40_XYL_WS_SKYCITY: "城市",
  T_40_XYL_WS_SKYSCRAPER_A001: "高樓 A 組件 A",
  T_40_XYL_WS_SKYSCRAPER_A002: "高樓 A 組件 B",
  T_40_XYL_WS_SKYSCRAPER_A003: "高樓 A 組件 C",
  T_40_XYL_WS_SKYSCRAPER_B001: "高樓 B 組件 A",
  T_40_XYL_WS_SKYSCRAPER_B002: "高樓 B 組件 B",
  T_40_XYL_WS_SKYSCRAPER_B003: "高樓 B 組件 C",
  T_40_XYL_WS_SKYSCRAPER_C001: "高樓 C 組件 A",
  T_40_XYL_WS_SKYSCRAPER_C002: "高樓 C 組件 B",
  T_40_XYL_WS_SKYSCRAPER_C003: "高樓 C 組件 C",
  T_40_XYL_WS_SKYSCRAPER_D001: "高樓 D 組件 A",
  T_40_XYL_WS_SKYSCRAPER_D002: "高樓 D 組件 B",
  T_40_XYL_WS_SKYSCRAPER_D003: "高樓 D 組件 C",
  T_40_XYL_WS_SKYSCRAPER_E001: "高樓 E 組件 A",
  T_40_XYL_WS_SKYSCRAPER_E002: "高樓 E 組件 B",
  T_40_XYL_WS_SKYSCRAPER_E003: "高樓 E 組件 C",
  T_40_XYL_WS_STEERANGLE: "高速最大轉向角",
  T_40_XYL_WS_STEERSPEED: "高速轉向時的最大速度",
  T_40_XYL_WS_SWINGSPEED: "擺盪速度",
  T_40_XYL_WS_TARGETOBJECT: "運動錨點",
  T_40_XYL_WS_TRACTIONSPEED: "牽引速度",
  T_40_XYL_WS_TRIGGERCAPSULE: "自訂膠囊體觸發器",
  T_40_XYL_WS_TRIGGERSPHERE: "自訂球體觸發器",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "自訂物件",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "一個空白物件組件，可以配合渲染器組建、碰撞器組件等使用",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "自訂渲染組件",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "自訂渲染組件，用於使用自訂模型資源進行呈現",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "你對敵人的標記會附加賞金效果，擊殺被標記敵人的友軍可獲得 [FFB300]{0} FF 代幣[-]。自身擊殺敵人將額外獲得 [FFB300]100 FF 代幣[-]。在經典模式中能從 FF 代幣生產器獲得額外 [FFB300]{1} FF 代幣。",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "賞金標記",
  T_41_CJ_A_ESPORTS_TH: "白影閃電(面飾)",
  T_41_CJ_B_ESPORTS_TH: "白影閃電(下裝)",
  T_41_CJ_H_ESPORTS_TH: "白影閃電(頭飾)",
  T_41_CJ_S_ESPORTS_TH: "白影閃電(鞋子)",
  T_41_CJ_T_ESPORTS_TH: "白影閃電(上裝)",
  T_41_CJ_T_FFSI: "FFSI 冠軍(上裝)",
  T_41_CJ_T_FOOTBALL_EU01: "旭日之鷹(上裝)",
  T_41_CJ_T_FOOTBALL_EU02: "英勇駿馬(上裝)",
  T_41_CJ_T_FOOTBALL_EU03: "傲然雄雞(上裝)",
  T_41_CJ_T_FOOTBALL_EU04: "泰坦雄獅(上裝)",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "蘇西",
  T_41_LXW_TabName_Items: "道具",
  T_41_R_CD_COIL: "縮圈",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "是否啟用此裝置",
  T_41_SJ_WS_SPECIALITEM_NAME: "特殊裝置",
  T_41_SW_SKILL_DESC_DELIVERY: "受到 [FFB300]{0} 公尺[-]內的敵人攻擊時，標記該敵人 [FFB300]{1} 秒[-]，最多可標記[FFB300] {2} 名[-]敵人，標記資訊可與隊友共享。",
  T_41_SW_SKILL_DESC_GANGLEADER: "比賽開始時，獲得 [FFB300]{0}[-] 護盾值；戰鬥後存活恢復護盾值。",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "使用主動技能時，提供自身與周圍 [FFB300]{0} 公尺[-]內友軍[FFB300] {1} [-]護盾值，護盾值在[FFB300] {2} 秒[-]後開始衰減。玩家擁有莎妮的護盾時，無法再次獲得，冷卻時間：[FFB300]{3} 秒[-]。",
  T_41_SW_SKILL_DESC_WINTERGUY: "放置的凝膠護盾受到傷害時會每秒恢復 [FFB300]{0} 耐久度[-]；凝膠護盾修復時提供周圍[FFB300] {1} 公尺[-]內友軍每秒 [FFB300]{2} HP [-]恢復，每個凝膠護盾最多能提供每名友軍 [FFB300]{3} HP[-]。凝膠護盾在安全區外超過 [FFB300]{4} 秒[-]後無法治療友軍。",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "寵物外觀：亡靈刺刺",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "寵物外觀：墨隼",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "類型",
  T_41_WT_SKILL_DESC_FIREBOY: "召喚一道 [FFB300]{1} 公尺寬[-] 的火焰之牆，持續 [FFB300]{0} 秒[-]，火焰之牆以每秒 [FFB300]{2} 公尺[-]的速度向前移動，最多持續 [FFB300]{3} 秒[-]。技能生效期間，可再次使用技能來停止牆移動。接觸火焰之牆的[FFB300]敵人或凝膠護盾[-]將立即受到 [FFB300]{4}(或 {5})[-] 傷害，並在接觸後每秒持續受到 [FFB300]{6}(或 {7})[-] 傷害，持續 [FFB300]{8} 秒[-]。冷卻時間：[FFB300]{9} 秒[-]。最多可儲存[FFB300]{10}次[-]技能使用，每次使用間隔[FFB300]{11}秒[-]。",
  T_41_WT_SKILL_NAME_FIREBOY: "烈火燎原",
  T_41_WZY_WS_CHARGEMAX: "凝膠製造器充能上限",
  T_41_WZY_WS_CROSSBOWNAME: "十字弩",
  T_41_WZY_WS_DECELERATIONRATIO: "水域減速百分比",
  T_41_WZY_WS_DEICEWALLPARAM1: "腐蝕區域半徑",
  T_41_WZY_WS_DEICEWALLPARAM2: "腐蝕區域時長",
  T_41_WZY_WS_EXPPERCHIP: "凝膠器晶片提供經驗",
  T_41_WZY_WS_EXPPERDAMAGE: "每點傷害提供經驗",
  T_41_WZY_WS_EXPPERMOVEMILE: "移動每公尺提供經驗",
  T_41_WZY_WS_EXPPERSECOND: "每秒提供經驗",
  T_41_WZY_WS_GRENADEEXPTIME: "爆炸延時",
  T_41_WZY_WS_GRENADELAUNCHNAME: "爆炸投擲物",
  T_41_WZY_WS_GRENADEMAX: "最大傷害",
  T_41_WZY_WS_GRENADEMIN: "最小傷害",
  T_41_WZY_WS_GRENADERANGE: "爆炸範圍",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "對載具傷害係數",
  T_41_WZY_WS_GRENADERATIOSELF: "對自身傷害係數",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "對隊友傷害係數",
  T_41_WZY_WS_GRENADTHROWSPEED: "飛行速度",
  T_41_WZY_WS_HANDCANNONNAME: "手銃",
  T_41_XXJ_WS_ACCELERATION: "加速度",
  T_41_XXJ_WS_ACCELERATION_D: "產生指定大小的加速度",
  T_41_XXJ_WS_ACTION: "行為節點",
  T_41_XXJ_WS_ACTION_D: "行為節點",
  T_41_XXJ_WS_ADDHP: "治療道具",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "增加最大 HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI 釋放技能",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "可被輔助瞄準中心偏移量",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "可被輔助瞄準距離",
  T_41_XXJ_WS_AIMASSISTENTITY: "可以被輔助瞄準的實體",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "可以被輔助瞄準的實體",
  T_41_XXJ_WS_AISKILLTYPE: "AI 技能類型",
  T_41_XXJ_WS_AISKILLTYPE_D: "殭屍技能類型",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "所有物品",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "所有物品",
  T_41_XXJ_WS_AMMOCLIPSIZE: "修改彈匣子彈數量",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "彈匣子彈數量",
  T_41_XXJ_WS_ANCHORPOSITION_D: "相對於父節點的錨點座標",
  T_41_XXJ_WS_ANGLE_D: "Z 軸旋轉角度",
  T_41_XXJ_WS_ANGULARDRAG: "轉動阻力係數",
  T_41_XXJ_WS_ANGULARVELOCITY: "角速度（rad/s，世界坐標系）",
  T_41_XXJ_WS_ANIMATIONCLIP: "動畫狀態",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "管理動畫控制器檔案與資源",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "動畫實體",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "管理動畫狀態機檔案與資源",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "動畫狀態機資源 UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "循環類型枚舉",
  T_41_XXJ_WS_ANIMATIONSTATE: "動畫狀態",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "運算方式，所有類型都支援賦值，數字類型還支持自加、自減、自乘、自除",
  T_41_XXJ_WS_ATTACHMENT: "配件道具",
  T_41_XXJ_WS_ATTACHMENT_D: "配件道具",
  T_41_XXJ_WS_ATTACHTARGET: "綁定的對象",
  T_41_XXJ_WS_BAG: "背包",
  T_41_XXJ_WS_BAG_D: "背包組件",
  T_41_XXJ_WS_BANNERID: "橫幅 ID",
  T_41_XXJ_WS_BANNERID_D: "橫幅 ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "行為樹",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "行為樹",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "可掛載行為樹實體",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "可掛載行為樹實體",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "行為樹自定義節點",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "行為數自訂節點",
  T_41_XXJ_WS_BODY: "身體",
  T_41_XXJ_WS_BORDERLR: "左右邊界",
  T_41_XXJ_WS_BORDERLR_D: "左右邊界",
  T_41_XXJ_WS_BORDERTB: "上下邊界",
  T_41_XXJ_WS_BORDERTB_D: "上下邊界",
  T_41_XXJ_WS_BRPEAKRANK: "經典模式最高段位",
  T_41_XXJ_WS_BRPEAKRANK_D: "經典模式最高段位",
  T_41_XXJ_WS_BRRANK: "經典模式段位",
  T_41_XXJ_WS_BRRANK_D: "經典模式段位",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "行為樹節點類型",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "行為樹節點類型",
  T_41_XXJ_WS_BTREE: "行為樹",
  T_41_XXJ_WS_BTREENODESTATE: "行為樹節點運行狀態",
  T_41_XXJ_WS_BTREENODESTATE_D: "行為樹節點運行狀態",
  T_41_XXJ_WS_BUFFABLEENTITY: "能夠使用 FF 增益系統的實體",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "可以添加、移除增益、獲得已添加的增益列表",
  T_41_XXJ_WS_BUILDINGICEWALL: "凝膠護盾",
  T_41_XXJ_WS_CAMOUFLAGE: "功能型道具",
  T_41_XXJ_WS_CAMOUFLAGE_D: "滑板、迷彩...",
  T_41_XXJ_WS_CAPICITY_D: "初始容量",
  T_41_XXJ_WS_CENTERINVISIBLE: "中心不可見",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "中心不可見",
  T_41_XXJ_WS_COLOR: "顏色",
  T_41_XXJ_WS_COLOR_D: "顏色",
  T_41_XXJ_WS_CONDITION: "條件節點",
  T_41_XXJ_WS_CONDITION_D: "條件是特殊的 布林值類型",
  T_41_XXJ_WS_CONDITION1_D: "條件節點",
  T_41_XXJ_WS_CONSTRAIN: "對剛體施加的限制，是剛體限制類型的集合",
  T_41_XXJ_WS_CONSTRAIN_D: "對剛體施加的限制，是剛體限制類型的集合",
  T_41_XXJ_WS_COUNT_D: "數量",
  T_41_XXJ_WS_CROSSBOW_D: "十字弩",
  T_41_XXJ_WS_CSPEAKRANK: "團隊突襲最高段位",
  T_41_XXJ_WS_CSPEAKRANK_D: "團隊突襲最高段位",
  T_41_XXJ_WS_CSRANK: "團隊突襲段位",
  T_41_XXJ_WS_CSRANK_D: "團隊突襲段位",
  T_41_XXJ_WS_CSVNAME_D: "模式對應 SceneData 下的 csv 文件，以 .csv 結尾，表頭全部使用小寫",
  T_41_XXJ_WS_CURCAPACITY: "已佔用空間",
  T_41_XXJ_WS_CURPROGRESS: "當前進度",
  T_41_XXJ_WS_CURRENTCLIP: "當前動畫片段",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "當前動畫片段播放進度",
  T_41_XXJ_WS_CURRENTSTATE: "當前動畫狀態",
  T_41_XXJ_WS_CUSTOMHUDID: "自訂 HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "用於描述自訂介面資產的 ID",
  T_41_XXJ_WS_DASHATTACK: "衝撞攻擊",
  T_41_XXJ_WS_DEBUG: "偵錯",
  T_41_XXJ_WS_DEBUG_D: "偵錯",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "減速百分比：水域物件開放水中移速減緩百分比（範圍暫定為0~100）",
  T_41_XXJ_WS_DEPTH_D: "深度",
  T_41_XXJ_WS_DRAG: "移動阻力係數",
  T_41_XXJ_WS_DRAG_D: "係數越大，運動速度衰減越快",
  T_41_XXJ_WS_DUMMY: "假人",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "是否開啟低幀率模式",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "開啟低幀率模式，遊戲將以 15 或 30 FPS 運行",
  T_41_XXJ_WS_ENTITYLIST: "返回創建的實體列表",
  T_41_XXJ_WS_ENTITYNAME: "物件名稱",
  T_41_XXJ_WS_ENTITYNAME_D: "玩家自訂的物件名稱",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "邏輯實體或 Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "防具與背包",
  T_41_XXJ_WS_EQUIPMENTSLOT: "裝備欄位枚舉",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "裝備欄位枚舉",
  T_41_XXJ_WS_EXPLODE: "自爆",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "爆破武器",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "自動裝填速度",
  T_41_XXJ_WS_FILEID: "內部 ID",
  T_41_XXJ_WS_FILEID_D: "控件在 Prefab 中的內部 ID",
  T_41_XXJ_WS_FILLAMOUNT: "填充值",
  T_41_XXJ_WS_FILLAMOUNT_D: "填充值",
  T_41_XXJ_WS_FILLDIR: "填充方向",
  T_41_XXJ_WS_FILLDIR_D: "填充方向",
  T_41_XXJ_WS_FILLDIR_D1: "填充方向枚舉",
  T_41_XXJ_WS_FILLTYPE: "填充類型",
  T_41_XXJ_WS_FILLTYPE_D: "填充類型枚舉",
  T_41_XXJ_WS_FILLTYPE_D1: "填充類型枚舉",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "尋路",
  T_41_XXJ_WS_FINISH: "完成",
  T_41_XXJ_WS_FIREINTERVAL: "攻擊間隔",
  T_41_XXJ_WS_FIREINTERVAL_D: "攻擊間隔",
  T_41_XXJ_WS_FLIP: "翻轉方式",
  T_41_XXJ_WS_FLIP_D: "翻轉方式",
  T_41_XXJ_WS_FLYBOMBBEE: "飛行殭屍",
  T_41_XXJ_WS_FORCE: "力",
  T_41_XXJ_WS_FORCE_D: "產生指定強度的力量",
  T_41_XXJ_WS_FORCETYPE: "施力類型",
  T_41_XXJ_WS_FORCETYPE_D: "剛體受力的不同效果。注意：只對動態類型的剛體有效",
  T_41_XXJ_WS_FREEZEALL: "限制所有軸的平移和旋轉",
  T_41_XXJ_WS_FREEZEPOSITION: "限制所有軸的平移",
  T_41_XXJ_WS_FREEZEPOSITIONX: "限制 X 軸方向的平移",
  T_41_XXJ_WS_FREEZEPOSITIONY: "限制 Y 軸方向的平移",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "限制 Z 軸方向平移",
  T_41_XXJ_WS_FREEZEROTATION: "限制所有軸的旋轉",
  T_41_XXJ_WS_FREEZEROTATIONX: "限制 X 軸方向的旋轉",
  T_41_XXJ_WS_FREEZEROTATIONY: "限制 Y 軸方向旋轉",
  T_41_XXJ_WS_FREEZEROTATIONZ: "限制 Z 軸方向旋轉",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "最大傷害距離",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "最大傷害距離",
  T_41_XXJ_WS_GAMEID_D: "任務 ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "提供都會道具",
  T_41_XXJ_WS_GRADIENT: "漸層",
  T_41_XXJ_WS_GRADIENT_D: "漸層",
  T_41_XXJ_WS_GRADIENTBOTTOM: "底部漸層色",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "底部漸層色",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "底部透明度",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "底部透明度",
  T_41_XXJ_WS_GRADIENTTOP: "頂部漸層色",
  T_41_XXJ_WS_GRADIENTTOP_D: "頂部漸層色",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "頂部透明度",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "頂部透明度",
  T_41_XXJ_WS_GRAPHID: "腳本 ID",
  T_41_XXJ_WS_GRAPHID_D: "用於描述腳本資產的 ID",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "凝膠腐蝕手榴彈組件",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "爆炸延時",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "投擲物道具",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "最大傷害",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "最小傷害",
  T_41_XXJ_WS_GRENADERANGE_D: "爆炸範圍",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "對自身傷害係數",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "對隊友傷害係數",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "對載具傷害係數",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "投擲速度",
  T_41_XXJ_WS_GRENADEWEAPON: "投擲物道具基類",
  T_41_XXJ_WS_GRENADEWEAPON_D: "投擲物道具基類",
  T_41_XXJ_WS_HANDCANNON_D: "投擲物道具基類",
  T_41_XXJ_WS_HEAD: "頭像 ID",
  T_41_XXJ_WS_HEADID: "頭像 ID",
  T_41_XXJ_WS_HEADID_D: "頭像 ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "重武器",
  T_41_XXJ_WS_HELMET_D: "當前頭盔",
  T_41_XXJ_WS_HELMET1_D: "頭盔",
  T_41_XXJ_WS_HELMET2_D: "頭盔實體",
  T_41_XXJ_WS_HITBODYPART_D: "傷害部位",
  T_41_XXJ_WS_HITBPDYPART: "擊中部位",
  T_41_XXJ_WS_HITENTITY_D: "擊中實體",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "所在 HUD 實體",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D HUD 裝載器",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "3D HUD 裝載器實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_41_XXJ_WS_HUDGRID: "自訂佈局（面板）控件",
  T_41_XXJ_WS_HUDLAYOUT: "佈局 HUD",
  T_41_XXJ_WS_HUDLAYOUT_D: "佈局 HUD 實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_41_XXJ_WS_HUDPROFILEINFO: "自訂頭像 HUD",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "自訂頭像 HUD 實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_41_XXJ_WS_HUDTEXTURE: "貼圖 HUD",
  T_41_XXJ_WS_HUDTEXTURE_D: "貼圖 HUD 實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_41_XXJ_WS_HUDTRANSFORM: "UI Transform 控件組件",
  T_41_XXJ_WS_HUDTRANSFORM_D: "UI Transform 控件組件實體",
  T_41_XXJ_WS_IMPULSE: "衝擊",
  T_41_XXJ_WS_IMPULSE_D: "產生指定強度的衝擊",
  T_41_XXJ_WS_INITIALWORLDPOS: "初始世界座標",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "增益枚舉",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "對應 BuffData.csv 中的 ID 列，增加新項前請和 GPP 確認是否適用",
  T_41_XXJ_WS_INVERTFILL: "反向填充",
  T_41_XXJ_WS_INVERTFILL_D: "反向填充",
  T_41_XXJ_WS_ISLOOP: "是否循環",
  T_41_XXJ_WS_ISLOOP_D: "是否循環，預設為 False",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "僅用於靜態載入物件時，判斷是靜態生成導航網格",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "僅用於靜態載入物件時，判斷是靜態生成導航網格",
  T_41_XXJ_WS_ISSUCCESS_D: "是否成功摧毀",
  T_41_XXJ_WS_ITEMENTITY_D: "道具實體",
  T_41_XXJ_WS_ITEMID: "道具 ID",
  T_41_XXJ_WS_ITEMID_D: "道具 ID",
  T_41_XXJ_WS_ITEMID_D1: "附件對應的道具 ID",
  T_41_XXJ_WS_ITEMLIST: "道具列表",
  T_41_XXJ_WS_ITEMTYPE_D: "道具類型",
  T_41_XXJ_WS_JUMPATTACK: "跳斬",
  T_41_XXJ_WS_LANDMINE: "地雷",
  T_41_XXJ_WS_LENGTH: "片段長度",
  T_41_XXJ_WS_LENGTH_D: "進度條長度，目前預設值為 Prefab 上 UI 的長度",
  T_41_XXJ_WS_LIMB: "四肢",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "列表長度超過容量，元素添加失敗",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "增益列表",
  T_41_XXJ_WS_LOOP: "循環",
  T_41_XXJ_WS_LOOP_D: "循環",
  T_41_XXJ_WS_MAXCAPACITY: "最大空間",
  T_41_XXJ_WS_MAXCAPACITY_D: "背包空間",
  T_41_XXJ_WS_MAXPROGRESS: "最大進度，以單位 10 為最大進度比例，大於 0 的時才會顯示進度資訊",
  T_41_XXJ_WS_MELEEWEAPON_D: "近戰武器",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "最小傷害開始距離",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "最小傷害開始距離",
  T_41_XXJ_WS_MINISENTRY: "自動砲塔",
  T_41_XXJ_WS_NAME: "名稱",
  T_41_XXJ_WS_NAME_D: "技能按鈕名字，用於 OnClick 事件發送時傳參，所以要保證唯一性",
  T_41_XXJ_WS_NAME1_D: "商品名稱",
  T_41_XXJ_WS_NAME2_D: "貨架名稱",
  T_41_XXJ_WS_NAME3_D: "商店名稱",
  T_41_XXJ_WS_NICKNAME: "暱稱",
  T_41_XXJ_WS_NICKNAME_D: "玩家的暱稱",
  T_41_XXJ_WS_NOCHANGE: "不變",
  T_41_XXJ_WS_NONE: "無",
  T_41_XXJ_WS_NONE1: "無",
  T_41_XXJ_WS_OFFSET: "偏移量",
  T_41_XXJ_WS_OFFSET_D: "偏移",
  T_41_XXJ_WS_OFFSET1_D: "寫入的偏移值",
  T_41_XXJ_WS_ONCE: "單次",
  T_41_XXJ_WS_ONCE_D: "單次",
  T_41_XXJ_WS_ONHIDE: "介面被關閉時",
  T_41_XXJ_WS_ONHIDE_D: "介面被關閉時",
  T_41_XXJ_WS_ONNODEENTER_D: "節點進入時",
  T_41_XXJ_WS_ONSHOW: "介面被打開時",
  T_41_XXJ_WS_ONSHOW_D: "介面被打開時",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "輸入框變化時觸發",
  T_41_XXJ_WS_PERSONALUAV: "迷你無人機",
  T_41_XXJ_WS_PINID: "紀念章 ID",
  T_41_XXJ_WS_PINID_D: "紀念章 ID",
  T_41_XXJ_WS_PLAYERBAG: "玩家背包",
  T_41_XXJ_WS_PLAYERBAG_D: "玩家背包實體",
  T_41_XXJ_WS_PLAYERBAGENTITY: "玩家背包",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "玩家背包",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "開鏡移動速度修正係數",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "射擊時的玩家速度影響",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "射擊時的玩家速度影響",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "用以描述預置資產體的ID",
  T_41_XXJ_WS_PREFABID1_D: "來自此模板 ID 所代表的HUD 模板實體創建",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "主武器 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "主武器 2",
  T_41_XXJ_WS_PROFILEINFO: "玩家檔案",
  T_41_XXJ_WS_PROFILEINFO_D: "玩家簡介訊息",
  T_41_XXJ_WS_PROGRESSICON_D: "進度圖標",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "進度圖標名稱",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "退出都會小遊戲",
  T_41_XXJ_WS_RANGE: "攻擊範圍",
  T_41_XXJ_WS_RANGE_D: "攻擊範圍",
  T_41_XXJ_WS_RANGE_D1: "爆炸範圍",
  T_41_XXJ_WS_RANGE_D2: "砲塔範圍",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "讀取整張表的內容，返回二維數組",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "讀取表中某一單元格的內容",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "讀取整張表某一列的內容，返回數組",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "讀取整張表某一行的內容，返回數組",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "讀取累計數據庫某個表中某個參數名對應的值",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "讀取累計數據庫某個表中某個參數名對應的值",
  T_41_XXJ_WS_RECOVERPLAYERHP: "持續恢復 HP",
  T_41_XXJ_WS_RELOADSPEED: "裝填速度",
  T_41_XXJ_WS_RELOADSPEED_D: "裝填速度（基礎速度*係數）",
  T_41_XXJ_WS_RESOURCEID: "資源 UUID",
  T_41_XXJ_WS_RESOURCEID_D: "資源 UUID",
  T_41_XXJ_WS_RESUUID: "資源 ID",
  T_41_XXJ_WS_RESUUID_D: "指定要渲染的資源 UUID",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "剛體限制類型",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "每種限制以 bit 標記定義，可以組合使用",
  T_41_XXJ_WS_ROTATION: "旋轉",
  T_41_XXJ_WS_ROTATION_D: "世界座標系中的旋轉角，XYZ分量分別是偏航角、俯仰角、翻滾角",
  T_41_XXJ_WS_ROTATION1_D: "旋轉",
  T_41_XXJ_WS_RUNNING: "運行中",
  T_41_XXJ_WS_SCALE: "縮放",
  T_41_XXJ_WS_SCALE_D: "縮放",
  T_41_XXJ_WS_SCALE1_D: "沿著某個軸縮放，可以是三個軸的組合",
  T_41_XXJ_WS_SCATTERMAX: "開始散射閾值",
  T_41_XXJ_WS_SCATTERMAX_D: "開始散射閾值",
  T_41_XXJ_WS_SCATTERMOVE1: "移動情況下擴散大小",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "散射恢復速度",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "散射恢復速度",
  T_41_XXJ_WS_SCATTERSPEED: "擴散增加速度",
  T_41_XXJ_WS_SCATTERSPEED_D: "擴散增加速度（0.1 = 每多一次連發準星擴大 10%）",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "蹲下、趴下減少散射",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "副武器",
  T_41_XXJ_WS_SHADERNAME: "著色器名稱",
  T_41_XXJ_WS_SHADERNAME_D: "著色器名稱",
  T_41_XXJ_WS_SHIELDBROKEN: "破盾攻擊",
  T_41_XXJ_WS_SHIELDUP: "舉盾攻擊",
  T_41_XXJ_WS_SHOCKWAVE: "衝擊波",
  T_41_XXJ_WS_SHOWNAME: "顯示暱稱",
  T_41_XXJ_WS_SHOWNAME_D: "顯示暱稱",
  T_41_XXJ_WS_SHOWPIN: "顯示紀念章",
  T_41_XXJ_WS_SHOWPIN_D: "顯示紀念章",
  T_41_XXJ_WS_SHOWRANK: "顯示段位",
  T_41_XXJ_WS_SHOWRANK_D: "顯示段位",
  T_41_XXJ_WS_SHOWTYPE: "樣式",
  T_41_XXJ_WS_SHOWTYPE_D: "樣式",
  T_41_XXJ_WS_SHRINKSPEED: "縮圈速度",
  T_41_XXJ_WS_SIGHTAIMASSIST: "允許開鏡時輔助瞄準",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "輔助瞄準距離衰減影響係數(0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "輔助瞄準距離優先影響係數(≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "優先輔助瞄準距離的最大距離",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "優先輔助瞄準距離的最小距離",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "允許輔助瞄準距離優先",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "輔助瞄準準星螢幕範圍吸引比率(0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "瞄準鏡名義放大倍率",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV 放大倍率",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "瞄鏡旋轉靈敏度係數",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "瞄鏡最小傷害距離修正係數 X",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "瞄鏡 UI 射擊放大時間（秒）",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "瞄鏡射擊 UI 放大倍率",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "瞄鏡 UI 射擊恢復時間（秒）",
  T_41_XXJ_WS_SPEED: "播放速度",
  T_41_XXJ_WS_SPEEQUIP: "功能型裝備",
  T_41_XXJ_WS_SPEITEM: "特殊道具",
  T_41_XXJ_WS_STATICGRAPHID: "靜態腳本 ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "用以描述靜態腳本資產的 ID",
  T_41_XXJ_WS_STATICWAINING: "靜態剛體類型修改失敗",
  T_41_XXJ_WS_TARGETTREE: "行為樹實體",
  T_41_XXJ_WS_TARGETTREE_D: "行為樹實體",
  T_41_XXJ_WS_TEAMINDEX: "隊伍陣營序號",
  T_41_XXJ_WS_TEAMINDEX_D: "隊伍陣營序號",
  T_41_XXJ_WS_TEAMINDEX_D1: "隊伍陣營序號",
  T_41_XXJ_WS_TEMPLATEPREFABID: "模板的 Prefab ID",
  T_41_XXJ_WS_TEXT_D: "文本內容",
  T_41_XXJ_WS_TEXTURENAME: "貼圖名稱",
  T_41_XXJ_WS_TEXTURENAME_D: "貼圖名稱",
  T_41_XXJ_WS_THROWATTACK: "手榴彈",
  T_41_XXJ_WS_TICKINTERVAL: "刷新間隔",
  T_41_XXJ_WS_TICKINTERVAL_D: "刷新間隔，數字越大刷新越慢",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "啟用玩家背包內的特殊裝置",
  T_41_XXJ_WS_UVRECTWH: "UV 寬高",
  T_41_XXJ_WS_UVRECTWH_D: "UV 寬高",
  T_41_XXJ_WS_UVRECTXY: "UV 偏移量",
  T_41_XXJ_WS_UVRECTXY_D: "UV 偏移量",
  T_41_XXJ_WS_VELOCITY: "速度",
  T_41_XXJ_WS_VELOCITY_D: "剛體的速度儘量不要直接修改，而是通過施力相關 API 修改",
  T_41_XXJ_WS_VEST_D: "當前防彈衣",
  T_41_XXJ_WS_VEST1_D: "防彈衣",
  T_41_XXJ_WS_WIDGETID: "控件 ID",
  T_41_XXJ_WS_WIDGETID_D: "用於描述自訂介面資產中的控件 ID，必須和自訂 HUD ID 搭配才能確定它對應唯一控件 ID",
  T_41_XXJ_WS_WINDATTACK: "旋風斬",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "寫入累計數據庫表偏移值",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "寫入累計數據庫某個表中某個參數名對應的偏移值",
  T_41_XXJ_WS_ZONEDURATION_D: "冰凍區域時長",
  T_41_XXJ_WS_ZONEDURATION1_D: "腐蝕區域時長",
  T_41_XXJ_WS_ZONERADIUS_D: "冰凍區域半徑",
  T_41_XXJ_WS_ZONERADIUS1_D: "腐蝕區域半徑",
  T_41_XYL_WS_BOT12: "鑽地怪",
  T_41_XYL_WS_BOT9: "變異投擲殭屍",
  T_41_XYL_WS_ITEM262: "冰凍金屬板 A",
  T_41_XYL_WS_ITEM263: "冰凍貨櫃 A",
  T_41_XYL_WS_ITEM264: "冰凍物資箱",
  T_41_XYL_WS_ITEM265: "冰凍鐵門",
  T_41_XYL_WS_ITEM266: "冰凍貨櫃 B",
  T_41_XYL_WS_ITEM267: "冰凍石塊 A",
  T_41_XYL_WS_ITEM268: "冰凍石塊 B",
  T_41_XYL_WS_ITEM269: "冰凍石塊 C",
  T_41_XYL_WS_ITEM270: "冰凍石塊 D",
  T_41_XYL_WS_ITEM271: "廢棄地鐵車廂",
  T_41_XYL_WS_MODELMATCHNAME: "競賽畫布",
  T_41_XYL_WS_NAVMESH: "動態導航網格",
  T_41_XYL_WS_REFCUBE: "鏡面方塊",
  T_41_XYL_WS_SNOWSKY: "極地星空",
  T_41_XYL_WS_TOYCUBE: "樂園方塊",
  T_42_CJ_F_B_VOCATIONAL: "工程總監(下裝)",
  T_42_CJ_F_H_VOCATIONAL: "工程總監(頭飾)",
  T_42_CJ_F_S_VOCATIONAL: "工程總監(鞋子)",
  T_42_CJ_F_T_VOCATIONAL: "工程總監(上裝)",
  T_42_CJ_HA_THUNDER_GOLD: "神罰之眼",
  T_42_CJ_M_B_VOCATIONAL: "資深技師(下裝)",
  T_42_CJ_M_H_VOCATIONAL: "資深技師(頭飾)",
  T_42_CJ_M_S_VOCATIONAL: "資深技師(鞋子)",
  T_42_CJ_M_T_VOCATIONAL: "資深技師(上裝)",
  T_42_H_CHARACTER_SUPERTEEN_N: "伊格尼斯",
  T_42_H_GLOO_EVOTIGER_N: "凝膠護盾-死亡凝視",
  T_42_H_GRENADE_SMUDGE_N: "手榴彈-血舐饗宴",
  T_42_H_M1917_EMPIRE_N: "M1917-帝國暴君",
  T_42_HJ_WS_VFX_INK: "水墨",
  T_42_JH_WS_BANMATCHMAKING: "此地圖禁止匹配",
  T_42_JH_WS_BANROOMCREATE: "無法創建房間",
  T_42_JH_WS_FPS: "第一人稱",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "派對嗨歌 (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "烈火燎原 (伊格尼斯)",
  T_42_JH_WS_SKILLSETSANTINO: "替身假人 (聖提諾)",
  T_42_JH_WS_SKILLSETSONIA: "奈米護盾 (索妮雅)",
  T_42_JH_WS_TAG1: "冰雪大亂鬥",
  T_42_JH_WS_TAG10: "無限飛車",
  T_42_JH_WS_TAG11: "極速狂飆",
  T_42_JH_WS_TAG12: "賽車競速",
  T_42_JH_WS_TAG13: "不上熱門",
  T_42_JH_WS_TAG14: "血戰前線",
  T_42_JH_WS_TAG15: "殭屍大戰",
  T_42_JH_WS_TAG16: "經典致敬",
  T_42_JH_WS_TAG2: "社交島 1.0",
  T_42_JH_WS_TAG3: "社交島 2.0",
  T_42_JH_WS_TAG4: "一起同樂！",
  T_42_JH_WS_TAG5: "廢墟生存",
  T_42_JH_WS_TAG6: "獵殺時刻",
  T_42_JH_WS_TAG7: "獵殺時刻",
  T_42_JH_WS_TAG8: "堡壘戰 2.0",
  T_42_JH_WS_TAG9: "賞金追獵",
  T_42_RW_PORTALSFORPERSONAL_DESC: "隨時隨地放置傳送門，快速轉點！",
  T_42_RW_PORTALSPERSONAL_NAME: "便攜傳送門",
  T_42_SJ_WS_ACCESSORIESITEM: "裝備配件道具",
  T_42_SJ_WS_AUTOPLAY: "自動播放",
  T_42_SJ_WS_CLIMB: "翻越",
  T_42_SJ_WS_CLOCK_EVENTS: "事件集合",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "倒計時與否",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "循環",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "暫停事件",
  T_42_SJ_WS_CLOCK_START_EVENT: "開始事件",
  T_42_SJ_WS_CLOCK_START_TIME: "倒計時開始時間",
  T_42_SJ_WS_CLOCK_STATE: "秒錶狀態",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "停止事件",
  T_42_SJ_WS_DAMRATIOHEAD: "爆頭傷害係數變化",
  T_42_SJ_WS_DAMRATIOLIMB: "四肢傷害係數變化",
  T_42_SJ_WS_DAMREDUCEXPLODE: "額外爆炸減商係數",
  T_42_SJ_WS_DRIVE: "駕駛",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "顯示層級",
  T_42_SJ_WS_EXTRABAGCAPACITY: "額外背包空間",
  T_42_SJ_WS_EXTRAHPRATIO: "玩家 HP 倍率",
  T_42_SJ_WS_GETOFF_DRIVE: "退出載具",
  T_42_SJ_WS_GETON_DRIVE: "進入載具",
  T_42_SJ_WS_KNIFEITEM: "飛刀",
  T_42_SJ_WS_KNIFEITEMPICK: "飛刀（可拾取）",
  T_42_SJ_WS_MARKBTNHUD: "標記按鈕 HUD 開關",
  T_42_SJ_WS_MARKBTNHUD_D: "可開啟或關閉標記按鈕",
  T_42_SJ_WS_MAXDISTANCE: "最大距離",
  T_42_SJ_WS_MAXDURARATIO: "耐久上限倍率",
  T_42_SJ_WS_MICBTNHUD: "麥克風按鈕 HUD 開關",
  T_42_SJ_WS_MICBTNHUD_D: "可開啟或關閉麥克風按鈕",
  T_42_SJ_WS_MINDISTANCE: "最小距離",
  T_42_SJ_WS_OPE_VEHICLE: "操控載具",
  T_42_SJ_WS_PLANE_DESC: "可以隨意調整尺寸的基本網格",
  T_42_SJ_WS_PLANENAME: "基本網格",
  T_42_SJ_WS_PRIORITY: "優先級",
  T_42_SJ_WS_REPLACEPRIORITY: "替換優先級",
  T_42_SJ_WS_SETBTNHUD: "設定按鈕 HUD 開關",
  T_42_SJ_WS_SETBTNHUD_D: "可開啟或關閉設定按鈕",
  T_42_SJ_WS_SIGNALBTNHUD: "網路連線按鈕 HUD 開關",
  T_42_SJ_WS_SIGNALBTNHUD_D: "可開啟或關閉網路連線按鈕",
  T_42_SJ_WS_SPEAKERBTNHUD: "載具喇叭按鈕 HUD 開關",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "可開啟或關閉載具喇叭按鈕",
  T_42_SJ_WS_START_TIME: "開始時間(秒)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "增加[FFB300]{0}[-]背包空間，用於榴彈以外的子彈。([FFB300]{1}[-] 步槍子彈，[FFB300]{2}[-] 衝鋒槍子彈，[FFB300]{3}[-] 狙擊槍子彈，[FFB300]{4}[-] 霰彈槍子彈)",
  T_42_SW_SKILL_DESC_Bodyguard: "裝填速度增加 [FFB300]{0}% [-]。每次對敵人造成傷害時，該敵人會受到 [FFB300]{1}%[-] 治療減少效果，持續 [FFB300]{3} 秒[-]，最多減少 [FFB300]{2}%[-]。",
  T_42_SW_SKILL_DESC_Playboy: "受到控制效果（緩速、標記、沉默等）時，無視控制並提升機動性 [FFB300]{1}%[-]，持續[FFB300] {2} 秒[-]，冷卻時間：[FFB300]{0} 秒[-]。",
  T_42_SW_SKILL_DESC_SwatGuy: "擊倒敵人或使用主動技能後，彈匣將自動裝填 [FFB300]{0}%[-]。",
  T_42_SW_SKILL_NAME_Playboy: "高貴血統",
  T_42_SY_BACKPACK_EMPIRE_N: "背包-暴君咆嘯",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "寵物外觀：冰雪蹦蹦",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "機車-都會漫遊",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae-凱旋勝利",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae-銀霧駭影",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno-夜幕神秘",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno-紅焰狂潮",
  T_42_TYC_CST_LOSE_MONEY_1: "失敗時獲得金幣數量",
  T_42_TYC_CST_LOSE_MONEY_2: "連續失敗 2 次時獲得金幣數量",
  T_42_TYC_CST_LOSE_MONEY_3: "連續失敗 3 次時獲得金幣數量",
  T_42_WH_ITEM_HEALUAV: "治療無人機",
  T_42_WH_ITEM_HEALUAV_DESC: "部署一架向前飛行的迷你無人機，持續治療範圍內的隊友。",
  T_42_WH_ITEM_SKILLCARD: "技能：{0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `使用後釋放[ffba00] {0}[-]的主動技能：[ffba00]{1}[-]
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "子彈類型",
  T_42_XXJ_WS_AMMOTYPE_D: "子彈類型",
  T_42_XXJ_WS_ASSETCONFIGID: "塗裝 ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "塗裝",
  T_42_XXJ_WS_ATTACKSTATUS: "攻擊狀態",
  T_42_XXJ_WS_AUTOPLAY: "自動播放",
  T_42_XXJ_WS_AUTOPLAY_D: "自動播放",
  T_42_XXJ_WS_AVATARABLE: "可修改外觀組件",
  T_42_XXJ_WS_AVATARABLE_D: "按照各部件改變外觀",
  T_42_XXJ_WS_AVATARRESUUID: "外觀資源 UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "將軸角表示的旋轉轉換為四元數",
  T_42_XXJ_WS_B_D: "顏色 B 值",
  T_42_XXJ_WS_BASEVALUE_D: "對數運算的底數",
  T_42_XXJ_WS_BEZIERCURVE: "貝茲曲線",
  T_42_XXJ_WS_BEZIERCURVE_D: "貝茲曲線",
  T_42_XXJ_WS_BOTDIFFICULTY: "人機難度",
  T_42_XXJ_WS_BOUNCE_COMBINE: "彈性組合方式",
  T_42_XXJ_WS_BOUNCINES: "彈性",
  T_42_XXJ_WS_BTREEID: "行為樹 ID",
  T_42_XXJ_WS_BTREEID_D: "行為樹 ID",
  T_42_XXJ_WS_CANPURCHAS: "能否購買",
  T_42_XXJ_WS_CANPURCHAS_D: "能否購買",
  T_42_XXJ_WS_CLIMBSTATUS: "翻越行為",
  T_42_XXJ_WS_CLOCK: "計時器物件",
  T_42_XXJ_WS_CLOCK_D: "計時器物件",
  T_42_XXJ_WS_CLOCK_D1: "計時器物件",
  T_42_XXJ_WS_CONTAINER: "容器",
  T_42_XXJ_WS_CONTROLPOINTS: "控制點",
  T_42_XXJ_WS_CONTROLPOINTS_D: "控制點",
  T_42_XXJ_WS_COROUTINEID: "協程控制代碼",
  T_42_XXJ_WS_COROUTINEID_D: "協程 ID 是指特定協程的控制代碼。它允許對該控制代碼執行各種操作。",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "建立相對自身運動動畫",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "建立相對自身幀",
  T_42_XXJ_WS_CREATESOUND: "創建音效",
  T_42_XXJ_WS_CREATESOUND_D: "播放指定音效。 如果需要設定更多屬性，您可以透過配置其實體屬性來完成。",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "完成自訂任務",
  T_42_XXJ_WS_DAMAGELIST_D: "傷害增量列表",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "爆頭傷害比例",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "爆炸傷害減免係數",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "預設物理材質",
  T_42_XXJ_WS_DEFAULTFIST_D: "預設拳頭",
  T_42_XXJ_WS_DELTA: "增量",
  T_42_XXJ_WS_DELTA_D: "增量",
  T_42_XXJ_WS_DELTATIME: "邏輯幀間隔",
  T_42_XXJ_WS_DELTATIME_D: "GS 兩次邏輯幀更新間隔",
  T_42_XXJ_WS_DEPTH: "層級",
  T_42_XXJ_WS_DEPTH_D: "圖標顯示層級",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "禁止拾取物品列表",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "禁止拾取物品列表",
  T_42_XXJ_WS_DRIVER: "駕駛座",
  T_42_XXJ_WS_DRIVINGSTATUS: "駕駛",
  T_42_XXJ_WS_DURATION_D1: "倒計時時長，單位為秒",
  T_42_XXJ_WS_DURATION_D2: "持續時間，單位為秒",
  T_42_XXJ_WS_DURATION_D3: "持續時間",
  T_42_XXJ_WS_DURATION_D4: "無敵效果持續時長，單位為秒",
  T_42_XXJ_WS_DURATIONTIMES: "持續時間",
  T_42_XXJ_WS_DURATIONTIMES_D: "持續時間，以秒為單位",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "動態摩擦",
  T_42_XXJ_WS_EASY: "非常簡單",
  T_42_XXJ_WS_ENDTIMES: "結束時間",
  T_42_XXJ_WS_ENDTIMES_D: "倒計時結束時間，以秒為單位",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "全域能量閾值",
  T_42_XXJ_WS_ENTITYVARNAME_D: "相對自身運動實體",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "裝備配件道具",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "將給定的歐拉角轉換為四元數",
  T_42_XXJ_WS_EXPONENTIATION_D: "求冪",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "額外背包空間",
  T_42_XXJ_WS_FIST: "拳頭",
  T_42_XXJ_WS_FONTTYPE: "字體枚舉",
  T_42_XXJ_WS_FONTTYPE_D: "字體枚舉",
  T_42_XXJ_WS_FORCESYNCVALUE: "強制同步 GS 狀態",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "強制同步值",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "GS 強制同步的位置資訊",
  T_42_XXJ_WS_FORCESYNCVALUE1: "強制同步位置資訊",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "可公式化屬性的實體",
  T_42_XXJ_WS_FORWARD_D: "方向向量",
  T_42_XXJ_WS_FRICTION_COMBINE: "摩擦組合方法",
  T_42_XXJ_WS_FUNCPOINT: "函數指針",
  T_42_XXJ_WS_FUNCPOINT_D: "函式實例指標，指向一個函式的實例。它通常用於實現虛擬函式或委派機制。",
  T_42_XXJ_WS_GETMAPID_D: "獲取地圖 ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "退出載具",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "進入車輛（駕駛）",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "進入載具（乘客）",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "查找玩家今日 token 數據",
  T_42_XXJ_WS_GRAVITY: "全域重力",
  T_42_XXJ_WS_HANDHELDITEM: "當前手持物品",
  T_42_XXJ_WS_HANDHELDITEM_D: "當前手持物品",
  T_42_XXJ_WS_HARD: "困難",
  T_42_XXJ_WS_HASCOMPONENT_D: "是否存在組件",
  T_42_XXJ_WS_HEIGHTLIST_D: "高度增量列表",
  T_42_XXJ_WS_INDEXLIST_D: "訪問字串的索引列表",
  T_42_XXJ_WS_INSCENE: "在場景中",
  T_42_XXJ_WS_INSCENE_D: "在場景中",
  T_42_XXJ_WS_IS3D_D: "是否為 3D 音樂",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "倒計時或正計時",
  T_42_XXJ_WS_ISLOOP: "是否循環",
  T_42_XXJ_WS_ISLOOP_D: "是否循環指令",
  T_42_XXJ_WS_ISREPLAY_D: "是否從頭開始",
  T_42_XXJ_WS_ISSWITCH_D: "為真時可以和相對運動組合，為假時可以和絕對運動組合。",
  T_42_XXJ_WS_JEEP: "吉普車",
  T_42_XXJ_WS_JUMPSTATUS: "跳躍狀態",
  T_42_XXJ_WS_LEFTVALUE: "左值",
  T_42_XXJ_WS_LEFTVALUE_D: "底數",
  T_42_XXJ_WS_LOGARITHM_D: "求對數值",
  T_42_XXJ_WS_LOOPABLE: "可循環",
  T_42_XXJ_WS_LOOPABLE_D: "可循環",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "獲取字典中所有 Key",
  T_42_XXJ_WS_MAPVALUE_D: "目標字典",
  T_42_XXJ_WS_MARKBTNHUD: "標記按鈕 HUD 開關",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "π",
  T_42_XXJ_WS_MAXDISTANCE_D: "最大距離",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "麥克風按鈕 HUD 開關",
  T_42_XXJ_WS_MINDISTANCE_D: "最小距離",
  T_42_XXJ_WS_MISSIONID_D: "任務 ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "任務完成進度，不能為負數",
  T_42_XXJ_WS_MODERATE: "適中",
  T_42_XXJ_WS_MONSTERTRUCK: "怪獸卡車",
  T_42_XXJ_WS_MOTORBIKE: "機車",
  T_42_XXJ_WS_MOVEMENTSTATUS: "移動狀態",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "兩個四元數相乘（代表旋轉合成）",
  T_42_XXJ_WS_NORMAL: "普通",
  T_42_XXJ_WS_OBSOLETE: "已廢棄",
  T_42_XXJ_WS_OPENPLAYERVIEW: "啟用玩家視角",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "啟用玩家視角",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "武器類型",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "武器類型",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "優先處理玩家配置。",
  T_42_XXJ_WS_PARAMSARRAY: "參數陣列",
  T_42_XXJ_WS_PARAMSARRAY_D: "參數陣列輸出涉及的參數列表。需要與格式描述中的 %v 數量相匹配。",
  T_42_XXJ_WS_PARAMSARRAY_D1: "傳遞給自定義函數的實際參數列表。",
  T_42_XXJ_WS_PARTVISABLEMASK1: "部件可見度遮罩 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "部件可見度遮罩 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "部件可見度遮罩 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "部件可見度遮罩 4",
  T_42_XXJ_WS_PASSENGER1: "乘客座 1",
  T_42_XXJ_WS_PASSENGER2: "乘客座 2",
  T_42_XXJ_WS_PASSENGER3: "乘客座 3",
  T_42_XXJ_WS_PHYMAT: "物理材質",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "實體",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "相對自身每幀運動",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "相對自身每幀運動",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "相對自身運動",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "相對自身進行的運動",
  T_42_XXJ_WS_PLAYER_D: "需要上車的玩家",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "玩家行為屬性同步實體",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "玩家行為屬性同步實體",
  T_42_XXJ_WS_PRIORITY_D: "優先級",
  T_42_XXJ_WS_PROPID_D: "屬性 ID",
  T_42_XXJ_WS_QUATERNION: "四元數",
  T_42_XXJ_WS_QUATERNION_D: "四元數是一個特殊的四維向量，僅用於表示旋轉",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "將四元數轉換為軸角表示",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "將給定四元數轉換為四元數，若四元數不符標準，返回 (0,0,0)",
  T_42_XXJ_WS_REPEATTIMES_D: "播放次數，預設為 1",
  T_42_XXJ_WS_RESETPLAYABLE_D: "重置",
  T_42_XXJ_WS_RIGHTVALUE: "右值",
  T_42_XXJ_WS_RIGHTVALUE_D: "指數",
  T_42_XXJ_WS_SEATTYPE: "載具座位枚舉",
  T_42_XXJ_WS_SEPSTR_D: "用於分隔的字符",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "設置玩家落地傷害",
  T_42_XXJ_WS_SETTINGSBTNHUD: "設定按鈕 HUD 開關",
  T_42_XXJ_WS_SHOWPOSITION: "顯示位置",
  T_42_XXJ_WS_SHOWPOSITION_D: "顯示位置",
  T_42_XXJ_WS_SIGNALICOHUD: "網路連線按鈕 HUD 開關",
  T_42_XXJ_WS_SIMPLE: "簡單",
  T_42_XXJ_WS_SLERPQUATERNION_D: "從A到B的球型四元數插值",
  T_42_XXJ_WS_SOUNDENTITY_D: "音效實體代表一個正在播放的音效",
  T_42_XXJ_WS_SPEAKERBTNHUD: "載具喇叭按鈕 HUD 開關",
  T_42_XXJ_WS_SPLITSTRING_D: "用某個字串作為分隔符號，將字串分隔為切片",
  T_42_XXJ_WS_SPORTSCAR: "超跑",
  T_42_XXJ_WS_SPRINTSTATUS: "衝刺狀態",
  T_42_XXJ_WS_SRCVAL_D: "源值",
  T_42_XXJ_WS_STARTTICKCOUNT: "GS 開始運作的時刻",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "GS 開始運作的時刻",
  T_42_XXJ_WS_STARTTIME_D: "開始時間",
  T_42_XXJ_WS_STARTTIME_D1: "開始時間",
  T_42_XXJ_WS_STATE_D: "玩家狀態：活躍、擊倒、死亡",
  T_42_XXJ_WS_STATE_D1: "判斷該音效是否播放中",
  T_42_XXJ_WS_STATIC_FRICTION: "靜摩擦力",
  T_42_XXJ_WS_STRELEMS_D: "目標字串集合",
  T_42_XXJ_WS_STRINGFINDAT_D: "根據索引列表，返回最終組合字串",
  T_42_XXJ_WS_STRINGJOIN_D: "以指定標識符連接字串",
  T_42_XXJ_WS_STRINGLOWER_D: "字串中所有字符轉換為小寫",
  T_42_XXJ_WS_STRINGSTRIP_D: "刪除字串兩側的空白字符",
  T_42_XXJ_WS_STRINGUPPER_D: "字串中所有字符轉換為大寫",
  T_42_XXJ_WS_STYLE_D: "播放方式",
  T_42_XXJ_WS_SUV: "皮卡車",
  T_42_XXJ_WS_SWITCH: "為真時可以和相對運動組合，為假時必須和絕對運動組合，否則屬性會不正確生效",
  T_42_XXJ_WS_SWITCH_D: "為真時可以和相對運動組合，為假時必須和絕對運動組合，否則屬性會不正確生效。",
  T_42_XXJ_WS_TARGETENTITY_D: "目標實體",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "團隊回合得分背景",
  T_42_XXJ_WS_TEAMSEQ_D: "對應隊伍實體中的隊伍序號屬性",
  T_42_XXJ_WS_TEMPORARYSHIELD: "臨時護盾值",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "臨時護盾值",
  T_42_XXJ_WS_TEXT_D: "需要過濾髒字的文本",
  T_42_XXJ_WS_THREESTATESWITCH: "三態切換",
  T_42_XXJ_WS_THROWINGKNIFE_D: "飛刀（可拾取）",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "飛刀",
  T_42_XXJ_WS_TUKTUK: "嘟嘟車",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "團隊比賽細節",
  T_42_XXJ_WS_UNIQUEID: "唯一 ID",
  T_42_XXJ_WS_UNIQUEID_D: "唯一 ID",
  T_42_XXJ_WS_VALUE_D: "值",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "方向向量轉為歐拉角",
  T_42_XXJ_WS_VEHICLEID: "載具 ID",
  T_42_XXJ_WS_VEHICLESKINID: "載具外觀 ID",
  T_42_XXJ_WS_VERYHARD: "非常困難",
  T_42_XXJ_WS_VOLUME_D: "音量大小，預設為 50",
  T_42_XXJ_WS_WEAPONTYPE_D: "武器主類型",
  T_42_XXJ_WS_WORKSHOPCODE: "地圖代碼",
  T_42_XXJ_WS_WORKSHOPCODE_D: "對應數據庫某筆數據的地圖代碼",
  T_42_XXJ_WS_WORLDPOSITION: "世界座標",
  T_42_XXJ_WS_WORLDPOSITION_D: "世界座標",
  T_42_XYL_WS_ITEM275: "軍用油罐",
  T_42_XYL_WS_ITEM276: "沙袋 A",
  T_42_XYL_WS_ITEM277: "沙袋 B",
  T_42_XYL_WS_ITEM278: "沙袋 C",
  T_42_XYL_WS_ITEM279: "沙袋",
  T_42_XYL_WS_ITEM280: "雙層別墅",
  T_42_XYL_WS_ITEM281: "軍火工廠",
  T_42_XYL_WS_ITEM282: "石牆 A",
  T_42_XYL_WS_ITEM283: "石牆 B",
  T_42_XYL_WS_ITEM284: "石牆 C",
  T_42_XYL_WS_ITEM285: "石牆 D",
  T_42_XYL_WS_ITEM286: "軍用物資箱 A",
  T_42_XYL_WS_ITEM287: "銅幣",
  T_42_XYL_WS_ITEM288: "銀幣",
  T_42_XYL_WS_ITEM289: "金幣",
  T_42_XYL_WS_ITEM290: "鑽石",
  T_42_XYL_WS_ITEM291: "碎鑽",
  T_42_XYL_WS_ITEM292: "紅寶石",
  T_42_XYL_WS_ITEM293: "綠寶石",
  T_42_XYL_WS_ITEM294: "藍寶石",
  T_42_XYL_WS_ITEM295: "警告標誌",
  T_42_XYL_WS_ITEM297: "廢墟",
  T_42_XYL_WS_ITEM297TRUE: "控制裝置",
  T_42_XYL_WS_ITEM298: "物資箱 B",
  T_42_XYL_WS_ITEM299: "雪堆",
  T_42_XYL_WS_ITEM300: "高科技牆壁 A",
  T_42_XYL_WS_ITEM301: "高科技牆壁 B",
  T_42_XYL_WS_ITEM302: "冰凍石塊 F",
  T_42_XYL_WS_ITEM303: "冰凍石塊 E",
  T_42_XYL_WS_ITEM304: "高科技平台 A",
  T_42_XYL_WS_ITEM305: "高科技樓梯 A",
  T_42_XYL_WS_ITEM306: "勘察燈 A",
  T_42_XYL_WS_ITEM307: "廢墟擋板 A",
  T_42_XYL_WS_ITEM308: "廢墟擋板 B",
  T_42_XYL_WS_ITEM309: "廢墟鋼架 A",
  T_42_XYL_WS_ITEM310: "廢墟石塊 A",
  T_42_XYL_WS_ITEM311: "廢墟石塊 B",
  T_42_XYL_WS_ITEM312: "廢墟石塊 C",
  T_42_XYL_WS_ITEM313: "探照燈 A",
  T_42_XYL_WS_ITEM314: "廢墟鋼筋 A",
  T_42_XYL_WS_LOGICALOBJECT: "邏輯",
  T_42_XYL_WS_THEMEHIGHTECH: "高科技",
  T_42_XYL_WS_THEMEICE: "冰雪",
  T_42_XYL_WS_THEMEMILITARY: "軍事",
  T_42_XYL_WS_THEMEOBJECTS: "主題物件",
  T_42_XYL_WS_TIMERCONTINUE: "計時器繼續事件",
  T_42_XYL_WS_TIMERCYCLE: "循環次數",
  T_42_XYL_WS_TIMERDOWN: "倒計時",
  T_42_XYL_WS_TIMEREND: "計時器結束事件",
  T_42_XYL_WS_TIMEREVENT: "自訂計時器事情",
  T_42_XYL_WS_TIMEREVENT1: "計時器控制",
  T_42_XYL_WS_TIMEREVENT2: "設置計時器事件",
  T_42_XYL_WS_TIMERORDER: "計時順序",
  T_42_XYL_WS_TIMERPAUSE: "計時器暫停事件",
  T_42_XYL_WS_TIMERSTART1: "計時器啟動時間",
  T_42_XYL_WS_TIMERSTART2: "計時器啟動事件",
  T_42_XYL_WS_TIMERUP: "正計時",
  T_42_XYL_WS_TRIGGERTIME_MS: "觸發時間（毫秒）",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "可乘載多人的飛行器",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "個人積分",
  T_42_ZZ_GUILDWAR_SCORE: "積分",
  T_43_B_SKILL_DESC_MONKEYGOD: "變身成灌木叢，持續時間 [FFB300]{1} 秒[-]。冷卻時間：[FFB300]{0} 秒[-]。攻擊他人或被攻擊將恢復原狀。擊倒敵人時冷卻時間重置。",
  T_43_B_SKILL_DESC_Nanoscientist: "受到致死傷害時展開奈米護盾免疫死亡，[FFB300]{0} 秒[-]內免疫傷害，期間無法攻擊或移動，隨後生成 [FFB300]{1} HP [-]臨時護盾，持續 [FFB300]{2} 秒[-]。護盾消失時，使用者將被淘汰。冷卻時間：[FFB300]{3} 秒[-]",
  T_43_B_SKILL_DESC_ORION: "將 EP 轉化為 [FFB300]{0} 腥紅能量[-]。消耗 [FFB300]{1} 腥紅能量[-]，使自身無法攻擊且免疫任何傷害，並每秒吸取 [FFB300]{3} 公尺[-]內的敵人 [FFB300]{4} HP[-]，持續 [FFB300]{2} 秒[-]，期間自身機動性減少 [FFB300]{6}%[-]。冷卻時間：[FFB300]{5} 秒[-]。",
  T_43_CJ_F_A_RACER: "超跑情人(面飾)",
  T_43_CJ_F_B_RACER: "超跑情人(下裝)",
  T_43_CJ_F_H_RACER: "超跑情人(頭飾)",
  T_43_CJ_F_HA_RACER: "超跑情人(臉彩)",
  T_43_CJ_F_S_RACER: "超跑情人(鞋子)",
  T_43_CJ_F_T_RACER: "超跑情人(上裝)",
  T_43_CJ_M_A_RACER: "飆速型男(面飾)",
  T_43_CJ_M_B_MACHINERY: "機械降臨(下裝)",
  T_43_CJ_M_B_RACER: "飆速型男(下裝)",
  T_43_CJ_M_H_MACHINERY: "機械降臨(頭飾)",
  T_43_CJ_M_H_RACER: "飆速型男(頭飾)",
  T_43_CJ_M_HA_MACHINERY: "機械降臨(臉彩)",
  T_43_CJ_M_S_MACHINERY: "機械降臨(鞋子)",
  T_43_CJ_M_S_RACER: "飆速型男(鞋子)",
  T_43_CJ_M_T_MACHINERY: "機械降臨(上裝)",
  T_43_CJ_M_T_RACER: "飆速型男(上裝)",
  T_43_H_CHARACTER_GEEK_N: "萊達",
  T_43_H_VSK94_MAMBAS_N: "VSK94-曼巴嘶咬",
  T_43_HJ_WS_OPTION8: "其他",
  T_43_HJ_WS_TEXTURE_BAMBOO: "竹子",
  T_43_HJ_WS_TEXTURE_BEACH: "海灘",
  T_43_HJ_WS_TEXTURE_BRICK1: "磚牆 A",
  T_43_HJ_WS_TEXTURE_BRICK2: "磚牆 B",
  T_43_HJ_WS_TEXTURE_BRICK3: "磚牆 C",
  T_43_HJ_WS_TEXTURE_CEMENT: "水泥地板",
  T_43_HJ_WS_TEXTURE_CEMENT2: "水泥",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "水晶",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "草地 A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "草地 B",
  T_43_HJ_WS_TEXTURE_ICE: "冰塊",
  T_43_HJ_WS_TEXTURE_IRON: "金屬地板",
  T_43_HJ_WS_TEXTURE_IRON2: "貨櫃",
  T_43_HJ_WS_TEXTURE_LAVA: "岩漿",
  T_43_HJ_WS_TEXTURE_MARBLE: "大理石地板",
  T_43_HJ_WS_TEXTURE_NONE: "空",
  T_43_HJ_WS_TEXTURE_STONE: "石頭",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "桌巾 A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "桌巾 B",
  T_43_HJ_WS_TEXTURE_WOOD: "木頭",
  T_43_HJ_WS_TEXTURE_WOODEN: "木地板 A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "木地板",
  T_43_JH_WS_MAPTAG1: "適合新手",
  T_43_JH_WS_MAPTAG10: "無趣新內容",
  T_43_JH_WS_MAPTAG11: "獎勵感低",
  T_43_JH_WS_MAPTAG12: "獎勵不平衡",
  T_43_JH_WS_MAPTAG13: "成長感低",
  T_43_JH_WS_MAPTAG14: "不適合新手",
  T_43_JH_WS_MAPTAG15: "引導不清楚",
  T_43_JH_WS_MAPTAG16: "缺乏引導",
  T_43_JH_WS_MAPTAG17: "中離玩家多",
  T_43_JH_WS_MAPTAG18: "操作複雜",
  T_43_JH_WS_MAPTAG19: "介面混亂",
  T_43_JH_WS_MAPTAG2: "首選新內容",
  T_43_JH_WS_MAPTAG20: "地圖設計差",
  T_43_JH_WS_MAPTAG21: "爽快射擊",
  T_43_JH_WS_MAPTAG22: "快節奏",
  T_43_JH_WS_MAPTAG23: "開放世界",
  T_43_JH_WS_MAPTAG24: "劇情豐富",
  T_43_JH_WS_MAPTAG25: "進度",
  T_43_JH_WS_MAPTAG26: "運動模擬",
  T_43_JH_WS_MAPTAG27: "合作任務",
  T_43_JH_WS_MAPTAG28: "社交",
  T_43_JH_WS_MAPTAG29: "豐富副本",
  T_43_JH_WS_MAPTAG3: "活躍玩家",
  T_43_JH_WS_MAPTAG30: "自由探索",
  T_43_JH_WS_MAPTAG31: "排名挑戰",
  T_43_JH_WS_MAPTAG32: "成就",
  T_43_JH_WS_MAPTAG33: "貨幣兌換",
  T_43_JH_WS_MAPTAG4: "精緻地圖",
  T_43_JH_WS_MAPTAG40: "豐富獎勵",
  T_43_JH_WS_MAPTAG41: "令人滿意的成長",
  T_43_JH_WS_MAPTAG42: "熱門訓練島",
  T_43_JH_WS_MAPTAG43: "熱門單槍匹馬地圖",
  T_43_JH_WS_MAPTAG44: "熱門戰區",
  T_43_JH_WS_MAPTAG5: "卡頓",
  T_43_JH_WS_MAPTAG6: "困難合作任務",
  T_43_JH_WS_MAPTAG7: "Bug 多",
  T_43_JH_WS_MAPTAG8: "更新頻率低",
  T_43_JH_WS_MAPTAG9: "遊戲內活動無趣",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "遙控蜘蛛(萊達)",
  T_43_SJ_WS_AIRDROP_ITEMS: "空投道具",
  T_43_SJ_WS_AIRDROP_NAME: "空投",
  T_43_SJ_WS_AIRDROP_TIME: "投放時間",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "空投道具",
  T_43_SJ_WS_ANITRIGGER_AUTO: "是否自動播放",
  T_43_SJ_WS_ANITRIGGER_CENTER: "是否使用錨點播放",
  T_43_SJ_WS_ANITRIGGER_CLIP: "動畫名稱",
  T_43_SJ_WS_ANITRIGGER_LOOP: "是否循環播放",
  T_43_SJ_WS_ANITRIGGER_NAME: "動畫觸發 HUD 組件",
  T_43_SJ_WS_RESET_ROUND: "每回合重置",
  T_43_SJ_WS_START_DROPTIME: "開始掉落時間(毫秒)",
  T_43_SJ_WS_TRIGGER_ANIMA: "動畫觸發器",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "寵物外觀：潑水絨恩",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "機車-格鬥爭霸",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "補充戰鬥中急需的子彈醫療物資",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "軍備物資",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "產生一個 [FFB300]{1} HP[-]的假人，它會自主移動 [FFB300]{0} 秒[-]。當假人在[FFB300] {3} 公尺[-]內時，再次使用技能可與其交換位置。[FFB300]{4} 秒[-]內只能交換一次，總共最多[FFB300] {2} 次[-]。摧毀假人的玩家將被標記[FFB300] {5} 秒[-]。冷卻時間：[FFB300]{6} 秒[-]。",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "角色技能傷害",
  T_43_XXJ_WS_AIRDROP: "空投與殭屍",
  T_43_XXJ_WS_ALPHA: "透明度",
  T_43_XXJ_WS_ALPHA_D: "HUD 的整體透明度，範圍為 0 至 1",
  T_43_XXJ_WS_ANIMATIONCTRLID: "動畫控制器 ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "用以描述動畫控制器資產的 ID",
  T_43_XXJ_WS_AUDIOID: "音訊 ID",
  T_43_XXJ_WS_AUDIOID_D: "用於描述音訊資產的 ID",
  T_43_XXJ_WS_BACKGRCOLOR: "背景顏色",
  T_43_XXJ_WS_BACKGRCOLOR_D: "血條邊框和模糊背景的顏色",
  T_43_XXJ_WS_BURNING: "載具爆炸後燃燒傷害",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "用於描述配置表資產的 ID",
  T_43_XXJ_WS_CURRENTHP: "當前生命值",
  T_43_XXJ_WS_CURRENTHP_D: "當前生命值",
  T_43_XXJ_WS_DAMAGEMAKER_D: "造成傷害的遊戲實體",
  T_43_XXJ_WS_DAMAGEZONE: "傷害區傷害",
  T_43_XXJ_WS_DEFAULT: "預設",
  T_43_XXJ_WS_DEFAULT_D: "預設",
  T_43_XXJ_WS_EFFECTID: "特效 ID",
  T_43_XXJ_WS_EFFECTID_D: "用於描述特效資產的 ID",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "可戰鬥的實體，例如能攻擊、被攻擊或淘汰等",
  T_43_XXJ_WS_FOLLOWTARGET: "跟隨目標",
  T_43_XXJ_WS_FOLLOWTARGET_D: "必須跟隨一個帶有 Transform 組件的實體",
  T_43_XXJ_WS_GAINHPCOLOR: "增加生命值顏色",
  T_43_XXJ_WS_GAINHPCOLOR_D: "生命值增加時，增加部分短暫顯示此顏色",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "是否無落地傷害",
  T_43_XXJ_WS_ISOPENTWEEN: "生命值變化效果",
  T_43_XXJ_WS_ISOPENTWEEN_D: "啟用時，以不同顏色顯示生命值變化",
  T_43_XXJ_WS_KNOCKDOWN_D1: "玩家處於擊倒狀態",
  T_43_XXJ_WS_KNOCKDOWN_D2: "設置被淘汰時擊倒狀態的處理方式",
  T_43_XXJ_WS_KNOCKDOWN_D3: "復活源類型，玩家從擊倒狀態復活",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "擊倒狀態",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "擊倒狀態類型",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "擊倒狀態處理方式，保持預設邏輯，跳過擊倒狀態，強制擊倒狀態",
  T_43_XXJ_WS_LEVEL: "等級",
  T_43_XXJ_WS_LEVEL_D: "等級",
  T_43_XXJ_WS_LEVEL_D1: "當前的殭屍等級",
  T_43_XXJ_WS_LINESPACING: "生命值分隔線間隔",
  T_43_XXJ_WS_LINESPACING_D: "每兩個分隔線之間的 HP ≤ 0 則不顯示",
  T_43_XXJ_WS_LOSEHPCOLOR: "減少生命值顏色",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "生命值減少時，失去的部分短暫顯示此顏色",
  T_43_XXJ_WS_MAINCOLOR: "主要顏色",
  T_43_XXJ_WS_MAINCOLOR_D: "生命值、等級和描邊的顏色",
  T_43_XXJ_WS_MINISENTRY: "哨塔",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "哨塔攻擊目標類型枚舉",
  T_43_XXJ_WS_MISSILEEXPLODE: "導彈爆炸",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "強制擊倒",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "強制擊倒",
  T_43_XXJ_WS_OFFSET: "偏移量",
  T_43_XXJ_WS_OFFSET_D: "相對於跟隨目標的偏移",
  T_43_XXJ_WS_OILDRUMEXPLODE: "油桶爆炸",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "僅控制器主動發生運動時才會觸發",
  T_43_XXJ_WS_PLAYER_D: "遊戲內玩家實體，每位玩家一個",
  T_43_XXJ_WS_PLAYERHEADHUD: "玩家頭部 HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "跟隨玩家頭部上方的資訊",
  T_43_XXJ_WS_PLAYERNAME: "玩家名稱",
  T_43_XXJ_WS_PLAYERNAME_D: "顯示擁有當前血條的玩家名稱",
  T_43_XXJ_WS_PLAYERORVEHICLE: "玩家或載具",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "指代玩家實體、載具實體類型的別名",
  T_43_XXJ_WS_SCALE: "縮放",
  T_43_XXJ_WS_SCALE_D: "決定整體 HUD 縮放大小，字體也一同縮放",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "顯示傷害數字",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "預設開啟。顯示傷害數字。",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "跳過擊倒",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "跳過擊倒狀態，立即淘汰",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "是否跳過交錯動畫",
  T_43_XXJ_WS_TEAM_D: "(已廢棄，請使用隊伍 ID)",
  T_43_XXJ_WS_TERRAIN: "地面",
  T_43_XXJ_WS_TERRAIN_D: "地面組件，無法修改任何參數，僅用於檢測函數",
  T_43_XXJ_WS_TOTALHP: "總生命值",
  T_43_XXJ_WS_TOTALHP_D: "總生命值",
  T_43_XXJ_WS_TWEENENTITY: "補間實體",
  T_43_XXJ_WS_VEHICLEEXPLODE: "載具爆炸",
  T_43_XXJ_WS_WIDTH: "長度",
  T_43_XXJ_WS_WIDTH_D: "畫面上顯示血條的長度",
  T_43_XXJ_WS_ZOMBIE: "殭屍",
  T_43_XYL_WS_DROIDFIST: "拳頭(啟示錄)",
  T_43_XYL_WS_DROIDFLAME: "火焰噴射器(啟示錄)",
  T_43_XYL_WS_JAPANESE: "日式",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "自訂遊戲事件日誌，用於分析用戶體驗",
  T_43_YU_WS_AIRDROPSTATE: "空投掉落狀態（1：準備、2：掉落中、3：著地）",
  T_43_YU_WS_AIRDROPSTATE_D: "空投掉落狀態（1：準備、2：掉落中、3：著地）",
  T_43_YU_WS_ANIMATIONCLIPID: "自訂動畫資源 ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "自訂動畫資源 ID",
  T_43_YU_WS_ASKBUYTARGET: "請求購買目標",
  T_43_YU_WS_ASKBUYTARGET_D: "指定目標，發送購買請求",
  T_43_YU_WS_ASKEDLIST: "被請求的物品列表",
  T_43_YU_WS_ASKEDLIST_D: "被請求的物品列表",
  T_43_YU_WS_BACKGROUNDCOLOR1: "背景顏色 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "上方背景顏色",
  T_43_YU_WS_BACKGROUNDCOLOR2: "背景顏色 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "下方背景顏色",
  T_43_YU_WS_BATCHCOMBINERENDER: "合併子物件節點",
  T_43_YU_WS_BINDMONEYENTITYLIST: "綁定的貨幣實體列表",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "綁定的貨幣實體列表",
  T_43_YU_WS_BINDWALLETENTITYID: "綁定的錢包實體 ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "綁定的錢包實體 ID",
  T_43_YU_WS_CENTEROFFSET: "中心點偏移",
  T_43_YU_WS_CENTEROFFSET_D: "膠囊體碰撞盒的偏移值",
  T_43_YU_WS_COLLECTIONID: "收藏 ID",
  T_43_YU_WS_COLLECTIONID_D: "用於資源資訊收藏的 ID",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "新建空投",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "建立傷害跳字",
  T_43_YU_WS_CROSSPLATFORM_D: "選擇後，若在服務端調用會發送給用戶端，用戶端調用則發送給服務端",
  T_43_YU_WS_CSROUNDRESULTHUD: "回合結果 HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "每回合結束時顯示結果",
  T_43_YU_WS_CURRENTEMOTECLIP: "當前播放的表情動畫資源 ID",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "當前播放的表情動畫資源 ID",
  T_43_YU_WS_DAMAGE_D: "安全區外傷害",
  T_43_YU_WS_DICTIONARY: "字典",
  T_43_YU_WS_DIRECTIONRULERHUD: "羅盤",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "頂部羅盤",
  T_43_YU_WS_DOTWEEN_D: "是否執行補間動畫",
  T_43_YU_WS_DROPITEMS_D: "空投中物品",
  T_43_YU_WS_DURATION: "恢復速度（毫秒）",
  T_43_YU_WS_ENERGY: "EP 恢復量",
  T_43_YU_WS_ENERGY_D: "EP 修改值",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "趴下",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "蹲下",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "衝刺",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "站立",
  T_43_YU_WS_EVENTID: "事件 ID",
  T_43_YU_WS_EVENTID_D: "指代某個事件",
  T_43_YU_WS_FACTION: "陣營實體",
  T_43_YU_WS_FACTION_D: "陣營實體",
  T_43_YU_WS_FACTION_D1: "向陣營請求幫助購買",
  T_43_YU_WS_FINALRADIUS_D: "安全區的最終半徑",
  T_43_YU_WS_FIRSTAIDKIT: "急救包",
  T_43_YU_WS_FIRSTAIDKIT_D: "急救包",
  T_43_YU_WS_FIRSTPERSONMODEL: "新版第一人稱相機",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "新版第一人稱相機",
  T_43_YU_WS_FONTCOLOR_D: "字體顏色",
  T_43_YU_WS_FONTSIZE_D: "字體大小",
  T_43_YU_WS_FORBIDEN: "禁用",
  T_43_YU_WS_FORBIDEN_D: "禁用 HUD 購買請求",
  T_43_YU_WS_FREEZINGTIME: "凍結時間",
  T_43_YU_WS_FREEZINGTIME_D: "命中玩家後造成的凍結時間",
  T_43_YU_WS_GRAVITY: "自身受到的重力加速度",
  T_43_YU_WS_GRAVITY_D: "該重力加速度僅作用於該玩家控制器",
  T_43_YU_WS_HANDCATAPULT: "氣流噴射台",
  T_43_YU_WS_HANDCATAPULT_D: "氣流噴射台",
  T_43_YU_WS_HEALTH: "生命恢復量",
  T_43_YU_WS_HEALTH_D: "護甲耐久度恢復值",
  T_43_YU_WS_HEIGHT: "總高度，包括上下半球",
  T_43_YU_WS_HELPEDPLAYER_D: "被救助的玩家",
  T_43_YU_WS_HELPPLAYER_D: "幫助購買的玩家",
  T_43_YU_WS_HORIZONTALMAXANGLE: "右側射界角度",
  T_43_YU_WS_HORIZONTALMINANGLE: "左側射界角度",
  T_43_YU_WS_HUDTOGGLE: "自訂切換控件",
  T_43_YU_WS_HUDTOGGLE_D: "HUD 切換實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_43_YU_WS_INHALER: "治療呼吸器",
  T_43_YU_WS_INHALER_D: "治療呼吸器",
  T_43_YU_WS_INITRADIUS_D: "安全區的初始半徑",
  T_43_YU_WS_INT64: "64 位整數",
  T_43_YU_WS_INT64_D: "整數類型，64 位帶符號整型",
  T_43_YU_WS_ISAPPLYSHADOW: "投影",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "底部是否發生碰撞",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "當前播放的表情動畫是否循環",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "當前播放的表情動畫是否循環",
  T_43_YU_WS_ISSIDECOLLIDING: "側邊是否發生碰撞",
  T_43_YU_WS_ISSLIDING: "是否正在滑落",
  T_43_YU_WS_ISTOPCOLLIDING: "頂部是否發生碰撞",
  T_43_YU_WS_ITEM331: "高科技裝置 A",
  T_43_YU_WS_ITEM332: "高科技石頭 A",
  T_43_YU_WS_ITEM333: "高科技螢幕 A",
  T_43_YU_WS_ITEM334: "高科技容器 A",
  T_43_YU_WS_ITEM335: "高科技貨櫃 A",
  T_43_YU_WS_ITEM336: "石沙發 A",
  T_43_YU_WS_ITEM337: "高科技交換機 A",
  T_43_YU_WS_ITEM338: "高科技管道 A",
  T_43_YU_WS_ITEM339: "金屬平台 A",
  T_43_YU_WS_ITEM340: "高科技桌子 A",
  T_43_YU_WS_ITEM341: "高科技桌子 B",
  T_43_YU_WS_ITEM342: "高科技桌子 C",
  T_43_YU_WS_ITEM343: "高科技電腦 A",
  T_43_YU_WS_ITEM344: "石頭 A",
  T_43_YU_WS_ITEM345: "石頭 B",
  T_43_YU_WS_ITEM346: "石頭 C",
  T_43_YU_WS_ITEM347: "石頭 D",
  T_43_YU_WS_ITEM348: "石頭 E",
  T_43_YU_WS_ITEM349: "石頭 F",
  T_43_YU_WS_ITEM350: "石頭 G",
  T_43_YU_WS_ITEM351: "日式門簾 A",
  T_43_YU_WS_ITEM352: "日式門簾 B",
  T_43_YU_WS_ITEM353: "日式門簾 C",
  T_43_YU_WS_ITEM354: "日式樓梯 A",
  T_43_YU_WS_ITEM355: "日式圍欄 A",
  T_43_YU_WS_ITEM356: "日式圍欄 B",
  T_43_YU_WS_ITEM357: "日式圍欄 C",
  T_43_YU_WS_ITEM358: "日式平台 A",
  T_43_YU_WS_ITEM359: "日式圍牆 B",
  T_43_YU_WS_ITEM360: "日式大門 B",
  T_43_YU_WS_ITEM361: "高科技牆 D",
  T_43_YU_WS_ITEM362: "高科技牆 B",
  T_43_YU_WS_ITEM363: "高科技直角護壁板",
  T_43_YU_WS_LEFTCOLOR: "左側顏色",
  T_43_YU_WS_LEFTCOLOR_D: "左側顏色",
  T_43_YU_WS_LEFTPLAYERARRAY: "左側玩家數組",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "左側玩家數組",
  T_43_YU_WS_LEFTSCORE: "左側得分",
  T_43_YU_WS_LEFTSCORE_D: "左側得分",
  T_43_YU_WS_LEFTSCOREAFTER: "左側最後得分",
  T_43_YU_WS_LEFTSCOREAFTER_D: "左側最後得分，用於得分切換動畫",
  T_43_YU_WS_LEVELOBJECTID: "關卡物件 ID",
  T_43_YU_WS_LEVELOBJECTID_D: "描述物件的類型，需透過 SceneEditPrefab 配置表解析後載入",
  T_43_YU_WS_LOCALPOSITION_D: "本地座標系的座標",
  T_43_YU_WS_LOCALPOSITION_D1: "相對位置",
  T_43_YU_WS_LOCALPOSITION_D2: "相對於右下角錨點的位置",
  T_43_YU_WS_LOCALPOSITION_D3: "相對於錨點的位置",
  T_43_YU_WS_LOCALROTATION_D: "本地座標系中的旋轉角，X、Y、Z分量分別是偏航角、俯仰角、翻滾角",
  T_43_YU_WS_LOCALROTATIONQ_D: "本地座標系的四元數",
  T_43_YU_WS_LOCALSCALE_D: "世界座標系中尺寸",
  T_43_YU_WS_MASS: "質量",
  T_43_YU_WS_MATERIALS: "材質列表",
  T_43_YU_WS_MATERIALS_D: "渲染要使用的材質列表",
  T_43_YU_WS_MAXSPEED: "最大絕對運動速度",
  T_43_YU_WS_MAXSPEED_D: "達到最大速度後，載具不會再提供馬力，但載具可能超過該最大速度（例如通過下坡）",
  T_43_YU_WS_MESHID: "網格 ID",
  T_43_YU_WS_MESHID_D: "用於描述網格資產的類型",
  T_43_YU_WS_MESHID1: "網格 ID",
  T_43_YU_WS_MESHID1_D: "用於渲染的網格",
  T_43_YU_WS_MINMOVEDISTANCE: "最小移動距離",
  T_43_YU_WS_MINMOVEDISTANCE_D: "小於該值的移動不會執行。如非特殊需求建議保持為 0",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "空投",
  T_43_YU_WS_MODULE_ANIMATION: "動畫",
  T_43_YU_WS_MODULE_AVATAR: "頭像",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "基礎屬性",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "行為樹",
  T_43_YU_WS_MODULE_BUFF: "增益效果",
  T_43_YU_WS_MODULE_CAMERA: "相機",
  T_43_YU_WS_MODULE_CHATCHANNEL: "聊天頻道",
  T_43_YU_WS_MODULE_CHECKPOINT: "檢查點",
  T_43_YU_WS_MODULE_COLLECTION: "收藏品",
  T_43_YU_WS_MODULE_COMBAT: "戰鬥",
  T_43_YU_WS_MODULE_COMPONENT: "組件",
  T_43_YU_WS_MODULE_CONVERT: "轉化",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "自訂房間參數",
  T_43_YU_WS_MODULE_DATABASE: "數據儲存",
  T_43_YU_WS_MODULE_DYEING: "染色",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "動態導航網格",
  T_43_YU_WS_MODULE_ECONOMY: "經濟",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF 平台",
  T_43_YU_WS_MODULE_FOOTBALL: "足球",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "幀率模式",
  T_43_YU_WS_MODULE_GAMERESULT: "遊戲結果",
  T_43_YU_WS_MODULE_GLOBAL: "全局",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "全局腳本",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "掛機與作弊",
  T_43_YU_WS_MODULE_HUD: "HUD 介面",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "輸入系統",
  T_43_YU_WS_MODULE_ITEMS: "物品",
  T_43_YU_WS_MODULE_LEVELOBJECT: "關卡物件",
  T_43_YU_WS_MODULE_LIST: "列表",
  T_43_YU_WS_MODULE_MAP: "地圖",
  T_43_YU_WS_MODULE_MATCHING: "匹配",
  T_43_YU_WS_MODULE_MATH: "數學",
  T_43_YU_WS_MODULE_MECHANISM: "機制參數",
  T_43_YU_WS_MODULE_MINIMAP: "小地圖",
  T_43_YU_WS_MODULE_MORPH: "轉換型態",
  T_43_YU_WS_MODULE_OTHER: "其他",
  T_43_YU_WS_MODULE_PET: "寵物",
  T_43_YU_WS_MODULE_PHYSICS: "物理",
  T_43_YU_WS_MODULE_PLAYABLE: "可播放",
  T_43_YU_WS_MODULE_PLAYER: "玩家",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "玩家腳本",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "預設角色",
  T_43_YU_WS_MODULE_PROFILE: "個人檔案",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "屬性公式",
  T_43_YU_WS_MODULE_SAFEZONE: "安全區",
  T_43_YU_WS_MODULE_SCENE: "場景",
  T_43_YU_WS_MODULE_SKILL: "技能",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "靜態腳本",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "數據回報",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD 庫",
  T_43_YU_WS_MODULE_STRINGS: "字串",
  T_43_YU_WS_MODULE_TEAM: "隊伍",
  T_43_YU_WS_MODULE_WORKFLOW: "流程",
  T_43_YU_WS_MONEYICON: "貨幣圖標",
  T_43_YU_WS_MONEYICON_D: "貨幣圖標",
  T_43_YU_WS_MONEYICONCOLOR: "貨幣圖標顏色",
  T_43_YU_WS_MONEYICONCOLOR_D: "貨幣圖標顏色",
  T_43_YU_WS_MOVESAFEZONE_D: "安全區將從起始位置平滑的移動到結束位置。位於安全區外的玩家將受到一定的傷害",
  T_43_YU_WS_NEWVECTOR2: "構造二維向量",
  T_43_YU_WS_NEWVECTOR2_D: "獲取一個新構造的二維向量",
  T_43_YU_WS_OFFSET_D: "相對於目標實體的世界位置偏移量",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "玩家購買請求被滿足時",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "商店有玩家請求他人購買商品時",
  T_43_YU_WS_ONTOGGLECHANGE_D: "切換控件狀態變化時觸發",
  T_43_YU_WS_OPENSTATE: "打開狀態",
  T_43_YU_WS_OPENSTATE_D: "為真時顯示，否則隱藏",
  T_43_YU_WS_PACEMAKER: "強心針",
  T_43_YU_WS_PACEMAKER_D: "強心針",
  T_43_YU_WS_PARAMS_D: "參數列表",
  T_43_YU_WS_PARENT_D: "序列化時紀錄的實體 ID",
  T_43_YU_WS_PHYSICALCCT: "帶物理效果的玩家控制器",
  T_43_YU_WS_PHYSICALCCT_D: "有物理效果的玩家控制器",
  T_43_YU_WS_PLAYER_D: "購買商品的玩家",
  T_43_YU_WS_PLAYERDATAID: "玩家資料 ID",
  T_43_YU_WS_PLAYERDATAID_D: "自訂角色資源 ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "玩家姿勢枚舉",
  T_43_YU_WS_POSITION: "位置",
  T_43_YU_WS_POSITION_D: "世界座標系中的座標",
  T_43_YU_WS_POSITION_D1: "世界座標系中的座標，僅對 3D 音樂有效",
  T_43_YU_WS_PRESSEDSPRITE: "按下精靈圖",
  T_43_YU_WS_PRESSEDSPRITE_D: "按下精靈圖",
  T_43_YU_WS_PRESSEDSPRITETYPE: "按下精靈圖類型",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "按下精靈圖類型",
  T_43_YU_WS_PRETIME: "使用所需時間（毫秒）",
  T_43_YU_WS_RADIUS: "半徑",
  T_43_YU_WS_RANDOMRANGE_D: "確定位置後，根據隨機範圍再次修正位置",
  T_43_YU_WS_REQUESTPURCHASETYPE: "購買請求類型",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "商店購買請求",
  T_43_YU_WS_REQUESTTYPE: "請求類型",
  T_43_YU_WS_REQUESTTYPE_D: "當前 HUD 玩家請求的目標類型",
  T_43_YU_WS_RESPLAYERUUID: "預設玩家類型",
  T_43_YU_WS_RESPLAYERUUID_D: "玩家資源 ID",
  T_43_YU_WS_RESUUID: "資源 UUID",
  T_43_YU_WS_RESUUID_D: "指定要渲染的 Batch 資源 UUID",
  T_43_YU_WS_RIGHTCOLOR: "右側顏色",
  T_43_YU_WS_RIGHTCOLOR_D: "右側顏色",
  T_43_YU_WS_RIGHTPLAYERARRAY: "右側玩家數組",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "右側玩家數組",
  T_43_YU_WS_RIGHTSCORE: "右側得分",
  T_43_YU_WS_RIGHTSCORE_D: "右側得分",
  T_43_YU_WS_RIGHTSCOREAFTER: "右側最後得分",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "右側最後得分，用於得分切換動畫",
  T_43_YU_WS_ROTATIONQ_D: "世界座標系的四元數",
  T_43_YU_WS_ROUNDINFOHUD: "回合訊息 HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "回合開始時顯示的訊息",
  T_43_YU_WS_SELECTEDCOLOR: "未選中圖片顏色",
  T_43_YU_WS_SELECTEDCOLOR_D: "選中圖片顏色",
  T_43_YU_WS_SELECTEDSPRITE: "選中圖片",
  T_43_YU_WS_SELECTEDSPRITE_D: "選中圖片",
  T_43_YU_WS_SELECTEDTYPE: "選中圖片類型",
  T_43_YU_WS_SELECTEDTYPE_D: "選中圖片類型",
  T_43_YU_WS_SHADOWCOLOR: "投影顏色",
  T_43_YU_WS_SHADOWOFFSET: "投影偏移量",
  T_43_YU_WS_SHOWTAG: "是否顯示隊伍或陣營的標記點",
  T_43_YU_WS_SHOWTAG_D: "是否顯示隊伍或陣營的標記點",
  T_43_YU_WS_SHRINKDURATION_D: "縮圈持續時間",
  T_43_YU_WS_SIMPLERENDER_D: "橋接渲染組件，用於使用內置模型資源渲染",
  T_43_YU_WS_SKINWIDTH: "皮膚厚度",
  T_43_YU_WS_SKINWIDTH_D: "允許潛入膠囊體的深度，可以防止角色卡住或抖動",
  T_43_YU_WS_SLOPELIMIT: "最大上坡角度",
  T_43_YU_WS_SLOPELIMIT_D: "放置在超過該角度的坡面上，會向下滑動",
  T_43_YU_WS_SPEED: "出膛速度",
  T_43_YU_WS_STARTDROPTIME_D: "空投掉落時間，單位為毫秒",
  T_43_YU_WS_STARTPOS_D: "安全區起始位置",
  T_43_YU_WS_STATICICONCOLORS: "某刻度上顯示的圖標疊加色",
  T_43_YU_WS_STATICICONCOLORS_D: "某刻度上顯示的圖標疊加色",
  T_43_YU_WS_STATICICONS: "某刻度上顯示的圖標樣式",
  T_43_YU_WS_STATICICONS_D: "某刻度上顯示的圖標樣式",
  T_43_YU_WS_STEPOFFSET: "步距垂直偏移",
  T_43_YU_WS_STEPOFFSET_D: "只有超過該高度的障礙物才有阻擋效果",
  T_43_YU_WS_SUBTITLE: "副標題",
  T_43_YU_WS_SUBTITLE_D: "副標題",
  T_43_YU_WS_TARGET: "目標",
  T_43_YU_WS_TARGET_D: "彈出傷害跳字的目標實體",
  T_43_YU_WS_TARGETICONCOLORS: "標記目標顯示的圖標疊加色",
  T_43_YU_WS_TARGETICONCOLORS_D: "標記目標顯示的圖標疊加色",
  T_43_YU_WS_TARGETICONS: "標記目標顯示的圖標樣式",
  T_43_YU_WS_TARGETICONS_D: "標記目標顯示的圖標樣式",
  T_43_YU_WS_TARGETPOS_D: "安全區目標結束位置",
  T_43_YU_WS_TEAM: "隊伍",
  T_43_YU_WS_TEAM_D: "遊戲中的隊伍實體，每支隊伍一個",
  T_43_YU_WS_TEAM_D1: "像隊伍請求幫助購買",
  T_43_YU_WS_TIMEOFSTAY_D: "顯示停留時長，單位為毫秒",
  T_43_YU_WS_TITLE: "主標題",
  T_43_YU_WS_TITLE_D: "主標題",
  T_43_YU_WS_TRANSFORM_D: "位置旋轉、縮放和父子關係紀錄",
  T_43_YU_WS_UNSELECTEDCOLOR: "未選中圖片顏色",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "未選中圖片顏色",
  T_43_YU_WS_UNSELECTEDSPRITE: "未選中圖片",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "未選中圖片",
  T_43_YU_WS_UNSELECTEDTYPE: "未選中圖片類型",
  T_43_YU_WS_UNSELECTEDTYPE_D: "未選中圖片類型",
  T_43_YU_WS_USEPHYSICALCCT: "是否使用帶物理效果的玩家控制器",
  T_43_YU_WS_VALUE_D: "顯示的跳字內容",
  T_43_YU_WS_VECTOR2ADD: "二維向量相加",
  T_43_YU_WS_VECTOR2GETX: "取二維向量 X 分量",
  T_43_YU_WS_VECTOR2GETY: "取二維向量 Y 分量",
  T_43_YU_WS_VECTOR2SCALE: "二維向量縮放",
  T_43_YU_WS_VECTOR2SETX: "設置二維向量 X 分量",
  T_43_YU_WS_VECTOR2SETY: "設置二維向量 Y 分量",
  T_43_YU_WS_VECTOR2SUB: "二維向量相減",
  T_43_YU_WS_VELOCITY: "速度",
  T_43_YU_WS_VERTICALMAXANGLE: "最大俯角",
  T_43_YU_WS_VERTICALMINANGLE: "最小仰角",
  T_43_YU_WS_VISIBILITY_D: "表示是否能設置可見性",
  T_43_YU_WS_VISIBLE_D: "是否可見，不可見時用戶端停止渲染目標",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "高科技牆 A",
  T_43_ZY_WS_ITEM320: "高科技牆 C",
  T_43_ZY_WS_ITEM321: "高科技窗戶",
  T_43_ZY_WS_ITEM322: "高科技門",
  T_43_ZY_WS_ITEM323: "高科技直角屋頂",
  T_43_ZY_WS_ITEM324: "高科技圓形屋頂",
  T_43_ZY_WS_ITEM325: "高科技護壁板",
  T_43_ZY_WS_ITEM326: "高科技圓形護壁板",
  T_43_ZY_WS_ITEM327: "高科技樓梯",
  T_43_ZY_WS_ITEM328: "高科技裝飾 A",
  T_43_ZY_WS_ITEM329: "高科技建築 A",
  T_43_ZY_WS_ITEM330: "高科技建築 B",
  T_44_CJ_M_B_SPORT_TH: "體能健將(下裝)",
  T_44_CJ_M_H_SPORT_TH: "體能健將(頭飾)",
  T_44_CJ_M_S_SPORT_TH: "體能健將(鞋子)",
  T_44_CJ_M_T_SPORT_TH: "體能健將(上裝)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "科諾斯",
  T_44_H_M24_ONIMUSHA_N: "M24-鬼火狂蝕",
  T_44_H_USP45_CARNIVORE_N: "USP-暴戾毒牙",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "機車-街頭塗鴉",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "強制以最少玩家人數開始",
  T_44_JH_WS_HALFWAYKEY1: "優先選擇與完整隊伍開始",
  T_44_PD_PVE_DRAGON_NAME: "機甲巨龍．零式",
  T_44_QL_GRENADE_DRAGON: "龍霜手榴彈",
  T_44_QL_GRENADE_DRAGON_DES: "強化冰凍手榴彈，會於落點連續爆炸 3 次",
  T_44_QL_JUMPSHOESX: "龍族推進鞋",
  T_44_QL_JUMPSHOESX_DES: "裝備後在跳躍狀態下再次跳躍可於空中衝刺",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "安全區域關閉時間",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "安全區域消失時間。如果安全區域關閉時間小於安全區域開始時間，則不會生成安全區域。",
  T_44_SJ_WS_SAFEZONE_COLOR: "安全區顏色",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "傷害間隔時間",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "傷害間隔時間",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "傷害數值",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "單次對距離外的玩家造成的傷害",
  T_44_SJ_WS_SAFEZONE_DESC: "可放置的毒圈物件",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "毒圈最終半徑",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "毒圈最終半徑",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "安全區玩家清單",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "獲得安全區玩家清單",
  T_44_SJ_WS_SAFEZONE_NAME: "毒圈",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "縮圈時間(秒)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "安全區縮圈所需時間",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "毒圈初始半徑",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "毒圈初始半徑",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "開始縮圈時間",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "開始縮圈時間",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "安全區域開始時間",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "安全區在比賽中每回合出現的時間，預設為 0",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "等離子槍-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "啟用的透明度",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "啟用的透明度",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "主動技能 HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "添加組件到實體上，僅支援自訂組件（當組件已存在時不會重複添加）",
  T_44_XXJ_WS_ALLMEMBERS: "所有成員",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "區域外允許觸發按壓",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "允許指定區域外觸發",
  T_44_XXJ_WS_ARROWIMAGE: "箭頭圖片",
  T_44_XXJ_WS_ARROWIMAGE_D: "方向箭頭圖片",
  T_44_XXJ_WS_ARROWOFFSET: "箭頭偏移",
  T_44_XXJ_WS_ARROWOFFSET_D: "方向箭頭偏移",
  T_44_XXJ_WS_ARROWSIZE: "箭頭尺寸",
  T_44_XXJ_WS_ARROWSIZE_D: "方向箭頭尺寸",
  T_44_XXJ_WS_AUTOPLAY_D: "建立後自動播放",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "背景圖片",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "底座圖片",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "背景半徑",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "底座半徑",
  T_44_XXJ_WS_BAGSKINID: "背包塗裝 ID",
  T_44_XXJ_WS_BAGSKINID_D: "背包塗裝 ID",
  T_44_XXJ_WS_BONEPOSITION: "骨骼位置",
  T_44_XXJ_WS_BONEPOSITION_D: "骨骼節點的世界座標",
  T_44_XXJ_WS_CCTMOVE: "移動角色控制器",
  T_44_XXJ_WS_COLLIDER: "碰撞對象",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "碰撞器收集",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "用於描述碰撞形狀的組件",
  T_44_XXJ_WS_COLOR: "顏色",
  T_44_XXJ_WS_CONTENT: "內容",
  T_44_XXJ_WS_CONTENT_D: "錢包內容是貨幣的集合",
  T_44_XXJ_WS_CONTEXT_D: "要列印的內容",
  T_44_XXJ_WS_CROSSHAIRSHUD: "準星 HUD",
  T_44_XXJ_WS_CURVE_D: "曲線",
  T_44_XXJ_WS_EFFECTCOLOR_D: "表面貼圖顏色",
  T_44_XXJ_WS_ENABLE: "啟動",
  T_44_XXJ_WS_ENTITY_D: "實體",
  T_44_XXJ_WS_GETBAGSKINID_D: "獲取玩家背包塗裝配置",
  T_44_XXJ_WS_GETFACTION_D: "獲取陣營",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "獲取未卸載的加載場景",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "取得本地玩家",
  T_44_XXJ_WS_GROUPID: "群組 ID",
  T_44_XXJ_WS_GROUPID_D: "內部邏輯使用",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD 操縱桿控件",
  T_44_XXJ_WS_HUDJOYSTICK_D: "操縱桿實體，玩家通過 HUD 編輯器編輯的 HUD",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD 觸控板控件",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "HUD 觸控板控制，玩家通過 HUD 編輯器編輯的 HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "自訂 HUD 或 HUD 工具",
  T_44_XXJ_WS_ICON: "圖表",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "羅盤上總是顯示標記點",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "總是在羅盤上顯示標記點",
  T_44_XXJ_WS_INACTIVATEDALPHA: "未啟用的透明度",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "未啟用的透明度",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "調用時，實參個數與形參個數不符。預期數量為 {0}，而實際數量為 {1}。",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "是否為動態阻擋",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "是否為動態導航網格的動態阻擋",
  T_44_XXJ_WS_ISEND: "是否結束",
  T_44_XXJ_WS_ISEND_D: "是否結束",
  T_44_XXJ_WS_ISSERVERDRIVEN: "是否由伺服器驅動",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "如果為 false，則自訂物件無法透過 API 控制。",
  T_44_XXJ_WS_ISSUC_D: "返回執行結果",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "操縱桿拖動半徑",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "操縱桿拖動半徑",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "操縱桿圖片",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "操縱桿圖片",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "操縱桿半徑",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "操縱桿半徑",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "角色技能 ID 列表",
  T_44_XXJ_WS_LOOPTYPE_D: "循環類型",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "中途退出配置",
  T_44_XXJ_WS_MOUNTABLE: "可以掛載子節點的實體",
  T_44_XXJ_WS_MOUNTABLE_D: "可以掛載子節點的實體",
  T_44_XXJ_WS_MOVEMENT: "移動",
  T_44_XXJ_WS_NAME_D: "名稱",
  T_44_XXJ_WS_NATURALCONST: "自然常數",
  T_44_XXJ_WS_NATURALCONST_D: "減少重覆定義的自然常數枚舉",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "播放圖標動畫效果",
  T_44_XXJ_WS_OFFSET_D: "底座默認偏移量",
  T_44_XXJ_WS_ONFIRE_D: "每當玩家射擊、拳頭攻擊或近戰武器攻擊時觸發事件。",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "當玩家從俯臥/蹲姿站起時觸發事件",
  T_44_XXJ_WS_ONSTARTFIRE_D: "當玩家點擊射擊按鈕時觸發事件",
  T_44_XXJ_WS_OPTION: "選項",
  T_44_XXJ_WS_PASSIVESKILLHUD: "被動技能 HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "物理移動平台",
  T_44_XXJ_WS_PHYSICALMOVER_D: "該平臺上的玩家會自動跟隨移動和旋轉",
  T_44_XXJ_WS_PHYSICALOBJECT: "物理物件",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "可以對其施力",
  T_44_XXJ_WS_PI: "圓周率",
  T_44_XXJ_WS_PI_D: "π，圓周率",
  T_44_XXJ_WS_PLAYERS: "玩家列表",
  T_44_XXJ_WS_PLAYERS_D: "玩家列表",
  T_44_XXJ_WS_PLAYERSKILLID: "角色技能 ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "角色技能 ID，對應 AvatarSkill.csv 配置表",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "玩家從蹲姿/臥姿站起前的上一個姿勢",
  T_44_XXJ_WS_PRINT: "列印",
  T_44_XXJ_WS_PRINTERROR: "列印錯誤",
  T_44_XXJ_WS_PRINTERROR_D: "將目標數據以報錯形式列印到控制台",
  T_44_XXJ_WS_PRINTWARNING: "列印警告",
  T_44_XXJ_WS_PRINTWARNING_D: "將目標數據以警告形式列印到控制台",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "已玩家塗裝設置為優先",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "以玩家局外的塗裝配置為優先",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "按列號和關鍵字讀取行中的單元格內容",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "清除玩家背包塗裝配置",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "從實體上移除組件，僅支援使用者自訂組件",
  T_44_XXJ_WS_RESETBAGSKINID_D: "重置玩家背包塗裝配置，恢復為玩家局外的背包塗裝配置",
  T_44_XXJ_WS_SETBAGSKINID_D: "設置玩家背包塗裝配置",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "支援 Transform、骨骼部分、玩家與掛載點組件的實體",
  T_44_XXJ_WS_SHOWBACKGROUND: "顯示背景",
  T_44_XXJ_WS_SKINID_D: "背包塗裝 ID 與塗裝配置",
  T_44_XXJ_WS_SPEED_D: "播放速度",
  T_44_XXJ_WS_TARGET: "目標",
  T_44_XXJ_WS_TARGET_D: "目標物件",
  T_44_XXJ_WS_TITLE: "標題",
  T_44_XXJ_WS_TYPEID_D: "組件類型 ID，僅支援使用者自訂組件",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "上傳自訂比賽結果",
  T_44_XXJ_WS_WARNINGCSVTYPE: "類型不匹配，無法讀取表內容",
  T_44_XXJ_WS_X_D: "X 軸座標",
  T_44_XXJ_WS_Y_D: "Y 軸座標",
  T_44_XYL_WS_CTZSAFEZONE: "自訂安全區",
  T_44_XYL_WS_CTZSAFEZONEDESC: "根據設置的位置與屬性生成安全區的起點與終點",
  T_44_XYL_WS_HEMISPHERICALSHELL: "基礎半球殼",
  T_44_XYL_WS_QUARTERCYLINDER: "基礎四分之一圓柱體",
  T_44_XYL_WS_SQUAREPYRAMID: "基礎方錐",
  T_44_XYL_WS_TORUS: "基礎圓環",
  T_44_XYL_WS_TRIANGULARPYRAMID: "基礎三角錐",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "自訂遊戲事件日誌",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "新增用戶事件日誌",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "用於 UX 資料分析的自訂比賽事件日誌",
  T_44_YU_WS_ITEM366: "軍用牆壁 A",
  T_44_YU_WS_ITEM367: "軍用牆壁 B",
  T_44_YU_WS_ITEM368: "軍用牆壁 C",
  T_44_YU_WS_ITEM369: "軍用牆壁 D",
  T_44_YU_WS_ITEM370: "軍用窗戶 A",
  T_44_YU_WS_ITEM371: "軍用窗戶 B",
  T_44_YU_WS_ITEM372: "軍用窗戶 C",
  T_44_YU_WS_ITEM373: "軍用門 A",
  T_44_YU_WS_ITEM374: "軍用 B",
  T_44_YU_WS_ITEM375: "軍用斜屋頂 A",
  T_44_YU_WS_ITEM376: "軍用斜屋頂 B",
  T_44_YU_WS_ITEM377: "軍用樓梯 A",
  T_44_YU_WS_ITEM378: "軍用樓梯 B",
  T_44_YU_WS_ITEM379: "軍用梁柱 A",
  T_44_YU_WS_ITEM380: "軍用扶手 A",
  T_45_C_WEAPON_CUST_ENTRANCE: "自訂",
  T_45_CJ_TREATMENTGUN_Y_N: "治療手槍-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "卡熙蒂",
  T_45_H_EMOTE_MVPDANCE_N: "現在誰才是贏家呀～",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "檢視武器",
  T_45_HL_Moderation_fail_1: "很遺憾，你提交的專案未通過審核",
  T_45_HL_Moderation_fail_2: "涉及",
  T_45_HL_Moderation_fail_3: "原因如下：",
  T_45_HL_Moderation_fail_Location_1: "遊戲內容",
  T_45_HL_Moderation_fail_reason_1: "有害內容",
  T_45_HL_Moderation_fail_reason_10: "違反社群規範",
  T_45_HL_Moderation_fail_reason_11: "影響遊戲內經濟與侵犯虛擬財產",
  T_45_HL_Moderation_fail_reason_2: "不當內容",
  T_45_HL_Moderation_fail_reason_3: "政治敏感",
  T_45_HL_Moderation_fail_reason_4: "虛假資訊",
  T_45_HL_Moderation_fail_reason_5: "侵犯著作權",
  T_45_HL_Moderation_fail_reason_6: "侵犯隱私",
  T_45_HL_Moderation_fail_reason_7: "安全疑慮",
  T_45_HL_Moderation_fail_reason_8: "仇恨言論",
  T_45_HL_Moderation_fail_reason_9: "垃圾訊息",
  T_45_HL_Moderation_fail_reason_999: "其他問題",
  T_45_JH_WS_CLEMPTYOBJECT: "關卡物件組",
  T_45_JH_WS_PETSWITCH1: "是否在比賽中顯示寵物",
  T_45_QL_CSFPP_DES: "在團隊突襲中，透過第一人稱視角擊殺所有對手！",
  T_45_QL_CSFPP_NAME: "團隊突襲：第一人稱",
  T_45_QL_CSFPP_RANKNAME: "第一人稱",
  T_45_SJ_WS_REVIEW_23: "遊戲內容",
  T_45_SJ_WS_REVIEW_24: "{0}涉及{1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1}涉及{2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]點擊查看詳情 >>[-]",
  T_45_SJ_WS_REVIEW_27: "審核失敗",
  T_45_SJ_WS_REVIEW_28: "審核資訊",
  T_45_SJ_WS_REVIEW_29: "共有 {0} 項內容涉及違規",
  T_45_SJ_WS_REVIEW_31: "未通過審核",
  T_45_SJ_WS_REVIEW_32: "異常原因導致審核失敗",
  T_45_SJ_WS_REVIEW_TITLE: "違規詳情",
  T_45_SJ_WS_VAULTTRIGGER_DES: "可觸發翻越障礙物",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "翻越距離",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "該值控制玩家翻越動作的距離",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "翻越高度",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "該值控制玩家翻越時身體上下移動的高度",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "翻越觸發器",
  T_45_TYC_CL_TEMPLATE_WS: `淘汰模式，需在混戰中擊敗所有敵隊取得勝利。
你可以自由設定遊戲規則與調整遊戲參數。`,
  T_45_W_SPEEDMODE_FLIGHT_N: "飛行載具",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 為自動攻擊，1 為防禦攻擊，2 為完全不攻擊",
  T_45_XXJ_WS_ADDFRIEND: "添加好友",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "全自動",
  T_45_XXJ_WS_BASEDATA: "基礎數據",
  T_45_XXJ_WS_BOTH: "雙端",
  T_45_XXJ_WS_BYHIERARCHY: "按層級",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "按優先級從高到低",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "按優先級從低到高",
  T_45_XXJ_WS_CAMERA: "相機",
  T_45_XXJ_WS_CAMERATYPE: "相機類型",
  T_45_XXJ_WS_CENTERINVISIBLE: "隱藏中心",
  T_45_XXJ_WS_CLIENT: "用戶端",
  T_45_XXJ_WS_COLLIDERID: "碰撞資源 ID",
  T_45_XXJ_WS_COLLIDERID_D: "用於描述碰撞資產的類型",
  T_45_XXJ_WS_COMPONENT: "組件",
  T_45_XXJ_WS_CURRENTCAMERA: "目前相機",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "自訂推力",
  T_45_XXJ_WS_DOUBLE: "二連發",
  T_45_XXJ_WS_DUMP: "丟棄",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "允許空中移動",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "啟用重力旋轉",
  T_45_XXJ_WS_ENUM: "枚舉",
  T_45_XXJ_WS_EVENT: "事件",
  T_45_XXJ_WS_FILLAMOUNT: "填充值",
  T_45_XXJ_WS_FILLDIR: "填充方向",
  T_45_XXJ_WS_FIRETYPE: "火焰類型",
  T_45_XXJ_WS_FIRETYPE_D: "火焰類型",
  T_45_XXJ_WS_FIXEDDELTATIME: "固定幀更新間隔時間",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "固定幀更新間隔，以毫秒為單位",
  T_45_XXJ_WS_FORWARD: "本地座標軸 z 軸朝向",
  T_45_XXJ_WS_FORWARD_D: "本地座標系中 z 軸朝向方向",
  T_45_XXJ_WS_FUNCTIONTYPE: "功能類型",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "功能類型",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "本地玩家的瞄準方向",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "獲取本地時間戳",
  T_45_XXJ_WS_GRADIENT: "漸層",
  T_45_XXJ_WS_GRADIENTBOTTOM: "漸層底部",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "漸層底部透明度",
  T_45_XXJ_WS_GRADIENTTOP: "漸層頂部",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "漸層頂部透明度",
  T_45_XXJ_WS_HITPOSITION_D: "被子彈擊中的目標的世界座標",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "社交功能按鈕 UI 控件",
  T_45_XXJ_WS_INVERTFILL: "反向填充",
  T_45_XXJ_WS_ISGROUNDED: "是否著地",
  T_45_XXJ_WS_ISSILENCE: "是否靜音",
  T_45_XXJ_WS_ISSILENCE_D: "是否靜音",
  T_45_XXJ_WS_ISSINGLESHOT: "是否為單發",
  T_45_XXJ_WS_ISSINGLESHOT_D: "是否為單發",
  T_45_XXJ_WS_JUMPHEIGHT: "跳躍高度",
  T_45_XXJ_WS_JUMPHEIGHT_D: "跳躍高度",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "佈局排序方式枚舉",
  T_45_XXJ_WS_LIGHT_D: "燈光",
  T_45_XXJ_WS_LOCAL: "本地",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "最大連跳次數",
  T_45_XXJ_WS_MODULE: "模組",
  T_45_XXJ_WS_NONE: "無",
  T_45_XXJ_WS_ONBEFOREHURT_D: "實體每次造成傷害前執行該指令",
  T_45_XXJ_WS_ONDISABLE_D: "當實體被禁用時執行",
  T_45_XXJ_WS_ONEACHLOOP_D: "每次循環播放時執行。僅對音效、特效等實體在客戶端有效。",
  T_45_XXJ_WS_ONENABLE_D: "當實體被啟用時執行",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "30 FPS 固定幀更新時",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "玩家新增或刪除好友時觸發此客戶端事件",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "調用遊戲暫停 API 使遊戲暫停時觸發該事件",
  T_45_XXJ_WS_ONGAMERESUME_D: "調用遊戲恢復 API 使遊戲從恢復時觸發該事件",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "玩家停止衝刺時",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "玩家結束使用水上滑板時",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "玩家使用水上滑板時",
  T_45_XXJ_WS_PHYSICALLAYER_D: "自訂物理層級，取值 0-31",
  T_45_XXJ_WS_PLATFORMTYPE: "平台類型",
  T_45_XXJ_WS_PLATFORMTYPE_D: "平台類型",
  T_45_XXJ_WS_PLAYER: "玩家",
  T_45_XXJ_WS_PLAYERCCT: "角色控制器",
  T_45_XXJ_WS_PLAYERCCT_D: "具有物理效果的角色控制器，僅用於 Free Fire 角色",
  T_45_XXJ_WS_PRIORITY: "優先級",
  T_45_XXJ_WS_REMAINMULTINUM: "剩餘可連跳次數",
  T_45_XXJ_WS_REPORT: "檢舉",
  T_45_XXJ_WS_RIGHT: "本地座標軸 x 軸朝向",
  T_45_XXJ_WS_RIGHT_D: "本地座標系中 x 軸朝向",
  T_45_XXJ_WS_SERVER: "伺服器端",
  T_45_XXJ_WS_SINGLE: "單發",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "按鈕樣式",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "社群按鈕樣式",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "按鈕類型",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "社交按鈕類型",
  T_45_XXJ_WS_SORTTYPE_D: "排序類型：非零升序、降序和升序",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "開鏡移動速度",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "開鏡移速倍率",
  T_45_XXJ_WS_STRINGORLOCSTRING: "字串或本地化字串",
  T_45_XXJ_WS_TRIPLE: "三連發",
  T_45_XXJ_WS_UP: "本地座標軸 y 軸朝向",
  T_45_XXJ_WS_UP_D: "本地座標系中 z 軸朝向方向",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "是否使用自訂推力",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "向指定區域投擲空投信標，召喚一輛隨機載具",
  T_45_ZD_VEHICLEDROP_R_NAME: "神秘載具空投",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "蕾娜",
  T_46_HJ_SHARE_GAMEDURATION: "遊玩時間",
  T_46_HJ_WS_SHAREBY: "由 {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "遊戲模式",
  T_46_HJ_WS_SHARETEAM: "隊伍",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "頂尖學霸(下裝)",
  T_46_HX_H_SCHOOL_VN: "頂尖學霸(頭飾)",
  T_46_HX_S_SCHOOL_VN: "頂尖學霸(鞋子)",
  T_46_HX_T_SCHOOL_VN: "頂尖學霸(上裝)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "教學",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "其他",
  T_46_XXJ_WS_ACTUALPOSITION: "實際位置",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "添加 AOI 特別關注，實現視距外 AOI 同步",
  T_46_XXJ_WS_APPEARANCE: "外觀",
  T_46_XXJ_WS_APPEARANCERES: "外觀資源",
  T_46_XXJ_WS_BECOME: "啟用",
  T_46_XXJ_WS_BRAKETORQUE_D: "使用倒車/刹車鍵時，載具獲得的馬力",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "相機旋轉角度限制類型",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "清空指定目標的全部 AOI 特別關注",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "用於傷害計算的最大撞擊傷害",
  T_46_XXJ_WS_CRASHMAXSPEED: "最大撞擊速度",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "用於撞擊的傷害計算，超過該速度後，傷害也不會提升",
  T_46_XXJ_WS_CRASHMESSFACTOR: "撞擊質量係數",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "用於撞擊傷害計算，運用傷害公式的參數",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "用於傷害計算的最小撞擊傷害",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "數據儲存讀寫頻率超出上限",
  T_46_XXJ_WS_DB_PARAMERROR_D: "參數異常",
  T_46_XXJ_WS_DB_TIMEOUT_D: "資料儲存超時，現在主要針對讀取操作",
  T_46_XXJ_WS_DELTA: "增量",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "編輯外觀",
  T_46_XXJ_WS_ENDVALUE_D: "目標值",
  T_46_XXJ_WS_ENGINETORQUE_D: "使用油門鍵時，載具獲得的馬力",
  T_46_XXJ_WS_ERRORCODE_D: "錯誤碼枚舉",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "歐拉角轉為三維向量",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "歐拉角轉為三維向量",
  T_46_XXJ_WS_EXPIRE: "過期",
  T_46_XXJ_WS_FEMALEAVATAR: "女性角色",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "獲取會員過期日期",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "判斷是否存在 AOI 特別關注",
  T_46_XXJ_WS_HELICOPTER: "飛行載具",
  T_46_XXJ_WS_HELICOPTER_D: "一種飛行載具",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "高速轉向限制",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "高速狀態下的最大轉向角",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "高速轉向角速度閾值",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "高速最大轉向角度應用的速度閾值",
  T_46_XXJ_WS_IDLE: "待機動畫",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "閒置煞車輸入",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "載具閒置時，按（閒置煞車輸入）乘以（煞車扭力）減速。",
  T_46_XXJ_WS_INTTOFLOAT: "整數轉浮點值",
  T_46_XXJ_WS_INTTOFLOAT_D: "整數轉浮點值",
  T_46_XXJ_WS_ISPREMIUM: "是否為會員",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "數據庫中排行榜名稱",
  T_46_XXJ_WS_MALEAVATAR: "男性角色",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI 角色",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "新 UMA 外觀",
  T_46_XXJ_WS_NONE_D: "無錯誤",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "NPC 物件",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "提示：擬人 NPC 為高140公分、半徑 25 公分的膠囊形碰撞模型。寵物 NPC 為高 100 公分、半徑 40 公分的膠囊形碰撞模型。",
  T_46_XXJ_WS_OBSERVER_D: "特別關注的觀察者",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "進入我的戰場會員時",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "退出我的戰場會員時",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "開啟我的戰場會員",
  T_46_XXJ_WS_PERSONA: "角色",
  T_46_XXJ_WS_PERSONACENTER: "角色中心",
  T_46_XXJ_WS_PET: "寵物",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "玩家或 Transform 實體",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "玩家和 Transform 實體的別名",
  T_46_XXJ_WS_PREMIUM: "會員",
  T_46_XXJ_WS_PREMIUMSTATUS: "會員狀態",
  T_46_XXJ_WS_PROXYOBSERVER: "觀察者代理",
  T_46_XXJ_WS_PROXYOBSERVER_D: "觀察者代理",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "移除 AOI 特別關注，取消視距外 AOI 同步",
  T_46_XXJ_WS_RENEWAL: "續訂",
  T_46_XXJ_WS_ROTATEVECTOR: "旋轉向量",
  T_46_XXJ_WS_ROTATEVECTOR_D: "根據四元數旋轉向量",
  T_46_XXJ_WS_SKIN: "裝備",
  T_46_XXJ_WS_STARTVALUE_D: "來源值",
  T_46_XXJ_WS_STATUS: "狀態",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "切換玩家的觀察者代理",
  T_46_XXJ_WS_TARGET_D: "特別關注的目標",
  T_46_XXJ_WS_USER_D: "用戶",
  T_46_XXJ_WS_VALUE: "值",
  T_46_XXJ_WS_VALUE_D: "向量",
  T_46_XYL_WS_CTZSAFEZONEEND: "安全區終點",
  T_46_XYL_WS_RESOURCETYPE1: "基礎物件",
  T_46_XYL_WS_RESOURCETYPE1_1: "幾何體",
  T_46_XYL_WS_RESOURCETYPE1_2: "視聽效果",
  T_46_XYL_WS_RESOURCETYPE2: "場景道具",
  T_46_XYL_WS_RESOURCETYPE2_2: "戰鬥補給",
  T_46_XYL_WS_RESOURCETYPE3: "自然",
  T_46_XYL_WS_RESOURCETYPE4: "模組化組件",
  T_46_XYL_WS_TYPEOTHERPROP: "其他",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "容器與箱子",
  T_47_CJ_FOREGRIP_SOFT_N: "輕量握把",
  T_47_CJ_MAGEZINE_FAST_N: "輕量彈匣",
  T_47_CJ_STOCK_FAST_N: "特製槍托",
  T_47_GT_WS_USERMANUAL: "使用說明書",
  T_47_HJ_WS_VFX_FOG: "雲霧特效",
  T_47_HJ_WS_VFX_LIGHTING: "光線特效",
  T_47_HJ_WS_VFX_TRAILING: "甩尾特效",
  T_47_HL_CL_CREATOR_LABEL1: "社群人才",
  T_47_HL_CL_MAP_LABEL1: "社群人才精選作品",
  T_47_JH_WS_MODERATION_REASON12: "賭博相關",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "火影忍者疾風傳合作",
  T_47_SD_RES_MATERIAL: "材質檔案",
  T_47_SD_RES_MESH: "網格",
  T_47_SD_WS_MAPTAG_AI: "智能地圖生成",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "一把特殊的苦無，在投擲後會黏附在撞擊點，經過短暫延遲後觸發火焰爆炸，造成燃燒傷害。",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "火之苦無",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "一把特殊的苦無，在投擲後會黏附在撞擊點，並在短暫延遲後觸發雷擊，使目標麻痺。",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "雷之苦無",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "一把特殊的苦無，在投擲後會黏附在撞擊點，並在短暫延遲後觸發風暴，減緩向其中心移動的目標速度。",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "風之苦無",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "一種適合中至遠距離戰鬥的手裡劍。一次投擲快速發射一枚，造成大量傷害。",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "重型手裏劍",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "一種適合近至中距離戰鬥的手裡劍，具有兩種攻擊模式。一次投擲發射三枚，造成少量傷害。",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "輕型手裏劍",
  T_47_XXJ_WS_ACTION: "動作",
  T_47_XXJ_WS_AOISETTING: "區域過濾選項",
  T_47_XXJ_WS_BAGSKINTYPE: "背包外觀類型",
  T_47_XXJ_WS_CLEARMEMORY: "清除記憶",
  T_47_XXJ_WS_CLNPC: "進階 NPC",
  T_47_XXJ_WS_CLOTHTYPE: "服裝外觀類型",
  T_47_XXJ_WS_COMMON_ERROR: "常見錯誤",
  T_47_XXJ_WS_CONTENT: "內容",
  T_47_XXJ_WS_CREATERANDOMSEED: "創建隨機種子",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "經過百分比",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "啟用雲霧特效",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "啟用主光源旋轉角度功能",
  T_47_XXJ_WS_ERRORCODE: "錯誤代碼",
  T_47_XXJ_WS_EXPONENTIAL: "指數雲霧特效",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "指數平方雲霧特效",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "創建房間失敗：無有效角色 ID",
  T_47_XXJ_WS_FOG: "雲霧",
  T_47_XXJ_WS_FOGDENSITY: "指數雲霧密度",
  T_47_XXJ_WS_FOGENDDISTANCE: "線性雲霧結束距離",
  T_47_XXJ_WS_FOGMODE: "雲霧模式",
  T_47_XXJ_WS_FOGMODETYPE: "雲霧模式類型",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "線性雲霧初始距離",
  T_47_XXJ_WS_HEIGHTSCALE: "高度刻度",
  T_47_XXJ_WS_ISVISIBLE: "是否可見",
  T_47_XXJ_WS_JOINNEWTEAM: "加入新隊伍",
  T_47_XXJ_WS_JOINTEAM: "加入隊伍",
  T_47_XXJ_WS_LIGHTROTATE: "主光源旋轉角度",
  T_47_XXJ_WS_LINEAR: "線性雲霧特效",
  T_47_XXJ_WS_LLMCHATHUD: "UI 人物聊天",
  T_47_XXJ_WS_NEWTEAM: "新隊伍",
  T_47_XXJ_WS_NEXT: "下一個",
  T_47_XXJ_WS_NPC_TIP: "您可以編輯 NPC 的外觀並讓 NPC 使用動畫",
  T_47_XXJ_WS_OBSERVERS: "觀察者",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "玩家通過 UI 人物聊天發送消息時",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "會員狀態已更改",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "從角色接收動作時",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "從角色接收內容時",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "從角色接收完成時",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "從角色接收狀態時",
  T_47_XXJ_WS_PARTICLESID: "粒子 ID",
  T_47_XXJ_WS_PERSONAAVATAR: "角色頭像",
  T_47_XXJ_WS_PERSONAID: "角色 ID",
  T_47_XXJ_WS_PERSONANICKNAME: "角色暱稱",
  T_47_XXJ_WS_PLAYERORNPC: "玩家或 NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "會員資格已關閉",
  T_47_XXJ_WS_RANDOM: "隨機",
  T_47_XXJ_WS_SEED: "種子",
  T_47_XXJ_WS_SENDER: "發送者",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "設置角色之觀察者",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "設置玩家可以中途退出",
  T_47_XXJ_WS_SHOULDREPLY: "應回覆",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "顯示系統回覆",
  T_47_XXJ_WS_SPOTANGLE: "聚光燈",
  T_47_XXJ_WS_SPOTLIGHT: "聚光燈",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "發送系統消息給角色",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "將系統訊息串流至角色",
  T_47_XXJ_WS_TARGETTEAM: "目標隊伍",
  T_47_XXJ_WS_THISENTITY: "此實體",
  T_47_XXJ_WS_USERAVATAR: "使用者角色",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "發送用戶消息給角色",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "將使用者訊息串流至角色",
  T_47_XXJ_WS_USERNICKNAME: "使用者暱稱",
  T_47_XXJ_WS_VEHICLESKINTYPE: "載具外觀類型",
  T_47_XXJ_WS_WEAPONSKINTYPE: "武器塗裝類型",
  T_47_XYL_NB_UGC_EFFECT001: "螺旋丸特效",
  T_47_XYL_NB_UGC_EFFECT002: "千鳥特效",
  T_47_XYL_NB_UGC_EFFECT003: "櫻花衝­特效",
  T_47_XYL_NB_UGC_EFFECT004: "火遁・豪火球之術特效",
  T_47_XYL_NB_UGC_EFFECT005: "水遁・水龍彈之術特效",
  T_47_XYL_NB_UGC_EFFECT006: "風遁・大突破之術特效",
  T_47_XYL_NB_UGC_EFFECT007: "尾獸玉特效",
  T_47_XYL_NB_UGC_EFFECT008: "穢土轉生咒印特效",
  T_47_XYL_UGC_CRAFTLANDSHOP: "資產商店",
  T_47_XYL_UGC_DONKEYCART: "驢子推車",
  T_47_XYL_UGC_SPOTLIGHT: "聚光燈",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "聚光燈角度",
  T_48_H_EMOTE_WATERFEST25_N: "狂歡舞步",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "機車-狂雨暴浪",
  T_48_HJ_AC_STATENOTEXIST: "動畫控制器中不存在狀態{0}",
  T_48_HL_CODESCRIPT: "指令腳本",
  T_48_HL_GLOBAL_VAR: "全局變量名稱",
  T_48_HL_GRAPH: "圖元",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "排行榜",
  T_48_HL_LOCAL_VAR: "本地變量名稱",
  T_48_HL_LOCALIZATION: "本地化名稱",
  T_48_HL_OPEN_ATTRIBUTES: "開放屬性名稱",
  T_48_HX_A_WATERFEST25: "清澈海灘(面飾)",
  T_48_HX_B_WATERFEST25: "清澈海灘(下裝)",
  T_48_HX_F_B_BLACKDRESS: "至暗女神(下裝)",
  T_48_HX_F_H_BLACKDRESS: "至暗女神(頭飾)",
  T_48_HX_F_HA_BLACKDRESS: "至暗女神(臉彩)",
  T_48_HX_F_S_BLACKDRESS: "至暗女神(鞋子)",
  T_48_HX_F_T_BLACKDRESS: "至暗女神(上裝)",
  T_48_HX_H_WATERFEST25: "清澈海灘(頭飾)",
  T_48_HX_HA_WATERFEST25: "清澈海灘(臉彩)",
  T_48_HX_M_A_BLACKDRESS: "致命黑雷(面飾)",
  T_48_HX_M_B_BLACKDRESS: "致命黑雷(下裝)",
  T_48_HX_M_H_BLACKDRESS: "致命黑雷(頭飾)",
  T_48_HX_M_HA_BLACKDRESS: "致命黑雷(臉彩)",
  T_48_HX_M_S_BLACKDRESS: "致命黑雷(鞋子)",
  T_48_HX_M_T_BLACKDRESS: "致命黑雷(上裝)",
  T_48_HX_S_WATERFEST25: "清澈海灘(鞋子)",
  T_48_HX_T_WATERFEST25: "清澈海灘(上裝)",
  T_48_JH_WS_STRINGDESC: '輸入一段文字或其他字串。部分控制項支援格式化文字顯示。使用格式化文字為文字添加顏色的格式為：[#XXXXXX] 為開頭，此處 "#XXXXXX" 為需要顯示的顏色。中間輸入顯示的文字，並以 [-] 結尾。使用時需確保已將相關控制項的文字顏色設置為白色。',
  T_48_M_WS_P_ICON: "頭像",
  T_48_META_API_10001: "以 ID 搜尋實體",
  T_48_META_API_10001_P0: "實體 ID",
  T_48_META_API_1098: "批次讀取資料庫表值",
  T_48_META_API_1098_D: "從指定的資料庫表中批次讀取多條數據，其中唯一玩家 ID 清單的條目與關鍵清單的條目一一對應。",
  T_48_META_API_1098_P1: "帳號 ID",
  T_48_META_API_1098_P1_D: "唯一玩家 ID 列表，讀取按鍵列表中相同索引處的按鍵對應的資料。",
  T_48_META_API_1098_P2: "按鍵",
  T_48_META_API_1098_P2_D: "按鍵列表，讀取 ID 列表中同一索引處的唯一玩家 ID 對應的資料。",
  T_48_META_API_1098_P5: "狀態代碼",
  T_48_META_API_1098_P5_D: "狀態代碼列表",
  T_48_META_API_1105: "通知開始繪圖",
  T_48_META_API_1105_D: "開始為觸發玩家播放指定劇情",
  T_48_META_API_1105_P1_D: "劇情 ID",
  T_48_META_API_1108: "獲取當地語言",
  T_48_META_API_1500_P0: "向量",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "設定身體部位重量",
  T_48_META_API_3300_D: "設定目標身體部位與其他低優先動畫混合時的權重",
  T_48_META_API_3300_P0_D: "身體部位所屬的可添加動畫控制器組件",
  T_48_META_API_3300_P1: "身體部位名稱",
  T_48_META_API_3300_P1_D: "身體部位名稱",
  T_48_META_API_3300_P2: "重量",
  T_48_META_API_3300_P2_D: "權重，取值範圍為[0,1]，表示與低優先權動畫的混合程度。",
  T_48_META_API_3315: "播放角色動畫片段覆蓋",
  T_48_META_API_3315_D: "播放角色動畫剪輯，並可選擇覆蓋遊戲的預設動畫",
  T_48_META_API_3315_P3: "覆蓋遊戲控制",
  T_48_META_API_3315_P3_D: "是否覆蓋遊戲預設動畫",
  T_48_META_API_3316: "停止動畫",
  T_48_META_API_3316_D: "停止播放處於指定狀態的目標的動畫",
  T_48_META_API_90_P1: "可以中途退出",
  T_48_META_API_93: "建立沿路徑運動",
  T_48_META_API_93_D: "建立沿路徑的內插運動，使物件沿著指定的路徑移動",
  T_48_META_API_93_P1: "小路",
  T_48_META_API_93_P1_D: "運動路徑",
  T_48_META_API_93_P3_D: "速度的大小",
  T_48_META_API_93_P4: "切線面向",
  T_48_META_API_93_P4_D: "物體是否面向運動方向。即使以其他方式強制修改物體的方向，此屬性仍保持不變。",
  T_48_META_API_96: "實例化 Prefab",
  T_48_META_API_96_D: "建立一個 Prefab 實例，並選擇非同步處理它",
  T_48_META_API_96_P2: "非同步載入",
  T_48_META_API_96_P2_D: "載入是否非同步",
  T_48_META_EVT_3140: "隊伍改變時",
  T_48_META_EVT_3140_D: "目前實體的隊伍發生變化時觸發",
  T_48_META_EVT_3140_P0: "前隊伍",
  T_48_META_EVT_3140_P0_D: "變更前所屬的隊伍",
  T_48_META_EVT_3140_P1: "目前隊伍",
  T_48_META_EVT_3140_P1_D: "變更後所屬的隊伍",
  T_48_META_EVT_3141: "劇情開始時",
  T_48_META_EVT_3141_D: "劇情開始播放時觸發",
  T_48_META_EVT_3141_P1: "劇情 ID",
  T_48_META_EVT_3141_P1_D: "劇情 ID",
  T_48_META_EVT_3142: "劇情結束時",
  T_48_META_EVT_3142_D: "劇情結束時觸發",
  T_48_META_EVT_3142_P0_D: "觸發的玩家",
  T_48_META_EVT_3142_P1_D: "劇情 ID",
  T_48_META_EVT_3143: "觸發劇情對話選項時",
  T_48_META_EVT_3143_D: "在劇情對話中選擇選項後觸發",
  T_48_META_EVT_3143_P1_D: "劇情 ID",
  T_48_META_EVT_3143_P2: "選項 ID",
  T_48_META_EVT_3143_P2_D: "被選擇的選項ID",
  T_48_META_TYP_409_I10: "換隊失敗-無效的對象",
  T_48_META_TYP_409_I11: "換隊失敗-死亡玩家不允許換隊",
  T_48_META_TYP_409_I12: "換隊失敗-不允許在載具中換隊",
  T_48_META_TYP_409_I7: "換隊失敗-模式不支援",
  T_48_META_TYP_409_I8: "換隊失敗-當前已經在目標隊伍中",
  T_48_META_TYP_409_I9: "換隊失敗-無效的目標隊伍",
  T_48_META_TYP_41_I19: "禁用碰撞箱",
  T_48_META_TYP_417: "粒子效果",
  T_48_META_TYP_428: "玩家變身後或 NPC 服飾",
  T_48_META_TYP_431: "沿路徑移動",
  T_48_META_TYP_431_I1: "路徑",
  T_48_META_TYP_432: "自訂曲線路徑路點",
  T_48_META_TYP_432_I0: "翻滾角",
  T_48_META_TYP_432_I1: "切線",
  T_48_META_TYP_433: "自訂曲線路徑類型",
  T_48_META_TYP_433_I0: "線性",
  T_48_META_TYP_433_I1: "平滑",
  T_48_META_TYP_433_I2: "自訂",
  T_48_META_TYP_434: "自訂曲線路徑",
  T_48_META_TYP_434_I2: "是否封閉",
  T_48_META_TYP_434_I3: "路點",
  T_48_META_TYP_437_I5: "分數類型名稱",
  T_48_META_TYP_437_I6: "左邊得分內容",
  T_48_META_TYP_437_I7: "右邊得分內容",
  T_48_META_TYP_438_I1: "玩家",
  T_48_META_TYP_438_I2: "排名",
  T_48_META_TYP_438_I3: "總得分",
  T_48_META_TYP_438_I4: "分數類型名稱",
  T_48_META_TYP_438_I5: "顏色",
  T_48_META_TYP_438_I6: "得分",
  T_48_META_TYP_439: "組合",
  T_48_META_TYP_442_I1: "左邊得分",
  T_48_META_TYP_442_I10: "右邊死亡圖標",
  T_48_META_TYP_442_I2: "右邊得分",
  T_48_META_TYP_442_I3: "左邊存活人數",
  T_48_META_TYP_442_I4: "右邊存活人數",
  T_48_META_TYP_442_I5: "左邊死亡人數",
  T_48_META_TYP_442_I6: "右邊死亡人數",
  T_48_META_TYP_442_I7: "左邊存活圖標",
  T_48_META_TYP_442_I8: "右邊存活圖標",
  T_48_META_TYP_442_I9: "左邊死亡圖標",
  T_48_META_TYP_444: "語言",
  T_48_META_TYP_444_I0: "英語",
  T_48_META_TYP_444_I1: "簡體中文",
  T_48_META_TYP_444_I10: "法語",
  T_48_META_TYP_444_I11: "德語",
  T_48_META_TYP_444_I12: "土耳其語",
  T_48_META_TYP_444_I13: "印地語",
  T_48_META_TYP_444_I14: "日語",
  T_48_META_TYP_444_I15: "羅馬尼亞語",
  T_48_META_TYP_444_I16: "阿拉伯語",
  T_48_META_TYP_444_I17: "緬甸語",
  T_48_META_TYP_444_I18: "烏都語",
  T_48_META_TYP_444_I19: "孟加拉語",
  T_48_META_TYP_444_I2: "繁體中文",
  T_48_META_TYP_444_I3: "泰語",
  T_48_META_TYP_444_I4: "越南語",
  T_48_META_TYP_444_I5: "印尼語",
  T_48_META_TYP_444_I6: "葡萄牙語",
  T_48_META_TYP_444_I7: "西班牙語",
  T_48_META_TYP_444_I8: "俄羅斯語",
  T_48_META_TYP_444_I9: "韓語",
  T_48_SD_ERROR_DIVISOR: "除數不能為 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "指定的 key 在地圖中不存在：{0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "列表下標超出範圍：{0}",
  T_48_SD_SK_WARNING: "沒有在{0}中找到{1}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: "由於我的戰場角色控制器 {0} 的屬性 IsServerDriven 被停用，因此相關伺服器 API 不會生效。",
  T_48_XXJ_WS_PARENTERROR: "無法設置父節點",
  T_48_XXJ_WS_PERFORMANCE: "表現",
  T_48_XXJ_WS_TANGENT: "切線",
  T_48_XXJ_WS_WAYPOINT: "路點",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "物件列表",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "使用自訂小地圖",
  T_48_XYL_UGC_HIDEMINIMAP: "隱藏小地圖 HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "基礎自訂曲面",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "基礎曲面椎體",
  T_48_XYL_WS_BASICHEMISPHERE: "基礎實心半球體",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "基礎 1/4 圓角圓環",
  T_48_XYL_WS_BASICQUARTERTORUS: "基礎 1/4 直角圓環",
  T_48_XYL_WS_BASICROUNDEDTORUS: "基礎圓角圓環",
  T_48_XYL_WS_BASICTRIANGLE: "基礎等邊直角三角面",
  T_48_XYL_WS_MAPPLAYERSTIPS: "對戰玩家數 = 隊伍數 x 每隊玩家數。對戰玩家數越多，配對時間越長",
  T_48_XYL_WS_MAPPLAYERSWARNING: "玩家數量較多的比賽可能會導致匹配時間延長",
  T_49_HL_CL_CREATOR_LABEL2: "我的戰場社群天才",
  T_49_HL_CL_MAPS_LABEL2: "地圖優勝者",
  T_49_HL_CL_MAPS_LABEL3: "遊戲優勝者",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "彈道運動",
  T_49_JH_WS_SKILLKASSIE: "生命連結 (卡熙蒂)",
  T_49_JH_WS_SKILLKODA: "極光視界 (柯塔)",
  T_49_JH_WS_SKILLOSCAR: "英勇衝鋒 (奧斯卡)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "AI 生成",
  T_49_META_API_10065: "切換自訂相機",
  T_49_META_API_10067: "取得目前自訂相機",
  T_49_META_API_10069: "建立自訂相機",
  T_49_META_API_10070: "設定自訂相機剔除遮罩",
  T_49_META_API_10070_D: "設定目標攝影機的剔除遮罩來控制所有圖層的可見性",
  T_49_META_API_10071: "取得自訂相機剔除遮罩",
  T_49_META_API_10071_D: "取得目標相機的剔除遮罩",
  T_49_META_API_10072: "設定自訂相機剔除遮罩層",
  T_49_META_API_10072_D: "設定特定圖層目標相機的可見性",
  T_49_META_API_10073: "截圖",
  T_49_META_API_10073_D: "截圖（供內部測試用）",
  T_49_META_API_106: "取得伺服器時間戳記(毫秒)",
  T_49_META_API_106_D: "取得毫秒精度的伺服器時間戳",
  T_49_META_API_107: "時間戳轉換為本地化字串(毫秒)",
  T_49_META_API_107_D: "根據特定格式將時間戳（以毫秒為單位）轉換為字串",
  T_49_META_API_107_P0: "時間戳(毫秒)",
  T_49_META_API_107_P0_D: "以毫秒為單位的時間戳",
  T_49_META_API_108: "向量3 線性插值",
  T_49_META_API_108_D: "對三維向量 A 與向量 B 執行線性插值運算",
  T_49_META_API_1089_P2: "請求 ID",
  T_49_META_API_109: "為人物更新背景設定",
  T_49_META_API_109_D: "更新當前聊天室中指定人物的模型背景設定，並在執行後覆蓋原有設定。此背景設定將影響該人物對於背景、歷史或特定對話參數的理解。",
  T_49_META_API_109_P1: "情境",
  T_49_META_API_109_P1_D: "情境細節",
  T_49_META_API_110: "針對角色回應的回饋",
  T_49_META_API_110_D: "提交對角色的回應內容的回饋，將用於優化我們的模型。",
  T_49_META_API_110_P1: "是否喜歡",
  T_49_META_API_110_P1_D: "是否喜歡該回應。真 = 喜歡。",
  T_49_META_API_1109: "設定本地玩家位置",
  T_49_META_API_1109_D: "當玩家使用經典遊戲角色時，此 API 可用來設定玩家的位置。",
  T_49_META_API_1109_P0_D: "目標位置",
  T_49_META_API_111: "三維向量線性插值",
  T_49_META_API_111_D: "對三維向量 A 與向量 B 執行球面插值，以實現平滑旋轉效果",
  T_49_META_API_1110: "設定本地玩家的前進方向",
  T_49_META_API_1110_D: "當玩家使用經典遊戲角色時，此 API 可用來設定玩家所面對的方向。",
  T_49_META_API_1110_P0_D: "前向向量",
  T_49_META_API_112: "清除角色指定回應後的記憶",
  T_49_META_API_112_D: "將角色的記憶重置至指定回應 ID 之前，即指定回應 ID 後，這條回應以及之後的對話記憶都會被清除",
  T_49_META_API_113: "播放一次性音效",
  T_49_META_API_113_D: "播放可調整音量的一次性音效",
  T_49_META_API_113_P0_D: "播放音效資源的ID",
  T_49_META_API_113_P1: "音量",
  T_49_META_API_113_P1_D: "音效的播放音量，大小從0到1。",
  T_49_META_API_97: "建立骨架部件觀察控制器",
  T_49_META_API_97_D: "建立骨架部件注視控制器實體後，可以使用該實體來控制指定的骨架部件，使其始終面向特定的目標。",
  T_49_META_API_97_P0_D: "骨架部分查看控制器實體。如果實體被摧毀，檢視功能將停止。",
  T_49_META_API_97_P1_D: "正在控制的骨架部分",
  T_49_META_API_97_P2_D: "正在查看的目標",
  T_49_META_API_98: "向量投影",
  T_49_META_API_98_D: "計算向量 A 在向量 B 上的投影",
  T_49_META_API_99: "取得本地時間戳(毫秒)",
  T_49_META_API_99_D: "取得毫秒精度的本地時間戳",
  T_49_META_EVT_16_P1_D: "從 0 開始，每個發出的請求都會消耗一個連續的數字 ID，例如用於創建房間或清除記憶體。",
  T_49_META_EVT_16_P2: "回應 ID",
  T_49_META_EVT_16_P2_D: "每個完整的回應都有唯一的 ID",
  T_49_META_TYP_122_I19: "自訂材料",
  T_49_META_TYP_122_I19_D: "允許用自訂材質替換天空盒",
  T_49_META_TYP_14_I78_D: "取得或設定目前在玩家用戶端上渲染場景的攝影機實體。注意：攝影機實體基本上代表控制用戶端攝影機的設定資料。",
  T_49_META_TYP_335_I9: "已過時間(毫秒)",
  T_49_META_TYP_335_I9_D: "音效的播放時長（單位為毫秒）。此屬性僅能在客戶端存取。",
  T_49_META_TYP_409_I13: "LLM_成功",
  T_49_META_TYP_409_I13_D: "LLM_成功",
  T_49_META_TYP_409_I14: "LLM_失敗",
  T_49_META_TYP_409_I14_D: "LLM_失敗",
  T_49_META_TYP_409_I15: "LLM_逾時",
  T_49_META_TYP_409_I15_D: "LLM_逾時",
  T_49_META_TYP_409_I16: "LLM_角色無效",
  T_49_META_TYP_409_I16_D: "LLM_角色或房間無效",
  T_49_META_TYP_409_I17: "LLM_對話輪數已達上限",
  T_49_META_TYP_409_I17_D: "LLM_代幣上限",
  T_49_META_TYP_409_I18: "LLM_包含惡意訊息",
  T_49_META_TYP_409_I18_D: "LLM_請求過於頻繁",
  T_49_META_TYP_409_I19: "LLM_請求過於頻繁",
  T_49_META_TYP_409_I19_D: "LLM_請求過於頻繁",
  T_49_META_TYP_441: "效能 ID",
  T_49_META_TYP_445: "播放控制器 ID",
  T_49_META_TYP_446: "可連接播放控制器的實體組件",
  T_49_META_TYP_446_I0: "播放控制器",
  T_49_META_TYP_447: "骨架零件控制器",
  T_49_META_TYP_448: "骨架部分觀察控制器",
  T_49_META_TYP_448_I0: "控制目標",
  T_49_META_TYP_448_I1: "注視目標",
  T_49_META_TYP_449: "自訂相機",
  T_49_META_TYP_449_I2: "正交尺寸",
  T_49_META_TYP_449_I2_D: "控制攝影機可見區域的大小",
  T_49_META_TYP_450: "時間戳本地化字串(毫秒)",
  T_49_META_TYPE_449_D: "自訂相機完全由開發者控制，決定玩家在遊戲過程中所看到的內容。",
  T_49_META_TYPE_450_D: "將毫秒等級的時間戳格式化為可讀的文字格式",
  T_49_SD_SEARCH_ICONDESC: "智能聯想",
  T_49_SD_SEARCHKEY_ACTION: "行動",
  T_49_SD_SEARCHKEY_ANICLIPID: "動畫片段 ID",
  T_49_SD_SEARCHKEY_AS: "為",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "配置道具 ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "音效類型",
  T_49_SD_SEARCHKEY_BAGSKINID: "背包塗裝 ID",
  T_49_SD_SEARCHKEY_BEZIER: "貝塞爾曲線",
  T_49_SD_SEARCHKEY_BOOL: "布林值",
  T_49_SD_SEARCHKEY_BREAK: "中斷循環",
  T_49_SD_SEARCHKEY_BTREEID: "行為樹",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "點擊按鈕時",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "點擊兩下按鈕時",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "按下按鈕時",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "放開按鈕時",
  T_49_SD_SEARCHKEY_CLOTHENUM: "服裝類型",
  T_49_SD_SEARCHKEY_COLOR: "顏色",
  T_49_SD_SEARCHKEY_COMMENT: "注釋",
  T_49_SD_SEARCHKEY_COMPARER: "等於大於小於不等於",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "組件枚舉",
  T_49_SD_SEARCHKEY_CONCANT: "連接",
  T_49_SD_SEARCHKEY_CONTINUE: "繼續",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "自訂 HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "自訂 HUD 小工具",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "可建立物件類型",
  T_49_SD_SEARCHKEY_E: "常數 e",
  T_49_SD_SEARCHKEY_EFFECTENUM: "視覺效果類型",
  T_49_SD_SEARCHKEY_ENTITY: "選擇場景對象",
  T_49_SD_SEARCHKEY_FLOAT: "浮點數",
  T_49_SD_SEARCHKEY_FOR: "索引",
  T_49_SD_SEARCHKEY_FOREACH: "對於每個",
  T_49_SD_SEARCHKEY_FUNCTION: "功能",
  T_49_SD_SEARCHKEY_GETCSV: "取得 CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "透過 key 獲取註冊資產",
  T_49_SD_SEARCHKEY_GETVALUE: "取得屬性值",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "取得全域變數",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "設定全域變數",
  T_49_SD_SEARCHKEY_IF: "如果",
  T_49_SD_SEARCHKEY_IFELSE: "如果否則",
  T_49_SD_SEARCHKEY_IMGENUM: "影像類型",
  T_49_SD_SEARCHKEY_INT: "整數",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD 類型",
  T_49_SD_SEARCHKEY_ITEMENUM: "物品類型",
  T_49_SD_SEARCHKEY_LISTAPPEND: "追加列表",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "列表追加範圍",
  T_49_SD_SEARCHKEY_LISTCLEAR: "清空列表",
  T_49_SD_SEARCHKEY_LISTCLONE: "克隆列表",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "是否包含指定元素",
  T_49_SD_SEARCHKEY_LISTCREATE: "建立清單",
  T_49_SD_SEARCHKEY_LISTDELETE: "刪除清單",
  T_49_SD_SEARCHKEY_LISTGET: "取得列表",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "獲取元素最先出現位置",
  T_49_SD_SEARCHKEY_LISTINSERT: "列表插入",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "獲取元素最後出現位置",
  T_49_SD_SEARCHKEY_LISTLENGTH: "列表長度",
  T_49_SD_SEARCHKEY_LISTREVERSE: "翻轉列表元素",
  T_49_SD_SEARCHKEY_LISTSET: "修改列表",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "隨機排序列表元素",
  T_49_SD_SEARCHKEY_LOCALKEY: "本地化 key",
  T_49_SD_SEARCHKEY_LOCALVAR: "局部變數",
  T_49_SD_SEARCHKEY_LOGICAL: "且或",
  T_49_SD_SEARCHKEY_LOGINFO: "列印提示",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "取得字典所有 key 取得映射所有 key",
  T_49_SD_SEARCHKEY_MAPCLEAR: "清除字典 清除映射",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "字典包含 key 映射包含 key",
  T_49_SD_SEARCHKEY_MAPCREATE: "建立字典 建立映射",
  T_49_SD_SEARCHKEY_MAPGET: "透過 key 取得字典值 透過 key 取得對應的映射值",
  T_49_SD_SEARCHKEY_MAPLENGTH: "字典長度 映射長度",
  T_49_SD_SEARCHKEY_MAPREMOVE: "移除字典 移除映射",
  T_49_SD_SEARCHKEY_MAPSET: "設定字典值 設定映射值",
  T_49_SD_SEARCHKEY_MATH: "加減乘除",
  T_49_SD_SEARCHKEY_NEWLIST: "建立列表",
  T_49_SD_SEARCHKEY_NULL: "空",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "數字轉字串",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "粒子參數檔案枚舉",
  T_49_SD_SEARCHKEY_PERSONA: "角色",
  T_49_SD_SEARCHKEY_PI: "常數 pi",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "玩家資料 ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "角色技能類型",
  T_49_SD_SEARCHKEY_PREEFFECT: "特殊貼紙類型",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "資源收集",
  T_49_SD_SEARCHKEY_READSTATIS: "讀取累計數據",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "資源 uuid",
  T_49_SD_SEARCHKEY_RETURN: "返回",
  T_49_SD_SEARCHKEY_SCENEENUM: "場景檔案",
  T_49_SD_SEARCHKEY_SCRIPTID: "腳本",
  T_49_SD_SEARCHKEY_SETVALUE: "設定屬性值",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "特殊物品 ID 類型",
  T_49_SD_SEARCHKEY_TEXT: "文字",
  T_49_SD_SEARCHKEY_TEXTUREID: "圖片類型",
  T_49_SD_SEARCHKEY_THISENTITY: "此實體",
  T_49_SD_SEARCHKEY_TIMELINE: "時間軸",
  T_49_SD_SEARCHKEY_TYPEENUM: "任何類型",
  T_49_SD_SEARCHKEY_V2VCREATE: "建立二維向量",
  T_49_SD_SEARCHKEY_V2VGET: "取得二維向量組件",
  T_49_SD_SEARCHKEY_V2VOPERATION: "二維向量運算：加法、減法、乘法、點積、距離、角度",
  T_49_SD_SEARCHKEY_V2VSET: "設定二維向量組件",
  T_49_SD_SEARCHKEY_V3VCREATE: "建立三維向量",
  T_49_SD_SEARCHKEY_V3VGET: "取得三維向量組件",
  T_49_SD_SEARCHKEY_V3VOPERATION: "三維向量運算：加法、減法、乘法、點積、叉積、距離、角度",
  T_49_SD_SEARCHKEY_V3VSET: "設定三維向量組件",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "載具外觀 ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "武器皮膚類型",
  T_49_SD_SEARCHKEY_WHILE: "條件循環",
  T_49_SD_SEARCHKEY_WRITESTATIS: "寫入累計資料庫偏移量",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "透過地圖程式碼寫入累計資料庫偏移量",
  T_49_XXJ_WS_DURATIONS: "持續時間(秒)",
  T_49_XXJ_WS_EDITPERFORMANCE: "編輯表演",
  T_49_XXJ_WS_PERFORMANCE: "表現",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "刪除表演",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "已刪除的表演無法恢復，是否繼續？",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "編輯 {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "名稱已被使用，請更改後重試",
  T_49_XXJ_WS_PERFORMANCENAME: "表演名稱",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "新增關鍵幀",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "新增子軌道",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "新增軌道",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "刪除軌道",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "演員軌道",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "事件軌道",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "關鍵幀已存在",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "對應的演員軌道已存在",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "內容",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "偵測到重複的軌道名稱。請更改後重試。",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "請先開始錄製或選擇關鍵幀",
  T_49_XXJ_WS_TIMELINE_RECORDING: "錄製中...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "刪除關鍵幀",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "場景視圖",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "選擇一個物件來建立軌道或直接點擊新增軌道按鈕",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "點擊新增軌道按鈕建立新軌道",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "子軌道",
  T_49_XXJ_WS_TIMELINE_TRACK: "軌道",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "軌道視圖",
  T_49_XYL_WS_DAILYPROPS: "基本",
  T_49_XYL_WS_STOREGAMPLAY: "遊戲玩法",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1-幽魂詭影",
  T_50_H_MACHETE_VA_N: "大砍刀-幽魂詭影",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "排行榜類別",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "溢位文字框",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "自動換行",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "縮小字體",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "建立元組",
  T_50_HJ_SEARCHKEY_TUPLEGET: "取得元組",
  T_50_HJ_SEARCHKEY_TUPLESET: "設定元組",
  T_50_HJ_TEXTOBGJ_H: "高度",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "溢位時的處理方式",
  T_50_HJ_TEXTOBGJ_W: "寬度",
  T_50_HZY_REVIEW_TEXTOBJ: "文字物件內容",
  T_50_JH_WS_HIDEMAPERROR: "無法隱藏小地圖，請先設置自訂封面圖像",
  T_50_JH_WS_HIDEMAPTIP: "當小地圖被隱藏時，將不再用作封面圖像。",
  T_50_JH_WS_HIDEMINIMAP: "隱藏小地圖",
  T_50_META_API_10073_P0: "檔案名稱",
  T_50_META_API_10073_P0_D: "檔案名稱",
  T_50_META_API_10073_P1_D: "執行結果。請參考狀態碼列舉。",
  T_50_META_API_1102: "讀取資料庫表格欄位數值",
  T_50_META_API_1102_D: "從標準資料表中依指定鍵讀取特定欄位的值",
  T_50_META_API_1102_P3: "欄位索引",
  T_50_META_API_1102_P3_D: "資料表欄位索引(0 表示第一欄)",
  T_50_META_API_1106: "建立演出內容",
  T_50_META_API_1106_D: "建立演出實體",
  T_50_META_API_1106_P0_D: "演出資產",
  T_50_META_API_1111: "讀取資料庫排行榜關聯數值",
  T_50_META_API_1111_D: "從排行榜資料表及其關聯資料表中讀取組合值",
  T_50_META_API_1111_P5: "關聯狀態碼",
  T_50_META_API_1111_P5_D: "關聯錯誤代碼",
  T_50_META_API_1112: "按範圍讀取排行榜關聯數值",
  T_50_META_API_1112_D: "從排行榜資料表中讀取指定排名範圍內的數值，再依據擷取到的鍵值從關聯資料表中讀取對應數值，並加以整合。",
  T_50_META_API_1112_P6: "關聯狀態碼",
  T_50_META_API_1112_P6_D: "關聯錯誤代碼",
  T_50_META_API_1113: "寫入排行榜關聯數值",
  T_50_META_API_1113_D: "將指定鍵值寫入排行榜資料表及其關聯資料表",
  T_50_META_API_1113_P5: "關聯狀態碼",
  T_50_META_API_1113_P5_D: "關聯錯誤代碼",
  T_50_META_API_114_D: "建立自訂 UI",
  T_50_META_API_114_P0_D: "此代碼將作為建立 UI 實體的參數名稱，對應的區域變數即為該 UI 實體",
  T_50_META_API_114_P1_D: "該物件隸屬的玩家實體，僅該玩家可見",
  T_50_META_API_114_P2: "UI 資源 ID",
  T_50_META_API_114_P2_D: "自訂 UI 資源 ID",
  T_50_META_API_115_D: "建立指定的自訂 UI",
  T_50_META_API_116: "設定關卡物件高光",
  T_50_META_API_116_D: "設定物件的高光狀態，可能會受其他遊戲邏輯影響",
  T_50_META_API_116_P0_D: "目標物件",
  T_50_META_API_116_P1_D: "高光狀態",
  T_50_META_API_117: "位元運算通用",
  T_50_META_API_117_D: "位元與／或／互斥或／左移／右移",
  T_50_META_API_117_P0_D: "左側數值",
  T_50_META_API_117_P1_D: "右側數值",
  T_50_META_API_117_P2_D: "運算類型",
  T_50_META_API_118: "位元反向",
  T_50_META_API_118_D: "位元反向，又稱為位元補數。",
  T_50_META_API_118_P0_D: "數值",
  T_50_META_API_119: "位元清單轉整數",
  T_50_META_API_119_D: "對所有清單元素執行位元 OR 運算，並將結果轉換為整數。",
  T_50_META_API_119_P0: "位元陣列",
  T_50_META_API_119_P0_D: "位元陣列",
  T_50_META_API_120: "位元整數轉清單",
  T_50_META_API_120_D: "將二進位整數中第 1 位為 1 的位元所對應的十進位值轉換為清單",
  T_50_META_API_120_P0_D: "整數",
  T_50_META_API_121: "四元數角度",
  T_50_META_API_121_D: "計算兩個四元數之間的夾角",
  T_50_META_API_121_P0_D: "四元數 1",
  T_50_META_API_121_P1_D: "四元數 2",
  T_50_META_API_122: "四元數點積",
  T_50_META_API_122_D: "計算兩個四元數的點積",
  T_50_META_API_123: "四元數反轉",
  T_50_META_API_123_D: "計算四元數的反轉值",
  T_50_META_API_123_P0_D: "四元數",
  T_50_META_API_124: "四元數方向旋轉",
  T_50_META_API_124_D: "計算從「起點」到「終點」的旋轉四元數",
  T_50_META_API_124_P0_D: "起點",
  T_50_META_API_124_P1_D: "終點",
  T_50_META_API_125: "四元數漸進旋轉",
  T_50_META_API_125_D: "計算從「起點」到「終點」的旋轉四元數，最大角度變化為允許的旋轉角度上限。",
  T_50_META_API_125_P0: "起始值",
  T_50_META_API_125_P0_D: "初始四元數",
  T_50_META_API_125_P1: "目標值",
  T_50_META_API_125_P1_D: "目標四元數",
  T_50_META_API_125_P2: "最大角度變化量",
  T_50_META_API_125_P2_D: "最大旋轉角度",
  T_50_META_API_126: "取得陀螺儀方向",
  T_50_META_API_126_D: "裝置在 3D 空間中的方向，表示三軸旋轉角度",
  T_50_META_API_127: "取得陀螺儀重力值",
  T_50_META_API_127_D: "裝置感測器所偵測到的重力分量",
  T_50_META_API_128: "取得陀螺儀旋轉速率",
  T_50_META_API_128_D: "指的是裝置在三維空間中旋轉移動的速度，由陀螺儀感測器量測的相關術語。",
  T_50_META_API_129: "取得校正後的陀螺儀旋轉速率",
  T_50_META_API_129_D: "描述裝置旋轉速率，並透過補償感測器噪訊或偏差以獲得更精準的結果。",
  T_50_META_API_130: "取得使用者加速度",
  T_50_META_API_130_D: "裝置加速度中扣除重力部分的結果，表示使用者操作或外力造成的加速度。",
  T_50_META_API_131: "取得觸控資訊",
  T_50_META_API_131_D: "取得指定索引的觸控資訊（包含位置、位移與變更時間）。",
  T_50_META_API_131_P0_D: "分配觸控點 ID，從 0 開始",
  T_50_META_API_131_P1_D: "觸控位置",
  T_50_META_API_131_P2: "位置變化量",
  T_50_META_API_131_P2_D: "與上一幀相比的位置位移",
  T_50_META_API_131_P3: "時間變化量",
  T_50_META_API_131_P3_D: "自上一幀以來經過的時間",
  T_50_META_API_132: "取得螢幕觸控點數",
  T_50_META_API_132_D: "取得目前螢幕上的觸控點數",
  T_50_META_API_133: "裝置震動",
  T_50_META_API_133_D: "使裝置震動一次",
  T_50_META_API_134_D: "通知目標玩家裝置播放音訊",
  T_50_META_API_134_P0_D: "目標玩家",
  T_50_META_API_134_P1_D: "音訊資源",
  T_50_META_API_134_P2_D: "播放速度（有效範圍：0.1~3.0；1＝正常，<1＝減速，>1＝加速）",
  T_50_META_API_135_D: "播放一次性音訊檔案",
  T_50_META_API_135_P0_D: "音訊資源",
  T_50_META_API_135_P1_D: "播放速度",
  T_50_META_API_136: "格式化字串",
  T_50_META_API_136_D: "格式化這些字串",
  T_50_META_API_136_P0_D: "使用 Go 語言格式化語法控制的格式化字串",
  T_50_META_API_136_P1: "參數陣列",
  T_50_META_API_136_P1_D: "參數清單",
  T_50_META_API_137: "貼上元件",
  T_50_META_API_137_D: "複製或新增元件資料",
  T_50_META_API_137_P0: "來源",
  T_50_META_API_137_P0_D: "來源實體",
  T_50_META_API_137_P1_D: "目標實體",
  T_50_META_API_137_P2: "元件類型",
  T_50_META_API_137_P2_D: "元件類型",
  T_50_META_API_137_P3: "是否成功",
  T_50_META_API_137_P3_D: "是否成功",
  T_50_META_API_138: "下一幀復活",
  T_50_META_API_138_D: "在下一幀執行復活",
  T_50_META_API_139: "下一幀淘汰",
  T_50_META_API_139_D: "在下一幀淘汰戰鬥實體",
  T_50_META_API_139_P0_D: "戰鬥實體",
  T_50_META_API_140: "下一幀退出遊戲",
  T_50_META_API_140_D: "在下一幀執行退出遊戲",
  T_50_META_API_141: "取得麥克風音量",
  T_50_META_API_141_D: "取得麥克風音量。若玩家麥克風關閉或無授權則返回狀態。",
  T_50_META_API_141_P0: "音量",
  T_50_META_API_141_P0_D: "麥克風音量",
  T_50_META_API_141_P1_D: "麥克風是否開啟",
  T_50_META_API_142: "取得渲染品質",
  T_50_META_API_142_D: "取得目前渲染品質（枚舉：低／中／高／超高）",
  T_50_META_API_143: "取得渲染解析度",
  T_50_META_API_143_D: "取得目前的渲染解析度",
  T_50_META_API_144: "綁定自訂玩家",
  T_50_META_API_144_D: "動態設定此玩家的綁定目標，將覆蓋現有綁定。失敗時會回傳 false。",
  T_50_META_API_144_P0: "自訂玩家",
  T_50_META_API_144_P0_D: "將此自訂玩家綁定至玩家後，其位置與方向等資料將自動同步",
  T_50_META_API_144_P1_D: "目標玩家",
  T_50_META_API_145: "解除自訂玩家綁定",
  T_50_META_API_145_D: "取消綁定。失敗時回傳 false",
  T_50_META_API_145_P0: "自訂玩家",
  T_50_META_API_145_P0_D: "清除此目標的所有綁定。解除後，位置與方向等資料將不再自動同步",
  T_50_META_API_146_P0_D: "一個自訂玩家",
  T_50_META_API_147: "設定自訂玩家狀態",
  T_50_META_API_147_D: "自動上傳至伺服器並與所有用戶端同步。失敗時回傳 false。",
  T_50_META_API_147_P0: "自訂玩家",
  T_50_META_API_147_P1: "狀態",
  T_50_META_API_147_P1_D: "通常用於儲存動畫狀態，可透過「取得自訂玩家狀態」取得同步狀態。",
  T_50_META_API_148: "取得自訂玩家狀態",
  T_50_META_API_148_D: "狀態資料會自動同步至伺服器。失敗時回傳 false。",
  T_50_META_API_148_P0: "自訂玩家",
  T_50_META_API_148_P1: "狀態",
  T_50_META_API_148_P1_D: "使用「設定自訂玩家狀態」來設定狀態",
  T_50_META_API_149: "設定距離音量",
  T_50_META_API_149_D: "設定玩家之間的距離範圍，以動態調整音量。",
  T_50_META_API_149_P0: "距離清單",
  T_50_META_API_149_P0_D: "一組距離範圍清單，與音量清單中的元素一一對應。",
  T_50_META_API_149_P1: "音量清單",
  T_50_META_API_149_P1_D: "一組音量清單，與距離清單中的元素一一對應。",
  T_50_META_API_150: "取得好友",
  T_50_META_API_150_D: "取得玩家的好友 ID 清單",
  T_50_META_API_151: "取得預設 UI 資訊",
  T_50_META_API_151_D: "取得玩家的預設 UI 位置",
  T_50_META_API_151_P0_D: "預設介面",
  T_50_META_API_151_P1_D: "狀態",
  T_50_META_API_151_P2_D: "UI 位置",
  T_50_META_API_151_P3: "尺寸",
  T_50_META_API_151_P3_D: "UI 尺寸",
  T_50_META_API_152: "推播自訂事件",
  T_50_META_API_152_D: "推播一個自訂事件，供所有實體接收（監聽）事件",
  T_50_META_API_153: "向實體傳送事件",
  T_50_META_API_153_D: "傳送自訂事件至目標實體",
  T_50_META_EVT_17: "螢幕觸控開始",
  T_50_META_EVT_17_D: "螢幕被觸碰時啟動事件",
  T_50_META_EVT_17_P0: "觸控索引",
  T_50_META_EVT_17_P0_D: "觸控點索引",
  T_50_META_EVT_17_P1_D: "觸控位置",
  T_50_META_EVT_18: "螢幕觸控結束",
  T_50_META_EVT_18_D: "螢幕被觸碰時結束事件",
  T_50_META_EVT_18_P0: "觸控索引",
  T_50_META_EVT_18_P0_D: "觸控點索引",
  T_50_META_EVT_18_P1_D: "螢幕上的觸控位置",
  T_50_META_EVT_19: "接收到 Persona 建房結果",
  T_50_META_EVT_19_D: "建立個人聊天室失敗時接收對應結果",
  T_50_META_EVT_19_P1: "房間 ID",
  T_50_META_EVT_19_P1_D: "房間 ID",
  T_50_META_EVT_20: "使用者退出或對戰結束",
  T_50_META_EVT_20_D: "當使用者退出比賽或比賽結束時觸發",
  T_50_META_TYP_11_I44: "距離音量",
  T_50_META_TYP_11_I44_D: "根據玩家之間的距離動態調整音量",
  T_50_META_TYP_22_I9_D: "用於建立 UI 的資源 ID",
  T_50_META_TYP_244_I12_D: "文字框寬度",
  T_50_META_TYP_244_I13_D: "文字框高度",
  T_50_META_TYP_244_I14_D: "溢出處理類型",
  T_50_META_TYP_335_I10_D: "播放速度（有效值需大於 0，預設為 1）",
  T_50_META_TYP_409_I20: "檔案建立失敗",
  T_50_META_TYP_409_I20_D: "IO 操作失敗：建立檔案時發生錯誤",
  T_50_META_TYP_409_I21: "檔名無效",
  T_50_META_TYP_409_I21_D: "IO 操作失敗：檔名無效",
  T_50_META_TYP_448_I0_D: "被控制的骨架部分",
  T_50_META_TYP_448_I1_D: "骨架部分所看向的目標",
  T_50_META_TYP_451: "溢出類型",
  T_50_META_TYP_451_D: "處理文字溢出的方式",
  T_50_META_TYP_452: "自訂 UI 資源 ID",
  T_50_META_TYP_452_D: "用於描述自訂 HUD 資源的 ID",
  T_50_META_TYP_453: "渲染品質類型",
  T_50_META_TYP_453_D: "渲染品質的列舉值",
  T_50_META_TYPE_448_D: "此實體用於控制骨架部分看向目標",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D物件生成地圖",
  T_50_SD_WS_MAPTAG_AIRACING: "競速AI生成地圖",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "動畫狀態名稱枚舉",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "停用腳步震動",
  T_50_XXJ_WS_NOPERFORMANCE: "尚未建立演出檔案",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta 版本",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "親愛的創作者們，目前演出編輯器仍處於測試階段，可能包含錯誤或尚未完善的功能，請小心使用。",
  T_50_XXJ_WS_PERFORMANCE_NEW: "新增演出檔案",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "新增關鍵片段",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "路徑跟隨軌道",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "動畫",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "動畫軌道",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "音軌",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "暫停",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "無限迴圈",
  T_50_XXJ_WS_TIMELINE_DURATION: "時長：{0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "動畫與模型不匹配",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "關鍵片段重疊",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "綁定實體遺失",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "曲目名稱不得為空",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC 軌道",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "屬性軌道",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "移除關鍵片段",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0} 秒",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "軌道數量上限已達",
  T_50_XYL_WS_AIGETERATESHOW: "幾何構件",
  T_50_YU_F_B_VA_WITCH: "秘術大師(下裝)",
  T_50_YU_F_H_VA_WITCH: "秘術大師(頭飾)",
  T_50_YU_F_HA_VA_WITCH: "秘術大師(臉彩)",
  T_50_YU_F_S_VA_WITCH: "秘術大師(鞋子)",
  T_50_YU_F_T_VA_WITCH: "秘術大師(上裝)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "自訂事件",
  T_51_GT_WS_BASIC: "基礎",
  T_51_GT_WS_GLOBALEVENT: "全局事件",
  T_51_GT_WS_PRIVATEEVENT: "私有事件",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "遊戲開始準備時間",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "只讀屬性",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "女用黑色皮夾克(上裝)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "蘑菇與玫瑰(下裝)",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "無名之黑(鞋子)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GSL電競短褲(下裝)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GSL電競裙(下裝)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "無名之黑(上裝)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "藍色復古清涼(上裝)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "蘑菇與玫瑰(上裝)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GSL電競(上裝)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "恭喜發財(下裝)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "休閒運動(下裝)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "黑色星期五(下裝)",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "戶外休閒(下裝)",
  TXT_AVATAR_MALE_PANTS_MARIO: "水管工(下裝)",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "戶外休閒(鞋子)",
  TXT_AVATAR_MALE_SHOE_RED: "紅色靴子(鞋子)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "花開富貴(上裝)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "休閒運動(上裝)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "恐怖份子(上裝)",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "酷霸之黑(上裝)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "黑色星期五(上裝)",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "戶外休閒(上裝)",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "水管工(上裝)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "賽場嬌點(上裝)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "詭夜小丑(頭飾)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "賽場之星(上裝)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "無袖拉鍊衫(上裝)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "血舌之神的化身",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "殺戮鬼(面飾)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "全臂刺青",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "釋放自我(下裝)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "維多莉亞(下裝)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "靈能之翼(下裝)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "千本櫻(下裝)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "千本櫻(鞋子)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "冰爽(鞋子)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "長腿妹妹(下裝)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "千本櫻(上裝)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "止戰宣言(下裝)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "天人(下裝)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "天下布武(下裝)",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "戰象(上裝)",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "明日之星(鞋子)",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "天下布武(鞋子)",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "玄鐵星(鞋子)",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "藍鯨(下裝)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "止戰宣言(上裝)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "明日之星(上裝)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "天下布武(上裝)",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "白色旋風(下裝)",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "花式開球(下裝)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "青色回憶(上裝)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "花式開球(上裝)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "棒球少年(下裝)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "嘻哈達人(頭飾)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "棒球少年(鞋子)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "青色旋律(上裝)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "棒球少年(上裝)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Q龍特務",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "勝利者銀靴(鞋子)",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "三獅軍團 T-Shirt",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "狂氣貴公子(面飾)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "狂氣貴公子(頭飾)",
  TXT_AVATAR_PARACHUTE_8: "降落傘-笑臉",
  TXT_AVATAR_SHIRT_PLAID_2: "紅黑格紋襯衫(上裝)",
  TXT_AVATAR_SHOES_1: "白色球鞋(鞋子)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "橘色學校制服(上裝)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "紅色學校制服(上裝)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "黃色學校制服(上裝)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "粉色學校制服(上裝)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "淡黃色學校制服(上裝)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "深藍色學校制服(上裝)",
  TXT_AVATAR_TSHIRT_WEEK_007: "熱情周日 T-Shirt",
  TXT_BANNER_NAME_MISHA: "背景-飆速",
  TXT_CHARACTER_ADAM_NAME: "亞當",
  TXT_CHARACTER_BODYGUARD_NAME: "尼基塔",
  TXT_CHARACTER_COP_NAME: "安德魯",
  TXT_CHARACTER_EVA_NAME: "夏娃",
  TXT_CHARACTER_NURSE_NAME: "奧利維亞",
  TXT_CHARACTER_RACERGIRL_NAME: "米莎",
  TXT_CHARACTER_RUNNER_NAME: "凱莉",
  TXT_CHARACTER_SEAMAN_NAME: "福特",
  TXT_CLAN_NAME: "名稱",
  TXT_COLLECTION_DESCRIPTION: "敘述",
  TXT_COLLECTION_HEADPORTRAIT: "頭像",
  TXT_INVENTORY_TITLE_EQUIPMENT: "裝備",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "步槍子彈",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "背包 Lv.1",
  TXT_ITEM_BAG2: "背包 Lv.2",
  TXT_ITEM_BAG3: "背包 Lv.3",
  TXT_ITEM_BASEBALLPOLE: "球棒",
  TXT_ITEM_BOWAMMO: "箭支",
  TXT_ITEM_CHANGUO: "平底鍋",
  TXT_ITEM_CROSSBOW: "十字弩",
  TXT_ITEM_DESC_FLASH: "戰術性投擲武器，可讓一定範圍內的敵人陷入短暫失明",
  TXT_ITEM_EAGLE: "沙漠之鷹",
  TXT_ITEM_FAK: "急救包",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "拳頭",
  TXT_ITEM_FLASH: "閃光彈",
  TXT_ITEM_FOREGRIP1: "握把 Lv.1",
  TXT_ITEM_FOREGRIP2: "握把 Lv.2",
  TXT_ITEM_FOREGRIP3: "握把 Lv.3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "手榴彈",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "手銃",
  TXT_ITEM_HEATSIGHT: "熱成像瞄準鏡",
  TXT_ITEM_HELMET1: "頭盔 Lv.1",
  TXT_ITEM_HELMET2: "頭盔 Lv.2",
  TXT_ITEM_HELMET3: "頭盔 Lv.3",
  TXT_ITEM_HGAMMO: "手槍子彈",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "榴彈",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "大砍刀",
  TXT_ITEM_MAGEZINE1: "擴容彈匣 Lv.1",
  TXT_ITEM_MAGEZINE2: "擴容彈匣 Lv.2",
  TXT_ITEM_MAGEZINE3: "擴容彈匣 Lv.3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "補償器 Lv.1",
  TXT_ITEM_MUZZLE2: "補償器 Lv.2",
  TXT_ITEM_MUZZLE3: "補償器 Lv.3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "霰彈槍子彈",
  TXT_ITEM_SIGHT2: "2倍瞄準鏡",
  TXT_ITEM_SIGHT4: "4倍瞄準鏡",
  TXT_ITEM_SILENCER1: "消音器",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "衝鋒槍子彈",
  TXT_ITEM_SNAMMO: "狙擊槍子彈",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "防彈衣 Lv.1",
  TXT_ITEM_VEST2: "防彈衣 Lv.2",
  TXT_ITEM_VEST3: "防彈衣 Lv.3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "比賽結果",
  TXT_MESSAGEBOX_ERROR: "錯誤",
  TXT_OB10_HQW_ITEM_BIPOD: "折疊支架",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "油桶",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "馬吉爾",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "殺戮衝動",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "球棒-烤玉米",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "爆炸範圍",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "大砍刀-赤焰處刑人",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "感應地雷",
  TXT_OB11_HQW_LANDMINE_DESC: "可以佈置在地上的感應地雷，敵人靠近就會爆炸，注意自己不要踩到",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "卡洛琳",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "鼓掌",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "嘻哈超人舞",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "搞笑雞",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "哈囉！",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "大笑",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "挑釁",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "持霰彈槍時機動性提升 [FFB300]{0}%[-]。",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "敏捷身手",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "SCAR-獵豹衝刺",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "SCAR-來自未來",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "修復工具包",
  TXT_OB5_HISTORY_HEADSHOOT: "爆頭",
  TXT_OB5_HISTORY_LIVE: "存活",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "馬克西姆",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "吃蘑菇和急救包的時間減少 [FFB300]{0}%[-]。",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "風捲殘雲",
  TXT_OB7_ZC_CLAN_NICKNAME: "暱稱",
  TXT_OB7_ZJS_HISTORY_TIME: "時間",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "營火棒",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "降落傘-雷電",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "查拉",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "拳頭攻擊傷害提升 [FFB300]{0}%[-]。",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "至上拳術",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "AWM-青之粒子",
  TXT_OB8_ZXR_G18_CAMO_NAME: "G18-數位粉碎",
  TXT_OB8_ZXR_M249_CAMO_NAME: "M249-森林之王",
  TXT_OB8_ZXR_M79_CAMO_NAME: "M79-轟天雷",
  TXT_OB8_ZXR_USP_CAMO_NAME: "USP-雪豹",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "帕洛瑪",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "軍火庫",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "滑板-綠色新星",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "凝膠護盾",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "AK47-草原掠食者",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "FAMAS-血鯊",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "G18-飢貪獵人",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "GROZA-蒼炎",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "M1014-午夜迷情",
  TXT_OB9_ZXR_M14_CAMO_NAME: "M14-靈魂之血",
  TXT_OB9_ZXR_M1873_NAME: "M1873-深海凝視",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "大砍刀-可憐的魚",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "MP5-無差別絞碎機",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "SCAR-量子衝擊",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "SKS-荒野殺機",
  TXT_OPTION_HIGH_BRIGHTNESS: "明亮",
  TXT_PLAYER_RANK: "排名",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "百慕達",
  TXT_SETTING_CHANGEWEAPON: "快速武器切換按鈕",
  TXT_SETTING_OB4_NOTREAL: "黑墨",
  TXT_SKILL_DESC_COP: "防彈衣受損比例減少 [FFB300]{0}%[-]。",
  TXT_SKILL_DESC_RUNNER: "衝刺速度提高 [FFB300]{0}%[-]。",
  TXT_SKILL_NAME_COP: "護甲精通",
  TXT_SKILL_NAME_NURSE: "治癒之手",
  TXT_SKILL_NAME_RACERGIRL: "風馳電掣",
  TXT_SKILL_NAME_RUNNER: "急速衝刺",
  TXT_SKILL_NAME_SEAMAN: "鋼鐵意志",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "衝刺",
  TXT_TUTORIAL_PICKUP_LABEL0: "武器",
  T_34_M_WS_VFXTYPE: "特效類型",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "攻擊目標",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "玩家 UI 類型",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "怪物技能類型",
  T_45_META_WS_DESCRIPTIVECOLOR: "描述性顏色",
  T_45_META_WS_GAMETIME: "遊戲時間",
  T_45_META_WS_PROPERTY: "屬性",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "按鈕樣式類型",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "按鈕類型",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "加速度",
  T_46_META_WS_A_ACCOUNTID: "用戶帳號",
  T_46_META_WS_A_ACTIONTYPE: "行為類型",
  T_46_META_WS_A_ACTIVE: "活動狀態",
  T_46_META_WS_A_ANGLE: "圓心角",
  T_46_META_WS_A_ANY: "任何",
  T_46_META_WS_A_APPEARANCEGROUP: "外觀組",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "斷言表達式",
  T_46_META_WS_A_ATTACHMENT: "配件",
  T_46_META_WS_A_ATTACHMENTS: "配件列表",
  T_46_META_WS_A_ATTACKABLE: "可攻擊",
  T_46_META_WS_A_ATTACKER: "造成傷害的實體",
  T_46_META_WS_A_ATTACKTARGET: "攻擊目標",
  T_46_META_WS_A_AUTOPLAY: "立即播放",
  T_46_META_WS_A_AXIS: "旋轉軸",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "基礎",
  T_46_META_WS_A_BOUNDTARGET: "綁定目標",
  T_46_META_WS_A_BTREE: "行為樹",
  T_46_META_WS_A_BUFF: "增益",
  T_46_META_WS_A_CAMERA: "相機",
  T_46_META_WS_A_CAPICITY: "容量",
  T_46_META_WS_A_CENTER: "中心",
  T_46_META_WS_A_CHANGEROTATION: "更改旋轉",
  T_46_META_WS_A_CHANNEL: "頻道",
  T_46_META_WS_A_CHASEENEMY: "自動索敵",
  T_46_META_WS_A_CHILD: "子節點",
  T_46_META_WS_A_COLOR: "叠加色",
  T_46_META_WS_A_COLUMN: "列數",
  T_46_META_WS_A_COLUMNNAME: "列名",
  T_46_META_WS_A_COMEBACK: "是否返回",
  T_46_META_WS_A_COMPONENT: "組件類型 ID",
  T_46_META_WS_A_CONTENT: "內容",
  T_46_META_WS_A_COORDINATESYSTEM: "坐標系",
  T_46_META_WS_A_COUNT: "數量",
  T_46_META_WS_A_COUNTS: "掉落物品數量列表",
  T_46_META_WS_A_CREATEDENTITY: "創建的實體",
  T_46_META_WS_A_CROSSPLATFORM: "是否跨端",
  T_46_META_WS_A_CULLINGMASK: "層遮罩",
  T_46_META_WS_A_CURVE: "曲線",
  T_46_META_WS_A_CUSTOMTAG: "自定義標籤",
  T_46_META_WS_A_CUTRADIUS: "截取半徑",
  T_46_META_WS_A_DAMAGE: "傷害量",
  T_46_META_WS_A_DAMAGESEGMENTS: "傷害分段",
  T_46_META_WS_A_DEGREE: "角度",
  T_46_META_WS_A_DELTA: "差值",
  T_46_META_WS_A_DEPTH: "距螢幕距離",
  T_46_META_WS_A_DESTVAL: "目標值",
  T_46_META_WS_A_DIFFICULTY: "難度",
  T_46_META_WS_A_DIRECTION: "方向",
  T_46_META_WS_A_DISABLE: "是否關閉",
  T_46_META_WS_A_DISPLACEMENT: "位移",
  T_46_META_WS_A_DISTANCE: "距離",
  T_46_META_WS_A_DIVINGMAXSPEED: "垂直下降時最大水平垂直速度",
  T_46_META_WS_A_DOTWEEN: "執行補間動畫",
  T_46_META_WS_A_DURATION: "持續時間 (秒)",
  T_46_META_WS_A_EMOTE: "Emote 類型",
  T_46_META_WS_A_ENABLE: "啟用默認行為邏輯",
  T_46_META_WS_A_ENDAREACENTER: "結束區域中心",
  T_46_META_WS_A_ENDAREARANGE: "結束區域範圍",
  T_46_META_WS_A_ENDPOSITION: "終點",
  T_46_META_WS_A_ENDRANK: "結束名次",
  T_46_META_WS_A_EQUIPMENTS: "武器或裝備",
  T_46_META_WS_A_EVENTID: "自定義事件 ID",
  T_46_META_WS_A_EXPONENT: "指數",
  T_46_META_WS_A_FACTION: "陣營",
  T_46_META_WS_A_FACTORTYPE: "屬性因子類型",
  T_46_META_WS_A_FILTERTYPE: "篩選類型",
  T_46_META_WS_A_FINALRADIUS: "最終半徑",
  T_46_META_WS_A_FINDVALUE: "要查找字符串",
  T_46_META_WS_A_FIXEDRANGE: "固定區域",
  T_46_META_WS_A_FOLLOWTARGET: "跟隨對象",
  T_46_META_WS_A_FONTCOLOR: "字體顏色",
  T_46_META_WS_A_FONTSIZE: "字體大小",
  T_46_META_WS_A_FOOTBALL: "足球",
  T_46_META_WS_A_FORCE: "力矢量",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "強制開傘高度",
  T_46_META_WS_A_FORCEMODE: "施力類型",
  T_46_META_WS_A_FORWARD: "朝向",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "任務ID",
  T_46_META_WS_A_HALFEXTENTS: "尺寸（一半）",
  T_46_META_WS_A_HEIGHT: "高度",
  T_46_META_WS_A_HEIGHTSEGMENTS: "高度分段",
  T_46_META_WS_A_HITDISTANCE: "命中距離",
  T_46_META_WS_A_HITDISTANCES: "命中距離",
  T_46_META_WS_A_HITENTITIES: "命中實體",
  T_46_META_WS_A_HITENTITY: "命中實體",
  T_46_META_WS_A_HITNORMAL: "命中點表面法線",
  T_46_META_WS_A_HITNORMALS: "命中點表面法線",
  T_46_META_WS_A_HITPOINTS: "命中點",
  T_46_META_WS_A_HITPOSITION: "命中點",
  T_46_META_WS_A_INCLUDETRIGGER: "包含觸發器",
  T_46_META_WS_A_INDEX: "索引",
  T_46_META_WS_A_INDEXS: "索引列表",
  T_46_META_WS_A_INITIALVELOCITY: "初速度",
  T_46_META_WS_A_INITRADIUS: "初始半徑",
  T_46_META_WS_A_INWALLET: "轉入錢包",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "底部是否有觸碰",
  T_46_META_WS_A_ISEXIST: "是否存在",
  T_46_META_WS_A_ISLOOP: "是否循環",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "是否映射在螢幕內",
  T_46_META_WS_A_ISPAUSE: "暫停",
  T_46_META_WS_A_ISSIDECOLLIDING: "側面是否有觸碰",
  T_46_META_WS_A_ISSUCCESS: "是否成功",
  T_46_META_WS_A_ISTOPCOLLIDING: "頂部是否有觸碰",
  T_46_META_WS_A_ITEM: "物品",
  T_46_META_WS_A_ITEMID: "ItemID",
  T_46_META_WS_A_ITEMS: "掉落物品 ID 列表",
  T_46_META_WS_A_ITEMTYPE: "ItemType",
  T_46_META_WS_A_JERSEYTYPE: "衣服樣式",
  T_46_META_WS_A_KEEPVELOCITY: "保持速度",
  T_46_META_WS_A_KEY: "鍵",
  T_46_META_WS_A_KEYCOLUMN: "列數",
  T_46_META_WS_A_KEYS: "字段名列表",
  T_46_META_WS_A_LAYER: "可見性層級",
  T_46_META_WS_A_LAYERMASK: "層遮罩",
  T_46_META_WS_A_LEFT: "左值",
  T_46_META_WS_A_LEFTVALUE: "列表",
  T_46_META_WS_A_LENGTH: "長度",
  T_46_META_WS_A_LEVELOBJECT: "物件 ID",
  T_46_META_WS_A_LOG: "日誌",
  T_46_META_WS_A_LOOKATTARGET: "注視目標",
  T_46_META_WS_A_LOOPTYPE: "循環類型",
  T_46_META_WS_A_MAINCOLOR1: "主色一",
  T_46_META_WS_A_MAINCOLOR2: "主色二",
  T_46_META_WS_A_MAPCODE: "戰場碼",
  T_46_META_WS_A_MAPPEDPOSITION: "映射位置",
  T_46_META_WS_A_MAX: "最大值",
  T_46_META_WS_A_MAXDISPLACEMENT: "最大位移",
  T_46_META_WS_A_MAXDISTANCE: "探測距離",
  T_46_META_WS_A_MIN: "最小值",
  T_46_META_WS_A_MISSIONID: "任務 ID",
  T_46_META_WS_A_MISSIONPROGRESS: "任務進度",
  T_46_META_WS_A_MODIFYTYPE: "修改方式",
  T_46_META_WS_A_MONEYTYPE: "貨幣類型",
  T_46_META_WS_A_MUST: "必須包含",
  T_46_META_WS_A_NAME: "名字",
  T_46_META_WS_A_NEWVALUE: "要替換的新字符串",
  T_46_META_WS_A_NODE: "行為樹節點",
  T_46_META_WS_A_NORMAL: "法向",
  T_46_META_WS_A_NOT: "必須不包含",
  T_46_META_WS_A_OBSERVER: "觀察者",
  T_46_META_WS_A_OFFSET: "偏移",
  T_46_META_WS_A_OLDVALUE: "要替換的老字符串",
  T_46_META_WS_A_OPERATIOMETHOD: "運算方式",
  T_46_META_WS_A_OPTIONS: "選項",
  T_46_META_WS_A_OTHERCOLOR: "配色",
  T_46_META_WS_A_OUTFIT: "服飾",
  T_46_META_WS_A_OUTFITS: "服裝列表",
  T_46_META_WS_A_OUTWALLET: "轉出錢包",
  T_46_META_WS_A_OWNER: "所屬者",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "開傘時最大水平垂直速度",
  T_46_META_WS_A_PARAMS: "參數列表",
  T_46_META_WS_A_PARENT: "父節點",
  T_46_META_WS_A_PARENTWIDGET: "父控件",
  T_46_META_WS_A_PATH: "路徑",
  T_46_META_WS_A_PATHPOINTS: "尋路點",
  T_46_META_WS_A_PHASEINDEX: "階段索引",
  T_46_META_WS_A_PLATFORM: "平台",
  T_46_META_WS_A_PLAYER: "玩家",
  T_46_META_WS_A_PLAYSPEED: "播放速度",
  T_46_META_WS_A_POSITION: "位置",
  T_46_META_WS_A_POSITIONS: "目標點集合",
  T_46_META_WS_A_POSTION: "位置",
  T_46_META_WS_A_PREFAB: "預製體ID",
  T_46_META_WS_A_PROPERTY: "屬性類型",
  T_46_META_WS_A_PROPERTYID: "屬性",
  T_46_META_WS_A_PURSUITTARGET: "追擊目標",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "半徑",
  T_46_META_WS_A_RANDOMDECAY: "隨機衰減係數",
  T_46_META_WS_A_RANDOMRANGE: "隨機範圍",
  T_46_META_WS_A_RANDOMRATIO: "隨機係數",
  T_46_META_WS_A_RANGE: "範圍",
  T_46_META_WS_A_RANK: "名次",
  T_46_META_WS_A_REALCOIN: "真實貨幣",
  T_46_META_WS_A_REALNUMBER: "實數",
  T_46_META_WS_A_RESET: "重置",
  T_46_META_WS_A_RESOURCE: "資源",
  T_46_META_WS_A_RESULT: "結果值",
  T_46_META_WS_A_RIGHT: "右值",
  T_46_META_WS_A_RIGHTVALUE: "列表",
  T_46_META_WS_A_ROTATION: "旋轉歐拉角",
  T_46_META_WS_A_ROW: "行數",
  T_46_META_WS_A_SAMPLEPOINT: "取樣點",
  T_46_META_WS_A_SCALE: "縮放",
  T_46_META_WS_A_SCENEID: "場景 ID",
  T_46_META_WS_A_SCORE: "積分值",
  T_46_META_WS_A_SCORENAME: "積分標題",
  T_46_META_WS_A_SCREENPOSITION: "螢幕座標",
  T_46_META_WS_A_SCRIPT: "腳本ID",
  T_46_META_WS_A_SEAT: "座位",
  T_46_META_WS_A_SEP: "分隔標識符",
  T_46_META_WS_A_SEPSTR: "分隔符",
  T_46_META_WS_A_SHEETNAME: "表名",
  T_46_META_WS_A_SHOPITEM: "商品",
  T_46_META_WS_A_SHOWBACKGROUND: "顯示背景",
  T_46_META_WS_A_SHOWMATCHRESULT: "顯示結算信息",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "取消時顯示彈窗",
  T_46_META_WS_A_SKILL: "技能",
  T_46_META_WS_A_SKILLS: "玩家技能列表",
  T_46_META_WS_A_SKILLTARGET: "技能目標",
  T_46_META_WS_A_SKIN: "背包外觀",
  T_46_META_WS_A_SLOT: "槽位",
  T_46_META_WS_A_SRCVAL: "起始值",
  T_46_META_WS_A_SRCVALUE: "起始值",
  T_46_META_WS_A_STARTAREACENTER: "起始區域中心",
  T_46_META_WS_A_STARTAREARANGE: "起始區域範圍",
  T_46_META_WS_A_STARTINDEX: "起始位置",
  T_46_META_WS_A_STARTPOSITION: "起點",
  T_46_META_WS_A_STARTRANK: "起始名次",
  T_46_META_WS_A_STATE: "動畫狀態",
  T_46_META_WS_A_STATUS: "狀態",
  T_46_META_WS_A_STATUSCODE: "狀態碼",
  T_46_META_WS_A_STYLE: "風格",
  T_46_META_WS_A_SURFINGMAXSPEED: "滑翔時最大水平垂直速度",
  T_46_META_WS_A_TARGET: "目標",
  T_46_META_WS_A_TARGETPOSITION: "終點",
  T_46_META_WS_A_TEAMSEQ: "隊伍",
  T_46_META_WS_A_THRESHOLD: "閾值",
  T_46_META_WS_A_TIMESTAMP: "時間戳",
  T_46_META_WS_A_TIPS: "提示",
  T_46_META_WS_A_TITLE: "標題",
  T_46_META_WS_A_TOKENCOUNT: "Token 數量",
  T_46_META_WS_A_TOKENID: "Token ID",
  T_46_META_WS_A_TORQUE: "力矩",
  T_46_META_WS_A_TOUCHPOINT: "觸點",
  T_46_META_WS_A_TRANSITIONTIME: "切換時間(ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "切換方式",
  T_46_META_WS_A_TRIGGER: "觸發器",
  T_46_META_WS_A_TYPE: "類型",
  T_46_META_WS_A_UI: "所屬Hud實體",
  T_46_META_WS_A_UIID: "HUD 唯一索引",
  T_46_META_WS_A_UPWARD: "正上方對應的方向",
  T_46_META_WS_A_VALUE: "值",
  T_46_META_WS_A_VALUEA: "左值",
  T_46_META_WS_A_VALUEB: "右值",
  T_46_META_WS_A_VALUES: "值列表",
  T_46_META_WS_A_VALUET: "插值",
  T_46_META_WS_A_VALUETYPE: "值類型",
  T_46_META_WS_A_VEHICLE: "載具",
  T_46_META_WS_A_VEHICLESKIN: "載具塗裝",
  T_46_META_WS_A_VELOCITY: "速度",
  T_46_META_WS_A_VELOCITYXZ: "向量XZ",
  T_46_META_WS_A_VELOCITYY: "向量Y",
  T_46_META_WS_A_VISIBLE: "是否可見",
  T_46_META_WS_A_WAITTIME: "等待時長 (秒)",
  T_46_META_WS_A_WALLET: "錢包",
  T_46_META_WS_A_WEAPON: "武器",
  T_46_META_WS_A_WEAPONSKIN: "武器塗裝",
  T_46_META_WS_A_WIDGETID: "控件唯一索引",
  T_46_META_WS_A_WIDGETTYPE: "控件類型",
  T_46_META_WS_A_WIDTH: "寬度",
  T_46_META_WS_A_WORLDPOSITION: "世界座標",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "是否保持世界位置",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "絕對值",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "增加 AOI 特別關注",
  T_46_META_WS_ADDATTACHMENTS: "增加配件",
  T_46_META_WS_ADDBUFF: "增加 Buff",
  T_46_META_WS_ADDCOMPONENT: "增加組件",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "增加足球速度",
  T_46_META_WS_ADDFORCE: "施力",
  T_46_META_WS_ADDFORCEATPOSITION: "在某位置施力",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "增加公式化屬性因子",
  T_46_META_WS_ADDGAMEEVENTLOG: "增加遊戲事件日誌",
  T_46_META_WS_ADDHP: "增加血量",
  T_46_META_WS_ADDITEM: "增加物品",
  T_46_META_WS_ADDITEMINSCENE: "在場景中創建物品",
  T_46_META_WS_ADDITEMTOSHOPITEM: "增加物品到商店商品",
  T_46_META_WS_ADDMONEY: "增加金錢",
  T_46_META_WS_ADDSCRIPT: "增加腳本",
  T_46_META_WS_ADDTAG: "增加標籤",
  T_46_META_WS_ADDTOKEN: "增加 token",
  T_46_META_WS_ADDTORQUE: "施加扭矩",
  T_46_META_WS_ADDUSEREVENTLOG: "增加用戶事件日誌",
  T_46_META_WS_ANGEL: "角度",
  T_46_META_WS_APPEND: "追加列表元素",
  T_46_META_WS_APPENDRANGE: "追加列表",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "應用中途退出 UI 配置",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "斷言",
  T_46_META_WS_ASSISTPLAYER: "助攻玩家",
  T_46_META_WS_ATAN2: "Atan2",
  T_46_META_WS_ATTACKER: "攻擊者",
  T_46_META_WS_ATTACKTARGET: "攻擊目標",
  T_46_META_WS_AXISANGLETOQUATERNION: "軸角轉四元數",
  T_46_META_WS_BOXCAST: "盒體投射",
  T_46_META_WS_BOXOVERLAP: "盒體重疊",
  T_46_META_WS_BUTTONNAME: "按鈕名稱",
  T_46_META_WS_C_ACTIONTYPE: "行為類型",
  T_46_META_WS_C_AIMABLE: "可被瞄準的實體組件",
  T_46_META_WS_C_AIMASSISTABLE: "可被輔助瞄準的實體組件",
  T_46_META_WS_C_AIMASSISTTYPE: "瞄準輔助類型",
  T_46_META_WS_C_AIRDROP: "空投箱",
  T_46_META_WS_C_AMMO: "子彈組件",
  T_46_META_WS_C_AMMOTYPE: "子彈類型",
  T_46_META_WS_C_AMPHIBIAN: "水陸兩用",
  T_46_META_WS_C_ANIMATIONCLIP: "動畫片段",
  T_46_META_WS_C_ANIMATIONCLIPID: "動畫資源 ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "動畫控制器",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "可掛載動畫控制器的實體組件",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "動畫控制器 ID",
  T_46_META_WS_C_ANIMATIONSTATE: "動畫狀態",
  T_46_META_WS_C_ANIMATIONTRIGGER: "動畫觸發器",
  T_46_META_WS_C_APPEARENCE: "外觀",
  T_46_META_WS_C_ASSETCONFIGID: "資產配置 ID",
  T_46_META_WS_C_ASSETID: "資產 ID",
  T_46_META_WS_C_ATTACHMENT: "配件道具",
  T_46_META_WS_C_ATTACKABLETYPE: "可攻擊類型",
  T_46_META_WS_C_AUDIOID: "音訊 ID",
  T_46_META_WS_C_BACKPACK: "背包",
  T_46_META_WS_C_BACKPACKSKINID: "背包外觀 ID",
  T_46_META_WS_C_BASEDATAALIAS: "基礎數據別名",
  T_46_META_WS_C_BASICAPPEARANCE: "基礎外觀",
  T_46_META_WS_C_BASICCYLINDER: "基本圓柱或圓錐",
  T_46_META_WS_C_BASICSCALABLE: "基本可擴展",
  T_46_META_WS_C_BASICSPHERE: "基本球體",
  T_46_META_WS_C_BATCHCOMBINERENDER: "批量合併渲染",
  T_46_META_WS_C_BEVTREE: "行為樹",
  T_46_META_WS_C_BEVTREEATTACHABLE: "可附加的行為樹",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "行為樹自訂節點",
  T_46_META_WS_C_BEVTREEID: "行為樹 ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "行為樹節點狀態",
  T_46_META_WS_C_BEVTREENODETYPE: "行為樹節點類型",
  T_46_META_WS_C_BEZIERCURVE: "貝茲曲線",
  T_46_META_WS_C_BOOL: "布林",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "機器人難度類型",
  T_46_META_WS_C_BOUNCINGTIRE: "彈跳輪胎",
  T_46_META_WS_C_BUFFABLE: "可增益",
  T_46_META_WS_C_BUFFGENERATOR: "增益生成器",
  T_46_META_WS_C_BUFFTYPE: "增益類型",
  T_46_META_WS_C_BUILTINRENDER: "內建渲染",
  T_46_META_WS_C_BUILTINUI: "內建 UI",
  T_46_META_WS_C_BUILTINUITYPE: "內建 UI 類型",
  T_46_META_WS_C_CAMERA: "相機",
  T_46_META_WS_C_CAMERABLOCKMODE: "相機遮蔽模式",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "相機投影模式",
  T_46_META_WS_C_CAMERARAYCASTUI: "相機射線投射 UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "相機過渡類型",
  T_46_META_WS_C_CAMERATYPE: "相機類型",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "相機視角限制類型",
  T_46_META_WS_C_CAPSULETRIGGER: "膠囊觸發",
  T_46_META_WS_C_CAR: "汽車",
  T_46_META_WS_C_CHARACTERCONTROLLER: "角色控制器",
  T_46_META_WS_C_CHATCHANNEL: "聊天頻道",
  T_46_META_WS_C_CHATCHANNELTYPE: "語音頻道枚舉",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "檢查點觸發器",
  T_46_META_WS_C_COINGENERATOR: "硬幣生成器組件",
  T_46_META_WS_C_COLLECTIONID: "藏品資產ID",
  T_46_META_WS_C_COLLIDER: "碰撞器",
  T_46_META_WS_C_COLLIDERCOLLECTION: "碰撞形狀",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "碰撞形狀ID",
  T_46_META_WS_C_COLORDRUM: "染色桶",
  T_46_META_WS_C_COMBATABLE: "可戰鬥實體元件",
  T_46_META_WS_C_COMPONENT: "組件基類",
  T_46_META_WS_C_CONDITION: "條件",
  T_46_META_WS_C_CONTAINER: "實體容器",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "坐標系",
  T_46_META_WS_C_CROSSBOW: "弓箭道具",
  T_46_META_WS_C_CSVID: "配置表ID",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "自訂觸發器",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "自訂物件",
  T_46_META_WS_C_CUSTOMPATH: "自訂路徑",
  T_46_META_WS_C_CUSTOMUI: "自訂 UI",
  T_46_META_WS_C_CUSTOMUIID: "自訂介面ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "自訂 UI 或小工具",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "自訂介面控件ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "擊中身體部位類型",
  T_46_META_WS_C_DAMAGETYPE: "傷害類型枚舉",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "死亡或無敵觸發器",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "可摧毀物件",
  T_46_META_WS_C_DICE: "骰子組件",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "雙跳鞋",
  T_46_META_WS_C_DRUMMUSIC: "鼓點音樂組件",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "雙持武器類型",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "普通關卡物件",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "可動態創建物件類型",
  T_46_META_WS_C_DYNAMICFENCE: "動態圍欄",
  T_46_META_WS_C_EFFECT: "特效",
  T_46_META_WS_C_EFFECTCONTAINER: "效果容器",
  T_46_META_WS_C_EFFECTID: "特效ID",
  T_46_META_WS_C_EMOTETYPE: "Emote 類型",
  T_46_META_WS_C_ENDPOINTTRIGGER: "終點觸發器",
  T_46_META_WS_C_ENTITY: "實體類",
  T_46_META_WS_C_ENTITYORPREFABID: "實體或Prefab ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "裝備配件道具",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "裝備欄槽位類型",
  T_46_META_WS_C_EQUIPMENTTYPE: "裝備類型",
  T_46_META_WS_C_EVENTID: "事件ID",
  T_46_META_WS_C_FACTION: "陣營",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "填充方向類型",
  T_46_META_WS_C_FILLTYPE: "填充類型",
  T_46_META_WS_C_FIRETYPE: "火災類型",
  T_46_META_WS_C_FLOAT: "浮點數",
  T_46_META_WS_C_FOLDWING: "折疊翼",
  T_46_META_WS_C_FOLLOW: "位置跟隨動畫實體",
  T_46_META_WS_C_FONTTYPE: "字體枚舉",
  T_46_META_WS_C_FOOTBALL: "足球",
  T_46_META_WS_C_FORCETYPE: "力量類型",
  T_46_META_WS_C_FORMULABLE: "可公式化屬性之實體元件",
  T_46_META_WS_C_FRAMESELFRELATIVE: "相對自身每幀運動",
  T_46_META_WS_C_GAMERESULTTYPE: "遊戲結果類型",
  T_46_META_WS_C_GENDERTYPE: "性別",
  T_46_META_WS_C_GENERALSPAWNPOINT: "通用出生點",
  T_46_META_WS_C_GRENADEDEICEWALL: "反制冰牆手雷組件",
  T_46_META_WS_C_GRENADEFLASHBANG: "閃光彈",
  T_46_META_WS_C_GRENADEFROZEN: "冰凍手雷組件",
  T_46_META_WS_C_GRENADELAUNCHER: "榴彈發射器",
  T_46_META_WS_C_GRENADESMOKE: "煙霧彈",
  T_46_META_WS_C_GRENADEWEAPON: "投擲物道具基類",
  T_46_META_WS_C_GRID: "網格",
  T_46_META_WS_C_HANDCANNON: "榴彈道具",
  T_46_META_WS_C_HELMET: "頭盔",
  T_46_META_WS_C_HIERARCHICAL: "可挂载子节点的实体",
  T_46_META_WS_C_HOOKGUN: "鉤鎖槍",
  T_46_META_WS_C_HORIZALINE: "水平線",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI 轉換器",
  T_46_META_WS_C_HUMANMODELID: "人形模型ID",
  T_46_META_WS_C_ICEWALL: "冰牆",
  T_46_META_WS_C_ICEWALLCREATED: "創建的冰牆",
  T_46_META_WS_C_ICEWALLMAKER: "冰牆生成器",
  T_46_META_WS_C_ICON: "圖標實體組件",
  T_46_META_WS_C_ICONTYPE: "圖標類型",
  T_46_META_WS_C_INHALER: "吸入器",
  T_46_META_WS_C_INT: "整數",
  T_46_META_WS_C_INT64: "64位整數",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "整數Map",
  T_46_META_WS_C_INTORINTLIST: "整數或整數列表",
  T_46_META_WS_C_INVENTORYTYPE: "物品類型枚舉（待廢棄）",
  T_46_META_WS_C_ITEMBASE: "道具資產基類",
  T_46_META_WS_C_ITEMCONTAINER: "實體容器",
  T_46_META_WS_C_ITEMID: "道具ID",
  T_46_META_WS_C_ITEMIDTYPE: "物品ID類型",
  "T_46_META_WS_C_JERSEY STYLE": "球衣樣式",
  T_46_META_WS_C_JERSEYMACHINE: "換衣機",
  T_46_META_WS_C_JETSHOES: "噴氣鞋",
  T_46_META_WS_C_KEYBOARD: "鍵盤",
  T_46_META_WS_C_KNOCKDOWNTYPE: "擊倒狀態處理方式枚舉",
  T_46_META_WS_C_LANDMINE: "地雷",
  T_46_META_WS_C_LANDMINECREATED: "創建的地雷",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "發射墊LevelObj",
  T_46_META_WS_C_LAUNCHPAD: "發射墊",
  T_46_META_WS_C_LAYOUTSORTTYPE: "佈局排序類型",
  T_46_META_WS_C_LEAD1MUSIC: "Lead1音樂組件",
  T_46_META_WS_C_LEAD2MUSIC: "Lead2音樂組件",
  T_46_META_WS_C_LEAD3MUSIC: "Lead3音樂組件",
  T_46_META_WS_C_LEVELOBJECTID: "物件ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "關卡對象類型",
  T_46_META_WS_C_LIST: "列表",
  T_46_META_WS_C_LISTORMAP: "列表或字典",
  T_46_META_WS_C_LISTT: "列表模板",
  T_46_META_WS_C_LISTT_BOOL: "布林列表",
  T_46_META_WS_C_LISTT_CONDITION: "條件列表",
  T_46_META_WS_C_LISTT_ENTITY: "實體列表",
  T_46_META_WS_C_LISTT_FLOAT: "小數列表",
  T_46_META_WS_C_LISTT_INT: "整數列表",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "物品列表",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "關卡物件列表",
  T_46_META_WS_C_LISTT_LOCKEY: "本地化文本列表",
  T_46_META_WS_C_LISTT_PLAYABLE: "可玩列表",
  T_46_META_WS_C_LISTT_PLAYER: "玩家列表",
  T_46_META_WS_C_LISTT_SKILLID: "技能ID列表",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "音效實體列表",
  T_46_META_WS_C_LISTT_STRING: "字符串列表",
  T_46_META_WS_C_LISTT_TEAM: "隊伍列表",
  T_46_META_WS_C_LISTT_TYPE: "類型列表",
  T_46_META_WS_C_LISTT_VECTOR3: "三維向量列表",
  T_46_META_WS_C_LOCKEY: "本地化字符串",
  T_46_META_WS_C_LOOKAT: "注視跟隨動畫實體",
  T_46_META_WS_C_LOOPABLE: "可循環",
  T_46_META_WS_C_LOOPTYPE: "循環類型",
  T_46_META_WS_C_LOOTAMMOTYPE: "戰利品子彈類型",
  T_46_META_WS_C_LOOTARMOR: "戰利品防具",
  T_46_META_WS_C_LOOTARMORTYPE: "戰利品護甲類型",
  T_46_META_WS_C_LOOTCONSUMABLE: "戰利品消耗品",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "戰利品消耗品類型",
  T_46_META_WS_C_LOOTIAMMO: "戰利品子彈",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "截球組件",
  T_46_META_WS_C_LOOTSCOPE: "戰利品倍鏡",
  T_46_META_WS_C_LOOTSCOPETYPE: "戰利品倍鏡類型",
  T_46_META_WS_C_LOOTSOCCERTYPE: "截球物件",
  T_46_META_WS_C_LOOTTHROWABLE: "戰利品投擲物",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "戰利品投擲物類型",
  T_46_META_WS_C_LOOTWEAPON: "戰利品武器",
  T_46_META_WS_C_LOOTWEAPONTYPE: "戰利品武器類型",
  T_46_META_WS_C_LOWGRAVITY: "低重力區",
  T_46_META_WS_C_MAP: "字典",
  T_46_META_WS_C_MAPT: "字典模板",
  T_46_META_WS_C_MATERIALID: "材質資產ID",
  T_46_META_WS_C_MEDKIT: "醫療包",
  T_46_META_WS_C_MESHID: "網格資產ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "遊戲中退出配置",
  T_46_META_WS_C_MINIMAP: "小地圖實體組件",
  T_46_META_WS_C_MINIMAPICON: "小地圖圖示實體組件",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "小地圖像素渲染器",
  T_46_META_WS_C_MINISENTRY: "防禦塔道具",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "小型防禦塔攻擊範圍類型",
  T_46_META_WS_C_MINISENTRYCREATED: "防禦塔道具放置後對象",
  T_46_META_WS_C_MONEY: "貨幣",
  T_46_META_WS_C_MONEYTYPE: "貨幣類型",
  T_46_META_WS_C_MONSTER: "怪物",
  T_46_META_WS_C_MONSTERSPAWN: "怪物生成",
  T_46_META_WS_C_MONSTERTYPE: "怪物類型",
  T_46_META_WS_C_MORPHABLEOBJECT: "可被變身物件",
  T_46_META_WS_C_MORPHOBJECT: "玩家變身伪裝組件",
  T_46_META_WS_C_MOTOBIKE: "摩托車",
  T_46_META_WS_C_MOVEPLATFORM: "移動平台",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "移動平台類型",
  T_46_META_WS_C_MUSHROOM: "蘑菇",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "自然常數",
  T_46_META_WS_C_NPC: "NPC物件",
  T_46_META_WS_C_NUMBER: "數字",
  T_46_META_WS_C_OBJECT: "物件",
  T_46_META_WS_C_OILDRUM: "油桶",
  T_46_META_WS_C_OUTFITID: "服飾ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "服裝槽位枚舉",
  T_46_META_WS_C_PATHPOINT: "路徑點",
  T_46_META_WS_C_PATROLSTYLETYPE: "巡邏風格類型",
  T_46_META_WS_C_PATROLTYPE: "巡邏方式枚舉",
  T_46_META_WS_C_PERSONA: "智能體",
  T_46_META_WS_C_PHASE: "階段",
  T_46_META_WS_C_PHYSICALMOVER: "物理移動器",
  T_46_META_WS_C_PHYSICALOBJECT: "物理對象",
  T_46_META_WS_C_PLATFORMTYPE: "平台類型",
  T_46_META_WS_C_PLAYABLE: "可播放",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "可玩或可玩數組",
  T_46_META_WS_C_PLAYER: "玩家",
  T_46_META_WS_C_PLAYERBACKPACK: "玩家背包",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "玩家行為狀態類型",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "玩家行為類型",
  T_46_META_WS_C_PLAYERCCT: "玩家 CCT",
  T_46_META_WS_C_PLAYERDATAID: "預設角色類型",
  T_46_META_WS_C_PLAYERORTRANSFORM: "玩家或Transform實體",
  T_46_META_WS_C_PLAYERORVEHICLE: "玩家或載具實體",
  T_46_META_WS_C_PLAYEROUTFIT: "玩家服飾",
  T_46_META_WS_C_PLAYERPOSETYPE: "玩家姿態類型枚舉",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "玩家復活來源類型",
  T_46_META_WS_C_PLAYERSTATETYPE: "玩家狀態類型枚舉",
  T_46_META_WS_C_POINTLIGHT: "點光源",
  T_46_META_WS_C_PORTAL: "傳送門",
  T_46_META_WS_C_PREFABID: "預置體ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "展示效果生成器",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "效果紋理類型",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "個人資料圖片小工具",
  T_46_META_WS_C_PROPERTY: "屬性",
  T_46_META_WS_C_PROPERTYFORMULA: "屬性公式",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "公式化屬性公式因子類型",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "屬性修改方式類型",
  T_46_META_WS_C_QUATERNION: "四元數",
  T_46_META_WS_C_RANKABLE: "可排名實體元件",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "射線檢測類型枚舉",
  T_46_META_WS_C_REPAIRKIT: "護甲修理包",
  T_46_META_WS_C_RESETABLE: "每回合重置元件",
  T_46_META_WS_C_RIGIDBODY: "剛體",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "剛體運動限制類型",
  T_46_META_WS_C_RIGIDBODYTYPE: "剛體類型",
  T_46_META_WS_C_ROUND: "回合",
  T_46_META_WS_C_SAFEZONE: "安全區",
  T_46_META_WS_C_SCOREABLE: "可得分實體元件",
  T_46_META_WS_C_SCRIPTID: "腳本ID",
  T_46_META_WS_C_SEATTYPE: "座位類型",
  T_46_META_WS_C_SELFRELATIVE: "相對自身運動",
  T_46_META_WS_C_SHOP: "商店實體組件",
  T_46_META_WS_C_SHOPITEM: "商品實體組件",
  T_46_META_WS_C_SHOPSHELF: "商店貨架組件",
  T_46_META_WS_C_SKATEBOARD: "滑板",
  T_46_META_WS_C_SKELETON: "骨架",
  T_46_META_WS_C_SKELETONPART: "骨架部位",
  T_46_META_WS_C_SKILLID: "技能ID",
  T_46_META_WS_C_SKYBLASTER: "飛行載具",
  T_46_META_WS_C_SKYBOX: "天空盒",
  T_46_META_WS_C_SKYBOXTYPE: "天空盒基礎類型",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "社交島雪球",
  T_46_META_WS_C_SORTTYPE: "排序方式枚舉",
  T_46_META_WS_C_SOUNDDRUMTYPE: "鼓音效類型",
  T_46_META_WS_C_SOUNDEFFECT: "音效實體組件",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "SoundEntity或SoundEntity數組",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "音效類型",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Lead1 音效類型",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Lead2 音效類型",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Lead3 音效類型",
  T_46_META_WS_C_SOUNDPIANOTYPE: "鋼琴音效類型",
  T_46_META_WS_C_SPAWN: "生成器實體元件",
  T_46_META_WS_C_SPAWNABLE: "支援生成的實體元件",
  T_46_META_WS_C_SPAWNBOX: "重生點",
  T_46_META_WS_C_SPAWNPOSITION: "生成點",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "特殊道具ID類型",
  T_46_META_WS_C_SPHERETRIGGER: "球體觸發器",
  T_46_META_WS_C_SPORTSCAR: "四輪車",
  T_46_META_WS_C_SPRAYCOLOR: "噴漆顏色",
  T_46_META_WS_C_SPRAYGUN: "噴漆槍基礎組件",
  T_46_META_WS_C_SPRAYRESULTUI: "噴漆結算",
  T_46_META_WS_C_SPRAYRIFLE: "噴漆槍（步槍）",
  T_46_META_WS_C_SPRITEID: "圖集精靈ID",
  T_46_META_WS_C_STATICSCRIPTID: "靜態腳本ID",
  T_46_META_WS_C_STRING: "字串",
  T_46_META_WS_C_STRINGORLOCSTRING: "字符串或本地化字符串",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "補給箱觸發器",
  T_46_META_WS_C_SWINGGUN: "吊索發射器",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "切換道具槽位",
  T_46_META_WS_C_TEAM: "隊伍實體元件",
  T_46_META_WS_C_TERRAIN: "地面",
  T_46_META_WS_C_TEXT: "文本實體組件",
  T_46_META_WS_C_TEXTUREID: "贴圖資產ID",
  T_46_META_WS_C_TEXTURETYPE: "對象紋理",
  T_46_META_WS_C_TIMER: "計時器",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "時間戳格式化顯示樣式",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "時間戳本地化字符串",
  T_46_META_WS_C_TRAJECTORY: "彈道動畫實體",
  T_46_META_WS_C_TRANSFORM: "變換",
  T_46_META_WS_C_TUKTUK: "突突車（三輪車）",
  T_46_META_WS_C_TURRET: "塔",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween曲線",
  T_46_META_WS_C_TWEENSTYLE: "Tween樣式",
  T_46_META_WS_C_TYPE: "類型",
  T_46_META_WS_C_TYPEENUM: "類型枚舉",
  T_46_META_WS_C_TYPEORTYPELIST: "類型或類型列表",
  T_46_META_WS_C_UIADDSCORE: "UI 增加得分",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI 動畫觸發 HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI 內建開關",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "內建 UI 切換控制器",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI 卡牌選擇面板",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI 檢查點指示器",
  T_46_META_WS_C_UICOMPASS: "UI 指南針",
  T_46_META_WS_C_UICOUNTDOWN5: "UI 5 秒倒計時",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI 倒計時提示",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI 倒計時提醒",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "角色頭頂血條",
  T_46_META_WS_C_UIHEALTHBAR: "UI 血條",
  T_46_META_WS_C_UIHEARTBEAT: "UI 心跳",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI 圖標通知",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI 身份通知",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI 互動按鈕",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI 排行榜按鈕",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI 比賽字幕",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI 怪物等級",
  T_46_META_WS_C_UIMONSTERUI: "UI 怪物 UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI 多隊排行榜",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI 多隊結果面板",
  T_46_META_WS_C_UIOPENINGBANNER: "UI 開場橫幅",
  T_46_META_WS_C_UIPANEL: "UI 面板",
  T_46_META_WS_C_UIPANELEMPTY: "空白 UI 面板",
  T_46_META_WS_C_UIPHASETIMER: "UI 階段計時器",
  T_46_META_WS_C_UIPROGRESSBAR: "UI 進度條",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI 進度圓圈",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI 進度技能按鈕",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI 購買請求類型",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI 回合資訊橫幅",
  T_46_META_WS_C_UIROUNDNUMBER: "UI 回合號碼",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI 回合結果橫幅",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI 回合開始橫幅",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI 回合過渡",
  T_46_META_WS_C_UISCOREBAR: "UI 得分條",
  T_46_META_WS_C_UISCROLLPANEL: "UI 滾動面板",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI 簡易回合得分橫幅",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI 簡易回合開始橫幅",
  T_46_META_WS_C_UISIMPLETIP: "簡易提示",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI 簡易對抗橫幅",
  T_46_META_WS_C_UISKILLBUTTON: "UI 技能按鈕",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "社交功能按鈕元件",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI 單人排行榜",
  T_46_META_WS_C_UISTORE: "UI 商店介面",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI 隊伍比賽資訊",
  T_46_META_WS_C_UITEXTTIP: "UI 文字提示",
  T_46_META_WS_C_UITIMERINFO: "UI 計時器資訊",
  T_46_META_WS_C_UITIPBUTTON: "UI 提示按鈕",
  T_46_META_WS_C_UITITLEBANNER: "UI 標題橫幅",
  T_46_META_WS_C_UITWEENTIP: "UI 過渡提示",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI 雙隊簡略資訊",
  T_46_META_WS_C_UITWOTEAMINFO: "UI 兩隊資訊",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI 雙隊排行榜",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI 雙隊結果面板",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI 兩隊回合得分橫幅",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI 雙隊得分面板",
  T_46_META_WS_C_UIVERSUSBANNER: "UI 對抗橫幅",
  T_46_META_WS_C_UIWIDGET: "UI 控件",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI 按鈕控件",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI 容器控件",
  T_46_META_WS_C_UIWIDGETEMPTY: "空白 UI 控件",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI 圖片控件",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI 輸入標籤控件",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI 操縱桿控件",
  T_46_META_WS_C_UIWIDGETLABEL: "UI 標籤控件",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI 佈局控件",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI 個人資料控件",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI 材質控件",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI 切換控件",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI 觸控板控件",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI 勝負橫幅",
  T_46_META_WS_C_UNITSPAWN: "單位生成器元件",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "爬窗邏輯物件",
  T_46_META_WS_C_VECTOR2: "二維向量",
  T_46_META_WS_C_VECTOR3: "三維向量",
  T_46_META_WS_C_VEHICLE: "載具組件",
  T_46_META_WS_C_VEHICLEIDTYPE: "載具ID",
  T_46_META_WS_C_VEHICLESKINID: "載具外觀 ID",
  T_46_META_WS_C_VENDINGMACHINE: "自動販賣機組件",
  T_46_META_WS_C_VEST: "防彈衣組件",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "可替換的特效材質實體",
  T_46_META_WS_C_VFXTEXTURE: "特效材質",
  T_46_META_WS_C_VISIBILITY: "可見組件",
  T_46_META_WS_C_WALLET: "錢包",
  T_46_META_WS_C_WALLETHUD: "錢包介面組件",
  T_46_META_WS_C_WATERZONE: "水域",
  T_46_META_WS_C_WAVECOUNTTYPE: "波次類型",
  T_46_META_WS_C_WAVEINTERVALTYPE: "波間隔類型",
  T_46_META_WS_C_WEAPON: "武器",
  T_46_META_WS_C_WEAPONGENERATOR: "武器生成器",
  T_46_META_WS_C_WEAPONSKINID: "武器塗裝 ID",
  T_46_META_WS_C_WEAPONTYPE: "武器類型",
  T_46_META_WS_C_WIDGETTYPE: "控件類型",
  T_46_META_WS_C_ZIPLINE: "纜索",
  T_46_META_WS_CAMERADIRECTION: "相機方向",
  T_46_META_WS_CAMERAPOSITION: "相機位置",
  T_46_META_WS_CAPSULECAST: "膠囊投射",
  T_46_META_WS_CAPSULEOVERLAP: "膠囊重疊",
  T_46_META_WS_CEIL: "向上取整",
  T_46_META_WS_CHATCHANNEL: "聊天頻道",
  T_46_META_WS_CHECKTRIGGERBYORDER: "檢測玩家是否按順序觸發levelobeject",
  T_46_META_WS_CLAMP: "限制",
  T_46_META_WS_CLEAR: "清空",
  T_46_META_WS_CLEARALLCHILDREN: "刪除所有子節點",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "清空AOI特別關注",
  T_46_META_WS_CLEARBACKPACK: "清空背包",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "清除公式化屬性因子",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "清理地圖物件殘留",
  T_46_META_WS_CLIPNAME: "片段名稱",
  T_46_META_WS_CLONE: "克隆",
  T_46_META_WS_COLLIDEDENTITY: "碰撞實體",
  T_46_META_WS_COLORGET: "構建一個顏色值",
  T_46_META_WS_COMPLETECUSTOMMISSION: "完成自定義任務",
  T_46_META_WS_CONNECT: "字串連接",
  T_46_META_WS_CONSUMABLEID: "道具ID",
  T_46_META_WS_CONTAIN: "是否包含特定元素",
  T_46_META_WS_CONTAINKEY: "判斷字典key是否存在",
  T_46_META_WS_COPYTOMORPH: "複製至變形",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "消耗金錢",
  T_46_META_WS_COSTTOKEN: "消耗token",
  T_46_META_WS_CREATEAIRDROP: "創建空投箱",
  T_46_META_WS_CREATEBOT: "添加Bot",
  T_46_META_WS_CREATEBUILTINUI: "創建內建UI",
  T_46_META_WS_CREATEBUILTINUICLIENT: "創建內建UI",
  T_46_META_WS_CREATECAMERA: "創建相機",
  T_46_META_WS_CREATECURVE: "創建曲線",
  T_46_META_WS_CREATECUSTOMUI: "創建自定義UI",
  T_46_META_WS_CREATECUSTOMUICLIENT: "創建自定義UI",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "創建自定義UI控件",
  T_46_META_WS_CREATEDAMAGENUM: "創建傷害跳字",
  T_46_META_WS_CREATEEFFECT: "創建特效",
  T_46_META_WS_CREATEEFFECTCLIENT: "創建特效",
  T_46_META_WS_CREATEFACTION: "創建陣營",
  T_46_META_WS_CREATEFOLLOW: "創建位置跟隨",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "創建每幀相對自身運動",
  T_46_META_WS_CREATEFROMPREFAB: "創建預製體實例",
  T_46_META_WS_CREATELEVELOBJECT: "創建物件",
  T_46_META_WS_CREATELOOKAT: "創建注視跟隨",
  T_46_META_WS_CREATEMINIMAPICON: "創建小地圖圖標",
  T_46_META_WS_CREATEMINIMAPPIXEL: "創建小地圖像素",
  T_46_META_WS_CREATEMONSTER: "創建怪物",
  T_46_META_WS_CREATEMORPH: "創建變形",
  T_46_META_WS_CREATESELFRELATIVE: "創建相對自身運動",
  T_46_META_WS_CREATESHOP: "創建商店",
  T_46_META_WS_CREATESHOPITEM: "創建商店商品",
  T_46_META_WS_CREATESHOPSHELF: "創建商店貨架",
  T_46_META_WS_CREATESOUND: "創建音效",
  T_46_META_WS_CREATESOUNDCLIENT: "創建音效",
  T_46_META_WS_CREATETOKENINSCENE: "場景中創建Token",
  T_46_META_WS_CREATETRAJECTORY: "創建彈道運動",
  T_46_META_WS_CREATETWEEN: "創建插值運動",
  T_46_META_WS_CREATEWALLET: "創建錢包",
  T_46_META_WS_CROSS: "向量叉積",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV列名轉整數",
  T_46_META_WS_CURRENTAMMOCOUNT: "當前彈藥量",
  T_46_META_WS_DAMAGE: "傷害",
  T_46_META_WS_DAMAGEDBODYPART: "受傷部位",
  T_46_META_WS_DAMAGEDPLAYERS: "受傷玩家",
  T_46_META_WS_DAMAGETYPE: "傷害類型",
  T_46_META_WS_DEALDAMAGE: "造成傷害",
  T_46_META_WS_DELETE: "刪除",
  T_46_META_WS_DELETEAT: "移除指定索引項目",
  T_46_META_WS_DELETECUSTOMUI: "移除自訂 UI",
  T_46_META_WS_DELETEFROMDATABASE: "刪除數據庫表值",
  T_46_META_WS_DELETEFROMDATASTORE: "刪除資料庫表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "根據鍵值刪除排行榜資料",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "根據名次刪除排行榜資料",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "根據Key來刪除資料庫中排行榜表值",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "根據名次來刪除資料庫中排行榜表值",
  T_46_META_WS_DELETETAG: "刪除標籤",
  T_46_META_WS_DELTA: "位移量",
  T_46_META_WS_DESTROY: "毀壞",
  T_46_META_WS_DESTROYBOT: "刪除Bot",
  T_46_META_WS_DESTROYBUILTINUI: "移除內建UI",
  T_46_META_WS_DESTROYEQUIPMENT: "毀壞裝備",
  T_46_META_WS_DESTROYITEM: "銷毀物品",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "方向向量轉歐拉角",
  T_46_META_WS_DISABLESAFEZONE: "關閉安全區",
  T_46_META_WS_DISPATCHEVENT: "發送事件",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "發送玩家自定義事件",
  T_46_META_WS_DISTANCE: "向量距離",
  T_46_META_WS_DOT: "向量點積",
  T_46_META_WS_DROPITEM: "丟棄物品",
  T_46_META_WS_DYEATAREA: "在區域染色",
  T_46_META_WS_DYEATPLANE: "在平面染色",
  T_46_META_WS_DYEATPOSITION: "在位置染色",
  T_46_META_WS_E_ABNORMALGRAVZONE: "低重力區",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "加速度",
  T_46_META_WS_E_ACTIONNODE: "行為節點",
  T_46_META_WS_E_ACTIVE: "活動狀態",
  T_46_META_WS_E_ACTIVESKILL: "主動技能",
  T_46_META_WS_E_ADBOARD: "廣告牌",
  T_46_META_WS_E_ADD: "增加",
  T_46_META_WS_E_ADDFRIEND: "增加好友",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "瞄準",
  T_46_META_WS_E_AIR: "空氣",
  T_46_META_WS_E_AIRCONDITIONERA: "空調",
  T_46_META_WS_E_AIRDROP: "空投，僵屍自殺",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "存活",
  T_46_META_WS_E_AMMO: "子彈特效",
  T_46_META_WS_E_AMPHIBIANCAR: "水陸兩用車",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "小鬼嬉鬧",
  T_46_META_WS_E_AR: "步槍",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR 子彈",
  T_46_META_WS_E_ARMAGAZINE: "突擊步槍彈匣",
  T_46_META_WS_E_ARMOR: "護甲",
  T_46_META_WS_E_ARMORBUFF: "護甲 Buff",
  T_46_META_WS_E_ARMORLV1: "護甲 Lv.1",
  T_46_META_WS_E_ARMORLV2: "護甲 Lv.2",
  T_46_META_WS_E_ARMORLV3: "護甲 Lv.3",
  T_46_META_WS_E_ARMORPIERCING: "碎甲",
  T_46_META_WS_E_ARMORSPECIALIST: "技能1",
  T_46_META_WS_E_ARROW: "箭頭",
  T_46_META_WS_E_ASC: "升序",
  T_46_META_WS_E_ASCIGNOREZERO: "升序忽略零值",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "旋風氣體爆炸",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "相容性配件1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "相容性配件4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "相容性配件5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "相容性配件6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "相容性配件8",
  T_46_META_WS_E_ATTACK: "攻擊",
  T_46_META_WS_E_ATTACKGRENADE: "攻擊投擲物",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "全自動",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "返回",
  T_46_META_WS_E_BACKANDFORTH: "來回",
  T_46_META_WS_E_BAG: "背包",
  T_46_META_WS_E_BAG1: "背包1",
  T_46_META_WS_E_BAG2: "背包2",
  T_46_META_WS_E_BAG3: "背包3",
  T_46_META_WS_E_BAMBOOA: "竹子A",
  T_46_META_WS_E_BANANATREE: "香蕉樹",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "基礎係數",
  T_46_META_WS_E_BASIC: "基礎類型",
  T_46_META_WS_E_BASICCONE: "基本圓錐",
  T_46_META_WS_E_BASICCYLINDER: "基本圓柱",
  T_46_META_WS_E_BASICSPHERE: "基本球體",
  T_46_META_WS_E_BATTLEINSTYLE: "BattleInStyle",
  T_46_META_WS_E_BELL: "鈴鐺",
  T_46_META_WS_E_BENCH: "長椅",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "大屏幕",
  T_46_META_WS_E_BIPOD: "雙腳架",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS 主題牆壁",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "黑洞爆炸特效",
  T_46_META_WS_E_BLACKHOLEBOOM: "水晶球特效",
  T_46_META_WS_E_BLAST: "爆炸",
  T_46_META_WS_E_BLOCK: "正方形",
  T_46_META_WS_E_BLOODBALL: "黑洞特效",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "藍色",
  T_46_META_WS_E_BLUEDOLL: "冰娃娃",
  T_46_META_WS_E_BOARD: "移動板",
  T_46_META_WS_E_BODY: "身體",
  T_46_META_WS_E_BOMBINDICATION: "炸彈提示",
  T_46_META_WS_E_BOMBPLIERS: "拆彈鉗",
  T_46_META_WS_E_BONFIRE: "燃燒的火堆",
  T_46_META_WS_E_BOOM: "爆炸",
  T_46_META_WS_E_BOOYAH: "勝利",
  T_46_META_WS_E_BOTH: "雙端",
  T_46_META_WS_E_BOUNCETIRE: "轮胎",
  T_46_META_WS_E_BOWAMMO: "箭支",
  T_46_META_WS_E_BREAKABLEBOX: "可破壞木箱",
  T_46_META_WS_E_BREAKABLECONTAINER: "可破壞集裝箱",
  T_46_META_WS_E_BREAKABLEFENCE: "可破壞栅欄",
  T_46_META_WS_E_BRICKA: "磚塊 A",
  T_46_META_WS_E_BRICKB: "磚塊 B",
  T_46_META_WS_E_BRICKC: "磚塊 C",
  T_46_META_WS_E_BRICKHOUSEA: "小矮房A",
  T_46_META_WS_E_BRIGHT: "亮色",
  T_46_META_WS_E_BUBBLE: "泡泡",
  T_46_META_WS_E_BUFFGENERATOR: "增益生成器",
  T_46_META_WS_E_BULLETBUFF: "子彈增益",
  T_46_META_WS_E_BULLETHITTING: "子彈命中",
  T_46_META_WS_E_BUMPERCAR: "碰碰車",
  T_46_META_WS_E_BUMPERCARFACTORY: "碰碰車廠",
  T_46_META_WS_E_BURNING: "載具爆炸後燃燒傷害",
  T_46_META_WS_E_BUSHES: "灌木",
  T_46_META_WS_E_BUSSTOP: "公車站",
  T_46_META_WS_E_BUTTOM: "下身服飾",
  T_46_META_WS_E_BUTTONWIDGET: "按鈕控件",
  T_46_META_WS_E_BYHIERARCHY: "按層級結構",
  T_46_META_WS_E_CABINET: "儲物櫃",
  T_46_META_WS_E_CACTUS: "仙人掌",
  T_46_META_WS_E_CAMOUFLAGE: "技能6",
  T_46_META_WS_E_CAPSULETRIGGER: "膠囊觸發",
  T_46_META_WS_E_CARDIOTONIC: "強心劑",
  T_46_META_WS_E_CASUALGAMEBGM: "休閒遊戲背景音樂",
  T_46_META_WS_E_CEMENTA: "水泥 A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "頻道 A",
  T_46_META_WS_E_CHANNELB: "頻道 B",
  T_46_META_WS_E_CHANNELC: "頻道 C",
  T_46_META_WS_E_CHANNELD: "頻道 D",
  T_46_META_WS_E_CHANNELE: "頻道 E",
  T_46_META_WS_E_CHANNELF: "頻道 F",
  T_46_META_WS_E_CHARACTERSKILL: "角色技能",
  T_46_META_WS_E_CHARACTOR: "角色",
  T_46_META_WS_E_CHARGE: "充能1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "檢查點",
  T_46_META_WS_E_CHEER: "歡呼",
  T_46_META_WS_E_CHERRYBLOSSOM: "櫻花樹",
  T_46_META_WS_E_CIRCLE: "圓",
  T_46_META_WS_E_CIRCLEBACK: "循環",
  T_46_META_WS_E_CIRCLEOFHEAT: "腳底光柱",
  T_46_META_WS_E_CITY: "城市",
  T_46_META_WS_E_CLAPS: "拍手聲",
  T_46_META_WS_E_CLEAR: "清除",
  T_46_META_WS_E_CLIENT: "客戶端",
  T_46_META_WS_E_CLONE: "變身",
  T_46_META_WS_E_CLONEKILL: "分身死亡",
  T_46_META_WS_E_CLOSE: "關閉",
  T_46_META_WS_E_CLOTHES: "衣服",
  T_46_META_WS_E_COINGENERATOR: "金幣生成器",
  T_46_META_WS_E_COLDAIR: "冷氣",
  T_46_META_WS_E_COLORBLOCK: "染色方塊",
  T_46_META_WS_E_COLOROILBARREL: "染色油桶",
  T_46_META_WS_E_COMBINEALL: "全部組合",
  T_46_META_WS_E_COMBINESELF: "自我組合",
  T_46_META_WS_E_COMBOKEYA1: "樂符-合成器A",
  T_46_META_WS_E_COMBOKEYA2: "樂符-合成器A",
  T_46_META_WS_E_COMBOKEYB1: "樂符-合成器B",
  T_46_META_WS_E_COMBOKEYB2: "樂符-合成器B",
  T_46_META_WS_E_COMBOKEYC1: "樂符-合成器C",
  T_46_META_WS_E_COMBOKEYC2: "樂符-合成器C",
  T_46_META_WS_E_CONCRETEPILLAR: "混凝土柱",
  T_46_META_WS_E_CONDITIONNODE: "條件節點",
  T_46_META_WS_E_CONTAINERA: "集裝箱A",
  T_46_META_WS_E_CONTAINERB: "集裝箱B",
  T_46_META_WS_E_CONTAINERC: "集裝箱C",
  T_46_META_WS_E_CONTAINERWIDGET: "容器控件",
  T_46_META_WS_E_CONTINUOUS: "連續",
  T_46_META_WS_E_COUNTDOWN: "計時",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "倒計時",
  T_46_META_WS_E_COUNTDOWNDIDI: "倒計時的滴滴聲",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "倒計時",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "倒計時3",
  T_46_META_WS_E_CROSS: "十字",
  T_46_META_WS_E_CROSSBOW: "十字弩",
  T_46_META_WS_E_CROSSHAIR: "十字準星",
  T_46_META_WS_E_CROSSHAIRS: "準星",
  T_46_META_WS_E_CROUCH: "蹲下",
  T_46_META_WS_E_CROUCHING: "蹲",
  T_46_META_WS_E_CROWCAW: "烏鴉叫的環境音",
  T_46_META_WS_E_CROWN: "冠軍",
  T_46_META_WS_E_CUBE: "方塊機關",
  T_46_META_WS_E_CURSE: "符咒",
  T_46_META_WS_E_CURSEEXPLOSION: "符咒爆炸",
  T_46_META_WS_E_CUSTOM: "自訂相機",
  T_46_META_WS_E_CUSTOMTRIGGER: "自訂觸發器",
  T_46_META_WS_E_CUSTOMWATERZONE: "自定義水域",
  T_46_META_WS_E_CYCLICCOMBUSTION: "循環燃燒",
  T_46_META_WS_E_CYLIC: "循環",
  T_46_META_WS_E_DAGGER: "投擲刀",
  T_46_META_WS_E_DAMAGEDTRUCK: "損壞的卡車",
  T_46_META_WS_E_DAMAGEZONE: "傷害區",
  T_46_META_WS_E_DANGERALARM: "危險提示音2",
  T_46_META_WS_E_DANGERVIBRATING: "危險提示音1",
  T_46_META_WS_E_DARK: "暗色",
  T_46_META_WS_E_DARKNESS: "黑暗",
  T_46_META_WS_E_DASHATTACK: "衝撞攻擊",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "數據存儲超出限制",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "數據存儲參數錯誤",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "數據存儲超時",
  T_46_META_WS_E_DATETIME: "日期和時間",
  T_46_META_WS_E_DAY: "白天",
  T_46_META_WS_E_DEAD: "死亡",
  T_46_META_WS_E_DEATH: "死亡",
  T_46_META_WS_E_DEFAULT: "預設",
  T_46_META_WS_E_DEFAULTFIST: "拳頭",
  T_46_META_WS_E_DEFENCEGRENADE: "防禦手雷",
  T_46_META_WS_E_DESC: "降序",
  T_46_META_WS_E_DIALOGUE: "對話",
  T_46_META_WS_E_DIAMOND: "鑽石",
  T_46_META_WS_E_DIRECTIONSIGN: "標記",
  T_46_META_WS_E_DIRVEVEHICLE: "操控載具",
  T_46_META_WS_E_DISABLE: "停用",
  T_46_META_WS_E_DISABLED: "禁用",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "消失提示",
  T_46_META_WS_E_DISCONNECT: "斷線",
  T_46_META_WS_E_DISGUISE: "分身",
  T_46_META_WS_E_DOGHOUSE: "狗狗屋",
  T_46_META_WS_E_DOOR: "門",
  T_46_META_WS_E_DOUBLE: "雙發",
  T_46_META_WS_E_DOUBLEDOOR: "雙扇門",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "雙重跳躍鞋",
  T_46_META_WS_E_DOUBLEMAGEZINE: "雙彈匣",
  T_46_META_WS_E_DRAW: "平局",
  T_46_META_WS_E_DRILLZOMBIE: "鑽地殭屍",
  T_46_META_WS_E_DRIVE: "駕駛",
  T_46_META_WS_E_DRIVER: "駕駛員",
  T_46_META_WS_E_DROPBEAT: "技能4",
  T_46_META_WS_E_DRUMKEY1: "樂符-鼓",
  T_46_META_WS_E_DRUMKEY2: "樂符-鼓",
  T_46_META_WS_E_DUEL: "戰鬥",
  T_46_META_WS_E_DUMMY: "假人",
  T_46_META_WS_E_DUMMYGRENADE: "假手雷",
  T_46_META_WS_E_DUMP: "傾倒",
  T_46_META_WS_E_DUSK: "黃昏",
  T_46_META_WS_E_DUST: "煙塵",
  T_46_META_WS_E_DYNAMIC: "動態",
  T_46_META_WS_E_E: "自然常數",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "容易的",
  T_46_META_WS_E_ELECTRICSHOCK: "電擊",
  T_46_META_WS_E_ELECTRICSURFBOARD: "電動衝浪板",
  T_46_META_WS_E_ELECTRICZONE: "毒圈",
  T_46_META_WS_E_ELECTRONICBGM: "電子夢幻可愛背景音樂",
  T_46_META_WS_E_ELIMINATEDBOSS: "彈劾會長",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "擊殺提示訊息",
  T_46_META_WS_E_EMOTE: "表情",
  T_46_META_WS_E_ENABLE: "啟用",
  T_46_META_WS_E_ENERGETIC: "充滿能量",
  T_46_META_WS_E_ENTERVEHICLE: "進入載具",
  T_46_META_WS_E_EP: "能量",
  T_46_META_WS_E_EXCLAMATIONMARK: "驚嘆號",
  T_46_META_WS_E_EXIT: "退出",
  T_46_META_WS_E_EXITVEHICLE: "離開載具",
  T_46_META_WS_E_EXPLODE: "自爆",
  T_46_META_WS_E_EXPLOSION: "爆炸特效",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "爆炸火光",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "元氣彈技能",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "爆炸殭屍",
  T_46_META_WS_E_EYE: "眼鏡",
  T_46_META_WS_E_FACEPAINT: "臉部彩繪",
  T_46_META_WS_E_FACTION: "陣營",
  T_46_META_WS_E_FALLING: "掉落",
  T_46_META_WS_E_FALLINGSTAR: "獲得道具",
  T_46_META_WS_E_FALSE: "否",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "螺旋槳機關",
  T_46_META_WS_E_FAR: "遠距離",
  T_46_META_WS_E_FEATHER: "羽毛",
  T_46_META_WS_E_FEMALE: "女",
  T_46_META_WS_E_FENCE: "圍欄",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "戰鬥實體",
  T_46_META_WS_E_FILLED: "填充",
  T_46_META_WS_E_FINISH: "完成",
  T_46_META_WS_E_FINISHINGPOINT: "終點",
  T_46_META_WS_E_FINISHLINEARCH: "終點橫幅",
  T_46_META_WS_E_FIRE: "火焰",
  T_46_META_WS_E_FIRECHARGE: "火焰彈",
  T_46_META_WS_E_FIREWORK: "煙花",
  T_46_META_WS_E_FIRINGEFFECT: "武器開火特效",
  T_46_META_WS_E_FIRSTPERSON: "第一人稱視角相機",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "第一人稱視角相機（經典）",
  T_46_META_WS_E_FIST: "拳頭",
  T_46_META_WS_E_FIT: "適應",
  T_46_META_WS_E_FLAG: "旗幟",
  T_46_META_WS_E_FLAME: "火焰",
  T_46_META_WS_E_FLAMEGUN: "火焰槍",
  T_46_META_WS_E_FLAMETHROWER: "火焰槍",
  T_46_META_WS_E_FLASH: "閃光彈",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "閃光彈煙火",
  T_46_META_WS_E_FLASHFREEZE: "冷凍手榴彈",
  T_46_META_WS_E_FLEXWALL: "伸縮牆",
  T_46_META_WS_E_FLICKER: "閃爍",
  T_46_META_WS_E_FLOWER: "花",
  T_46_META_WS_E_FLYBOMBBEE: "飛行炸彈蜂",
  T_46_META_WS_E_FLYPAN: "平底鍋機關",
  T_46_META_WS_E_FLYSHOE: "飛鞋",
  T_46_META_WS_E_FOLDER: "文件夾",
  T_46_META_WS_E_FOLDWINGS: "折疊翅膀",
  T_46_META_WS_E_FOODTRUCK: "餐车",
  T_46_META_WS_E_FOODTRUCKB: "小餐車B",
  T_46_META_WS_E_FOOTBALL: "足球",
  T_46_META_WS_E_FOOTBALLGUN: "足球槍",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "足球槍",
  T_46_META_WS_E_FORCE: "線性力",
  T_46_META_WS_E_FOREGRIP_MR: "前握把MR",
  T_46_META_WS_E_FOREGRIP1: "前握把1",
  T_46_META_WS_E_FOREGRIP2: "前握把2",
  T_46_META_WS_E_FOREGRIP3: "前握把3",
  T_46_META_WS_E_FORWARD: "前進",
  T_46_META_WS_E_FOUNTAIN: "噴泉",
  T_46_META_WS_E_FREE: "自由視角相機",
  T_46_META_WS_E_FREEZEALL: "限制所有軸的平移和旋轉",
  T_46_META_WS_E_FREEZEPOSITION: "限制所有軸的平移",
  T_46_META_WS_E_FREEZEPOSITIONX: "限制X軸方向平移",
  T_46_META_WS_E_FREEZEPOSITIONY: "限制Y軸方向平移",
  T_46_META_WS_E_FREEZEPOSITIONZ: "限制Z軸方向平移",
  T_46_META_WS_E_FREEZEROTATION: "限制所有軸的旋轉",
  T_46_META_WS_E_FREEZEROTATIONX: "限制X軸方向旋轉",
  T_46_META_WS_E_FREEZEROTATIONY: "限制Y軸方向旋轉",
  T_46_META_WS_E_FREEZEROTATIONZ: "限制Z軸方向旋轉",
  T_46_META_WS_E_FREEZEZONE: "冰凍區域",
  "T_46_META_WS_E_FROST GALAXY": "極地星空",
  T_46_META_WS_E_FROZEN: "冰凍",
  T_46_META_WS_E_FROZENGRENADE: "冰凍手雷",
  T_46_META_WS_E_FUNCTIONALITEMS: "功能性道具",
  T_46_META_WS_E_FZLANTINGHEI: "方正蘭亭黑",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "遊戲",
  T_46_META_WS_E_GAMEOVER: "遊戲結束2",
  T_46_META_WS_E_GAMESTART: "遊戲開始",
  T_46_META_WS_E_GARAGE: "車庫",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "機關開啟",
  T_46_META_WS_E_GENTLETAP: "輕觸",
  T_46_META_WS_E_GETITEM: "獲得道具2",
  T_46_META_WS_E_GFFLATIN: "GFF拉丁字體",
  T_46_META_WS_E_GHOST: "鬼魂",
  T_46_META_WS_E_GIANTDICE: "骰子",
  T_46_META_WS_E_GIANTLOLLIPOP: "大型棒棒糖",
  T_46_META_WS_E_GIFT: "禮物",
  T_46_META_WS_E_GLOOWALL: "凝膠護盾",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS 主題花壇",
  T_46_META_WS_E_GRAFFITIWALL: "塗鴉牆",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "鉤槍",
  T_46_META_WS_E_GREATCONDUCTOR: "偉大指揮",
  T_46_META_WS_E_GREEN: "綠色",
  T_46_META_WS_E_GRENADE: "手榴彈",
  T_46_META_WS_E_GRID: "網格",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "哨塔",
  T_46_META_WS_E_GUILD: "公會",
  T_46_META_WS_E_GUN: "槍械",
  T_46_META_WS_E_GUNFIRE: "銃火",
  T_46_META_WS_E_HALO: "光環",
  T_46_META_WS_E_HAMMER: "巨槌機關",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "晾衣架",
  T_46_META_WS_E_HARD: "困難的",
  T_46_META_WS_E_HATTRICK: "技能8",
  T_46_META_WS_E_HAYSTACK: "草垛",
  T_46_META_WS_E_HEAD: "頭飾",
  T_46_META_WS_E_HEADSHOOT: "爆頭",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "治療槍",
  T_46_META_WS_E_HEART: "愛心",
  T_46_META_WS_E_HEARTBEAT: "心跳",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "重武器",
  T_46_META_WS_E_HELL: "非常困難",
  T_46_META_WS_E_HELMET: "頭盔",
  T_46_META_WS_E_HELMET1: "頭盔1",
  T_46_META_WS_E_HELMET2: "頭盔2",
  T_46_META_WS_E_HELMET3: "頭盔3",
  T_46_META_WS_E_HEXAGON: "六邊形",
  T_46_META_WS_E_HGAMMO: "HG 子彈",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "捉迷藏火焰槍",
  T_46_META_WS_E_HIDERKILL: "躲藏者被擊殺",
  T_46_META_WS_E_HIHATS: "閉合踩镲",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "沉悶打擊",
  T_46_META_WS_E_HITEFFECT: "子彈命中特效",
  T_46_META_WS_E_HITFEEDBACK: "射擊反饋",
  T_46_META_WS_E_HOOK: "鉤鎖頭",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "鉤槍彈藥",
  T_46_META_WS_E_HORIZALINE: "强心針",
  T_46_META_WS_E_HORIZONTAL: "水平",
  T_46_META_WS_E_HORN: "喇叭",
  T_46_META_WS_E_HORROR: "恐怖",
  T_46_META_WS_E_HOURGLASS: "沙漏",
  T_46_META_WS_E_HOUSE: "房屋",
  T_46_META_WS_E_HOUSEA: "一層民房",
  T_46_META_WS_E_HOUSEB: "二層民房",
  T_46_META_WS_E_HOUSEC: "三層民房",
  T_46_META_WS_E_HP: "血量",
  T_46_META_WS_E_HPBUFF: "血量buff",
  T_46_META_WS_E_HUT: "小屋",
  T_46_META_WS_E_ICEA: "冰塊A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "冰牆製造器",
  T_46_META_WS_E_ICONOBJECT: "圖標實體",
  T_46_META_WS_E_IMAGEWIDGET: "圖片控件",
  T_46_META_WS_E_IMPULSE: "衝擊",
  T_46_META_WS_E_INHALER: "吸入器",
  T_46_META_WS_E_INJUREDFEMALE: "受擊尖叫聲女",
  T_46_META_WS_E_INJUREDMALE: "受擊尖叫聲男",
  T_46_META_WS_E_INK: "水墨特效",
  T_46_META_WS_E_INPUTLABLEWIDGET: "輸入標籤控件",
  T_46_META_WS_E_INSECTCHIRPING: "夜晚蟲鳴",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 秒",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 秒",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 秒",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 秒",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 秒",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 秒",
  T_46_META_WS_E_INVISIBLE: "隱形",
  T_46_META_WS_E_IPIPE: "直管道",
  T_46_META_WS_E_IRONFENCE: "圍欄",
  T_46_META_WS_E_IRONFENCEB: "圍欄B",
  T_46_META_WS_E_IRONPLATFORM: "鐵台",
  T_46_META_WS_E_ITEMENTITY: "道具生成器",
  T_46_META_WS_E_JEEP: "吉普車",
  T_46_META_WS_E_JERRYCAN: "油桶",
  T_46_META_WS_E_JERSEYMACHINE: "球衣機",
  T_46_META_WS_E_JOINEDGAMEDULL: "加入激戰",
  T_46_META_WS_E_JOINGAME: "加入遊戲",
  T_46_META_WS_E_JOYSTICKWIDGET: "摇杆控件",
  T_46_META_WS_E_JUMP: "跳躍",
  T_46_META_WS_E_JUMPATTACK: "跳斬",
  T_46_META_WS_E_JUSTPATROL: "只巡邏",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "鑰匙",
  T_46_META_WS_E_KICK: "底鼓",
  T_46_META_WS_E_KILLINGTIPS: "擊殺提示",
  T_46_META_WS_E_KILLZONE: "死亡區域",
  T_46_META_WS_E_KINEMATIC: "運動學",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "倒地",
  T_46_META_WS_E_KNOCKEDDOWN: "擊倒",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "標籤控件",
  T_46_META_WS_E_LANDINGA: "樓梯平台A",
  T_46_META_WS_E_LANDINGB: "樓梯平台B",
  T_46_META_WS_E_LANDINGC: "樓梯平台C",
  T_46_META_WS_E_LANDMINE: "地雷",
  T_46_META_WS_E_LANUNCHERAMMO: "發射器彈藥",
  T_46_META_WS_E_LASER: "激光特效",
  T_46_META_WS_E_LASERSKILL: "激光技能",
  T_46_META_WS_E_LATTICESCREEN: "屏風",
  T_46_META_WS_E_LAWNA: "草坪A",
  T_46_META_WS_E_LAWNB: "草坪B",
  T_46_META_WS_E_LAYOUTWIDGET: "布局控件",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "枯木",
  T_46_META_WS_E_LEVELMAXED: "滿級",
  T_46_META_WS_E_LEVELUP: "升級",
  T_46_META_WS_E_LEVELUPDISCARDED: "升級",
  T_46_META_WS_E_LIGHTBEAM: "光束",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "光柱",
  T_46_META_WS_E_LIGHTEFFECT: "光效",
  T_46_META_WS_E_LIGHTNING: "雷電",
  T_46_META_WS_E_LIMB: "四肢",
  T_46_META_WS_E_LINE: "線",
  T_46_META_WS_E_LIQUID: "液體",
  T_46_META_WS_E_LOCAL: "本地",
  T_46_META_WS_E_LOCALPOSITION: "本地位置",
  T_46_META_WS_E_LOCK: "鎖",
  T_46_META_WS_E_LONGBOX: "長木箱",
  T_46_META_WS_E_LOOP: "循環",
  T_46_META_WS_E_LOOTITEMBOX: "Loot點武器组件LootItemBox",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Loot點子彈组件LootItemBoxAmmo",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Loot點護甲组件LootItemBoxArmor",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Loot點可消耗物品组件LootItemBoxConsumableItem",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Loot點投擲物品组件LootItemBoxProjectile",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Loot點倍鏡组件LootItemBoxSight",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot点足球组件LootItemBoxSoccer",
  T_46_META_WS_E_LOOTSOCCERICE: "冰凍手雷",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "隨機足球戰利品",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "足球護盾",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "随机武器Loot",
  T_46_META_WS_E_LOSE: "失敗",
  T_46_META_WS_E_LOUDSPEAKER: "喇叭",
  T_46_META_WS_E_LOWFALLING: "低落",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79榴彈",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79專用榴彈",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "衝鋒槍",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "彈匣1",
  T_46_META_WS_E_MAGEZINE2: "彈匣2",
  T_46_META_WS_E_MAGEZINE3: "彈匣3",
  T_46_META_WS_E_MAGMAA: "岩漿A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "放大鏡",
  T_46_META_WS_E_MALE: "男",
  T_46_META_WS_E_MARK: "標記",
  T_46_META_WS_E_MARKER: "標記",
  T_46_META_WS_E_MASK: "臉部裝飾",
  T_46_META_WS_E_MAXVALUE: "最大值",
  T_46_META_WS_E_MECHANICAL: "密集叮叮叮2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "機械裝置回聲",
  T_46_META_WS_E_MEDICALPROPS: "醫療道具",
  T_46_META_WS_E_MEDICALTENT: "醫療帳篷",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "心跳中",
  T_46_META_WS_E_MEDKIT: "急救包",
  T_46_META_WS_E_MELEE: "近戰武器",
  T_46_META_WS_E_MELEEWEAPONS: "近戰武器",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "麥克風",
  T_46_META_WS_E_MIDDLE: "中等距離",
  T_46_META_WS_E_MINIHANDLE: "迷你握把",
  T_46_META_WS_E_MINIMAP: "小地圖",
  T_46_META_WS_E_MINISENTRY: "小型哨兵",
  T_46_META_WS_E_MINVALUE: "最小值",
  T_46_META_WS_E_MISSILEEXPLODE: "類導彈武器",
  T_46_META_WS_E_MISSIONCOMPLETE: "任務成功提示1",
  T_46_META_WS_E_MISTAKE: "失誤",
  T_46_META_WS_E_MODERATE: "中等難度",
  T_46_META_WS_E_MONEY: "錢",
  T_46_META_WS_E_MONSTER: "僵屍",
  T_46_META_WS_E_MONSTERSPAWN: "怪物生成點",
  T_46_META_WS_E_MONSTERTRUCK: "怪物卡车",
  T_46_META_WS_E_MOON: "月亮",
  T_46_META_WS_E_MOSQUITO: "蚊子",
  T_46_META_WS_E_MOTIONTRAIL: "追尾",
  T_46_META_WS_E_MOTOBIKE: "摩托车",
  T_46_META_WS_E_MOTORBIKE: "摩托車",
  T_46_META_WS_E_MOVE: "移動",
  T_46_META_WS_E_MOVEMENT: "移動",
  T_46_META_WS_E_MOVINGJOYSTICK: "移動搖桿",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Mr. V",
  T_46_META_WS_E_MULTIPLIER: "连乘器",
  T_46_META_WS_E_MULTIPLY: "相乘",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "乗算累積器",
  T_46_META_WS_E_MUSHROOM1: "蘑菇1",
  T_46_META_WS_E_MUSHROOM2: "蘑菇2",
  T_46_META_WS_E_MUSHROOM3: "蘑菇3",
  T_46_META_WS_E_MUSHROOM4: "蘑菇4",
  T_46_META_WS_E_MUSHSHADE: "巨型蘑菇群",
  T_46_META_WS_E_MUSIC: "音樂",
  T_46_META_WS_E_MUZZLE1: "消焰器1",
  T_46_META_WS_E_MUZZLE2: "消焰器2",
  T_46_META_WS_E_MUZZLE3: "消焰器3",
  T_46_META_WS_E_NEAR: "近距離",
  T_46_META_WS_E_NIGHT: "夜晚",
  T_46_META_WS_E_NOATTACK: "不攻擊",
  T_46_META_WS_E_NODUALWIELDING: "無雙持",
  T_46_META_WS_E_NOERROR: "無錯誤",
  T_46_META_WS_E_NONE: "無限制",
  T_46_META_WS_E_NORMAL: "正常的",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "強制擊倒",
  T_46_META_WS_E_NOTONASTALIQURDU: "諾托納斯塔利克烏爾都語",
  T_46_META_WS_E_NUTTYMOVEMENT: "技能7",
  T_46_META_WS_E_OBTAINEDCOINS: "獲得中金幣",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "獲得大金幣",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "獲得小金幣",
  T_46_META_WS_E_OILDRUMEXPLODE: "油桶爆炸",
  T_46_META_WS_E_ONCE: "一次",
  T_46_META_WS_E_ONEWAY: "單向",
  T_46_META_WS_E_OPENFOLDER: "開啟的文件夾",
  T_46_META_WS_E_OPENHIHATS: "打開的踩镲",
  T_46_META_WS_E_OPENINGBOX: "打開盒子",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "公會福利紅包",
  T_46_META_WS_E_OPENINGWARCHEST: "倉庫保存",
  T_46_META_WS_E_ORANGE: "橙色",
  T_46_META_WS_E_ORTHOGONAL: "正交",
  T_46_META_WS_E_OUTPOST: "警衛室",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "彩繪牆",
  T_46_META_WS_E_PAINTSHIELDSKILL: "血池技能",
  T_46_META_WS_E_PALM: "布",
  T_46_META_WS_E_PANEL: "面板",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "乘客1座位",
  T_46_META_WS_E_PASSENGERB: "乘客2座位",
  T_46_META_WS_E_PASSENGERC: "乘客3座位",
  T_46_META_WS_E_PASSIVE: "被動",
  T_46_META_WS_E_PASSIVESKILL: "被動技能",
  T_46_META_WS_E_PATROLWHILEATTACK: "巡邏並攻擊",
  T_46_META_WS_E_PERSONALUAV: "個人UAV",
  T_46_META_WS_E_PERSPECTIVE: "透視",
  T_46_META_WS_E_PETTABBG: "寵物",
  T_46_META_WS_E_PHASESTART: "階段開始",
  T_46_META_WS_E_PHONEBOOTH: "電話亭",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "樂符-鋼琴",
  T_46_META_WS_E_PIANOKEY2: "樂符-鋼琴",
  T_46_META_WS_E_PICKUPS: "拾取物品",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "混凝土柱",
  T_46_META_WS_E_PIN: "標註",
  T_46_META_WS_E_PINGPONG: "乒乓球",
  T_46_META_WS_E_PIPECORNER: "轉折管道",
  T_46_META_WS_E_PIPEINTERSECTION: "十字管道",
  T_46_META_WS_E_PISTOL: "手槍",
  T_46_META_WS_E_PISTOLAMMO: "手槍彈藥",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "格紋遊樂園方塊",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "玩家",
  T_46_META_WS_E_PLUS: "加",
  T_46_META_WS_E_PODIUM: "頒獎台",
  T_46_META_WS_E_POISONGAS: "毒氣",
  T_46_META_WS_E_POISONGASPREDISCARDED: "毒氣",
  T_46_META_WS_E_PORTAL: "傳送門",
  T_46_META_WS_E_POSTACCUMULATOR: "後置累加器",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "心跳快",
  T_46_META_WS_E_PREACCUMULATOR: "前置累加器",
  T_46_META_WS_E_PRIMARYWEAPONA: "主武器A",
  T_46_META_WS_E_PRIMARYWEAPONB: "主武器B",
  T_46_META_WS_E_PRIOREXPLOSION: "炸彈爆炸前",
  T_46_META_WS_E_PROFILEWIDGET: "名片控件",
  T_46_META_WS_E_PRONE: "趴",
  T_46_META_WS_E_PUMPKIN: "南瓜",
  T_46_META_WS_E_PURPLE: "紫色",
  T_46_META_WS_E_QUADRILATERAL: "四邊形",
  T_46_META_WS_E_QUESTIONMARK: "問號",
  T_46_META_WS_E_QUICKCHAT: "快速聊天",
  T_46_META_WS_E_QUICKCHATSHOW: "快速聊天顯示",
  T_46_META_WS_E_RADIAL180: "180度扇形",
  T_46_META_WS_E_RADIAL360: "360度扇形",
  T_46_META_WS_E_RADIAL90: "90度扇形",
  T_46_META_WS_E_RAMPAGE: "暴走",
  T_46_META_WS_E_RANDOM: "隨機",
  T_46_META_WS_E_RANDOMBUFF: "隨機buff",
  T_46_META_WS_E_RANKDOWN: "降級",
  T_46_META_WS_E_REACTION: "響應",
  T_46_META_WS_E_RECOVER: "圓環",
  T_46_META_WS_E_RECYCLE: "回收",
  T_46_META_WS_E_RED: "紅色",
  T_46_META_WS_E_REFINERYTANK: "大水罐",
  T_46_META_WS_E_REFLECTIVECUBE: "反射純色基礎方塊1",
  T_46_META_WS_E_REFRESH: "刷新",
  T_46_META_WS_E_RELEASINGSKILL: "技能釋放特效",
  T_46_META_WS_E_RELOAD: "裝填",
  T_46_META_WS_E_REMINDER: "提醒",
  T_46_META_WS_E_REPAIR: "修復",
  T_46_META_WS_E_REPAIREQUIP: "裝備修復",
  T_46_META_WS_E_REPAIRKIT: "修理包",
  T_46_META_WS_E_REPLACER: "替代品",
  T_46_META_WS_E_REPORT: "舉報",
  T_46_META_WS_E_REST: "休息",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "吊镲",
  T_46_META_WS_E_RIDICULE: "嘲笑",
  T_46_META_WS_E_RIDICULEFUNNY: "搞怪嘲笑",
  T_46_META_WS_E_RIFLE: "步槍",
  T_46_META_WS_E_RIFLEAMMO: "步槍彈藥",
  T_46_META_WS_E_RIGHT: "對",
  T_46_META_WS_E_RIGHTTRAPEZOID: "直角梯形",
  T_46_META_WS_E_RING: "圓環機關",
  T_46_META_WS_E_RINGPREDISCARDED: "圓環",
  T_46_META_WS_E_RIPTIDERHYTHM: "技能9",
  T_46_META_WS_E_RISINGPARTICLE: "上升粒子",
  T_46_META_WS_E_ROADBLOCK: "路障",
  T_46_META_WS_E_ROTATE: "回轉",
  T_46_META_WS_E_RUNNING: "運行中",
  T_46_META_WS_E_RUSHTIME: "暴走",
  T_46_META_WS_E_SAMURAI: "武士",
  T_46_META_WS_E_SANDA: "沙子A",
  T_46_META_WS_E_SANDSTRUCTURE: "沙雕",
  T_46_META_WS_E_SCALE: "縮放",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "稻草人",
  T_46_META_WS_E_SCISSORS: "剪刀",
  T_46_META_WS_E_SCOPE2X: "2 倍鏡",
  T_46_META_WS_E_SCOPE4X: "4 倍鏡",
  T_46_META_WS_E_SCROLLPANEL: "滾動面板",
  T_46_META_WS_E_SECONDARYWEAPON: "副武器",
  T_46_META_WS_E_SENSESSHOCKWAVE: "技能10",
  T_46_META_WS_E_SERVER: "服務端",
  T_46_META_WS_E_SET: "連體衣",
  T_46_META_WS_E_SETTING: "設定",
  T_46_META_WS_E_SETTINGS: "設置",
  T_46_META_WS_E_SG: "散彈槍",
  T_46_META_WS_E_SGAMMO: "SN 子彈",
  T_46_META_WS_E_SHARPMECHANICAL: "密集叮叮叮1",
  T_46_META_WS_E_SHIELD: "防守",
  T_46_META_WS_E_SHIELDBROKEN: "破盾攻擊",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "舉盾攻擊",
  T_46_META_WS_E_SHOCKWAVE: "衝擊波",
  T_46_META_WS_E_SHOES: "鞋",
  T_46_META_WS_E_SHOOTINGTARGET: "移動靶",
  T_46_META_WS_E_SHORTDATE: "短日期",
  T_46_META_WS_E_SHORTDATETIME: "短日期時間",
  T_46_META_WS_E_SHORTTIME: "短時間",
  T_46_META_WS_E_SHOTGUN: "散彈槍",
  T_46_META_WS_E_SHOTGUNAMMO: "霰彈槍子彈",
  T_46_META_WS_E_SHOTGUNMUZZLE: "霰彈槍消焰器",
  T_46_META_WS_E_SHOW: "顯示",
  T_46_META_WS_E_SHRUB: "灌木長木箱",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "側滾視角相機",
  T_46_META_WS_E_SIGNAL: "信號",
  T_46_META_WS_E_SIGNOUT: "退出",
  T_46_META_WS_E_SILENCER: "消音器",
  T_46_META_WS_E_SIMPLE: "簡單",
  T_46_META_WS_E_SIMPLEWIDGET: "簡單控件",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "簡體阿拉伯語",
  T_46_META_WS_E_SINGLE: "單發",
  T_46_META_WS_E_SITEHUT: "貨櫃屋",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "技能充能完成",
  T_46_META_WS_E_SKILLRECOVER: "技能恢復",
  T_46_META_WS_E_SKIPKNOCKDOWN: "跳過擊倒",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "切片",
  T_46_META_WS_E_SLOPE: "斜坡",
  T_46_META_WS_E_SLOWHEARTBEAT: "心跳慢",
  T_46_META_WS_E_SMG: "冲鋒槍",
  T_46_META_WS_E_SMGAMMO: "SMG 子彈",
  T_46_META_WS_E_SMGMUZZLE: "衝鋒槍消焰器",
  T_46_META_WS_E_SMILEY: "笑臉",
  T_46_META_WS_E_SMOKE: "煙霧",
  T_46_META_WS_E_SMOKEGRENADE: "煙霧彈",
  T_46_META_WS_E_SMOKEY: "煙霧",
  T_46_META_WS_E_SMOOTH: "平滑",
  T_46_META_WS_E_SNAMMO: "SN 子彈",
  T_46_META_WS_E_SNARES: "軍鼓",
  T_46_META_WS_E_SNEAKERS: "跑鞋特效",
  T_46_META_WS_E_SNIPER: "狙擊槍",
  T_46_META_WS_E_SNIPERAMMO: "狙擊槍子彈",
  T_46_META_WS_E_SNOWA: "雪地A",
  T_46_META_WS_E_SNOWFLAKE: "雪花",
  T_46_META_WS_E_SOCCER: "足球",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "社交按鈕控件",
  T_46_META_WS_E_SOLARPANEL: "太阳能板",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "按優先級由高到低",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "按優先級由低到高",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "重生點特效",
  T_46_META_WS_E_SPEAKER: "喇叭",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "特殊槍聲",
  T_46_META_WS_E_SPECIALGUN: "特殊武器",
  T_46_META_WS_E_SPHERE: "球體",
  T_46_META_WS_E_SPHERETRIGGER: "球體衝觸發器",
  T_46_META_WS_E_SPIDERWEB: "技能特效",
  T_46_META_WS_E_SPORTSCAR: "跑車",
  T_46_META_WS_E_SPOTLIGHT: "燈光",
  T_46_META_WS_E_SPREADOFPOISONGAS: "毒氣擴散",
  T_46_META_WS_E_SPRINT: "快速移動",
  T_46_META_WS_E_SQUARE: "正方形",
  T_46_META_WS_E_SQUAREBOX: "方形木箱",
  T_46_META_WS_E_SR: "狙擊槍",
  T_46_META_WS_E_STABLE: "草棚",
  T_46_META_WS_E_STAIRS: "樓梯",
  T_46_META_WS_E_STANDING: "站立",
  T_46_META_WS_E_STAR: "星星",
  T_46_META_WS_E_STATIC: "靜態",
  T_46_META_WS_E_STATUSTRIGGER: "死亡或無敵觸發器組件",
  T_46_META_WS_E_STEP: "腳步提示",
  T_46_META_WS_E_STEPTRIGGER: "啟動機制",
  T_46_META_WS_E_STOCK_S: "槍托S",
  T_46_META_WS_E_STOCK_SR: "槍托SR",
  T_46_META_WS_E_STOCK1: "槍托1",
  T_46_META_WS_E_STOCK2: "槍托2",
  T_46_META_WS_E_STOCK3: "槍托3",
  T_46_META_WS_E_STONE: "石頭",
  T_46_META_WS_E_STONEBRIDGE: "石拱桥",
  T_46_META_WS_E_STONELANTERN: "宮燈",
  T_46_META_WS_E_STONESPLASH: "石子飛濺",
  T_46_META_WS_E_STORE: "商店",
  T_46_META_WS_E_STREETLAMP: "路燈",
  T_46_META_WS_E_STYLEA: "樣式A",
  T_46_META_WS_E_STYLEB: "樣式B",
  T_46_META_WS_E_STYLEC: "樣式C",
  T_46_META_WS_E_SUBMACHINEGUN: "衝鋒槍",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "衝鋒槍子彈",
  T_46_META_WS_E_SUCCESSFULHIT: "擊中",
  T_46_META_WS_E_SUN: "太陽",
  T_46_META_WS_E_SUNSHADE: "雨伞桌组合",
  T_46_META_WS_E_SUPERCAR: "運動汽車",
  T_46_META_WS_E_SUPERMARKET: "超市",
  T_46_META_WS_E_SURPRISEFIND: "發現驚喜",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "快速換武器",
  T_46_META_WS_E_SWIMRING: "游泳圈",
  T_46_META_WS_E_SWORD: "劍",
  T_46_META_WS_E_SYMBOLIC: "地面印記",
  T_46_META_WS_E_TANKZOMBIE: "坦克殭屍",
  T_46_META_WS_E_TAP: "點擊",
  T_46_META_WS_E_TAPPINGBUTTON: "點擊按鈕",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "點擊禁用按鈕",
  T_46_META_WS_E_TEAM: "팀",
  T_46_META_WS_E_TEAMMATESINFO: "隊友資訊",
  T_46_META_WS_E_TELEPORT: "圓環",
  T_46_META_WS_E_TELEPORTCORRECT: "用傳送點傳送到正確區域的聲音",
  T_46_META_WS_E_TELEPORTWRONG: "用傳送點傳送到錯誤區域的聲音",
  T_46_META_WS_E_TEXT: "文本",
  T_46_META_WS_E_TEXTOBJECT: "文本實體",
  T_46_META_WS_E_TEXTUREWIDGET: "貼圖控件",
  T_46_META_WS_E_THERMALSCOPE: "熱成像鏡",
  T_46_META_WS_E_THIRDPERSON: "第三人稱視角相機",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "第三人稱視角相機（經典）",
  T_46_META_WS_E_THIRDPERSONLOCK: "第三人稱鎖定視角相機",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "相容性投擲刀2",
  T_46_META_WS_E_THRILLBATTLE: "技能5",
  T_46_META_WS_E_THROWATTACK: "投擲手雷",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "投擲紅色殭屍",
  T_46_META_WS_E_THROWZOMBIE: "投擲殭屍",
  T_46_META_WS_E_THUMBSUP: "按讚",
  T_46_META_WS_E_THUNDER: "電擊",
  T_46_META_WS_E_TILEA: "磁磚A",
  T_46_META_WS_E_TILEB: "磁磚B",
  T_46_META_WS_E_TILEC: "磁磚C",
  T_46_META_WS_E_TILED: "磁磚",
  T_46_META_WS_E_TIPSSOUND: "顯示Tips提示",
  T_46_META_WS_E_TOGGLEWIDGET: "切換按鈕控件",
  T_46_META_WS_E_TOILETBOWL: "馬桶",
  T_46_META_WS_E_TONEA: "石頭A",
  T_46_META_WS_E_TOP: "上身服飾",
  T_46_META_WS_E_TOPDOWN: "俯視視角相機",
  T_46_META_WS_E_TORII: "鳥居",
  T_46_META_WS_E_TOUCHPADWIDGET: "觸控板控件",
  T_46_META_WS_E_TOWER: "堡壘",
  T_46_META_WS_E_TPIPE: "T管道",
  T_46_META_WS_E_TRACINGSTEPS: "技能3",
  T_46_META_WS_E_TRAILER: "拖車",
  T_46_META_WS_E_TRANSFORMATION: "變身",
  T_46_META_WS_E_TRANSPARENT: "透明",
  T_46_META_WS_E_TRAPEZOID: "梯形",
  T_46_META_WS_E_TRASHCAN: "垃圾桶",
  T_46_META_WS_E_TRIANGLE: "三角形",
  T_46_META_WS_E_TRIGGERS: "觸發器",
  T_46_META_WS_E_TRIPLE: "三連發",
  T_46_META_WS_E_TROPHY: "獎盃",
  T_46_META_WS_E_TRUE: "是",
  T_46_META_WS_E_TUKTUK: "嘟嘟車",
  T_46_META_WS_E_TUTUCAR: "三轮车",
  T_46_META_WS_E_TYRANTZOMBIE: "暴君殭屍",
  T_46_META_WS_E_UAVLITE: "輕型無人機",
  T_46_META_WS_E_UIFINISH: "結束",
  T_46_META_WS_E_UITAP: "界面點擊",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "單位生成器",
  T_46_META_WS_E_UPWARDTURBULENCE: "上升氣流",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "翻越",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "車輛",
  T_46_META_WS_E_VEHICLEEXPLODE: "載具爆炸",
  T_46_META_WS_E_VELOCITY: "速度",
  T_46_META_WS_E_VENDINGMACHINE: "自動販賣機",
  T_46_META_WS_E_VERTICAL: "垂直",
  T_46_META_WS_E_VEST: "防彈背心",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "防彈背心4",
  T_46_META_WS_E_VISUALEFFECTS: "視覺效果",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "墙壁A",
  T_46_META_WS_E_WALLBRAWL: "技能2",
  T_46_META_WS_E_WARNING: "警告",
  T_46_META_WS_E_WATERRING: "水花",
  T_46_META_WS_E_WAVE1: "波浪1",
  T_46_META_WS_E_WAVE2: "波浪2",
  T_46_META_WS_E_WAVE3: "波浪3",
  T_46_META_WS_E_WEAPONGENERATOR: "武器",
  T_46_META_WS_E_WEAPONSLOT: "武器欄",
  T_46_META_WS_E_WHISTLE: "打敗敵人",
  T_46_META_WS_E_WIDERANGE: "寬範圍",
  T_46_META_WS_E_WIN: "勝利",
  T_46_META_WS_E_WINDATTACK: "旋風斬",
  T_46_META_WS_E_WOODA: "木頭A",
  T_46_META_WS_E_WOODCUTZOMBIE: "斧頭殭屍",
  T_46_META_WS_E_WOODENPLANK: "木板橋",
  T_46_META_WS_E_WORLDPOSITION: "世界座標",
  T_46_META_WS_E_WRECKEDBUS: "廢巴士",
  T_46_META_WS_E_WRECKEDCAR: "廢汽車",
  T_46_META_WS_E_WRONG: "錯",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "殭屍",
  T_46_META_WS_E_ZOMBIES: "殭屍",
  T_46_META_WS_E_ZOOM: "縮放",
  T_46_META_WS_ELIMINATE: "消除",
  T_46_META_WS_ELIMINATEDENTITY: "被擊殺實體",
  T_46_META_WS_ELIMINATEDPLAYER: "被擊殺玩家",
  T_46_META_WS_ENABLEDEFAULTBTREE: "啟用預設行為樹",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "開啟移動安全區",
  T_46_META_WS_ENABLESAFEZONE: "開啟安全區",
  T_46_META_WS_ENDCURRENTPHASE: "結束當前階段",
  T_46_META_WS_ENDMORPH: "結束變形",
  T_46_META_WS_ENDPOSITION: "結束位置",
  T_46_META_WS_ENTERVEHICLE: "強制玩家上車",
  T_46_META_WS_ENTITY: "實體",
  T_46_META_WS_EQUIPMENTID: "裝備ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "歐拉角轉四元數",
  T_46_META_WS_EXITVEHICLE: "強制下車",
  T_46_META_WS_EXPONENTIATION: "求冪運算",
  T_46_META_WS_FILTERENTITY: "過濾實體",
  T_46_META_WS_FILTERLEVELOBJECTS: "所有地圖物件",
  T_46_META_WS_FIND: "查找",
  T_46_META_WS_FINDAT: "查找於",
  T_46_META_WS_FINDPATH: "尋路",
  T_46_META_WS_FLOOR: "向下取整",
  T_46_META_WS_FOOTBALLGOAL: "足球進球",
  T_46_META_WS_FORMAT: "格式化字串",
  T_46_META_WS_GETALLKEYS: "獲取字典的所有key",
  T_46_META_WS_GETALLPLAYERS: "所有玩家",
  T_46_META_WS_GETALLSHOPS: "獲取所有商店",
  T_46_META_WS_GETALLTEAMS: "所有隊伍",
  T_46_META_WS_GETATTACKABLEENTITY: "獲取可攻擊實體",
  T_46_META_WS_GETATTACKABLEFACTIONS: "獲取可攻擊的陣營",
  T_46_META_WS_GETBACKPACKSKIN: "獲取背包外觀",
  T_46_META_WS_GETBLACKBOARDVALUE: "獲取黑板變數",
  T_46_META_WS_GETBUFFS: "獲取Buff",
  T_46_META_WS_GETCHATCHANNEL: "獲取聊天頻道",
  T_46_META_WS_GETCHILDBYINDEX: "根據索引獲取指定子節點",
  T_46_META_WS_GETCHILDBYNAME: "根據名稱獲取指定子節點",
  T_46_META_WS_GETCHILDREN: "獲取所有子節點",
  T_46_META_WS_GETCOLORCHANNEL: "獲得色值(RGBA)通道",
  T_46_META_WS_GETCONSUMABLES: "獲取消耗品",
  T_46_META_WS_GETCULLINGMASK: "獲取相機層遮罩",
  T_46_META_WS_GETCURRENTCAMERA: "獲取當前相機",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "獲取當前聊天頻道",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "查詢自定義任務進度",
  T_46_META_WS_GETDYEDCOUNT: "獲取染色數量",
  T_46_META_WS_GETDYEDSTATUS: "獲取染色狀態",
  T_46_META_WS_GETEQUIPMENTS: "獲取裝備",
  T_46_META_WS_GETFACTION: "獲取陣營",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "獲取全局休眠閾值",
  T_46_META_WS_GETITEMCOUNT: "獲取物品數量",
  T_46_META_WS_GETLOADEDSCENES: "獲取已加載場景",
  T_46_META_WS_GETLOCALAIMDIRECTION: "獲取本地的瞄準方向",
  T_46_META_WS_GETLOCALPLAYER: "當前玩家",
  T_46_META_WS_GETLOCALTIMESTAMP: "獲取本地時間戳",
  T_46_META_WS_GETMAPID: "獲取地圖ID",
  T_46_META_WS_GETMINIMAP: "獲得小地圖",
  T_46_META_WS_GETMONEY: "獲取金錢",
  T_46_META_WS_GETMONEYCOUNT: "獲取金錢數量",
  T_46_META_WS_GETMORPH: "獲取變形",
  T_46_META_WS_GETNODEVARIABLE: "獲取節點參數",
  T_46_META_WS_GETOUTFIT: "獲取服裝",
  T_46_META_WS_GETOWNER: "獲得實體的綁定玩家",
  T_46_META_WS_GETPARENT: "獲取父節點",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "獲得隊友附近的位置",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "獲取隨機出生點",
  T_46_META_WS_GETRESULTFROMCURVE: "通過Curve獲取運算值",
  T_46_META_WS_GETSCENESKYBOX: "獲取場景的天空盒",
  T_46_META_WS_GETSERVERREGION: "獲取伺服器區域",
  T_46_META_WS_GETSERVERTIMESTAMP: "獲取伺服器時間戳",
  T_46_META_WS_GETSKELETONPARTBYNAME: "通過名字獲取骨骼部位",
  T_46_META_WS_GETSKILLS: "獲取技能",
  T_46_META_WS_GETSLEEPTHRESHOLD: "獲取休眠閾值",
  T_46_META_WS_GETTOKENCOUNT: "獲取玩家token數據",
  T_46_META_WS_GETTOKENCOUNTTODAY: "獲取玩家今日token數據",
  T_46_META_WS_GETTYPE: "獲取類型",
  T_46_META_WS_GETVEHICLESKIN: "獲取載具塗裝",
  T_46_META_WS_GETWALLET: "獲取錢包",
  T_46_META_WS_GETWEAPONSKIN: "獲取武器塗裝",
  T_46_META_WS_GETWIDGETBYPATH: "透過路徑獲取控件",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "獲取控件",
  T_46_META_WS_GIVEJAILBREAKITEM: "給予逃脫物品",
  T_46_META_WS_GIVEJAILBREAKREWARD: "給予逃脫獎勳",
  T_46_META_WS_HASAOISPECIALFOLLOW: "是否存在AOI特別關注",
  T_46_META_WS_HASCOMPONENT: "擁有組件",
  T_46_META_WS_HASSCRIPT: "是否擁有腳本",
  T_46_META_WS_HASTAG: "是否擁有標籤",
  T_46_META_WS_HELPEDPLAYER: "被幫助的玩家",
  T_46_META_WS_HELPPLAYER: "助攻玩家",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "隱藏外觀組",
  T_46_META_WS_HITENTITY: "命中實體",
  T_46_META_WS_HITFLY: "擊飛",
  T_46_META_WS_HITNORMAL: "命中法線",
  T_46_META_WS_HITOBJECT: "命中物件",
  T_46_META_WS_HITPOSITION: "命中位置",
  T_46_META_WS_INDEXOF: "獲取元素最先出現的位置",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "感染模式僵尸進化",
  T_46_META_WS_INSERT: "插入",
  T_46_META_WS_ISATTACKABLE: "是否可攻擊",
  T_46_META_WS_ISCHATCHANNELEMPTY: "聊天頻道是否空",
  T_46_META_WS_ISEQUAL: "是否相等",
  T_46_META_WS_ISFRIEND: "判斷好友關係",
  T_46_META_WS_ISHIT: "是否命中",
  T_46_META_WS_ISINSIDEBOX: "立方體範圍判定",
  T_46_META_WS_ISINSIDECYLINDER: "圓柱體範圍判定",
  T_46_META_WS_ISINSIDESECTOR: "扇形範圍判定",
  T_46_META_WS_ISINSIDESPHERE: "球形範圍判定",
  T_46_META_WS_ISSLEEPING: "剛體是否處於休眠狀態",
  T_46_META_WS_ISSUBTYPEOF: "是…的子類型",
  T_46_META_WS_ITEM: "實體",
  T_46_META_WS_ITEMID: "道具ID",
  T_46_META_WS_JOIN: "連接",
  T_46_META_WS_JOINCHATCHANNEL: "加入聊天頻道",
  T_46_META_WS_JOINFACTION: "加入陣營",
  T_46_META_WS_LASTINDEXOF: "獲取元素最後出現的位置",
  T_46_META_WS_LENGTH: "長度",
  T_46_META_WS_LERP: "線性插值",
  T_46_META_WS_LOADSCENE: "載入場景",
  T_46_META_WS_LOGARITHM: "求對數算",
  T_46_META_WS_LOGERROR: "打印報錯",
  T_46_META_WS_LOGINFO: "打印提示",
  T_46_META_WS_LOGWARNING: "打印警告",
  T_46_META_WS_LOOKROTATION: "創建朝目標方向看過去的旋轉量",
  T_46_META_WS_MAGNITUDE: "向量大小",
  T_46_META_WS_MAKER: "創造者",
  T_46_META_WS_MAX: "最大值",
  T_46_META_WS_MECHANISM: "機關",
  T_46_META_WS_MIN: "最小值",
  T_46_META_WS_MONSTERUSESKILL: "怪物釋放技能",
  T_46_META_WS_MORPHOBJECT: "變形物件",
  T_46_META_WS_MORPHTO: "變形為",
  T_46_META_WS_MORPHTOBYITEMID: "根據物品ID變形",
  T_46_META_WS_MOVECCT: "移動角色控制器",
  T_46_META_WS_MOVEPOSITION: "移動剛體",
  T_46_META_WS_MOVEROTATION: "旋轉剛體",
  T_46_META_WS_MULTIPLYQUATERNION: "四元數相乘",
  T_46_META_WS_MULTIRAYCAST: "多次射線檢測",
  T_46_META_WS_NEGATE: "負值",
  T_46_META_WS_NEW: "構造",
  T_46_META_WS_NODENAME: "節點名稱",
  T_46_META_WS_NORMALIZE: "向量歸一化",
  T_46_META_WS_NOTIFYPLAYEFFECT: "通知客戶端播放特效",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "通知客戶端播放圖標動畫效果",
  T_46_META_WS_NOTIFYPLAYSOUND: "通知客戶端播放音效",
  T_46_META_WS_NOTIFYSHOWTIPS: "通知客戶端顯示飄字",
  T_46_META_WS_NUMTOSTRING: "數字轉字串",
  T_46_META_WS_ONACCESSEQUIPMENT: "當獲得裝備時",
  T_46_META_WS_ONACCESSITEM: "當獲取物品時",
  T_46_META_WS_ONACCESSWEAPON: "當獲取武器時",
  T_46_META_WS_ONACE: "當 ACE 完成時",
  T_46_META_WS_ONAIMED: "當瞄準完成時",
  T_46_META_WS_ONAIMING: "當瞄準時",
  T_46_META_WS_ONASSIST: "當助攻時",
  T_46_META_WS_ONATTACK: "當攻擊時",
  T_46_META_WS_ONATTACKSTOP: "當停止攻擊時",
  T_46_META_WS_ONAWAKE: "當覺醒時",
  T_46_META_WS_ONBEKNOCKEDDOWN: "當被擊倒時",
  T_46_META_WS_ONBOUNCEDBYTIRE: "當被輪胎彈起時",
  T_46_META_WS_ONBOUNCEENTITY: "當彈起實體時",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "當內建 UI 按鈕被點擊時",
  T_46_META_WS_ONBULLETHIT: "子彈擊中時",
  T_46_META_WS_ONCAMERARAYCAST: "當相機射線檢測時",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "當角色控制器被擊中時",
  T_46_META_WS_ONCHASE: "當追逐時",
  T_46_META_WS_ONCHASESTOP: "當停止追逐時",
  T_46_META_WS_ONCLIPEND: "當片段結束時",
  T_46_META_WS_ONCOLLISIONENTER: "當發生碰撞時",
  T_46_META_WS_ONCOLLISIONEXIT: "當碰撞結束時",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "當倒計時結束時",
  T_46_META_WS_ONCREEP: "俯臥時",
  T_46_META_WS_ONCROUCH: "當蹲下時",
  T_46_META_WS_ONDEALDAMAGE: "當造成傷害時",
  T_46_META_WS_ONDESTROY: "當銷毀時",
  T_46_META_WS_ONDISABLE: "當禁用時",
  T_46_META_WS_ONDISCONNECT: "當斷開連接時",
  T_46_META_WS_ONDOUBLETAPPED: "當雙擊時",
  T_46_META_WS_ONDRAG: "當拖動時",
  T_46_META_WS_ONDRAGEND: "當拖動結束時",
  T_46_META_WS_ONDRAGSTART: "當開始拖動時",
  T_46_META_WS_ONDRIVED: "當被駕駛時",
  T_46_META_WS_ONDRIVEVEHICLE: "當駕駛載具時",
  T_46_META_WS_ONDROPCONSUMABLE: "當丟棄消耗品時",
  T_46_META_WS_ONDROPPED: "當被丟下時",
  T_46_META_WS_ONDROPWEAPON: "當丟棄武器時",
  T_46_META_WS_ONEACHLOOP: "每次迴圈時",
  T_46_META_WS_ONELIMINATE: "當擊殺時",
  T_46_META_WS_ONELIMINATED: "當被淘汰時",
  T_46_META_WS_ONENABLE: "當啟用時",
  T_46_META_WS_ONEND: "當結束時",
  T_46_META_WS_ONENTERED: "當進入時",
  T_46_META_WS_ONENTERVEHICLE: "當進入載具時",
  T_46_META_WS_ONENTITYENTER: "當碰觸進入時",
  T_46_META_WS_ONENTITYEXIT: "當碰觸離開時",
  T_46_META_WS_ONEQUIPARMOR: "當裝備防具時",
  T_46_META_WS_ONEQUIPED: "當裝備時",
  T_46_META_WS_ONEQUIPWEAPON: "當裝備武器時",
  T_46_META_WS_ONEXPLODE: "當爆炸時",
  T_46_META_WS_ONFALL: "當墜落時",
  T_46_META_WS_ONFALLSTOP: "當墜落結束時",
  T_46_META_WS_ONFIRE: "當開火時",
  T_46_META_WS_ONFIXEDUPDATE: "當固定更新時",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "足球碰撞時",
  T_46_META_WS_ONFRIENDSUPDATE: "當好友狀態更新時",
  T_46_META_WS_ONGAMEEND: "當遊戲結束時",
  T_46_META_WS_ONGAMEPAUSE: "當遊戲暫停時",
  T_46_META_WS_ONGAMERESUME: "當遊戲恢復時",
  T_46_META_WS_ONGAMESTART: "當遊戲開始時",
  T_46_META_WS_ONGOAL: "當進球時",
  T_46_META_WS_ONHITBYBULLET: "當被子彈擊中時",
  T_46_META_WS_ONHITFLY: "當擊飛時",
  T_46_META_WS_ONHITFLYENTITY: "當擊飛實體時",
  T_46_META_WS_ONHOOKGUNFIRE: "當鉤槍開火時",
  T_46_META_WS_ONIDLE: "當閒置時",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "當越獄區開始時",
  T_46_META_WS_ONJAILBREAKAREAEND: "當越獄區結束時",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "當越獄玩家加入時",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "當越獄玩家退出時",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "當成功加入聊天頻道時",
  T_46_META_WS_ONJOYSTICKMOVE: "當搖桿移動時",
  T_46_META_WS_ONJOYSTICKPRESSED: "當按下時",
  T_46_META_WS_ONJOYSTICKRELEASED: "當釋放時",
  T_46_META_WS_ONJUMP: "當跳躍時",
  T_46_META_WS_ONJUMPSTOP: "當跳躍結束時",
  T_46_META_WS_ONLANDMINEACTIVE: "當地雷激活時",
  T_46_META_WS_ONLANDMINETRIGGER: "當地雷觸發時",
  T_46_META_WS_ONLEAVECHATCHANNEL: "當離開聊天頻道時",
  T_46_META_WS_ONLEAVEVEHICLE: "當離開載具時",
  T_46_META_WS_ONLEFT: "當離開時",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "當關卡物體變形時",
  T_46_META_WS_ONMOVE: "當移動時",
  T_46_META_WS_ONNODEENTER: "當節點進入時",
  T_46_META_WS_ONNODEEXIT: "當節點退出時",
  T_46_META_WS_ONPAUSE: "當暫停時",
  T_46_META_WS_ONPHASEEND: "當階段結束時",
  T_46_META_WS_ONPHASESTART: "當階段開始時",
  T_46_META_WS_ONPICKEDUP: "當被拾起時",
  T_46_META_WS_ONPLAYERASSIST: "當玩家助攻時",
  T_46_META_WS_ONPLAYERBEELIMINATED: "當玩家被淘汰時",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "當玩家被擊倒時",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "當玩家造成傷害時",
  T_46_META_WS_ONPLAYERELIMINATE: "當玩家擊殺時",
  T_46_META_WS_ONPLAYERENTER: "當玩家進入時",
  T_46_META_WS_ONPLAYERJOIN: "當玩家加入遊戲時",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "當加入聊天頻道失敗時",
  T_46_META_WS_ONPLAYERLEAVE: "當玩家離開時",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "當玩家請求購買時",
  T_46_META_WS_ONPLAYERQUIT: "當玩家退出時",
  T_46_META_WS_ONPLAYERRANKCHANGE: "當玩家排名改變時",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "當玩家購買請求被滿足時",
  T_46_META_WS_ONPLAYERREVIVED: "當玩家復活時",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "當玩家在出生點復活時",
  T_46_META_WS_ONPLAYERSCORECHANGE: "當玩家積分改變時",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "當玩家切換場景時",
  T_46_META_WS_ONPREDEALDAMAGE: "在造成傷害之前",
  T_46_META_WS_ONPREPURCHASE: "在購買之前",
  T_46_META_WS_ONPRESSED: "當按下時",
  T_46_META_WS_ONPRETAKEDAMAGE: "在受到傷害之前",
  T_46_META_WS_ONPURCHASE: "當購買時",
  T_46_META_WS_ONRANKCHANGED: "當實體排名改變時",
  T_46_META_WS_ONRECONNECT: "當重新連接時",
  T_46_META_WS_ONRELEASED: "當釋放時",
  T_46_META_WS_ONRELOAD: "當重新裝填時",
  T_46_META_WS_ONRESUME: "當繼續時",
  T_46_META_WS_ONREVIVED: "當復活時",
  T_46_META_WS_ONROUNDEND: "當回合結束時",
  T_46_META_WS_ONROUNDSTART: "當回合開始時",
  T_46_META_WS_ONSCENELOAD: "當場景加載時",
  T_46_META_WS_ONSCENESWITCH: "當場景切換時",
  T_46_META_WS_ONSCORECHANGE: "當實體積分改變時",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "當被足球射手射中時",
  T_46_META_WS_ONSLEEP: "當休眠時",
  T_46_META_WS_ONSPAWN: "當生成時",
  T_46_META_WS_ONSPRAY: "當噴灑時",
  T_46_META_WS_ONSPRAYED: "當被噴灑時",
  T_46_META_WS_ONSPRINT: "當疾跑時",
  T_46_META_WS_ONSPRINTSTOP: "當停止疾跑時",
  T_46_META_WS_ONSTANDUP: "當站立時",
  T_46_META_WS_ONSTART: "當開始時",
  T_46_META_WS_ONSTARTFIRE: "當攻擊時",
  T_46_META_WS_ONSTATEEND: "當狀態結束時",
  T_46_META_WS_ONSURFING: "當衝浪時",
  T_46_META_WS_ONSURFINGSTOP: "當停止衝浪時",
  T_46_META_WS_ONSWITCHHANDHELD: "切換到手持模式時",
  T_46_META_WS_ONTAKEDAMAGE: "當受到傷害時",
  T_46_META_WS_ONTAPPED: "當被點擊時",
  T_46_META_WS_ONTEAMACE: "當隊伍全滅時",
  T_46_META_WS_ONTEAMADD: "當添加隊伍時",
  T_46_META_WS_ONTEAMREMOVE: "當移除隊伍時",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "當隊伍回合排名改變時",
  T_46_META_WS_ONTEAMSCORECHANGE: "當隊伍積分改變時",
  T_46_META_WS_ONTELEPORTENTITY: "當傳送實體時",
  T_46_META_WS_ONTEXTCHANGE: "當文本更改時",
  T_46_META_WS_ONTHROWABLEEXPLODE: "當投擲物爆炸時",
  T_46_META_WS_ONTOGGLE: "當切換時",
  T_46_META_WS_ONTOUCHDOWN: "當觸摸按下時",
  T_46_META_WS_ONTOUCHUP: "當觸摸抬起時",
  T_46_META_WS_ONUIHIDE: "當 UI 隱藏時",
  T_46_META_WS_ONUISHOW: "當 UI 顯示時",
  T_46_META_WS_ONUPDATE: "當更新時",
  T_46_META_WS_ONUSEAVATARSKILL: "當使用頭像技能時",
  T_46_META_WS_ONUSECONSUMABLE: "當使用消耗品時",
  T_46_META_WS_ONUSED: "當使用時",
  T_46_META_WS_ONUSEPORTAL: "當使用傳送門時",
  T_46_META_WS_ONWAKEUP: "當喚醒時",
  T_46_META_WS_ONWEAPONBEEQUIPED: "當裝備武器時",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "當武器造成傷害時",
  T_46_META_WS_ONWEAPONELIMINATE: "當武器淘汰時",
  T_46_META_WS_ONWEAPONSTOPFIRING: "當武器停止射擊時",
  T_46_META_WS_OWNER: "所有者",
  T_46_META_WS_P_ACCELERATE: "加速",
  T_46_META_WS_P_ACCELERATION: "加速度",
  T_46_META_WS_P_ACCOUNTID: "用戶帳號",
  T_46_META_WS_P_ACCURACY: "精準度",
  T_46_META_WS_P_ACTIONTYPE: "行為類型",
  T_46_META_WS_P_ACTIVATEDALPHA: "啟用透明度",
  T_46_META_WS_P_ACTIVE: "活動狀態",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "在層級中啟用",
  T_46_META_WS_P_ACTIVESELF: "啟用自身",
  T_46_META_WS_P_ACTIVETEXT: "啟用文字",
  T_46_META_WS_P_ACTUALPOSITION: "實際位置",
  T_46_META_WS_P_AFTERACCUMULATOR: "後置累加器",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "瞄準輔助中心偏移量",
  T_46_META_WS_P_AIMASSISTDISTANCE: "瞄準輔助距離",
  T_46_META_WS_P_AIMASSISTTYPE: "瞄準輔助類型",
  T_46_META_WS_P_AIRDROPSTATE: "空投箱掉狀態",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "水平對齊",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "垂直對齊",
  T_46_META_WS_P_ALLITEMS: "所有物品",
  T_46_META_WS_P_ALLMEMBERS: "所有成員",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "是否可被輔助瞄準鎖定",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "區域外保持觸發",
  T_46_META_WS_P_ALLPLAYERS: "所有玩家",
  T_46_META_WS_P_ALLTEAMMATES: "所有隊員",
  T_46_META_WS_P_ALPHA: "透明度",
  T_46_META_WS_P_ALWAYSSHOWMARK: "標記點始終顯示在標尺上",
  T_46_META_WS_P_AMBIENTCOLOR: "環境光顏色",
  T_46_META_WS_P_AMMOCLIPSIZE: "彈匣數量修正",
  T_46_META_WS_P_AMMOMAGSIZE: "彈匣子彈數量",
  T_46_META_WS_P_AMMOPERSHOT: "單次發射子彈數量",
  T_46_META_WS_P_AMMOTYPE: "子彈類型",
  T_46_META_WS_P_ANCHORMAX: "錨點最大值",
  T_46_META_WS_P_ANCHORMIN: "錨點最小值",
  T_46_META_WS_P_ANCHOROBJECT: "錨點對象",
  T_46_META_WS_P_ANCHORPOSITION: "錨點座標",
  T_46_META_WS_P_ANCHORTYPE: "錨點類型",
  T_46_META_WS_P_ANGLE: "旋轉角度",
  T_46_META_WS_P_ANGLEDOWN: "炮塔俯角",
  T_46_META_WS_P_ANGLEUP: "炮塔仰角",
  T_46_META_WS_P_ANGULARDRAG: "轉動阻力係數",
  T_46_META_WS_P_ANGULARSPEED: "炮塔角速度",
  T_46_META_WS_P_ANGULARVELOCITY: "角速度 (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "動畫片段",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "動畫控制器",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "動畫控制器資源 ID",
  T_46_META_WS_P_ARMORPENETRATION: "護甲穿透",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "護甲穿透係數",
  T_46_META_WS_P_ARMORTYPE: "護甲類型",
  T_46_META_WS_P_ARROWOFFSET: "方向箭頭偏移",
  T_46_META_WS_P_ARROWSIZE: "方向箭頭尺寸",
  T_46_META_WS_P_ARROWSPRITE: "方向箭頭圖片",
  T_46_META_WS_P_ASKBUYTARGET: "請求購買目標",
  T_46_META_WS_P_ATTACHTARGET: "行為樹實體",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "可攻擊的陣營",
  T_46_META_WS_P_ATTACKDAMAGE: "攻擊力",
  T_46_META_WS_P_ATTACKINTERVAL: "攻擊間隔",
  T_46_META_WS_P_ATTACKRANGE: "攻擊範圍",
  T_46_META_WS_P_ATTACKTARGET: "攻擊目標",
  T_46_META_WS_P_ATTTACKABLETARGETS: "攻擊目標",
  T_46_META_WS_P_AUTOPLAY: "自動播放狀態",
  T_46_META_WS_P_AVAILABLEPOINT: "可用點",
  T_46_META_WS_P_AVATAR: "頭像",
  T_46_META_WS_P_AVATARID: "頭像 ID",
  T_46_META_WS_P_BACKGROUND: "底圖",
  T_46_META_WS_P_BACKGROUNDALPHA: "背景透明度",
  T_46_META_WS_P_BACKGROUNDCOLOR: "背景顏色",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "背景顏色1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "背景顏色2",
  T_46_META_WS_P_BACKGROUNDFILL: "背景填充",
  T_46_META_WS_P_BACKGROUNDICONNAME: "背景圖示名稱",
  T_46_META_WS_P_BACKGROUNDNAME: "背景名稱",
  T_46_META_WS_P_BACKGROUNDOFFSET: "底座偏移",
  T_46_META_WS_P_BACKGROUNDRADIUS: "底座半徑",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "背景尺寸增量",
  T_46_META_WS_P_BACKGROUNDSPRITE: "底座圖片",
  T_46_META_WS_P_BACKPACK: "背包",
  T_46_META_WS_P_BACKPACKSKINID: "背包外觀 ID",
  T_46_META_WS_P_BACKWARDSPEED: "後退速度",
  T_46_META_WS_P_BANNERID: "橫幅 ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "基礎水平速度",
  T_46_META_WS_P_BASEMULTIPLIER: "基礎係數",
  T_46_META_WS_P_BASETIME: "基礎時間",
  T_46_META_WS_P_BASEVERTICALSPEED: "基礎垂直速度",
  T_46_META_WS_P_BEFOREACCUMULATOR: "前置累加器",
  T_46_META_WS_P_BEVTREEID: "行為樹 ID",
  T_46_META_WS_P_BINDPROPERTYID: "綁定屬性 ID",
  T_46_META_WS_P_BODY: "軀幹",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "身體傷害係數",
  T_46_META_WS_P_BONEPOSITION: "骨骼位置",
  T_46_META_WS_P_BONESCALE: "骨骼縮放",
  T_46_META_WS_P_BOOSTCD: "衝刺冷卻時間",
  T_46_META_WS_P_BOOSTDURATION: "衝刺持續時間",
  T_46_META_WS_P_BOOSTSPEED: "衝刺速度",
  T_46_META_WS_P_BORDERLR: "左右邊界",
  T_46_META_WS_P_BORDERTB: "上下邊界",
  T_46_META_WS_P_BOTTOMALPHA: "底部透明度",
  T_46_META_WS_P_BOUNDWALLET: "綁定錢包",
  T_46_META_WS_P_BRAKEHORSEPOWER: "制動馬力",
  T_46_META_WS_P_BRAKETORQUE: "制動扭矩",
  T_46_META_WS_P_BRRANK: "經典模式段位",
  T_46_META_WS_P_BUFFTYPE: "增益類型",
  T_46_META_WS_P_BURNDAMAGE: "燃燒傷害",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "燃燒傷害間隔",
  T_46_META_WS_P_BURNTIME: "燃燒時間",
  T_46_META_WS_P_BUTTOM: "下裝",
  T_46_META_WS_P_BUTTONCOLORS: "按鈕顏色數組",
  T_46_META_WS_P_BUTTONNAMES: "按鈕名字數組",
  T_46_META_WS_P_BUTTONSTYLE: "按鈕樣式",
  T_46_META_WS_P_CAMERABLOCKMODE: "相機遮蔽模式",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "相機投影模式",
  T_46_META_WS_P_CAMERATYPE: "相機類型",
  T_46_META_WS_P_CANCELDRAGIFFITS: "若適合則取消拖曳",
  T_46_META_WS_P_CANCOSTDURABILITY: "是否消耗耐久度",
  T_46_META_WS_P_CANDAMAGED: "是否會破損",
  T_46_META_WS_P_CANDESTROY: "是否可摧毀",
  T_46_META_WS_P_CANDESTROYED: "是否會摧毀",
  T_46_META_WS_P_CANSELFTRIGGER: "是否能自己觸發",
  T_46_META_WS_P_CANTEAMTRIGGER: "是否隊友能觸發",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "是否可由自己觸發",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "是否可由隊友觸發",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "是否可由載具觸發",
  T_46_META_WS_P_CANVEHICLETRIGGER: "是否載具可以觸發",
  T_46_META_WS_P_CELLSIZE: "單元格大小",
  T_46_META_WS_P_CELLSPACE: "單元格空間",
  T_46_META_WS_P_CENTER: "中心",
  T_46_META_WS_P_CENTERINVISIBLE: "隱藏中心",
  T_46_META_WS_P_CENTEROFFSET: "中心偏移",
  T_46_META_WS_P_CENTEROFMASS: "中心座標",
  T_46_META_WS_P_CENTERRANGE: "中心範圍",
  T_46_META_WS_P_CENTRALFLASHTIME: "中央閃光時間",
  T_46_META_WS_P_CENTRALLINEACTIVE: "中央線啟用",
  T_46_META_WS_P_CENTRALLINEPOSITION: "中央線位置",
  T_46_META_WS_P_CHANNELID: "聊天頻道實體 ID",
  T_46_META_WS_P_CHARGEMAX: "冰牆充能上限（矯正系數）",
  T_46_META_WS_P_CHASETARGET: "被AI追擊的對象",
  T_46_META_WS_P_CHATCHANNEL: "頻道實體",
  T_46_META_WS_P_CHECKPOINTID: "檢查點 ID",
  T_46_META_WS_P_CHILDINDEX: "在所屬父節點的第幾個孩子",
  T_46_META_WS_P_CHIPEXP: "凝膠生成器升級晶片提供經驗",
  T_46_META_WS_P_CLICKSIZE: "點擊區域",
  T_46_META_WS_P_CLIPLENGTH: "片段長度",
  T_46_META_WS_P_CLIPPINGTYPE: "剪裁类型",
  T_46_META_WS_P_COLLIDERID: "碰撞資源 ID",
  T_46_META_WS_P_CONSTRAIN: "剛體約束",
  T_46_META_WS_P_CONSTRAINT: "限制",
  T_46_META_WS_P_CONSTRAINTCOUNT: "限制數量",
  T_46_META_WS_P_CONSUMABLETYPE: "道具類型",
  T_46_META_WS_P_CONTENT: "內容",
  T_46_META_WS_P_CONTENTORIGIN: "初始方向",
  T_46_META_WS_P_CONTROLPOINTS: "ControlPoints",
  T_46_META_WS_P_COORDINATESYSTEM: "坐標系",
  T_46_META_WS_P_COUNT: "充能數量",
  T_46_META_WS_P_COUNTDOWNENDTIME: "倒計時結束時間 (秒)",
  T_46_META_WS_P_COUNTDOWNKEY: "倒計時 Key",
  T_46_META_WS_P_COUNTDOWNTIME: "倒計時長，以秒為單位",
  T_46_META_WS_P_COUNTPERWAVE: "每波生成數量",
  T_46_META_WS_P_CRASHMAXDAMAGE: "最高撞擊傷害",
  T_46_META_WS_P_CRASHMAXSPEED: "撞擊傷害速度上限",
  T_46_META_WS_P_CRASHMESSFACTOR: "撞擊質量參數",
  T_46_META_WS_P_CRASHMINDAMAGE: "最低撞擊傷害",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "爬行的移動速度縮放比",
  T_46_META_WS_P_CREATEDENTITY: "創建的實體",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "蹲下時移動速度的縮放比",
  T_46_META_WS_P_CSRANK: "CS 段位",
  "T_46_META_WS_P_CURRENT AMMO": "當前子彈數",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "當前播放的Emote動畫資源ID",
  T_46_META_WS_P_CURRENTCLIP: "當前動畫片段",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "當前動畫片段播放進度",
  T_46_META_WS_P_CURRENTDURABILITY: "當前耐久度",
  T_46_META_WS_P_CURRENTENERGY: "當前能量值",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "當前手持物品",
  T_46_META_WS_P_CURRENTHP: "生命值當前量",
  T_46_META_WS_P_CURRENTPHASEINDEX: "當前階段索引",
  T_46_META_WS_P_CURRENTPROGRESS: "當前進度",
  T_46_META_WS_P_CURRENTROUNDINDEX: "當前回合索引",
  T_46_META_WS_P_CURRENTSTATE: "當前動畫狀態",
  T_46_META_WS_P_CURRENTVALUE: "當前進度值",
  T_46_META_WS_P_CURRENTWAVE: "當前波數",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "預設玩家類型",
  T_46_META_WS_P_CUSTOMGAMERESULT: "自定義遊戲結果",
  T_46_META_WS_P_CUSTOMGRAVITY: "自訂重力",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "自訂推力",
  T_46_META_WS_P_CUSTOMXY: "XY 拖拽量",
  T_46_META_WS_P_DAMAGE: "傷害",
  "T_46_META_WS_P_DAMAGE RANGE": "炮塔範圍",
  T_46_META_WS_P_DAMAGEFACTOR: "傷害係數",
  T_46_META_WS_P_DAMAGEINTERVAL: "傷害時間間隔（秒）",
  T_46_META_WS_P_DAMAGERADIUS: "傷害半徑",
  T_46_META_WS_P_DAMAGERATIOHEAD: "頭部傷害系數變化",
  T_46_META_WS_P_DAMAGERATIOLIMB: "四肢傷害系數變化",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "傷害減免係數",
  T_46_META_WS_P_DAMAGETAKENPCT: "受到傷害百分比",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "承受的傷害百分比",
  T_46_META_WS_P_DAMAGEVALUE: "每次傷害量",
  T_46_META_WS_P_DARKNESS: "全局暗度",
  T_46_META_WS_P_DECELERATIONPERCENT: "減速百分比",
  T_46_META_WS_P_DEFAULTTEXT: "佔位文本內容",
  T_46_META_WS_P_DEFENSE: "防禦百分比",
  T_46_META_WS_P_DEFENSERATE: "防禦率",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "邏輯幀間隔",
  T_46_META_WS_P_DELTAVALUE: "變化值",
  T_46_META_WS_P_DEPTH: "Hud 層級",
  T_46_META_WS_P_DESC: "描述",
  T_46_META_WS_P_DESCRIPTION: "描述文本",
  T_46_META_WS_P_DESCRIPTIONKEY: "描述信息 Key",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "提示信息描述參數",
  T_46_META_WS_P_DESTVAL: "DestVal",
  T_46_META_WS_P_DETECTRANGE: "追擊範圍",
  T_46_META_WS_P_DIFFUSEALPHA: "表面透明度",
  T_46_META_WS_P_DIFFUSECOLOR: "表面貼圖顏色",
  T_46_META_WS_P_DIFFUSETEXTURE: "表面貼圖",
  T_46_META_WS_P_DISABLECOLOR: "禁用色",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "是否墜落時免傷",
  T_46_META_WS_P_DISABLEITEMDROP: "是否禁止丟棄物品",
  T_46_META_WS_P_DISABLEITEMPICKUP: "是否禁止拾取物品",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "禁用手動關閉",
  T_46_META_WS_P_DISABLEQUICKCHAT: "開關快捷聊天",
  T_46_META_WS_P_DISABLERECIPROCATING: "不使用往返運動",
  T_46_META_WS_P_DISABLEVOICECHAT: "開關語音聊天",
  T_46_META_WS_P_DISTANCE: "射線距離",
  T_46_META_WS_P_DOUBLEGUNTYPE: "雙持類型",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "倒地後爬行時移動速度的縮放比",
  T_46_META_WS_P_DOWNSPEED: "下降速度（力）",
  T_46_META_WS_P_DRAG: "移動阻力係數",
  T_46_META_WS_P_DRIVER: "駕駛者",
  T_46_META_WS_P_DROPITEMS: "空投箱攜帶物品",
  T_46_META_WS_P_DURABILITY: "耐久",
  T_46_META_WS_P_DURABILITYRECOVERY: "耐久恢復值",
  T_46_META_WS_P_DURATION: "持續時間",
  T_46_META_WS_P_EDGEFLASHTIME: "閃光彈命中效果開關",
  T_46_META_WS_P_EFFECTACTIVE: "顯示特效",
  T_46_META_WS_P_EFFECTCOLOR: "特效顏色",
  T_46_META_WS_P_EFFECTDURATION: "觸發時間",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "生效時間間隔",
  T_46_META_WS_P_EFFECTRESID: "資源路徑",
  T_46_META_WS_P_ENABLE: "啟用",
  T_46_META_WS_P_ENABLEATTACK: "是否開啟攻擊（為否時禁止攻擊）",
  T_46_META_WS_P_ENABLEBOTREVIVE: "是否復活（Bot）",
  T_46_META_WS_P_ENABLEDEPTHMAP: "深度圖開關",
  T_46_META_WS_P_ENABLEDROPONDEATH: "是否死亡時掉落",
  T_46_META_WS_P_ENABLELOCALIZATION: "本地化開關",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "空中是否可水平移動",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "是否復活（玩家）",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "開啟玩家視角",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "是否跟隨重力旋轉朝向",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "寫入武器塗裝對槍的屬性",
  T_46_META_WS_P_ENABLESWINGING: "開啟盪擺",
  T_46_META_WS_P_ENABLETRACTION: "開啟牽引",
  T_46_META_WS_P_ENDPOSITION: "終點位置",
  T_46_META_WS_P_ENDRADIUS: "結束半徑",
  T_46_META_WS_P_ENDTIME: "失效時間（秒）",
  T_46_META_WS_P_ENDTIMES: "结束时间",
  T_46_META_WS_P_ENDVALUE: "最終值",
  T_46_META_WS_P_ENERGY: "EP修改值",
  T_46_META_WS_P_ENERGYCOST: "每秒能量消耗",
  T_46_META_WS_P_ENERGYRECOVERY: "每秒恢復能量",
  T_46_META_WS_P_ENGINEHORSEPOWER: "引擎馬力",
  T_46_META_WS_P_ENGINETORQUE: "引擎馬力",
  T_46_META_WS_P_EP: "EP HUD 開關",
  T_46_META_WS_P_EPMAX: "EPMAX",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "能量（EP）恢復量",
  T_46_META_WS_P_EVENTS: "事件集合",
  T_46_META_WS_P_EXPLODEDAMAGE: "爆炸傷害",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "爆炸傷害減免係數",
  T_46_META_WS_P_EXPLODEDELAY: "爆炸延遲",
  T_46_META_WS_P_EXPLODERANGE: "爆炸範圍",
  T_46_META_WS_P_EXPLOSIONDELAY: "中心閃光時間",
  T_46_META_WS_P_EXPLOSIONRANGE: "爆炸範圍",
  T_46_META_WS_P_EXPLOSIONTIME: "爆炸延遲",
  T_46_META_WS_P_EXPPERDAMAGE: "每點傷害獲取經驗",
  T_46_META_WS_P_EXPPERMOVEMILE: "每移動一英里獲取經驗",
  T_46_META_WS_P_EXPPERSECOND: "每秒獲取經驗",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "額外背包空間",
  T_46_META_WS_P_EXTRABAGCAPACITY: "額外背包空間",
  T_46_META_WS_P_EXTRAHPRATIO: "玩家血量倍率",
  T_46_META_WS_P_FACEPAINT: "妝容",
  T_46_META_WS_P_FACTION: "陣營實體",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "掉落傷害比例",
  T_46_META_WS_P_FALLSPEED: "結束滑行下落速度",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "自動換彈速度",
  T_46_META_WS_P_FILEID: "內部 ID",
  T_46_META_WS_P_FILL: "填充",
  T_46_META_WS_P_FILLAMOUNT: "填充值",
  T_46_META_WS_P_FILLDIRECTION: "填充方向",
  T_46_META_WS_P_FILLTYPE: "填充類型",
  T_46_META_WS_P_FIREANGLELIMIT: "開火角度限制",
  T_46_META_WS_P_FIRETYPE: "開火類型",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "第一種得分值參數數組",
  T_46_META_WS_P_FIRSTSCORETITLE: "第一種得分標題文本 Key",
  T_46_META_WS_P_FIRSTSCOREVALUE: "第一種得分值 Key",
  T_46_META_WS_P_FIXEDDELTATIME: "固定幀更新間隔",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "特效持續時間",
  T_46_META_WS_P_FLIP: "翻轉",
  T_46_META_WS_P_FLIPTYPE: "翻轉類型",
  T_46_META_WS_P_FLYMAXHEIGHT: "最大飛行高度",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "滑行速度",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "滑行下降速度",
  T_46_META_WS_P_FOGCOLOR: "雾氣顏色",
  T_46_META_WS_P_FOLLOWTARGET: "跟隨的目標實體",
  T_46_META_WS_P_FONT: "字體",
  T_46_META_WS_P_FONTSIZE: "字體大小",
  T_46_META_WS_P_FONTSTYLE: "字體風格",
  T_46_META_WS_P_FONTTYPE: "字體",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "強制同步至客戶端",
  T_46_META_WS_P_FORWARD: "前方",
  T_46_META_WS_P_FORWARDSPEED: "前進速度（力）",
  T_46_META_WS_P_FOV: "視角",
  T_46_META_WS_P_FREEZEDURATION: "冰凍時間 (秒)",
  T_46_META_WS_P_FRIENDFACTIONS: "友好陣營",
  T_46_META_WS_P_FRIENDLYPLAYERS: "友善玩家",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "滿傷害距離",
  T_46_META_WS_P_FUNCTIONTYPE: "功能類型",
  T_46_META_WS_P_GAINHPCOLOR: "增加生命值顏色",
  T_46_META_WS_P_GAMEFRAMECOUNT: "累計運行幀",
  T_46_META_WS_P_GAMETIMECOUNT: "遊戲時間",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "檔位切換延遲",
  T_46_META_WS_P_GENDER: "性別",
  T_46_META_WS_P_GETONBOOSTCD: "上滑板後衝刺CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "上滑板後衝刺CD開關",
  T_46_META_WS_P_GETONSKATEBOARDCD: "上滑板CD",
  T_46_META_WS_P_GRADIENT: "漸變",
  T_46_META_WS_P_GRADIENTBOTTOM: "底部漸變色",
  T_46_META_WS_P_GRADIENTTOP: "頂部漸變色",
  T_46_META_WS_P_GRAVITY: "重力",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "載具導彈最大傷害",
  T_46_META_WS_P_GRENADEMINDAMAGE: "載具導彈最小傷害",
  T_46_META_WS_P_GRENADERANGE: "載具導彈範圍",
  T_46_META_WS_P_GROUPID: "GroupID",
  T_46_META_WS_P_HEAD: "頭飾",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "頭部傷害系數",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "爆頭減傷率",
  T_46_META_WS_P_HEIGHT: "高度",
  T_46_META_WS_P_HELMET: "当前頭盔",
  T_46_META_WS_P_HIGHESTBRRANK: "BR 巔峰段位",
  T_46_META_WS_P_HIGHESTCSRANK: "CS 巔峰段位",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "高射最小角度",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "高速轉向限制",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "高速轉向限制速度閾值",
  T_46_META_WS_P_HITPOINTEFFECT: "目標點對象",
  T_46_META_WS_P_HORIZONTALBAR: "水平顯示類型",
  T_46_META_WS_P_HORIZONTALOFFSET: "水平方向偏移量",
  T_46_META_WS_P_HOSTILETEAMS: "敵對隊伍",
  T_46_META_WS_P_HOSTTEAM: "所屬隊伍",
  T_46_META_WS_P_HP: "當前血量",
  T_46_META_WS_P_HPMAX: "炮塔最大生命值",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "生命恢復量",
  T_46_META_WS_P_HPRECOVERYSPEED: "血量恢復速度（毫秒）",
  T_46_META_WS_P_ICON: "圖示",
  T_46_META_WS_P_ICONCOLOR: "圖示顏色",
  T_46_META_WS_P_ICONNAME: "圖示名稱",
  T_46_META_WS_P_ICONRESOURCE: "資源路徑",
  T_46_META_WS_P_ID: "編號",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "炮塔攻擊間隔 (秒)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "無操控停車馬力比例",
  T_46_META_WS_P_INACTIVATEDALPHA: "未激活透明度",
  T_46_META_WS_P_INDEX: "索引",
  T_46_META_WS_P_INITIALMAGCOUNT: "初始彈夾數量",
  T_46_META_WS_P_INITIALSPEED: "初速度",
  T_46_META_WS_P_INITIALVALUE: "初始值 [0, 1]（瞬切）",
  T_46_META_WS_P_INITIALWORLDPOSITION: "初始世界坐標",
  T_46_META_WS_P_INSCENE: "在場景中",
  T_46_META_WS_P_INSTANCEID: "實例ID",
  T_46_META_WS_P_INTENSITY: "光照強度",
  T_46_META_WS_P_INVERTFILL: "反向填充",
  T_46_META_WS_P_INVINCIBLE: "無敵",
  "T_46_META_WS_P_IS SHOW": "是否顯示觸發器",
  T_46_META_WS_P_IS3D: "是否3D",
  T_46_META_WS_P_ISACE: "是否團滅",
  T_46_META_WS_P_ISACED: "是否團滅",
  T_46_META_WS_P_ISAI: "是否是AI",
  T_46_META_WS_P_ISALWAYSINSCREEN: "總在螢幕內",
  T_46_META_WS_P_ISAPPLYSHADOW: "投影",
  T_46_META_WS_P_ISATTACKABLE: "是否可被攻擊",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "是否自動追擊敵人",
  T_46_META_WS_P_ISAUTOPLAY: "自動播放",
  T_46_META_WS_P_ISAUTOTELEPORT: "是否是自動傳送",
  T_46_META_WS_P_ISBILLBOARD: "總是面向攝像機",
  T_46_META_WS_P_ISBOLD: "加粗",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "底部是否發生了觸碰",
  T_46_META_WS_P_ISCENTERPOS: "是否使用中心點播放",
  T_46_META_WS_P_ISCONSUMEAMMO: "是否消耗彈藥",
  T_46_META_WS_P_ISCONTINUOUS: "是否是連續生成",
  T_46_META_WS_P_ISCOUNTDOWN: "是否為倒計時",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "當前播放的Emote動畫是否循環",
  T_46_META_WS_P_ISDEADDROP: "是否支持死亡掉落",
  T_46_META_WS_P_ISDEATHTRIGGER: "是否為死亡觸發器",
  T_46_META_WS_P_ISDEBUG: "啟用 B 樹調試",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "是否是默認出生點",
  T_46_META_WS_P_ISDROPONELIMINATED: "死亡時遺失所有裝備",
  T_46_META_WS_P_ISEND: "isEnd",
  T_46_META_WS_P_ISFEBUTTON: "是否是 FE 的按鈕",
  T_46_META_WS_P_ISGREY: "按鈕變灰",
  T_46_META_WS_P_ISGROUNDED: "是否著地",
  T_46_META_WS_P_ISIGNOREDEPTH: "是否忽略深度",
  T_46_META_WS_P_ISINVINCIBLE: "無敵狀態",
  T_46_META_WS_P_ISITALIC: "斜體",
  T_46_META_WS_P_ISLASTROUND: "是否最終回合",
  T_46_META_WS_P_ISLOCALPOS: "啟用偏移坐標局部坐標系",
  T_46_META_WS_P_ISLOOP: "是否循環",
  T_46_META_WS_P_ISMATCHPOINT: "是否決勝局",
  T_46_META_WS_P_ISMOVEABLE: "是否允許移動",
  T_46_META_WS_P_ISOCCUPIED: "是否已被佔用",
  T_46_META_WS_P_ISOPENTWEEN: "啟用生命值變化效果",
  T_46_META_WS_P_ISPLAYING: "是否正在播放",
  T_46_META_WS_P_ISPURCHASABLE: "能否購買",
  T_46_META_WS_P_ISREVERSE: "反轉",
  T_46_META_WS_P_ISSERVERDRIVEN: "是否由伺服器驅動",
  T_46_META_WS_P_ISSHOW: "是否顯示觸發器",
  T_46_META_WS_P_ISSHOWHUDNAME: "是否顯示 HudName",
  T_46_META_WS_P_ISSHOWMAPINFO: "是否顯示 MapInfo",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "是否顯示快速消息",
  T_46_META_WS_P_ISSHOWSCAN: "是否顯示 Scan",
  T_46_META_WS_P_ISSHOWTAG: "是否顯示 Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "側邊是否發生了觸碰",
  T_46_META_WS_P_ISSILENCE: "是否消音",
  T_46_META_WS_P_ISSINGLESHOT: "是否單發",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "跳過墜落時的僵直動畫",
  T_46_META_WS_P_ISSLIDING: "是否正在滑落",
  T_46_META_WS_P_ISTOPCOLLIDING: "上部是否發生了觸碰",
  T_46_META_WS_P_ISUNDERLINE: "下劃線",
  T_46_META_WS_P_ISVISIBLE: "是否可見",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "卡牌背景顏色數組",
  T_46_META_WS_P_ITEMBACKGROUNDS: "卡牌背景 Sprite 數組",
  T_46_META_WS_P_ITEMCOUNTS: "商品數量列表",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "卡牌描述數組",
  T_46_META_WS_P_ITEMICONS: "卡牌 Icon Sprite 數組",
  T_46_META_WS_P_ITEMID: "武器對應的道具id",
  T_46_META_WS_P_ITEMIDS: "物品 ID",
  T_46_META_WS_P_ITEMNAMES: "卡牌名字數組",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "禁止拾取物品列表",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "操縱桿拖拽半徑",
  T_46_META_WS_P_JOYSTICKIMAGE: "操縱桿圖片",
  T_46_META_WS_P_JOYSTICKRADIUS: "操縱桿半徑",
  T_46_META_WS_P_JUMPCD: "跳躍CD",
  T_46_META_WS_P_JUMPHEIGHT: "跳躍高度",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "跳躍高度縮放比",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "對倒地玩家傷害偏移",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "擊倒設置",
  T_46_META_WS_P_LABEL: "文本內容",
  T_46_META_WS_P_LABELCOLOR: "文本顏色",
  T_46_META_WS_P_LABELKEY: "文本內容 Key",
  T_46_META_WS_P_LABELPARAMS: "文本內容參數數組",
  T_46_META_WS_P_LASTCHECKPOINTID: "當前檢查點ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "存活時間",
  T_46_META_WS_P_LAYERTYPE: "層級",
  T_46_META_WS_P_LAYOUTTYPE: "布局类型",
  T_46_META_WS_P_LEFTARM: "左臂",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "左邊背景顏色",
  T_46_META_WS_P_LEFTCOLOR: "左邊顏色",
  T_46_META_WS_P_LEFTDESCRIPTION: "左邊隊伍描述",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "是否顯示左側特效",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "左側射界角度",
  T_46_META_WS_P_LEFTFOOT: "左腳",
  T_46_META_WS_P_LEFTHAND: "左手",
  T_46_META_WS_P_LEFTICON: "左側圖標",
  T_46_META_WS_P_LEFTICONNAME: "左邊圖示名稱",
  T_46_META_WS_P_LEFTLEG: "左腿",
  T_46_META_WS_P_LEFTPLAYERS: "左邊玩家數組",
  T_46_META_WS_P_LEFTSCORE: "左側得分",
  T_46_META_WS_P_LEFTSCOREAFTER: "左側最後得分",
  T_46_META_WS_P_LEFTSCORETEXT: "左側得分文本",
  T_46_META_WS_P_LEFTTEAM: "左邊隊伍/陣營",
  T_46_META_WS_P_LEFTTEAMINDEX: "左邊隊伍索引",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "左邊隊員存活數",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "左邊隊員旗子數",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "左邊隊員狀態數組",
  T_46_META_WS_P_LEFTTEAMNAME: "左邊隊伍名",
  T_46_META_WS_P_LEFTTEAMSCORE: "左邊隊伍得分",
  T_46_META_WS_P_LEFTTEXT: "左側文本",
  T_46_META_WS_P_LENGTH: "HUD 長度",
  T_46_META_WS_P_LENSFLARE: "光暈強度",
  T_46_META_WS_P_LEVEL: "當前等級",
  T_46_META_WS_P_LIFETIME: "炮塔持續時間 (秒)",
  T_46_META_WS_P_LIGHTCOLOR: "主光源顏色",
  T_46_META_WS_P_LIGHTINTENSITY: "主光源強度",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "四肢傷害系數",
  T_46_META_WS_P_LINESPACING: "行間距",
  T_46_META_WS_P_LOCALPOSITION: "相對位置",
  T_46_META_WS_P_LOCALROTATION: "本地旋轉",
  T_46_META_WS_P_LOCALROTATIONQ: "本地旋轉四元數",
  T_46_META_WS_P_LOCALSCALE: "本地縮放大小，默認為1",
  T_46_META_WS_P_LOCKEY: "本地化 Key",
  T_46_META_WS_P_LOOPCOUNT: "循環次數",
  T_46_META_WS_P_LOOTSOCCER: "Loot足球點",
  T_46_META_WS_P_LOSEHPCOLOR: "失去生命值顏色",
  T_46_META_WS_P_LOSEMVPS: "失敗 MVP 列表",
  T_46_META_WS_P_LOSETEXT: "失敗提示文本",
  "T_46_META_WS_P_MAIN CAMERA": "主相機",
  T_46_META_WS_P_MAINCOLOR: "主要顏色",
  T_46_META_WS_P_MAINSCORELIST: "總積分列表",
  T_46_META_WS_P_MAINSCORETITLE: "總積分名",
  T_46_META_WS_P_MAINWEAPON: "當前主武器",
  T_46_META_WS_P_MAPSIZE: "地圖尺寸大小",
  T_46_META_WS_P_MASK: "臉飾",
  T_46_META_WS_P_MASKNAME: "掩码名称",
  T_46_META_WS_P_MASS: "質量 (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "對局標題 1",
  T_46_META_WS_P_MATCHTITLERIGHT: "對局標題 2",
  T_46_META_WS_P_MAXCAPACITY: "空間",
  T_46_META_WS_P_MAXCOUNT: "最大數量",
  T_46_META_WS_P_MAXDAMAGE: "最大傷害",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "最大俯角",
  T_46_META_WS_P_MAXDISPLACEMENT: "最大位移",
  T_46_META_WS_P_MAXDISTANCE: "最大距離",
  T_46_META_WS_P_MAXDURABILITY: "最大耐久度",
  T_46_META_WS_P_MAXDURABILITYRATIO: "耐久上限倍率",
  T_46_META_WS_P_MAXENERGY: "最大能量",
  T_46_META_WS_P_MAXEP: "總能量值",
  T_46_META_WS_P_MAXHP: "最大血量",
  T_46_META_WS_P_MAXJUMPCOUNT: "最大連續跳躍次數",
  T_46_META_WS_P_MAXJUMPHEIGHT: "二段跳最大跳躍高度",
  T_46_META_WS_P_MAXLENGTH: "最大長度",
  T_46_META_WS_P_MAXPROGRESS: "最大進度",
  T_46_META_WS_P_MAXSCATTERRATIO: "最大擴散比率",
  T_46_META_WS_P_MAXSPEED: "最大絕對運動速度",
  T_46_META_WS_P_MAXTURRETCOUNT: "最大炮塔數量",
  T_46_META_WS_P_MAXVALUE: "最大數值",
  T_46_META_WS_P_MAXWIDGETID: "當前最大 WidgetID",
  T_46_META_WS_P_MINDAMAGE: "最小傷害",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "最小傷害開始距離",
  T_46_META_WS_P_MINDISTANCE: "最小距離",
  T_46_META_WS_P_MINELEVATIONANGLE: "最小仰角",
  T_46_META_WS_P_MINENDHEIGHT: "最小結束高度",
  T_46_META_WS_P_MINFLYHEIGHT: "最小起飛高度",
  T_46_META_WS_P_MINMOVEDISTANCE: "最小移動距離",
  T_46_META_WS_P_MINVALUE: "最小值",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "飛彈最大傷害",
  T_46_META_WS_P_MISSILEMINDAMAGE: "飛彈最小傷害",
  T_46_META_WS_P_MISSILERANGE: "飛彈範圍",
  T_46_META_WS_P_MODEL: "外觀類型",
  T_46_META_WS_P_MODELVISIBILITY: "模型顯隱",
  T_46_META_WS_P_MODELVISIBLE: "模型顯隱",
  T_46_META_WS_P_MONEY: "貨幣",
  T_46_META_WS_P_MONEYLIST: "貨幣列表",
  T_46_META_WS_P_MONEYS: "貨幣",
  T_46_META_WS_P_MONEYTYPE: "貨幣類型",
  T_46_META_WS_P_MONSTERTYPE: "怪物類型",
  T_46_META_WS_P_MOTIONTYPE: "運動方式",
  T_46_META_WS_P_MOTIONVALUEX: "X 軸方向的增量",
  T_46_META_WS_P_MOTIONVALUEY: "Y 軸方向的增量",
  T_46_META_WS_P_MOTIONVALUEZ: "Z 軸方向的增量",
  T_46_META_WS_P_MOVEMENTDURATION: "移動時長",
  T_46_META_WS_P_MULTIPLIER: "連乘器",
  T_46_META_WS_P_MUSICELEMENTTYPE: "音樂類型",
  T_46_META_WS_P_MUZZLEVELOCITY: "出膛速度",
  T_46_META_WS_P_MVP: "MVP 玩家暱稱",
  T_46_META_WS_P_NAME: "物件名字",
  T_46_META_WS_P_NEXTROUNDINDEX: "下回合 Index",
  T_46_META_WS_P_NICKNAME: "暱稱",
  T_46_META_WS_P_NORMALCOLOR: "常規顏色",
  T_46_META_WS_P_NORMALIZEDPOSITION: "HUD位置",
  T_46_META_WS_P_NUMBERINFACTION: "玩家在陣營中的序號",
  T_46_META_WS_P_OBJECTID: "名字拼接對象編號",
  T_46_META_WS_P_OFFSET: "偏移",
  T_46_META_WS_P_OPTIONS: "選項",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "其他傷害系數",
  T_46_META_WS_P_OUTFIT: "玩家服飾",
  T_46_META_WS_P_OVERFLOW: "文本溢出",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "超高之後的下落速度",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "玩家配置優先",
  T_46_META_WS_P_OWNER: "所有者",
  T_46_META_WS_P_PARAMS: "信息提示描述參數數組",
  T_46_META_WS_P_PARENT: "父節點實體",
  T_46_META_WS_P_PARENTID: "父節點控件 EntityID",
  T_46_META_WS_P_PARENTUI: "所屬 UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "父級小部件Entity ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "父節點控件 FileID",
  T_46_META_WS_P_PARTMASKA: "部件顯示掩碼1",
  T_46_META_WS_P_PASSENGERS: "乘客",
  T_46_META_WS_P_PATHID: "路徑的場景物件ID",
  T_46_META_WS_P_PAUSEEVENT: "暫停事件",
  T_46_META_WS_P_PERSONAID: "智能體 ID",
  T_46_META_WS_P_PHASEDURATION: "持續時間 (ms)",
  T_46_META_WS_P_PHASEENDTIME: "結束時間 (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "物理層級",
  T_46_META_WS_P_PINID: "紀念章 ID",
  T_46_META_WS_P_PITCH: "俯仰角",
  T_46_META_WS_P_PIVOT: "支點",
  T_46_META_WS_P_PLAYER: "當前綁定的玩家",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "開鏡移動速度修正系數",
  T_46_META_WS_P_PLAYERLIST: "玩家列表",
  T_46_META_WS_P_PLAYERNAME: "名稱",
  T_46_META_WS_P_PLAYERRANK: "玩家排名",
  T_46_META_WS_P_PLAYERRANKS: "玩家排行數組",
  T_46_META_WS_P_PLAYERS: "玩家列表",
  T_46_META_WS_P_PLAYERSCORETYPES: "玩家積分類型數組",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "影響玩家移速係數",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "攻擊時的玩家速度係數",
  T_46_META_WS_P_PLAYERSTATUS: "玩家狀態",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "牽引玩家速讀",
  T_46_META_WS_P_PLAYINGSTATUS: "播放狀態",
  T_46_META_WS_P_PLAYSPEED: "播放速度",
  T_46_META_WS_P_POINTPOSITION: "點位置",
  T_46_META_WS_P_POINTS: "積分",
  T_46_META_WS_P_POSITION: "位置",
  T_46_META_WS_P_PREFABID: "模板 ID",
  T_46_META_WS_P_PRESSEDCOLOR: "按壓色",
  T_46_META_WS_P_PRESSEDSPRITE: "按下圖片",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "按下圖片類型",
  T_46_META_WS_P_PRICE: "價格",
  T_46_META_WS_P_PRIORITY: "優先級",
  T_46_META_WS_P_PROFILEINFO: "玩家名片",
  T_46_META_WS_P_PROGRESS: "進度 [0,1]",
  T_46_META_WS_P_PROGRESSICON: "進度圖示",
  T_46_META_WS_P_PROGRESSICONNAME: "進度圖示名",
  T_46_META_WS_P_PROPID: "屬性 ID",
  T_46_META_WS_P_PURCHASELIMIT: "限購數量",
  T_46_META_WS_P_RADIUS: "半徑",
  T_46_META_WS_P_RANGE: "光照範圍",
  T_46_META_WS_P_RANK: "排名",
  T_46_META_WS_P_RATIOSELFFACTOR: "自己傷害系數",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "隊友傷害系數",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "車輛傷害系數",
  T_46_META_WS_P_REFRESHTIME: "Buff 刷新時間 (秒)",
  T_46_META_WS_P_RELOADSPEED: "換彈夾速度",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "換彈速度係數",
  T_46_META_WS_P_REMAINJUMPCOUNT: "剩餘可連續跳躍次數",
  T_46_META_WS_P_REMAINQUANTITY: "當前數量",
  T_46_META_WS_P_RENDERTYPE: "顯示方式",
  T_46_META_WS_P_REPEATTIMES: "播放次數",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "替換優先級",
  T_46_META_WS_P_REQUESTEDITEMLIST: "被請求的物品列表",
  T_46_META_WS_P_REQUESTTYPE: "請求類型",
  T_46_META_WS_P_RESETPERROUND: "每回合重置",
  T_46_META_WS_P_RESETPOSITION: "復位位置",
  T_46_META_WS_P_RESETTIME: "復位時間",
  T_46_META_WS_P_RESOURCE: "資源",
  T_46_META_WS_P_RESOURCEID: "資源UUID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "限制內容在視口內",
  T_46_META_WS_P_RESULT: "勝敗平",
  T_46_META_WS_P_RESULTTYPE: "顯示結果",
  T_46_META_WS_P_REVIVALPOINT: "復活點",
  T_46_META_WS_P_REVIVECD: "復活時長",
  T_46_META_WS_P_RIGHT: "右方",
  T_46_META_WS_P_RIGHTARM: "右臂",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "右邊背景顏色",
  T_46_META_WS_P_RIGHTCOLOR: "右邊顏色",
  T_46_META_WS_P_RIGHTDESCRIPTION: "右邊隊伍描述",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "是否顯示右側特效",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "右側射界角度",
  T_46_META_WS_P_RIGHTFOOT: "右腳",
  T_46_META_WS_P_RIGHTHAND: "右手",
  T_46_META_WS_P_RIGHTICON: "右側圖標",
  T_46_META_WS_P_RIGHTICONNAME: "右邊圖示名稱",
  T_46_META_WS_P_RIGHTLEG: "右腿",
  T_46_META_WS_P_RIGHTPLAYERS: "右邊玩家數組",
  T_46_META_WS_P_RIGHTSCORE: "右側得分",
  T_46_META_WS_P_RIGHTSCOREAFTER: "右側最後得分",
  T_46_META_WS_P_RIGHTSCORETEXT: "右側得分文本",
  T_46_META_WS_P_RIGHTTEAM: "右邊隊伍/陣營",
  T_46_META_WS_P_RIGHTTEAMINDEX: "右邊隊伍索引",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "右邊隊員存活數",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "右邊隊員旗子數",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "右邊隊員狀態數組",
  T_46_META_WS_P_RIGHTTEAMNAME: "右邊隊伍名",
  T_46_META_WS_P_RIGHTTEAMSCORE: "右邊隊伍得分",
  T_46_META_WS_P_RIGHTTEXT: "右側文本",
  T_46_META_WS_P_RIMALPHA: "邊緣透明度",
  T_46_META_WS_P_RIMCOLOR: "邊緣顏色",
  T_46_META_WS_P_RIMTEXTURE: "邊界材質",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "滾動摩擦係數",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "滾動摩擦係數(衝擊)",
  T_46_META_WS_P_ROTATION: "旋轉",
  T_46_META_WS_P_ROTATIONANGLE: "旋轉角度",
  T_46_META_WS_P_ROTATIONQ: "旋轉四元數",
  T_46_META_WS_P_ROUNDINCOME: "回合收入數值",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "回合收入詳情數據",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "回合收入詳情標題",
  T_46_META_WS_P_ROUNDINCOMETITLE: "回合收入標題",
  T_46_META_WS_P_ROUNDNUM: "第幾回合",
  T_46_META_WS_P_ROUNDNUMKEY: "回合數文本 Key",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "回合數參數數組",
  T_46_META_WS_P_RUNSPEED: "行動速度",
  T_46_META_WS_P_RUNSPEEDSCALE: "移動速度縮放比",
  T_46_META_WS_P_RUSHDISTANCE: "衝刺距離",
  T_46_META_WS_P_RUSHENERGYCOST: "每秒衝刺能量消耗",
  T_46_META_WS_P_RUSHVERTICALSPEED: "上衝垂直速度",
  T_46_META_WS_P_SCALE: "縮放",
  T_46_META_WS_P_SCATTERINCREASESPEED: "擴散增加速度",
  T_46_META_WS_P_SCATTERMAX: "最大擴散值",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "移動時的擴散倍數",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "擴散恢復速度",
  T_46_META_WS_P_SCATTERSPEED: "擴散速度",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "蹲下或匍匐時的擴散速度",
  T_46_META_WS_P_SCATTERTHRESHOLD: "擴散閾值",
  T_46_META_WS_P_SCOPETYPE: "倍鏡類型",
  T_46_META_WS_P_SCORE: "積分數",
  T_46_META_WS_P_SCORES1: "積分列表 1",
  T_46_META_WS_P_SCORES2: "積分列表 2",
  T_46_META_WS_P_SCORES3: "積分列表 3",
  T_46_META_WS_P_SCORES4: "積分列表 4",
  T_46_META_WS_P_SCORES5: "積分列表 5",
  T_46_META_WS_P_SCORETEXTKEY: "得分文本 Key",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "得分文本參數數組",
  T_46_META_WS_P_SCROLLCONTINUITY: "慣性因子",
  T_46_META_WS_P_SCROLLDIRECTION: "滾動方向",
  T_46_META_WS_P_SCROLLEFFECT: "拖動效果",
  T_46_META_WS_P_SCROLLWHEELSPEED: "滾輪因子",
  T_46_META_WS_P_SECONDSCORETITLE: "第二種得分標題文本 Key",
  T_46_META_WS_P_SECONDSCOREVALUE: "第二種得分值 Key",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "第二種得分值參數數組",
  T_46_META_WS_P_SELECTEDCOLOR: "選中圖片顏色",
  T_46_META_WS_P_SELECTEDINDEX: "選擇 Item 的索引",
  T_46_META_WS_P_SELECTEDSPRITE: "選中圖片",
  T_46_META_WS_P_SELECTEDTYPE: "選中圖片填充類型",
  T_46_META_WS_P_SELF: "自身實體",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "自我傷害係數",
  T_46_META_WS_P_SET: "連體衣",
  T_46_META_WS_P_SHADERNAME: "Shader 名稱",
  T_46_META_WS_P_SHADOWCOLOR: "投影顏色",
  T_46_META_WS_P_SHADOWOFFSET: "投影偏移量",
  T_46_META_WS_P_SHADOWSTRENGTH: "陰影暗度",
  T_46_META_WS_P_SHELFS: "貨架列表",
  T_46_META_WS_P_SHOES: "鞋",
  T_46_META_WS_P_SHOOTANGLEMAX: "射門最大角度",
  T_46_META_WS_P_SHOOTANGLEMIN: "最小射門角度",
  T_46_META_WS_P_SHOP: "商店",
  T_46_META_WS_P_SHOPITEMS: "商品列表",
  T_46_META_WS_P_SHOWADDFRIEND: "顯示加好友",
  T_46_META_WS_P_SHOWATTACKGRENADE: "攻擊投擲物 HUD 開關",
  T_46_META_WS_P_SHOWBACKGROUND: "顯示背景",
  T_46_META_WS_P_SHOWCROUCH: "蹲下 HUD 開關",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "顯示傷害數字",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "防禦投擲物 HUD 開關",
  T_46_META_WS_P_SHOWECCONOMY: "顯示局外經濟",
  T_46_META_WS_P_SHOWECONOMY: "顯示局外經濟",
  T_46_META_WS_P_SHOWFIRE: "開火 HUD 開關",
  T_46_META_WS_P_SHOWFRAME: "顯示邊框",
  T_46_META_WS_P_SHOWGIFT: "顯示送禮",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "顯示目標點對象",
  T_46_META_WS_P_SHOWJUMP: "跳 HUD 開關",
  T_46_META_WS_P_SHOWLIKE: "顯示點讚",
  T_46_META_WS_P_SHOWLOBBY: "顯示回到大廳",
  T_46_META_WS_P_SHOWMAPEVALUATE: "顯示地圖評價",
  T_46_META_WS_P_SHOWMATCHDETAIL: "顯示對局詳情",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "移動搖桿 HUD 開關",
  T_46_META_WS_P_SHOWNAME: "顯示暱稱",
  T_46_META_WS_P_SHOWPIN: "顯示紀念章",
  T_46_META_WS_P_SHOWPRONE: "爬行 HUD 開關",
  T_46_META_WS_P_SHOWRANK: "顯示段位",
  T_46_META_WS_P_SHOWREPLAY: "顯示回放",
  T_46_META_WS_P_SHOWREPORT: "顯示舉報",
  T_46_META_WS_P_SHOWSHARE: "顯示分享",
  T_46_META_WS_P_SHOWSPRINT: "疾跑 HUD 開關",
  T_46_META_WS_P_SHOWTAG: "是否顯示隊伍或陣營的標記點",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "隊友信息 HUD 開關",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "顯示隊員狀態",
  T_46_META_WS_P_SHOWTEAMSCORE: "顯示隊伍比分",
  T_46_META_WS_P_SHOWTIMETYPE: "顯示結果",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "顯示2個隊伍比分",
  T_46_META_WS_P_SHRINKDURATION: "縮圈用時（毫秒）",
  T_46_META_WS_P_SHRINKENDTIME: "縮圈結束時間（毫秒）",
  T_46_META_WS_P_SHRINKSPEED: "收斂速度",
  T_46_META_WS_P_SHRINKSTARTTIME: "縮圈開始時間（秒）",
  T_46_META_WS_P_SIGHTAIMASSIST: "允許開鏡時輔助瞄準",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "瞄準輔助距離衰減係數(0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "瞄準輔助距離優先影響係數(>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "瞄準輔助距離優先最大距離",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "瞄準輔助距離優先最小距離",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "允許輔助瞄準距離優先",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "瞄準輔助準星螢幕範圍吸引比率（0-1）",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "瞄準鏡名義放大倍率",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV放大倍率",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS 旋轉靈敏度",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS 最小傷害距離校正係數 X",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS 放大時間 (秒)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS 放大倍率",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS 恢復時間 (秒)",
  T_46_META_WS_P_SIZE: "尺寸大小",
  T_46_META_WS_P_SIZEDELTA: "與錨框尺寸差",
  T_46_META_WS_P_SKELETON: "骨骼",
  T_46_META_WS_P_SKIN: "塗裝",
  T_46_META_WS_P_SKINID: "外觀 ID",
  T_46_META_WS_P_SKINWIDTH: "塗裝厚度",
  T_46_META_WS_P_SKYBOXENV: "天空盒",
  T_46_META_WS_P_SKYBOXRESOURCE: "基礎天空盒資源",
  T_46_META_WS_P_SLOPELIMIT: "最大上坡角度",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "開始滾動時緩動",
  T_46_META_WS_P_SOFTNESS: "柔软度",
  T_46_META_WS_P_SORTTYPE: "排序方式",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "每波生成數量",
  T_46_META_WS_P_SPAWNPOINT: "出生點",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "出生點個數",
  T_46_META_WS_P_SPAWNPOSITION: "出生點坐標",
  T_46_META_WS_P_SPEED: "速度",
  T_46_META_WS_P_SPEEDWHILEAIMING: "ADS 移動速度比率",
  T_46_META_WS_P_SPRAYCOLOR: "噴漆顏色",
  T_46_META_WS_P_SPRINTENERGYCOST: "每秒快跑能量消耗",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "快跑水平速度",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "冲刺時移動速度的縮放比",
  T_46_META_WS_P_SPRITENAME: "圖片形狀",
  T_46_META_WS_P_SPRITERESOURCE: "圖片形狀",
  T_46_META_WS_P_SRCVAL: "SrcVal",
  T_46_META_WS_P_STARTDROPTIME: "空投箱掉落時間（毫秒）",
  T_46_META_WS_P_STARTEVENT: "開始事件",
  T_46_META_WS_P_STARTPOSITION: "起始位置",
  T_46_META_WS_P_STARTRADIUS: "開始半徑",
  T_46_META_WS_P_STARTSPAWNTIME: "開始生成時間 (秒)",
  T_46_META_WS_P_STARTTIME: "開始時間 (秒)",
  T_46_META_WS_P_STARTVALUE: "初始值",
  T_46_META_WS_P_STATICICONCOLORS: "在某刻度上顯示的圖標疊加色",
  T_46_META_WS_P_STATICICONS: "在某刻度上顯示的圖標樣式",
  T_46_META_WS_P_STATUS: "防禦塔狀態",
  T_46_META_WS_P_STEPOFFSET: "步距垂直偏移",
  T_46_META_WS_P_STOPDURATION: "停止時長",
  T_46_META_WS_P_STOPEVENT: "停止事件",
  T_46_META_WS_P_STORE: "商店",
  T_46_META_WS_P_STROPID: "StropID",
  T_46_META_WS_P_STYLE: "樣式",
  T_46_META_WS_P_SUBTITLE: "副標題",
  T_46_META_WS_P_SUMMULTIPLIER: "乘法累加器",
  T_46_META_WS_P_SWINGEXITACCELERATION: "離開盪擺的加速度",
  T_46_META_WS_P_SWINGINGSPEED: "盪擺速度",
  T_46_META_WS_P_TAGS: "標籤列表",
  T_46_META_WS_P_TARGETCHECKPOINTID: "目標檢查點ID",
  T_46_META_WS_P_TARGETICONCOLORS: "標記目標顯示的圖標的疊加色",
  T_46_META_WS_P_TARGETICONS: "標記目標顯示的圖標樣式",
  T_46_META_WS_P_TARGETID: "目標實體 ID",
  T_46_META_WS_P_TARGETITEMID: "模仿的目標物品 ID，參照 SceneEditPrefab 中的第一列",
  T_46_META_WS_P_TARGETROTATION: "模仿的目標的朝向",
  T_46_META_WS_P_TARGETSCALE: "模仿的目標的縮放",
  T_46_META_WS_P_TEAMCOLOR: "隊伍顏色",
  T_46_META_WS_P_TEAMCOLORS: "隊伍顏色數組",
  T_46_META_WS_P_TEAMINDEXS: "隊伍索引數組",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "隊友傷害係數",
  T_46_META_WS_P_TEAMMEMBERNUM: "隊伍成員數",
  T_46_META_WS_P_TEAMNUM: "隊伍數",
  T_46_META_WS_P_TEAMRANK: "隊伍/陣營排名",
  T_46_META_WS_P_TEAMRANKDISPLAY: "隊伍名次顯示",
  T_46_META_WS_P_TEAMRANKS: "隊伍排行數組",
  T_46_META_WS_P_TEAMSCORES: "隊伍得分數組",
  T_46_META_WS_P_TEAMSEQ: "隊伍索引",
  T_46_META_WS_P_TEMPLATEENTITY: "模板實體",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "臨時護盾值",
  T_46_META_WS_P_TERRAINWETNESS: "地面濕度",
  T_46_META_WS_P_TEXT: "提示文字",
  T_46_META_WS_P_TEXTCOLOR: "提示文字顏色",
  T_46_META_WS_P_TEXTKEY: "文本 key",
  T_46_META_WS_P_TEXTKEYPARAMS: "文本 key 對應的參數",
  T_46_META_WS_P_TEXTURERESOURCE: "Texture 名稱",
  T_46_META_WS_P_THEMECOLOR: "主題顏色",
  T_46_META_WS_P_THROWABLETYPE: "投擲物類型",
  T_46_META_WS_P_THROWINGSPEED: "投擲速度",
  T_46_META_WS_P_THROWSPEED: "鉤鎖飛行速讀",
  T_46_META_WS_P_TICKINTERVAL: "刷新間隔",
  T_46_META_WS_P_TIMEREQUIRED: "使用所需時間（ms）",
  T_46_META_WS_P_TIPSTYPE: "飄字提示類型",
  T_46_META_WS_P_TITLE: "標題文本",
  T_46_META_WS_P_TITLELIST: "標題列表",
  T_46_META_WS_P_TITLES: "標題列表",
  T_46_META_WS_P_TOP: "上身服飾",
  T_46_META_WS_P_TOPALPHA: "頂部透明度",
  T_46_META_WS_P_TOTALHP: "生命值總量",
  T_46_META_WS_P_TOTALLEVEL: "總等級數",
  T_46_META_WS_P_TOTALROUNDCOUNT: "遊戲總回合數",
  T_46_META_WS_P_TOWSPEED: "牽引玩家速度",
  T_46_META_WS_P_TRANSITIONSTAGE: "切換階段",
  T_46_META_WS_P_TRANSITIONTYPE: "过渡型",
  T_46_META_WS_P_TRIGGERPLAYERID: "觸發的實體 ID",
  T_46_META_WS_P_TRIGGERRADIUS: "觸發範圍",
  T_46_META_WS_P_TRIGGERRANGE: "觸發範圍",
  T_46_META_WS_P_TRIGGERTIME: "觸發時間",
  T_46_META_WS_P_TURNSPEED: "轉彎速度（每秒度）",
  T_46_META_WS_P_TWEENERENABLED: "是否啟用 UITweener 腳本",
  T_46_META_WS_P_TWEENSTYLE: "動畫風格",
  T_46_META_WS_P_TYPE: "類型",
  T_46_META_WS_P_UNSELECTEDCOLOR: "未選中圖片顏色",
  T_46_META_WS_P_UNSELECTEDSPRITE: "未選中圖片",
  T_46_META_WS_P_UNSELECTEDTYPE: "未選中圖片填充類型",
  T_46_META_WS_P_UP: "上方",
  T_46_META_WS_P_UPDATETYPE: "更新類型",
  T_46_META_WS_P_UPENERGYCOST: "每秒向上能量消耗",
  T_46_META_WS_P_UPSPEED: "上升速度（力）",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "是否使用自訂推力大小",
  T_46_META_WS_P_USECUSTOMRESOURCE: "是否使用自訂資源",
  T_46_META_WS_P_USEDCAPACITY: "已占用空間",
  T_46_META_WS_P_USEGRAVITY: "是否受重力",
  T_46_META_WS_P_USEPHYSICALCCT: "使用帶物理效果的 CCT",
  T_46_META_WS_P_USERUID: "用戶UID",
  T_46_META_WS_P_UVOFFSET: "UV 偏移量",
  T_46_META_WS_P_UVSIZE: "UV 寬高",
  T_46_META_WS_P_VALUE: "值[0, 1]",
  T_46_META_WS_P_VAULTDISTANCE: "翻越距離",
  T_46_META_WS_P_VAULTHEIGHT: "翻越高度",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "車輛傷害係數",
  T_46_META_WS_P_VEHICLESKINID: "載具外觀 ID",
  T_46_META_WS_P_VEHICLESKINIDS: "載具外觀 ID",
  T_46_META_WS_P_VELOCITY: "線速度 (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "XZ 軸速度",
  T_46_META_WS_P_VELOCITYY: "Y 軸速度",
  T_46_META_WS_P_VERTICALBAR: "垂直顯示類型",
  T_46_META_WS_P_VERTICALOFFSET: "垂直方向偏移量",
  T_46_META_WS_P_VEST: "當前防彈衣",
  T_46_META_WS_P_VFXTEXTURETYPE: "特效貼圖類型",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "視角限制",
  T_46_META_WS_P_VISIBILITYLAYER: "可見層級（0~15）",
  T_46_META_WS_P_VISIBLE: "是否可見",
  T_46_META_WS_P_VISIBLEONBACK: "背在身上是否顯示",
  T_46_META_WS_P_VISIBLEPLAYERS: "玩家實體列表 可見屬性",
  T_46_META_WS_P_VOLUME: "音量",
  T_46_META_WS_P_WALLETID: "錢包ID",
  T_46_META_WS_P_WANDERRANGE: "遊蕩距離",
  T_46_META_WS_P_WAVECOUNT: "波數",
  T_46_META_WS_P_WAVEINTERVAL: "間隔時間",
  T_46_META_WS_P_WEAPONDAMAGERATE: "傷害倍率",
  T_46_META_WS_P_WEAPONSKINIDS: "武器塗裝 ID",
  T_46_META_WS_P_WEAPONSUBTYPE: "武器子類型",
  T_46_META_WS_P_WEAPONTYPE: "武器類型",
  T_46_META_WS_P_WIDTH: "寬度",
  T_46_META_WS_P_WINMVPS: "獲勝 MVP 列表",
  T_46_META_WS_P_WINTEXT: "勝利提示文本",
  T_46_META_WS_P_WORDWRAP: "自動換行",
  T_46_META_WS_P_WORLDPOSITION: "世界座標",
  T_46_META_WS_P_YAW: "水平角",
  T_46_META_WS_PATROLALONG: "沿著巡邏",
  T_46_META_WS_PATROLTO: "巡邏至",
  T_46_META_WS_PAUSE: "暫停",
  T_46_META_WS_PAUSEEMOTE: "暫停動作",
  T_46_META_WS_PAUSEFIXEDUPDATE: "暫停固定幀更新",
  T_46_META_WS_PHASE: "階段",
  T_46_META_WS_PLAY: "播放",
  T_46_META_WS_PLAYANIMATION: "播放動畫",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "播放角色動畫片段",
  T_46_META_WS_PLAYEMOTE: "播放Emote",
  T_46_META_WS_PLAYER: "玩家",
  T_46_META_WS_PORTAL: "傳送門",
  T_46_META_WS_POSE: "姿勢",
  T_46_META_WS_POSITION: "位置",
  T_46_META_WS_PREPOSE: "預設姿勢 ",
  T_46_META_WS_PROFANITYFILTER: "脏字過濾",
  T_46_META_WS_PURSUITTARGET: "追擊目標",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "四元數轉軸角",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "四元數轉歐拉角",
  T_46_META_WS_QUITCHATCHANNEL: "離開聊天頻道",
  T_46_META_WS_QUITFACTION: "退出陣營",
  T_46_META_WS_QUITGAME: "退出遊戲",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "退出逃脫迷你遊戲",
  T_46_META_WS_RANDOMFLOAT: "隨機小數",
  T_46_META_WS_RANDOMINT: "隨機整數",
  T_46_META_WS_RANK: "排名",
  T_46_META_WS_READCSV: "讀取CSV",
  T_46_META_WS_READCSVCELL: "讀取CSV單元格",
  T_46_META_WS_READCSVCELLBYNAME: "通過行數和列名讀取CSV單元格",
  T_46_META_WS_READCSVCELLFROMSERVER: "從伺服器讀取CSV單元格",
  T_46_META_WS_READCSVCOLUMN: "讀取CSV列",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "從伺服器讀取CSV列",
  T_46_META_WS_READCSVFROMSERVER: "從伺服器讀取CSV",
  T_46_META_WS_READCSVROW: "讀取CSV行",
  T_46_META_WS_READCSVROWBYKEY: "通過鍵獲取CSV行",
  T_46_META_WS_READCSVROWFROMSERVER: "從伺服器讀取CSV行",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "讀取累積資料庫表值",
  T_46_META_WS_READFROMDATASTORE: "讀取資料庫表值",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "讀取資料庫中排行榜表值",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "根據名次區間讀取資料庫中排行榜表值",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "移除AOI特別關注",
  T_46_META_WS_REMOVEBACKPACKSKIN: "移除背包外觀",
  T_46_META_WS_REMOVEBUFF: "移除Buff",
  T_46_META_WS_REMOVECOMPONENT: "移除組件",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "移除公式化屬性因子",
  T_46_META_WS_REMOVEOUTFIT: "去除服裝",
  T_46_META_WS_REMOVESCRIPT: "移除腳本",
  T_46_META_WS_REMOVEVEHICLESKIN: "移除載具塗裝",
  T_46_META_WS_REMOVEWEAPONSKIN: "移除武器塗裝",
  T_46_META_WS_REPLACE: "替換",
  T_46_META_WS_REQUESTMATCHMAKING: "請求匹配",
  T_46_META_WS_RESET: "重置",
  T_46_META_WS_RESETBACKPACKSKIN: "恢復背包外觀",
  T_46_META_WS_RESETDYEING: "重置染色",
  T_46_META_WS_RESETJERSEY: "重設球衣",
  T_46_META_WS_RESETOUTFIT: "恢復默認服裝",
  T_46_META_WS_RESETVEHICLESKIN: "恢復默認載具塗裝",
  T_46_META_WS_RESETWEAPONSKIN: "恢復默認武器塗裝",
  T_46_META_WS_RESUMEFIXEDUPDATE: "恢復固定幀更新",
  T_46_META_WS_REVERSE: "反轉",
  T_46_META_WS_REVIVALSOURCE: "復活來源",
  T_46_META_WS_REVIVE: "復活",
  T_46_META_WS_ROUND: "四捨五入",
  T_46_META_WS_ROUNDINDEX: "回合索引",
  T_46_META_WS_SAMPLEONCURVE: "在Curve上採樣",
  T_46_META_WS_SCENENAME: "場景名稱",
  T_46_META_WS_SCORE: "積分",
  T_46_META_WS_SCORER: "進球者",
  T_46_META_WS_SCORETYPE: "積分類型",
  T_46_META_WS_SCREENMULTIRAYCAST: "螢幕觸控多返回射線檢測",
  T_46_META_WS_SCREENSINGLERAYCAST: "螢幕觸控單返回射線檢測",
  T_46_META_WS_SCREENTOUCHRAY: "通過螢幕觸控獲得射線",
  T_46_META_WS_SCREENTOWORLDPOINT: "螢幕座標轉世界座標",
  T_46_META_WS_SENDEVENT: "發送玩家自定義事件",
  T_46_META_WS_SETACTIVE: "設置活動狀態",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "設置玩家是否可以移動",
  T_46_META_WS_SETATTACKABLEENTITY: "設置可攻擊實體",
  T_46_META_WS_SETATTACKABLEFACTION: "設置可攻擊的陣營",
  T_46_META_WS_SETATTACKABLETEAM: "設置可攻擊的隊伍",
  T_46_META_WS_SETBACKPACKSKIN: "設置背包外觀",
  T_46_META_WS_SETBEHAVIORSTATUS: "設置行為狀態",
  T_46_META_WS_SETBLACKBOARDVALUE: "設置黑板變數",
  T_46_META_WS_SETBUNDLE: "設置套裝",
  T_46_META_WS_SETCAMERAFOCUS: "相機聚焦目標",
  T_46_META_WS_SETCAMERAFOLLOW: "相機跟隨目標",
  T_46_META_WS_SETCHARACTER: "設置角色",
  T_46_META_WS_SETCULLINGMASK: "設置相機層遮罩",
  T_46_META_WS_SETCULLINGMASKLAYER: "設置相機的渲染層遮罩",
  T_46_META_WS_SETDEFAULTUISTATUS: "設置默認界面狀態",
  T_46_META_WS_SETDROPSTATUS: "設置丟棄狀態",
  T_46_META_WS_SETFALLINGDAMAGE: "設置墜落傷害",
  T_46_META_WS_SETFOOTBALLPOSITION: "設置足球位置",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "設置公式化屬性絕對值",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "設置公式化屬性相對值",
  T_46_META_WS_SETFORWARD: "設置朝向",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "設置全局休眠閾值",
  T_46_META_WS_SETINVINCIBILITY: "設置無敵狀態",
  T_46_META_WS_SETJERSEY: "設置球衣",
  T_46_META_WS_SETOUTFIT: "設置服裝",
  T_46_META_WS_SETPARENT: "設置父節點",
  T_46_META_WS_SETPARENTCLIENT: "設置物件實體的父節點",
  T_46_META_WS_SETPICKUPSTATUS: "設置拾取狀態",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "設置玩家快捷訊息狀態",
  T_46_META_WS_SETPLAYERVOICESTATUS: "設置玩家語音狀態",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "平滑設置實體屬性",
  T_46_META_WS_SETSKILLS: "設置技能",
  T_46_META_WS_SETSKYBOX: "設置天空盒",
  T_46_META_WS_SETSLEEPTHRESHOLD: "設置休眠閾值",
  T_46_META_WS_SETSPECIALITEMSTATUS: "設置特殊物品狀態",
  T_46_META_WS_SETVEHICLESKIN: "設置載具塗裝",
  T_46_META_WS_SETWEAPONSKIN: "設置武器塗裝",
  T_46_META_WS_SETWIDGETPARENT: "設置控件的父節點",
  T_46_META_WS_SHOPITEM: "商店物品",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "顯示外觀組",
  T_46_META_WS_SHUFFLE: "打亂",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "單次射線檢測",
  T_46_META_WS_SKILL: "技能",
  T_46_META_WS_SLEEP: "強制休眠",
  T_46_META_WS_SLERPQUATERNION: "四元數插值",
  T_46_META_WS_SPAWNABLES: "生成物品",
  T_46_META_WS_SPAWNEDITEM: "生成的道具",
  T_46_META_WS_SPAWNNEXTWAVE: "生成下一波",
  T_46_META_WS_SPHERECAST: "球形檢測",
  T_46_META_WS_SPHEREOVERLAP: "球形重疊檢測",
  T_46_META_WS_SPLIT: "分割",
  T_46_META_WS_SQRT: "平方根",
  T_46_META_WS_STARTPARACHUTE: "開啟跳傘",
  T_46_META_WS_STARTPOSITION: "起始位置",
  T_46_META_WS_STATENAME: "狀態名稱",
  T_46_META_WS_STATUS: "狀態",
  T_46_META_WS_STRINGTOFLOAT: "字串轉浮點數",
  T_46_META_WS_STRINGTOINT: "字串轉整型",
  T_46_META_WS_STRIP: "剔除",
  T_46_META_WS_SUB: "減去",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "切換AOI代理觀察者",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "切換外觀組",
  T_46_META_WS_SWITCHAREA: "切換區域",
  T_46_META_WS_SWITCHCAMERA: "切換相機",
  T_46_META_WS_SWITCHPHASE: "切換遊戲階段",
  T_46_META_WS_SWITCHSCENE: "切換場景",
  T_46_META_WS_SWITCHWEAPON: "切換武器",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "目標",
  T_46_META_WS_TEAM: "隊伍",
  T_46_META_WS_TELEPORT: "傳送",
  T_46_META_WS_TELEPORTCCT: "強制移動角色控制器到某位置",
  T_46_META_WS_TEXT: "文本",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "時間戳本地化字串",
  T_46_META_WS_TIRE: "輪胎",
  T_46_META_WS_TOLOWER: "轉為小寫",
  T_46_META_WS_TOSTRING: "轉換為字串",
  T_46_META_WS_TOUPPER: "轉為大寫",
  T_46_META_WS_TRANSFERMONEY: "轉移金錢",
  T_46_META_WS_TRIGGER: "觸發器",
  T_46_META_WS_TYPEIS: "類型是",
  T_46_META_WS_UNLOADSCENE: "卸載場景",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "更新逃脫任務",
  T_46_META_WS_UPLOADGAMERESULT: "上傳遊戲結算信息",
  T_46_META_WS_VALUE: "傷害",
  T_46_META_WS_VECTOR2ANGLE: "二維向量夾角",
  T_46_META_WS_VECTOR2DISTANCE: "二維向量距離",
  T_46_META_WS_VECTOR2DOT: "二維向量點積",
  T_46_META_WS_VECTOR2MAGNITUDE: "二維向量大小",
  T_46_META_WS_VECTOR2NORMALIZE: "二維向量歸一化",
  T_46_META_WS_VECTOR2REFLECT: "二維向量反射",
  T_46_META_WS_VECTOR2TOVECTOR3: "二維向量轉三維向量",
  T_46_META_WS_VECTOR3REFLECT: "三維向量反射",
  T_46_META_WS_VECTOR3TOVECTOR2: "三維向量轉二維向量",
  T_46_META_WS_VEHICLE: "載具",
  T_46_META_WS_VELOCITY: "速度",
  T_46_META_WS_WAITFORMILESECOND: "等待毫秒",
  T_46_META_WS_WAITFORNEXTFRAME: "等待直到下一幀",
  T_46_META_WS_WAKEUP: "喚醒剛體",
  T_46_META_WS_WAVES: "波次",
  T_46_META_WS_WEAPON: "武器",
  T_46_META_WS_WORLDTOSCREENPOINT: "世界座標轉螢幕座標",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "寫入累積資料庫表偏移值",
  T_46_META_WS_WRITETODATASTORE: "寫入資料庫表值",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "寫入資料庫中排行榜表值",
  T_48_META_API_1_D: "取得目前遊戲中所有玩家，返回玩家清單。",
  T_48_META_API_1_R_D: "玩家列表",
  T_48_META_API_10_D: "取得場景物件",
  T_48_META_API_10_P0_D: "篩選何種類型的場景物件",
  T_48_META_API_10_R_D: "場景物件列表",
  T_48_META_API_100_D: "載入場景，不會自動卸載已經載入的場景",
  T_48_META_API_100_P0_D: "要載入的場景ID",
  T_48_META_API_10000_D: "傳回目前腳本綁定的實體",
  T_48_META_API_10000_R_D: "目前腳本綁定的實體",
  T_48_META_API_10001_D: "使用實體ID來尋找對應的實體，該API僅限編輯器使用，用戶側使用該API無法保證它的兼容性，例如移除或調整",
  T_48_META_API_10001_P0_D: "目標實體ID",
  T_48_META_API_10001_R_D: "實體",
  T_48_META_API_10002_D: "取得該局遊戲全域實體",
  T_48_META_API_10002_R_D: "全域實體",
  T_48_META_API_10003_D: "把玩家傳送到具體座標（已廢棄，請使用Teleport）",
  T_48_META_API_10003_P0_D: "被傳送的玩家",
  T_48_META_API_10003_P1_D: "被傳送點的座標",
  T_48_META_API_10004_D: "取得隊友附近位置，會規避開無法站立玩家的位置（已廢棄，請使用GetTeammateNearPosition）",
  T_48_META_API_10004_P0_D: "目標玩家",
  T_48_META_API_10004_R_D: "隊友附近座標",
  T_48_META_API_10005_D: "獲得實體的所屬玩家",
  T_48_META_API_10005_P0_D: "目標實體，實體只會和所屬玩家進行同步",
  T_48_META_API_10005_R_D: "目標實體的所屬玩家",
  T_48_META_API_10006_D: "將玩家設為無敵狀態",
  T_48_META_API_10006_P0_D: "目標玩家",
  T_48_META_API_10006_P1_D: "無敵效果持續時長，單位秒",
  T_48_META_API_10007_D: "在原始位置複製選取的實體及其所有屬性",
  T_48_META_API_10007_P0_D: "建立的實體",
  T_48_META_API_10007_P1_D: "待克隆的實體",
  T_48_META_API_10008_D: "對玩家造成傷害，若不選擇傷害來源，則目標受到來自系統的傷害",
  T_48_META_API_10008_P0_D: "受到傷害的遊戲實體",
  T_48_META_API_10008_P1_D: "造成傷害的遊戲實體",
  T_48_META_API_10008_P2_D: "傷害類型",
  T_48_META_API_10008_P3_D: "傷害量",
  T_48_META_API_10009_D: "復活指定玩家",
  T_48_META_API_10009_P0_D: "被復活的玩家",
  T_48_META_API_1001_D: "滿足條件則運行IF下的節點。不符合條件時，若有ELSE則運行ELSE下方節點，否則結束IF語句。",
  T_48_META_API_1001_P0_D: "條件清單需和子流程清單（邏輯分支清單）數量保持一致",
  T_48_META_API_10010_D: "在指定位置建立物品或物品清單。",
  T_48_META_API_10010_P0_D: "物品創建位置",
  T_48_META_API_10010_P1_D: "創建的物品或物品列表",
  T_48_META_API_10010_P2_D: "建立的物品數量，在建立物品清單時需要填入與物品清單順序對應物品數量清單",
  T_48_META_API_10011_D: "AI實體向目標點巡邏",
  T_48_META_API_10011_P0_D: "目標AI實體",
  T_48_META_API_10011_P1_D: "移動的目標點",
  T_48_META_API_10011_P2_D: "是否返回出發點",
  T_48_META_API_10011_P3_D: "巡邏時是否偵測並攻擊敵對目標",
  T_48_META_API_10012_D: "AI實體依照座標列表順序依序巡邏",
  T_48_META_API_10012_P0_D: "目標AI實體",
  T_48_META_API_10012_P1_D: "移動的座標點列表",
  T_48_META_API_10012_P2_D: "巡邏類型，可以選擇單次、往返循環或循環",
  T_48_META_API_10012_P3_D: "巡邏時是否偵測並攻擊敵對目標",
  T_48_META_API_10013_D: "生成器立刻刷新下一波單位實體",
  T_48_META_API_10013_P0_D: "生成器實體",
  T_48_META_API_10014_D: "增加可計算屬性計算因子，可計算屬性將會透過因子組成的公式運算出最終結果",
  T_48_META_API_10014_P0_D: "目標實體",
  T_48_META_API_10014_P1_D: "可計算屬性類型",
  T_48_META_API_10014_P2_D: "計算因子類型",
  T_48_META_API_10014_P3_D: "計算因子值",
  T_48_META_API_10015_D: "清除可計算屬性的計算因子",
  T_48_META_API_10015_P0_D: "目標實體",
  T_48_META_API_10015_P1_D: "可計算屬性類型",
  T_48_META_API_10016_D: "清除目標實體所有可計算屬性的所有計算因子",
  T_48_META_API_10016_P0_D: "目標實體",
  T_48_META_API_10017_D: "修改屬性",
  T_48_META_API_10017_P0_D: "目標實體",
  T_48_META_API_10017_P1_D: "屬性類型",
  T_48_META_API_10017_P2_D: "修改方式",
  T_48_META_API_10017_P3_D: "值",
  T_48_META_API_10018_D: "設定可計算屬性的值",
  T_48_META_API_10018_P0_D: "目標實體",
  T_48_META_API_10018_P1_D: "屬性類型",
  T_48_META_API_10018_P2_D: "值",
  T_48_META_API_10019_D: "清除單一可計算屬性修改",
  T_48_META_API_10019_P0_D: "目標實體",
  T_48_META_API_10019_P1_D: "屬性類型",
  T_48_META_API_1002_D: "參數i從最小值開始，每運行一次下方節點則i增加步進值，直到i大於等於最大值。",
  T_48_META_API_1002_P0_D: "循環索引的名稱，可以使用它來取得局部變數上的循環索引值",
  T_48_META_API_1002_P1_D: "循環初始值",
  T_48_META_API_1002_P2_D: "循環結束值",
  T_48_META_API_1002_P3_D: "循環步長，當起始值小於結束值時，步長應大於0；當起始值大於結束值時，步長應小於0",
  T_48_META_API_10020_D: "取得遊戲中全部符合篩選條件的實體",
  T_48_META_API_10020_P0_D: "篩選結果必須包含這個參數內輸入的類型",
  T_48_META_API_10020_P1_D: "篩選結果必須不包含這個參數內輸入的類型",
  T_48_META_API_10020_P2_D: "篩選結果至少包含這個參數內輸入的類型之一",
  T_48_META_API_10020_R_D: "篩選結果實體列表",
  T_48_META_API_10021_D: "為足球增加一個速度，速度會受同方向加速度的影響而改變",
  T_48_META_API_10021_P0_D: "目標足球",
  T_48_META_API_10021_P1_D: "添加的三維空間速度",
  T_48_META_API_10022_D: "銷毀指定實體",
  T_48_META_API_10022_P0_D: "要銷毀的目標實體",
  T_48_META_API_10023_D: "為實體新增標籤",
  T_48_META_API_10023_P0_D: "目標實體",
  T_48_META_API_10023_P1_D: "自訂標籤",
  T_48_META_API_10024_D: "為實體移除標籤",
  T_48_META_API_10024_P0_D: "目標實體",
  T_48_META_API_10024_P1_D: "自訂標籤",
  T_48_META_API_10025_D: "判斷目標實體是否包含指定的標籤",
  T_48_META_API_10025_P0_D: "目標實體",
  T_48_META_API_10025_P1_D: "自訂標籤",
  T_48_META_API_10025_R_D: "是否包含指定標籤",
  T_48_META_API_10026_D: "設定足球位置",
  T_48_META_API_10026_P0_D: "足球實體",
  T_48_META_API_10026_P1_D: "位置",
  T_48_META_API_10026_P2_D: "保持速度",
  T_48_META_API_10027_D: "取得目標玩家目前使用的攝影機實體",
  T_48_META_API_10027_P0_D: "目標玩家",
  T_48_META_API_10027_R_D: "目前使用的攝影機實體",
  T_48_META_API_10028_D: "將目標玩家的相機切換為目標相機，",
  T_48_META_API_10028_P0_D: "目標玩家",
  T_48_META_API_10028_P1_D: "目標相機",
  T_48_META_API_10028_P2_D: "切換方式，可選擇保持原邏輯或漸進",
  T_48_META_API_10028_P3_D: "切換時間是漸進模式下切換相機的時間",
  T_48_META_API_10029_D: "創建一個相機",
  T_48_META_API_10029_P0_D: "創建的相機類型",
  T_48_META_API_10029_P1_D: "建立的相機實體",
  T_48_META_API_1003_D: "實現一個資料容器的遍歷，取得到每一個子元素，含有子過程，循環體就是子過程",
  T_48_META_API_1003_P0_D: "遍歷到子元素的名稱，可以使用它來取得局部變數上的子元素值",
  T_48_META_API_1003_P1_D: "循環索引的名稱，可以使用它來取得局部變數上的循環索引值",
  T_48_META_API_1003_P2_D: "要遍歷的資料容器，目前支援以下類型：數組類型",
  T_48_META_API_10030_D: "殺死可戰鬥實體",
  T_48_META_API_10030_P0_D: "目標實體，必須為可戰鬥實體",
  T_48_META_API_10031_D: "設定目標實體及其子節點的活動狀態，不活動的物體的可用性、可見度、碰撞等均會關閉",
  T_48_META_API_10031_P0_D: "目標實體",
  T_48_META_API_10031_P1_D: "是否為活動狀態",
  T_48_META_API_10032_D: "設定相機實體的位置始終跟隨目標實體",
  T_48_META_API_10032_P0_D: "目標相機實體",
  T_48_META_API_10032_P1_D: "要跟隨的目標實體",
  T_48_META_API_10032_P2_D: "距離目標實體座標的偏移量",
  T_48_META_API_10032_P3_D: "偏移量的座標系",
  T_48_META_API_10033_D: "設定相機實體始終朝向目標實體",
  T_48_META_API_10033_P0_D: "目標相機實體",
  T_48_META_API_10033_P1_D: "目標實體",
  T_48_META_API_10033_P2_D: "注視點距離目標座標的偏移量",
  T_48_META_API_10033_P3_D: "偏移量的座標系",
  T_48_META_API_10034_D: "創建Tween",
  T_48_META_API_10034_P0_D: "目標實體",
  T_48_META_API_10034_P1_D: "屬性ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Style",
  T_48_META_API_10034_P5_D: "Curve",
  T_48_META_API_10034_P6_D: "Duration",
  T_48_META_API_10034_P7_D: "tween實體",
  T_48_META_API_10035_D: "設定父節點，要求父子都具有Transform元件",
  T_48_META_API_10035_P0_D: "父節點",
  T_48_META_API_10035_P1_D: "子節點",
  T_48_META_API_10035_P2_D: "是否保留子節點目前世界位置、旋轉和縮放，設定UI時該項無效",
  T_48_META_API_10036_D: "NewCurve（已廢棄，請使用CreateTweenCurve）",
  T_48_META_API_10036_P0_D: "ControlPoints",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "嘗試播放目標實體，目標實體必須具有可播放組件",
  T_48_META_API_10037_P0_D: "目標可播放實體",
  T_48_META_API_10037_P1_D: `是否重新播放
真：重新播放
假：繼續播放`,
  T_48_META_API_10038_D: "暫停可播放實體",
  T_48_META_API_10038_P0_D: "目標可播放實體",
  T_48_META_API_10039_D: "創造彈道運動，會給予目標實體帶有方向的初速與加速度",
  T_48_META_API_10039_P0_D: "目標實體",
  T_48_META_API_10039_P1_D: "運動初速度",
  T_48_META_API_10039_P2_D: "運動加速度",
  T_48_META_API_10039_P3_D: "最大位移距離",
  T_48_META_API_10039_P4_D: "創建的彈道運動實體",
  T_48_META_API_10039_P5_D: "建立後是否自動開始播放",
  T_48_META_API_1004_D: "打斷當前循環過程，退出循環",
  T_48_META_API_10040_D: "建立位置跟隨運動，目標實體會跟隨指定物件運動",
  T_48_META_API_10040_P0_D: "目標實體",
  T_48_META_API_10040_P1_D: "跟隨運動的對象實體",
  T_48_META_API_10040_P2_D: "距離跟隨目標座標的偏移量",
  T_48_META_API_10040_P3_D: "使用的座標系",
  T_48_META_API_10040_P4_D: "建立的跟隨運動實體",
  T_48_META_API_10040_P5_D: "建立後是否自動開始播放",
  T_48_META_API_10041_D: "建立注視跟隨運動，目標實體會保持朝向指定對象",
  T_48_META_API_10041_P0_D: "目標實體",
  T_48_META_API_10041_P1_D: "注視的物件實體",
  T_48_META_API_10041_P2_D: "注視點距離物件實體的偏移量",
  T_48_META_API_10041_P3_D: "使用的座標系",
  T_48_META_API_10041_P4_D: "所建立的注視跟隨運動實體",
  T_48_META_API_10041_P5_D: "建立後是否自動開始播放",
  T_48_META_API_10042_D: "已廢棄",
  T_48_META_API_10042_P0_D: "玩家實體",
  T_48_META_API_10042_P1_D: "比賽結果",
  T_48_META_API_10042_P2_D: "已廢棄",
  T_48_META_API_10042_P3_D: "已廢棄",
  T_48_META_API_10042_P4_D: "已廢棄",
  T_48_META_API_10043_D: "平滑設定目標實體的屬性，屬性會立刻改變，但是客戶端會播放一個平滑過渡表現",
  T_48_META_API_10043_P0_D: "目標實體",
  T_48_META_API_10043_P1_D: "目標實體的某個屬性",
  T_48_META_API_10043_P2_D: "目標值，需要符合屬性定義時要求的類型",
  T_48_META_API_10044_D: "進行一次射線偵測，返回射線方向上命中的第一個實體，命中實體需要有碰撞組件，層級參若填空，則可以偵測到地形",
  T_48_META_API_10044_P0_D: "開始位置座標",
  T_48_META_API_10044_P1_D: "射線偵測方向",
  T_48_META_API_10044_P2_D: "射線偵測距離，只接受正值",
  T_48_META_API_10044_P3_D: "射線偵測層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_10044_P4_D: "是否可以掃描出觸發器",
  T_48_META_API_10044_P5_D: "命中實體",
  T_48_META_API_10044_P6_D: "命中點座標",
  T_48_META_API_10044_P7_D: "命中點距離開始點距離",
  T_48_META_API_10044_P8_D: "命中表面法線",
  T_48_META_API_10045_D: "進行一次射線偵測，從近到遠地返回射線方向上命中的所有實體，層級參若填空，則可以偵測到地形",
  T_48_META_API_10045_P0_D: "開始位置座標",
  T_48_META_API_10045_P1_D: "射線偵測方向",
  T_48_META_API_10045_P2_D: "射線偵測距離，只接受正值",
  T_48_META_API_10045_P3_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_10045_P4_D: "是否可以偵測出觸發器",
  T_48_META_API_10045_P5_D: "命中的實體列表",
  T_48_META_API_10045_P6_D: "命中點列表",
  T_48_META_API_10045_P7_D: "命中點距離開始點距離列表",
  T_48_META_API_10045_P8_D: "命中表面法線",
  T_48_META_API_10046_D: "使用預製體為模板建立實體",
  T_48_META_API_10046_P0_D: "建立的實體",
  T_48_META_API_10046_P1_D: "預製體ID",
  T_48_META_API_10047_D: "染色",
  T_48_META_API_10047_P0_D: "設定物件法線",
  T_48_META_API_10047_P1_D: "設定染色點",
  T_48_META_API_10047_P2_D: "顏色",
  T_48_META_API_10048_D: "染色狀態",
  T_48_META_API_10048_P0_D: "設定染色點",
  T_48_META_API_10048_P1_D: "設定方向",
  T_48_META_API_10048_P2_D: "設定距離",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "染色統計",
  T_48_META_API_10049_P0_D: "顏色",
  T_48_META_API_10049_R_D: "染色數量",
  T_48_META_API_1005_D: "跳過剩餘的循環體內容，直接進入下一次循環",
  T_48_META_API_10050_D: "平面範圍染色",
  T_48_META_API_10050_P0_D: "設定物件法線",
  T_48_META_API_10050_P1_D: "設定染色點",
  T_48_META_API_10050_P2_D: "設定染色範圍",
  T_48_META_API_10050_P3_D: "顏色",
  T_48_META_API_10050_P4_D: "染色數量",
  T_48_META_API_10051_D: "區域染色",
  T_48_META_API_10051_P0_D: "設定物件法線",
  T_48_META_API_10051_P1_D: "設定染色點",
  T_48_META_API_10051_P2_D: "設定染色範圍",
  T_48_META_API_10051_P3_D: "顏色",
  T_48_META_API_10051_P4_D: "固定染色區域",
  T_48_META_API_10051_P5_D: "隨機係數",
  T_48_META_API_10051_P6_D: "隨機衰減係數",
  T_48_META_API_10051_P7_D: "染色數量",
  T_48_META_API_10052_D: "取得目標父節點實體的所有子節點",
  T_48_META_API_10052_P0_D: "父節點實體",
  T_48_META_API_10052_R_D: "子節點列表",
  T_48_META_API_10053_D: "根據索引取得目標父節點實體的指定子節點",
  T_48_META_API_10053_P0_D: "父節點實體",
  T_48_META_API_10053_P1_D: "子節點索引",
  T_48_META_API_10053_R_D: "子節點實體",
  T_48_META_API_10054_D: "取得目標子節點實體的父節點",
  T_48_META_API_10054_P0_D: "子節點實體",
  T_48_META_API_10054_R_D: "父節點實體",
  T_48_META_API_10055_D: "刪除指定父節點實體下的所有子節點，節點必須具有Transform元件",
  T_48_META_API_10055_P0_D: "父節點實體",
  T_48_META_API_10056_D: "將目標傳送至指定位置",
  T_48_META_API_10056_P0_D: "被傳送的單位",
  T_48_META_API_10056_P1_D: "傳送點座標",
  T_48_META_API_10056_P2_D: "傳送後單位朝向",
  T_48_META_API_10057_D: "獲得隨機隊友附近位置，沒有隊友時返回自身附近的座標，會規避開無法站立玩家的位置",
  T_48_META_API_10057_P0_D: "目標玩家",
  T_48_META_API_10057_R_D: "目標玩家隊友附近的座標",
  T_48_META_API_10058_D: "清除染色狀態",
  T_48_META_API_10059_D: "播放指定的音效，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性",
  T_48_META_API_10059_P0_D: "程式碼中是用來表示建立音效實體的形參名稱，其對應的局部變數值是建立音效的實體",
  T_48_META_API_10059_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_10059_P2_D: "音效類型，玩家可以選擇的音效種類",
  T_48_META_API_1006_D: "結束目前執行過程，直接返回呼叫位置，可以攜帶資料一併返回",
  T_48_META_API_1006_P0_D: "希望傳回給呼叫位置的數據",
  T_48_META_API_10060_D: "將目標玩家踢出遊戲",
  T_48_META_API_10060_P0_D: "目標玩家",
  T_48_META_API_10060_P1_D: "是否顯示結算訊息",
  T_48_META_API_10061_D: "目標玩家請求匹配指定地圖",
  T_48_META_API_10061_P0_D: "目標玩家",
  T_48_META_API_10061_P1_D: "戰場碼",
  T_48_META_API_10061_P2_D: "取消配對時是否彈窗提示重回原遊戲",
  T_48_META_API_10062_D: "中斷播放中的音效實體",
  T_48_META_API_10062_P0_D: "需要被暫停的音效實體",
  T_48_META_API_10063_D: "繼續播放音效,可選擇是否從頭開始播放",
  T_48_META_API_10063_P0_D: "被暫停後需要繼續播放的音效實體",
  T_48_META_API_10063_P1_D: "是否從頭開始",
  T_48_META_API_10064_D: "創造一個空投，空投有三個階段：1.準備、2.掉落中、3.落地，只有在狀態1的時候可以修改空投屬性",
  T_48_META_API_10064_P0_D: "建立的空投箱實體",
  T_48_META_API_1007_D: "實現根據條件是否為真持續執行的循環，直到條件為假結束循環",
  T_48_META_API_1007_P0_D: "當條件為真則繼續循環，條件為假則結束循環",
  T_48_META_API_1008_D: `等待至下一邏輯幀開始時
在伺服器上，開啟低幀率模式，將會等待更長時間
在客戶端上，等待時間受設備效能和當前幀邏輯複雜程度影響
使用該API的函數需要宣告為async`,
  T_48_META_API_1009_D: "等待一定時間，使用該API的函數需要宣告為async。",
  T_48_META_API_1009_P0_D: "等待的時長，單位毫秒",
  T_48_META_API_101_D: "解除安裝指定場景",
  T_48_META_API_101_P0_D: "要解除安裝的場景ID",
  T_48_META_API_1010: "事件回調",
  T_48_META_API_1010_D: "當某事件發生時觸發的動作",
  T_48_META_API_1010_P0: "事件參數名稱",
  T_48_META_API_1010_P0_D: "事件參數的形參名稱，透過它可以在局部變數上取得到實參值",
  T_48_META_API_1011: "程式碼區塊",
  T_48_META_API_1011_D: "一段程式碼區塊，用以承載一連串API的組合",
  T_48_META_API_1011_P0: "參數名稱",
  T_48_META_API_1011_P0_D: "當程式碼區塊是自訂函數時的形參名稱",
  T_48_META_API_1012: "使用串行查找並調用自訂 API",
  T_48_META_API_1012_D: "以串行的方式呼叫自訂函數，如果自訂函數中存在等待，則呼叫位置也進行等待",
  T_48_META_API_1012_P0_D: "自訂函數所在的實體",
  T_48_META_API_1012_P1: "圖ID",
  T_48_META_API_1012_P1_D: "自訂函數所在的腳本ID",
  T_48_META_API_1012_P2: "功能編號",
  T_48_META_API_1012_P2_D: "目標呼叫的函數ID",
  T_48_META_API_1012_P3_D: "傳遞給自訂函數的實參列表",
  T_48_META_API_1013: "使用 Parallel 尋找並呼叫自訂 API",
  T_48_META_API_1013_D: "以並行的方式呼叫自訂函數，無論自訂函數中是否存在等待，都會立即返回呼叫位置繼續向下執行",
  T_48_META_API_1013_P0_D: "自訂函數所在的實體",
  T_48_META_API_1013_P1: "圖ID",
  T_48_META_API_1013_P1_D: "自訂函數所在的腳本ID",
  T_48_META_API_1013_P2: "功能編號",
  T_48_META_API_1013_P2_D: "目標呼叫的函數ID",
  T_48_META_API_1013_P3_D: "傳遞給自訂函數的實參列表",
  T_48_META_API_1014: "透過串口查找並呼叫自訂API",
  T_48_META_API_1014_D: "以串列方式呼叫目前腳本中的自訂函數，如果自訂函數中存在等待，則呼叫位置也會等待",
  T_48_META_API_1014_P0: "功能編號",
  T_48_META_API_1014_P0_D: "目標呼叫的函數ID",
  T_48_META_API_1014_P1_D: "傳遞給自訂函數的實參列表",
  T_48_META_API_1015: "並行查找並呼叫自訂 API",
  T_48_META_API_1015_D: "以並行的方式呼叫自訂函數，無論自訂函數中是否存在等待，都會立即返回呼叫位置繼續向下執行",
  T_48_META_API_1015_P0: "按索引設定局部變數",
  T_48_META_API_1015_P0_D: "目標呼叫的函數ID",
  T_48_META_API_1015_P1_D: "傳遞給自訂函數的實參列表",
  T_48_META_API_1016_D: "取得呼叫此API時目標的類型",
  T_48_META_API_1016_P0_D: "被查詢的目標",
  T_48_META_API_1016_R_D: "變數類型",
  T_48_META_API_1017_D: "判斷目標變數是否為指定類型",
  T_48_META_API_1017_P0_D: "被查詢的目標",
  T_48_META_API_1017_P1_D: "被比較的類型",
  T_48_META_API_1017_R_D: "是否一致",
  T_48_META_API_1018_D: "判斷目標變數是否為某一類型的子類，回傳值是一個布林值",
  T_48_META_API_1018_P0_D: "被查詢的目標變數",
  T_48_META_API_1018_P1_D: "被比較的類型",
  T_48_META_API_1018_R_D: "是否為子類",
  T_48_META_API_1019_D: "使目標實體觸發指定自訂事件",
  T_48_META_API_1019_P0_D: "發送的自訂事件ID",
  T_48_META_API_1019_P1_D: "目標實體",
  T_48_META_API_1019_P2_D: "參數列表",
  T_48_META_API_102_D: "切換到指定場景，會解除安裝其他已載入場景",
  T_48_META_API_102_P0_D: "要切換至的場景ID",
  T_48_META_API_1020_D: "實現一個容器的遍歷，取得到每一對鍵值對，含有子過程，循環體就是子過程",
  T_48_META_API_1020_P0_D: "遍歷到鍵的名稱，可以使用它來取得到局部變數上的鍵值",
  T_48_META_API_1020_P1_D: "遍歷到值的名稱，可以使用它來取得到局部變數上的值",
  T_48_META_API_1020_P2_D: "要遍歷的容器",
  T_48_META_API_1021_D: "銷毀指定Bot",
  T_48_META_API_1021_P0_D: "需要被銷毀的Bot玩家",
  T_48_META_API_1022_D: "強制目標玩家離開載具",
  T_48_META_API_1022_P0_D: "目標玩家",
  T_48_META_API_1023_D: "創造傷害跳字",
  T_48_META_API_1023_P0_D: "跳字內容",
  T_48_META_API_1023_P1_D: "字體大小",
  T_48_META_API_1023_P2_D: "字體顏色",
  T_48_META_API_1023_P3_D: "停留時長，單位毫秒",
  T_48_META_API_1023_P4_D: "受到傷害的實體",
  T_48_META_API_1023_P5_D: "傷害跳字相對於目標實體世界座標的偏移量",
  T_48_META_API_1023_P6_D: "在傷害跳字位置再次進行隨機位置修正的範圍大小",
  T_48_META_API_1023_P7_D: "是否執行補間動畫",
  T_48_META_API_1024_D: "已廢棄",
  T_48_META_API_1024_P0_D: "已廢棄",
  T_48_META_API_1024_P1_D: "目標實體",
  T_48_META_API_1024_P2_D: "選取後,如果在服務端呼叫,則傳送給客戶端,客戶端呼叫則傳送給服務端",
  T_48_META_API_1024_P3_D: "參數列表",
  T_48_META_API_1025_D: "查詢自訂任務進度",
  T_48_META_API_1025_P0_D: "目標玩家",
  T_48_META_API_1025_P1_D: "自訂任務ID",
  T_48_META_API_1025_R_D: "任務進度",
  T_48_META_API_1026_D: "取得目標玩家的背包皮膚",
  T_48_META_API_1026_P0_D: "目標玩家",
  T_48_META_API_1026_R_D: "背包皮膚ID",
  T_48_META_API_1027_D: "設定目標玩家的背包皮膚",
  T_48_META_API_1027_P0_D: "目標玩家",
  T_48_META_API_1027_P1_D: "背包皮膚ID",
  T_48_META_API_1028_D: "恢復目標玩家的背包皮膚為預設局外配置",
  T_48_META_API_1028_P0_D: "目標玩家",
  T_48_META_API_1029_D: "清空目標玩家的背包皮膚",
  T_48_META_API_1029_P0_D: "目標玩家",
  T_48_META_API_103_D: "更換遊戲的天空盒環境樣式，可選擇白天、黃昏、黑夜等",
  T_48_META_API_103_P0_D: "天空盒類型",
  T_48_META_API_1030_D: "透過名字取得骨骼掛點部位",
  T_48_META_API_1030_P0_D: "目標實體",
  T_48_META_API_1030_P1_D: "骨骼掛點名稱",
  T_48_META_API_1030_R_D: "骨骼掛點",
  T_48_META_API_1031_D: "設定物件實體的父節點，支援掛載了Transform,SkeletonPart,Player,MountPoint元件的實體",
  T_48_META_API_1031_P0_D: "父節點",
  T_48_META_API_1031_P1_D: "子節點",
  T_48_META_API_1031_P2_D: "是否保留子節點目前世界位置、旋轉和縮放，UI設定該項無效",
  T_48_META_API_1032_D: "播放圖示動畫效果，圖示由起始位置以播放速度平移至結束位置",
  T_48_META_API_1032_P0_D: "圖示資源ID",
  T_48_META_API_1032_P1_D: "顏色",
  T_48_META_API_1032_P2_D: "圖示縮放",
  T_48_META_API_1032_P3_D: "起始位置中心",
  T_48_META_API_1032_P4_D: "起始區域範圍",
  T_48_META_API_1032_P5_D: "結束位置中心",
  T_48_META_API_1032_P6_D: "結束位置範圍",
  T_48_META_API_1032_P7_D: "播放速度，是圖示移動的每秒距離",
  T_48_META_API_1033_D: "進行反正切運算獲得角度",
  T_48_META_API_1033_P0_D: "Y軸座標",
  T_48_META_API_1033_P1_D: "X軸座標",
  T_48_META_API_1033_R_D: "角度，範圍(-180, 180]",
  T_48_META_API_1034_D: "新增元件到實體上，僅支援使用者建立的自訂元件",
  T_48_META_API_1034_P0_D: "目標實體",
  T_48_META_API_1034_P1_D: "組件類型ID，僅支援使用者建立的自訂組件",
  T_48_META_API_1034_P2_D: "是否成功添加，已存在的元件或非自訂元件會添加失敗",
  T_48_META_API_1035_D: "從實體上移除元件，僅支援自訂元件",
  T_48_META_API_1035_P0_D: "目標實體",
  T_48_META_API_1035_P1_D: "組件類型ID，僅支援使用者建立的自訂組件",
  T_48_META_API_1035_P2_D: "是否成功移除，不存在的元件或非自訂元件會移除失敗",
  T_48_META_API_1036_D: "自訂玩家中途退出介面",
  T_48_META_API_1036_P0_D: "標題",
  T_48_META_API_1036_P1_D: "內容",
  T_48_META_API_1036_P2_D: "選項",
  T_48_META_API_1036_P3_D: "是否顯示背景",
  T_48_META_API_1037_D: "取得目前已載入的所有場景",
  T_48_META_API_1037_R_D: "場景列表",
  T_48_META_API_1038_D: "取得玩家本地的瞄準方向",
  T_48_META_API_1038_R_D: "瞄準方向",
  T_48_META_API_1039_D: "取得本地時間戳",
  T_48_META_API_1039_R_D: "時間戳",
  T_48_META_API_104_D: "將玩家切換至指定場景的指定位置，未載入的場景會自動加載，不會自動卸載已載入的場景",
  T_48_META_API_104_P0_D: "玩家",
  T_48_META_API_104_P1_D: "要載入的場景ID",
  T_48_META_API_104_P2_D: "玩家在新場景的位置",
  T_48_META_API_104_P3_D: "玩家在新場景的朝向",
  T_48_META_API_1040_D: "暫停目前平台的固定幀更新，暫停後該平台的固定幀更新事件不再觸發",
  T_48_META_API_1041_D: "恢復目前平台的固定幀更新，恢復後該平台的固定幀更新事件重新開始觸發",
  T_48_META_API_1042_D: "判斷目標玩家與目前客戶端玩家的好友關係，目前客戶端本身不是目前客戶端的好友",
  T_48_META_API_1042_P0_D: "目標玩家",
  T_48_META_API_1042_R_D: "是否與目前客戶端是好友",
  T_48_META_API_1043_D: "觸發自訂事件",
  T_48_META_API_1043_P0_D: "自訂事件ID",
  T_48_META_API_1043_P1_D: "目標實體",
  T_48_META_API_1043_P2_D: "運行平台為服務端或客戶端",
  T_48_META_API_1043_P3_D: "參數列表",
  T_48_META_API_1044_D: "開啟跳傘",
  T_48_META_API_1044_P0_D: "目標玩家",
  T_48_META_API_1044_P1_D: "低於該高度會強制開傘",
  T_48_META_API_1044_P2_D: "滑翔時的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量為負時玩家向下降落",
  T_48_META_API_1044_P3_D: "俯衝時的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量為負時玩家向下降落",
  T_48_META_API_1044_P4_D: "開傘時的速度，X分量代表水平速度，Y分量代表垂直速度；Y分量為負時玩家向下降落",
  T_48_META_API_1045_D: "讀取資料表中指定標識符對應的值",
  T_48_META_API_1045_P0_D: "資料庫中表名",
  T_48_META_API_1045_P1_D: "玩家唯一ID",
  T_48_META_API_1045_P2_D: "指定標識符",
  T_48_META_API_1045_P3_D: "讀取的結果",
  T_48_META_API_1045_P4_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1045_P5_D: "錯誤碼",
  T_48_META_API_1046_D: "讀取排行榜資料表中指定標識符對應的值",
  T_48_META_API_1046_P0_D: "資料庫中排行榜表名",
  T_48_META_API_1046_P1_D: "指定標識符",
  T_48_META_API_1046_P2_D: "讀取的結果",
  T_48_META_API_1046_P3_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1046_P4_D: "錯誤碼",
  T_48_META_API_1047_D: "讀取排行榜資料表中指定名次區間的值",
  T_48_META_API_1047_P0_D: "資料庫中排行榜表名",
  T_48_META_API_1047_P1_D: "起始名次，須小於等於結束名次，名次從1開始計算",
  T_48_META_API_1047_P2_D: "結束名次",
  T_48_META_API_1047_P3_D: "讀取的結果",
  T_48_META_API_1047_P4_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1047_P5_D: "錯誤碼",
  T_48_META_API_1048_D: "讀取累計資料表中指定標識符對應的值",
  T_48_META_API_1048_P0_D: "資料庫中累計資料表名",
  T_48_META_API_1048_P1_D: "指定標識符",
  T_48_META_API_1048_P2_D: "讀取的結果",
  T_48_META_API_1048_P3_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1048_P4_D: "錯誤碼",
  T_48_META_API_1049_D: "寫入資料表中指定標識符對應的值",
  T_48_META_API_1049_P0_D: "資料庫中表名",
  T_48_META_API_1049_P1_D: "玩家唯一ID",
  T_48_META_API_1049_P2_D: "指定標識符",
  T_48_META_API_1049_P3_D: "寫入的值",
  T_48_META_API_1049_P4_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1049_P5_D: "錯誤碼",
  T_48_META_API_105_D: "取得場景的天空盒",
  T_48_META_API_105_P0_D: "場景ID",
  T_48_META_API_105_R_D: "天空盒",
  T_48_META_API_1050_D: "取得列表的元素個數",
  T_48_META_API_1050_P0_D: "目標清單",
  T_48_META_API_1050_R_D: "元素個數",
  T_48_META_API_1051_D: "取得清單中指定索引的元素值",
  T_48_META_API_1051_P0_D: "目標清單",
  T_48_META_API_1051_P1_D: "索引值，從0開始",
  T_48_META_API_1051_R_D: "元素值",
  T_48_META_API_1052_D: "設定清單中指定索引對應的元素值",
  T_48_META_API_1052_P0_D: "目標清單",
  T_48_META_API_1052_P1_D: "索引值，從0開始",
  T_48_META_API_1052_P2_D: "元素值",
  T_48_META_API_1053_D: "向清單尾部追加元素",
  T_48_META_API_1053_P0_D: "目標清單",
  T_48_META_API_1053_P1_D: "要新增的元素",
  T_48_META_API_1054_D: "從清單中刪除指定索引對應的元素",
  T_48_META_API_1054_P0_D: "目標清單",
  T_48_META_API_1054_P1_D: "索引值，從0開始",
  T_48_META_API_1055_D: "清空清單中所有元素",
  T_48_META_API_1055_P0_D: "目標清單",
  T_48_META_API_1056_D: "反轉指定列表，列表中的元素順序會反轉",
  T_48_META_API_1056_P0_D: "目標清單",
  T_48_META_API_1057_D: "複製一個列表",
  T_48_META_API_1057_P0_D: "目標清單",
  T_48_META_API_1057_R_D: "複製出的新列表",
  T_48_META_API_1058_D: "在清單中指定索引位置插入一個新元素，原先該索引位置及之後的元素會依序向後移動一位",
  T_48_META_API_1058_P0_D: "目標清單",
  T_48_META_API_1058_P1_D: "要插入的索引位置，索引從0開始計算",
  T_48_META_API_1058_P2_D: "要插入的新元素值",
  T_48_META_API_1059_D: "將清單中的元素重新隨機排序",
  T_48_META_API_1059_P0_D: "目標清單",
  T_48_META_API_1060_D: "對兩側參數進行比較，傳回true或false",
  T_48_META_API_1060_P0_D: "用來比較的左值",
  T_48_META_API_1060_P1_D: "比較方式，支援以下方式：>,>=,==,!=,<=,<,And(限定bool型別),Or(限定bool型別)",
  T_48_META_API_1060_P2_D: "用來比較的左值",
  T_48_META_API_1060_R_D: "比較結果",
  T_48_META_API_1061_D: "基本四則運算，包括加、減、乘、除和求餘。求餘運算僅支援整數，其餘運算支援整數或小數",
  T_48_META_API_1061_P0_D: "運算的左值",
  T_48_META_API_1061_P1_D: "四則運算的類型，包括加、減、乘、除和求餘，求餘運算不支援小數",
  T_48_META_API_1061_P2_D: "運算的右值",
  T_48_META_API_1061_R_D: "計算結果",
  T_48_META_API_1062_D: "在最小值整數（包含）和最大值整數（不包含）之間隨機產生一個整數",
  T_48_META_API_1062_P0_D: "隨機範圍左區間，有可能隨機到填入的值",
  T_48_META_API_1062_P1_D: "隨機範圍右區間，不會隨機到填入的值",
  T_48_META_API_1062_R_D: "隨機結果，整數",
  T_48_META_API_1063_D: "在最小值小數（包含）和最大值小數（不包含）之間隨機產生一個小數",
  T_48_META_API_1063_P0_D: "隨機範圍左區間，有很小可能隨機到填入的值",
  T_48_META_API_1063_P1_D: "隨機範圍右區間，不會隨機到填入的值",
  T_48_META_API_1063_R_D: "隨機結果，小數，精確到小數點後7位",
  T_48_META_API_1064_D: "判斷物件是否為空",
  T_48_META_API_1064_P0_D: "要判空的對象",
  T_48_META_API_1064_R_D: "是否為空",
  T_48_META_API_1065_D: "邏輯取反，輸入值：真或假，回傳值：假或真",
  T_48_META_API_1065_P0_D: "需要求非的值",
  T_48_META_API_1065_R_D: "求非的結果",
  T_48_META_API_1066_D: "取絕對值，支援整數和小數",
  T_48_META_API_1066_P0_D: "需要求絕對值的數值",
  T_48_META_API_1066_R_D: "取絕對值的結果",
  T_48_META_API_1067_D: "計算平方根",
  T_48_META_API_1067_P0_D: "需要求平方根的數值",
  T_48_META_API_1067_R_D: "求平方根的結果",
  T_48_META_API_1068_D: "計算負值",
  T_48_META_API_1068_P0_D: "需要求負值的數值",
  T_48_META_API_1068_R_D: "負值的結果",
  T_48_META_API_1069_D: "把兩個字串連接在一起",
  T_48_META_API_1069_P0_D: "字串左值",
  T_48_META_API_1069_P1_D: "字串右值",
  T_48_META_API_1069_R_D: "字串連接結果",
  T_48_META_API_1070_D: "取得字串長度",
  T_48_META_API_1070_P0_D: "字串",
  T_48_META_API_1070_R_D: "字串長度",
  T_48_META_API_1071_D: "對指定值按照向下取整方式取整",
  T_48_META_API_1071_P0_D: "需要向下取整的數值",
  T_48_META_API_1071_R_D: "向下取整的結果",
  T_48_META_API_1072_D: "對指定值依照向上取整方式取整",
  T_48_META_API_1072_P0_D: "需要向上取整的數值",
  T_48_META_API_1072_R_D: "向上取整的結果",
  T_48_META_API_1073_D: "對指定值依四捨五入方式取整",
  T_48_META_API_1073_P0_D: "需要四捨五入的數值",
  T_48_META_API_1073_R_D: "四捨五入的結果",
  T_48_META_API_1074_D: "將目標字串中的所有指定字串替換後，輸出新字串",
  T_48_META_API_1074_P0_D: "目標字串",
  T_48_META_API_1074_P1_D: "要替換掉的舊字串",
  T_48_META_API_1074_P2_D: "要替換為的新字串",
  T_48_META_API_1074_R_D: "替換完成的字串",
  T_48_META_API_1075_D: "在目標字串重查找一段指定字串第一次出現的位置",
  T_48_META_API_1075_P0_D: "目標字串",
  T_48_META_API_1075_P1_D: "要尋找的指定字串",
  T_48_META_API_1075_P2_D: "從起始位置找出字串，字串位置從0開始計算",
  T_48_META_API_1075_R_D: "指定字串在目標字串中第一次出現的位置，字串位置從0開始計算",
  T_48_META_API_1076_D: "從指定位置開始截取指定長度的字串後，輸出新字串",
  T_48_META_API_1076_P0_D: "目標字串",
  T_48_META_API_1076_P1_D: "開始截取的位置，字串位置從0開始計算",
  T_48_META_API_1076_P2_D: "截取長度，缺省時截取到字串結束",
  T_48_META_API_1076_R_D: "截取到的字串",
  T_48_META_API_1077_D: "比較兩個清單元素是否完全相同，列表容量不影響比較結果",
  T_48_META_API_1077_P0_D: "用來比較的列表左值",
  T_48_META_API_1077_P1_D: "用來比較的列表右值",
  T_48_META_API_1077_R_D: "比較結果，內容一致回傳True，內容不一致回傳False",
  T_48_META_API_1078_D: "以指定字串為分隔符，將目標字串切割為若干個切片後輸出新字串，連續的N個分隔符會切割為N-1個半角空格作為字串列表元素輸出",
  T_48_META_API_1078_P0_D: "目標字串",
  T_48_META_API_1078_P1_D: "分隔符號字串",
  T_48_META_API_1078_R_D: "輸出的字串列表，總是有一個半角空格元素作為結尾",
  T_48_META_API_1079_D: "根據字串位置列表提取字符，組合為新的字串輸出",
  T_48_META_API_1079_P0_D: "目標字串",
  T_48_META_API_1079_P1_D: "字串位置列表，字串位置從0開始計算",
  T_48_META_API_1079_R_D: "輸出的字串",
  T_48_META_API_1080_D: "將目標字串字元全部轉換為大寫",
  T_48_META_API_1080_P0_D: "目標字串",
  T_48_META_API_1080_R_D: "輸出的字串",
  T_48_META_API_1081_D: "將目標字串字元全部轉換為小寫",
  T_48_META_API_1081_P0_D: "目標字串",
  T_48_META_API_1081_R_D: "輸出的字串",
  T_48_META_API_1082_D: "去除目標字串第一個非空格字元以前和最後一個非空格字元以後的所有空格",
  T_48_META_API_1082_P0_D: "目標字串",
  T_48_META_API_1082_R_D: "輸出的字串",
  T_48_META_API_1083_D: "以指定標識符連結後輸出新字串",
  T_48_META_API_1083_P0_D: "目標字串列表",
  T_48_META_API_1083_P1_D: "用來連接字串的指定標識符",
  T_48_META_API_1083_R_D: "輸出的字串",
  T_48_META_API_1084_D: "寫入排行榜資料表中指定標識符對應的值",
  T_48_META_API_1084_P0_D: "資料庫中排行榜表名",
  T_48_META_API_1084_P1_D: "指定標識符",
  T_48_META_API_1084_P2_D: "寫入的值",
  T_48_META_API_1084_P3_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1084_P4_D: "錯誤碼",
  T_48_META_API_1085_D: "寫入累計資料表中指定標識符對應的偏移值",
  T_48_META_API_1085_P0_D: "資料庫中累計資料表名",
  T_48_META_API_1085_P1_D: "指定標識符",
  T_48_META_API_1085_P2_D: "四則運算的類型",
  T_48_META_API_1085_P3_D: "寫入的偏移值",
  T_48_META_API_1085_P4_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1085_P5_D: "錯誤碼",
  T_48_META_API_1086_D: "刪除資料表中指定標識符對應的值",
  T_48_META_API_1086_P0_D: "資料庫中表名",
  T_48_META_API_1086_P1_D: "玩家唯一ID",
  T_48_META_API_1086_P2_D: "指定標識符",
  T_48_META_API_1086_P3_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1086_P4_D: "錯誤碼",
  T_48_META_API_1087_D: "刪除排行榜資料表中指定標識符對應的值",
  T_48_META_API_1087_P0_D: "資料庫中排行榜表名",
  T_48_META_API_1087_P1_D: "指定標識符",
  T_48_META_API_1087_P2_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1087_P3_D: "錯誤碼",
  T_48_META_API_1088_D: "刪除排行榜資料表中指定名次對應的值",
  T_48_META_API_1088_P0_D: "資料庫中排行榜表名",
  T_48_META_API_1088_P1_D: "指定名次",
  T_48_META_API_1088_P2_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_1088_P3_D: "錯誤碼",
  T_48_META_API_1089_D: "發送用戶訊息給Persona",
  T_48_META_API_1089_P0_D: "目標PersonaID",
  T_48_META_API_1089_P1_D: "訊息內容",
  T_48_META_API_1090_D: "發送系統訊息給Persona",
  T_48_META_API_1090_P0_D: "目標PersonaID",
  T_48_META_API_1090_P1_D: "訊息內容",
  T_48_META_API_1091_D: "清除Persona記憶",
  T_48_META_API_1091_P0_D: "錯誤碼",
  T_48_META_API_1092_D: "喚起會員中心",
  T_48_META_API_1092_P0_D: "錯誤碼",
  T_48_META_API_1093_D: "取得會員到期時間戳",
  T_48_META_API_1093_P0_D: "目標玩家",
  T_48_META_API_1093_P1_D: "時間戳",
  T_48_META_API_1093_P2_D: "錯誤碼",
  T_48_META_API_1094_D: "判斷玩家是否為會員",
  T_48_META_API_1094_P0_D: "錯誤碼",
  T_48_META_API_1094_P1_D: "是否為會員",
  T_48_META_API_1095_D: "取得會員到期時間戳",
  T_48_META_API_1095_P0_D: "時間戳",
  T_48_META_API_1095_P1_D: "錯誤碼",
  T_48_META_API_1096_D: "判斷玩家是否為會員",
  T_48_META_API_1096_P0_D: "目標玩家",
  T_48_META_API_1096_P1_D: "錯誤碼",
  T_48_META_API_1096_P2_D: "是否為會員",
  T_48_META_API_1097_D: "喚起會員中心",
  T_48_META_API_1097_P0_D: "目標玩家",
  T_48_META_API_1097_P1_D: "錯誤碼",
  T_48_META_API_1099_D: "設定Persona觀察者，此後和Persona的對話也會傳送給觀察者",
  T_48_META_API_1099_P0_D: "目標PersonaID",
  T_48_META_API_1099_P1_D: "觀察者列表",
  T_48_META_API_11_D: "結束目前階段，並進入下一階段",
  T_48_META_API_1100_D: "使用串流傳輸發送用戶訊息給Persona",
  T_48_META_API_1100_P0_D: "目標PersonaID",
  T_48_META_API_1100_P1_D: "訊息內容",
  T_48_META_API_1101_D: "使用串流傳輸發送系統訊息給Persona",
  T_48_META_API_1101_P0_D: "目標PersonaID",
  T_48_META_API_1101_P1_D: "訊息內容",
  T_48_META_API_1101_P2_D: "是否應回复",
  T_48_META_API_1103_D: "創建隨機種子",
  T_48_META_API_1103_P0_D: "種子",
  T_48_META_API_1103_R_D: "隨機數產生器",
  T_48_META_API_1104_D: "取得指定隨機數產生器的下一個隨機數，最大值32767",
  T_48_META_API_1104_P0_D: "隨機數產生器",
  T_48_META_API_1104_P1_D: "範圍最小值",
  T_48_META_API_1104_P2_D: "範圍最大值",
  T_48_META_API_1104_R_D: "隨機數",
  T_48_META_API_1108_D: "獲取玩家使用的客戶端語言",
  T_48_META_API_12_D: "列印日誌到控制台",
  T_48_META_API_12_P0_D: "需要列印的內容",
  T_48_META_API_13_D: "輸出帶有參數的字串",
  T_48_META_API_13_P0_D: "使用%v佔位符代表一個參數，%v的個數和參數個數需要保持一致",
  T_48_META_API_13_P1_D: "參與輸出的參數列表，需要和格式描述中的%v個數保持一致",
  T_48_META_API_13_R_D: "輸出的字串",
  T_48_META_API_14_D: "清理地圖物件殘留，包含死亡盒子、創建的物件、擺放的物件、投擲物殘留等",
  T_48_META_API_15_D: "自訂比賽埋點日誌，用於使用者體驗資料分析",
  T_48_META_API_15_P0_D: "要上報字段名的列表",
  T_48_META_API_15_P1_D: "要上報欄位值的列表",
  T_48_META_API_1500_D: "取得三維向量的X分量",
  T_48_META_API_1500_P0_D: "三維向量",
  T_48_META_API_1500_R_D: "三維向量X分量",
  T_48_META_API_1501_D: "取得三維向量的Y分量",
  T_48_META_API_1501_P0_D: "三維向量",
  T_48_META_API_1501_R_D: "三維向量Y分量",
  T_48_META_API_1502_D: "取得三維向量的Z分量",
  T_48_META_API_1502_P0_D: "三維向量",
  T_48_META_API_1502_R_D: "三維向量Z分量",
  T_48_META_API_1503_D: "設定三維向量的X分量",
  T_48_META_API_1503_P0_D: "三維向量",
  T_48_META_API_1503_P1_D: "X分量",
  T_48_META_API_1504_D: "設定三維向量的Y分量",
  T_48_META_API_1504_P0_D: "三維向量",
  T_48_META_API_1504_P1_D: "Y分量",
  T_48_META_API_1505_D: "設定三維向量的Z分量",
  T_48_META_API_1505_P0_D: "三維向量",
  T_48_META_API_1505_P1_D: "Z分量",
  T_48_META_API_1506_D: "將兩個三維向量相加",
  T_48_META_API_1506_P0_D: "左值",
  T_48_META_API_1506_P1_D: "右值",
  T_48_META_API_1506_R_D: "三維向量相加結果",
  T_48_META_API_1507_D: "將兩個三維向量相減",
  T_48_META_API_1507_P0_D: "左值",
  T_48_META_API_1507_P1_D: "右值",
  T_48_META_API_1507_R_D: "三維向量左值減去右值的結果",
  T_48_META_API_1508_D: "將三維向量進行縮放",
  T_48_META_API_1508_P0_D: "需要縮放的三維向量",
  T_48_META_API_1508_P1_D: "三維向量縮放量",
  T_48_META_API_1508_R_D: "三維向量縮放結果",
  T_48_META_API_1509_D: "將兩個三維向量點乘，點乘結果為標量",
  T_48_META_API_1509_P0_D: "左值",
  T_48_META_API_1509_P1_D: "右值",
  T_48_META_API_1509_R_D: "點乘結果",
  T_48_META_API_1510_D: "將兩個三維向量叉乘，叉乘結果為向量，垂直於兩個向量所在的平面",
  T_48_META_API_1510_P0_D: "左值",
  T_48_META_API_1510_P1_D: "右值",
  T_48_META_API_1510_R_D: "叉乘結果，方向垂直於參與運算的兩個向量所在的平面",
  T_48_META_API_1511_D: "對三維向量歸一化",
  T_48_META_API_1511_P0_D: "三維向量",
  T_48_META_API_1511_R_D: "傳回一個新的歸一化向量。模長為1",
  T_48_META_API_1512_D: "對三維向量取模",
  T_48_META_API_1512_P0_D: "三維向量",
  T_48_META_API_1512_R_D: "取模結果，為向量模的長度",
  T_48_META_API_1513_D: "計算兩個三維向量的歐氏距離",
  T_48_META_API_1513_P0_D: "左值",
  T_48_META_API_1513_P1_D: "右值",
  T_48_META_API_1513_R_D: "兩向量相減後，所得向量的模長",
  T_48_META_API_1514_D: "計算兩個三維向量的夾角",
  T_48_META_API_1514_P0_D: "左值",
  T_48_META_API_1514_P1_D: "右值",
  T_48_META_API_1514_R_D: "向量夾角，角度範圍0-180",
  T_48_META_API_1515_D: "建立一個三維向量",
  T_48_META_API_1515_P0_D: "三維向量的X分量",
  T_48_META_API_1515_P1_D: "三維向量的Y分量",
  T_48_META_API_1515_P2_D: "三維向量的Z分量",
  T_48_META_API_1515_R_D: "創建出的三維向量",
  T_48_META_API_1516_D: "取得一個新構造的方向點（已廢棄，請勿使用）",
  T_48_META_API_1516_P0_D: "位置",
  T_48_META_API_1516_P1_D: "朝向",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "取方向點位置（已廢棄，請勿使用）",
  T_48_META_API_1517_P0_D: "方向點",
  T_48_META_API_1517_R_D: "Position",
  T_48_META_API_1518_D: "取方向點朝向（已廢棄，請勿使用）",
  T_48_META_API_1518_P0_D: "方向點",
  T_48_META_API_1518_R_D: "Forward",
  T_48_META_API_1519_D: "創建一個列表",
  T_48_META_API_1519_P0_D: "清單的初始長度，必須小於等於初始容量",
  T_48_META_API_1519_P1_D: "清單的初始容量，必須大於等於初始長度。容量可以動態擴充，但是會消耗一定性能，建議構造時就設定一個合適的值。",
  T_48_META_API_1519_R_D: "創建出的列表",
  T_48_META_API_1520_D: "檢查清單是否包含指定元素",
  T_48_META_API_1520_P0_D: "目標清單",
  T_48_META_API_1520_P1_D: "要檢查的指定元素",
  T_48_META_API_1520_R_D: "是否包含指定元素",
  T_48_META_API_1521_D: "向目標清單尾部追加多個元素",
  T_48_META_API_1521_P0_D: "目標清單",
  T_48_META_API_1521_P1_D: "追加列表",
  T_48_META_API_1522_D: "從清單中移除指定元素",
  T_48_META_API_1522_P0_D: "目標清單",
  T_48_META_API_1522_P1_D: "要移除的元素值",
  T_48_META_API_1523_D: "取得清單中元素最先出現的位置索引，清單中無目標元素則傳回-1",
  T_48_META_API_1523_P0_D: "目標清單",
  T_48_META_API_1523_P1_D: "元素值",
  T_48_META_API_1523_R_D: "位置索引",
  T_48_META_API_1524_D: "取得清單中元素最後出現的位置索引，清單中無目標元素則傳回-1",
  T_48_META_API_1524_P0_D: "目標清單",
  T_48_META_API_1524_P1_D: "元素值",
  T_48_META_API_1524_R_D: "位置索引",
  T_48_META_API_1525_D: "求角度的正弦值",
  T_48_META_API_1525_P0_D: "角度，360代表360度",
  T_48_META_API_1525_R_D: "正弦值",
  T_48_META_API_1526_D: "求角度的餘弦值",
  T_48_META_API_1526_P0_D: "角度，360代表360度",
  T_48_META_API_1526_R_D: "餘弦值",
  T_48_META_API_1527_D: "求角度的正切值",
  T_48_META_API_1527_P0_D: "角度，360代表360度",
  T_48_META_API_1527_R_D: "正切值",
  T_48_META_API_1528_D: "建立一個顏色值，透明度固定為十進制255，先將通道轉換為二進制數，每8位代表一個通道，按照R、G、B、透明度拼接，然後將該二進制數轉換為Int32型返回",
  T_48_META_API_1528_P0_D: "顏色的紅色通道值，取值範圍[0,255]，超過範圍會clamp至合法值",
  T_48_META_API_1528_P1_D: "顏色的綠色通道值，取值範圍[0,255]，超過範圍會clamp至合法值",
  T_48_META_API_1528_P2_D: "顏色的藍色通道值，取值範圍[0,255]，超過範圍會clamp至合法值",
  T_48_META_API_1528_R_D: "建構的顏色值",
  T_48_META_API_1529_D: "進行反正弦運算獲得角度",
  T_48_META_API_1529_P0_D: "進行反正弦運算的值，取值範圍[-1,1]",
  T_48_META_API_1529_R_D: "角度",
  T_48_META_API_1530_D: "進行反餘弦運算獲得角度",
  T_48_META_API_1530_P0_D: "進行反餘弦運算的值，取值範圍[-1,1]",
  T_48_META_API_1530_R_D: "角度",
  T_48_META_API_1531_D: "進行反正切運算獲得角度",
  T_48_META_API_1531_P0_D: "進行反正切運算的值",
  T_48_META_API_1531_R_D: "角度",
  T_48_META_API_1532_D: "判斷目標實體是否在規定的球體範圍內，如果實體沒有位置屬性，會回傳假",
  T_48_META_API_1532_P0_D: "目標實體",
  T_48_META_API_1532_P1_D: "規定球體的球心",
  T_48_META_API_1532_P2_D: "規定球體的半徑",
  T_48_META_API_1532_R_D: "判定結果",
  T_48_META_API_1533_D: "判斷目標實體是否在規定的圓柱體範圍內，如果實體沒有位置屬性，會回傳假",
  T_48_META_API_1533_P0_D: "目標實體",
  T_48_META_API_1533_P1_D: "規定圓柱體的中心點",
  T_48_META_API_1533_P2_D: "規定圓柱體的截面半徑",
  T_48_META_API_1533_P3_D: "規定圓柱體的高度",
  T_48_META_API_1533_P4_D: "規定圓柱體繞中心點的三維旋轉歐拉角",
  T_48_META_API_1533_R_D: "判定結果",
  T_48_META_API_1534_D: "判斷目標實體是否在規定的立方體範圍內",
  T_48_META_API_1534_P0_D: "目標實體",
  T_48_META_API_1534_P1_D: "規定立方體的中心點",
  T_48_META_API_1534_P2_D: "規定立方體的長",
  T_48_META_API_1534_P3_D: "規定立方體的寬",
  T_48_META_API_1534_P4_D: "規定立方體的高",
  T_48_META_API_1534_P5_D: "規定立方體繞中心點的三維旋轉歐拉角",
  T_48_META_API_1534_R_D: "判定結果",
  T_48_META_API_1535_D: "判斷目標實體是否在規定的扇形柱體範圍內",
  T_48_META_API_1535_P0_D: "目標實體",
  T_48_META_API_1535_P1_D: "規定扇形柱體的中截面圓心",
  T_48_META_API_1535_P2_D: "規定扇形柱體的中截面半徑",
  T_48_META_API_1535_P3_D: "不進行檢測的扇形柱體截面半徑，以中心點為圓心，該小扇形柱體區域不會進行檢測，只會檢測規定扇形柱體和小扇形主題的差",
  T_48_META_API_1535_P4_D: "規定扇形柱體的高度",
  T_48_META_API_1535_P5_D: "進行檢測的扇形柱體截面圓心角，大於360時以圓柱形進行檢測，小於0時檢測區域大小為0",
  T_48_META_API_1535_P6_D: "規定扇形柱體繞中心點的三位旋轉歐拉角",
  T_48_META_API_1535_R_D: "判定結果",
  T_48_META_API_1536_D: "比較兩個數字的值，回傳較大的一個",
  T_48_META_API_1536_P0_D: "左值",
  T_48_META_API_1536_P1_D: "右值",
  T_48_META_API_1536_R_D: "較大的數字",
  T_48_META_API_1537_D: "傳回清單中的最大值",
  T_48_META_API_1537_P0_D: "目標列表，只接受列表元素類型為數字",
  T_48_META_API_1537_P1_D: "比較結果，列表中存在非數字等情況時比較失敗，返回假",
  T_48_META_API_1537_P2_D: "比較成功時傳回清單中最大的值，比較失敗時回傳0",
  T_48_META_API_1538_D: "比較兩個數字的值，回傳較小的一個",
  T_48_META_API_1538_P0_D: "左值",
  T_48_META_API_1538_P1_D: "右值",
  T_48_META_API_1538_R_D: "較小的數字",
  T_48_META_API_1539_D: "傳回列表中的最小值。",
  T_48_META_API_1539_P0_D: "目標列表，只接受列表元素類型為數字",
  T_48_META_API_1539_P1_D: "比較結果，列表中存在非數字等情況時比較失敗，返回假",
  T_48_META_API_1539_P2_D: "比較成功時傳回列表中最小的值，比較失敗時回傳0",
  T_48_META_API_1540_D: "線性內插值，在開始值到目標值之間傳回插值進度對應的值，插值係數[0,1]",
  T_48_META_API_1540_P0_D: "線性內插開始值，插值進度為0時傳回該值",
  T_48_META_API_1540_P1_D: "線性內插目標值，內插進度為1時傳回該值",
  T_48_META_API_1540_P2_D: "內插進度，取值範圍[0,1]，取值為0時傳回開始值、取值為1時回傳目標值、取值為0.5時傳回開始值和目標值的平均值",
  T_48_META_API_1540_R_D: "線性插值返回值",
  T_48_META_API_1541_D: "限制目標值的範圍，取得三個入參中大小處於中間的值；其作用是將目標值限製到指定範圍內，目標值比最小值小時返回最小值，比最大值大時返回最大值，處於範圍中時返回自身",
  T_48_META_API_1541_P0_D: "目標值",
  T_48_META_API_1541_P1_D: "限定範圍的最小值",
  T_48_META_API_1541_P2_D: "限定範圍的最大值",
  T_48_META_API_1541_R_D: "限制後的回傳值",
  T_48_META_API_1542_D: "取得目標顏色的各通道值",
  T_48_META_API_1542_P0_D: "目標顏色",
  T_48_META_API_1542_P1_D: "顏色的R值，範圍[0 , 255]",
  T_48_META_API_1542_P2_D: "顏色的G值，範圍[0 , 255]",
  T_48_META_API_1542_P3_D: "顏色的B值，範圍[0 , 255]",
  T_48_META_API_1542_P4_D: "顏色的A值，範圍[0 , 255]",
  T_48_META_API_1543_D: "求冪運算",
  T_48_META_API_1543_P0_D: "底數",
  T_48_META_API_1543_P1_D: "指數",
  T_48_META_API_1543_R_D: "計算結果",
  T_48_META_API_1544_D: "對數運算",
  T_48_META_API_1544_P0_D: "底數",
  T_48_META_API_1544_P1_D: "真數",
  T_48_META_API_1544_R_D: "計算結果",
  T_48_META_API_1545_D: "方向向量轉歐拉角",
  T_48_META_API_1545_P0_D: "方向向量",
  T_48_META_API_1545_R_D: "歐拉角",
  T_48_META_API_1546_D: "歐拉角轉方向向量",
  T_48_META_API_1546_P0_D: "歐拉角",
  T_48_META_API_1546_R_D: "方向向量",
  T_48_META_API_1547_D: "整數轉浮點數",
  T_48_META_API_1547_P0_D: "整數",
  T_48_META_API_1547_R_D: "浮點數",
  T_48_META_API_1548_D: "根據四元數旋轉目標向量",
  T_48_META_API_1548_P0_D: "目標向量",
  T_48_META_API_1548_P1_D: "旋轉四元數",
  T_48_META_API_1548_R_D: "旋轉後的向量",
  T_48_META_API_1549_D: "將目標數字轉換為字串",
  T_48_META_API_1549_P0_D: "要轉字串的目標數字",
  T_48_META_API_1549_P1_D: "輸出的數字字串格式",
  T_48_META_API_1549_R_D: "字串",
  T_48_META_API_1598_D: "取得伺服器時間戳",
  T_48_META_API_1598_R_D: "傳回1970年1月1日0時0分0秒開始的秒數",
  T_48_META_API_1599_D: "取得伺服器區域",
  T_48_META_API_1599_R_D: "返回區域縮寫(BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "自訂使用者埋點日誌，用於使用者體驗資料分析",
  T_48_META_API_16_P0_D: "要記錄上報的玩家",
  T_48_META_API_16_P1_D: "要上報字段名的列表",
  T_48_META_API_16_P2_D: "要上報欄位值的列表",
  T_48_META_API_1601_D: "創建一個字典",
  T_48_META_API_1601_R_D: "創建出的字典",
  T_48_META_API_1602_D: "取得字典中指定鍵對應的值",
  T_48_META_API_1602_P0_D: "目標字典",
  T_48_META_API_1602_P1_D: "鍵",
  T_48_META_API_1602_R_D: "值",
  T_48_META_API_1603_D: "設定字典中指定鍵對應的值",
  T_48_META_API_1603_P0_D: "目標字典",
  T_48_META_API_1603_P1_D: "鍵",
  T_48_META_API_1603_P2_D: "值",
  T_48_META_API_1604_D: "移除字典指定鍵值對",
  T_48_META_API_1604_P0_D: "目標字典",
  T_48_META_API_1604_P1_D: "鍵",
  T_48_META_API_1605_D: "清空字典中所有鍵值對",
  T_48_META_API_1605_P0_D: "目標字典",
  T_48_META_API_1606_D: "取得字典中鍵值對的數量",
  T_48_META_API_1606_P0_D: "目標字典",
  T_48_META_API_1606_R_D: "字典長度",
  T_48_META_API_1607_D: "判斷字典中某個鍵是否存在",
  T_48_META_API_1607_P0_D: "目標字典",
  T_48_META_API_1607_P1_D: "鍵",
  T_48_META_API_1607_R_D: "是否存在",
  T_48_META_API_1608_D: "取得字典的所有鍵，以列表形式返回",
  T_48_META_API_1608_P0_D: "目標字典",
  T_48_META_API_1608_R_D: "所有鍵值的列表",
  T_48_META_API_17_D: "使用一個直線運動的盒形區域進行檢測，從近到遠地返回盒形區域路線上碰到的所有實體，初始即在盒形範圍內則不會檢測出來；層級參若填空，則可以檢測到地形",
  T_48_META_API_17_P0_D: "盒形區域三邊長的一半，只接受正值",
  T_48_META_API_17_P1_D: "盒形區域中心點",
  T_48_META_API_17_P2_D: "盒形區域旋轉",
  T_48_META_API_17_P3_D: "盒形區域行進方向",
  T_48_META_API_17_P4_D: "盒形區域行進距離，只接受正值",
  T_48_META_API_17_P5_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_17_P6_D: "是否可以偵測出觸發器",
  T_48_META_API_17_P7_D: "命中的實體列表",
  T_48_META_API_1700_D: "將指定字串轉為整數",
  T_48_META_API_1700_P0_D: "目標字串",
  T_48_META_API_1700_P1_D: "結果整數",
  T_48_META_API_1700_P2_D: "是否轉化成功",
  T_48_META_API_1701_D: "將指定字串轉為浮點數",
  T_48_META_API_1701_P0_D: "目標字串",
  T_48_META_API_1701_P1_D: "結果浮點數",
  T_48_META_API_1701_P2_D: "是否轉化成功",
  T_48_META_API_18_D: "使用一個直線運動的球形區域進行檢測，從近到遠地返回球形區域路線上碰到的所有實體，初始即在球形區域內則不會檢測出來；層級參若填空，則可以檢測到地形",
  T_48_META_API_18_P0_D: "球形區域半徑，只接受正值",
  T_48_META_API_18_P1_D: "球形區域中心點",
  T_48_META_API_18_P2_D: "球形區域行進方向",
  T_48_META_API_18_P3_D: "球形區域行進距離，只接受正值",
  T_48_META_API_18_P4_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_18_P5_D: "是否可以偵測出觸發器",
  T_48_META_API_18_P6_D: "命中的實體列表",
  T_48_META_API_19_D: "使用直線運動的膠囊體區域進行檢測，從近到遠地返回膠囊體區域路線上碰到的所有實體，初始即在膠囊體區域內則不會檢測出來；層級參若填空，則可以檢測到地形",
  T_48_META_API_19_P0_D: "膠囊體區域兩端半球半徑，只接受正值",
  T_48_META_API_19_P1_D: "膠囊體區域兩端半球球心距離，此值必須大於兩端半球半徑的二倍",
  T_48_META_API_19_P2_D: "膠囊體區域的中心點",
  T_48_META_API_19_P3_D: "膠囊體區域的旋轉",
  T_48_META_API_19_P4_D: "膠囊體區域的行進方向",
  T_48_META_API_19_P5_D: "膠囊體區域的行進距離，只接受正值",
  T_48_META_API_19_P6_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_19_P7_D: "是否可以偵測出觸發器",
  T_48_META_API_19_P8_D: "命中的實體列表",
  T_48_META_API_2_D: "取得目前遊戲中所有隊伍，返回隊伍清單。",
  T_48_META_API_2_R_D: "隊伍列表",
  T_48_META_API_20_D: "使用一個靜止的盒形區域進行偵測，返回盒形區域內的所有實體，層級參若填空，則可以偵測到地形",
  T_48_META_API_20_P0_D: "盒形區域三邊長的一半，只接受正值",
  T_48_META_API_20_P1_D: "盒形區域中心點",
  T_48_META_API_20_P2_D: "盒形區域旋轉",
  T_48_META_API_20_P3_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_20_P4_D: "是否可以偵測出觸發器",
  T_48_META_API_20_P5_D: "命中的實體列表",
  T_48_META_API_2000_D: "設定目標實體的屬性值，需要該屬性已經被定義過",
  T_48_META_API_2000_P0_D: "目標實體",
  T_48_META_API_2000_P1_D: "目標實體的某個屬性",
  T_48_META_API_2000_P2_D: "目標值，需要符合屬性定義時要求的類型",
  T_48_META_API_2000_P3_D: "運算方式，所有類型都支援賦值，數字類型也支援自加、自減、自乘、自除、自餘",
  T_48_META_API_2001_D: "取得一個實體的屬性值",
  T_48_META_API_2001_P0_D: "目標實體",
  T_48_META_API_2001_P1_D: "該實體的某個屬性ID",
  T_48_META_API_2001_R_D: "屬性值",
  T_48_META_API_2002: "設定圖形屬性",
  T_48_META_API_2002_D: "設定腳本變數",
  T_48_META_API_2002_P0_D: "目標實體",
  T_48_META_API_2002_P1: "圖ID",
  T_48_META_API_2002_P1_D: "目標腳本ID",
  T_48_META_API_2002_P2: "物業編號",
  T_48_META_API_2002_P2_D: "腳本中定義的成員屬性ID",
  T_48_META_API_2002_P3: "物業價值",
  T_48_META_API_2002_P3_D: "目標值，需要符合屬性定義時要求的類型",
  T_48_META_API_2002_P4_D: "運算方式，所有類型都支援賦值，數字類型也支援自加、自減、自乘、自除、自餘",
  T_48_META_API_2003: "取得圖屬性",
  T_48_META_API_2003_D: "取得腳本變數",
  T_48_META_API_2003_P0_D: "目標實體",
  T_48_META_API_2003_P1: "圖ID",
  T_48_META_API_2003_P1_D: "目標腳本ID",
  T_48_META_API_2003_P2: "物業編號",
  T_48_META_API_2003_P2_D: "目標屬性ID",
  T_48_META_API_2003_R_D: "屬性值",
  T_48_META_API_2004_D: "定義並初始化一個局部變量，局部變量作用域為從聲明位置開始到所在語句塊結束",
  T_48_META_API_2004_P0_D: "變數名稱",
  T_48_META_API_2004_P1_D: "變數初始值",
  T_48_META_API_2004_P2_D: "變數宣告類型，賦值時需要符合宣告的型別",
  T_48_META_API_2005_D: "設定局部變數值，局部變數作用域為從宣告位置開始到所在語句區塊結束",
  T_48_META_API_2005_P0_D: "變數名稱",
  T_48_META_API_2005_P1: "變數值",
  T_48_META_API_2005_P1_D: "變數值",
  T_48_META_API_2005_P2_D: "運算方式，所有類型都支援賦值，數字類型也支援自加、自減、自乘、自除、自餘",
  T_48_META_API_2006: "取得局部變數",
  T_48_META_API_2006_D: "取得局部變數值，局部變數作用域為從宣告位置開始到所在語句區塊結束",
  T_48_META_API_2006_P0: "變數名",
  T_48_META_API_2006_P0_D: "變數名稱",
  T_48_META_API_2006_R_D: "變數值",
  T_48_META_API_2009: "使用串行查找並調用全域自訂 API",
  T_48_META_API_2009_D: "以串行的方式呼叫全域自訂函數，如果自訂函數中存在等待，則呼叫位置也進行等待",
  T_48_META_API_2009_P0: "圖ID",
  T_48_META_API_2009_P0_D: "自訂函數所在的腳本ID",
  T_48_META_API_2009_P1: "功能編號",
  T_48_META_API_2009_P1_D: "呼叫的自訂函數ID",
  T_48_META_API_2009_P2_D: "傳遞給自訂函數的參數列表",
  T_48_META_API_2010: "使用 Parallel 尋找並呼叫全域自訂 API",
  T_48_META_API_2010_D: "以並行的方式呼叫全域自訂函數，無論自訂函數中是否存在等待，都會立即返回呼叫位置繼續向下執行",
  T_48_META_API_2010_P0: "圖ID",
  T_48_META_API_2010_P0_D: "自訂函數所在的腳本ID",
  T_48_META_API_2010_P1: "功能編號",
  T_48_META_API_2010_P1_D: "呼叫的自訂函數ID",
  T_48_META_API_2010_P2_D: "傳遞給自訂函數的參數列表",
  T_48_META_API_2013: "設定自圖屬性",
  T_48_META_API_2013_D: "設定當前腳本的變數",
  T_48_META_API_2013_P0: "物業編號",
  T_48_META_API_2013_P0_D: "目標屬性ID",
  T_48_META_API_2013_P1: "物業價值",
  T_48_META_API_2013_P1_D: "目標值",
  T_48_META_API_2013_P2_D: "運算方式，所有類型都支援賦值，數字類型也支援自加、自減、自乘、自除、自餘",
  T_48_META_API_2014: "取得自圖屬性",
  T_48_META_API_2014_D: "取得目前腳本的變數",
  T_48_META_API_2014_P0: "物業編號",
  T_48_META_API_2014_P0_D: "目標屬性ID",
  T_48_META_API_2014_R_D: "屬性值",
  T_48_META_API_21_D: "使用一個靜止的球形區域進行偵測，返回球形區域內的所有實體，層級參若填空，則可以偵測到地形",
  T_48_META_API_21_P0_D: "球形區域半徑，只接受正值",
  T_48_META_API_21_P1_D: "球形區域中心點",
  T_48_META_API_21_P2_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_21_P3_D: "是否可以偵測出觸發器",
  T_48_META_API_21_P4_D: "命中的實體列表",
  T_48_META_API_22_D: "使用一個靜止的膠囊體區域進行檢測，返回膠囊體區域內的所有實體，層級參若填空，則可以檢測到地形",
  T_48_META_API_22_P0_D: "膠囊體區域兩端半球半徑，只接受正值",
  T_48_META_API_22_P1_D: "膠囊體區域兩端半球球心距離，此值必須大於兩端半球半徑的二倍",
  T_48_META_API_22_P2_D: "膠囊體區域的中心點",
  T_48_META_API_22_P3_D: "膠囊體區域的旋轉",
  T_48_META_API_22_P4_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_22_P5_D: "是否可以偵測出觸發器",
  T_48_META_API_22_P6_D: "命中的實體列表",
  T_48_META_API_23_D: "為玩家設定特殊物品狀態，特殊物品只能擁有一個",
  T_48_META_API_23_P0_D: "玩家",
  T_48_META_API_23_P1_D: "物品ID",
  T_48_META_API_23_P2_D: "是否啟用該物品",
  T_48_META_API_23_P3_D: "特殊物品實體",
  T_48_META_API_24_D: "對目標施加一次力，目標必須為物理物件",
  T_48_META_API_24_P0_D: "目標物理物件",
  T_48_META_API_24_P1_D: "力向量",
  T_48_META_API_24_P2_D: "力的類型",
  T_48_META_API_25_D: "在某點施加一次力，目標必須為剛體",
  T_48_META_API_25_P0_D: "目標剛體",
  T_48_META_API_25_P1_D: "力向量",
  T_48_META_API_25_P2_D: "施力位置",
  T_48_META_API_25_P3_D: "力的類型",
  T_48_META_API_26_D: "對目標施加一次扭矩，目標必須為剛體",
  T_48_META_API_26_P0_D: "目標剛體",
  T_48_META_API_26_P1_D: "扭力",
  T_48_META_API_26_P2_D: "施力類型",
  T_48_META_API_27_D: "移動目標剛體到指定位置",
  T_48_META_API_27_P0_D: "目標剛體",
  T_48_META_API_27_P1_D: "指定位置",
  T_48_META_API_28_D: "旋轉目標剛體",
  T_48_META_API_28_P0_D: "目標剛體",
  T_48_META_API_28_P1_D: "旋轉四元數",
  T_48_META_API_29_D: "建立插值運動，目標實體的指定屬性將依照設定進行平滑運動",
  T_48_META_API_29_P0_D: "目標實體",
  T_48_META_API_29_P1_D: "需要進行運動變化的屬性ID",
  T_48_META_API_29_P2_D: "屬性起始值",
  T_48_META_API_29_P3_D: "屬性結束值",
  T_48_META_API_29_P4_D: `可以選擇單次、循環和往復。 
循環表示每次動作完成後，實體會從起始值再進行一次運動。往復表示從起始值到目標值移動完成後，實體會從目標值再向起始值移動一次，然後重複這個過程`,
  T_48_META_API_29_P5_D: "貝塞爾曲線控制點",
  T_48_META_API_29_P6_D: "一次變化的時長，單位是毫秒",
  T_48_META_API_29_P7_D: "建立出的內插運動實體",
  T_48_META_API_29_P8_D: "建立後是否自動開始播放",
  T_48_META_API_3_D: "切換遊戲至目標階段，回合也是一種特殊階段。切換至回合中的階段時，回合計數為0。",
  T_48_META_API_3_P0_D: "目標回合或階段的索引",
  T_48_META_API_30_D: "強制目標玩家進入指定載具",
  T_48_META_API_30_P0_D: "目標玩家",
  T_48_META_API_30_P1_D: "載具實體",
  T_48_META_API_30_P2_D: "座位編號",
  T_48_META_API_30_P3_D: "是否成功使玩家進入載具",
  T_48_META_API_3001_D: "使目標玩家丟棄物品",
  T_48_META_API_3001_P0_D: "目標玩家",
  T_48_META_API_3001_P1_D: "物品實體",
  T_48_META_API_3002_D: "取得目前可用沒有完全佔滿的隨機出生點內可用座標（已廢棄，請使用GetRandomSpawnPosition）",
  T_48_META_API_3002_P0_D: "需要分配出生點區域的玩家",
  T_48_META_API_3002_R_D: "隨機分配到的隨機點座標",
  T_48_META_API_3003_D: "取得玩家指定積分類型的總分值",
  T_48_META_API_3003_P0_D: "玩家",
  T_48_META_API_3003_P1_D: "積分類型",
  T_48_META_API_3003_R_D: "積分值",
  T_48_META_API_3004_D: "設定玩家指定積分類型的回合分值",
  T_48_META_API_3004_P0_D: "玩家實體",
  T_48_META_API_3004_P1_D: "積分類型",
  T_48_META_API_3004_P2_D: "積分值",
  T_48_META_API_3005_D: "取得隊伍指定積分類型的總分值",
  T_48_META_API_3005_P0_D: "隊伍實體",
  T_48_META_API_3005_P1_D: "積分類型",
  T_48_META_API_3005_R_D: "積分值",
  T_48_META_API_3006_D: "設定隊伍指定積分類型的回合分值",
  T_48_META_API_3006_P0_D: "隊伍實體",
  T_48_META_API_3006_P1_D: "積分類型",
  T_48_META_API_3006_P2_D: "積分值",
  T_48_META_API_3007_D: "取得玩家指定回合、積分類型的分數",
  T_48_META_API_3007_P0_D: "玩家實體",
  T_48_META_API_3007_P1_D: "回合索引",
  T_48_META_API_3007_P2_D: "積分類型",
  T_48_META_API_3007_R_D: "積分值",
  T_48_META_API_3008_D: "取得隊伍指定回合、積分類型的分數",
  T_48_META_API_3008_P0_D: "隊伍實體",
  T_48_META_API_3008_P1_D: "回合索引",
  T_48_META_API_3008_P2_D: "積分類型",
  T_48_META_API_3008_R_D: "積分值",
  T_48_META_API_3009_D: "取得玩家遊戲總排名",
  T_48_META_API_3009_P0_D: "玩家實體",
  T_48_META_API_3009_R_D: "名次",
  T_48_META_API_3011_D: "取得隊伍遊戲總排名",
  T_48_META_API_3011_P0_D: "已廢棄",
  T_48_META_API_3011_R_D: "名次",
  T_48_META_API_3013_D: "取得玩家指定回合排名",
  T_48_META_API_3013_P0_D: "玩家實體",
  T_48_META_API_3013_P1_D: "回合索引",
  T_48_META_API_3013_R_D: "名次",
  T_48_META_API_3014_D: "取得隊伍指定回合排名",
  T_48_META_API_3014_P0_D: "已廢棄",
  T_48_META_API_3014_P1_D: "回合索引",
  T_48_META_API_3014_R_D: "名次",
  T_48_META_API_3015_D: "取得目標實體的錢包",
  T_48_META_API_3015_P0_D: "目標實體",
  T_48_META_API_3015_P1_D: "是否存在錢包",
  T_48_META_API_3015_P2_D: "取得的錢包實體",
  T_48_META_API_3016_D: "為目標玩家創建錢包，若玩家已有錢包則無效",
  T_48_META_API_3016_P0_D: "目標玩家",
  T_48_META_API_3016_P1_D: "錢包綁定的實體，錢包的擁有者",
  T_48_META_API_3016_P2_D: "錢包實體",
  T_48_META_API_3017_D: "為指定錢包增加貨幣",
  T_48_META_API_3017_P0_D: "目標錢包",
  T_48_META_API_3017_P1_D: "增加的貨幣類型",
  T_48_META_API_3017_P2_D: "增加的貨幣數量",
  T_48_META_API_3018_D: "為指定錢包減少貨幣",
  T_48_META_API_3018_P0_D: "目標錢包",
  T_48_META_API_3018_P1_D: "減少的貨幣類型",
  T_48_META_API_3018_P2_D: "減少的貨幣數量",
  T_48_META_API_3019_D: "將一個錢包中的貨幣轉移到另一個錢包中",
  T_48_META_API_3019_P0_D: "轉出貨幣的錢包",
  T_48_META_API_3019_P1_D: "轉移貨幣的類型",
  T_48_META_API_3019_P2_D: "轉移貨幣的數量",
  T_48_META_API_3019_P3_D: "轉入貨幣的錢包",
  T_48_META_API_3020_D: "取得指定錢包中指定類型貨幣的數量",
  T_48_META_API_3020_P0_D: "目標錢包",
  T_48_META_API_3020_P1_D: "查詢的貨幣類型",
  T_48_META_API_3020_R_D: "貨幣數量",
  T_48_META_API_3021_D: "取得指定錢包中指定類型貨幣的實體",
  T_48_META_API_3021_P0_D: "目標錢包",
  T_48_META_API_3021_P1_D: "查詢的貨幣類型",
  T_48_META_API_3021_R_D: "貨幣實體",
  T_48_META_API_3022_D: "取得遊戲中的所有商店，以列表形式返回",
  T_48_META_API_3022_R_D: "商店實體列表",
  T_48_META_API_3023_D: "將目標玩家的外形替換為指定場景物件的外形",
  T_48_META_API_3023_P0_D: "目標玩家",
  T_48_META_API_3023_P1_D: "替換的目標場景物件",
  T_48_META_API_3023_P2_D: "替換後創造出的玩家變身偽裝組件",
  T_48_META_API_3024_D: "取消玩家的偽裝狀態",
  T_48_META_API_3024_P0_D: "目標玩家",
  T_48_META_API_3025_D: "在目標玩家處創造一個場景實體外形的分身",
  T_48_META_API_3025_P0_D: "目標玩家",
  T_48_META_API_3025_P1_D: "用於分身形象的場景實體",
  T_48_META_API_3025_P2_D: "建立出的分身實體",
  T_48_META_API_3026_D: "取得玩家的偽裝實體",
  T_48_META_API_3026_P0_D: "玩家",
  T_48_META_API_3026_R_D: "玩家偽裝實體",
  T_48_META_API_3027_D: "根據索引取得聊天頻道實體",
  T_48_META_API_3027_P0_D: "聊天頻道索引，範圍[1,8]",
  T_48_META_API_3027_R_D: "聊天頻道實體",
  T_48_META_API_3028_D: "取得指定玩家目前所在的聊天頻道實體",
  T_48_META_API_3028_P0_D: "目標玩家",
  T_48_META_API_3028_R_D: "聊天頻道實體",
  T_48_META_API_3029_D: "使玩家加入指定聊天頻道，玩家已經處於其他聊天頻道時會切換至目標頻道",
  T_48_META_API_3029_P0_D: "目標玩家",
  T_48_META_API_3029_P1_D: "聊天頻道實體",
  T_48_META_API_3030_D: "使玩家退出目前所在頻道，之後處於不在任何聊天頻道的狀態",
  T_48_META_API_3030_P0_D: "目標玩家",
  T_48_META_API_3031_D: "已廢棄",
  T_48_META_API_3031_P0_D: "聊天頻道實體，頻道中無玩家時為空",
  T_48_META_API_3032_D: "設定玩家的行為狀態",
  T_48_META_API_3032_P0_D: "目標玩家",
  T_48_META_API_3032_P1_D: "玩家行為類型",
  T_48_META_API_3032_P2_D: `啟用：有HUD按鈕，正常可用
停用：HUD按鈕為禁止狀態，無法主動或被動進入該行為狀態
屏蔽：HUD按鈕隱藏，無法主動進入該行為狀態，但可以被動進入該行為狀態`,
  T_48_META_API_3033_D: "玩家變身為指定場景物件",
  T_48_META_API_3033_P0_D: "目標玩家",
  T_48_META_API_3033_P1_D: "要變身為的物件",
  T_48_META_API_3033_P2_D: "變身後創建的實體",
  T_48_META_API_3034_D: "玩家創造一個自身外觀的分身",
  T_48_META_API_3034_P0_D: "目標玩家",
  T_48_META_API_3034_P1_D: "建立的分身實體",
  T_48_META_API_3035_D: "建立一個自訂商店，商店的下一層是貨架",
  T_48_META_API_3035_P0_D: "建立的商店實體",
  T_48_META_API_3036_D: "創建一個自訂貨架，貨架的上一層級是商店，下一層是商品",
  T_48_META_API_3036_P0_D: "建立的貨架實體",
  T_48_META_API_3037_D: "創建一個自訂商品，商品可以添加物品",
  T_48_META_API_3037_P0_D: "建立的商品實體",
  T_48_META_API_3038_D: "添加物品到商品，可以透過多次使用該圖元將複數個物品加入一個商品中",
  T_48_META_API_3038_P0_D: "商品實體",
  T_48_META_API_3038_P1_D: "要新增的物品",
  T_48_META_API_3038_P2_D: "物品數量",
  T_48_META_API_3039_D: "給予越獄獎勵",
  T_48_META_API_3039_P0_D: "玩家實體",
  T_48_META_API_3039_P1_D: "數量",
  T_48_META_API_3039_P2_D: "真實貨幣",
  T_48_META_API_3040_D: "更新越獄任務",
  T_48_META_API_3040_P0_D: "玩家實體",
  T_48_META_API_3040_P1_D: "任務ID",
  T_48_META_API_3040_P2_D: "值",
  T_48_META_API_3041_D: "取得隨機出生點座標，只會從沒有完全佔滿的可用出生點中隨機",
  T_48_META_API_3041_P0_D: "目標玩家",
  T_48_META_API_3041_R_D: "隨機出生點座標，沒有符合條件的出生點時會回到靠近(0, 0, 0)的位置",
  T_48_META_API_3042_D: "退出越獄小遊戲",
  T_48_META_API_3042_P0_D: "玩家實體",
  T_48_META_API_3042_P1_D: "任務ID",
  T_48_META_API_3043_D: "基於越獄道具",
  T_48_META_API_3043_P0_D: "玩家實體",
  T_48_META_API_3043_P1_D: "道具類型",
  T_48_META_API_3043_P2_D: "道具ID",
  T_48_META_API_31_D: "建立相對自身運動，目標實體每次相對自身目前屬性值進行變化",
  T_48_META_API_31_P0_D: "目標實體",
  T_48_META_API_31_P1_D: "需要進行運動變化的屬性",
  T_48_META_API_31_P2_D: "每次運動的變化量",
  T_48_META_API_31_P3_D: "貝塞爾曲線控制點",
  T_48_META_API_31_P4_D: `單次：屬性變化Delta量即停止
循環：重複進行運動，每次屬性變化Delta量`,
  T_48_META_API_31_P5_D: "一次變化的時長，單位是毫秒",
  T_48_META_API_31_P6_D: "建立的相對自身運動實體",
  T_48_META_API_31_P7_D: "建立後是否自動開始播放",
  T_48_META_API_3100_D: "目標播放指定狀態下的動畫",
  T_48_META_API_3100_P0_D: "播放動畫的可掛載動畫控制器的實體元件",
  T_48_META_API_3100_P1_D: "動畫控制器的指定狀態",
  T_48_META_API_3100_P2_D: "動畫播放速度縮放",
  T_48_META_API_3100_P3_D: "循環類型，可以保持動畫原邏輯、只播放一次或循環播放",
  T_48_META_API_3101_D: "播放角色動畫，支援自訂動畫資源",
  T_48_META_API_3101_P0_D: "目標玩家",
  T_48_META_API_3101_P1_D: "自訂動畫資源ID",
  T_48_META_API_3101_P2_D: "是否循環播放",
  T_48_META_API_3102_D: "設定指定玩家的角色資源",
  T_48_META_API_3102_P0_D: "目標玩家",
  T_48_META_API_3102_P1_D: "自訂角色資源ID",
  T_48_META_API_3109_D: "開啟會平滑移動至終點的安全區",
  T_48_META_API_3109_P0_D: "安全區起始位置",
  T_48_META_API_3109_P1_D: "安全區終點位置",
  T_48_META_API_3109_P2_D: "安全區初始半徑",
  T_48_META_API_3109_P3_D: "安全區最終半徑",
  T_48_META_API_3109_P4_D: "安全區達到最終狀態所需的時間，單位為秒",
  T_48_META_API_3109_P5_D: "在安全區域外承受的每秒傷害量",
  T_48_META_API_3110_D: "切換角色外觀群組",
  T_48_META_API_3110_P0_D: "目標",
  T_48_META_API_3110_P1_D: "外觀組",
  T_48_META_API_3111_D: "顯示角色外觀群組",
  T_48_META_API_3111_P0_D: "目標",
  T_48_META_API_3111_P1_D: "外觀組",
  T_48_META_API_3112_D: "隱藏角色外觀群組",
  T_48_META_API_3112_P0_D: "目標",
  T_48_META_API_3112_P1_D: "外觀組",
  T_48_META_API_3121_D: "將斷言結果發送給Craftland Studio PC統計使用",
  T_48_META_API_3121_P0_D: "斷言表達式",
  T_48_META_API_3121_P1_D: "提示",
  T_48_META_API_32_D: "取得玩家今日token數據",
  T_48_META_API_32_P0_D: "目標玩家",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "token數量",
  T_48_META_API_32_P3_D: "圖元是否成功調用",
  T_48_META_API_3200_D: "為玩家新增物品，傳回發放的物品列表",
  T_48_META_API_3200_P0_D: "玩家",
  T_48_META_API_3200_P1_D: "物品ID",
  T_48_META_API_3200_P2_D: "物品數量",
  T_48_META_API_3200_P3_D: "為玩家添加的物品列表，即使只添加一個物品也以列表返回",
  T_48_META_API_3201_D: "為指定玩家回覆血量，不會超過血量上限",
  T_48_META_API_3201_P0_D: "目標玩家",
  T_48_META_API_3201_P1_D: "為玩家加血的值，只接受正數",
  T_48_META_API_3202_D: "設定目標玩家的技能列表",
  T_48_META_API_3202_P0_D: "目標玩家",
  T_48_META_API_3202_P1_D: "技能列表",
  T_48_META_API_3203_D: "取得目標玩家的技能列表",
  T_48_META_API_3203_P0_D: "目標玩家",
  T_48_META_API_3203_R_D: "技能列表",
  T_48_META_API_3205_D: "刪除玩家一定數量的物品",
  T_48_META_API_3205_P0_D: "目標玩家",
  T_48_META_API_3205_P1_D: "要刪除的物品類型",
  T_48_META_API_3205_P2_D: "要刪除的數量，超過玩家持有數量則只刪除持有的物品",
  T_48_META_API_3206_D: "取得玩家持有的指定物品數量",
  T_48_META_API_3206_P0_D: "目標玩家",
  T_48_META_API_3206_P1_D: "物品類型",
  T_48_META_API_3206_R_D: "玩家持有的數量",
  T_48_META_API_3207_D: "偵測玩家是否可觸發目前檢查點",
  T_48_META_API_3207_P0_D: "目標玩家",
  T_48_META_API_3207_P1_D: "觸發器",
  T_48_META_API_3207_R_D: "真: 可以觸發，假: 不行觸發",
  T_48_META_API_3208_D: "感染模式殭屍進化",
  T_48_META_API_3208_P0_D: "目標玩家",
  T_48_META_API_3209_D: "AI實體停止/執行預設的行為樹",
  T_48_META_API_3209_P0_D: "要啟用行為樹的目標",
  T_48_META_API_3209_P1_D: "是否執行預設行為樹",
  T_48_META_API_3210_D: "AI實體追擊指定目標",
  T_48_META_API_3210_P0_D: "執行追擊的AI實體",
  T_48_META_API_3210_P1_D: "被追擊的目標",
  T_48_META_API_3211_D: "摧毀玩家物品（已廢棄，請使用DeleteEquipment）",
  T_48_META_API_3211_P0_D: "被摧毀物品的玩家",
  T_48_META_API_3211_P1_D: "被摧毀物品類型",
  T_48_META_API_3211_P2_D: "武器槽位,僅對武器生效",
  T_48_META_API_3212_D: "更換球衣",
  T_48_META_API_3212_P0_D: "目標玩家",
  T_48_META_API_3212_P1_D: "衣服樣式",
  T_48_META_API_3212_P2_D: "主要顏色一",
  T_48_META_API_3212_P3_D: "主要顏色二",
  T_48_META_API_3212_P4_D: "配置",
  T_48_META_API_3213_D: "將玩家球衣恢復成初始狀態",
  T_48_META_API_3213_P0_D: "目標玩家",
  T_48_META_API_3214_D: "開關玩家語音聊天",
  T_48_META_API_3214_P0_D: "目標玩家",
  T_48_META_API_3214_P1_D: "是否關閉語音聊天，True:關閉False:打開",
  T_48_META_API_3215_D: "開關玩家快捷聊天",
  T_48_META_API_3215_P0_D: "目標玩家",
  T_48_META_API_3215_P1_D: "是否關閉快捷聊天，True:關閉False:打開",
  T_48_META_API_3216_D: "設定目標玩家是否可以拾取物品",
  T_48_META_API_3216_P0_D: "目標玩家",
  T_48_META_API_3216_P1_D: "是否禁止拾取物品，真：禁止拾取假：可以拾取",
  T_48_META_API_3217_D: "設定目標玩家是否可以丟棄物品",
  T_48_META_API_3217_P0_D: "目標玩家",
  T_48_META_API_3217_P1_D: "是否禁止丟棄物品，真：禁止拾取假：可以拾取",
  T_48_META_API_3218_D: "摧毀玩家指定槽位內的武器",
  T_48_META_API_3218_P0_D: "目標玩家",
  T_48_META_API_3218_P1_D: "要摧毀的武器槽位",
  T_48_META_API_3218_P2_D: "要摧毀的數量",
  T_48_META_API_3218_P3_D: "是否成功銷毀，武器槽位上沒有裝備武器時會銷毀失敗",
  T_48_META_API_3219_D: "清空目標玩家背包內所有物品，包括已裝備物品",
  T_48_META_API_3219_P0_D: "目標玩家",
  T_48_META_API_3220_D: "設定玩家朝向",
  T_48_META_API_3220_P0_D: "目標玩家",
  T_48_META_API_3220_P1_D: "玩家朝向",
  T_48_META_API_3221_D: "（已廢棄，請勿使用，相關資訊請參閱屬性<Player>:Skeleton）",
  T_48_META_API_3221_P0_D: "玩家實體",
  T_48_META_API_3221_P1_D: "縮放部位",
  T_48_META_API_3221_P2_D: "縮放值",
  T_48_META_API_3222_D: "給予玩家擊飛效果，目標玩家會以固定的加速度下墜、並且空中發生撞擊後會強制停止擊飛",
  T_48_META_API_3222_P0_D: "目標玩家",
  T_48_META_API_3222_P1_D: "擊飛方向",
  T_48_META_API_3222_P2_D: "擊飛時長",
  T_48_META_API_3222_P3_D: "擊飛時Y軸的初速",
  T_48_META_API_3222_P4_D: "擊飛時XZ平面的初速",
  T_48_META_API_3222_P5_D: "是否改變玩家朝向",
  T_48_META_API_3223_D: "取得目標玩家或NPC的服裝ID",
  T_48_META_API_3223_P0_D: "目標玩家或NPC",
  T_48_META_API_3223_P1_D: "服裝類型",
  T_48_META_API_3223_R_D: "服裝ID",
  T_48_META_API_3224_D: "設定目標玩家或NPC的服裝ID",
  T_48_META_API_3224_P0_D: "目標玩家或NPC",
  T_48_META_API_3224_P1_D: "服裝ID",
  T_48_META_API_3225_D: "恢復目標玩家的預設服裝，無法作用於NPC",
  T_48_META_API_3225_P0_D: "目標玩家",
  T_48_META_API_3226_D: "人工智慧實體攻擊指定目標",
  T_48_META_API_3226_P0_D: "執行攻擊的AI實體",
  T_48_META_API_3226_P1_D: "被攻擊的目標",
  T_48_META_API_3227_D: "切換玩家武器為指定槽位的武器",
  T_48_META_API_3227_P0_D: "目標玩家",
  T_48_META_API_3227_P1_D: "要切換的武器插槽",
  T_48_META_API_3227_P2_D: "是否成功切換，武器槽位上沒有裝備武器時會切換失敗",
  T_48_META_API_3228_D: "取得目標玩家或NPC的武器皮膚",
  T_48_META_API_3228_P0_D: "目標玩家或NPC",
  T_48_META_API_3228_P1_D: "武器皮膚ID",
  T_48_META_API_3228_R_D: "武器皮膚ID",
  T_48_META_API_3229_D: "設定目標玩家或NPC的武器皮膚",
  T_48_META_API_3229_P0_D: "目標玩家或NPC",
  T_48_META_API_3229_P1_D: "武器皮膚ID",
  T_48_META_API_3230_D: "恢復目標玩家的預設武器皮膚，無法作用於NPC",
  T_48_META_API_3230_P0_D: "目標玩家",
  T_48_META_API_3230_P1_D: "武器ID",
  T_48_META_API_3231_D: "設定玩家的套裝",
  T_48_META_API_3231_P0_D: "目標玩家",
  T_48_META_API_3231_P1_D: "服裝列表",
  T_48_META_API_3232_D: "去除目標玩家或NPC指定服裝類型的所有服裝",
  T_48_META_API_3232_P0_D: "目標玩家或NPC",
  T_48_META_API_3232_P1_D: "服裝類型",
  T_48_META_API_3233_D: "去除玩家或NPC指定武器的皮膚",
  T_48_META_API_3233_P0_D: "目標玩家或NPC",
  T_48_META_API_3233_P1_D: "武器ID",
  T_48_META_API_3234_D: "為目標添加Buff",
  T_48_META_API_3234_P0_D: "目標實體，必須為可新增Buff的實體",
  T_48_META_API_3234_P1_D: "Buff id",
  T_48_META_API_3235_D: "為目標移除Buff",
  T_48_META_API_3235_P0_D: "目標實體，必須為可新增Buff的實體",
  T_48_META_API_3235_P1_D: "Buff id",
  T_48_META_API_3236_D: "取得目標目前的Buff",
  T_48_META_API_3236_P0_D: "目標實體，必須為可新增Buff的實體",
  T_48_META_API_3236_R_D: "Buff列表",
  T_48_META_API_3237_D: "取得目標玩家背包道具欄中的道具",
  T_48_META_API_3237_P0_D: "目標玩家",
  T_48_META_API_3237_P1_D: "道具列表",
  T_48_META_API_3238_D: "為指定槽位的武器添加配件，與該槽位不匹配的配件會添加失敗；匹配但重複的配件會替換掉原有的配件，原配件會送入玩家背包，玩家背包已滿時原配件會掉落在玩家當時的位置",
  T_48_META_API_3238_P0_D: "目標玩家",
  T_48_META_API_3238_P1_D: "裝備欄槽位",
  T_48_META_API_3238_P2_D: "配件",
  T_48_META_API_3238_P3_D: `是否成功添加配件
真：配件已裝備到對應槽位的武器上
假：配件添加失敗，不會出現在玩家背包`,
  T_48_META_API_3238_P4_D: "添加的配件，失敗時為空",
  T_48_META_API_3239_D: "取得背包裝備欄中的裝備",
  T_48_META_API_3239_P0_D: "目標玩家",
  T_48_META_API_3239_P1_D: "裝備欄槽位",
  T_48_META_API_3239_P2_D: "指定槽位的裝備，沒有裝備時為空",
  T_48_META_API_3239_P3_D: "該裝備的所有配件",
  T_48_META_API_3240_D: "二維向量取X分量",
  T_48_META_API_3240_P0_D: "二維向量",
  T_48_META_API_3240_R_D: "二維向量X分量",
  T_48_META_API_3241_D: "二維向量取Y分量",
  T_48_META_API_3241_P0_D: "二維向量",
  T_48_META_API_3241_R_D: "二維向量Y分量",
  T_48_META_API_3242_D: "二維向量設定X分量",
  T_48_META_API_3242_P0_D: "二維向量",
  T_48_META_API_3242_P1_D: "二維向量X分量",
  T_48_META_API_3243_D: "二維向量設定Y分量",
  T_48_META_API_3243_P0_D: "二維向量",
  T_48_META_API_3243_P1_D: "二維向量Y分量",
  T_48_META_API_3244_D: "將兩個二維向量相加",
  T_48_META_API_3244_P0_D: "左值",
  T_48_META_API_3244_P1_D: "右值",
  T_48_META_API_3244_R_D: "二維向量相加結果",
  T_48_META_API_3245_D: "將兩個二維向量相減",
  T_48_META_API_3245_P0_D: "左值",
  T_48_META_API_3245_P1_D: "右值",
  T_48_META_API_3245_R_D: "二維向量相減結果",
  T_48_META_API_3246_D: "將二維向量數乘",
  T_48_META_API_3246_P0_D: "二維向量",
  T_48_META_API_3246_P1_D: "二維向量縮放值",
  T_48_META_API_3246_R_D: "二維向量數乘結果",
  T_48_META_API_3247_D: "將兩個二維向量點乘，點乘結果為標量，以表徵兩個向量間的夾角",
  T_48_META_API_3247_P0_D: "左值",
  T_48_META_API_3247_P1_D: "右值",
  T_48_META_API_3247_R_D: "點乘結果",
  T_48_META_API_3248_D: "計算兩個二維向量的歐氏距離",
  T_48_META_API_3248_P0_D: "左值",
  T_48_META_API_3248_P1_D: "右值",
  T_48_META_API_3248_R_D: "兩向量相減後，所得向量的模長",
  T_48_META_API_3249_D: "計算兩個二維向量的夾角",
  T_48_META_API_3249_P0_D: "左值",
  T_48_META_API_3249_P1_D: "右值",
  T_48_META_API_3249_R_D: "向量夾角，角度範圍0-180",
  T_48_META_API_3250_D: "對二維向量歸一化",
  T_48_META_API_3250_P0_D: "二維向量",
  T_48_META_API_3250_R_D: "歸一化結果，為向量同方向長度為1公尺的向量",
  T_48_META_API_3251_D: "對二維向量取模",
  T_48_META_API_3251_P0_D: "二維向量",
  T_48_META_API_3251_R_D: "取模結果，為向量長度",
  T_48_META_API_3252_D: "計算二維向量經法線垂直直線反射後的向量",
  T_48_META_API_3252_P0_D: "入射二維向量",
  T_48_META_API_3252_P1_D: "法線二維向量",
  T_48_META_API_3252_R_D: "反射二維向量",
  T_48_META_API_3253_D: "計算三維向量經法線垂直平面反射後的向量",
  T_48_META_API_3253_P0_D: "入射三維向量",
  T_48_META_API_3253_P1_D: "法線三維向量",
  T_48_META_API_3253_R_D: "反射三維向量",
  T_48_META_API_3254_D: "三維向量轉二維向量，刪除三維向量的Z分量",
  T_48_META_API_3254_P0_D: "目標三維向量",
  T_48_META_API_3254_R_D: "轉換後的二維向量",
  T_48_META_API_3255_D: "二維向量轉三維向量，三維向量的Z分量設定為0",
  T_48_META_API_3255_P0_D: "目標二維向量",
  T_48_META_API_3255_R_D: "轉換後的三維向量",
  T_48_META_API_3256_D: "建立一個二維向量",
  T_48_META_API_3256_P0_D: "二維向量的X分量",
  T_48_META_API_3256_P1_D: "二維向量的Y分量",
  T_48_META_API_3256_R_D: "建立出的二維向量",
  T_48_META_API_3257_D: "自訂比賽埋點日誌，用於使用者體驗資料分析",
  T_48_META_API_3257_P0_D: "紀錄",
  T_48_META_API_3258_D: "自訂比賽埋點日誌，用於使用者體驗資料分析",
  T_48_META_API_3258_P0_D: "要記錄上報的玩家",
  T_48_META_API_3258_P1_D: "紀錄",
  T_48_META_API_33_D: "髒字過濾",
  T_48_META_API_33_P0_D: "需要進行髒字過濾的原文本",
  T_48_META_API_33_R_D: "過濾後的文本",
  T_48_META_API_3301_D: "創建一個陣營實體",
  T_48_META_API_3301_P0_D: "陣營實體",
  T_48_META_API_3302_D: "目標實體加入指定陣營",
  T_48_META_API_3302_P0_D: "目標實體",
  T_48_META_API_3302_P1_D: "陣營實體",
  T_48_META_API_3303_D: "取得陣營的可攻擊陣營",
  T_48_META_API_3303_P0_D: "攻擊陣營",
  T_48_META_API_3303_R_D: "陣營實體列表",
  T_48_META_API_3304_D: "設置陣營的可攻擊陣營",
  T_48_META_API_3304_P0_D: "攻擊陣營",
  T_48_META_API_3304_P1_D: "目標陣營",
  T_48_META_API_3304_P2_D: "是否可攻擊",
  T_48_META_API_3305_D: "設定可攻擊玩家",
  T_48_META_API_3305_P0_D: "玩家",
  T_48_META_API_3305_P1_D: "可攻擊玩家",
  T_48_META_API_3305_P2_D: "是否可攻擊",
  T_48_META_API_3306_D: "設定隊伍的可攻擊隊伍",
  T_48_META_API_3306_P0_D: "攻擊隊伍",
  T_48_META_API_3306_P1_D: "目標隊伍",
  T_48_META_API_3306_P2_D: "是否可攻擊",
  T_48_META_API_3307_D: "已廢棄",
  T_48_META_API_3307_P0_D: "已廢棄",
  T_48_META_API_3307_R_D: "玩家實體列表",
  T_48_META_API_3308_D: "指定實體退出當前陣營",
  T_48_META_API_3308_P0_D: "目標實體",
  T_48_META_API_3309_D: "獲取目標的陣營",
  T_48_META_API_3309_P0_D: "目標實體",
  T_48_META_API_3309_R_D: "陣營實體",
  T_48_META_API_3310_D: "判斷是否可以攻擊目標",
  T_48_META_API_3310_P0_D: "攻擊者",
  T_48_META_API_3310_P1_D: "目標實體",
  T_48_META_API_3310_R_D: "是否可攻擊",
  T_48_META_API_3311_D: "設定實體的可攻擊目標",
  T_48_META_API_3311_P0_D: "攻擊者",
  T_48_META_API_3311_P1_D: "目標實體",
  T_48_META_API_3311_P2_D: "是否可攻擊",
  T_48_META_API_3312_D: "取得實體的可攻擊目標",
  T_48_META_API_3312_P0_D: "攻擊者",
  T_48_META_API_3312_R_D: "可攻擊的實體列表",
  T_48_META_API_34_D: "判斷目標實體是否存在組件",
  T_48_META_API_34_P0_D: "目標實體",
  T_48_META_API_34_P1_D: "組件類型",
  T_48_META_API_34_R_D: "是否存在",
  T_48_META_API_35_D: "新增Bot",
  T_48_META_API_35_P0_D: "Bot難度等級",
  T_48_META_API_35_P1_D: "Bot所屬隊伍",
  T_48_META_API_35_P2_D: "創建出的Bot玩家實體",
  T_48_META_API_3500_D: "取得玩家token數據",
  T_48_META_API_3500_P0_D: "目標玩家",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "token數量",
  T_48_META_API_3500_P3_D: "是否成功",
  T_48_META_API_3501_D: "給玩家添加token數據",
  T_48_META_API_3501_P0_D: "目標玩家",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "token數量",
  T_48_META_API_3501_P3_D: "圖元是否成功調用",
  T_48_META_API_3502_D: "消耗目標玩家token",
  T_48_META_API_3502_P0_D: "目標玩家",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "token數量",
  T_48_META_API_3502_P3_D: "圖元是否成功調用",
  T_48_META_API_3503_D: "在指定位置新增token",
  T_48_META_API_3503_P0_D: "位置",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "token數量",
  T_48_META_API_3503_P3_D: "圖元是否成功調用",
  T_48_META_API_3504_D: "目標AI釋放指定技能",
  T_48_META_API_3504_P0_D: "目標AI",
  T_48_META_API_3504_P1_D: "技能",
  T_48_META_API_3504_P2_D: "技能目標",
  T_48_META_API_3504_P3_D: "是否成功釋放技能",
  T_48_META_API_3505_D: "創建從起點到終點的尋路路徑，會繞開阻擋，可以用於AI尋路",
  T_48_META_API_3505_P0_D: "起點座標",
  T_48_META_API_3505_P1_D: "終點座標",
  T_48_META_API_3505_P2_D: "是否成功建立尋路路徑",
  T_48_META_API_3505_P3_D: "尋路點集合",
  T_48_META_API_3506_D: "設定行為樹黑板變數",
  T_48_META_API_3506_P0_D: "目標行為樹",
  T_48_META_API_3506_P1_D: "變數名",
  T_48_META_API_3506_P2_D: "變數值",
  T_48_META_API_3507_D: "取得行為樹黑板變量",
  T_48_META_API_3507_P0_D: "目標行為樹",
  T_48_META_API_3507_P1_D: "變數名",
  T_48_META_API_3507_P2_D: "變數值",
  T_48_META_API_3508_D: "取得行為樹節點參數",
  T_48_META_API_3508_P0_D: "目標行為樹節點",
  T_48_META_API_3508_P1_D: "參數名",
  T_48_META_API_3508_P2_D: "參數值",
  T_48_META_API_3509_D: "取得目標玩家的載具皮膚",
  T_48_META_API_3509_P0_D: "目標玩家",
  T_48_META_API_3509_P1_D: "載具ID",
  T_48_META_API_3509_R_D: "載具皮膚",
  T_48_META_API_3510_D: "設定目標玩家的載具皮膚",
  T_48_META_API_3510_P0_D: "目標玩家",
  T_48_META_API_3510_P1_D: "載具皮膚ID",
  T_48_META_API_3511_D: "清除目標玩家指定載具的皮膚",
  T_48_META_API_3511_P0_D: "目標玩家",
  T_48_META_API_3511_P1_D: "載具ID",
  T_48_META_API_3512_D: "恢復目標玩家預設的載具皮膚",
  T_48_META_API_3512_P0_D: "目標玩家",
  T_48_META_API_3512_P1_D: "載具ID",
  T_48_META_API_36_D: "休眠目標，只能用於Dynamic類型剛體",
  T_48_META_API_36_P0_D: "目標剛體",
  T_48_META_API_37_D: "喚醒目標，只能用於Dynamic類型剛體",
  T_48_META_API_37_P0_D: "目標剛體",
  T_48_META_API_38_D: "檢查目標剛體是否處於休眠狀態",
  T_48_META_API_38_P0_D: "目標剛體",
  T_48_META_API_38_R_D: "是否正在休眠",
  T_48_META_API_39_D: "設定休眠閾值",
  T_48_META_API_39_P0_D: "目標剛體",
  T_48_META_API_39_P1_D: "休眠閾值，剛體的運動和旋轉小於該值一段時間後進入休眠狀態，休眠狀態的剛體不再進行物理計算",
  T_48_META_API_4_D: "設定全體玩家是否可以移動",
  T_48_META_API_4_P0_D: `真：可以移動
假：不可移動`,
  T_48_META_API_40_D: "取得休眠閾值",
  T_48_META_API_40_P0_D: "目標剛體",
  T_48_META_API_40_R_D: "休眠閾值，剛體的運動和旋轉小於該值一段時間後進入休眠狀態，休眠狀態的剛體不再進行物理計算",
  T_48_META_API_4000_D: "讀取整張表的內容，並依照行的順序傳回二維數組",
  T_48_META_API_4000_P0_D: "表名",
  T_48_META_API_4000_R_D: "表的內容",
  T_48_META_API_4001_D: "讀取表格的某一行內容，回傳數組",
  T_48_META_API_4001_P0_D: "表名",
  T_48_META_API_4001_P1_D: "要讀取的行數，從1開始計算",
  T_48_META_API_4001_R_D: "表指定一行的內容",
  T_48_META_API_4002_D: "讀取表格某一列的內容，回傳數組",
  T_48_META_API_4002_P0_D: "表名",
  T_48_META_API_4002_P1_D: "要讀取的列數，從1開始計算",
  T_48_META_API_4002_R_D: "表指定一列的內容",
  T_48_META_API_4003_D: "讀取表格某一儲存格的內容",
  T_48_META_API_4003_P0_D: "表名",
  T_48_META_API_4003_P1_D: "要讀取的行數，從1開始計算",
  T_48_META_API_4003_P2_D: "要讀取的列數，從1開始計算",
  T_48_META_API_4003_R_D: "表指定單元格的內容",
  T_48_META_API_4004_D: "透過行數和列名讀取表格某一儲存格的內容",
  T_48_META_API_4004_P0_D: "表名",
  T_48_META_API_4004_P1_D: "要讀取的行數，從1開始計算",
  T_48_META_API_4004_P2_D: "要讀取的列名",
  T_48_META_API_4004_R_D: "表指定單元格的內容",
  T_48_META_API_4005_D: "讀取整張表的內容，返回二維數組",
  T_48_META_API_4005_P0_D: "表名",
  T_48_META_API_4005_R_D: "表的內容，二維數組",
  T_48_META_API_4006_D: "讀取整張表的某一行內容，並返回數組",
  T_48_META_API_4006_P0_D: "表名",
  T_48_META_API_4006_P1_D: "要讀取的行數，從1開始計算",
  T_48_META_API_4006_R_D: "表指定一行的內容，數組",
  T_48_META_API_4007_D: "讀取整張表某一列的內容，返回數組",
  T_48_META_API_4007_P0_D: "表名",
  T_48_META_API_4007_P1_D: "要讀取的列數，從1開始計算",
  T_48_META_API_4007_R_D: "表指定一列的內容，數組",
  T_48_META_API_4008_D: "讀取表格某一儲存格的內容",
  T_48_META_API_4008_P0_D: "表名",
  T_48_META_API_4008_P1_D: "要讀取的行數，從1開始計算",
  T_48_META_API_4008_P2_D: "要讀取的列數，從1開始計算",
  T_48_META_API_4008_R_D: "表指定單元格的內容",
  T_48_META_API_4009_D: "透過列數和單元格的值找到指定行",
  T_48_META_API_4009_P0_D: "表名",
  T_48_META_API_4009_P1_D: "要讀取的列數",
  T_48_META_API_4009_P2_D: "要尋找的儲存格值",
  T_48_META_API_4009_R_D: "查找到的行的內容，數組",
  T_48_META_API_4010_D: "透過列名取得列序號",
  T_48_META_API_4010_P0_D: "表名",
  T_48_META_API_4010_P1_D: "要查序號的列名稱",
  T_48_META_API_4010_R_D: "列數，從1開始計算",
  T_48_META_API_41_D: "設定全域休眠閾值，僅對於新產生的Dynamic類型的剛體有效",
  T_48_META_API_41_P0_D: "休眠閾值，剛體的運動和旋轉小於該值一段時間後進入休眠狀態，休眠狀態的剛體不再進行物理計算",
  T_48_META_API_42_D: "取得全域休眠閾值",
  T_48_META_API_42_R_D: "休眠閾值，預設為0.005，剛體的運動和旋轉小於該值一段時間後進入休眠狀態，休眠狀態的剛體不再進行物理計算",
  T_48_META_API_43_D: "將給定四元數轉換為歐拉角，歐拉角的旋轉次序為YXZ，若傳入的四元數不合法，則回傳(0,0,0)",
  T_48_META_API_43_P0_D: "輸入的四元數",
  T_48_META_API_43_R_D: "返回的歐拉角",
  T_48_META_API_44_D: "將給定歐拉角轉換為四元數",
  T_48_META_API_44_P0_D: "輸入的歐拉角",
  T_48_META_API_44_R_D: "傳回的四元數",
  T_48_META_API_45_D: "將軸角表示的旋轉轉換為四元數",
  T_48_META_API_45_P0_D: "旋轉軸",
  T_48_META_API_45_P1_D: "繞旋轉軸順時針轉動的角度",
  T_48_META_API_45_R_D: "傳回的四元數",
  T_48_META_API_46_D: "將四元數轉換為軸角表示",
  T_48_META_API_46_P0_D: "輸入的四元數",
  T_48_META_API_46_P1_D: "旋轉軸",
  T_48_META_API_46_P2_D: "繞旋轉軸順時針轉動的角度",
  T_48_META_API_47_D: "設定自訂任務完成進度",
  T_48_META_API_47_P0_D: "目標玩家",
  T_48_META_API_47_P1_D: "任務ID",
  T_48_META_API_47_P2_D: "完成進度，不允許為負數",
  T_48_META_API_48_D: "建立一個貝塞爾曲線，可以用於插值運動",
  T_48_META_API_48_P0_D: "曲線控制點",
  T_48_META_API_48_R_D: "貝塞爾曲線",
  T_48_META_API_49_D: "取得場景地圖ID",
  T_48_META_API_49_P0_D: "場景ID",
  T_48_META_API_49_R_D: "地圖ID",
  T_48_META_API_5_D: "刪除場景中的擺放物件（已廢棄，請使用DeleteEntity）",
  T_48_META_API_5_P0_D: "待刪除的物件實體",
  T_48_META_API_50_D: "建立相對自身每幀運動，目標實體每幀變化一次自身屬性，每次相對自身當前屬性值進行變化",
  T_48_META_API_50_P0_D: "目標實體",
  T_48_META_API_50_P1_D: "需要進行運動變化的屬性",
  T_48_META_API_50_P2_D: "每次運動的變化量",
  T_48_META_API_50_P3_D: `與其他運動模式組合使用時的配置
真：可以與相對運動組合使用
假：可以與絕對運動組合使用`,
  T_48_META_API_50_P4_D: "創建出的相對自身每幀運動實體",
  T_48_META_API_50_P5_D: "建立後是否自動開始播放",
  T_48_META_API_5000_D: "讀取資料庫某個表中某個Key對應的值",
  T_48_META_API_5000_P0_D: "資料庫中表名",
  T_48_META_API_5000_P1_D: "標記玩家，處理並發狀況",
  T_48_META_API_5000_P2_D: "用於標識資料的自訂名",
  T_48_META_API_5000_P3_D: "傳回讀取的結果",
  T_48_META_API_5000_P4_D: "資料庫對應的戰場碼",
  T_48_META_API_5001_D: "寫入資料庫某個表中某個Key對應的值",
  T_48_META_API_5001_P0_D: "資料庫中表名",
  T_48_META_API_5001_P1_D: "標記玩家，處理並發狀況",
  T_48_META_API_5001_P2_D: "用於標識資料的自訂名",
  T_48_META_API_5001_P3_D: "寫入的值",
  T_48_META_API_5001_P4_D: "資料庫對應的戰場碼，允許填空，代表目前地圖戰場碼",
  T_48_META_API_5002_D: "刪除資料庫某個表中某個Key對應的值",
  T_48_META_API_5002_P0_D: "資料庫中表名",
  T_48_META_API_5002_P1_D: "標記玩家，處理並發狀況",
  T_48_META_API_5002_P2_D: "用於標識資料的自訂名",
  T_48_META_API_5002_P3_D: "資料庫對應的戰場碼",
  T_48_META_API_5003_D: "讀取資料庫中排行榜表中某個Key對應的值",
  T_48_META_API_5003_P0_D: "資料庫中排行榜表名",
  T_48_META_API_5003_P1_D: "用於標識資料的自訂名",
  T_48_META_API_5003_P2_D: "傳回讀取的結果",
  T_48_META_API_5003_P3_D: "資料庫對應的戰場碼",
  T_48_META_API_5004_D: "寫入資料庫某個排行榜表中某個Key對應的值",
  T_48_META_API_5004_P0_D: "資料庫中排行榜表名",
  T_48_META_API_5004_P1_D: "用於標識資料的自訂名",
  T_48_META_API_5004_P2_D: "寫入的值",
  T_48_META_API_5004_P3_D: "資料庫對應的戰場碼",
  T_48_META_API_5005_D: "刪除資料庫某個排行榜表中某個Key對應的值",
  T_48_META_API_5005_P0_D: "資料庫中表名",
  T_48_META_API_5005_P1_D: "用於標識資料的自訂名",
  T_48_META_API_5005_P2_D: "資料庫對應的戰場碼",
  T_48_META_API_5006_D: "刪除資料庫某個排行榜表中某個名次對應的值",
  T_48_META_API_5006_P0_D: "資料庫中表名",
  T_48_META_API_5006_P1_D: "排行榜中的名次",
  T_48_META_API_5006_P2_D: "資料庫對應的戰場碼",
  T_48_META_API_5007_D: "讀取資料庫某個排行榜表中從某名次到某名次之間的值",
  T_48_META_API_5007_P0_D: "資料庫中表名",
  T_48_META_API_5007_P1_D: "起始名次",
  T_48_META_API_5007_P2_D: "結束名次",
  T_48_META_API_5007_P3_D: "傳回讀取的結果",
  T_48_META_API_5007_P4_D: "資料庫對應的戰場碼",
  T_48_META_API_5008_D: "讀取累計資料庫某個表中某個Key對應的值",
  T_48_META_API_5008_P0_D: "資料庫中表名",
  T_48_META_API_5008_P1_D: "用於標識資料的自訂名",
  T_48_META_API_5008_P2_D: "傳回讀取的結果",
  T_48_META_API_5008_P3_D: "資料庫對應的戰場碼",
  T_48_META_API_5009_D: "寫入累計資料庫某個表格中某個Key對應的偏移值",
  T_48_META_API_5009_P0_D: "資料庫中表名",
  T_48_META_API_5009_P1_D: "用於標識資料的自訂名",
  T_48_META_API_5009_P2_D: "四則運算的類型，目前支援以下類型：Int類型支援加、減、乘、除、餘；Float類型支援加、減、乘、除",
  T_48_META_API_5009_P3_D: "寫入的偏移值",
  T_48_META_API_5009_P4_D: "資料庫對應的戰場碼",
  T_48_META_API_51_D: "重置可播放實體，將可播放實體恢復到初始形態，不改變播放狀態",
  T_48_META_API_51_P0_D: "目標可播放實體",
  T_48_META_API_52_D: "將兩個四元數相乘，A*B表示先旋轉A再旋轉B，旋轉順序不同會導致結果不同",
  T_48_META_API_52_P0_D: "左值四元數",
  T_48_META_API_52_P1_D: "右值四元數",
  T_48_META_API_52_R_D: "結果四元數",
  T_48_META_API_53_D: "建立一個朝向指定方向的旋轉四元數",
  T_48_META_API_53_P0_D: "指定方向",
  T_48_META_API_53_P1_D: "上方方向",
  T_48_META_API_53_R_D: "朝指定方向對齊所需的旋轉量",
  T_48_META_API_54_D: "從A到B進行四元數球形內插",
  T_48_META_API_54_P0_D: "A值",
  T_48_META_API_54_P1_D: "B值",
  T_48_META_API_54_P2_D: "內插進度，取值範圍[0,1]，取值為0時回傳開始值、取值為1時回傳目標值",
  T_48_META_API_54_R_D: "結果四元數",
  T_48_META_API_57_D: "將目標資料以警告形式列印到控制台",
  T_48_META_API_57_P0_D: "需要列印的內容",
  T_48_META_API_58_D: "將目標資料以報錯形式列印到控制台",
  T_48_META_API_58_P0_D: "需要列印的內容",
  T_48_META_API_59_D: "取得曲線上的值",
  T_48_META_API_59_P0_D: "曲線",
  T_48_META_API_59_P1_D: "採樣點，取值範圍[0,1]",
  T_48_META_API_59_R_D: "結果",
  T_48_META_API_6_D: "建立場景對像到指定座標",
  T_48_META_API_6_P0_D: "建立的場景物件實體",
  T_48_META_API_6_P1_D: "物件產生的位置",
  T_48_META_API_6_P2_D: "建立的物件類型ID，在程式碼腳本中使用時，需要事先在資產註冊中註冊關卡物件枚舉",
  T_48_META_API_60_D: "根據曲線進行插值",
  T_48_META_API_60_P0_D: "值類型",
  T_48_META_API_60_P1_D: "起始值",
  T_48_META_API_60_P2_D: "目標值",
  T_48_META_API_60_P3_D: "曲線",
  T_48_META_API_60_P4_D: "採樣點，取值範圍[0,1]",
  T_48_META_API_60_R_D: "結果",
  T_48_META_API_6000_D: "為目標實體新增腳本",
  T_48_META_API_6000_P0_D: "目標實體",
  T_48_META_API_6000_P1_D: "腳本ID",
  T_48_META_API_6001_D: "為目標實體卸載腳本",
  T_48_META_API_6001_P0_D: "目標實體",
  T_48_META_API_6001_P1_D: "腳本ID",
  T_48_META_API_6002_D: "檢查目標實體是否存在指定腳本",
  T_48_META_API_6002_P0_D: "目標實體",
  T_48_META_API_6002_P1_D: "腳本ID",
  T_48_META_API_6002_R_D: "是否存在指定腳本",
  T_48_META_API_61_D: "設定UI控制項的父節點",
  T_48_META_API_61_P0_D: "父節點，可以指定UI控製或自訂UI",
  T_48_META_API_61_P1_D: "子節點",
  T_48_META_API_62_D: "已廢棄",
  T_48_META_API_62_P0_D: "已廢棄",
  T_48_META_API_62_P1_D: "已廢棄",
  T_48_META_API_62_P2_D: "已廢棄",
  T_48_META_API_62_P3_D: "已廢棄",
  T_48_META_API_62_P4_D: "已廢棄",
  T_48_META_API_63_D: "從目前相機到螢幕觸控點建立一條射線",
  T_48_META_API_63_P0_D: "螢幕觸點",
  T_48_META_API_63_P1_D: "起始點",
  T_48_META_API_63_P2_D: "射線方向",
  T_48_META_API_64_D: "上傳自訂結算訊息",
  T_48_META_API_64_P0_D: "玩家實體",
  T_48_META_API_64_P1_D: "比賽結果",
  T_48_META_API_64_P2_D: "積分標題",
  T_48_META_API_64_P3_D: "積分值",
  T_48_META_API_65_D: "播放指定的音效，有更多需要設定的屬性時可設定它的實體屬性",
  T_48_META_API_65_P0_D: "建立的音效實體",
  T_48_META_API_65_P1_D: "目標玩家，只有目標玩家可聽到音效",
  T_48_META_API_65_P2_D: "音效類型",
  T_48_META_API_65_P3_D: "循環類型",
  T_48_META_API_65_P4_D: "是否立即播放",
  T_48_META_API_66_D: "建立指定視覺特效，有更多需要設定的屬性時可設定它的實體屬性",
  T_48_META_API_66_P0_D: "創建的特效實體",
  T_48_META_API_66_P1_D: "目標玩家，只有目標玩家可見",
  T_48_META_API_66_P2_D: "特效類型",
  T_48_META_API_66_P3_D: "循環類型",
  T_48_META_API_66_P4_D: "是否立即播放",
  T_48_META_API_67_D: "建立指定的音效，有更多需要設定的屬性時可設定它的實體屬性",
  T_48_META_API_67_P0_D: "建立的音效實體",
  T_48_META_API_67_P1_D: "音效類型",
  T_48_META_API_67_P2_D: "循環類型",
  T_48_META_API_67_P3_D: "是否立即播放",
  T_48_META_API_68_D: "世界座標轉換為螢幕座標",
  T_48_META_API_68_P0_D: "世界座標",
  T_48_META_API_68_P1_D: "是否映射在螢幕內",
  T_48_META_API_68_P2_D: "映射位置",
  T_48_META_API_69_D: "螢幕座標轉世界座標",
  T_48_META_API_69_P0_D: "螢幕座標",
  T_48_META_API_69_P1_D: "距離螢幕距離",
  T_48_META_API_69_P2_D: "世界座標",
  T_48_META_API_7_D: "將目標值轉換為字串",
  T_48_META_API_7_P0_D: "要轉字串的目標值",
  T_48_META_API_7_R_D: "字串",
  T_48_META_API_70_D: "透過螢幕觸控進行射線檢測，返回第一個命中實體",
  T_48_META_API_70_P0_D: "起始螢幕觸點",
  T_48_META_API_70_P1_D: "檢測距離",
  T_48_META_API_70_P2_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_70_P3_D: "是否可以偵測出觸發器",
  T_48_META_API_70_P4_D: "命中的實體",
  T_48_META_API_70_P5_D: "命中點座標",
  T_48_META_API_70_P6_D: "命中點距離開始點距離",
  T_48_META_API_70_P7_D: "命中表面法線",
  T_48_META_API_71_D: "透過螢幕觸控進行射線檢測，返回所有命中實體",
  T_48_META_API_71_P0_D: "起始螢幕觸點",
  T_48_META_API_71_P1_D: "檢測距離",
  T_48_META_API_71_P2_D: "層遮罩，只有填入的層級會參與掃描，留空代表所有層級都參與掃描",
  T_48_META_API_71_P3_D: "是否可以偵測出觸發器",
  T_48_META_API_71_P4_D: "命中的實體列表",
  T_48_META_API_71_P5_D: "命中點座標列表",
  T_48_META_API_71_P6_D: "命中點距離開始點的距離列表",
  T_48_META_API_71_P7_D: "命中表面法線列表",
  T_48_META_API_72_D: "建立指定視覺特效，有更多需要設定的屬性時可設定它的實體屬性",
  T_48_META_API_72_P0_D: "創建的特效實體",
  T_48_META_API_72_P1_D: "特效類型",
  T_48_META_API_72_P2_D: "循環類型",
  T_48_META_API_72_P3_D: "是否立即播放",
  T_48_META_API_73_D: "建立內建UI，該UI不會同步給其他用戶端",
  T_48_META_API_73_P0_D: "建立的內建UI實體",
  T_48_META_API_73_P1_D: "內建UI類型",
  T_48_META_API_74_D: "建立自訂UI，該UI不會同步給其他客戶端",
  T_48_META_API_74_P0_D: "建立出的自訂UI實體",
  T_48_META_API_74_P1_D: "自訂UI索引",
  T_48_META_API_75_D: "取得當前客戶端對應玩家",
  T_48_META_API_75_R_D: "玩家實體",
  T_48_META_API_76_D: "創建AI怪物",
  T_48_META_API_76_P0_D: "目標AI",
  T_48_META_API_76_P1_D: "建立位置",
  T_48_META_API_76_P2_D: "人工智慧類型",
  T_48_META_API_76_P3_D: "所屬隊伍",
  T_48_META_API_76_P4_D: "是否自動索敵",
  T_48_META_API_76_P5_D: "攻擊模式",
  T_48_META_API_76_P6_D: "行進路徑",
  T_48_META_API_77_D: "設定向量的第一個分量",
  T_48_META_API_77_P0_D: "向量",
  T_48_META_API_77_P1_D: "第一個分量值",
  T_48_META_API_77_R_D: "修改第一個分量後的向量",
  T_48_META_API_78_D: "設定向量的第二個分量",
  T_48_META_API_78_P0_D: "向量",
  T_48_META_API_78_P1_D: "第二個分量值",
  T_48_META_API_78_R_D: "修改第二個分量後的向量",
  T_48_META_API_79_D: "設定向量的第三個分量",
  T_48_META_API_79_P0_D: "向量",
  T_48_META_API_79_P1_D: "第三個分量值",
  T_48_META_API_79_R_D: "修改第三個分量後的向量",
  T_48_META_API_8_D: "開啟會縮至中心座標點的安全區",
  T_48_META_API_8_P0_D: "安全區的中心點",
  T_48_META_API_8_P1_D: "安全區的半徑",
  T_48_META_API_8_P2_D: "等待時間，單位為秒，結束後安全區會開始向中心點收縮",
  T_48_META_API_8_P3_D: "安全區縮至中心點所需的時間，單位為秒",
  T_48_META_API_8_P4_D: "在安全區域外承受的每秒傷害量",
  T_48_META_API_80_D: "設定二維向量的第一個分量",
  T_48_META_API_80_P0_D: "二維向量",
  T_48_META_API_80_P1_D: "第一個分量值",
  T_48_META_API_80_R_D: "修改第一個分量後的二維向量",
  T_48_META_API_81_D: "設定二維向量的第二個分量",
  T_48_META_API_81_P0_D: "二維向量",
  T_48_META_API_81_P1_D: "第二個分量值",
  T_48_META_API_81_R_D: "修改第二個分量後的二維向量",
  T_48_META_API_82_D: "將角色控制器移動到指定位置，如果作用於玩家，則玩家必須開啟使用實體效果的玩家控制器才能生效",
  T_48_META_API_82_P0_D: "目標角色控制器",
  T_48_META_API_82_P1_D: "指定位置",
  T_48_META_API_83_D: "根據名稱取得目標父節點實體的指定子節點",
  T_48_META_API_83_P0_D: "父節點實體",
  T_48_META_API_83_P1_D: "子節點名稱",
  T_48_META_API_83_R_D: "子節點實體",
  T_48_META_API_84_D: "添加AOI特別關注，無視距離始終同步",
  T_48_META_API_84_P0_D: "特別關注的目標",
  T_48_META_API_84_P1_D: "觀察者",
  T_48_META_API_85_D: "移除AOI特別關注，取消視距外AOI同步",
  T_48_META_API_85_P0_D: "特別關注的目標",
  T_48_META_API_85_P1_D: "觀察者",
  T_48_META_API_86_D: "清空指定目標的全部AOI特別關注",
  T_48_META_API_86_P0_D: "特別關注的目標",
  T_48_META_API_87_D: "判斷是否存在AOI特別關注",
  T_48_META_API_87_P0_D: "特別關注的目標",
  T_48_META_API_87_P1_D: "已廢棄",
  T_48_META_API_87_R_D: "是否存在",
  T_48_META_API_88_D: "切換玩家的代理觀察者",
  T_48_META_API_88_P0_D: "玩家",
  T_48_META_API_88_P1_D: "代理觀察者",
  T_48_META_API_89_D: "將角色控制器位移一次，如果作用於玩家，則玩家必須打開使用物理效果的玩家控制器才能生效",
  T_48_META_API_89_P0_D: "目標對象，如果是玩家，則玩家必須開啟使用實體效果的玩家控制器才能生效",
  T_48_META_API_89_P1_D: "位移向量",
  T_48_META_API_9_D: "關閉安全區機制，當安全區縮到最小後，安全區外的玩家會持續受到傷害，關閉安全區機制後玩家恢復安全",
  T_48_META_API_90_D: "設定玩家是否可以自由退出",
  T_48_META_API_90_P0_D: "目標玩家",
  T_48_META_API_90_P1_D: "是否可以自由退出",
  T_48_META_API_9000_D: "建立內建UI，只有指定的玩家可以看到該UI",
  T_48_META_API_9000_P0_D: "建立的內建UI實體",
  T_48_META_API_9000_P1_D: "UI所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9000_P2_D: "內建UI類型",
  T_48_META_API_9001_D: "移除內建遊戲UI",
  T_48_META_API_9001_P0_D: "要移除的內建UI實體",
  T_48_META_API_9002_D: "使用指定的圖標類型建立圖標，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性（已廢棄，請使用CreateLevelObject）",
  T_48_META_API_9002_P0_D: "程式碼中是用來表示建立圖示實體的形參名稱，其對應的局部變數值是建立圖示的實體",
  T_48_META_API_9002_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9002_P2_D: "資源路徑，玩家選擇的圖示對應的資源路徑",
  T_48_META_API_9003_D: "移除指定的圖示（已廢棄，請使用DeleteEntity）",
  T_48_META_API_9003_P0_D: "要移除的圖示實體",
  T_48_META_API_9004_D: "使用指定的文本內容建立一個文本，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性（已廢棄，請使用CreateLevelObject）",
  T_48_META_API_9004_P0_D: "程式碼中是用來表示建立文字實體的形參名稱，其對應的局部變數值是建立文字的實體",
  T_48_META_API_9004_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9004_P2_D: "需要呈現的文字內容",
  T_48_META_API_9005_D: "移除指定的文字（已廢棄，請使用DeleteEntity）",
  T_48_META_API_9005_P0_D: "要移除的文字實體",
  T_48_META_API_9006_D: "使用指定的特效類型建立圖標，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性（已廢棄，請使用CreateEffect）",
  T_48_META_API_9006_P0_D: "程式碼中是用來表示創建特效實體的形參名稱，其對應的局部變數值是創建特效的實體",
  T_48_META_API_9006_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9006_P2_D: "特效類型，玩家可以選擇的特效種類",
  T_48_META_API_9007_D: "移除指定的特效（已廢棄，請使用DeleteEntity）",
  T_48_META_API_9007_P0_D: "要移除的特效實體",
  T_48_META_API_9008_D: "建立自訂UI，只有指定的玩家可以看到該UI",
  T_48_META_API_9008_P0_D: "建立出的自訂UI實體",
  T_48_META_API_9008_P1_D: "UI所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9008_P2_D: "自訂UI索引",
  T_48_META_API_9009_D: "移除自訂遊戲UI",
  T_48_META_API_9009_P0_D: "要移除的自訂UI實體",
  T_48_META_API_9010_D: "從自訂UI取得UI控件",
  T_48_META_API_9010_P0_D: "UI所屬的玩家實體",
  T_48_META_API_9010_P1_D: "自訂UI實體",
  T_48_META_API_9010_P2_D: "控制項唯一索引",
  T_48_META_API_9010_R_D: "UI控制項實體",
  T_48_META_API_9011_D: "播放指定的音效，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性（已廢棄，請使用CreateSound）",
  T_48_META_API_9011_P0_D: "程式碼中是用來表示建立音效實體的形參名稱，其對應的局部變數值是建立音效的實體",
  T_48_META_API_9011_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9011_P2_D: "音效類型，玩家可以選擇的音效種類",
  T_48_META_API_9012_D: "移除指定的音效（已廢棄，請使用DeleteEntity）",
  T_48_META_API_9012_P0_D: "要移除的音效實體",
  T_48_META_API_9013_D: "從自訂UI使用路徑取得一個UI控件",
  T_48_META_API_9013_P0_D: "UI所屬的玩家實體",
  T_48_META_API_9013_P1_D: "自訂UI",
  T_48_META_API_9013_P2_D: "控制項路徑",
  T_48_META_API_9013_R_D: "UI控制項實體",
  T_48_META_API_9014_D: "中斷播放中的音效實體（已廢棄，請使用PauseSound）",
  T_48_META_API_9014_P0_D: "需要被暫停的音效實體",
  T_48_META_API_9015_D: "繼續播放音效,可選擇是否從頭開始播放（已廢棄，請使用ResumeSound）",
  T_48_META_API_9015_P0_D: "被暫停後需要繼續播放的音效實體",
  T_48_META_API_9015_P1_D: "是否從頭開始",
  T_48_META_API_9016_D: "建立自訂UI控件",
  T_48_META_API_9016_P0_D: "建立的自訂控制項實體",
  T_48_META_API_9016_P1_D: "建立的控制項類型",
  T_48_META_API_9016_P2_D: "所屬UI實體",
  T_48_META_API_9016_P3_D: "所屬父控件，如果不填則以所屬UI實體為父節點",
  T_48_META_API_9017_D: "設定目標相機層遮罩",
  T_48_META_API_9017_P0_D: "目標相機實體",
  T_48_META_API_9017_P1_D: "層遮罩，只有填入的層級會顯示在目標相機中，留空代表所有層級都顯示",
  T_48_META_API_9018_D: "取得目標相機層遮罩",
  T_48_META_API_9018_P0_D: "目標相機實體",
  T_48_META_API_9018_R_D: "層遮罩，只有層遮罩內的層級會顯示在目標相機中",
  T_48_META_API_9019_D: "設定指定層級對目標相機是否可見",
  T_48_META_API_9019_P0_D: "目標相機實體",
  T_48_META_API_9019_P1_D: "可見性層級",
  T_48_META_API_9019_P2_D: "是否可見",
  T_48_META_API_9020_D: "設定目標玩家預設介面顯隱狀態",
  T_48_META_API_9020_P0_D: "目標玩家",
  T_48_META_API_9020_P1_D: "玩家介面類型，玩家介面類型是用來操控玩家及玩家相關內容的UI元素",
  T_48_META_API_9020_P2_D: "開關值，決定玩家介面顯隱",
  T_48_META_API_9021_D: "建立一個時間戳本地化字串",
  T_48_META_API_9021_P0_D: "時間戳",
  T_48_META_API_9021_P1_D: "格式化樣式",
  T_48_META_API_9021_R_D: "時間戳本地化字串",
  T_48_META_API_9022_D: "建立小地圖圖標",
  T_48_META_API_9022_P0_D: "建立的小地圖圖示實體",
  T_48_META_API_9022_P1_D: "所屬玩家，創建的小地圖圖示只有該玩家可見",
  T_48_META_API_9022_P2_D: "小地圖圖示資源路徑",
  T_48_META_API_9023_D: "使用指定的特效類型建立圖標，有更多需要設定的屬性時則透過實體進一步設定它的實體屬性",
  T_48_META_API_9023_P0_D: "程式碼中是用來表示創建特效實體的形參名稱，其對應的局部變數值是創建特效的實體",
  T_48_META_API_9023_P1_D: "所屬的玩家實體，只有該玩家可見",
  T_48_META_API_9023_P2_D: "特效類型，玩家可以選擇的特效種類",
  T_48_META_API_9024_D: "移除指定的特效（已廢棄，請使用DeleteEntity）",
  T_48_META_API_9024_P0_D: "要移除的特效實體",
  T_48_META_API_9025_D: "為目標物件在地圖上產生靜態像素，靜態像素不會隨著目標物件移動",
  T_48_META_API_9025_P0_D: "建立的靜態像素實體",
  T_48_META_API_9025_P1_D: "所屬玩家，所建立的靜態像素只有該玩家可見",
  T_48_META_API_9025_P2_D: "目標物件實體",
  T_48_META_API_9026_D: "獲得目標玩家的小地圖實體",
  T_48_META_API_9026_P0_D: "目標玩家",
  T_48_META_API_9026_R_D: "目前玩家小地圖",
  T_48_META_API_9027_D: "設定玩家墜落傷害，可依高度分段設定不同傷害",
  T_48_META_API_9027_P0_D: "目標玩家",
  T_48_META_API_9027_P1_D: "高度分段列表",
  T_48_META_API_9027_P2_D: "傷害分段列表",
  T_48_META_API_91_D: "使目標加入指定隊伍，會使目標退出原先所屬隊伍",
  T_48_META_API_91_P0_D: "需要加入隊伍的目標",
  T_48_META_API_91_P1_D: "加入的隊伍",
  T_48_META_API_91_P2_D: "是否成功",
  T_48_META_API_92_D: "使目標加入一支新建隊伍，會使目標退出原先所屬隊伍",
  T_48_META_API_92_P0_D: "需要加入隊伍的目標",
  T_48_META_API_92_P1_D: "新隊伍的名字",
  T_48_META_API_92_P2_D: "是否成功",
  T_48_META_API_94_D: "透過索引設定局部變數的值；在設定之前，該變數必須在目前呼叫過程中定義",
  T_48_META_API_94_P0: "指數",
  T_48_META_API_94_P0_D: "透過索引取得變數",
  T_48_META_API_94_P1: "變數值",
  T_48_META_API_94_P1_D: "目標變數值",
  T_48_META_API_94_P2: "算術類型",
  T_48_META_API_94_P2_D: "操作方法；所有類型都支援賦值，數值類型也支援自增、自減、乘法、除法和取模運算",
  T_48_META_API_94_P3: "變數名",
  T_48_META_API_94_P3_D: "目標變數名稱。僅用於錯誤輸出",
  T_48_META_API_95: "透過索引取得局部變數",
  T_48_META_API_95_D: "取得局部變數的值；在取得之前，該變數必須在目前呼叫過程中定義",
  T_48_META_API_95_P0: "指數",
  T_48_META_API_95_P0_D: "可變索引",
  T_48_META_API_95_P1: "變數名",
  T_48_META_API_95_P1_D: "目標變數名稱。僅用於錯誤輸出",
  T_48_META_API_9500_D: "通知目標玩家的用戶端播放特效",
  T_48_META_API_9500_P0_D: "目標玩家",
  T_48_META_API_9500_P1_D: "特效資源路徑",
  T_48_META_API_9500_P2_D: "顏色",
  T_48_META_API_9500_P3_D: "縮放大小，預設為1",
  T_48_META_API_9500_P4_D: "綁定對象，特效會附加為它的子節點",
  T_48_META_API_9500_P5_D: "相對於綁定物件的世界座標偏移",
  T_48_META_API_9501_D: "通知目標玩家的用戶端播放音效",
  T_48_META_API_9501_P0_D: "目標玩家",
  T_48_META_API_9501_P1_D: "音效類型",
  T_48_META_API_9502_D: "通知目標玩家的用戶端顯示飄字",
  T_48_META_API_9502_P0_D: "目標玩家",
  T_48_META_API_9502_P1_D: "飄字內容",
  T_48_META_API_9502_P2_D: "飄字顏色，類型為顏色",
  T_48_META_API_9502_P3_D: "飄字持續時間，單位為毫秒",
  T_48_META_API_9503_D: "使目標單位播放一次Emote動作表情",
  T_48_META_API_9503_P0_D: "播放Emote的目標",
  T_48_META_API_9503_P1_D: "Emote類型",
  T_48_META_API_9504_D: "暫停/恢復單位的Emote動作表情",
  T_48_META_API_9504_P0_D: "暫停/恢復Emote的目標",
  T_48_META_API_9504_P1_D: "True: 暫停播放，False: 恢復播放",
  T_48_META_EVT_1_D: "在遊戲開始時觸發，服務端會早於客戶端一段時間準備好",
  T_48_META_EVT_10_D: "在當前實體受到傷害前觸發",
  T_48_META_EVT_10_P0_D: "攻擊者實體，可能為空",
  T_48_META_EVT_10_P1_D: "傷害類型",
  T_48_META_EVT_10_P2_D: "造成的傷害量",
  T_48_META_EVT_10_P3_D: "傷害部位",
  T_48_META_EVT_1000_D: "在玩家積分改變時觸發",
  T_48_META_EVT_1000_P0_D: "積分變化的玩家",
  T_48_META_EVT_1000_P1_D: "變化積分的類型",
  T_48_META_EVT_1000_P2_D: "積分變化後的積分值",
  T_48_META_EVT_1001_D: "在隊伍積分改變時觸發",
  T_48_META_EVT_1001_P0_D: "積分變化的隊伍",
  T_48_META_EVT_1001_P1_D: "變化積分的類型",
  T_48_META_EVT_1001_P2_D: "積分變化後的積分值",
  T_48_META_EVT_1002_D: "當玩家排名改變時觸發",
  T_48_META_EVT_1002_P0_D: "排名變化的玩家",
  T_48_META_EVT_1002_P1_D: "排名變化後的名次",
  T_48_META_EVT_1003_D: "已廢棄",
  T_48_META_EVT_1003_P0_D: "已廢棄",
  T_48_META_EVT_1003_P1_D: "排名變化後的名次",
  T_48_META_EVT_11_D: "當玩家退出時觸發",
  T_48_META_EVT_11_P0_D: "退出的玩家",
  T_48_META_EVT_12_D: "在玩家控制器觸碰實體時觸發，只有當控制器主動發生動作時才會觸發",
  T_48_META_EVT_12_P0_D: "碰到的實體",
  T_48_META_EVT_13_D: "在目前實體造成傷害前觸發",
  T_48_META_EVT_13_P0_D: "承受傷害的實體",
  T_48_META_EVT_13_P1_D: "傷害類型",
  T_48_META_EVT_13_P2_D: "造成的傷害量",
  T_48_META_EVT_13_P3_D: "傷害部位",
  T_48_META_EVT_14_D: "在可播放實體每次循環時觸發，可播放實體為音效、特效等實體時此事件只在客戶端生效",
  T_48_META_EVT_2_D: "在邏輯幀更新時觸發，根據使用平台和設置，此事件觸發頻率會有不同",
  T_48_META_EVT_2002_D: "當玩家死亡時觸發",
  T_48_META_EVT_2002_P0_D: "死亡的玩家",
  T_48_META_EVT_2003_D: "在玩家助攻時觸發",
  T_48_META_EVT_2003_P0_D: "獲得助攻的玩家",
  T_48_META_EVT_2003_P1_D: "被擊殺的玩家",
  T_48_META_EVT_2004_D: "當玩家造成傷害時觸發",
  T_48_META_EVT_2004_P0_D: "造成傷害的玩家",
  T_48_META_EVT_2004_P1_D: "受到傷害的玩家",
  T_48_META_EVT_2004_P2_D: "傷害類型",
  T_48_META_EVT_2004_P3_D: "傷害量",
  T_48_META_EVT_2004_P4_D: "傷害部位",
  T_48_META_EVT_2005_D: "當玩家造成擊殺時觸發",
  T_48_META_EVT_2005_P0_D: "造成擊殺的玩家",
  T_48_META_EVT_2005_P1_D: "被擊殺的玩家",
  T_48_META_EVT_2005_P2_D: "傷害類型",
  T_48_META_EVT_2006_D: "當玩家加入遊戲時觸發",
  T_48_META_EVT_2006_P0_D: "加入遊戲的玩家",
  T_48_META_EVT_2007_D: "當玩家復活時觸發",
  T_48_META_EVT_2007_P0_D: "復活的玩家",
  T_48_META_EVT_2007_P1_D: "復活來源",
  T_48_META_EVT_2008_D: "當玩家被擊倒時觸發",
  T_48_META_EVT_2008_P0_D: "被擊倒的玩家",
  T_48_META_EVT_2008_P1_D: "進行攻擊的玩家",
  T_48_META_EVT_2009_D: "在玩家斷開連線時觸發",
  T_48_META_EVT_2009_P0_D: "斷開連線的玩家",
  T_48_META_EVT_2010_D: "在玩家重新連線時觸發",
  T_48_META_EVT_2010_P0_D: "重新連結的玩家",
  T_48_META_EVT_2100_D: "當隊伍被移除時觸發",
  T_48_META_EVT_2100_P0_D: "被移除的隊伍",
  T_48_META_EVT_2101_D: "在新增隊伍時觸發",
  T_48_META_EVT_2101_P0_D: "新增的隊伍",
  T_48_META_EVT_2102_D: "在隊伍被團滅時觸發",
  T_48_META_EVT_2102_P0_D: "被團滅的隊伍",
  T_48_META_EVT_3_D: "在遊戲結束時觸發，遊戲在伺服器上結束前觸發此事件",
  T_48_META_EVT_30_D: "在場景載入成功時觸發",
  T_48_META_EVT_30_P0_D: "場景名",
  T_48_META_EVT_3000_D: "在目前實體建立後觸發",
  T_48_META_EVT_3001_D: "在目前實體銷毀前觸發",
  T_48_META_EVT_3002_D: "當玩家進入觸發器時觸發",
  T_48_META_EVT_3002_P0_D: "進入觸發器的玩家",
  T_48_META_EVT_3003_D: "當玩家離開觸發器時觸發",
  T_48_META_EVT_3003_P0_D: "離開觸發器的玩家",
  T_48_META_EVT_3004_D: "點擊UI按鈕控制項後觸發",
  T_48_META_EVT_3004_P0_D: "點擊的玩家",
  T_48_META_EVT_3005_D: "點擊內建UI中的按鈕時觸發",
  T_48_META_EVT_3005_P0_D: "點擊的按鈕控制名字",
  T_48_META_EVT_3006_D: "當玩家使用水上滑板時觸發",
  T_48_META_EVT_3007_D: "在目前實體可用後觸發",
  T_48_META_EVT_3008_D: "在目前實體不可用後觸發",
  T_48_META_EVT_3009_D: "在實體進入觸發器時觸發，觸發事件時雙方均接收該事件，其中一方須為剛體，另一方須為觸發器；特別地，當觸發器為自訂觸發器物件時，僅觸發器會接收該事件",
  T_48_META_EVT_3009_P0_D: "發生觸發事件時的對方實體",
  T_48_META_EVT_3010_D: "在實體離開觸發器時觸發，觸發事件時雙方均接收該事件，其中一方須為剛體，另一方須為觸發器；特別地，當觸發器為自訂觸發器物件時，僅觸發器會接收該事件",
  T_48_META_EVT_3010_P0_D: "發生觸發事件時的對方實體",
  T_48_META_EVT_3011_D: "在當前實體被消滅後觸發",
  T_48_META_EVT_3011_P0_D: "攻擊者實體，可能為空",
  T_48_META_EVT_3011_P1_D: "傷害類型",
  T_48_META_EVT_3011_P2_D: "傷害部位",
  T_48_META_EVT_3012_D: "在目前實體被攻擊後觸發",
  T_48_META_EVT_3012_P0_D: "攻擊者實體，可能為空",
  T_48_META_EVT_3012_P1_D: "傷害類型",
  T_48_META_EVT_3012_P2_D: "造成的傷害量",
  T_48_META_EVT_3012_P3_D: "傷害部位",
  T_48_META_EVT_3013_D: "在目前實體造成傷害後觸發",
  T_48_META_EVT_3013_P0_D: "承受傷害的實體",
  T_48_META_EVT_3013_P1_D: "傷害類型",
  T_48_META_EVT_3013_P2_D: "造成的傷害量",
  T_48_META_EVT_3013_P3_D: "傷害部位",
  T_48_META_EVT_3014_D: "在目前實體消滅其他實體後觸發",
  T_48_META_EVT_3014_P0_D: "被消滅的實體",
  T_48_META_EVT_3014_P1_D: "傷害部位",
  T_48_META_EVT_3015_D: "在該玩家復活時觸發",
  T_48_META_EVT_3015_P0_D: "玩家復活來源類型",
  T_48_META_EVT_3016_D: "在生成器產生實體時觸發",
  T_48_META_EVT_3016_P0_D: "產生的實體列表",
  T_48_META_EVT_3016_P1_D: "波數",
  T_48_META_EVT_3017_D: "當玩家進入擊倒跪姿時調用",
  T_48_META_EVT_3018_D: "在隊伍成員全部死亡時觸發",
  T_48_META_EVT_3019_D: "在裝備頭盔、防彈衣或背包時觸發",
  T_48_META_EVT_3019_P0_D: "裝備ID",
  T_48_META_EVT_3020_D: "在手持主武器、副武器或近戰武器時觸發，包括切換為拳頭時",
  T_48_META_EVT_3020_P0_D: "觸發時裝備的武器實體",
  T_48_META_EVT_3021_D: "使用道具後觸發，需要使用時間的道具會在完成使用後觸發此事件",
  T_48_META_EVT_3021_P0_D: "道具ID",
  T_48_META_EVT_3021_P1_D: "道具實體，可能為空",
  T_48_META_EVT_3021_P2_D: "使用道具建立的新道具實體，可能為空",
  T_48_META_EVT_3022_D: "在獲得物品時觸發",
  T_48_META_EVT_3022_P0_D: "物品類型",
  T_48_META_EVT_3022_P1_D: "物品實體，可能為空",
  T_48_META_EVT_3023_D: "在實體積分改變時觸發",
  T_48_META_EVT_3023_P0_D: "變化積分的類型",
  T_48_META_EVT_3023_P1_D: "積分變化後的積分值",
  T_48_META_EVT_3024_D: "在實體排名改變時觸發",
  T_48_META_EVT_3024_P0_D: "排名變化後的名次",
  T_48_META_EVT_3025_D: "在助攻時觸發",
  T_48_META_EVT_3025_P0_D: "被擊殺的對象",
  T_48_META_EVT_3026_D: "實體進入載具時觸發，包括作為駕駛者和乘客",
  T_48_META_EVT_3026_P0_D: "進入載具的實體",
  T_48_META_EVT_3026_P1_D: "進入的載具",
  T_48_META_EVT_3027_D: "實體離開載具時觸發",
  T_48_META_EVT_3027_P0_D: "離開載具的實體",
  T_48_META_EVT_3027_P1_D: "離開的載具",
  T_48_META_EVT_3028_D: "實體駕駛載具時觸發，在車上為駕駛時",
  T_48_META_EVT_3028_P0_D: "駕駛載具的實體",
  T_48_META_EVT_3028_P1_D: "駕駛的載具",
  T_48_META_EVT_3029_D: "在載具被實體進入時觸發",
  T_48_META_EVT_3029_P0_D: "觸發實體",
  T_48_META_EVT_3030_D: "在載具有實體離開時觸發",
  T_48_META_EVT_3030_P0_D: "觸發實體",
  T_48_META_EVT_3031_D: "在載具被實體駕駛時觸發",
  T_48_META_EVT_3031_P0_D: "觸發實體",
  T_48_META_EVT_3032_D: "實體使用傳送門發生傳送後觸發（已廢棄，請使用OnBouncesOffTire）",
  T_48_META_EVT_3032_P0_D: "使用傳送門的實體",
  T_48_META_EVT_3032_P1_D: "使用的傳送門",
  T_48_META_EVT_3033_D: "實體發生彈跳行為時觸發",
  T_48_META_EVT_3033_P0_D: "觸發實體",
  T_48_META_EVT_3033_P1_D: "使用的彈跳物件",
  T_48_META_EVT_3034_D: "在傳送門使實體進行傳送後觸發",
  T_48_META_EVT_3034_P0_D: "進行傳送的實體",
  T_48_META_EVT_3035_D: "在輪胎將實體彈起後觸發",
  T_48_META_EVT_3035_P0_D: "被彈起的實體",
  T_48_META_EVT_3036_D: "在機關將實體擊飛時觸發",
  T_48_META_EVT_3036_P0_D: "被擊飛的實體",
  T_48_META_EVT_3036_P1_D: "機關物件",
  T_48_META_EVT_3037_D: "在實體進入觸發器時觸發",
  T_48_META_EVT_3037_P0_D: "進入的觸發器",
  T_48_META_EVT_3038_D: "在實體離開觸發器時觸發",
  T_48_META_EVT_3038_P0_D: "離開的觸發器",
  T_48_META_EVT_3039_D: "在獲得武器實體時觸發",
  T_48_META_EVT_3039_P0_D: "武器實體",
  T_48_META_EVT_3040_D: "實體被機關擊飛時觸發",
  T_48_META_EVT_3040_P0_D: "被擊飛的實體",
  T_48_META_EVT_3040_P1_D: "機關物件",
  T_48_META_EVT_3041_D: "在瞄準一個可瞄準實體時觸發",
  T_48_META_EVT_3041_P0_D: "被瞄準的實體",
  T_48_META_EVT_3042_D: "當被玩家瞄準時觸發",
  T_48_META_EVT_3042_P0_D: "進行瞄準的玩家",
  T_48_META_EVT_3043_D: "在子彈擊中目標時觸發",
  T_48_META_EVT_3043_P0_D: "被擊中的目標",
  T_48_META_EVT_3043_P1_D: "子彈擊中位置的世界座標",
  T_48_META_EVT_3044_D: "被武器擊中時觸發",
  T_48_META_EVT_3044_P0_D: "武器",
  T_48_META_EVT_3044_P1_D: "擊中部位的世界座標",
  T_48_META_EVT_3045_D: "當玩家選擇變身為該關卡物件時觸發",
  T_48_META_EVT_3045_P0_D: "玩家變身實體，並非場景物件本身",
  T_48_META_EVT_3046_D: "玩家在該復活點復活時觸發",
  T_48_META_EVT_3046_P0_D: "在此復活點復活的玩家",
  T_48_META_EVT_3047_D: "當玩家丟棄武器時觸發",
  T_48_META_EVT_3047_P0_D: "丟棄的武器實體",
  T_48_META_EVT_3048_D: "當玩家丟棄武器以外的物品時觸發",
  T_48_META_EVT_3048_P0_D: "物品類型",
  T_48_META_EVT_3048_P1_D: "物品實體，可能為空",
  T_48_META_EVT_3049_D: "在被足球槍擊中時觸發",
  T_48_META_EVT_3049_P0_D: "玩家",
  T_48_META_EVT_3049_P1_D: "被擊中後的速度",
  T_48_META_EVT_3050_D: "在足球和實體碰撞時觸發",
  T_48_META_EVT_3050_P0_D: "碰撞對象",
  T_48_META_EVT_3050_P1_D: "碰撞後的速度",
  T_48_META_EVT_3051_D: "當玩家加入語音頻道成功時觸發",
  T_48_META_EVT_3051_P0_D: "語音頻道實體",
  T_48_META_EVT_3052_D: "當玩家加入語音頻道失敗時觸發",
  T_48_META_EVT_3052_P0_D: "語音頻道實體",
  T_48_META_EVT_3053_D: "當玩家退出語音頻道時觸發",
  T_48_META_EVT_3053_P0_D: "語音頻道實體",
  T_48_META_EVT_3054_D: "在足球進入球門時觸發",
  T_48_META_EVT_3054_P0_D: "球門",
  T_48_META_EVT_3054_P1_D: "得分者，進門前最後一位觸球玩家",
  T_48_META_EVT_3054_P2_D: "助攻者，進門前倒數第二位觸球玩家",
  T_48_META_EVT_3055_D: "當玩家按下開火鍵時觸發",
  T_48_META_EVT_3056_D: "當玩家跳起時觸發",
  T_48_META_EVT_3057_D: "當玩家蹲下時觸發",
  T_48_META_EVT_3058_D: "在玩家趴下時觸發",
  T_48_META_EVT_3059_D: "在玩家疾跑時觸發",
  T_48_META_EVT_3060_D: "商店中成功購買商品時觸發",
  T_48_META_EVT_3060_P0_D: "購買商品的玩家",
  T_48_META_EVT_3060_P1_D: "商品",
  T_48_META_EVT_3061_D: "當武器被玩家裝備時觸發",
  T_48_META_EVT_3061_P0_D: "裝備武器的玩家",
  T_48_META_EVT_3062_D: "在使用該武器擊殺單位時觸發",
  T_48_META_EVT_3062_P0_D: "被擊殺的實體",
  T_48_META_EVT_3063_D: "在使用該武器對單位造成傷害時觸發",
  T_48_META_EVT_3063_P0_D: "受到傷害的實體",
  T_48_META_EVT_3063_P1_D: "傷害量",
  T_48_META_EVT_3064_D: "在武器更換子彈時觸發",
  T_48_META_EVT_3065_D: "在實體進入載具時觸發，作為駕駛者或乘客都可以觸發此事件",
  T_48_META_EVT_3065_P0_D: "進入的載具",
  T_48_META_EVT_3066_D: "在實體離開載具時觸發",
  T_48_META_EVT_3066_P0_D: "離開的載具",
  T_48_META_EVT_3067_D: "在實體駕駛載具時觸發",
  T_48_META_EVT_3067_P0_D: "駕駛的載具",
  T_48_META_EVT_3068_D: "在實體使用傳送門發生傳送後觸發",
  T_48_META_EVT_3068_P0_D: "使用的傳送門",
  T_48_META_EVT_3069_D: "在實體被輪胎彈起後觸發",
  T_48_META_EVT_3069_P0_D: "使用的輪胎",
  T_48_META_EVT_3070_D: "在實體被機關擊飛時觸發",
  T_48_META_EVT_3070_P0_D: "機關物件",
  T_48_META_EVT_3071_D: "在UI按鈕控制被玩家按下後觸發",
  T_48_META_EVT_3071_P0_D: "觸發玩家",
  T_48_META_EVT_3072_D: "在UI按鈕控制項抬起後觸發",
  T_48_META_EVT_3072_P0_D: "觸發玩家",
  T_48_META_EVT_3073_D: "在UI按鈕控制被玩家雙擊後觸發",
  T_48_META_EVT_3073_P0_D: "觸發玩家",
  T_48_META_EVT_3074_D: "越獄區域開始",
  T_48_META_EVT_3075_D: "越獄區域結束",
  T_48_META_EVT_3076_D: "當玩家停止使用水上滑板時觸發",
  T_48_META_EVT_3077_D: "在UI輸入框控制項的文字內容被玩家改變時觸發",
  T_48_META_EVT_3077_P0_D: "觸發玩家",
  T_48_META_EVT_3077_P1_D: "改變後的文字內容",
  T_48_META_EVT_3078_D: "在可播放實體開始播放時觸發",
  T_48_META_EVT_3078_P0_D: "可播放實體",
  T_48_META_EVT_3079_D: "在可播放實體結束播放時觸發，可播放實體為音效、特效等實體時此事件只在客戶端生效",
  T_48_META_EVT_3079_P0_D: "可播放實體",
  T_48_META_EVT_3080_D: "在可播放實體繼續播放時觸發",
  T_48_META_EVT_3080_P0_D: "可播放實體",
  T_48_META_EVT_3081_D: "在可播放實體暫停播放時觸發",
  T_48_META_EVT_3081_P0_D: "可播放實體",
  T_48_META_EVT_3082_D: "越獄玩家加入",
  T_48_META_EVT_3082_P0_D: "觸發玩家",
  T_48_META_EVT_3083_D: "越獄玩家退出",
  T_48_META_EVT_3083_P0_D: "觸發玩家",
  T_48_META_EVT_3084_D: "在倒數結束時觸發",
  T_48_META_EVT_3084_P0_D: "所屬實體",
  T_48_META_EVT_3085_D: "在物品被拾取時觸發",
  T_48_META_EVT_3085_P0_D: "拾取物品的玩家",
  T_48_META_EVT_3086_D: "在物品被丟棄時觸發",
  T_48_META_EVT_3086_P0_D: "丟棄物品的玩家",
  T_48_META_EVT_3087_D: "當此物品被裝備時觸發",
  T_48_META_EVT_3088_D: "在地雷創建後物件啟動時觸發",
  T_48_META_EVT_3089_D: "在地雷創建後物件觸發時觸發",
  T_48_META_EVT_3089_P0_D: "觸發地雷創建後物件的目標",
  T_48_META_EVT_3090_D: "商店中購買商品前觸發",
  T_48_META_EVT_3090_P0_D: "購買商品的玩家",
  T_48_META_EVT_3090_P1_D: "商品",
  T_48_META_EVT_3091_D: "在此裝置被使用時觸發",
  T_48_META_EVT_3092_D: "在鉤鎖槍被發射時觸發",
  T_48_META_EVT_3093_D: "在擲出投擲物後投擲物爆炸時觸發",
  T_48_META_EVT_3093_P0_D: "爆炸點",
  T_48_META_EVT_3094_D: "在被噴漆槍擊中時觸發",
  T_48_META_EVT_3094_P0_D: "噴漆槍實體",
  T_48_META_EVT_3094_P1_D: "命中點",
  T_48_META_EVT_3094_P2_D: "命中法線",
  T_48_META_EVT_3095_D: "在使用噴漆槍命中時觸發",
  T_48_META_EVT_3095_P0_D: "命中的物件",
  T_48_META_EVT_3095_P1_D: "命中點",
  T_48_META_EVT_3095_P2_D: "命中法線",
  T_48_META_EVT_3096_D: "在載具或染色桶爆炸時觸發",
  T_48_META_EVT_3096_P0_D: "造成爆炸的玩家",
  T_48_META_EVT_3096_P1_D: "被爆炸波及的玩家列表",
  T_48_META_EVT_3097_D: "在武器停止開火時觸發",
  T_48_META_EVT_3097_P0_D: "停止開火時當前彈匣餘彈量",
  T_48_META_EVT_3098_D: "在追擊目標進入追擊範圍時觸發",
  T_48_META_EVT_3099_D: "在追擊目標離開追擊範圍時觸發",
  T_48_META_EVT_31_D: "在場景切換成功時觸發",
  T_48_META_EVT_31_P0_D: "場景名",
  T_48_META_EVT_3100_D: "在攻擊目標進入攻擊範圍時觸發",
  T_48_META_EVT_3101_D: "在攻擊目標離開攻擊範圍時觸發",
  T_48_META_EVT_3102_D: "透過用戶端點擊事件觸發相機射線偵測時觸發此事件",
  T_48_META_EVT_3102_P0_D: "觸發玩家",
  T_48_META_EVT_3102_P1_D: "相機射線是否擊中對象",
  T_48_META_EVT_3102_P2_D: "相機射線撞擊位置",
  T_48_META_EVT_3102_P3_D: "用戶端相機朝向",
  T_48_META_EVT_3102_P4_D: "用戶端相機位置",
  T_48_META_EVT_3102_P5_D: "擊中實體",
  T_48_META_EVT_3103_D: "在商店介面被打開時觸發",
  T_48_META_EVT_3103_P0_D: "觸發玩家",
  T_48_META_EVT_3104_D: "在商店介面被關閉時觸發",
  T_48_META_EVT_3104_P0_D: "觸發玩家",
  T_48_META_EVT_3105_D: "在行為樹邏輯進入該節點時觸發",
  T_48_META_EVT_3105_P0_D: "節點名稱",
  T_48_META_EVT_3105_P1_D: "所屬實體",
  T_48_META_EVT_3106_D: "在行為樹邏輯退出該節點時觸發",
  T_48_META_EVT_3106_P0_D: "節點名稱",
  T_48_META_EVT_3106_P1_D: "所屬實體",
  T_48_META_EVT_3107_D: "在剛體被喚醒時觸發",
  T_48_META_EVT_3108_D: "在剛體進入休眠時觸發",
  T_48_META_EVT_3109_D: "在玩家移動時觸發",
  T_48_META_EVT_3109_P0_D: "姿態",
  T_48_META_EVT_3110_D: "當玩家待機時觸發",
  T_48_META_EVT_3110_P0_D: "姿態",
  T_48_META_EVT_3111_D: "當玩家使用技能時觸發",
  T_48_META_EVT_3111_P0_D: "使用的技能",
  T_48_META_EVT_3112_D: "在玩家結束衝刺時觸發",
  T_48_META_EVT_3113_D: "在取得SwitchEquipSlot列舉下的插槽對應的物品時觸發",
  T_48_META_EVT_3113_P0_D: "獲得的物品實體",
  T_48_META_EVT_3114_D: "在切換手持物品時觸發，包括切換為拳頭時",
  T_48_META_EVT_3114_P0_D: "切換後手持的的物品實體",
  T_48_META_EVT_3115_D: "商店中有玩家請求他人購買商品時觸發",
  T_48_META_EVT_3115_P0_D: "請求購買商品的玩家",
  T_48_META_EVT_3115_P1_D: "商品",
  T_48_META_EVT_3116_D: "商店中有玩家請求他人購買商品且請求被接受時觸發",
  T_48_META_EVT_3116_P0_D: "幫助購買的玩家",
  T_48_META_EVT_3116_P1_D: "請求幫助購買的玩家",
  T_48_META_EVT_3116_P2_D: "商品",
  T_48_META_EVT_3117_D: "在固定幀更新時觸發，頻率固定為每秒30次",
  T_48_META_EVT_3118_D: "在呼叫暫停遊戲API後觸發",
  T_48_META_EVT_3119_D: "在呼叫恢復遊戲API後觸發",
  T_48_META_EVT_3120_D: "當玩家新增、刪除好友時觸發",
  T_48_META_EVT_3121_D: "在收到Persona訊息時觸發",
  T_48_META_EVT_3121_P0_D: "資訊內容",
  T_48_META_EVT_3121_P1_D: "發送方Persona",
  T_48_META_EVT_3122_D: "在玩家跳躍結束時觸發",
  T_48_META_EVT_3123_D: "在玩家墜落時觸發",
  T_48_META_EVT_3124_D: "在玩家墜落結束時觸發",
  T_48_META_EVT_3125_D: "在收到Persona行為時觸發",
  T_48_META_EVT_3125_P0_D: "行為",
  T_48_META_EVT_3125_P1_D: "發送方Persona",
  T_48_META_EVT_3126_D: "在會員資訊改變時觸發",
  T_48_META_EVT_3126_P0_D: "會員改變後的狀態",
  T_48_META_EVT_3127_D: "進入會員中心時觸發",
  T_48_META_EVT_3128_D: "離開會員中心時觸發",
  T_48_META_EVT_3129_D: "在玩家進入擊倒狀態時觸發",
  T_48_META_EVT_3129_P0_D: "攻擊者實體，可能為空",
  T_48_META_EVT_3130_D: "在收到Persona狀態時觸發",
  T_48_META_EVT_3130_P0_D: "發送方Persona",
  T_48_META_EVT_3130_P1_D: "錯誤碼",
  T_48_META_EVT_3131_D: "透過UI傳送訊息給Persona時觸發",
  T_48_META_EVT_3131_P0_D: "資訊內容",
  T_48_META_EVT_3131_P1_D: "發送方Persona",
  T_48_META_EVT_3132_D: "在收到Persona結束時觸發",
  T_48_META_EVT_3132_P0_D: "發送方Persona",
  T_48_META_EVT_3132_P1_D: "錯誤碼",
  T_48_META_EVT_32_D: "在玩家切換場景時觸發",
  T_48_META_EVT_32_P0_D: "場景名",
  T_48_META_EVT_3200_D: "在動畫片段播放完成時觸發",
  T_48_META_EVT_3200_P0_D: "動畫片段名",
  T_48_META_EVT_3201_D: "在動畫狀態播放完成時觸發",
  T_48_META_EVT_3201_P0_D: "動畫狀態名",
  T_48_META_EVT_3204_D: "在Toggle控制項狀態變更時觸發",
  T_48_META_EVT_3204_P0_D: "觸發玩家",
  T_48_META_EVT_3204_P1_D: "狀態",
  T_48_META_EVT_3260_D: "在觸控板被玩家按下時觸發",
  T_48_META_EVT_3260_P0_D: "觸發玩家",
  T_48_META_EVT_3260_P1_D: "按下位置",
  T_48_META_EVT_3261_D: "在觸控板抬起時觸發",
  T_48_META_EVT_3261_P0_D: "觸發玩家",
  T_48_META_EVT_3261_P1_D: "抬起位置",
  T_48_META_EVT_3262_D: "在觸控板開始滑動時觸發",
  T_48_META_EVT_3262_P0_D: "觸發玩家",
  T_48_META_EVT_3262_P1_D: "開始滑動位置",
  T_48_META_EVT_3263_D: "在觸控板滑動中觸發，在滑動中，每個畫面都會觸發一次此事件",
  T_48_META_EVT_3263_P0_D: "觸發玩家",
  T_48_META_EVT_3263_P1_D: "開始滑動位置",
  T_48_META_EVT_3263_P2_D: "位移量",
  T_48_META_EVT_3264_D: "在觸控板滑動結束時觸發",
  T_48_META_EVT_3264_P0_D: "觸發玩家",
  T_48_META_EVT_3264_P1_D: "結束滑動位置",
  T_48_META_EVT_3265_D: "當JoyStick按下時觸發",
  T_48_META_EVT_3265_P0_D: "觸發玩家",
  T_48_META_EVT_3266_D: "在JoyStick抬起時觸發",
  T_48_META_EVT_3266_P0_D: "觸發玩家",
  T_48_META_EVT_3267_D: "在使用JoyStick搖桿時觸發",
  T_48_META_EVT_3267_P0_D: "觸發玩家",
  T_48_META_EVT_3267_P1_D: "輸出位移",
  T_48_META_EVT_3268_D: "當玩家從其他姿態站起時觸發",
  T_48_META_EVT_3268_P0_D: "玩家站起前的姿態",
  T_48_META_EVT_3269_D: "在武器進行開火操作時觸發",
  T_48_META_EVT_4_D: "在每一回合開始時觸發",
  T_48_META_EVT_4_P0_D: "回合索引，從0開始計算",
  T_48_META_EVT_5_D: "在每一回合結束時觸發",
  T_48_META_EVT_5_P0_D: "回合索引，從0開始計算",
  T_48_META_EVT_6_D: "在實體發生了碰撞時觸發，只有掛載了剛體元件的實體支援該事件",
  T_48_META_EVT_6_P0_D: "碰到的實體",
  T_48_META_EVT_7_D: "在每一階段開始時觸發",
  T_48_META_EVT_7_P0_D: "階段實體",
  T_48_META_EVT_8_D: "在每一階段結束時觸發",
  T_48_META_EVT_8_P0_D: "階段實體",
  T_48_META_EVT_9_D: "在實體碰撞結束時觸發，只有掛載了剛體元件的實體支援該事件",
  T_48_META_EVT_9_P0_D: "碰到的實體",
  T_49_META_TYP_10_I1_D: "標籤列表",
  T_49_META_TYP_10_I2_D: "自身是否可用",
  T_49_META_TYP_10_I3_D: "所有父節點是否都可用",
  T_49_META_TYP_10_I4_D: "在場景中是否可用",
  T_49_META_TYP_10_I5_D: "是否開啟邏輯更新，關閉時，該實體上的腳本會停止每幀更新",
  T_49_META_TYP_10_I6_D: "實體名稱",
  T_49_META_TYP_10_I7_D: "區域過濾選項，0表示自動計算是否受控，1表示不受控制始終同步，2表示受控制",
  T_49_META_TYP_100_I0_D: "設定觸發範圍",
  T_49_META_TYP_100_I1_D: "模型顯隱",
  T_49_META_TYP_101_I0_D: "當前綁定的玩家",
  T_49_META_TYP_101_I1_D: "模仿的目標物品 ID，參照 SceneEditPrefab 中的第一列",
  T_49_META_TYP_101_I2_D: "模仿的目標的朝向",
  T_49_META_TYP_101_I3_D: "模仿的目標的縮放",
  T_49_META_TYP_1010_I1_D: "計時的時長，單位秒",
  T_49_META_TYP_1010_I2_D: "計時的開始時刻，以秒為單位的遊戲時刻",
  T_49_META_TYP_1010_I3_D: "計時的更新類型，請參閱`EUITimeUpdateType`，可選靜止、計時、倒數計時",
  T_49_META_TYP_1010_I4_D: "顯示位置,當有跟隨目標時是相對目標原點的偏移,當沒有跟隨目標時是螢幕座標",
  T_49_META_TYP_1011_I10_D: "進度圖示名",
  T_49_META_TYP_1011_I2_D: "主題顏色",
  T_49_META_TYP_1011_I3_D: "是否開啟本地化顯示",
  T_49_META_TYP_1011_I4_D: "標題文本",
  T_49_META_TYP_1011_I5_D: "描述文本",
  T_49_META_TYP_1011_I6_D: "圖示資源名",
  T_49_META_TYP_1011_I7_D: "最大進度",
  T_49_META_TYP_1011_I8_D: "當前進度",
  T_49_META_TYP_1011_I9_D: "進度圖示",
  T_49_META_TYP_1012_I1_D: "是否開啟本地化",
  T_49_META_TYP_1012_I2_D: "回合數文本",
  T_49_META_TYP_1012_I3_D: "回合數參數數組",
  T_49_META_TYP_1012_I5_D: "左邊顏色",
  T_49_META_TYP_1012_I6_D: "右邊顏色",
  T_49_META_TYP_1013_I2_D: "回合數文本",
  T_49_META_TYP_1013_I3_D: "回合數參數數組",
  T_49_META_TYP_1014_I2_D: "第一種得分標題文本",
  T_49_META_TYP_1014_I3_D: "第一種得分值",
  T_49_META_TYP_1014_I4_D: "第一種得分值參數數組",
  T_49_META_TYP_1014_I5_D: "第二種得分標題文本",
  T_49_META_TYP_1014_I6_D: "第二種得分值",
  T_49_META_TYP_1014_I7_D: "第二種得分值參數數組",
  T_49_META_TYP_1016_I1_D: "根據數值顯示對應的狀態，勝利（1）、失敗（2）、平手（3）、Booyah（4）",
  T_49_META_TYP_1016_I2_D: "顯示2個隊伍比數為true時則顯示，否則隱藏",
  T_49_META_TYP_1016_I3_D: "左邊隊伍得分",
  T_49_META_TYP_1016_I4_D: "右邊隊伍得分",
  T_49_META_TYP_1016_I5_D: "階段結束時間戳",
  T_49_META_TYP_1017_I1_D: "左邊隊伍名",
  T_49_META_TYP_1017_I2_D: "左邊隊伍描述",
  T_49_META_TYP_1017_I3_D: "右邊隊伍名",
  T_49_META_TYP_1017_I4_D: "右邊隊伍描述",
  T_49_META_TYP_1018_I1_D: "第幾回合",
  T_49_META_TYP_1018_I4_D: "左邊隊伍分數",
  T_49_META_TYP_1018_I6_D: "右邊隊伍分數",
  T_49_META_TYP_1019_I1_D: "勝敗平分別對應1 2 3",
  T_49_META_TYP_102_I0_D: "復活來源類型, 玩家從死亡狀態復活",
  T_49_META_TYP_102_I1_D: "復活源類型, 玩家從倒地狀態復活",
  T_49_META_TYP_1020_I2_D: "所要顯示的文字key",
  T_49_META_TYP_1020_I3_D: "文字key對應的參數數組",
  T_49_META_TYP_1021_I1_D: "基礎時間，以秒為單位",
  T_49_META_TYP_1021_I2_D: "持續時間，以秒為單位",
  T_49_META_TYP_1021_I3_D: "顯示位置,當有跟隨目標時是相對目標原點的偏移,當沒有跟隨目標時是螢幕座標,預設為Vector3(0)",
  T_49_META_TYP_1022_I2_D: "所要顯示的文字key",
  T_49_META_TYP_1022_I3_D: "文字key對應的參數數組",
  T_49_META_TYP_1023_I1_D: "顯示隊伍比分為true時則顯示，否則關閉",
  T_49_META_TYP_1023_I4_D: "顯示隊員狀態為true時則顯示，否則關閉",
  T_49_META_TYP_1023_I5_D: "左邊隊員狀態數組, 0：存活數，1：死亡數，2：倒地數",
  T_49_META_TYP_1023_I6_D: "右邊隊員狀態數組, 0：存活數，1：死亡數，2：倒地數",
  T_49_META_TYP_1023_I7_D: "左邊隊員旗子數",
  T_49_META_TYP_1023_I8_D: "右邊隊員旗子數",
  T_49_META_TYP_1024_I2_D: "偏移量",
  T_49_META_TYP_1024_I3_D: "排名",
  T_49_META_TYP_1024_I4_D: "隊伍顏色",
  T_49_META_TYP_1024_I5_D: "圖示名稱",
  T_49_META_TYP_1024_I6_D: "顯示邊框為true時則顯示，否則關閉",
  T_49_META_TYP_1024_I7_D: "得分文本 Key",
  T_49_META_TYP_1024_I8_D: "得分文本參數數組",
  T_49_META_TYP_1028_I1_D: "左邊隊員存活數",
  T_49_META_TYP_1028_I2_D: "右邊隊員存活數",
  T_49_META_TYP_1028_I3_D: "左邊背景顏色",
  T_49_META_TYP_1028_I4_D: "右邊背景顏色",
  T_49_META_TYP_1028_I5_D: "左邊圖示名稱",
  T_49_META_TYP_1028_I6_D: "右邊圖示名稱",
  T_49_META_TYP_1029_I1_D: "圖示名稱",
  T_49_META_TYP_1029_I2_D: "背景圖示名稱",
  T_49_META_TYP_103_I0_D: "主武器A",
  T_49_META_TYP_103_I1_D: "主武器B",
  T_49_META_TYP_103_I10_D: "冰凍彈",
  T_49_META_TYP_103_I11_D: "冰牆",
  T_49_META_TYP_103_I12_D: "地雷",
  T_49_META_TYP_103_I13_D: "自動砲塔",
  T_49_META_TYP_103_I14_D: "假手雷",
  T_49_META_TYP_103_I16_D: "滑板、迷彩....",
  T_49_META_TYP_103_I2_D: "副武器",
  T_49_META_TYP_103_I3_D: "爆破武器",
  T_49_META_TYP_103_I5_D: "重武器",
  T_49_META_TYP_1030_I3_D: "左邊隊員存活數",
  T_49_META_TYP_1030_I4_D: "右邊隊員存活數",
  T_49_META_TYP_1030_I5_D: "左邊隊伍圖示名稱",
  T_49_META_TYP_1030_I6_D: "右邊隊伍圖示名稱",
  T_49_META_TYP_1031_I2_D: "提示資訊描述",
  T_49_META_TYP_1031_I3_D: "倒數計時開始時間戳，以秒為單位",
  T_49_META_TYP_1031_I4_D: "提示信息描述參數",
  T_49_META_TYP_1032_I1_D: "飄字提示類型",
  T_49_META_TYP_1032_I3_D: "信息提示描述參數數組",
  T_49_META_TYP_1033_I1_D: "切換階段，0 為目前回合結算，1為下回合開始",
  T_49_META_TYP_1033_I10_D: "失敗提示文本，不填為默認",
  T_49_META_TYP_1033_I11_D: "回合收入標題",
  T_49_META_TYP_1033_I12_D: "回合收入數值",
  T_49_META_TYP_1033_I13_D: "回合收入詳情標題",
  T_49_META_TYP_1033_I14_D: "回合收入數值詳情列表，與以上詳情標題列表一一對應",
  T_49_META_TYP_1033_I15_D: "MVP玩家暱稱",
  T_49_META_TYP_1033_I16_D: "下回合 Index",
  T_49_META_TYP_1033_I17_D: "是否決勝局",
  T_49_META_TYP_1033_I18_D: "是否最終回合",
  T_49_META_TYP_1033_I6_D: "左邊隊伍圖示名稱",
  T_49_META_TYP_1033_I7_D: "右邊隊伍圖示名稱",
  T_49_META_TYP_1033_I8_D: "根據值顯示對應的狀態，勝利（1）、失敗（2）",
  T_49_META_TYP_1033_I9_D: "勝利提示文本，不填為默認",
  T_49_META_TYP_1036_I1_D: "表示總共有多少個等級",
  T_49_META_TYP_1036_I2_D: "表示目前的殭屍等級",
  T_49_META_TYP_1037_I1_D: "表示顯示多少積分",
  T_49_META_TYP_1039_I3_D: "倒數計時開始時間戳，以秒為單位",
  T_49_META_TYP_104_I0_D: "樣式A",
  T_49_META_TYP_104_I1_D: "樣式B",
  T_49_META_TYP_104_I2_D: "樣式C",
  T_49_META_TYP_1040_I10_D: "卡牌描述數組",
  T_49_META_TYP_1040_I11_D: "選擇Item的索引,從0開始，小於0表示取消選擇",
  T_49_META_TYP_1040_I12_D: "按鈕名字數組",
  T_49_META_TYP_1040_I13_D: "按鈕顏色數組",
  T_49_META_TYP_1040_I2_D: "倒計時 Key",
  T_49_META_TYP_1040_I3_D: "倒計時長，以秒為單位",
  T_49_META_TYP_1040_I4_D: "描述信息 Key",
  T_49_META_TYP_1040_I5_D: "描述資訊參數數組",
  T_49_META_TYP_1040_I6_D: "卡牌背景 Sprite 數組",
  T_49_META_TYP_1040_I7_D: "卡牌背景顏色數組",
  T_49_META_TYP_1040_I8_D: "卡牌 Icon Sprite 數組",
  T_49_META_TYP_1040_I9_D: "卡牌名字數組",
  T_49_META_TYP_1041_I2_D: "位置",
  T_49_META_TYP_1041_I3_D: "Icon圖片",
  T_49_META_TYP_1041_I4_D: "文本內容",
  T_49_META_TYP_1041_I5_D: "背景顏色",
  T_49_META_TYP_1042_I1_D: "相對位置",
  T_49_META_TYP_1043_I4_D: "文本顏色",
  T_49_META_TYP_1043_I5_D: "文本內容 Key",
  T_49_META_TYP_1043_I6_D: "文本內容參數數組",
  T_49_META_TYP_1045_I2_D: "按鈕圖示",
  T_49_META_TYP_1045_I3_D: "圖示顏色",
  T_49_META_TYP_1045_I4_D: "尺寸大小，寬高相同",
  T_49_META_TYP_1045_I5_D: "相對於右下角錨點的位置",
  T_49_META_TYP_1045_I6_D: "充能數量,小於0就隱藏",
  T_49_META_TYP_1045_I7_D: "CD開始時間,以毫秒為單位",
  T_49_META_TYP_1045_I8_D: "CD持續時間,以毫秒為單位",
  T_49_META_TYP_1045_I9_D: "為True，按鈕變灰， False則還原",
  T_49_META_TYP_106_I1_D: "啟用",
  T_49_META_TYP_106_I2_D: "停用",
  T_49_META_TYP_109_I0_D: "聊天頻道實體 ID",
  T_49_META_TYP_109_I1_D: "玩家列表",
  T_49_META_TYP_11_I0_D: "當前遊戲是否處於非法狀態，當處於非法狀態時意味著遊戲已失去對抗價值，建議直接結束遊戲",
  T_49_META_TYP_11_I1_D: "目前遊戲已經進行的遊戲時長，單位毫秒",
  T_49_META_TYP_11_I10_D: "是否每回合重置裝備",
  T_49_META_TYP_11_I11_D: "是否啟用毒圈機制",
  T_49_META_TYP_11_I12_D: "安全區大小",
  T_49_META_TYP_11_I13_D: "開始縮圈時間",
  T_49_META_TYP_11_I14_D: "縮圈時長",
  T_49_META_TYP_11_I15_D: "毒圈傷害",
  T_49_META_TYP_11_I18_D: "復活類型",
  T_49_META_TYP_11_I2_D: "當前回合索引，透過該值可以取得到目前的回合實體",
  T_49_META_TYP_11_I27_D: "遊戲總回合數",
  T_49_META_TYP_11_I3_D: "當前階段索引，透過該值可以獲得目前的階段實體",
  T_49_META_TYP_11_I32_D: "回合開始時獲得金幣數量",
  T_49_META_TYP_11_I33_D: "擊殺時獲得金幣數量",
  T_49_META_TYP_11_I34_D: "獲勝時獲得金幣數量",
  T_49_META_TYP_11_I35_D: "是否顯示錢包UI",
  T_49_META_TYP_11_I36_D: "天空盒實體",
  T_49_META_TYP_11_I37_D: "自遊戲啟動後的累計運行幀",
  T_49_META_TYP_11_I38_D: "是否允許移動",
  T_49_META_TYP_11_I39_D: "是否自訂結算",
  T_49_META_TYP_11_I4_D: "預設UGC模式的範本ID",
  T_49_META_TYP_11_I40_D: "是否允許中途加入",
  T_49_META_TYP_11_I41_D: "開啟低幀率模式，遊戲將以15FPS運行，否則30FPS",
  T_49_META_TYP_11_I42_D: "遊戲伺服器兩次邏輯幀更新間隔",
  T_49_META_TYP_11_I43_D: "固定幀更新間隔，以毫秒為單位",
  T_49_META_TYP_11_I5_D: "若關閉則禁用玩家復活",
  T_49_META_TYP_11_I6_D: "若關閉則禁用Bot復活",
  T_49_META_TYP_11_I7_D: "復活時長，單位秒",
  T_49_META_TYP_11_I8_D: "遊戲中總隊伍數",
  T_49_META_TYP_11_I9_D: "每隊的成員數",
  T_49_META_TYP_110_I0_D: "頻道 A",
  T_49_META_TYP_110_I1_D: "頻道 B",
  T_49_META_TYP_110_I2_D: "頻道 C",
  T_49_META_TYP_110_I3_D: "頻道 D",
  T_49_META_TYP_110_I4_D: "頻道 E",
  T_49_META_TYP_110_I5_D: "頻道 F",
  T_49_META_TYP_111_I1_D: "衝刺",
  T_49_META_TYP_111_I2_D: "攻擊",
  T_49_META_TYP_111_I3_D: "跳躍",
  T_49_META_TYP_111_I4_D: "翻越",
  T_49_META_TYP_111_I5_D: "駕駛",
  T_49_META_TYP_111_I6_D: "進入載具",
  T_49_META_TYP_111_I7_D: "離開載具",
  T_49_META_TYP_111_I8_D: "操控載具",
  T_49_META_TYP_112_I0_D: "啟用",
  T_49_META_TYP_112_I1_D: "停用",
  T_49_META_TYP_112_I2_D: "隱形",
  T_49_META_TYP_117_I0_D: "拍手聲",
  T_49_META_TYP_117_I1_D: "閉合踩镲",
  T_49_META_TYP_117_I2_D: "底鼓",
  T_49_META_TYP_117_I3_D: "打開的踩镲",
  T_49_META_TYP_117_I4_D: "吊镲",
  T_49_META_TYP_117_I5_D: "軍鼓",
  T_49_META_TYP_118_I0_D: "陣營所有成員是否處於死亡",
  T_49_META_TYP_118_I1_D: "所有隊員列表",
  T_49_META_TYP_118_I2_D: "友好陣營",
  T_49_META_TYP_118_I3_D: "可攻擊的陣營",
  T_49_META_TYP_118_I4_D: "是否顯示UI名字",
  T_49_META_TYP_118_I5_D: "是否顯示地圖訊息",
  T_49_META_TYP_118_I6_D: "是否“顯示”",
  T_49_META_TYP_118_I7_D: "是否“顯示”",
  T_49_META_TYP_118_I8_D: "所有成員",
  T_49_META_TYP_118_I9_D: "是否顯示快速消息",
  T_49_META_TYP_119_I0_D: "是",
  T_49_META_TYP_119_I1_D: "否",
  T_49_META_TYP_120_I1_D: "跟隨的目標實體，預設為空",
  T_49_META_TYP_120_I2_D: "UI顏色",
  T_49_META_TYP_120_I3_D: "UI長度",
  T_49_META_TYP_120_I4_D: "當前進度值,0到1.0",
  T_49_META_TYP_120_I5_D: "顯示位置,當有跟隨目標時是相對目標原點的偏移,當沒有跟隨目標時是螢幕座標,預設為Vector3(0)",
  T_49_META_TYP_121_I0_D: "3 秒",
  T_49_META_TYP_121_I1_D: "5 秒",
  T_49_META_TYP_121_I2_D: "10 秒",
  T_49_META_TYP_121_I3_D: "15 秒",
  T_49_META_TYP_121_I4_D: "30 秒",
  T_49_META_TYP_121_I5_D: "9999 秒",
  T_49_META_TYP_122_I0_D: "基礎天空盒資源",
  T_49_META_TYP_122_I1_D: "主光源顏色",
  T_49_META_TYP_122_I10_D: "所屬的子場景GUID",
  T_49_META_TYP_122_I11_D: "霧效功能開關",
  T_49_META_TYP_122_I12_D: "霧效模式",
  T_49_META_TYP_122_I13_D: "指數霧的密度",
  T_49_META_TYP_122_I14_D: "線性霧的起始距離",
  T_49_META_TYP_122_I15_D: "線性霧的結束距離",
  T_49_META_TYP_122_I16_D: "開啟霧效特性",
  T_49_META_TYP_122_I17_D: "主光源旋轉角度",
  T_49_META_TYP_122_I18_D: "開啟主光源旋轉角度特性",
  T_49_META_TYP_122_I2_D: "主光源強度",
  T_49_META_TYP_122_I3_D: "全局暗度",
  T_49_META_TYP_122_I4_D: "陰影暗度",
  T_49_META_TYP_122_I5_D: "地面濕度",
  T_49_META_TYP_122_I6_D: "光暈強度",
  T_49_META_TYP_122_I7_D: "霧氣顏色",
  T_49_META_TYP_122_I8_D: "環境光顏色",
  T_49_META_TYP_123_I0_D: "白天",
  T_49_META_TYP_123_I1_D: "夜晚",
  T_49_META_TYP_123_I2_D: "黃昏",
  T_49_META_TYP_123_I3_D: "城市",
  T_49_META_TYP_123_I4_D: "彩色魔方",
  T_49_META_TYP_123_I5_D: "極地星空",
  T_49_META_TYP_124_I0_D: "近距離",
  T_49_META_TYP_124_I1_D: "中距離",
  T_49_META_TYP_124_I2_D: "遠距離",
  T_49_META_TYP_125_I0_D: "表面貼圖顏色",
  T_49_META_TYP_125_I2_D: "表面貼圖",
  T_49_META_TYP_125_I4_D: "表面透明度",
  T_49_META_TYP_126_I1_D: "物件名字",
  T_49_META_TYP_126_I2_D: "當前進度數值",
  T_49_META_TYP_126_I3_D: "最大進度數值",
  T_49_META_TYP_126_I4_D: "螢幕座標,預設為Vector3(0)",
  T_49_META_TYP_126_I5_D: "進度條長度，目前預設值為prefab上UI的長度",
  T_49_META_TYP_127_I0_D: "沿著某個軸平移，可以三個軸組合",
  T_49_META_TYP_127_I1_D: "沿著某個軸旋轉，可以三個軸組合",
  T_49_META_TYP_127_I2_D: "沿著某個軸縮放，可以三個軸組合",
  T_49_META_TYP_128_I0_D: "灌木",
  T_49_META_TYP_128_I1_D: "南瓜",
  T_49_META_TYP_128_I2_D: "稻草人",
  T_49_META_TYP_128_I3_D: "儲物櫃",
  T_49_META_TYP_129_I0_D: "隨機Loot",
  T_49_META_TYP_129_I1_D: "AR 子彈",
  T_49_META_TYP_129_I2_D: "SMG 子彈",
  T_49_META_TYP_129_I3_D: "SN 子彈",
  T_49_META_TYP_129_I4_D: "HG 子彈",
  T_49_META_TYP_129_I5_D: "SG子彈",
  T_49_META_TYP_129_I6_D: "箭支",
  T_49_META_TYP_13_I1_D: "相對於父節的錨點座標",
  T_49_META_TYP_13_I10_D: "Widget與錨框尺寸差",
  T_49_META_TYP_13_I11_D: "支點",
  T_49_META_TYP_13_I12_D: "深度",
  T_49_META_TYP_13_I14_D: "在同一個父節點所有子節點的順序",
  T_49_META_TYP_13_I15_D: "父節點控件 EntityID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "優先級",
  T_49_META_TYP_13_I18_D: "實際位置",
  T_49_META_TYP_13_I2_D: "寬度",
  T_49_META_TYP_13_I4_D: "Z軸旋轉角度",
  T_49_META_TYP_13_I6_D: "控制項在Prefab中的內部ID",
  T_49_META_TYP_13_I7_D: "所在UI實體",
  T_49_META_TYP_13_I8_D: "錨點最小值",
  T_49_META_TYP_13_I9_D: "錨點最大值",
  T_49_META_TYP_130_I0_D: "隨機消耗品Loot",
  T_49_META_TYP_130_I1_D: "急救包",
  T_49_META_TYP_130_I2_D: "護甲修理包",
  T_49_META_TYP_130_I3_D: "强心針",
  T_49_META_TYP_130_I4_D: "吸入器",
  T_49_META_TYP_131_I0_D: "隨機護甲Loot",
  T_49_META_TYP_131_I1_D: "一級護甲",
  T_49_META_TYP_131_I2_D: "二級護甲",
  T_49_META_TYP_131_I3_D: "三級護甲",
  T_49_META_TYP_132_I0_D: "隨機投擲物Loot",
  T_49_META_TYP_132_I1_D: "手榴彈",
  T_49_META_TYP_132_I4_D: "冷凍手榴彈",
  T_49_META_TYP_133_I0_D: "隨機倍鏡Loot",
  T_49_META_TYP_133_I1_D: "2 倍鏡",
  T_49_META_TYP_133_I2_D: "4 倍鏡",
  T_49_META_TYP_133_I3_D: "熱成像鏡",
  T_49_META_TYP_134_I0_D: "随机武器Loot",
  T_49_META_TYP_134_I5_D: "散彈槍",
  T_49_META_TYP_134_I8_D: "足球槍",
  T_49_META_TYP_135_I0_D: "Loot子彈點",
  T_49_META_TYP_136_I0_D: "Loot消耗物品點",
  T_49_META_TYP_137_I0_D: "Loot消耗物品點",
  T_49_META_TYP_138_I0_D: "Loot倍鏡點",
  T_49_META_TYP_139_I0_D: "Loot護甲點",
  T_49_META_TYP_14_I0_D: "玩家當前的血量",
  T_49_META_TYP_14_I1_D: "玩家目前的血量最大值",
  T_49_META_TYP_14_I11_D: "玩家的陣營",
  T_49_META_TYP_14_I12_D: "玩家的傷害倍率，如2倍配置為2.0",
  T_49_META_TYP_14_I13_D: "使用和男性或女性角色完全一致的骨骼，0表示不替換模型",
  T_49_META_TYP_14_I14_D: "與現有的速度縮放比例不會衝突",
  T_49_META_TYP_14_I15_D: "與現有的跳躍高度縮放比例不會衝突",
  T_49_META_TYP_14_I16_D: "身分,0 普通玩家，1 獵手,2 母體殭屍,3 普通殭屍，4 進化殭屍類型1, 5 進化殭屍類型2,6進化殭屍類型3",
  T_49_META_TYP_14_I17_D: "殭屍等級，1~3",
  T_49_META_TYP_14_I19_D: "玩家的暱稱",
  T_49_META_TYP_14_I2_D: "判斷當前玩家是AI玩家，AI一般為NPC或PVE的怪物",
  T_49_META_TYP_14_I20_D: "受到傷害時傷害量百分比，可減傷或增傷",
  T_49_META_TYP_14_I21_D: "玩家當前的EP",
  T_49_META_TYP_14_I22_D: "玩家EP最大值",
  T_49_META_TYP_14_I23_D: "當前手持中的主武器",
  T_49_META_TYP_14_I24_D: "死亡時遺失所有裝備",
  T_49_META_TYP_14_I26_D: "瞄準輔助類型",
  T_49_META_TYP_14_I27_D: "是否可被輔助瞄準鎖定",
  T_49_META_TYP_14_I28_D: "開關語音聊天: true關閉語音, false開啟語音",
  T_49_META_TYP_14_I29_D: "開關快速聊天: true關閉語音, false開啟語音",
  T_49_META_TYP_14_I3_D: "玩家狀態",
  T_49_META_TYP_14_I30_D: "頻道",
  T_49_META_TYP_14_I35_D: "開關拾取物品: true不能拾取, false可以拾取",
  T_49_META_TYP_14_I36_D: "開關丟棄物品: true不能丟棄, false可以丟棄",
  T_49_META_TYP_14_I37_D: "攻擊目標",
  T_49_META_TYP_14_I38_D: "友善玩家",
  T_49_META_TYP_14_I39_D: "陣營實體",
  T_49_META_TYP_14_I4_D: "玩家的存活時間，如果玩家死亡，該時間重新計算",
  T_49_META_TYP_14_I40_D: "玩家在陣營中的序號",
  T_49_META_TYP_14_I41_D: "玩家正在使用的相機",
  T_49_META_TYP_14_I42_D: "自訂重力",
  T_49_META_TYP_14_I43_D: "当前頭盔",
  T_49_META_TYP_14_I44_D: "當前防彈衣",
  T_49_META_TYP_14_I5_D: "玩家的無敵狀態",
  T_49_META_TYP_14_I52_D: "用戶UID",
  T_49_META_TYP_14_I53_D: "爆頭減傷率",
  T_49_META_TYP_14_I54_D: "玩家綁定的AVATAR",
  T_49_META_TYP_14_I55_D: "性別",
  T_49_META_TYP_14_I56_D: "武器塗裝 ID",
  T_49_META_TYP_14_I57_D: "玩家的出生點",
  T_49_META_TYP_14_I58_D: "玩家的復活點，如果沒有檢查點記錄則使用出生點，否則使用檢查點",
  T_49_META_TYP_14_I59_D: "玩家當前的位置",
  T_49_META_TYP_14_I6_D: "玩家所屬隊伍的實體",
  T_49_META_TYP_14_I60_D: "玩家當前的朝向",
  T_49_META_TYP_14_I61_D: "用來訪問蒙皮骨骼的節點",
  T_49_META_TYP_14_I62_D: "背包",
  T_49_META_TYP_14_I63_D: "臨時護盾值",
  T_49_META_TYP_14_I64_D: "載具外觀 ID",
  T_49_META_TYP_14_I65_D: "跳過墜落時的僵直動畫",
  T_49_META_TYP_14_I66_D: "是否墜落時免傷",
  T_49_META_TYP_14_I67_D: "當前手持物品",
  T_49_META_TYP_14_I68_D: "禁止拾取物品列表",
  T_49_META_TYP_14_I69_D: "玩家資源ID",
  T_49_META_TYP_14_I7_D: "目前的檢查點ID",
  T_49_META_TYP_14_I70_D: "發送請求購買訊息的目標",
  T_49_META_TYP_14_I71_D: "目前播放的Emote資源ID",
  T_49_META_TYP_14_I72_D: "目前播放的Emote是否循環",
  T_49_META_TYP_14_I73_D: "對擊倒狀態的處理",
  T_49_META_TYP_14_I74_D: "是否開啟傷害跳字，預設為True，表示開啟",
  T_49_META_TYP_14_I76_D: "能否中途退出",
  T_49_META_TYP_14_I77_D: "玩家變身為其他角色時需要保留的服飾訊息",
  T_49_META_TYP_14_I8_D: "目標前往的檢查點ID",
  T_49_META_TYP_140_I0_D: "波次1",
  T_49_META_TYP_140_I1_D: "波次2",
  T_49_META_TYP_140_I2_D: "波次3",
  T_49_META_TYP_140_I3_D: "連續",
  T_49_META_TYP_141_I0_D: "隨機足球戰利品",
  T_49_META_TYP_141_I1_D: "足球護盾",
  T_49_META_TYP_141_I2_D: "冰凍手雷",
  T_49_META_TYP_142_I0_D: "Loot足球點",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF經典（射擊）",
  T_49_META_TYP_147_I1_D: "第三人稱",
  T_49_META_TYP_147_I2_D: "第一人稱（射擊）",
  T_49_META_TYP_147_I3_D: "俯視角",
  T_49_META_TYP_147_I4_D: "橫向滾軸",
  T_49_META_TYP_147_I5_D: "自訂相機",
  T_49_META_TYP_147_I6_D: "追背",
  T_49_META_TYP_147_I7_D: "由玩家控制，自由移動的相機",
  T_49_META_TYP_147_I8_D: "新版第一人稱視角相機",
  T_49_META_TYP_148_I0_D: "提供多種預設相機類型，以及自訂相機類型",
  T_49_META_TYP_148_I1_D: "視野範圍為相機的觀察角度",
  T_49_META_TYP_148_I10_D: "相機切換動畫的類型",
  T_49_META_TYP_148_I11_D: "僅切換類型為平滑時生效，切換至該相機的過渡時間，單位毫秒",
  T_49_META_TYP_148_I12_D: "當相機與跟隨物件中間有遮蔽物時，相機的運動模式",
  T_49_META_TYP_148_I13_D: "相機渲染畫面時的成像方式",
  T_49_META_TYP_148_I14_D: "跟隨物件偏移參考座標系",
  T_49_META_TYP_148_I15_D: "觀察物件偏移參考座標系",
  T_49_META_TYP_148_I16_D: "相機的渲染層遮罩，可透過可見性層級篩選相機的渲染對象",
  T_49_META_TYP_148_I17_D: "視角限制",
  T_49_META_TYP_148_I2_D: "一般指相機位置相對於玩家原點位置的偏移量，不同相機類型具體意義不同",
  T_49_META_TYP_148_I3_D: "一般指相機對焦點相對於玩家原點位置的偏移量，不同相機類型具體意義不同",
  T_49_META_TYP_148_I4_D: "相機在垂直方向上的旋轉角",
  T_49_META_TYP_148_I5_D: "相機在水平方向上的旋轉角",
  T_49_META_TYP_148_I7_D: "相機跟隨的目標",
  T_49_META_TYP_148_I8_D: "相機觀察的目標",
  T_49_META_TYP_148_I9_D: "正在使用該相機的玩家",
  T_49_META_TYP_15_I0_D: "隊伍目前是否所有隊員都處於死亡狀態",
  T_49_META_TYP_15_I1_D: "隊伍的所有隊員列表",
  T_49_META_TYP_15_I3_D: "敵對隊伍列表",
  T_49_META_TYP_15_I4_D: "友善隊伍列表",
  T_49_META_TYP_15_I5_D: "隊伍序號",
  T_49_META_TYP_150_I0_D: "耐久",
  T_49_META_TYP_150_I1_D: "膠囊體兩端半球的半徑",
  T_49_META_TYP_150_I2_D: "傷害係數",
  T_49_META_TYP_152_I1_D: "自訂重力",
  T_49_META_TYP_152_I2_D: "是否需要顯示觸發器，True為顯示",
  T_49_META_TYP_154_I0_D: "不可以雙持",
  T_49_META_TYP_154_I1_D: "只可以和同一種槍進行組合雙持",
  T_49_META_TYP_154_I2_D: "可以和另一種武器也可以跟自己組合雙持",
  T_49_META_TYP_155_I0_D: "等級",
  T_49_META_TYP_155_I1_D: "最大耐久度",
  T_49_META_TYP_155_I2_D: "當前耐久度",
  T_49_META_TYP_155_I3_D: "傷害減免係數",
  T_49_META_TYP_155_I4_D: "爆炸傷害減免係數",
  T_49_META_TYP_155_I5_D: "是否消耗耐久度",
  T_49_META_TYP_155_I6_D: "是否可摧毀",
  T_49_META_TYP_156_I1_D: "最大耐久度",
  T_49_META_TYP_156_I2_D: "當前耐久度",
  T_49_META_TYP_156_I3_D: "傷害減免係數",
  T_49_META_TYP_156_I4_D: "爆炸傷害減免係數",
  T_49_META_TYP_156_I5_D: "是否消耗耐久度",
  T_49_META_TYP_156_I6_D: "是否可摧毀",
  T_49_META_TYP_157_I0_D: "無動畫",
  T_49_META_TYP_157_I1_D: "平滑",
  T_49_META_TYP_158_I2_D: "UI錨點類型枚舉,預設值為9（Center）",
  T_49_META_TYP_158_I6_D: "文本內容 Key",
  T_49_META_TYP_158_I7_D: "文本內容參數數組",
  T_49_META_TYP_158_I8_D: "是否啟用 UITweener 腳本",
  T_49_META_TYP_16_I1_D: "實體對應的物品ID",
  T_49_META_TYP_16_I2_D: "僅用於靜態載入物件時，判斷是靜態生成NavMesh",
  T_49_META_TYP_16_I3_D: "是否是NavMesh的動態阻擋",
  T_49_META_TYP_16_I4_D: "非同步載入",
  T_49_META_TYP_160_I0_D: "磚塊 A",
  T_49_META_TYP_160_I1_D: "磁磚A",
  T_49_META_TYP_160_I10_D: "沙子A",
  T_49_META_TYP_160_I11_D: "雪地A",
  T_49_META_TYP_160_I12_D: "木頭A",
  T_49_META_TYP_160_I13_D: "石頭A",
  T_49_META_TYP_160_I14_D: "草坪B",
  T_49_META_TYP_160_I15_D: "磚塊 B",
  T_49_META_TYP_160_I16_D: "磚塊 C",
  T_49_META_TYP_160_I17_D: "清除",
  T_49_META_TYP_160_I2_D: "磁磚B",
  T_49_META_TYP_160_I3_D: "磁磚C",
  T_49_META_TYP_160_I4_D: "竹子A",
  T_49_META_TYP_160_I5_D: "水泥 A",
  T_49_META_TYP_160_I6_D: "集裝箱A",
  T_49_META_TYP_160_I7_D: "草坪A",
  T_49_META_TYP_160_I8_D: "冰塊A",
  T_49_META_TYP_160_I9_D: "岩漿A",
  T_49_META_TYP_165_I0_D: "是否開啟碰撞",
  T_49_META_TYP_165_I1_D: "是否作為觸發器",
  T_49_META_TYP_165_I2_D: "物理層級，在實體模組裡配置層級，最多16個",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "特效貼圖類型",
  T_49_META_TYP_170_I0_D: "是否可見，當不可見時客戶端停止渲染目標",
  T_49_META_TYP_170_I1_D: "可見層級，取值範圍[0,15]，影響在相機中的可見性",
  T_49_META_TYP_171_I0_D: "EP修改值",
  T_49_META_TYP_172_I0_D: "子彈數量",
  T_49_META_TYP_173_I0_D: "額外背包空間",
  T_49_META_TYP_173_I1_D: "玩家局外的皮膚配置優先",
  T_49_META_TYP_173_I2_D: "背包皮膚ID,背包自身的皮膚配置",
  T_49_META_TYP_174_I2_D: "最大傷害",
  T_49_META_TYP_174_I4_D: "投擲速度",
  T_49_META_TYP_174_I5_D: "爆炸延時，單位秒",
  T_49_META_TYP_174_I6_D: "自己傷害系數",
  T_49_META_TYP_174_I7_D: "隊友傷害系數",
  T_49_META_TYP_174_I8_D: "車輛傷害系數",
  T_49_META_TYP_174_I9_D: "塗裝",
  T_49_META_TYP_175_I0_D: "冰凍區域半徑",
  T_49_META_TYP_175_I1_D: "冰凍區域時長，單位秒",
  T_49_META_TYP_176_I0_D: "武器的主類型",
  T_49_META_TYP_176_I1_D: "武器子類型",
  T_49_META_TYP_177_I0_D: "當相機與跟隨物件中間有遮蔽物時，相機不做任何變化",
  T_49_META_TYP_177_I1_D: "當相機與跟隨對像中間有遮擋物時，相機將推近跟隨對象",
  T_49_META_TYP_177_I2_D: "當相機與跟隨物件中間有遮擋物時，遮擋物將變為半透明",
  T_49_META_TYP_178_I0_D: "相機觀察對象時，近大遠小",
  T_49_META_TYP_178_I1_D: "相機觀察對象時，遠近物體大小一樣",
  T_49_META_TYP_184_I0_D: "指定要渲染的資源UUID",
  T_49_META_TYP_185_I0_D: "渲染要使用的模型網格",
  T_49_META_TYP_185_I1_D: "渲染要使用的材質列表",
  T_49_META_TYP_187_I0_D: "物品 ID",
  T_49_META_TYP_190_I0_D: "開啟狀態",
  T_49_META_TYP_190_I1_D: "對局結果",
  T_49_META_TYP_190_I10_D: "積分列表 1",
  T_49_META_TYP_190_I11_D: "積分列表 2",
  T_49_META_TYP_190_I12_D: "積分列表 3",
  T_49_META_TYP_190_I13_D: "獲勝 MVP 列表",
  T_49_META_TYP_190_I14_D: "失敗 MVP 列表",
  T_49_META_TYP_190_I15_D: "顯示對局詳情",
  T_49_META_TYP_190_I16_D: "顯示地圖評價",
  T_49_META_TYP_190_I17_D: "顯示送禮",
  T_49_META_TYP_190_I18_D: "顯示舉報",
  T_49_META_TYP_190_I19_D: "顯示回放",
  T_49_META_TYP_190_I20_D: "顯示分享",
  T_49_META_TYP_190_I21_D: "顯示回到大廳",
  T_49_META_TYP_190_I22_D: "顯示點讚",
  T_49_META_TYP_190_I23_D: "顯示加好友",
  T_49_META_TYP_190_I24_D: "顯示局外經濟",
  T_49_META_TYP_190_I4_D: "左邊隊伍/陣營",
  T_49_META_TYP_190_I5_D: "右邊隊伍/陣營",
  T_49_META_TYP_190_I6_D: "玩家排名",
  T_49_META_TYP_190_I9_D: "標題列表",
  T_49_META_TYP_191_I0_D: "中心範圍",
  T_49_META_TYP_191_I4_D: "中心閃光時間，單位毫秒",
  T_49_META_TYP_191_I5_D: "邊緣閃光時間，單位毫秒",
  T_49_META_TYP_191_I6_D: "特效持續時間",
  T_49_META_TYP_192_I3_D: "特效持續時間，單位秒",
  T_49_META_TYP_193_I1_D: "對局標題 1",
  T_49_META_TYP_193_I10_D: "積分列表 1",
  T_49_META_TYP_193_I11_D: "積分列表 2",
  T_49_META_TYP_193_I12_D: "積分列表 3",
  T_49_META_TYP_193_I13_D: "積分列表 4",
  T_49_META_TYP_193_I14_D: "積分列表 5",
  T_49_META_TYP_193_I15_D: "獲勝 MVP 列表",
  T_49_META_TYP_193_I16_D: "失敗 MVP 列表",
  T_49_META_TYP_193_I17_D: "顯示對局詳情",
  T_49_META_TYP_193_I18_D: "顯示地圖評價",
  T_49_META_TYP_193_I19_D: "顯示送禮",
  T_49_META_TYP_193_I2_D: "對局標題 2",
  T_49_META_TYP_193_I20_D: "顯示舉報",
  T_49_META_TYP_193_I21_D: "顯示回放",
  T_49_META_TYP_193_I22_D: "顯示分享",
  T_49_META_TYP_193_I23_D: "顯示回到大廳",
  T_49_META_TYP_193_I24_D: "顯示點讚",
  T_49_META_TYP_193_I25_D: "顯示加好友",
  T_49_META_TYP_193_I26_D: "顯示局外經濟",
  T_49_META_TYP_193_I3_D: "對局結果",
  T_49_META_TYP_193_I4_D: "隊伍/陣營排名",
  T_49_META_TYP_193_I5_D: "玩家排名",
  T_49_META_TYP_193_I6_D: "隊伍名次",
  T_49_META_TYP_193_I7_D: "總積分名",
  T_49_META_TYP_193_I8_D: "總積分列表",
  T_49_META_TYP_193_I9_D: "標題列表",
  T_49_META_TYP_194_I0_D: "地雷開始生效的時間，單位秒",
  T_49_META_TYP_194_I1_D: "觸發半徑",
  T_49_META_TYP_194_I2_D: "在地雷範圍內觸發地雷所需的時長，單位秒",
  T_49_META_TYP_194_I3_D: "是否能自己觸發",
  T_49_META_TYP_194_I4_D: "是否隊友能觸發",
  T_49_META_TYP_194_I5_D: "是否可由載具觸發",
  T_49_META_TYP_194_I6_D: "地雷的存在時間，結束後自動爆炸，從放下地雷開始計時，單位秒",
  T_49_META_TYP_194_I7_D: "是否可被攻擊",
  T_49_META_TYP_194_I8_D: "生命值",
  T_49_META_TYP_195_I0_D: "一次",
  T_49_META_TYP_195_I2_D: "往復",
  T_49_META_TYP_197_I0_D: "是否正在播放",
  T_49_META_TYP_197_I1_D: "標記位",
  T_49_META_TYP_197_I2_D: "勾選則建立時自動播放",
  T_49_META_TYP_198_I0_D: "附件對應的道具id",
  T_49_META_TYP_199_I0_D: "總能量值",
  T_49_META_TYP_199_I1_D: "每秒能量消耗",
  T_49_META_TYP_199_I10_D: "掉落傷害比例",
  T_49_META_TYP_199_I11_D: "當前能量值",
  T_49_META_TYP_199_I2_D: "每秒向上能量消耗",
  T_49_META_TYP_199_I3_D: "每秒快跑能量消耗",
  T_49_META_TYP_199_I4_D: "每秒衝刺能量消耗",
  T_49_META_TYP_199_I5_D: "基礎水平速度",
  T_49_META_TYP_199_I6_D: "快跑水平速度",
  T_49_META_TYP_199_I7_D: "基礎垂直速度",
  T_49_META_TYP_199_I8_D: "衝刺垂直速度",
  T_49_META_TYP_199_I9_D: "衝刺距離",
  T_49_META_TYP_200_I0_D: "區域ID",
  T_49_META_TYP_200_I1_D: "遊戲ID",
  T_49_META_TYP_201_I0_D: "減速百分比：水域物件開放水中移速減緩百分比",
  T_49_META_TYP_203_I0_D: "目標實體",
  T_49_META_TYP_203_I1_D: "屬性 ID",
  T_49_META_TYP_203_I10_D: "遊戲伺服器開始tick的時刻",
  T_49_META_TYP_203_I11_D: "初始值",
  T_49_META_TYP_203_I12_D: "最終值",
  T_49_META_TYP_203_I13_D: "已過百分比",
  T_49_META_TYP_203_I4_D: "動畫風格",
  T_49_META_TYP_203_I6_D: "持續時間(s)",
  T_49_META_TYP_203_I7_D: "反轉",
  T_49_META_TYP_203_I8_D: "控制點",
  T_49_META_TYP_203_I9_D: "強制同步遊戲伺服器狀態",
  T_49_META_TYP_204_I0_D: "二段跳最大跳躍高度",
  T_49_META_TYP_204_I1_D: "跌落傷害百分比",
  T_49_META_TYP_204_I2_D: "每秒恢復能量",
  T_49_META_TYP_204_I3_D: "消耗能量",
  T_49_META_TYP_204_I4_D: "最大能量",
  T_49_META_TYP_205_I0_D: "最小起飛高度",
  T_49_META_TYP_205_I1_D: "最小結束高度",
  T_49_META_TYP_205_I2_D: "滑行速度",
  T_49_META_TYP_205_I3_D: "滑行下降速度",
  T_49_META_TYP_205_I4_D: "結束滑行下落速度",
  T_49_META_TYP_205_I5_D: "轉彎速度（每秒度）",
  T_49_META_TYP_205_I6_D: "最大飛行高度",
  T_49_META_TYP_205_I7_D: "超高之後的下落速度",
  T_49_META_TYP_205_I8_D: "變速加速度",
  T_49_META_TYP_206_I0_D: "速度",
  T_49_META_TYP_206_I1_D: "加速度",
  T_49_META_TYP_206_I10_D: "在高速狀態下，最大轉向角度",
  T_49_META_TYP_206_I11_D: "高速轉向角插值基率",
  T_49_META_TYP_206_I2_D: "衝刺速度",
  T_49_META_TYP_206_I3_D: "衝刺持續時間，單位秒",
  T_49_META_TYP_206_I4_D: "衝刺冷卻時間，單位秒",
  T_49_META_TYP_206_I6_D: "跳躍cd，單位秒",
  T_49_META_TYP_206_I7_D: "上滑板後衝刺CD，單位秒",
  T_49_META_TYP_206_I8_D: "上滑板後衝刺CD開關",
  T_49_META_TYP_206_I9_D: "上滑板CD，單位秒",
  T_49_META_TYP_207_I1_D: "起始位置",
  T_49_META_TYP_207_I2_D: "終點位置",
  T_49_META_TYP_207_I3_D: "滑索ID",
  T_49_META_TYP_207_I4_D: "群組ID",
  T_49_META_TYP_207_I5_D: "是否結束",
  T_49_META_TYP_21_I0_D: "UI的基礎層級",
  T_49_META_TYP_210_I1_D: "初速度",
  T_49_META_TYP_210_I2_D: "加速度",
  T_49_META_TYP_210_I3_D: "最大位移",
  T_49_META_TYP_210_I4_D: "初始世界坐標",
  T_49_META_TYP_210_I5_D: "遊戲伺服器強制同步位置訊息",
  T_49_META_TYP_211_I0_D: "本地位置",
  T_49_META_TYP_211_I1_D: "世界座標",
  T_49_META_TYP_212_I0_D: "自身實體",
  T_49_META_TYP_212_I2_D: "偏移座標",
  T_49_META_TYP_213_I0_D: "自身實體",
  T_49_META_TYP_213_I2_D: "偏移座標",
  T_49_META_TYP_215_I0_D: "勝利",
  T_49_META_TYP_215_I1_D: "失敗",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "平局",
  T_49_META_TYP_218_I0_D: "光照強度",
  T_49_META_TYP_218_I1_D: "光照範圍",
  T_49_META_TYP_218_I2_D: "光照顏色",
  T_49_META_TYP_22_I0_D: "開啟狀態為true時則顯示，否則關閉",
  T_49_META_TYP_22_I1_D: "模板 ID",
  T_49_META_TYP_22_I2_D: "目前最大控制項ID",
  T_49_META_TYP_22_I3_D: "UI的基礎層級",
  T_49_META_TYP_22_I4_D: "開啟玩家視角",
  T_49_META_TYP_22_I5_D: "世界座標",
  T_49_META_TYP_22_I6_D: "是否在場景中",
  T_49_META_TYP_22_I7_D: "世界座標系中的旋轉",
  T_49_META_TYP_22_I8_D: "世界坐標系中的縮放",
  T_49_META_TYP_221_I0_D: "檔位切換延遲,該值越大，檔位變化速度越慢",
  T_49_META_TYP_222_I0_D: "檔位切換延遲,該值越大，檔位變化速度越慢",
  T_49_META_TYP_225_I0_D: "砲塔傷害",
  T_49_META_TYP_225_I1_D: "炮塔攻擊間隔 (秒)",
  T_49_META_TYP_225_I10_D: "角度內才開火",
  T_49_META_TYP_225_I11_D: "減傷率",
  T_49_META_TYP_225_I12_D: "護甲穿透",
  T_49_META_TYP_225_I2_D: "精準度",
  T_49_META_TYP_225_I3_D: "炮塔範圍",
  T_49_META_TYP_225_I4_D: "炮塔角速度",
  T_49_META_TYP_225_I5_D: "炮塔仰角",
  T_49_META_TYP_225_I6_D: "炮塔俯角",
  T_49_META_TYP_225_I7_D: "炮塔最大生命值",
  T_49_META_TYP_225_I8_D: "炮塔持續時間 (秒)",
  T_49_META_TYP_225_I9_D: "最大炮塔數量",
  T_49_META_TYP_226_I0_D: "砲塔當前生命值",
  T_49_META_TYP_226_I1_D: "是否開啟攻擊（為否時禁止攻擊）",
  T_49_META_TYP_227_I0_D: "簡單小工具",
  T_49_META_TYP_227_I1_D: "圖片小工具",
  T_49_META_TYP_227_I10_D: "紋理小工具",
  T_49_META_TYP_227_I11_D: "個人資料小工具",
  T_49_META_TYP_227_I12_D: "切換小工具",
  T_49_META_TYP_227_I13_D: "觸控板小工具",
  T_49_META_TYP_227_I14_D: "搖桿小工具",
  T_49_META_TYP_227_I15_D: "社交按鈕控件",
  T_49_META_TYP_227_I2_D: "標籤小工具",
  T_49_META_TYP_227_I3_D: "按鈕小工具",
  T_49_META_TYP_227_I4_D: "輸入標籤小工具",
  T_49_META_TYP_227_I5_D: "面板",
  T_49_META_TYP_227_I6_D: "滾動面板",
  T_49_META_TYP_227_I7_D: "網格",
  T_49_META_TYP_227_I8_D: "佈局小工具",
  T_49_META_TYP_227_I9_D: "容器小工具",
  T_49_META_TYP_231_I0_D: "耐久恢復值",
  T_49_META_TYP_231_I1_D: "生效時間間隔，單位秒",
  T_49_META_TYP_233_I2_D: "計時結束時間，以秒為單位",
  T_49_META_TYP_233_I4_D: "圖示資源名",
  T_49_META_TYP_234_I0_D: "觸發時間，單位秒",
  T_49_META_TYP_234_I1_D: "是否能自己觸發",
  T_49_META_TYP_234_I10_D: "目前生命值",
  T_49_META_TYP_234_I2_D: "是否隊友能觸發",
  T_49_META_TYP_234_I3_D: "是否可由載具觸發",
  T_49_META_TYP_234_I4_D: "持續時間，單位秒",
  T_49_META_TYP_234_I5_D: "是否可被攻擊",
  T_49_META_TYP_234_I6_D: "生命值",
  T_49_META_TYP_235_I0_D: "最大生命值",
  T_49_META_TYP_235_I2_D: "最大數量",
  T_49_META_TYP_237_I0_D: "鉤鎖飛行速讀",
  T_49_META_TYP_237_I1_D: "牽引玩家速讀",
  T_49_META_TYP_238_I0_D: "噴漆顏色",
  T_49_META_TYP_239_I0_D: "初始速度",
  T_49_META_TYP_239_I1_D: "加速度（如重力）",
  T_49_META_TYP_24_I0_D: "近戰",
  T_49_META_TYP_24_I1_D: "槍械",
  T_49_META_TYP_24_I10_D: "空投砸中傷害，怪物自殺傷害",
  T_49_META_TYP_24_I11_D: "載具爆炸後燃燒傷害",
  T_49_META_TYP_24_I12_D: "油桶爆炸",
  T_49_META_TYP_24_I13_D: "類導彈武器",
  T_49_META_TYP_24_I14_D: "怪物",
  T_49_META_TYP_24_I15_D: "傷害區",
  T_49_META_TYP_24_I17_D: "角色技能",
  T_49_META_TYP_24_I2_D: "投擲手雷",
  T_49_META_TYP_24_I3_D: "安全區",
  T_49_META_TYP_24_I4_D: "車輛",
  T_49_META_TYP_24_I5_D: "掉落",
  T_49_META_TYP_24_I6_D: "死亡區域",
  T_49_META_TYP_24_I7_D: "退出",
  T_49_META_TYP_24_I8_D: "斷線",
  T_49_META_TYP_24_I9_D: "載具爆炸",
  T_49_META_TYP_241_I0_D: "牽引速度",
  T_49_META_TYP_241_I1_D: "擺盪速度",
  T_49_META_TYP_241_I2_D: "開啟牽引按鈕",
  T_49_META_TYP_241_I3_D: "開啟擺動按鈕",
  T_49_META_TYP_241_I4_D: "運動錨點",
  T_49_META_TYP_241_I5_D: "離開盪擺的加速度",
  T_49_META_TYP_242_I2_D: "是否顯示左側特效",
  T_49_META_TYP_242_I3_D: "是否顯示右側特效",
  T_49_META_TYP_242_I4_D: "中央線啟用",
  T_49_META_TYP_242_I5_D: "值[0, 1]",
  T_49_META_TYP_242_I7_D: "UI位置，只有XY分量有效",
  T_49_META_TYP_242_I8_D: "中間線位置[0,1]",
  T_49_META_TYP_243_I0_D: "上身服飾",
  T_49_META_TYP_243_I1_D: "下身服飾",
  T_49_META_TYP_243_I2_D: "鞋",
  T_49_META_TYP_243_I3_D: "臉部彩繪",
  T_49_META_TYP_243_I4_D: "頭飾",
  T_49_META_TYP_243_I5_D: "連體衣",
  T_49_META_TYP_243_I6_D: "臉部裝飾",
  T_49_META_TYP_244_I0_D: "要顯示的文字內容",
  T_49_META_TYP_244_I10_D: "可以看見該實體的玩家列表",
  T_49_META_TYP_244_I11_D: "顯示層級",
  T_49_META_TYP_244_I2_D: "跟隨的目標實體",
  T_49_META_TYP_244_I3_D: "忽略深度時可以穿透牆體顯示，否則不行",
  T_49_META_TYP_244_I4_D: "總是面向攝像機",
  T_49_META_TYP_244_I5_D: "設定為true時，當位置在螢幕外會貼邊顯示在螢幕內",
  T_49_META_TYP_244_I6_D: "字體風格",
  T_49_META_TYP_244_I7_D: "字體類型",
  T_49_META_TYP_244_I8_D: "字體尺寸",
  T_49_META_TYP_245_I0_D: "資源路徑",
  T_49_META_TYP_245_I11_D: "顯示層級",
  T_49_META_TYP_245_I3_D: "忽略深度時可以穿透牆體顯示，否則不行",
  T_49_META_TYP_245_I4_D: "設定為true時，當位置在螢幕外會貼邊顯示在螢幕內",
  T_49_META_TYP_245_I5_D: "總是面向攝像機",
  T_49_META_TYP_245_I6_D: "顯示方式",
  T_49_META_TYP_245_I7_D: "寬度",
  T_49_META_TYP_246_I0_D: "橙色",
  T_49_META_TYP_246_I1_D: "紫色",
  T_49_META_TYP_246_I2_D: "紅色",
  T_49_META_TYP_246_I3_D: "綠色",
  T_49_META_TYP_246_I4_D: "藍色",
  T_49_META_TYP_247_I1_D: "衝刺",
  T_49_META_TYP_247_I14_D: "表情",
  T_49_META_TYP_247_I15_D: "快速聊天",
  T_49_META_TYP_247_I16_D: "拾取物品",
  T_49_META_TYP_247_I17_D: "快速聊天顯示",
  T_49_META_TYP_247_I18_D: "血量",
  T_49_META_TYP_247_I19_D: "能量",
  T_49_META_TYP_247_I2_D: "攻擊",
  T_49_META_TYP_247_I20_D: "護甲",
  T_49_META_TYP_247_I21_D: "裝填",
  T_49_META_TYP_247_I22_D: "快速換槍按鈕",
  T_49_META_TYP_247_I23_D: "可開啟/關閉載具喇叭按鈕",
  T_49_META_TYP_247_I24_D: "可開啟/關閉語音（麥克風）按鈕",
  T_49_META_TYP_247_I25_D: "可開啟/關閉標記按鈕",
  T_49_META_TYP_247_I27_D: "可開啟/關閉網路訊號按鈕",
  T_49_META_TYP_247_I28_D: "主動技能",
  T_49_META_TYP_247_I29_D: "準星",
  T_49_META_TYP_247_I3_D: "跳躍",
  T_49_META_TYP_247_I30_D: "被動技能",
  T_49_META_TYP_247_I4_D: "擊殺提示",
  T_49_META_TYP_247_I5_D: "武器欄",
  T_49_META_TYP_247_I6_D: "小地圖",
  T_49_META_TYP_247_I7_D: "背包UI",
  T_49_META_TYP_247_I8_D: "醫療道具",
  T_49_META_TYP_247_I9_D: "true時則顯示，否則關閉",
  T_49_META_TYP_249_I3_D: "爆破武器",
  T_49_META_TYP_249_I5_D: "重武器",
  T_49_META_TYP_249_I8_D: "冰凍彈",
  T_49_META_TYP_249_I9_D: "假手雷",
  T_49_META_TYP_25_I0_D: "當前階段的索引，和流程編輯器中的索引對應",
  T_49_META_TYP_25_I1_D: "當前階段的開始時間，單位ms",
  T_49_META_TYP_25_I2_D: "當前階段的結束時間，單位ms",
  T_49_META_TYP_25_I3_D: "當前階段的持續時間，單位ms",
  T_49_META_TYP_250_I1_D: "特效顏色，RGBA四通道，單通道取值範圍0~255，儲存在一個Int32中",
  T_49_META_TYP_250_I3_D: "特效貼圖類型",
  T_49_META_TYP_250_I4_D: "表面透明度",
  T_49_META_TYP_2500_I1_D: "是否是默認出生點",
  T_49_META_TYP_2500_I3_D: "是否已經有玩家在該出生點區域內出生",
  T_49_META_TYP_2500_I4_D: "目前可分配的出生點點位座標",
  T_49_META_TYP_2502_I0_D: "是否為死亡觸發器，當不是死亡觸發器時就是無敵觸發器。 （這是來自OB32的遺留問題，以後請分割功能！）",
  T_49_META_TYP_2502_I1_D: "是否顯示觸發器邊框，true為顯示",
  T_49_META_TYP_2503_I0_D: "檢查點 ID",
  T_49_META_TYP_2503_I2_D: "檢查點的位置",
  T_49_META_TYP_2507_I0_D: "該防禦塔屬於哪個陣營，和玩家相同則不會攻擊玩家",
  T_49_META_TYP_2507_I1_D: "當前血量",
  T_49_META_TYP_2507_I10_D: "名字拼接對象編號",
  T_49_META_TYP_2507_I2_D: "最大血量",
  T_49_META_TYP_2507_I3_D: "攻擊傷害，單次攻擊對玩家能造成的傷害",
  T_49_META_TYP_2507_I4_D: "兩次攻擊之間的間隔，以秒為單位",
  T_49_META_TYP_2507_I5_D: "以中心為圓心，在多大範圍為半徑的區域內均可被攻擊",
  T_49_META_TYP_2507_I6_D: "減傷率，小於1的小數，最終傷害為傷害乘以（1-減傷率）",
  T_49_META_TYP_2507_I7_D: "攻擊目標",
  T_49_META_TYP_2507_I8_D: "旋轉角度",
  T_49_META_TYP_2507_I9_D: "防禦塔狀態",
  T_49_META_TYP_2508_I0_D: "每一波會生成的殭屍數",
  T_49_META_TYP_2508_I1_D: "總共會產生多少波殭屍",
  T_49_META_TYP_2508_I2_D: "是否連續生成，但是會有同屏上限",
  T_49_META_TYP_2508_I3_D: "目前生成到第幾波了",
  T_49_META_TYP_2508_I5_D: "當前波次生成哪種殭屍",
  T_49_META_TYP_2508_I6_D: "AI在死亡的時候是否會掉落裝備或物品",
  T_49_META_TYP_2508_I7_D: "開始生成時間 (秒)",
  T_49_META_TYP_2508_I8_D: "下一波和上一波之間的時間間隔",
  T_49_META_TYP_2509_I0_D: "每一波會產生的單位數量",
  T_49_META_TYP_2509_I1_D: "總共會產生多少波單位產生器",
  T_49_META_TYP_2509_I2_D: "目前生成到第幾波了",
  T_49_META_TYP_2509_I4_D: "每一波會依照哪個實體為模板生成",
  T_49_META_TYP_2509_I5_D: "單位開始產生時間",
  T_49_META_TYP_2509_I6_D: "是否連續生成，但是會有同屏上限",
  T_49_META_TYP_2509_I7_D: "下一波和上一波之間的時間間隔",
  T_49_META_TYP_2509_I8_D: "範本的prefabID",
  T_49_META_TYP_2510_I0_D: "出生點個數",
  T_49_META_TYP_252_I1_D: "左側圖標",
  T_49_META_TYP_252_I2_D: "左側文本",
  T_49_META_TYP_252_I3_D: "左側得分文本",
  T_49_META_TYP_252_I5_D: "右側圖標",
  T_49_META_TYP_252_I6_D: "右側文本",
  T_49_META_TYP_252_I7_D: "右側得分文本",
  T_49_META_TYP_252_I8_D: "進度 [0,1]",
  T_49_META_TYP_253_I0_D: "選擇圖示",
  T_49_META_TYP_253_I1_D: "提示文字",
  T_49_META_TYP_253_I2_D: "顯示特效",
  T_49_META_TYP_253_I3_D: "UI位置",
  T_49_META_TYP_254_I1_D: "例如1.25表示正常速度的1.25倍",
  T_49_META_TYP_254_I2_D: "顏色",
  T_49_META_TYP_256_I0_D: "完全靜止。最省性能",
  T_49_META_TYP_256_I1_D: "正常受力施力。最費性能",
  T_49_META_TYP_256_I2_D: "可透過腳本控制運動，可視為品質無限大",
  T_49_META_TYP_257_I0_D: "不同類型剛體功能不同",
  T_49_META_TYP_257_I1_D: "是否受重力影響",
  T_49_META_TYP_257_I2_D: "質量(kg)，最小有效質量0.001kg，若為0則表示無限大質量，不會受力移動",
  T_49_META_TYP_257_I3_D: "重心位置，本地座標系",
  T_49_META_TYP_257_I4_D: "剛體運動的線速度",
  T_49_META_TYP_257_I5_D: "剛體運動的角速度",
  T_49_META_TYP_257_I6_D: "線速度自然衰減係數，係數越大，運動速度衰減的越快",
  T_49_META_TYP_257_I7_D: "角速度自然衰減係數，係數越大，運動速度衰減的越快",
  T_49_META_TYP_257_I8_D: "剛體施加的限制，是RigidbodyConstrainType的集合",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "底圖",
  T_49_META_TYP_259_I1_D: "提示文字",
  T_49_META_TYP_259_I2_D: "UI位置",
  T_49_META_TYP_259_I4_D: "提示文字顏色",
  T_49_META_TYP_260_I0_D: "選擇圖示",
  T_49_META_TYP_260_I1_D: "進度條顏色",
  T_49_META_TYP_260_I2_D: "值[0, 1]",
  T_49_META_TYP_260_I3_D: "速度，單位m/s",
  T_49_META_TYP_260_I4_D: "是否顯示特效",
  T_49_META_TYP_260_I5_D: "UI位置[0,1]",
  T_49_META_TYP_260_I6_D: "技能初始進度，取值[0, 1]，UI建立後進度會立刻同步至當前進度",
  T_49_META_TYP_260_I7_D: "特效顏色",
  T_49_META_TYP_260_I8_D: "設定對象縮放值",
  T_49_META_TYP_265_I1_D: "是否進行背景填充",
  T_49_META_TYP_265_I2_D: "背景名稱",
  T_49_META_TYP_265_I3_D: "背景顏色",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "裁切類型",
  T_49_META_TYP_265_I7_D: "遮罩類型是遮罩時選用的圖片名稱",
  T_49_META_TYP_265_I8_D: "邊緣柔和單位",
  T_49_META_TYP_267_I0_D: "滾動起點，預設為左上角",
  T_49_META_TYP_267_I1_D: "支援多種滾動方向",
  T_49_META_TYP_267_I10_D: "水平顯示類型",
  T_49_META_TYP_267_I11_D: "顯示位置",
  T_49_META_TYP_267_I2_D: "XY方向拖曳分量",
  T_49_META_TYP_267_I3_D: "支援多種拖曳效果",
  T_49_META_TYP_267_I4_D: "滾輪因子，數值越大滾動越快",
  T_49_META_TYP_267_I5_D: "慣性因子，數值越大滾動時慣性越大",
  T_49_META_TYP_267_I6_D: "拖曳是否被限制在視口內，預設選中",
  T_49_META_TYP_267_I7_D: "勾選時拖曳開始會有緩動，不勾選則開始拖曳就是滑鼠移動的速度",
  T_49_META_TYP_267_I8_D: "當剛好合適視口時則退出拖曳",
  T_49_META_TYP_267_I9_D: "垂直顯示類型",
  T_49_META_TYP_268_I0_D: "預設",
  T_49_META_TYP_268_I1_D: "關閉",
  T_49_META_TYP_268_I2_D: "顯示",
  T_49_META_TYP_269_I0_D: "所有者",
  T_49_META_TYP_269_I1_D: "套裝ID",
  T_49_META_TYP_269_I2_D: "頭飾ID",
  T_49_META_TYP_269_I3_D: "臉飾ID",
  T_49_META_TYP_269_I4_D: "妝容ID",
  T_49_META_TYP_269_I5_D: "上身ID",
  T_49_META_TYP_269_I6_D: "下身ID",
  T_49_META_TYP_269_I7_D: "鞋ID",
  T_49_META_TYP_272_I0_D: "女",
  T_49_META_TYP_272_I1_D: "男",
  T_49_META_TYP_273_I0_D: "小地圖中心對應的世界座標",
  T_49_META_TYP_273_I1_D: "小地圖尺寸大小，寬度相同",
  T_49_META_TYP_273_I2_D: "是否啟用小地圖深度圖顯示模式",
  T_49_META_TYP_274_I1_D: "縮放大小",
  T_49_META_TYP_274_I4_D: "圖示顯示層級",
  T_49_META_TYP_275_I0_D: "骨骼縮放",
  T_49_META_TYP_275_I1_D: "骨骼節點的世界座標",
  T_49_META_TYP_276_I0_D: "頭部",
  T_49_META_TYP_276_I1_D: "左臂",
  T_49_META_TYP_276_I2_D: "左手",
  T_49_META_TYP_276_I3_D: "右臂",
  T_49_META_TYP_276_I4_D: "右手",
  T_49_META_TYP_276_I5_D: "軀幹",
  T_49_META_TYP_276_I6_D: "左腿",
  T_49_META_TYP_276_I7_D: "左腳",
  T_49_META_TYP_276_I8_D: "右腿",
  T_49_META_TYP_276_I9_D: "右腳",
  T_49_META_TYP_277_I1_D: "相機射線偵測的距離",
  T_49_META_TYP_277_I2_D: "相機射線偵測的碰撞層遮罩",
  T_49_META_TYP_277_I3_D: "按鈕的位置偏移",
  T_49_META_TYP_277_I4_D: "圖示資源ID",
  T_49_META_TYP_277_I5_D: "點擊區域大小",
  T_49_META_TYP_277_I6_D: "是否在目標點顯示對象",
  T_49_META_TYP_277_I7_D: "目標點顯示的對象",
  T_49_META_TYP_278_I0_D: "產生地圖像素的目標實體",
  T_49_META_TYP_28_I0_D: "每回合能否重置",
  T_49_META_TYP_280_I0_D: "球體半徑",
  T_49_META_TYP_281_I0_D: "膠囊體兩端半球的半徑",
  T_49_META_TYP_29_I0_D: "球體",
  T_49_META_TYP_29_I1_D: "光柱",
  T_49_META_TYP_29_I10_D: "腳底光柱，現用於進入終點的回饋",
  T_49_META_TYP_29_I11_D: "冰凍",
  T_49_META_TYP_29_I12_D: "燈光",
  T_49_META_TYP_29_I13_D: "上升氣流",
  T_49_META_TYP_29_I14_D: "旋風氣體爆炸",
  T_49_META_TYP_29_I15_D: "躲藏者被擊殺",
  T_49_META_TYP_29_I16_D: "暴走",
  T_49_META_TYP_29_I17_D: "分身死亡",
  T_49_META_TYP_29_I18_D: "射擊反饋",
  T_49_META_TYP_29_I19_D: "分身死亡",
  T_49_META_TYP_29_I2_D: "爆炸",
  T_49_META_TYP_29_I20_D: "分身",
  T_49_META_TYP_29_I21_D: "傳送門",
  T_49_META_TYP_29_I22_D: "閃光彈煙火",
  T_49_META_TYP_29_I23_D: "火焰彈",
  T_49_META_TYP_29_I24_D: "循環燃燒",
  T_49_META_TYP_29_I25_D: "毒氣",
  T_49_META_TYP_29_I26_D: "愛心",
  T_49_META_TYP_29_I29_D: "門",
  T_49_META_TYP_29_I30_D: "煙花",
  T_49_META_TYP_29_I31_D: "跑鞋特效",
  T_49_META_TYP_29_I32_D: "爆炸特效",
  T_49_META_TYP_29_I33_D: "重生點特效",
  T_49_META_TYP_29_I34_D: "激光特效",
  T_49_META_TYP_29_I35_D: "技能釋放特效",
  T_49_META_TYP_29_I36_D: "子彈特效",
  T_49_META_TYP_29_I37_D: "子彈命中特效",
  T_49_META_TYP_29_I38_D: "武器開火特效",
  T_49_META_TYP_29_I39_D: "技能特效",
  T_49_META_TYP_29_I40_D: "光環",
  T_49_META_TYP_29_I41_D: "氣泡",
  T_49_META_TYP_29_I42_D: "煙塵",
  T_49_META_TYP_29_I43_D: "石子飛濺",
  T_49_META_TYP_29_I44_D: "線條",
  T_49_META_TYP_29_I45_D: "閃爍",
  T_49_META_TYP_29_I47_D: "上升粒子",
  T_49_META_TYP_29_I48_D: "煙霧",
  T_49_META_TYP_29_I49_D: "符咒",
  T_49_META_TYP_29_I50_D: "冰凍區域",
  T_49_META_TYP_29_I51_D: "冷氣",
  T_49_META_TYP_29_I52_D: "雪花",
  T_49_META_TYP_29_I53_D: "火焰",
  T_49_META_TYP_29_I54_D: "光束",
  T_49_META_TYP_29_I55_D: "毒氣擴散",
  T_49_META_TYP_29_I56_D: "毒氣",
  T_49_META_TYP_29_I57_D: "爆炸火光",
  T_49_META_TYP_29_I58_D: "光效",
  T_49_META_TYP_29_I59_D: "星星",
  T_49_META_TYP_29_I6_D: "腳下光環",
  T_49_META_TYP_29_I60_D: "燃燒的火堆",
  T_49_META_TYP_29_I61_D: "水花",
  T_49_META_TYP_29_I62_D: "電擊",
  T_49_META_TYP_29_I63_D: "水墨特效",
  T_49_META_TYP_29_I64_D: "黑洞特效",
  T_49_META_TYP_29_I65_D: "黑洞爆炸特效",
  T_49_META_TYP_29_I66_D: "水晶球特效",
  T_49_META_TYP_29_I67_D: "雷射彈性",
  T_49_META_TYP_29_I68_D: "拖尾特效",
  T_49_META_TYP_29_I69_D: "雲霧特效",
  T_49_META_TYP_29_I7_D: "地面印記",
  T_49_META_TYP_29_I8_D: "煙霧",
  T_49_META_TYP_29_I9_D: "符咒爆炸",
  T_49_META_TYP_290_I0_D: "刷新間隔,數字越大刷新越慢，單位毫秒",
  T_49_META_TYP_290_I1_D: "是否開啟調試",
  T_49_META_TYP_291_I0_D: "條件節點",
  T_49_META_TYP_291_I1_D: "行為節點",
  T_49_META_TYP_293_I0_D: "行為樹 ID",
  T_49_META_TYP_293_I1_D: "行為樹實體",
  T_49_META_TYP_294_I1_D: "佈局類型",
  T_49_META_TYP_294_I10_D: "排序方式",
  T_49_META_TYP_294_I2_D: "初始方向",
  T_49_META_TYP_294_I3_D: "排列方向",
  T_49_META_TYP_294_I4_D: "子項格子的寬高",
  T_49_META_TYP_294_I5_D: "單元格空間",
  T_49_META_TYP_294_I6_D: "限制",
  T_49_META_TYP_294_I7_D: "限制數量",
  T_49_META_TYP_294_I8_D: "垂直偏移量",
  T_49_META_TYP_294_I9_D: "水平偏移量",
  T_49_META_TYP_295_I2_D: "播放速度",
  T_49_META_TYP_296_I1_D: "片段長度",
  T_49_META_TYP_297_I0_D: "綁定的對象",
  T_49_META_TYP_297_I4_D: "資源UUID",
  T_49_META_TYP_298_I0_D: "預設",
  T_49_META_TYP_298_I2_D: "一次",
  T_49_META_TYP_30_I0_D: "正方形",
  T_49_META_TYP_30_I1_D: "四邊形",
  T_49_META_TYP_30_I10_D: "箭頭",
  T_49_META_TYP_30_I11_D: "標註",
  T_49_META_TYP_30_I12_D: "石頭",
  T_49_META_TYP_30_I13_D: "剪刀",
  T_49_META_TYP_30_I14_D: "布",
  T_49_META_TYP_30_I15_D: "按讚",
  T_49_META_TYP_30_I16_D: "對",
  T_49_META_TYP_30_I17_D: "錯",
  T_49_META_TYP_30_I18_D: "加",
  T_49_META_TYP_30_I19_D: "閃電",
  T_49_META_TYP_30_I2_D: "直角梯形",
  T_49_META_TYP_30_I20_D: "心",
  T_49_META_TYP_30_I21_D: "星",
  T_49_META_TYP_30_I22_D: "月亮",
  T_49_META_TYP_30_I23_D: "太陽",
  T_49_META_TYP_30_I24_D: "眼鏡",
  T_49_META_TYP_30_I25_D: "鑰匙",
  T_49_META_TYP_30_I26_D: "獎盃",
  T_49_META_TYP_30_I27_D: "旗幟",
  T_49_META_TYP_30_I28_D: "沙漏",
  T_49_META_TYP_30_I29_D: "文件夾",
  T_49_META_TYP_30_I3_D: "梯形",
  T_49_META_TYP_30_I30_D: "開啟的文件夾",
  T_49_META_TYP_30_I31_D: "房屋",
  T_49_META_TYP_30_I32_D: "休息",
  T_49_META_TYP_30_I33_D: "刷新",
  T_49_META_TYP_30_I34_D: "循環",
  T_49_META_TYP_30_I35_D: "放大鏡",
  T_49_META_TYP_30_I36_D: "垃圾桶",
  T_49_META_TYP_30_I37_D: "返回",
  T_49_META_TYP_30_I38_D: "鑽石",
  T_49_META_TYP_30_I39_D: "游泳圈",
  T_49_META_TYP_30_I4_D: "六邊形",
  T_49_META_TYP_30_I40_D: "錢",
  T_49_META_TYP_30_I41_D: "鎖",
  T_49_META_TYP_30_I42_D: "設定",
  T_49_META_TYP_30_I43_D: "退出",
  T_49_META_TYP_30_I44_D: "對話",
  T_49_META_TYP_30_I45_D: "十字準星",
  T_49_META_TYP_30_I46_D: "槍",
  T_49_META_TYP_30_I47_D: "劍",
  T_49_META_TYP_30_I48_D: "爆炸",
  T_49_META_TYP_30_I49_D: "瞄準",
  T_49_META_TYP_30_I5_D: "圓形",
  T_49_META_TYP_30_I50_D: "十字",
  T_49_META_TYP_30_I51_D: "防守",
  T_49_META_TYP_30_I52_D: "僵屍",
  T_49_META_TYP_30_I53_D: "回收",
  T_49_META_TYP_30_I54_D: "禮物",
  T_49_META_TYP_30_I55_D: "衣服",
  T_49_META_TYP_30_I56_D: "遊戲",
  T_49_META_TYP_30_I57_D: "玩家",
  T_49_META_TYP_30_I58_D: "商店",
  T_49_META_TYP_30_I59_D: "出口",
  T_49_META_TYP_30_I6_D: "三角形",
  T_49_META_TYP_30_I60_D: "警告",
  T_49_META_TYP_30_I61_D: "文本",
  T_49_META_TYP_30_I62_D: "計時器",
  T_49_META_TYP_30_I63_D: "鈴鐺",
  T_49_META_TYP_30_I64_D: "寵物",
  T_49_META_TYP_30_I65_D: "炸彈",
  T_49_META_TYP_30_I66_D: "修復",
  T_49_META_TYP_30_I67_D: "笑臉",
  T_49_META_TYP_30_I68_D: "喇叭",
  T_49_META_TYP_30_I7_D: "驚嘆號",
  T_49_META_TYP_30_I70_D: "冠軍",
  T_49_META_TYP_30_I71_D: "戰鬥",
  T_49_META_TYP_30_I72_D: "公會",
  T_49_META_TYP_30_I73_D: "心跳",
  T_49_META_TYP_30_I74_D: "音樂",
  T_49_META_TYP_30_I75_D: "載具",
  T_49_META_TYP_30_I76_D: "近戰武器",
  T_49_META_TYP_30_I77_D: "手槍",
  T_49_META_TYP_30_I78_D: "步槍",
  T_49_META_TYP_30_I79_D: "狙擊槍",
  T_49_META_TYP_30_I8_D: "問號",
  T_49_META_TYP_30_I80_D: "散彈槍",
  T_49_META_TYP_30_I81_D: "衝鋒槍",
  T_49_META_TYP_30_I82_D: "治療槍",
  T_49_META_TYP_30_I83_D: "碎甲",
  T_49_META_TYP_30_I84_D: "爆頭",
  T_49_META_TYP_30_I85_D: "技能1",
  T_49_META_TYP_30_I86_D: "技能2",
  T_49_META_TYP_30_I87_D: "技能3",
  T_49_META_TYP_30_I88_D: "技能4",
  T_49_META_TYP_30_I89_D: "技能5",
  T_49_META_TYP_30_I9_D: "標記",
  T_49_META_TYP_30_I90_D: "技能6",
  T_49_META_TYP_30_I91_D: "技能7",
  T_49_META_TYP_30_I92_D: "技能8",
  T_49_META_TYP_30_I93_D: "技能9",
  T_49_META_TYP_30_I94_D: "技能10",
  T_49_META_TYP_300_I0_D: "資源UUID",
  T_49_META_TYP_300_I2_D: "回轉",
  T_49_META_TYP_300_I3_D: "創建的實體",
  T_49_META_TYP_301_I1_D: "自爆",
  T_49_META_TYP_301_I2_D: "衝撞攻擊",
  T_49_META_TYP_301_I3_D: "衝擊波",
  T_49_META_TYP_301_I4_D: "旋風斬",
  T_49_META_TYP_301_I5_D: "跳斬",
  T_49_META_TYP_301_I6_D: "舉盾攻擊",
  T_49_META_TYP_301_I7_D: "破盾攻擊",
  T_49_META_TYP_302_I5_D: "背包",
  T_49_META_TYP_302_I7_D: "滑板、迷彩....",
  T_49_META_TYP_303_I0_D: "增加最大血量",
  T_49_META_TYP_303_I1_D: "持續恢復血量",
  T_49_META_TYP_305_I0_D: "完成",
  T_49_META_TYP_305_I1_D: "運行中",
  T_49_META_TYP_307_I0_D: "每點傷害獲取經驗",
  T_49_META_TYP_307_I1_D: "每移動一英里獲取經驗",
  T_49_META_TYP_307_I2_D: "每秒獲取經驗",
  T_49_META_TYP_307_I3_D: "凝膠生成器升級晶片提供經驗",
  T_49_META_TYP_307_I4_D: "冰牆充能上限（矯正系數）",
  T_49_META_TYP_308_I0_D: "凝膠製造器",
  T_49_META_TYP_31_I0_D: "手雷爆炸",
  T_49_META_TYP_31_I1_D: "槍聲",
  T_49_META_TYP_31_I10_D: "擊中造成傷害音效",
  T_49_META_TYP_31_I11_D: "升級音效",
  T_49_META_TYP_31_I12_D: "弱點擊音效",
  T_49_META_TYP_31_I13_D: "玩家踩機關音效",
  T_49_META_TYP_31_I14_D: "裝備修復音效",
  T_49_META_TYP_31_I15_D: "裝備修復音效",
  T_49_META_TYP_31_I16_D: "失誤或遺失音效",
  T_49_META_TYP_31_I17_D: "提醒音效",
  T_49_META_TYP_31_I18_D: "足球落地音效",
  T_49_META_TYP_31_I19_D: "歡呼聲音效",
  T_49_META_TYP_31_I2_D: "倒計時的滴滴聲",
  T_49_META_TYP_31_I20_D: "炸彈提示音效",
  T_49_META_TYP_31_I21_D: "炸彈爆炸前音效",
  T_49_META_TYP_31_I22_D: "獵人出現音效",
  T_49_META_TYP_31_I23_D: "最終bgm音效",
  T_49_META_TYP_31_I24_D: "補給箱刷新音效",
  T_49_META_TYP_31_I25_D: "加速裝置音效",
  T_49_META_TYP_31_I26_D: "消失提示音效",
  T_49_META_TYP_31_I27_D: "視覺效果音效",
  T_49_META_TYP_31_I28_D: "夜晚蟲鳴音效",
  T_49_META_TYP_31_I29_D: "沉悶打擊音效",
  T_49_META_TYP_31_I3_D: "界面點擊",
  T_49_META_TYP_31_I30_D: "響應音效",
  T_49_META_TYP_31_I31_D: "發現驚喜音效",
  T_49_META_TYP_31_I32_D: "小鬼嬉鬧音效",
  T_49_META_TYP_31_I33_D: "階段開始音效",
  T_49_META_TYP_31_I34_D: "殭屍音效",
  T_49_META_TYP_31_I35_D: "恐怖音效",
  T_49_META_TYP_31_I36_D: "變身音效",
  T_49_META_TYP_31_I37_D: "快速心跳音效",
  T_49_META_TYP_31_I38_D: "中速心跳音效",
  T_49_META_TYP_31_I39_D: "慢速心跳音效",
  T_49_META_TYP_31_I4_D: "受擊尖叫聲女",
  T_49_META_TYP_31_I40_D: "暴走音效",
  T_49_META_TYP_31_I41_D: "點擊音效",
  T_49_META_TYP_31_I42_D: "技能恢復音效",
  T_49_META_TYP_31_I43_D: "加入遊戲音效",
  T_49_META_TYP_31_I44_D: "機械裝置迴聲音效",
  T_49_META_TYP_31_I45_D: "蚊子音效",
  T_49_META_TYP_31_I46_D: "密集叮叮叮1音效",
  T_49_META_TYP_31_I47_D: "密集叮叮叮2音效",
  T_49_META_TYP_31_I48_D: "機關開啟音效",
  T_49_META_TYP_31_I49_D: "充能音效1",
  T_49_META_TYP_31_I5_D: "受擊尖叫聲男",
  T_49_META_TYP_31_I50_D: "腳步提示音效",
  T_49_META_TYP_31_I51_D: "任務成功提示1音效",
  T_49_META_TYP_31_I52_D: "危險提示音1音效",
  T_49_META_TYP_31_I53_D: "危險提示音2音效",
  T_49_META_TYP_31_I54_D: "倒數3音效",
  T_49_META_TYP_31_I55_D: "顯示Tips提示音效",
  T_49_META_TYP_31_I56_D: "烏鴉叫的環境音音效",
  T_49_META_TYP_31_I57_D: "用傳送點傳送到錯誤區域的聲音音效",
  T_49_META_TYP_31_I58_D: "用傳送點傳送到正確區域的聲音音效",
  T_49_META_TYP_31_I59_D: "傳送音效",
  T_49_META_TYP_31_I6_D: "金幣拾取音效",
  T_49_META_TYP_31_I60_D: "電擊音效",
  T_49_META_TYP_31_I61_D: "獲得道具音效",
  T_49_META_TYP_31_I62_D: "電子夢幻可愛背景音樂音效",
  T_49_META_TYP_31_I63_D: "休閒遊戲背景音樂音效",
  T_49_META_TYP_31_I64_D: "打開盒子",
  T_49_META_TYP_31_I65_D: "升級",
  T_49_META_TYP_31_I66_D: "滿級",
  T_49_META_TYP_31_I67_D: "點擊按鈕",
  T_49_META_TYP_31_I68_D: "倒計時",
  T_49_META_TYP_31_I69_D: "打敗敵人",
  T_49_META_TYP_31_I7_D: "競速賽中經過終點的觸發音效",
  T_49_META_TYP_31_I70_D: "結束",
  T_49_META_TYP_31_I71_D: "前進",
  T_49_META_TYP_31_I72_D: "勝利",
  T_49_META_TYP_31_I73_D: "訓練基地檢查點",
  T_49_META_TYP_31_I74_D: "倒計時",
  T_49_META_TYP_31_I75_D: "遊戲開始",
  T_49_META_TYP_31_I76_D: "獲得大金幣",
  T_49_META_TYP_31_I77_D: "獲得中金幣",
  T_49_META_TYP_31_I78_D: "獲得小金幣",
  T_49_META_TYP_31_I79_D: "加入激戰",
  T_49_META_TYP_31_I8_D: "觸發器觸發音效",
  T_49_META_TYP_31_I80_D: "公會福利紅包",
  T_49_META_TYP_31_I81_D: "喇叭",
  T_49_META_TYP_31_I82_D: "彈劾會長",
  T_49_META_TYP_31_I83_D: "倉庫保存",
  T_49_META_TYP_31_I84_D: "特殊槍聲",
  T_49_META_TYP_31_I85_D: "子彈命中",
  T_49_META_TYP_31_I86_D: "移動",
  T_49_META_TYP_31_I87_D: "點擊禁用按鈕",
  T_49_META_TYP_31_I88_D: "技能充能完成",
  T_49_META_TYP_31_I89_D: "激光技能",
  T_49_META_TYP_31_I9_D: "降級音效",
  T_49_META_TYP_31_I90_D: "獲得道具2",
  T_49_META_TYP_31_I91_D: "倒計時3",
  T_49_META_TYP_31_I92_D: "遊戲結束2",
  T_49_META_TYP_31_I93_D: "擊殺提示訊息",
  T_49_META_TYP_31_I94_D: "爆炸",
  T_49_META_TYP_31_I95_D: "元氣彈技能",
  T_49_META_TYP_31_I96_D: "血池技能",
  T_49_META_TYP_311_I1_D: "最大傷害",
  T_49_META_TYP_311_I3_D: "投擲物脫手後的飛行速度，單位m/s",
  T_49_META_TYP_311_I4_D: "投擲物脫手後到生效的時長間隔，單位秒",
  T_49_META_TYP_313_I0_D: "反制區域半徑",
  T_49_META_TYP_313_I1_D: "反制區域持續時長，單位秒",
  T_49_META_TYP_314_I0_D: "動畫控制器資源ID",
  T_49_META_TYP_314_I1_D: "動畫控制器",
  T_49_META_TYP_315_I0_D: "背包所有者",
  T_49_META_TYP_315_I1_D: "背包空間",
  T_49_META_TYP_315_I2_D: "已佔用空間",
  T_49_META_TYP_315_I3_D: "所有物品",
  T_49_META_TYP_316_I0_D: "Texture 名稱",
  T_49_META_TYP_316_I1_D: "Shader 名稱",
  T_49_META_TYP_316_I11_D: "翻轉方式",
  T_49_META_TYP_316_I2_D: "UV 偏移量",
  T_49_META_TYP_316_I3_D: "UV 寬高",
  T_49_META_TYP_316_I4_D: "填充類型",
  T_49_META_TYP_316_I5_D: "左右邊界",
  T_49_META_TYP_316_I6_D: "上下邊界",
  T_49_META_TYP_317_I0_D: "無限制",
  T_49_META_TYP_317_I1_D: "本地座標系中 y 軸朝向",
  T_49_META_TYP_317_I2_D: "限制 Y 軸方向平移",
  T_49_META_TYP_317_I3_D: "限制 Z 軸方向平移",
  T_49_META_TYP_317_I4_D: "限制繞X軸旋轉",
  T_49_META_TYP_317_I5_D: "限制繞Y軸旋轉",
  T_49_META_TYP_317_I6_D: "限制繞Z軸旋轉",
  T_49_META_TYP_317_I7_D: "限制所有軸的平移",
  T_49_META_TYP_317_I8_D: "限制所有軸的旋轉",
  T_49_META_TYP_317_I9_D: "限制所有軸的平移和旋轉",
  T_49_META_TYP_318_I0_D: "射程",
  T_49_META_TYP_318_I1_D: "滿傷害距離",
  T_49_META_TYP_318_I10_D: "開鏡移動速度修正系數",
  T_49_META_TYP_318_I11_D: "瞄準鏡名義放大倍率",
  T_49_META_TYP_318_I12_D: "FOV放大倍率",
  T_49_META_TYP_318_I13_D: "ADS 放大倍率",
  T_49_META_TYP_318_I14_D: "ADS 放大時間 (秒)",
  T_49_META_TYP_318_I15_D: "ADS 恢復時間 (秒)",
  T_49_META_TYP_318_I16_D: "瞄準鏡最小傷害距離修正係數",
  T_49_META_TYP_318_I17_D: "允許開鏡時輔助瞄準",
  T_49_META_TYP_318_I18_D: "瞄準輔助準星螢幕範圍吸引比率（0-1）",
  T_49_META_TYP_318_I19_D: "瞄準輔助距離衰減係數(0-1)",
  T_49_META_TYP_318_I2_D: "最小傷害開始距離",
  T_49_META_TYP_318_I20_D: "允許輔助瞄準距離優先",
  T_49_META_TYP_318_I21_D: "瞄準輔助距離優先最小距離",
  T_49_META_TYP_318_I22_D: "瞄準輔助距離優先最大距離",
  T_49_META_TYP_318_I23_D: "瞄準輔助距離優先影響係數(>=1)",
  T_49_META_TYP_318_I24_D: "ADS 旋轉靈敏度",
  T_49_META_TYP_318_I25_D: "收斂速度",
  T_49_META_TYP_318_I3_D: "彈匣數量修正",
  T_49_META_TYP_318_I4_D: "攻擊間隔",
  T_49_META_TYP_318_I5_D: "換彈夾速度",
  T_49_META_TYP_318_I6_D: "自動換彈速度",
  T_49_META_TYP_318_I7_D: "擴散速度",
  T_49_META_TYP_318_I8_D: "蹲下,趴下時的散射速率，每0.1表示每發子彈準星增加10%範圍",
  T_49_META_TYP_318_I9_D: "最大擴散值",
  T_49_META_TYP_319_I0_D: "簡單",
  T_49_META_TYP_319_I1_D: "切片",
  T_49_META_TYP_319_I2_D: "磁磚",
  T_49_META_TYP_319_I3_D: "填充",
  T_49_META_TYP_319_I4_D: "適應",
  T_49_META_TYP_32_I0_D: "玩家處於正常活躍狀態",
  T_49_META_TYP_32_I1_D: "玩家處於擊倒狀態",
  T_49_META_TYP_32_I2_D: "玩家處於死亡狀態",
  T_49_META_TYP_320_I0_D: "水平",
  T_49_META_TYP_320_I1_D: "垂直",
  T_49_META_TYP_320_I2_D: "90度扇形",
  T_49_META_TYP_320_I3_D: "180度扇形",
  T_49_META_TYP_320_I4_D: "360度扇形",
  T_49_META_TYP_321_I0_D: "觸發輔助瞄準的最大距離",
  T_49_META_TYP_321_I1_D: "觸發輔助瞄準時準星偏移量，如偏移後的點不在實體中則輔助瞄準會失效",
  T_49_META_TYP_322_I0_D: "無",
  T_49_META_TYP_322_I1_D: "頭",
  T_49_META_TYP_322_I2_D: "身體",
  T_49_META_TYP_322_I3_D: "四肢",
  T_49_META_TYP_323_I0_D: "縮放",
  T_49_META_TYP_323_I1_D: "用戶帳號",
  T_49_META_TYP_323_I2_D: "玩家簡介訊息",
  T_49_META_TYP_323_I3_D: "樣式",
  T_49_META_TYP_323_I4_D: "顯示段位",
  T_49_META_TYP_323_I5_D: "顯示紀念章",
  T_49_META_TYP_323_I6_D: "顯示暱稱",
  T_49_META_TYP_324_I0_D: "產生指定大小的力",
  T_49_META_TYP_324_I1_D: "產生指定大小的加速度",
  T_49_META_TYP_324_I2_D: "產生指定大小的衝量",
  T_49_META_TYP_324_I3_D: "產生指定大小的速度",
  T_49_META_TYP_326_I0_D: "帳號ID",
  T_49_META_TYP_326_I1_D: "頭像 ID",
  T_49_META_TYP_326_I2_D: "橫幅 ID",
  T_49_META_TYP_326_I3_D: "紀念章 ID",
  T_49_META_TYP_326_I4_D: "玩家的暱稱",
  T_49_META_TYP_326_I5_D: "經典模式段位",
  T_49_META_TYP_326_I6_D: "BR 巔峰段位",
  T_49_META_TYP_326_I7_D: "CS 段位",
  T_49_META_TYP_326_I8_D: "CS 巔峰段位",
  T_49_META_TYP_327_I0_D: "資源ID",
  T_49_META_TYP_327_I1_D: "部件顯示遮罩 1",
  T_49_META_TYP_327_I2_D: "部件顯示遮罩 2",
  T_49_META_TYP_327_I3_D: "部件顯示遮罩 3",
  T_49_META_TYP_327_I4_D: "部件顯示遮罩 4",
  T_49_META_TYP_329_I0_D: "駕駛員",
  T_49_META_TYP_329_I1_D: "乘客1座位",
  T_49_META_TYP_329_I2_D: "乘客2座位",
  T_49_META_TYP_329_I3_D: "乘客3座位",
  T_49_META_TYP_33_I0_D: "升序忽略零值，零值排在最後",
  T_49_META_TYP_33_I1_D: "降序，大到小",
  T_49_META_TYP_33_I2_D: "升序，小到大",
  T_49_META_TYP_330_I4_D: "無敵效果持續時長（單位s）",
  T_49_META_TYP_330_I5_D: "控制點",
  T_49_META_TYP_330_I8_D: "變化值",
  T_49_META_TYP_332_I0_D: "是否循環",
  T_49_META_TYP_333_I0_D: "方正蘭亭黑",
  T_49_META_TYP_333_I1_D: "簡體阿拉伯語",
  T_49_META_TYP_333_I2_D: "諾托納斯塔利克烏爾都語",
  T_49_META_TYP_333_I3_D: "GFF拉丁字體",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "超市",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "資源路徑, 預設為空",
  T_49_META_TYP_335_I1_D: "播放次數，預設為1",
  T_49_META_TYP_335_I2_D: "音量大小，預設為50",
  T_49_META_TYP_335_I3_D: "最大距離",
  T_49_META_TYP_335_I4_D: "最小距離",
  T_49_META_TYP_335_I5_D: "是否是3D音樂",
  T_49_META_TYP_335_I6_D: "優先級",
  T_49_META_TYP_335_I7_D: "開始前等待時長，單位秒",
  T_49_META_TYP_335_I8_D: "是否正在播放",
  T_49_META_TYP_338_I0_D: "移動狀態",
  T_49_META_TYP_338_I1_D: "衝刺狀態",
  T_49_META_TYP_338_I2_D: "攻擊狀態",
  T_49_META_TYP_338_I3_D: "跳躍狀態",
  T_49_META_TYP_338_I4_D: "翻越狀態",
  T_49_META_TYP_338_I5_D: "進入載具(駕駛)",
  T_49_META_TYP_338_I6_D: "進入載具(乘客)",
  T_49_META_TYP_338_I7_D: "離開載具",
  T_49_META_TYP_338_I8_D: "駕駛",
  T_49_META_TYP_339_I0_D: "四肢傷害系數變化",
  T_49_META_TYP_339_I1_D: "頭部傷害系數變化",
  T_49_META_TYP_339_I2_D: "耐久上限倍率",
  T_49_META_TYP_339_I3_D: "玩家血量倍率",
  T_49_META_TYP_339_I4_D: "額外爆炸減傷係數（%）",
  T_49_META_TYP_339_I5_D: "額外背包空間",
  T_49_META_TYP_339_I6_D: "替換優先級",
  T_49_META_TYP_34_I0_D: "預設拳頭",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "蓄力霰彈槍",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "手砲",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "護盾槍",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "火焰榴彈槍",
  T_49_META_TYP_34_I133_D: "閃光彈",
  T_49_META_TYP_34_I134_D: "煙霧彈",
  T_49_META_TYP_34_I135_D: "冰凍手雷",
  T_49_META_TYP_34_I136_D: "防彈衣Lv1",
  T_49_META_TYP_34_I137_D: "防彈衣Lv2",
  T_49_META_TYP_34_I138_D: "防彈衣Lv3",
  T_49_META_TYP_34_I139_D: "頭盔Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "頭盔Lv2",
  T_49_META_TYP_34_I141_D: "頭盔Lv3",
  T_49_META_TYP_34_I142_D: "防爆甲",
  T_49_META_TYP_34_I143_D: "背包Lv1",
  T_49_META_TYP_34_I144_D: "背包Lv2",
  T_49_META_TYP_34_I145_D: "背包Lv3",
  T_49_META_TYP_34_I146_D: "槍口Lv1",
  T_49_META_TYP_34_I147_D: "槍口Lv2",
  T_49_META_TYP_34_I148_D: "槍口Lv3",
  T_49_META_TYP_34_I149_D: "消音器",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "突擊槍口",
  T_49_META_TYP_34_I151_D: "寬式槍口",
  T_49_META_TYP_34_I152_D: "彈匣Lv1",
  T_49_META_TYP_34_I153_D: "彈匣Lv2",
  T_49_META_TYP_34_I154_D: "彈匣Lv3",
  T_49_META_TYP_34_I155_D: "雙捆彈夾",
  T_49_META_TYP_34_I156_D: "鍊式彈夾",
  T_49_META_TYP_34_I157_D: "握把Lv1",
  T_49_META_TYP_34_I158_D: "握把Lv2",
  T_49_META_TYP_34_I159_D: "握把Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "折疊支架",
  T_49_META_TYP_34_I161_D: "射手步槍握把",
  T_49_META_TYP_34_I162_D: "霰彈槍槍托",
  T_49_META_TYP_34_I163_D: "狙擊槍槍托",
  T_49_META_TYP_34_I164_D: "熱成像瞄鏡",
  T_49_META_TYP_34_I165_D: "槍托Lv1",
  T_49_META_TYP_34_I166_D: "槍托Lv2",
  T_49_META_TYP_34_I167_D: "槍托Lv3",
  T_49_META_TYP_34_I168_D: "護盾擴充器",
  T_49_META_TYP_34_I169_D: "全身護甲",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "過量夾層",
  T_49_META_TYP_34_I171_D: "防爆夾層",
  T_49_META_TYP_34_I172_D: "背包擴容",
  T_49_META_TYP_34_I173_D: "治療呼吸器",
  T_49_META_TYP_34_I174_D: "强心針",
  T_49_META_TYP_34_I175_D: "急救包",
  T_49_META_TYP_34_I176_D: "防具修理包",
  T_49_META_TYP_34_I177_D: "高科技材料製成的人工智慧哨塔，會主動搜尋並攻擊一定範圍內的敵人",
  T_49_META_TYP_34_I178_D: "1級蘑菇",
  T_49_META_TYP_34_I179_D: "2級蘑菇",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "3級蘑菇",
  T_49_META_TYP_34_I181_D: "4級蘑菇",
  T_49_META_TYP_34_I182_D: "個人UAV",
  T_49_META_TYP_34_I184_D: "感應地雷",
  T_49_META_TYP_34_I185_D: "噴射飛行鞋",
  T_49_META_TYP_34_I186_D: "彈跳動力鞋",
  T_49_META_TYP_34_I187_D: "滑翔翼",
  T_49_META_TYP_34_I188_D: "誘餌手榴彈",
  T_49_META_TYP_34_I189_D: "磁浮滑板",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "拆彈鉗",
  T_49_META_TYP_34_I191_D: "槍械升級器",
  T_49_META_TYP_34_I192_D: "步槍彈藥",
  T_49_META_TYP_34_I193_D: "手槍彈藥",
  T_49_META_TYP_34_I194_D: "狙擊槍子彈",
  T_49_META_TYP_34_I195_D: "霰彈槍子彈",
  T_49_META_TYP_34_I196_D: "衝鋒槍子彈",
  T_49_META_TYP_34_I197_D: "箭矢",
  T_49_META_TYP_34_I198_D: "M79榴彈",
  T_49_META_TYP_34_I199_D: "噴火器子彈",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "鉤鎖頭",
  T_49_META_TYP_34_I202_D: "足球槍",
  T_49_META_TYP_34_I203_D: "拳擊",
  T_49_META_TYP_34_I204_D: "火焰槍",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "足球護盾",
  T_49_META_TYP_34_I30_D: "過熱能量槍",
  T_49_META_TYP_34_I31_D: "過熱槍-I",
  T_49_META_TYP_34_I32_D: "過熱槍-II",
  T_49_META_TYP_34_I33_D: "過熱槍-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "治療手槍-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "治療手槍",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "平底鍋",
  T_49_META_TYP_34_I44_D: "大砍刀",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "棒球棍",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "武士刀",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "加特林",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "強力鉤鎖槍",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3發子彈的1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "大頭鎚",
  T_49_META_TYP_34_I88_D: "飛刀(可拾取)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "容易的",
  T_49_META_TYP_340_I1_D: "簡單的",
  T_49_META_TYP_340_I2_D: "正常的",
  T_49_META_TYP_340_I3_D: "中等難度",
  T_49_META_TYP_340_I4_D: "困難的",
  T_49_META_TYP_340_I5_D: "地獄的",
  T_49_META_TYP_342_I0_D: "開始事件",
  T_49_META_TYP_342_I1_D: "停止事件",
  T_49_META_TYP_342_I2_D: "暫停事件",
  T_49_META_TYP_342_I3_D: "被創建後等待多久開始計時，單位毫秒",
  T_49_META_TYP_342_I4_D: "循環次數",
  T_49_META_TYP_342_I5_D: "事件集合",
  T_49_META_TYP_342_I6_D: "倒數計時或正計時",
  T_49_META_TYP_342_I7_D: "玩家狀態",
  T_49_META_TYP_342_I8_D: "計時結束時間，以秒為單位",
  T_49_META_TYP_345_I10_D: "手砲",
  T_49_META_TYP_345_I12_D: "冰牆槍",
  T_49_META_TYP_345_I13_D: "火焰槍",
  T_49_META_TYP_345_I4_D: "霰彈槍",
  T_49_META_TYP_345_I6_D: "特殊武器",
  T_49_META_TYP_345_I8_D: "蓄力槍",
  T_49_META_TYP_346_I0_D: "步槍彈藥",
  T_49_META_TYP_346_I1_D: "手槍彈藥",
  T_49_META_TYP_346_I2_D: "狙擊槍子彈",
  T_49_META_TYP_346_I3_D: "霰彈槍子彈",
  T_49_META_TYP_346_I4_D: "衝鋒槍子彈",
  T_49_META_TYP_346_I5_D: "箭矢",
  T_49_META_TYP_346_I6_D: "M79榴彈",
  T_49_META_TYP_346_I7_D: "鉤鎖頭",
  T_49_META_TYP_346_I8_D: "M79專用榴彈",
  T_49_META_TYP_347_I3_D: "為真的時候可以和相對運動組合，為假的時候必須和絕對運動組合否則屬性會不正確生效",
  T_49_META_TYP_347_I6_D: "變化值",
  T_49_META_TYP_350_I0_D: "跑車",
  T_49_META_TYP_350_I1_D: "摩托車",
  T_49_META_TYP_350_I2_D: "吉普車",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "怪獸卡車",
  T_49_META_TYP_350_I5_D: "突突車",
  T_49_META_TYP_352_I1_D: "未選中圖片",
  T_49_META_TYP_352_I2_D: "未選取圖片類型",
  T_49_META_TYP_352_I3_D: "未選中圖片顏色",
  T_49_META_TYP_352_I4_D: "選中圖片",
  T_49_META_TYP_352_I5_D: "選取圖片類型",
  T_49_META_TYP_352_I6_D: "選中圖片顏色",
  T_49_META_TYP_353_I0_D: "生命恢復量",
  T_49_META_TYP_353_I1_D: "血量恢復速度（毫秒）",
  T_49_META_TYP_353_I2_D: "使用所需時間（ms）",
  T_49_META_TYP_354_I0_D: "能量（EP）恢復量",
  T_49_META_TYP_355_I0_D: "生命恢復量",
  T_49_META_TYP_355_I1_D: "能量（EP）恢復量",
  T_49_META_TYP_355_I2_D: "使用所需時間（ms）",
  T_49_META_TYP_356_I0_D: "空投箱攜帶物品",
  T_49_META_TYP_356_I1_D: "空投箱掉落時間ms",
  T_49_META_TYP_356_I2_D: "空投箱掉狀態",
  T_49_META_TYP_357_I0_D: "表面",
  T_49_META_TYP_357_I1_D: "邊界",
  T_49_META_TYP_359_I0_D: "是否使用具有物理效果的玩家控制器",
  T_49_META_TYP_359_I1_D: "放置在超過該角度的坡面上，會向下滑動",
  T_49_META_TYP_359_I10_D: "此重力加速度僅作用於此玩家控制器",
  T_49_META_TYP_359_I11_D: "質量，單位kg",
  T_49_META_TYP_359_I12_D: "所處坡面超過最大上坡角度時會向下滑落",
  T_49_META_TYP_359_I16_D: "開啟後，由服務端圖元或腳本控制移動",
  T_49_META_TYP_359_I17_D: "開啟後，角色推動剛體時施加的力可以自訂",
  T_49_META_TYP_359_I18_D: "角色推動剛體時施加的力大小",
  T_49_META_TYP_359_I19_D: "下半部接觸碰撞體時為真，通常用於判斷玩家是否在地面上",
  T_49_META_TYP_359_I2_D: "只有超過該高度的障礙物才會有阻擋效果，取值範圍[0,Height]",
  T_49_META_TYP_359_I20_D: "自訂物理層級，取值[0,15]",
  T_49_META_TYP_359_I21_D: "是否跟隨重力旋轉朝向",
  T_49_META_TYP_359_I3_D: "允許嵌入改膠囊體的深度。可以防止角色卡住或抖動，無特殊需求不建議修改。取值範圍(0,Radius]",
  T_49_META_TYP_359_I4_D: "最小移動距離，小於該值的移動不會被執行。如非特殊需求建議維持0",
  T_49_META_TYP_359_I5_D: "碰撞盒中心距離本地座標原點的偏移",
  T_49_META_TYP_359_I6_D: "膠囊體半徑，最小值0.01",
  T_49_META_TYP_359_I7_D: "膠囊體總高度，包含上下半球，最小值2*Radius",
  T_49_META_TYP_359_I8_D: "當前線速度，單位m/s",
  T_49_META_TYP_360_I0_D: "左側射界角度",
  T_49_META_TYP_360_I1_D: "右側射界角度",
  T_49_META_TYP_360_I2_D: "最小仰角",
  T_49_META_TYP_360_I3_D: "最大俯角",
  T_49_META_TYP_360_I4_D: "出膛速度",
  T_49_META_TYP_362_I0_D: "命中玩家後造成的凍結時間，單位秒",
  T_49_META_TYP_363_I0_D: "禁用Hud請求購買",
  T_49_META_TYP_363_I1_D: "向隊伍請求協助購買",
  T_49_META_TYP_363_I2_D: "向陣營請求協助購買",
  T_49_META_TYP_364_I0_D: "是否使用中心點播放",
  T_49_META_TYP_364_I1_D: "是否循環播放",
  T_49_META_TYP_364_I2_D: "動畫名",
  T_49_META_TYP_364_I3_D: "是否自動播放",
  T_49_META_TYP_364_I4_D: "是否使用自訂資源",
  T_49_META_TYP_366_I0_D: "指定要渲染的Batch資源UUID",
  T_49_META_TYP_367_I1_D: "是否顯示隊伍或陣營的標記點",
  T_49_META_TYP_367_I2_D: "標記目標顯示的圖示樣式",
  T_49_META_TYP_367_I3_D: "標記目標顯示的圖示的疊加色",
  T_49_META_TYP_367_I4_D: "在某刻度上顯示的圖示樣式",
  T_49_META_TYP_367_I5_D: "在某刻度上顯示的圖示疊加色",
  T_49_META_TYP_367_I6_D: "標記點始終顯示在標尺上",
  T_49_META_TYP_370_I0_D: "主標題",
  T_49_META_TYP_370_I1_D: "副標題",
  T_49_META_TYP_370_I2_D: "上方背景顏色",
  T_49_META_TYP_370_I3_D: "下面背景顏色",
  T_49_META_TYP_371_I2_D: "左側得分",
  T_49_META_TYP_371_I3_D: "右側得分",
  T_49_META_TYP_371_I4_D: "左邊最後得分，用於播放分數切換動畫",
  T_49_META_TYP_371_I5_D: "右邊最後得分，用於播放分數切換動畫",
  T_49_META_TYP_372_I0_D: "站立",
  T_49_META_TYP_372_I1_D: "蹲下 HUD 開關",
  T_49_META_TYP_372_I10_D: "高高度墜落",
  T_49_META_TYP_372_I11_D: "低高度墜落，如跳躍",
  T_49_META_TYP_372_I12_D: "飛行鞋",
  T_49_META_TYP_372_I13_D: "二段跳跳躍",
  T_49_META_TYP_372_I14_D: "坐在椅子上",
  T_49_META_TYP_372_I15_D: "被彈射器彈射出去",
  T_49_META_TYP_372_I16_D: "彈射器準備階段",
  T_49_META_TYP_372_I17_D: "滑翔道具滑翔",
  T_49_META_TYP_372_I18_D: "滑翔道具下落",
  T_49_META_TYP_372_I19_D: "被輪胎彈起",
  T_49_META_TYP_372_I2_D: "跑步",
  T_49_META_TYP_372_I20_D: "被人體輪胎彈起",
  T_49_META_TYP_372_I21_D: "在派對區域中的一種動作",
  T_49_META_TYP_372_I22_D: "搭乘飛行器",
  T_49_META_TYP_372_I23_D: "進入加農砲",
  T_49_META_TYP_372_I24_D: "從加農炮、載具等出來時，如果乘坐對像是飛行的，就是這個狀態",
  T_49_META_TYP_372_I25_D: "從跳板上跳起後",
  T_49_META_TYP_372_I26_D: "從滑索上下來",
  T_49_META_TYP_372_I27_D: "未使用",
  T_49_META_TYP_372_I3_D: "趴下爬行",
  T_49_META_TYP_372_I4_D: "快速游泳",
  T_49_META_TYP_372_I5_D: "垂直下落",
  T_49_META_TYP_372_I6_D: "翻過牆壁",
  T_49_META_TYP_372_I7_D: "未使用",
  T_49_META_TYP_372_I8_D: "被擊倒但沒有死亡",
  T_49_META_TYP_372_I9_D: "水上使用滑板",
  T_49_META_TYP_374_I0_D: "生命值、等級和描邊的顏色",
  T_49_META_TYP_374_I1_D: "生命值減少時，失去的部分短暫顯示這個顏色",
  T_49_META_TYP_374_I10_D: "相對於跟隨目標的偏移",
  T_49_META_TYP_374_I11_D: "每兩個隔間線之間的生命值量，小於等於0則不顯示",
  T_49_META_TYP_374_I12_D: "生命值總量",
  T_49_META_TYP_374_I13_D: "生命值當前量",
  T_49_META_TYP_374_I14_D: "啟用時，血量變化才會有不同顏色表現",
  T_49_META_TYP_374_I15_D: "啟用時，偏移屬性會使用局部座標係到世界座標系",
  T_49_META_TYP_374_I2_D: "生命值增加時，增加的部分短暫顯示這個顏色",
  T_49_META_TYP_374_I3_D: "生命值邊框和虛化底部的顏色",
  T_49_META_TYP_374_I4_D: "範圍0~1，整體UI的透明度",
  T_49_META_TYP_374_I5_D: "決定整體UI縮放小,字體也一同縮放",
  T_49_META_TYP_374_I6_D: "表示目前血條擁有者的名字訊息",
  T_49_META_TYP_374_I8_D: "血條部分在畫面上顯示的長度",
  T_49_META_TYP_374_I9_D: "必須跟隨一個有Transform元件的實體",
  T_49_META_TYP_375_I1_D: "戰鬥實體",
  T_49_META_TYP_376_I1_D: "戰鬥實體",
  T_49_META_TYP_38_I0_D: "透明度",
  T_49_META_TYP_382_I0_D: "預設",
  T_49_META_TYP_382_I1_D: "跳過擊倒狀態，直接死亡",
  T_49_META_TYP_382_I2_D: "強制擊倒",
  T_49_META_TYP_387_I1_D: "區域外保持觸發",
  T_49_META_TYP_389_I0_D: "底座預設偏移量",
  T_49_META_TYP_389_I1_D: "底座圖片",
  T_49_META_TYP_389_I10_D: "未激活透明度",
  T_49_META_TYP_389_I2_D: "底座半徑",
  T_49_META_TYP_389_I3_D: "操縱桿圖片",
  T_49_META_TYP_389_I4_D: "操縱桿半徑",
  T_49_META_TYP_389_I5_D: "操縱桿拖拽半徑",
  T_49_META_TYP_389_I6_D: "方向箭頭圖片",
  T_49_META_TYP_389_I7_D: "方向箭頭尺寸",
  T_49_META_TYP_389_I8_D: "方向箭頭偏移",
  T_49_META_TYP_389_I9_D: "啟用透明度",
  T_49_META_TYP_39_I1_D: "圖片形狀",
  T_49_META_TYP_39_I10_D: "頂部漸變色",
  T_49_META_TYP_39_I11_D: "底部漸變色",
  T_49_META_TYP_39_I12_D: "頂部透明度",
  T_49_META_TYP_39_I13_D: "底部透明度",
  T_49_META_TYP_39_I3_D: "翻轉",
  T_49_META_TYP_39_I4_D: "填充",
  T_49_META_TYP_39_I5_D: "隱藏中心",
  T_49_META_TYP_39_I6_D: "填充方向",
  T_49_META_TYP_39_I7_D: "填充值",
  T_49_META_TYP_39_I8_D: "反向填充",
  T_49_META_TYP_39_I9_D: "漸變",
  T_49_META_TYP_392_I0_D: "安全區在局內每回合出現的時間，預設為0，單位ms",
  T_49_META_TYP_392_I1_D: "縮圈時，單位ms",
  T_49_META_TYP_392_I10_D: "縮圈結束時間，單位ms",
  T_49_META_TYP_392_I12_D: "毒圈結束圈半徑",
  T_49_META_TYP_392_I13_D: "開始縮圈時間",
  T_49_META_TYP_392_I14_D: "傷害時間間隔（毫秒）",
  T_49_META_TYP_392_I3_D: "對毒圈內的玩家單次的傷害量",
  T_49_META_TYP_392_I4_D: "安全區內的玩家列表",
  T_49_META_TYP_392_I5_D: "安全區消失時間，安全區消失時間小於生效時間時不產生安全區",
  T_49_META_TYP_392_I6_D: "GroupID",
  T_49_META_TYP_392_I7_D: "毒圈起始圈半徑",
  T_49_META_TYP_392_I8_D: "結束狀態",
  T_49_META_TYP_392_I9_D: "狀態",
  T_49_META_TYP_394_I0_D: "值約3.1416",
  T_49_META_TYP_394_I1_D: "值約2.7183",
  T_49_META_TYP_396_I0_D: "標題",
  T_49_META_TYP_396_I1_D: "內容",
  T_49_META_TYP_396_I2_D: "選項",
  T_49_META_TYP_396_I3_D: "顯示背景",
  T_49_META_TYP_399_I0_D: "跳躍高度",
  T_49_META_TYP_399_I1_D: "落地前可以進行的連續跳躍次數",
  T_49_META_TYP_399_I2_D: "落地前還能進行幾次跳躍",
  T_49_META_TYP_399_I3_D: "空中是否可水平移動",
  T_49_META_TYP_40_I1_D: "文本內容",
  T_49_META_TYP_40_I10_D: "行間距",
  T_49_META_TYP_40_I11_D: "溢出方式",
  T_49_META_TYP_40_I12_D: "字體風格",
  T_49_META_TYP_40_I13_D: "投影",
  T_49_META_TYP_40_I14_D: "投影顏色",
  T_49_META_TYP_40_I15_D: "投影偏移量",
  T_49_META_TYP_40_I3_D: "本地化Key，可用於多語言",
  T_49_META_TYP_40_I5_D: "對齊方式",
  T_49_META_TYP_40_I6_D: "垂直對齊",
  T_49_META_TYP_40_I7_D: "加粗",
  T_49_META_TYP_40_I8_D: "斜體",
  T_49_META_TYP_40_I9_D: "下劃線",
  T_49_META_TYP_400_I0_D: "活動狀態",
  T_49_META_TYP_400_I1_D: "被動",
  T_49_META_TYP_400_I2_D: "不攻擊",
  T_49_META_TYP_401_I0_D: "不能開火",
  T_49_META_TYP_401_I1_D: "可以持續開火",
  T_49_META_TYP_401_I2_D: "每次攻擊指令發射一次",
  T_49_META_TYP_401_I3_D: "每次攻擊指令發射三次",
  T_49_META_TYP_401_I4_D: "每次攻擊指令發射兩次",
  T_49_META_TYP_401_I5_D: "拋射",
  T_49_META_TYP_402_I0_D: "要新增為好友的目標",
  T_49_META_TYP_402_I1_D: "功能類型",
  T_49_META_TYP_402_I2_D: "樣式",
  T_49_META_TYP_403_I0_D: "增加好友",
  T_49_META_TYP_403_I1_D: "舉報",
  T_49_META_TYP_404_I0_D: "亮色",
  T_49_META_TYP_404_I1_D: "暗色",
  T_49_META_TYP_405_I0_D: "按層級結構",
  T_49_META_TYP_405_I1_D: "按優先級由高到低",
  T_49_META_TYP_405_I2_D: "按優先級由低到高",
  T_49_META_TYP_406_I0_D: "控制玩家翻越動作的距離",
  T_49_META_TYP_406_I1_D: "控制玩家翻越時身體上下移動的高度",
  T_49_META_TYP_407_I0_D: "本地",
  T_49_META_TYP_407_I1_D: "客戶端",
  T_49_META_TYP_407_I2_D: "服務端",
  T_49_META_TYP_407_I3_D: "雙端",
  T_49_META_TYP_409_I0_D: "沒有錯誤",
  T_49_META_TYP_409_I1_D: "資料儲存逾時，主要針對讀取操作",
  T_49_META_TYP_409_I10_D: "換隊失敗-無效的目標隊伍",
  T_49_META_TYP_409_I11_D: "換隊失敗-死亡玩家不允許換隊",
  T_49_META_TYP_409_I12_D: "換隊失敗-不允許在載具中換隊",
  T_49_META_TYP_409_I2_D: "資料儲存讀寫頻次超出限制",
  T_49_META_TYP_409_I3_D: "參數異常",
  T_49_META_TYP_409_I4_D: "建立房間失敗：無有效PersonaIDs",
  T_49_META_TYP_409_I5_D: "未定義的錯誤狀態",
  T_49_META_TYP_409_I6_D: "商業化服務關閉，使用者不再能使用開發者的服務",
  T_49_META_TYP_409_I7_D: "換隊失敗-模式不支持",
  T_49_META_TYP_409_I8_D: "換隊失敗-目前已經在目標隊伍中",
  T_49_META_TYP_409_I9_D: "換隊失敗-無效的對象",
  T_49_META_TYP_41_I0_D: "圖片形狀",
  T_49_META_TYP_41_I19_D: "禁用碰撞盒",
  T_49_META_TYP_41_I3_D: "禁用色",
  T_49_META_TYP_41_I4_D: "按壓色",
  T_49_META_TYP_41_I5_D: "填充類型",
  T_49_META_TYP_41_I6_D: "是否是 FE 的按鈕",
  T_49_META_TYP_41_I7_D: "按下圖片",
  T_49_META_TYP_41_I8_D: "按下圖片類型",
  T_49_META_TYP_41_I9_D: "翻轉類型",
  T_49_META_TYP_411_I0_D: "前進速度（力）",
  T_49_META_TYP_411_I1_D: "後退速度",
  T_49_META_TYP_411_I2_D: "上升速度（力）",
  T_49_META_TYP_411_I3_D: "下降速度（力）",
  T_49_META_TYP_411_I4_D: "載具導彈最小傷害",
  T_49_META_TYP_411_I5_D: "載具導彈最大傷害",
  T_49_META_TYP_411_I6_D: "載具導彈範圍",
  T_49_META_TYP_412_I0_D: "使用油門鍵時，載具獲得的馬力",
  T_49_META_TYP_412_I1_D: "使用倒車/煞車鍵時，載具獲得的馬力",
  T_49_META_TYP_412_I2_D: "在高速狀態下，最大轉向角度",
  T_49_META_TYP_412_I3_D: "高速最大轉向角度應用的速度閾值",
  T_49_META_TYP_412_I4_D: "達到最大速度後，載具不會再提供馬力，但載具可能超過該最大速度（例如通過下坡）",
  T_49_META_TYP_412_I5_D: "未對載具進行操控時，以IdleBrakeInput乘以BrakeTorque對載具進行減速",
  T_49_META_TYP_412_I6_D: "用於撞擊人的傷害計算，運用傷害公式的參數",
  T_49_META_TYP_412_I7_D: "用於撞人的傷害計算，超過該速度後，傷害也不會提升",
  T_49_META_TYP_412_I8_D: "用於撞人的傷害計算，最低傷害",
  T_49_META_TYP_412_I9_D: "用於撞人的傷害計算，最高傷害",
  T_49_META_TYP_413_I0_D: "玩家（NPC）變身後服飾",
  T_49_META_TYP_414_I1_D: "寬範圍",
  T_49_META_TYP_415_I0_D: "智能體 ID",
  T_49_META_TYP_415_I1_D: "暱稱",
  T_49_META_TYP_415_I2_D: "頭像",
  T_49_META_TYP_416_I1_D: "綁定的Persona",
  T_49_META_TYP_416_I2_D: "偏移量",
  T_49_META_TYP_416_I3_D: "高度",
  T_49_META_TYP_416_I4_D: "是否回覆系統訊息",
  T_49_META_TYP_416_I5_D: "Persona暱稱",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "使用者暱稱",
  T_49_META_TYP_416_I8_D: "用戶Avatar",
  T_49_META_TYP_417_I0_D: "資源ID",
  T_49_META_TYP_418_I0_D: "會員到期",
  T_49_META_TYP_418_I1_D: "成為會員",
  T_49_META_TYP_418_I2_D: "會員續費",
  T_49_META_TYP_42_I0_D: "佔位文本內容",
  T_49_META_TYP_42_I1_D: "啟用文字",
  T_49_META_TYP_42_I10_D: "最大長度",
  T_49_META_TYP_42_I14_D: "按壓色",
  T_49_META_TYP_42_I16_D: "本地化Key，可用於多語言",
  T_49_META_TYP_42_I3_D: "對齊方式",
  T_49_META_TYP_42_I4_D: "垂直對齊",
  T_49_META_TYP_42_I5_D: "加粗",
  T_49_META_TYP_42_I6_D: "斜體",
  T_49_META_TYP_42_I7_D: "下劃線",
  T_49_META_TYP_42_I8_D: "行間距",
  T_49_META_TYP_42_I9_D: "自動換行",
  T_49_META_TYP_424_I0_D: "線性霧效",
  T_49_META_TYP_424_I1_D: "指數霧效",
  T_49_META_TYP_424_I2_D: "指數平方霧效",
  T_49_META_TYP_426_I0_D: "光照強度",
  T_49_META_TYP_426_I1_D: "光照範圍",
  T_49_META_TYP_426_I2_D: "聚光錐的角度以度為單位",
  T_49_META_TYP_426_I3_D: "光照顏色",
  T_49_META_TYP_428_I0_D: "武器塗裝 ID",
  T_49_META_TYP_428_I2_D: "套裝ID",
  T_49_META_TYP_428_I3_D: "頭飾ID",
  T_49_META_TYP_428_I4_D: "臉飾ID",
  T_49_META_TYP_428_I5_D: "妝容ID",
  T_49_META_TYP_428_I6_D: "上身ID",
  T_49_META_TYP_428_I7_D: "下身ID",
  T_49_META_TYP_428_I8_D: "鞋ID",
  T_49_META_TYP_431_I1_D: "目標實體的運動軌跡",
  T_49_META_TYP_431_I3_D: "運動速度，單位m/s",
  T_49_META_TYP_431_I4_D: `運動時是否朝向路徑切線
預設為False，當運動物件的朝向不變
為True時，運動物件會面向路徑前進方向`,
  T_49_META_TYP_431_I5_D: "已播放百分比",
  T_49_META_TYP_432_I0_D: "翻滾角，影響從此點兩側路徑的徑向旋轉",
  T_49_META_TYP_432_I1_D: "切線控制點與路點的相對位置，決定了路徑切線",
  T_49_META_TYP_433_I0_D: "在路徑點間直線內插",
  T_49_META_TYP_433_I1_D: "在路徑點間曲線內插，平滑運動",
  T_49_META_TYP_433_I2_D: "支援手動調整曲線點的切線",
  T_49_META_TYP_434_I0_D: "路徑類型",
  T_49_META_TYP_434_I1_D: "路徑的總長度",
  T_49_META_TYP_434_I2_D: "是否首尾銜接",
  T_49_META_TYP_434_I3_D: "路點集合",
  T_49_META_TYP_437_I3_D: "左邊玩家數組",
  T_49_META_TYP_437_I4_D: "右邊玩家數組",
  T_49_META_TYP_437_I5_D: "積分類型名數組",
  T_49_META_TYP_437_I6_D: "左邊積分數組（List一維：玩家；List二維：根據自訂積分類型填入的積分資料）",
  T_49_META_TYP_437_I7_D: "右邊積分數組（List一維：玩家；List二維：根據自訂積分類型填入的積分資料）",
  T_49_META_TYP_438_I1_D: "分組玩家數組",
  T_49_META_TYP_438_I2_D: "分組排名數組",
  T_49_META_TYP_438_I3_D: "分組得分數組",
  T_49_META_TYP_438_I4_D: "積分類型名數組",
  T_49_META_TYP_438_I5_D: "分組顏色數組",
  T_49_META_TYP_438_I6_D: "玩家積分數組（對應未分組時的順序）",
  T_49_META_TYP_442_I1_D: "左側得分",
  T_49_META_TYP_442_I10_D: "右邊死亡圖標",
  T_49_META_TYP_442_I2_D: "右側得分",
  T_49_META_TYP_442_I3_D: "左邊存活人數",
  T_49_META_TYP_442_I4_D: "右邊存活人數",
  T_49_META_TYP_442_I5_D: "左邊死亡人數",
  T_49_META_TYP_442_I6_D: "右邊死亡人數",
  T_49_META_TYP_442_I7_D: "左邊存活圖標",
  T_49_META_TYP_442_I8_D: "右邊存活圖標",
  T_49_META_TYP_442_I9_D: "左邊死亡圖標",
  T_49_META_TYP_444_I0_D: "英語",
  T_49_META_TYP_444_I1_D: "簡體中文",
  T_49_META_TYP_444_I10_D: "法語",
  T_49_META_TYP_444_I11_D: "德文",
  T_49_META_TYP_444_I12_D: "土耳其語",
  T_49_META_TYP_444_I13_D: "印地語",
  T_49_META_TYP_444_I14_D: "日語",
  T_49_META_TYP_444_I15_D: "羅馬尼亞語",
  T_49_META_TYP_444_I16_D: "阿拉伯語",
  T_49_META_TYP_444_I17_D: "緬甸語",
  T_49_META_TYP_444_I18_D: "烏爾都語",
  T_49_META_TYP_444_I19_D: "孟加拉語",
  T_49_META_TYP_444_I2_D: "繁體中文",
  T_49_META_TYP_444_I3_D: "泰語",
  T_49_META_TYP_444_I4_D: "越南語",
  T_49_META_TYP_444_I5_D: "印尼語",
  T_49_META_TYP_444_I6_D: "葡萄牙語",
  T_49_META_TYP_444_I7_D: "西班牙語",
  T_49_META_TYP_444_I8_D: "俄文",
  T_49_META_TYP_444_I9_D: "韓語",
  T_49_META_TYP_51_I0_D: "普通殭屍",
  T_49_META_TYP_51_I1_D: "斧頭殭屍",
  T_49_META_TYP_51_I10_D: "飛行炸彈蜂",
  T_49_META_TYP_51_I11_D: "殭屍龍",
  T_49_META_TYP_51_I2_D: "投擲殭屍",
  T_49_META_TYP_51_I3_D: "爆炸殭屍",
  T_49_META_TYP_51_I4_D: "暴君殭屍",
  T_49_META_TYP_51_I5_D: "投擲紅色殭屍",
  T_49_META_TYP_51_I6_D: "Mr. V",
  T_49_META_TYP_51_I7_D: "坦克殭屍",
  T_49_META_TYP_51_I8_D: "鑽地殭屍",
  T_49_META_TYP_51_I9_D: "武士",
  T_49_META_TYP_56_I10_D: "爆炸延遲",
  T_49_META_TYP_56_I11_D: "爆炸範圍",
  T_49_META_TYP_56_I12_D: "爆炸傷害",
  T_49_META_TYP_56_I13_D: "燃燒時間",
  T_49_META_TYP_56_I14_D: "燃燒傷害",
  T_49_META_TYP_56_I15_D: "燃燒傷害間隔",
  T_49_META_TYP_56_I17_D: "載具駕駛者",
  T_49_META_TYP_56_I18_D: "載具上所有乘客",
  T_49_META_TYP_56_I19_D: "載具外觀 ID",
  T_49_META_TYP_56_I20_D: "玩家配置優先",
  T_49_META_TYP_56_I21_D: "最大血量",
  T_49_META_TYP_56_I22_D: "當前血量",
  T_49_META_TYP_57_I0_D: "是手動傳送還是自動傳送（預設為手動）",
  T_49_META_TYP_58_I0_D: "產生的BUFF類型",
  T_49_META_TYP_58_I1_D: "從BUFF被拾取到下一個BUFF生成的時間，單位為秒",
  T_49_META_TYP_59_I0_D: "運動方式",
  T_49_META_TYP_59_I1_D: "X 軸方向的增量",
  T_49_META_TYP_59_I2_D: "Y 軸方向的增量",
  T_49_META_TYP_59_I3_D: "Z 軸方向的增量",
  T_49_META_TYP_59_I4_D: "移動時長",
  T_49_META_TYP_59_I5_D: "停止時長",
  T_49_META_TYP_59_I6_D: "不使用往返運動",
  T_49_META_TYP_60_I0_D: "Loot武器點",
  T_49_META_TYP_61_I0_D: "綁定商店",
  T_49_META_TYP_61_I1_D: "設定觸發範圍",
  T_49_META_TYP_61_I2_D: "模型顯隱",
  T_49_META_TYP_62_I0_D: "XZ 軸速度",
  T_49_META_TYP_62_I1_D: "Y 軸速度",
  T_49_META_TYP_64_I0_D: "音樂組件類型",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "路徑點",
  T_49_META_TYP_68_I0_D: "AI目前的血量",
  T_49_META_TYP_68_I1_D: "AI目前的血量最大值",
  T_49_META_TYP_68_I10_D: "AI在死亡的時候是否會掉落裝備或物品",
  T_49_META_TYP_68_I11_D: "AI目前是否在無敵狀態",
  T_49_META_TYP_68_I12_D: "受到傷害時傷害量百分比，可減傷或增傷",
  T_49_META_TYP_68_I13_D: "AI的類型",
  T_49_META_TYP_68_I14_D: "是否自動索敵",
  T_49_META_TYP_68_I15_D: "0為自動攻擊，1為防禦攻擊，2為完全不攻擊",
  T_49_META_TYP_68_I16_D: "路徑的場景物件ID",
  T_49_META_TYP_68_I17_D: "被AI追擊的對象",
  T_49_META_TYP_68_I18_D: "攻擊目標",
  T_49_META_TYP_68_I19_D: "AI的出生點座標",
  T_49_META_TYP_68_I2_D: "取得AI所屬隊伍的實體",
  T_49_META_TYP_68_I20_D: "隊伍陣營序號",
  T_49_META_TYP_68_I4_D: "只能修改普通攻擊的攻擊力，技能的攻擊不算",
  T_49_META_TYP_68_I7_D: "AI自由移動的範圍， 只能修改基礎值，如果有額外加成會在該值的就基礎上加成",
  T_49_META_TYP_68_I8_D: "AI偵測敵人的範圍，只能修改基礎值，如果有額外加成會在該值的就基礎上加成",
  T_49_META_TYP_68_I9_D: "真實的行動速度，如果有技能加速會和它相乘",
  T_49_META_TYP_70_I0_D: "公式作用的目標實體ID，內部實現使用，對玩家不可見",
  T_49_META_TYP_70_I1_D: "公式作用的目標實體屬性ID，內部實作使用，對玩家不可見",
  T_49_META_TYP_70_I2_D: "數值允許的最小值",
  T_49_META_TYP_70_I3_D: "數值允許的最大值",
  T_49_META_TYP_70_I4_D: "基礎係數",
  T_49_META_TYP_70_I5_D: "前置累加器",
  T_49_META_TYP_70_I6_D: "连乘器",
  T_49_META_TYP_70_I7_D: "乗算累積器",
  T_49_META_TYP_70_I8_D: "後置累加器",
  T_49_META_TYP_71_I0_D: "商品編號",
  T_49_META_TYP_71_I1_D: "價格",
  T_49_META_TYP_71_I10_D: "能否購買",
  T_49_META_TYP_71_I2_D: "貨幣類型",
  T_49_META_TYP_71_I3_D: "整體限購",
  T_49_META_TYP_71_I4_D: "目前整體限購",
  T_49_META_TYP_71_I5_D: "商品名字",
  T_49_META_TYP_71_I6_D: "商品描述",
  T_49_META_TYP_71_I7_D: "商品物品列表",
  T_49_META_TYP_71_I8_D: "商品數量列表",
  T_49_META_TYP_71_I9_D: "資源路徑, 預設為空",
  T_49_META_TYP_72_I1_D: "商品列表",
  T_49_META_TYP_73_I1_D: "貨架列表",
  T_49_META_TYP_74_I0_D: "武器",
  T_49_META_TYP_74_I1_D: "頭盔",
  T_49_META_TYP_74_I2_D: "防彈背心",
  T_49_META_TYP_74_I3_D: "手榴彈",
  T_49_META_TYP_75_I0_D: "單向",
  T_49_META_TYP_75_I1_D: "來回",
  T_49_META_TYP_76_I0_D: "只巡邏，不攻擊沿途目標",
  T_49_META_TYP_76_I1_D: "巡邏並攻擊",
  T_49_META_TYP_79_I0_D: "武器攻擊力",
  T_49_META_TYP_79_I1_D: "攻擊範圍",
  T_49_META_TYP_79_I10_D: "開始散射閾值",
  T_49_META_TYP_79_I11_D: "武器對應的道具id",
  T_49_META_TYP_79_I12_D: "兩次開火間至少等待的時長，單位秒，每次開火可能會根據開火類型射出多枚子彈",
  T_49_META_TYP_79_I13_D: "擁有該武器的玩家",
  T_49_META_TYP_79_I14_D: "是否消耗彈藥",
  T_49_META_TYP_79_I15_D: "雙持型式（0不雙持1和自己2和任意武器）",
  T_49_META_TYP_79_I16_D: "護甲傷害係數",
  T_49_META_TYP_79_I17_D: "玩家移動速度影響",
  T_49_META_TYP_79_I18_D: "打軀幹的傷害比例",
  T_49_META_TYP_79_I19_D: "打頭的傷害比例",
  T_49_META_TYP_79_I2_D: "兩發子彈間至少等待的時長，單位秒",
  T_49_META_TYP_79_I20_D: "打四肢的傷害比例",
  T_49_META_TYP_79_I21_D: "額外傷害比例(車子、油桶冰牆)",
  T_49_META_TYP_79_I22_D: "背在身上是否顯示",
  T_49_META_TYP_79_I23_D: "擊中倒地額外傷害",
  T_49_META_TYP_79_I24_D: "單次發射子彈數量",
  T_49_META_TYP_79_I25_D: "換彈速度（基礎速度*係數）",
  T_49_META_TYP_79_I26_D: "當前彈藥量",
  T_49_META_TYP_79_I27_D: "槍皮的ID",
  T_49_META_TYP_79_I28_D: "玩家配置優先時，玩家身上的槍皮配置會覆蓋武器本身的槍皮屬性",
  T_49_META_TYP_79_I29_D: "寫入槍皮對武器的屬性時，武器的基本值會受槍皮影響",
  T_49_META_TYP_79_I3_D: "彈匣子彈數量",
  T_49_META_TYP_79_I30_D: "擴散增加速度(0.1 = 每多一次連發準星擴大10%)",
  T_49_META_TYP_79_I31_D: "散射恢復速度",
  T_49_META_TYP_79_I32_D: "射擊時的玩家速度影響",
  T_49_META_TYP_79_I33_D: "移動情況下擴散大小(1.5 = 1.5 * 基本準星大小)",
  T_49_META_TYP_79_I34_D: "武器類型",
  T_49_META_TYP_79_I36_D: "火災類型",
  T_49_META_TYP_79_I37_D: "是否單發",
  T_49_META_TYP_79_I38_D: "是否消音",
  T_49_META_TYP_79_I39_D: "ADS 移動速度比率",
  T_49_META_TYP_79_I4_D: "初始彈夾數量",
  T_49_META_TYP_79_I5_D: "護甲穿透",
  T_49_META_TYP_79_I6_D: "滿傷害距離",
  T_49_META_TYP_79_I7_D: "最小傷害開始距離",
  T_49_META_TYP_79_I8_D: "最小傷害",
  T_49_META_TYP_79_I9_D: "散射開始前可以射出的子彈數",
  T_49_META_TYP_80_I1_D: "為true時,禁止手動關閉",
  T_49_META_TYP_80_I2_D: "綁定的商店實體",
  T_49_META_TYP_80_I4_D: "綁定金額清單",
  T_49_META_TYP_80_I5_D: "綁定錢包 ID",
  T_49_META_TYP_80_I6_D: "目前UI玩家請求目標的類型",
  T_49_META_TYP_80_I7_D: "被請求的物品列表",
  T_49_META_TYP_81_I0_D: "隨機buff",
  T_49_META_TYP_81_I1_D: "血量buff",
  T_49_META_TYP_81_I2_D: "子彈增益",
  T_49_META_TYP_81_I3_D: "護甲 Buff",
  T_49_META_TYP_82_I1_D: "按鈕圖示",
  T_49_META_TYP_82_I3_D: "相對於錨點的位置",
  T_49_META_TYP_83_I1_D: "觸發的實體 ID",
  T_49_META_TYP_83_I2_D: "傳遞參數",
  T_49_META_TYP_86_I0_D: "最小值",
  T_49_META_TYP_86_I1_D: "最大值",
  T_49_META_TYP_86_I2_D: "基礎係數,在所有計算前乘以原始值",
  T_49_META_TYP_86_I3_D: "前置累加器，在進行乘法運算前累加，參與乘法計算",
  T_49_META_TYP_86_I4_D: "連乘器，連續乘法，例如（降低到90%、加強為110%）的效果是Value*90%*110%",
  T_49_META_TYP_86_I5_D: "乘法累加器，例如（加10%、加5%）的效果是Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "後置累加器，不參與乘法計算，最後進行疊加",
  T_49_META_TYP_88_I0_D: "基礎類型，最基本的遊戲幣，目前版本中一般商品的定價類型",
  T_49_META_TYP_89_I0_D: "目前版本中暫只有基礎貨幣",
  T_49_META_TYP_89_I1_D: "貨幣數量",
  T_49_META_TYP_89_I2_D: "貨幣圖標",
  T_49_META_TYP_89_I3_D: "貨幣圖示顏色",
  T_49_META_TYP_90_I0_D: "錢包內容是一堆貨幣",
  T_49_META_TYP_92_I0_D: "方形木箱",
  T_49_META_TYP_92_I1_D: "長木箱",
  T_49_META_TYP_92_I10_D: "哨塔",
  T_49_META_TYP_92_I100_D: "樓梯",
  T_49_META_TYP_92_I101_D: "樓梯平台B",
  T_49_META_TYP_92_I102_D: "樓梯平台A",
  T_49_META_TYP_92_I103_D: "電話亭",
  T_49_META_TYP_92_I104_D: "BIS 主題牆壁",
  T_49_META_TYP_92_I105_D: "BIS 主題花壇",
  T_49_META_TYP_92_I106_D: "自動販賣機",
  T_49_META_TYP_92_I107_D: "怪物實體",
  T_49_META_TYP_92_I108_D: "單位生成器",
  T_49_META_TYP_92_I109_D: "跑車",
  T_49_META_TYP_92_I11_D: "警衛室",
  T_49_META_TYP_92_I110_D: "三轮车",
  T_49_META_TYP_92_I111_D: "可破壞木箱",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "摩托車",
  T_49_META_TYP_92_I114_D: "怪獸卡車",
  T_49_META_TYP_92_I115_D: "金幣生成器",
  T_49_META_TYP_92_I116_D: "樓梯平台C",
  T_49_META_TYP_92_I117_D: "標記",
  T_49_META_TYP_92_I118_D: "圍欄",
  T_49_META_TYP_92_I119_D: "球衣機",
  T_49_META_TYP_92_I12_D: "二層民房",
  T_49_META_TYP_92_I121_D: "混凝土柱",
  T_49_META_TYP_92_I122_D: "截球組件",
  T_49_META_TYP_92_I123_D: "油桶",
  T_49_META_TYP_92_I124_D: "低重力區",
  T_49_META_TYP_92_I125_D: "武器",
  T_49_META_TYP_92_I126_D: "圍欄B",
  T_49_META_TYP_92_I127_D: "小矮房A",
  T_49_META_TYP_92_I128_D: "損壞的卡車",
  T_49_META_TYP_92_I129_D: "基本球體",
  T_49_META_TYP_92_I13_D: "沙雕",
  T_49_META_TYP_92_I130_D: "基本圓錐",
  T_49_META_TYP_92_I131_D: "基本圓柱",
  T_49_META_TYP_92_I132_D: "道具生成器",
  T_49_META_TYP_92_I133_D: "自定義水域",
  T_49_META_TYP_92_I134_D: "箭頭",
  T_49_META_TYP_92_I135_D: "染色方塊",
  T_49_META_TYP_92_I136_D: "染色油桶",
  T_49_META_TYP_92_I137_D: "文本實體",
  T_49_META_TYP_92_I138_D: "圖標實體",
  T_49_META_TYP_92_I139_D: "冰娃娃",
  T_49_META_TYP_92_I14_D: "噴泉",
  T_49_META_TYP_92_I140_D: "膠囊觸發",
  T_49_META_TYP_92_I141_D: "球體衝觸發器",
  T_49_META_TYP_92_I142_D: "反射純色基礎方塊1",
  T_49_META_TYP_92_I143_D: "碰碰車廠",
  T_49_META_TYP_92_I144_D: "格紋遊樂園方塊",
  T_49_META_TYP_92_I145_D: "大屏幕",
  T_49_META_TYP_92_I146_D: "頒獎台",
  T_49_META_TYP_92_I147_D: "大型棒棒糖",
  T_49_META_TYP_92_I148_D: "小餐車B",
  T_49_META_TYP_92_I15_D: "櫻花樹",
  T_49_META_TYP_92_I16_D: "一層民房",
  T_49_META_TYP_92_I17_D: "三層民房",
  T_49_META_TYP_92_I18_D: "香蕉樹",
  T_49_META_TYP_92_I19_D: "馬桶",
  T_49_META_TYP_92_I2_D: "灌木長木箱",
  T_49_META_TYP_92_I20_D: "圍欄",
  T_49_META_TYP_92_I21_D: "可破壞集裝箱",
  T_49_META_TYP_92_I22_D: "可破壞栅欄",
  T_49_META_TYP_92_I23_D: "轮胎",
  T_49_META_TYP_92_I24_D: "碰碰車",
  T_49_META_TYP_92_I25_D: "水陸兩用車",
  T_49_META_TYP_92_I26_D: "吉普車",
  T_49_META_TYP_92_I27_D: "垃圾桶",
  T_49_META_TYP_92_I28_D: "醫療帳篷",
  T_49_META_TYP_92_I29_D: "車庫",
  T_49_META_TYP_92_I3_D: "草垛",
  T_49_META_TYP_92_I30_D: "彩繪牆",
  T_49_META_TYP_92_I31_D: "鳥居",
  T_49_META_TYP_92_I32_D: "鐵台",
  T_49_META_TYP_92_I33_D: "貨櫃屋",
  T_49_META_TYP_92_I34_D: "拖車",
  T_49_META_TYP_92_I35_D: "墙壁A",
  T_49_META_TYP_92_I36_D: "樂符-鋼琴",
  T_49_META_TYP_92_I37_D: "樂符-鋼琴",
  T_49_META_TYP_92_I38_D: "樂符-鼓",
  T_49_META_TYP_92_I39_D: "樂符-鼓",
  T_49_META_TYP_92_I4_D: "廢汽車",
  T_49_META_TYP_92_I40_D: "樂符-合成器A",
  T_49_META_TYP_92_I41_D: "樂符-合成器A",
  T_49_META_TYP_92_I42_D: "樂符-合成器B",
  T_49_META_TYP_92_I43_D: "樂符-合成器B",
  T_49_META_TYP_92_I44_D: "樂符-合成器C",
  T_49_META_TYP_92_I45_D: "樂符-合成器C",
  T_49_META_TYP_92_I46_D: "增益生成器",
  T_49_META_TYP_92_I47_D: "螺旋槳機關",
  T_49_META_TYP_92_I48_D: "平底鍋機關",
  T_49_META_TYP_92_I49_D: "方塊機關",
  T_49_META_TYP_92_I5_D: "廢巴士",
  T_49_META_TYP_92_I50_D: "圓環機關",
  T_49_META_TYP_92_I51_D: "巨槌機關",
  T_49_META_TYP_92_I52_D: "移動板",
  T_49_META_TYP_92_I53_D: "移動靶",
  T_49_META_TYP_92_I54_D: "伸縮牆",
  T_49_META_TYP_92_I55_D: "Loot點武器組件",
  T_49_META_TYP_92_I56_D: "Loot點子彈組件",
  T_49_META_TYP_92_I57_D: "Loot點可消耗物品組件",
  T_49_META_TYP_92_I58_D: "Loot點投擲物品組件",
  T_49_META_TYP_92_I59_D: "Loot點倍鏡組件",
  T_49_META_TYP_92_I6_D: "集裝箱A",
  T_49_META_TYP_92_I60_D: "Loot點護甲組件",
  T_49_META_TYP_92_I61_D: "直管道",
  T_49_META_TYP_92_I62_D: "T管道",
  T_49_META_TYP_92_I63_D: "十字管道",
  T_49_META_TYP_92_I64_D: "轉折管道",
  T_49_META_TYP_92_I65_D: "巨型蘑菇群",
  T_49_META_TYP_92_I66_D: "晾衣架",
  T_49_META_TYP_92_I67_D: "木板橋",
  T_49_META_TYP_92_I68_D: "屏風",
  T_49_META_TYP_92_I69_D: "混凝土柱",
  T_49_META_TYP_92_I7_D: "集裝箱B",
  T_49_META_TYP_92_I70_D: "仙人掌",
  T_49_META_TYP_92_I71_D: "枯木",
  T_49_META_TYP_92_I72_D: "宮燈",
  T_49_META_TYP_92_I73_D: "路燈",
  T_49_META_TYP_92_I74_D: "太阳能板",
  T_49_META_TYP_92_I75_D: "空調",
  T_49_META_TYP_92_I76_D: "正方形",
  T_49_META_TYP_92_I77_D: "斜坡",
  T_49_META_TYP_92_I78_D: "餐车",
  T_49_META_TYP_92_I79_D: "死亡或無敵觸發器組件",
  T_49_META_TYP_92_I8_D: "集裝箱C",
  T_49_META_TYP_92_I80_D: "檢查點",
  T_49_META_TYP_92_I81_D: "終點",
  T_49_META_TYP_92_I82_D: "骰子",
  T_49_META_TYP_92_I83_D: "長椅",
  T_49_META_TYP_92_I84_D: "公車站",
  T_49_META_TYP_92_I85_D: "狗狗屋",
  T_49_META_TYP_92_I86_D: "廣告牌",
  T_49_META_TYP_92_I87_D: "大水罐",
  T_49_META_TYP_92_I88_D: "塗鴉牆",
  T_49_META_TYP_92_I89_D: "草棚",
  T_49_META_TYP_92_I9_D: "小屋",
  T_49_META_TYP_92_I90_D: "石拱桥",
  T_49_META_TYP_92_I91_D: "雨伞桌组合",
  T_49_META_TYP_92_I92_D: "終點橫幅",
  T_49_META_TYP_92_I93_D: "堡壘",
  T_49_META_TYP_92_I94_D: "怪物生成點",
  T_49_META_TYP_92_I95_D: "標記",
  T_49_META_TYP_92_I97_D: "自訂觸發器",
  T_49_META_TYP_92_I98_D: "雙扇門",
  T_49_META_TYP_92_I99_D: "路障",
  T_49_META_TYP_94_I0_D: "增加",
  T_49_META_TYP_94_I1_D: "相乘",
  T_49_META_TYP_95_I0_D: "貨幣類型",
  T_49_META_TYP_95_I1_D: "貨幣數量",
  T_49_META_TYP_96_I0_D: "獲取錢包",
  T_49_META_TYP_96_I1_D: "顯示位置(錨點為右上角）",
  T_49_META_TYP_97_I0_D: "世界座標系中的位置",
  T_49_META_TYP_97_I1_D: "世界座標系中的旋轉角，XYZ分量分別是俯仰角、偏航角、翻滾角，旋轉順序YXZ。",
  T_49_META_TYP_97_I10_D: "本地座標軸x軸朝向",
  T_49_META_TYP_97_I11_D: "本地座標軸z軸朝向",
  T_49_META_TYP_97_I2_D: "世界座標系中縮放尺寸",
  T_49_META_TYP_97_I3_D: "該節點的父節點",
  T_49_META_TYP_97_I4_D: "世界座標系中的旋轉，以四元數表示",
  T_49_META_TYP_97_I5_D: "本地座標系中的位置",
  T_49_META_TYP_97_I6_D: "在本地座標系中的旋轉，以四元數表示",
  T_49_META_TYP_97_I7_D: "在本地座標系中的旋轉角，XYZ分量分別是俯仰角、偏航角、翻滾角，旋轉順序YXZ。",
  T_49_META_TYP_97_I8_D: "本地座標系中的縮放尺寸",
  T_49_META_TYP_97_I9_D: "本地座標軸y軸朝向",
  T_49_META_TYP_99_I0_D: "足球半徑",
  T_49_META_TYP_99_I1_D: "普通狀態下摩擦係數",
  T_49_META_TYP_99_I2_D: "衝擊狀態下摩擦係數",
  T_49_META_TYP_99_I3_D: "最小射門角度",
  T_49_META_TYP_99_I4_D: "高射最小角度",
  T_49_META_TYP_99_I5_D: "復位時間",
  T_49_META_TYP_99_I6_D: "射門最大角度",
  T_49_META_TYP_99_I7_D: "復位位置",
  T_49_META_TYPE_0_D: "對象，類型層次結構的根",
  T_49_META_TYPE_1_D: "列表一組資料的容器",
  T_49_META_TYPE_10_D: "實體基礎組件，所有組件都會組合該組件",
  T_49_META_TYPE_100_D: "換衣機",
  T_49_META_TYPE_101_D: "玩家變身伪裝組件",
  T_49_META_TYPE_1010_D: "計時器資訊",
  T_49_META_TYPE_1011_D: "開場橫幅",
  T_49_META_TYPE_1012_D: "兩隊回合開始橫幅實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1013_D: "一般回合開始橫幅實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1014_D: "隊伍回合得分橫幅實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1015_D: "檢查點管理器實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1016_D: "回合結束展示實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1017_D: "開局時如果是兩隊，展示兩隊對抗橫幅",
  T_49_META_TYPE_1018_D: "兩隊回合比分",
  T_49_META_TYPE_1019_D: "最終結果勝敗平",
  T_49_META_TYPE_102_D: "復活來源類型:死亡,倒地",
  T_49_META_TYPE_1020_D: "回合數實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1021_D: "階段倒數實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1022_D: "比賽資訊子標題實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1023_D: "兩個隊伍比賽資訊實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1024_D: "隊伍比賽資訊UI實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1027_D: "描述類型的類型，當使用Typeof時傳回該類型",
  T_49_META_TYPE_1028_D: "陣營資訊實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1029_D: "圖示提示資訊實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_103_D: "物品槽位類型枚舉",
  T_49_META_TYPE_1030_D: "兩個隊伍比賽資訊簡版實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1031_D: "計時提示介面實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1032_D: "飄字提示實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1033_D: "回合切換實體，包括當前回合結算和下回合開始訊息，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1035_D: "開啟計分板按鈕UI實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1036_D: "感染模式，顯示目前殭屍等級的UI",
  T_49_META_TYPE_1037_D: "新增積分動效UI實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_1038_D: "感染模式殭屍UI特效",
  T_49_META_TYPE_1039_D: "倒數計時飄字提示實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_104_D: "球衣樣式",
  T_49_META_TYPE_1040_D: "UI 卡牌選擇面板",
  T_49_META_TYPE_1041_D: "UI 身份通知",
  T_49_META_TYPE_1042_D: "UI 5 秒倒計時",
  T_49_META_TYPE_1043_D: "UI 標題橫幅",
  T_49_META_TYPE_1044_D: "UI 內建開關",
  T_49_META_TYPE_1045_D: "UI 技能按鈕",
  T_49_META_TYPE_105_D: "足球進球",
  T_49_META_TYPE_106_D: "瞄準輔助類型類型",
  T_49_META_TYPE_107_D: "可以被瞄準以及受擊，不一定會受傷",
  T_49_META_TYPE_108_D: "整數型，64位元帶符號整數",
  T_49_META_TYPE_109_D: "聊天頻道實體是一個包含了自身頻道ID和玩家的容器",
  T_49_META_TYPE_11_D: "全域實體，整場遊戲唯一",
  T_49_META_TYPE_110_D: "空閒語音頻道",
  T_49_META_TYPE_111_D: "行為類型",
  T_49_META_TYPE_112_D: "玩家行為狀態類型",
  T_49_META_TYPE_113_D: "鼓點音樂組件",
  T_49_META_TYPE_114_D: "Lead1音樂組件",
  T_49_META_TYPE_115_D: "Lead2音樂組件",
  T_49_META_TYPE_116_D: "Lead3音樂組件",
  T_49_META_TYPE_117_D: "鼓點音樂組件類型",
  T_49_META_TYPE_118_D: "陣營實體",
  T_49_META_TYPE_119_D: "可攻擊選項",
  T_49_META_TYPE_12_D: "可戰鬥實體，能夠進行攻擊、受擊、擊殺等",
  T_49_META_TYPE_120_D: "UI 進度條",
  T_49_META_TYPE_121_D: "每波間隔時間",
  T_49_META_TYPE_122_D: "天空盒",
  T_49_META_TYPE_123_D: "天空盒基礎類型枚舉",
  T_49_META_TYPE_124_D: "索敵範圍",
  T_49_META_TYPE_125_D: "可修改物件的基礎外觀，如貼圖和透明度",
  T_49_META_TYPE_126_D: "血條",
  T_49_META_TYPE_127_D: "移動物件的移動方式",
  T_49_META_TYPE_128_D: "可被變身物件",
  T_49_META_TYPE_129_D: "戰利品子彈類型",
  T_49_META_TYPE_13_D: "UI控制項實體",
  T_49_META_TYPE_130_D: "戰利品消耗品類型",
  T_49_META_TYPE_131_D: "戰利品護甲類型",
  T_49_META_TYPE_132_D: "戰利品投擲物類型",
  T_49_META_TYPE_133_D: "戰利品倍鏡類型",
  T_49_META_TYPE_134_D: "戰利品武器類型",
  T_49_META_TYPE_135_D: "會產生所選類型的彈藥掉落",
  T_49_META_TYPE_136_D: "會產生所選類型的道具掉落",
  T_49_META_TYPE_137_D: "會產生所選類型的投擲物掉落",
  T_49_META_TYPE_138_D: "會產生所選類型的瞄準鏡掉落",
  T_49_META_TYPE_139_D: "會產生所選類型的防具掉落",
  T_49_META_TYPE_14_D: "遊戲中的玩家實體，每位使用者一個",
  T_49_META_TYPE_140_D: "波次",
  T_49_META_TYPE_141_D: "截球物件",
  T_49_META_TYPE_142_D: "截球組件",
  T_49_META_TYPE_143_D: "Lead1音樂組件類型",
  T_49_META_TYPE_144_D: "Lead2音樂組件類型",
  T_49_META_TYPE_145_D: "Lead3音樂組件類型",
  T_49_META_TYPE_146_D: "琴鍵音樂組件類型",
  T_49_META_TYPE_147_D: "提供多種預設相機類型，以及自訂相機類型",
  T_49_META_TYPE_148_D: "相機組件",
  T_49_META_TYPE_149_D: "本地化字串",
  T_49_META_TYPE_15_D: "遊戲中的隊伍實體，每隊一個",
  T_49_META_TYPE_150_D: "油桶",
  T_49_META_TYPE_151_D: "四元數是一個特殊的四維向量，僅用於表示旋轉",
  T_49_META_TYPE_152_D: "低重力區",
  T_49_META_TYPE_153_D: "實體容器，會在所在位置產生對應類型的實體",
  T_49_META_TYPE_154_D: "雙持武器類型",
  T_49_META_TYPE_155_D: "頭盔實體",
  T_49_META_TYPE_156_D: "防彈衣實體",
  T_49_META_TYPE_157_D: "相機過渡類型",
  T_49_META_TYPE_158_D: "文字提示介面",
  T_49_META_TYPE_159_D: "二維向量",
  T_49_META_TYPE_16_D: "關卡物件實體",
  T_49_META_TYPE_160_D: "貼圖類型",
  T_49_META_TYPE_161_D: "不可替換紋理 VFX",
  T_49_META_TYPE_162_D: "類型列表",
  T_49_META_TYPE_163_D: "類型或類型列表",
  T_49_META_TYPE_164_D: "元件是所有實體元件或特定元件類別的基底類",
  T_49_META_TYPE_165_D: "碰撞盒組件",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "特效實體表示一個顯示的特效(刪除，可回收重複使用)",
  T_49_META_TYPE_17_D: "關卡物件列表",
  T_49_META_TYPE_170_D: "表示是否可以設定可見性",
  T_49_META_TYPE_171_D: "蘑菇",
  T_49_META_TYPE_172_D: "子彈組件",
  T_49_META_TYPE_173_D: "背包",
  T_49_META_TYPE_174_D: "手雷組件",
  T_49_META_TYPE_175_D: "冰凍手雷組件",
  T_49_META_TYPE_176_D: "武器生成器",
  T_49_META_TYPE_177_D: "當相機與跟隨物件中間有遮蔽物時，相機的運動模式",
  T_49_META_TYPE_178_D: "相機渲染畫面時的成像方式",
  T_49_META_TYPE_179_D: "基本球體",
  T_49_META_TYPE_18_D: "（已廢棄，請勿使用）",
  T_49_META_TYPE_180_D: "指涉某組件的某個屬性",
  T_49_META_TYPE_181_D: "用以描述網格資產的類型",
  T_49_META_TYPE_182_D: "用以描述材質資產的類型",
  T_49_META_TYPE_183_D: "用以描述貼圖資產的類型",
  T_49_META_TYPE_184_D: "橋接渲染元件，用於使用內建模型資源進行呈現",
  T_49_META_TYPE_185_D: "自訂渲染元件，用於使用自訂模型資源進行呈現",
  T_49_META_TYPE_186_D: "一個空白物件元件，可以配合渲染器元件、碰撞器元件等使用。",
  T_49_META_TYPE_187_D: "實體容器",
  T_49_META_TYPE_188_D: "基本圓柱或圓錐",
  T_49_META_TYPE_189_D: "本地化字串列表",
  T_49_META_TYPE_19_D: "清單模板，可透過T指定內容的類型",
  T_49_META_TYPE_190_D: "兩隊結算介面",
  T_49_META_TYPE_191_D: "戰術性投擲武器，可以讓一定範圍內的敵人短暫失明",
  T_49_META_TYPE_192_D: "使用後可以產生遮蔽事件的煙霧，是打擾敵人攻擊的利器",
  T_49_META_TYPE_193_D: "多隊結算介面",
  T_49_META_TYPE_194_D: "可以佈置在地上的感應地雷，敵人靠近就會爆炸，注意不要踩到",
  T_49_META_TYPE_195_D: "插值運動的播放方式",
  T_49_META_TYPE_197_D: "可播放組件",
  T_49_META_TYPE_198_D: "道具資產基類",
  T_49_META_TYPE_199_D: "實施空中作戰的輔助裝備，但需要隨時注意能量的消耗",
  T_49_META_TYPE_2_D: "布林類型，用以表示真、假或是、否",
  T_49_META_TYPE_20_D: "內建介面型別枚舉, 此枚舉會依據型別系統自動生成",
  T_49_META_TYPE_200_D: "越獄區域",
  T_49_META_TYPE_201_D: "進入後可以游泳的區域",
  T_49_META_TYPE_202_D: "碰撞資源 ID",
  T_49_META_TYPE_203_D: "插值運動",
  T_49_META_TYPE_204_D: "組裝了科技動力裝置的鞋，可以讓你在空中二段跳躍",
  T_49_META_TYPE_205_D: "可以在天空飛行的滑翔翼，用它從高處降落可以移動到更遠的地方",
  T_49_META_TYPE_206_D: "滑板",
  T_49_META_TYPE_207_D: "滑索",
  T_49_META_TYPE_208_D: "由Playable組成的列表",
  T_49_META_TYPE_209_D: "Playable或由Playable組成的列表",
  T_49_META_TYPE_21_D: "內建介面實體，封裝好特定功能的介面",
  T_49_META_TYPE_210_D: "彈道動畫是對彈道運動的模擬動畫",
  T_49_META_TYPE_211_D: "坐標系",
  T_49_META_TYPE_212_D: "一對象跟著另一對象",
  T_49_META_TYPE_213_D: "一對象的正面始終朝向另一對象",
  T_49_META_TYPE_214_D: "用以描述圖集精靈資產的ID",
  T_49_META_TYPE_215_D: "比賽結果",
  T_49_META_TYPE_216_D: "字典資料容器，資料元素是一對Key、Value",
  T_49_META_TYPE_217_D: "字典資料模板，可透過T1、T2指定內容的類型",
  T_49_META_TYPE_218_D: "光源的一種，從光源位置向所有方向發射強度相等的光線",
  T_49_META_TYPE_219_D: "摩托車載具",
  T_49_META_TYPE_22_D: "自訂介面，玩家透過介面編輯器創建的介面",
  T_49_META_TYPE_220_D: "突突車（三輪車）載具",
  T_49_META_TYPE_221_D: "兩棲/機槍摩托車載具",
  T_49_META_TYPE_222_D: "四輪車載具",
  T_49_META_TYPE_224_D: "技能 ID 列表",
  T_49_META_TYPE_225_D: "高科技材料製成的人工智慧砲塔，會主動搜尋並攻擊一定範圍內的敵人",
  T_49_META_TYPE_226_D: "使用砲塔道具後產生的砲塔",
  T_49_META_TYPE_227_D: "自訂UI控制項類型枚舉",
  T_49_META_TYPE_23_D: "關卡物件類型列舉, 此枚舉會依據類型系統自動生成",
  T_49_META_TYPE_231_D: "護甲修理包",
  T_49_META_TYPE_233_D: "準備等待進度圈",
  T_49_META_TYPE_234_D: "創建的地雷",
  T_49_META_TYPE_235_D: "凝膠護盾",
  T_49_META_TYPE_236_D: "創建的冰牆",
  T_49_META_TYPE_237_D: "鉤鎖槍",
  T_49_META_TYPE_238_D: "彩虹噴漆槍",
  T_49_META_TYPE_239_D: "噴漆槍（步槍）",
  T_49_META_TYPE_24_D: "目前系統定義的傷害類型",
  T_49_META_TYPE_240_D: "實體是所有元件的載體，元件必須附加到實體才能產生實例",
  T_49_META_TYPE_241_D: "強力鉤鎖槍",
  T_49_META_TYPE_242_D: "分數條",
  T_49_META_TYPE_243_D: "服裝插槽",
  T_49_META_TYPE_244_D: "文字實體表示一個顯示的文字",
  T_49_META_TYPE_245_D: "圖標實體表示一個顯示的圖標",
  T_49_META_TYPE_246_D: "噴漆顏色",
  T_49_META_TYPE_247_D: "玩家 UI 類型",
  T_49_META_TYPE_248_D: "通用UI開關實體",
  T_49_META_TYPE_249_D: "切換道具槽位",
  T_49_META_TYPE_25_D: "遊戲過程中的階段，例如遊戲開始、遊戲準備、遊戲結束等",
  T_49_META_TYPE_250_D: "特效實體表示一個顯示的特效",
  T_49_META_TYPE_2500_D: "玩家的出生點",
  T_49_META_TYPE_2501_D: "觸發器用於觸發玩家（或其它物體）的進入離開事件",
  T_49_META_TYPE_2502_D: "死亡或無敵觸發器，當玩家進入時根據屬性控制是死亡還是無敵效果",
  T_49_META_TYPE_2503_D: "競速模式檢查點",
  T_49_META_TYPE_2504_D: "通常是用在競速模式中，用來辨識玩家進入指定終點。這是一個特定的觸發器，後期將開放自訂觸發器，這個終點只是自訂觸發器的封裝。",
  T_49_META_TYPE_2505_D: "出生點四周的柵欄，關閉後可離開出生點",
  T_49_META_TYPE_2507_D: "塔",
  T_49_META_TYPE_2508_D: "怪物生成",
  T_49_META_TYPE_2509_D: "可按需產生對應類型的實例",
  T_49_META_TYPE_251_D: "效果容器",
  T_49_META_TYPE_2510_D: "玩家出生區域(矩形)",
  T_49_META_TYPE_252_D: "噴漆結算",
  T_49_META_TYPE_253_D: "提示按鈕",
  T_49_META_TYPE_254_D: "心跳效果",
  T_49_META_TYPE_255_D: "時間戳本地化字符串",
  T_49_META_TYPE_256_D: "剛體類型枚舉",
  T_49_META_TYPE_257_D: "剛體組件",
  T_49_META_TYPE_258_D: "時間戳格式化顯示樣式",
  T_49_META_TYPE_259_D: "提示",
  T_49_META_TYPE_26_D: "遊戲過程中的回合，往往是一小局，包含數個階段",
  T_49_META_TYPE_260_D: "進度技能按鈕",
  T_49_META_TYPE_261_D: "唯一識別",
  T_49_META_TYPE_262_D: "武器塗裝 ID",
  T_49_META_TYPE_263_D: "服裝ID",
  T_49_META_TYPE_264_D: "道具ID，當版本只有武器ID",
  T_49_META_TYPE_265_D: "UI面板實體",
  T_49_META_TYPE_267_D: "UI捲動視圖實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_268_D: "具有三種狀態的開關，除開啟和關閉外可選擇保持原有邏輯",
  T_49_META_TYPE_269_D: "玩家裝備的服飾",
  T_49_META_TYPE_270_D: "邏輯實體或者 PrefabID",
  T_49_META_TYPE_271_D: "UI面板實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_272_D: "性別枚舉",
  T_49_META_TYPE_273_D: "小地圖實體組件",
  T_49_META_TYPE_274_D: "在小地圖上顯示的Icon，可以跟著目標移動",
  T_49_META_TYPE_275_D: "骨架中的單一部位節點",
  T_49_META_TYPE_276_D: "用來訪問蒙皮骨骼的節點",
  T_49_META_TYPE_277_D: "用戶端相機射線檢測",
  T_49_META_TYPE_278_D: "在小地圖上顯示的像素區塊，代表該位置物件的碰撞大小",
  T_49_META_TYPE_279_D: "染色桶",
  T_49_META_TYPE_28_D: "每回合開始的時候會把狀態重置",
  T_49_META_TYPE_280_D: "球體觸發器",
  T_49_META_TYPE_281_D: "膠囊觸發",
  T_49_META_TYPE_282_D: "描述資產配置ID的類型，用於表示母包自備資產配置ID，需透過配置表解析後再加載",
  T_49_META_TYPE_283_D: "描述資產的類型，用於表示資產的標識符，可直接進行加載",
  T_49_META_TYPE_284_D: "表示人形模型資源，可替換玩家角色",
  T_49_META_TYPE_285_D: "列表或字典，可以循環遍歷",
  T_49_META_TYPE_286_D: "用以描述腳本資產的ID",
  T_49_META_TYPE_287_D: "用以描述靜態腳本資產的ID",
  T_49_META_TYPE_288_D: "用以描述自訂介面資產的ID",
  T_49_META_TYPE_289_D: "用以描述預置資產體的ID",
  T_49_META_TYPE_29_D: "特效",
  T_49_META_TYPE_290_D: "行為樹",
  T_49_META_TYPE_291_D: "行為樹節點類型",
  T_49_META_TYPE_292_D: "行為樹自訂節點",
  T_49_META_TYPE_293_D: "可附加的行為樹",
  T_49_META_TYPE_294_D: "UI版面實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_295_D: "動畫狀態",
  T_49_META_TYPE_296_D: "動畫片段",
  T_49_META_TYPE_297_D: "動畫控制器",
  T_49_META_TYPE_298_D: "循環類型",
  T_49_META_TYPE_3_D: "整數型，32位元帶符號整數",
  T_49_META_TYPE_30_D: "圖示",
  T_49_META_TYPE_300_D: "UI3DContainer實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_301_D: "AI 技能類型",
  T_49_META_TYPE_302_D: "裝備欄槽位枚舉",
  T_49_META_TYPE_303_D: "對應BuffData.csv中Id列，增加新項前請和GPP確認是否適用",
  T_49_META_TYPE_304_D: "增益類型列表",
  T_49_META_TYPE_305_D: "行為樹節點狀態",
  T_49_META_TYPE_306_D: "可以添加buff,移除buff,獲得已加的buff列表",
  T_49_META_TYPE_307_D: "冰牆生成器",
  T_49_META_TYPE_308_D: "特殊道具ID類型",
  T_49_META_TYPE_309_D: "投擲物道具",
  T_49_META_TYPE_31_D: "音效",
  T_49_META_TYPE_310_D: "十字弩",
  T_49_META_TYPE_311_D: "投擲物道具基類",
  T_49_META_TYPE_312_D: "投擲物道具",
  T_49_META_TYPE_313_D: "反制冰牆手雷組件",
  T_49_META_TYPE_314_D: "管理動畫控制器與資源",
  T_49_META_TYPE_315_D: "玩家背包實體",
  T_49_META_TYPE_316_D: "UITexture實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_317_D: "剛體運動限制，每種限制可組合使用",
  T_49_META_TYPE_318_D: "配件道具",
  T_49_META_TYPE_319_D: "填充類型枚舉",
  T_49_META_TYPE_32_D: "玩家狀態類型",
  T_49_META_TYPE_320_D: "填充方向枚舉",
  T_49_META_TYPE_321_D: "可以被輔助瞄準的實體",
  T_49_META_TYPE_322_D: "擊中身體部位類型",
  T_49_META_TYPE_323_D: "UIProfileInfo實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_324_D: "剛體受力的幾種不同效果。注意只對Dynamic類型的剛體有效",
  T_49_META_TYPE_325_D: "用以描述自訂介面資產中的控制項的ID",
  T_49_META_TYPE_326_D: "玩家簡介訊息",
  T_49_META_TYPE_327_D: "依照各部件配置換裝",
  T_49_META_TYPE_328_D: "行為樹 ID",
  T_49_META_TYPE_329_D: "座位類型",
  T_49_META_TYPE_33_D: "排序方式：升序忽略零值、降序、升序",
  T_49_META_TYPE_330_D: "相對自身進行的運動",
  T_49_META_TYPE_331_D: "貝茲曲線",
  T_49_META_TYPE_332_D: "可循環組件",
  T_49_META_TYPE_333_D: "字體枚舉",
  T_49_META_TYPE_334_D: "載具外觀 ID",
  T_49_META_TYPE_335_D: "音效實體表示一個播放的音效",
  T_49_META_TYPE_336_D: "音效實體列表",
  T_49_META_TYPE_337_D: "SoundEntity或SoundEntity數組",
  T_49_META_TYPE_338_D: "玩家行為屬性同步實體",
  T_49_META_TYPE_339_D: "裝備配件道具",
  T_49_META_TYPE_34_D: "道具ID",
  T_49_META_TYPE_340_D: "機器人難度類型",
  T_49_META_TYPE_341_D: "整數字典",
  T_49_META_TYPE_342_D: "計時器",
  T_49_META_TYPE_343_D: "飛刀(可拾取)",
  T_49_META_TYPE_344_D: "投擲刀",
  T_49_META_TYPE_345_D: "武器類型",
  T_49_META_TYPE_346_D: "子彈類型",
  T_49_META_TYPE_347_D: "相對自身每幀運動",
  T_49_META_TYPE_348_D: "函數指標指向某個函數實例，用以實現虛函數或委託機制",
  T_49_META_TYPE_349_D: "指某個協程的句柄，可以進行一些句柄操作",
  T_49_META_TYPE_350_D: "載具枚舉",
  T_49_META_TYPE_351_D: "描述物件的類型",
  T_49_META_TYPE_352_D: "UIToggle實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_353_D: "醫療包",
  T_49_META_TYPE_354_D: "吸入器",
  T_49_META_TYPE_355_D: "水平線",
  T_49_META_TYPE_356_D: "空投，準備時間結束後會開始從高處掉落",
  T_49_META_TYPE_357_D: "物件的描述性顏色，如邊框、表面等（刪除，可回收重複使用）",
  T_49_META_TYPE_358_D: "指涉某個事件",
  T_49_META_TYPE_359_D: "具有物理效果的玩家控制器，可施力受力",
  T_49_META_TYPE_360_D: "發射墊",
  T_49_META_TYPE_361_D: "折疊後的大砲，展開後可以用來把人發射出去，要小心不要把自己發射出安全區！",
  T_49_META_TYPE_362_D: "打雪仗！衝啊！",
  T_49_META_TYPE_363_D: "商店請求購買",
  T_49_META_TYPE_364_D: "動畫觸發器",
  T_49_META_TYPE_365_D: "動畫觸發器介面組件",
  T_49_META_TYPE_366_D: "批量合併渲染",
  T_49_META_TYPE_367_D: "頂部羅盤",
  T_49_META_TYPE_368_D: "自訂角色資源ID",
  T_49_META_TYPE_369_D: "自訂動畫資源ID",
  T_49_META_TYPE_370_D: "回合開始展示的訊息",
  T_49_META_TYPE_371_D: "每回合結束，展示結果",
  T_49_META_TYPE_372_D: "玩家姿態類型",
  T_49_META_TYPE_373_D: "藏品ID，用於資源資訊收集",
  T_49_META_TYPE_374_D: "角色跟隨血條",
  T_49_META_TYPE_375_D: "怪物攻擊目標型態枚舉",
  T_49_META_TYPE_376_D: "防禦塔攻擊目標型態枚舉",
  T_49_META_TYPE_377_D: "指涉玩家實體、載具實體類型的別名",
  T_49_META_TYPE_378_D: "用以描述音訊資產的ID",
  T_49_META_TYPE_379_D: "用以描述配置表資產的ID",
  T_49_META_TYPE_38_D: "UI空Widget實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_380_D: "用以描述特效資產的ID",
  T_49_META_TYPE_381_D: "用以描述動畫控制器資產的ID",
  T_49_META_TYPE_382_D: "擊倒狀態處理方式",
  T_49_META_TYPE_383_D: "地圖本身的地表或裝飾物",
  T_49_META_TYPE_384_D: "掉落物品 ID 列表",
  T_49_META_TYPE_385_D: "人物技能ID",
  T_49_META_TYPE_386_D: "技能 ID",
  T_49_META_TYPE_387_D: "UITouchPad實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_388_D: "背包外觀 ID",
  T_49_META_TYPE_389_D: "Joystick實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_39_D: "UI圖片實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_390_D: "可挂载子节点的实体",
  T_49_META_TYPE_391_D: "自訂 UI 或小工具",
  T_49_META_TYPE_392_D: "可擺放的毒圈物件",
  T_49_META_TYPE_393_D: "帶有PhysicalCCT或Rigidbody組件的實體",
  T_49_META_TYPE_394_D: "數學常數",
  T_49_META_TYPE_395_D: "具有PhysicalCCT或PlayerCCT組件的實體可以隨其一起運動",
  T_49_META_TYPE_396_D: "遊戲中退出配置",
  T_49_META_TYPE_397_D: "用於描述碰撞形狀的組件",
  T_49_META_TYPE_398_D: "字符串或本地化字符串",
  T_49_META_TYPE_399_D: "具有物理效果的角色控制器，僅用於FF角色",
  T_49_META_TYPE_4_D: "浮點類型，32位元單精度浮點數",
  T_49_META_TYPE_40_D: "UI文字實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_400_D: "如何進行攻擊行為",
  T_49_META_TYPE_401_D: "火災類型",
  T_49_META_TYPE_402_D: "社交功能按鈕",
  T_49_META_TYPE_403_D: "社交按鈕類型",
  T_49_META_TYPE_404_D: "社群按鈕樣式",
  T_49_META_TYPE_405_D: "佈局排序類型",
  T_49_META_TYPE_406_D: "可觸發翻越障礙物",
  T_49_META_TYPE_407_D: "平台類型",
  T_49_META_TYPE_408_D: "基礎數據別名",
  T_49_META_TYPE_409_D: "錯誤碼枚舉",
  T_49_META_TYPE_41_D: "UI按鈕實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_410_D: "指涉玩家實體或Transform實體類型的別名",
  T_49_META_TYPE_411_D: "直升機載具",
  T_49_META_TYPE_412_D: "汽車組件，是載具組件的功能擴充",
  T_49_META_TYPE_413_D: "NPC物件",
  T_49_META_TYPE_414_D: "限制攝影機轉動的角度範圍",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona聊天視窗介面",
  T_49_META_TYPE_417_D: "粒子實體組件",
  T_49_META_TYPE_418_D: "會員狀態枚舉",
  T_49_META_TYPE_419_D: "槍械皮膚類型",
  T_49_META_TYPE_42_D: "UI輸入實體，玩家透過UI編輯器編輯的UI",
  T_49_META_TYPE_420_D: "載具皮膚類型",
  T_49_META_TYPE_421_D: "皮膚類型",
  T_49_META_TYPE_422_D: "背包皮膚類型",
  T_49_META_TYPE_423_D: "智能體 ID",
  T_49_META_TYPE_424_D: "霧效基礎類型",
  T_49_META_TYPE_425_D: "粒子資產ID",
  T_49_META_TYPE_426_D: "光源的一種，從光源開始向光源的Y軸負向發射錐形光線，預設照射地面",
  T_49_META_TYPE_427_D: "NPC物件",
  T_49_META_TYPE_428_D: "玩家變身為其他角色時需要保留的服飾訊息",
  T_49_META_TYPE_429_D: "玩家或NPC實體",
  T_49_META_TYPE_43_D: "元素類型須為玩家實體的列表",
  T_49_META_TYPE_430_D: "隨機數產生器",
  T_49_META_TYPE_431_D: "運動對象沿著自訂路徑運動",
  T_49_META_TYPE_432_D: "自訂曲線路徑路點",
  T_49_META_TYPE_433_D: "自訂曲線路徑路點類型",
  T_49_META_TYPE_434_D: "自訂曲線路徑",
  T_49_META_TYPE_435_D: "玩家唯一識別列表",
  T_49_META_TYPE_436_D: "錯誤碼列表",
  T_49_META_TYPE_437_D: "兩隊比賽詳情UI實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_438_D: "多隊比賽詳情UI實體，修改實體屬性則影響對應UI上的顯示內容",
  T_49_META_TYPE_439_D: "組合",
  T_49_META_TYPE_44_D: "元素類型須為隊伍實體的列表",
  T_49_META_TYPE_440_D: "時間軸",
  T_49_META_TYPE_441_D: "時間軸資源ID",
  T_49_META_TYPE_442_D: "新兩隊比賽資訊簡版實體組件，支援完全自訂的人數顯示",
  T_49_META_TYPE_443_D: "對話流資產ID",
  T_49_META_TYPE_444_D: "語言類型",
  T_49_META_TYPE_45_D: "布林列表",
  T_49_META_TYPE_46_D: "整數列表",
  T_49_META_TYPE_47_D: "小數列表",
  T_49_META_TYPE_48_D: "字串列表",
  T_49_META_TYPE_49_D: "三維向量列表",
  T_49_META_TYPE_5_D: "字串類型，值是文字內容",
  T_49_META_TYPE_50_D: "元素類型須為實體的列表",
  T_49_META_TYPE_51_D: "殭屍類型",
  T_49_META_TYPE_53_D: "普通關卡物件",
  T_49_META_TYPE_54_D: "可摧毀物件",
  T_49_META_TYPE_55_D: "通用出生點",
  T_49_META_TYPE_56_D: "載具組件",
  T_49_META_TYPE_57_D: "玩家進入時可傳送到指定地點",
  T_49_META_TYPE_58_D: "可按需生成buff",
  T_49_META_TYPE_59_D: "移動平台",
  T_49_META_TYPE_6_D: "三維向量，可表示空間座標或空間方向",
  T_49_META_TYPE_60_D: "會產生所選類型的武器掉落",
  T_49_META_TYPE_61_D: "進入觸發範圍可以開啟綁定商店",
  T_49_META_TYPE_62_D: "彈跳性極佳的骰子",
  T_49_META_TYPE_63_D: "玩家踩上去會被彈飛到指定位置",
  T_49_META_TYPE_64_D: "玩家踩上去會發出聲音",
  T_49_META_TYPE_65_D: "基本可擴展",
  T_49_META_TYPE_66_D: "自訂路徑",
  T_49_META_TYPE_67_D: "路徑點",
  T_49_META_TYPE_68_D: "AI怪物實體，例如殭屍",
  T_49_META_TYPE_69_D: "大數是高精度浮點數",
  T_49_META_TYPE_7_D: "數字是型別別名，指稱整數、64位元整數或浮點型",
  T_49_META_TYPE_70_D: "屬性公式用於計算實體屬性值，暫只支援部分玩家屬性、武器屬性",
  T_49_META_TYPE_71_D: "僅用於商店出售的實體，商品與購買商品得到的物品概念不同",
  T_49_META_TYPE_72_D: "包含若干商品",
  T_49_META_TYPE_73_D: "內含若干貨架",
  T_49_META_TYPE_74_D: "道具ID",
  T_49_META_TYPE_75_D: "是否返回",
  T_49_META_TYPE_76_D: "巡邏風格",
  T_49_META_TYPE_77_D: "可以生成，刷新物件的生成器實體",
  T_49_META_TYPE_78_D: "可以被單位產生器用來吸取，並按批次產生的單位實體",
  T_49_META_TYPE_79_D: "武器",
  T_49_META_TYPE_8_D: "條件是特殊的Bool類型",
  T_49_META_TYPE_80_D: "商店介面",
  T_49_META_TYPE_81_D: "增益類型",
  T_49_META_TYPE_82_D: "UI 心跳",
  T_49_META_TYPE_83_D: "互動按鈕介面實體組件",
  T_49_META_TYPE_84_D: "可排名實體，能夠進行排名",
  T_49_META_TYPE_85_D: "可積分實體，有自己的積分",
  T_49_META_TYPE_86_D: "屬性公式因子類型",
  T_49_META_TYPE_87_D: "描述RGBA顏色的類型，每個通道取值範圍0~255",
  T_49_META_TYPE_88_D: "貨幣類型，目前只有基礎貨幣類型",
  T_49_META_TYPE_89_D: "貨幣實體，用以描述貨幣的種類和數量",
  T_49_META_TYPE_9_D: "一組條件",
  T_49_META_TYPE_90_D: "錢包實體是一堆貨幣實體的容器",
  T_49_META_TYPE_91_D: "指涉整數或整數數組類型",
  T_49_META_TYPE_92_D: "可動態創建物件類型",
  T_49_META_TYPE_93_D: "可公式化屬性的實體",
  T_49_META_TYPE_94_D: "屬性修改方式",
  T_49_META_TYPE_95_D: "金幣生成器",
  T_49_META_TYPE_96_D: "錢包",
  T_49_META_TYPE_97_D: "位置旋轉縮放，支援父子結構",
  T_49_META_TYPE_98_D: "列出所有可用的類型",
  T_49_META_TYPE_99_D: "足球"
};
export {
  _ as default
};
